import { g as getRenderingRef, f as forceUpdate } from './index-1a15fc4b.js';

const languageStorageKey = 'PORTAL_LOC_CONTEXT';
const languageDateStorageKey = 'PORTAL_LOC_CONTEXT_DATE';
const defaultLanguage = 'en';
// The addition of any new languages should be followed with an import of the locale in the `portal-date` file.
const Languages = {
    'en': 'English',
    'ja': '日本語',
    'de': 'Deutsch',
    'es': 'Español',
    'es-mx': 'Español (México)',
    'fr': 'Français',
    'ko': '한국어',
    'pt': 'Português',
    'pt-br': 'Português (Brasil)',
    'ru': 'Pусский',
    'tr': 'Türkçe',
    'zh-cn': '中文(简体)',
    'zh-tw': '中文(繁體)',
    'keys': 'Localization Keys',
};

const themeStorageKey = 'PORTAL_THEME';
const darkMediaQuery = '(prefers-color-scheme: dark)';
const themeList = ['light', 'light-hc', 'dark', 'dark-hc', 'autoTheme'];
const defaultTheme = 'autoTheme';
const highContrastMediaQueries = [
    '(forced-colors: active)',
    '(prefers-contrast: more)',
    '(inverted-colors: active)',
];

var ServiceType;
(function (ServiceType) {
    ServiceType["actions"] = "actions";
    ServiceType["academy"] = "academy";
    ServiceType["aifabric"] = "aifabric";
    ServiceType["apps"] = "apps";
    ServiceType["automationHub"] = "automationhub";
    ServiceType["automationStore"] = "automationstore";
    ServiceType["chatBots"] = "chatBots";
    ServiceType["cloudRpa"] = "portal";
    ServiceType["customerPortal"] = "customerportal";
    ServiceType["entities"] = "entities";
    ServiceType["insights"] = "insights";
    ServiceType["marketplace"] = "marketplace";
    ServiceType["orchestrator"] = "orchestrator";
    ServiceType["processes"] = "processes";
    ServiceType["reinfer"] = "reinfer";
    ServiceType["taskMining"] = "taskmining";
    ServiceType["processMining"] = "processmining";
    ServiceType["studio"] = "studio";
    ServiceType["testManager"] = "testmanager";
    ServiceType["integrations"] = "connections";
    ServiceType["du"] = "du";
    ServiceType["roboticsOps"] = "roboticsops";
    ServiceType["dataservice"] = "dataservice";
    ServiceType["connectorbuilder"] = "connectorbuilder";
    ServiceType["automationsolutions"] = "automationsolutions";
    ServiceType["provisioning"] = "provisioning";
    ServiceType["docs"] = "docs";
    ServiceType["assistant"] = "assistant";
    ServiceType["agents"] = "agents";
    ServiceType["agenticorchestration"] = "agenticorchestration";
    ServiceType["srs"] = "srs";
})(ServiceType || (ServiceType = {}));

var TextFieldClassName;
(function (TextFieldClassName) {
    TextFieldClassName["OmitStartAdornmentSpacing"] = "ap-omit-start-adornment-spacing";
})(TextFieldClassName || (TextFieldClassName = {}));

var ApolloSettingKey;
(function (ApolloSettingKey) {
    ApolloSettingKey["UserLanguage"] = "UserLanguage.Language";
    ApolloSettingKey["UserLanguageDate"] = "UserLanguage.Date";
    ApolloSettingKey["UserTheme"] = "UserTheme.Theme";
    ApolloSettingKey["UserAccessibility"] = "UserAccessibility.Accessibility";
    ApolloSettingKey["UserAlert"] = "UserAlert.AlertDuration";
    ApolloSettingKey["Favorites"] = "Favorites";
})(ApolloSettingKey || (ApolloSettingKey = {}));

var DialogEventNames;
(function (DialogEventNames) {
    DialogEventNames["UpgradeToTrialDialogBusinessEmail"] = "upgradeToTrialDialogBusinessEmail";
    DialogEventNames["UpgradeToTrialDialogPersonalEmail"] = "upgradeToTrialDialogPersonalEmail";
})(DialogEventNames || (DialogEventNames = {}));

const GlobalEventNames = {
    portalShellLoaded: 'portalShellLoaded',
    accessTokenChanged: 'accessTokenChanged',
    tenantsNotAvailable: 'tenantsNotAvailable',
    tenantChanged: 'tenantChanged',
    tenantLoaded: 'tenantLoaded',
    themeChanged: 'themeChanged',
    themeSelectChanged: 'themeSelectChanged',
    themeLoaded: 'themeLoaded',
    languageChanged: 'languageChanged',
    languageLoaded: 'languageLoaded',
    pendoInitialized: 'pendoInitialized',
    logout: 'logout',
    sessionTimedOut: 'sessionTimedOut',
    accessiblityModeChanged: 'accessiblityModeChanged',
    alertDurationChanged: 'alertDurationChanged',
    switchingOrganizations: 'switchingOrganizations',
    chatMessageReceived: 'chatMessageReceived',
    chatMessagePosted: 'chatMessagePosted',
    chatCreated: 'chatCreated',
    chatConnected: 'chatConnected',
    chatEnded: 'chatEnded',
    platformInfo: 'platformInfo',
    openApDialog: 'openApDialog',
    openServicesNav: 'openServicesNav',
    closeServicesNav: 'closeServicesNav',
    isNewNavSelected: 'isNewNavSelected',
    toggleServiceNav: 'toggleServiceNav',
};

var Entitlement;
(function (Entitlement) {
    Entitlement["ACCESS_POLICY"] = "Platform.AccessPolicy";
    Entitlement["APP_TEST_DEVELOPER"] = "Ubl.AppTestDevNamedUser";
    Entitlement["APP_TESTER"] = "Ubl.AppTesterNamedUser";
    Entitlement["CHECK_ACCESS"] = "Platform.CheckAccess";
    Entitlement["CUSTOM_MAIL_SETTINGS"] = "Platform.CustomMailSettings";
    Entitlement["CUSTOMER_MANAGED_KEY"] = "Platform.CustomerManagedKey";
    Entitlement["INSIGHTS"] = "Insights.FullMode";
    Entitlement["IPRESTRICTION"] = "Platform.IpRestrictions";
    Entitlement["SAP"] = "Platform.SapEnabled";
    Entitlement["SESSION_POLICY"] = "Platform.SessionPolicy";
    Entitlement["SSO_PROVISIONING"] = "Platform.SSOProvisioning";
    Entitlement["USER_CONSENT"] = "Platform.UserConsentPolicy";
})(Entitlement || (Entitlement = {}));

var AlertDurationEnum;
(function (AlertDurationEnum) {
    AlertDurationEnum[AlertDurationEnum["s3"] = 3000] = "s3";
    AlertDurationEnum[AlertDurationEnum["s5"] = 5000] = "s5";
    AlertDurationEnum[AlertDurationEnum["s10"] = 10000] = "s10";
    AlertDurationEnum[AlertDurationEnum["s30"] = 30000] = "s30";
    AlertDurationEnum[AlertDurationEnum["s60"] = 60000] = "s60";
    AlertDurationEnum[AlertDurationEnum["NODISMISS"] = -1] = "NODISMISS";
})(AlertDurationEnum || (AlertDurationEnum = {}));

var AutopilotChatMode;
(function (AutopilotChatMode) {
    AutopilotChatMode["Closed"] = "closed";
    AutopilotChatMode["SideBySide"] = "side-by-side";
    AutopilotChatMode["FullScreen"] = "full-screen";
})(AutopilotChatMode || (AutopilotChatMode = {}));
var AutopilotChatAccordionPosition;
(function (AutopilotChatAccordionPosition) {
    AutopilotChatAccordionPosition["Left"] = "left";
    AutopilotChatAccordionPosition["Right"] = "right";
})(AutopilotChatAccordionPosition || (AutopilotChatAccordionPosition = {}));
var AutopilotChatFileType;
(function (AutopilotChatFileType) {
    AutopilotChatFileType["Word"] = "Word";
    AutopilotChatFileType["PowerPoint"] = "PowerPoint";
    AutopilotChatFileType["File"] = "File";
})(AutopilotChatFileType || (AutopilotChatFileType = {}));
var AutopilotChatRole;
(function (AutopilotChatRole) {
    AutopilotChatRole["User"] = "user";
    AutopilotChatRole["Assistant"] = "assistant";
})(AutopilotChatRole || (AutopilotChatRole = {}));
/**
 * Enum representing the various events that can occur in the Autopilot Chat system.
 * These events are used for communication between components and for event handling.
 *
 * @enum {string}
 * @property {string} Error - Emitted when an error occurs in the chat system
 * @property {string} NewChat - Emitted when a new chat session is started
 * @property {string} ModeChange - Emitted when the chat mode changes (e.g., from normal to full-screen)
 * @property {string} SetPrompt - Emitted when the chat prompt is set or changed
 * @property {string} Request - Emitted when a user sends a message request
 * @property {string} Response - Emitted when the assistant sends a response
 * @property {string} StopResponse - Emitted when a response is manually stopped
 * @property {string} SetFirstRunExperience - Emitted when the first run experience is configured
 * @property {string} SetDisabledFeatures - Emitted when disabled features are configured
 * @property {string} Open - Emitted when the chat is opened
 * @property {string} Close - Emitted when the chat is closed
 * @property {string} SendChunk - Emitted when a chunk of a streaming response is sent
 * @property {string} SetConversation - Emitted when the conversation is set
 */
var AutopilotChatEvent;
(function (AutopilotChatEvent) {
    AutopilotChatEvent["Error"] = "error";
    AutopilotChatEvent["NewChat"] = "newChat";
    AutopilotChatEvent["ModeChange"] = "modeChange";
    AutopilotChatEvent["SetPrompt"] = "setPrompt";
    AutopilotChatEvent["Request"] = "request";
    AutopilotChatEvent["Response"] = "response";
    AutopilotChatEvent["StopResponse"] = "stopResponse";
    AutopilotChatEvent["SetFirstRunExperience"] = "setFirstRunExperience";
    AutopilotChatEvent["SetDisabledFeatures"] = "setDisabledFeatures";
    AutopilotChatEvent["Open"] = "open";
    AutopilotChatEvent["Close"] = "close";
    AutopilotChatEvent["SendChunk"] = "sendChunk";
    AutopilotChatEvent["SetConversation"] = "setConversation";
})(AutopilotChatEvent || (AutopilotChatEvent = {}));
/**
 * Enum representing the various interceptable events that can occur in the Autopilot Chat system.
 * These events are used for intercepting and preventing default handling of events.
 *
 * @enum {string}
 * @property {string} Request - Emitted when a user sends a message request
 */
var AutopilotChatInterceptableEvent;
(function (AutopilotChatInterceptableEvent) {
    AutopilotChatInterceptableEvent["Request"] = "request";
})(AutopilotChatInterceptableEvent || (AutopilotChatInterceptableEvent = {}));
var AutopilotChatInternalEvent;
(function (AutopilotChatInternalEvent) {
    AutopilotChatInternalEvent["ChatResize"] = "chatResize";
    AutopilotChatInternalEvent["ScrollToBottom"] = "scrollToBottom";
})(AutopilotChatInternalEvent || (AutopilotChatInternalEvent = {}));

const StudioWebHosts = [
    'st-aks-sw-we-tm.trafficmanager.net',
    'st-aks-sw-we-b-dns.westeurope.cloudapp.azure.com',
    'st-aks-sw-we-g-dns.westeurope.cloudapp.azure.com',
    'st-alp-sw-we-b-dns.westeurope.cloudapp.azure.com',
    'st-alp-sw-we-g-dns.westeurope.cloudapp.azure.com',
    'st-alp-sw-ne-dns.northeurope.cloudapp.azure.com',
    'st-stg-sw-we-b-dns.westeurope.cloudapp.azure.com',
    'st-stg-sw-we-g-dns.westeurope.cloudapp.azure.com',
    'st-stg-sw-ne-dns.northeurope.cloudapp.azure.com',
    'stw-prod-sw-ne-b-dns.northeurope.cloudapp.azure.com',
    'stw-prod-sw-ne-g-dns.northeurope.cloudapp.azure.com',
    'stw-prod-sw-we-dns.westeurope.cloudapp.azure.com',
    'sw-prd1-ent-ne-b-dns.northeurope.cloudapp.azure.com',
    'sw-prd1-ent-ne-g-dns.northeurope.cloudapp.azure.com',
    'sw-prd1-ent-we-dns.westeurope.cloudapp.azure.com',
    'sw-prd2-ent-eus-b-dns.eastus2.cloudapp.azure.com',
    'sw-prd2-ent-eus-g-dns.eastus2.cloudapp.azure.com',
    'sw-prd2-ent-cus-dns.centralus.cloudapp.azure.com',
];

function getEnvironment(organizationStandardUrl) {
    var _a;
    const host = getHost(organizationStandardUrl);
    switch (host) {
        case 'alpha.uipath.com':
        case 'portal.alpha.uipath.com':
            return 'alp';
        case 'staging.uipath.com':
        case 'portal.staging.uipath.com':
            return 'stg';
        case 'cloud.uipath.com':
        case 'portal.uipath.com':
            return 'prd';
        case 'alpha.gov.uipath-dev.com': return 'agov';
        case 'staging.gov.uipath-dev.com': return 'sgov';
        case 'govcloud.uipath.us': return 'pgov';
    }
    if (isLocal$1(organizationStandardUrl)) {
        if ((host === null || host === void 0 ? void 0 : host.includes('localhost:44351')) || ((_a = window.location.pathname) === null || _a === void 0 ? void 0 : _a.startsWith('/identity/management'))) {
            return 'local-msi';
        }
        else if (host === null || host === void 0 ? void 0 : host.includes('localhost:10485')) {
            return 'local-k8s';
        }
        return 'local';
    }
    return isMSI() ? 'msi' : 'k8s';
}
function getEnvironmentDomain(env = getEnvironment()) {
    switch (env) {
        case 'local':
            return 'localhost';
        case 'alp':
        case 'stg':
        case 'prd':
            return '.uipath.com';
        case 'agov':
        case 'sgov':
            return '.gov.uipath-dev.com';
        case 'pgov':
            return '.uipath.us';
        default:
            return undefined;
    }
}
function isMSI() {
    var _a;
    const services = Object.values(ServiceType).map(name => name.toLowerCase());
    const pathName = (_a = window.location.pathname) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    if (pathName === null || pathName === void 0 ? void 0 : pathName.startsWith('/identity_')) {
        return false;
    }
    for (let i = 0; i < services.length; i++) {
        const name = services[i];
        if ((pathName === null || pathName === void 0 ? void 0 : pathName.indexOf(`/${name}_/`)) > -1 || (pathName === null || pathName === void 0 ? void 0 : pathName.endsWith(`/${name}_`))) {
            return false;
        }
    }
    // This will include both MSI and isStandalone cases
    return true;
}
function isLocal$1(organizationStandardUrl) {
    const host = getHost(organizationStandardUrl);
    return !!(host === null || host === void 0 ? void 0 : host.includes('localhost'))
        || !!(host === null || host === void 0 ? void 0 : host.includes('designer.jamjam.local'))
        || !!StudioWebHosts.find(h => host === null || host === void 0 ? void 0 : host.includes(h));
}
function getHost(url) {
    if (url) {
        try {
            return new URL(url).host.toLowerCase();
        }
        catch ( /* N/A */_a) { /* N/A */ }
    }
    return window.location.host.toLowerCase();
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var lib$1 = {};

var broadcastChannel = {};

var util = {};

Object.defineProperty(util, "__esModule", {
  value: true
});
util.PROMISE_RESOLVED_VOID = util.PROMISE_RESOLVED_TRUE = util.PROMISE_RESOLVED_FALSE = void 0;
util.isPromise = isPromise;
util.microSeconds = microSeconds$4;
util.randomInt = randomInt;
util.randomToken = randomToken;
util.sleep = sleep;
util.supportsWebLockAPI = supportsWebLockAPI;
/**
 * returns true if the given object is a promise
 */
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}
util.PROMISE_RESOLVED_FALSE = Promise.resolve(false);
util.PROMISE_RESOLVED_TRUE = Promise.resolve(true);
util.PROMISE_RESOLVED_VOID = Promise.resolve();
function sleep(time, resolveWith) {
  if (!time) time = 0;
  return new Promise(function (res) {
    return setTimeout(function () {
      return res(resolveWith);
    }, time);
  });
}
function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

/**
 * https://stackoverflow.com/a/8084248
 */
function randomToken() {
  return Math.random().toString(36).substring(2);
}
var lastMs = 0;

/**
 * Returns the current unix time in micro-seconds,
 * WARNING: This is a pseudo-function
 * Performance.now is not reliable in webworkers, so we just make sure to never return the same time.
 * This is enough in browsers, and this function will not be used in nodejs.
 * The main reason for this hack is to ensure that BroadcastChannel behaves equal to production when it is used in fast-running unit tests.
 */
function microSeconds$4() {
  var ret = Date.now() * 1000; // milliseconds to microseconds
  if (ret <= lastMs) {
    ret = lastMs + 1;
  }
  lastMs = ret;
  return ret;
}

/**
 * Check if WebLock API is supported.
 * @link https://developer.mozilla.org/en-US/docs/Web/API/Web_Locks_API
 */
function supportsWebLockAPI() {
  if (typeof navigator !== 'undefined' && typeof navigator.locks !== 'undefined' && typeof navigator.locks.request === 'function') {
    return true;
  } else {
    return false;
  }
}

var methodChooser = {};

var _typeof = {exports: {}};

(function (module) {
function _typeof(o) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(_typeof));

var native = {};

Object.defineProperty(native, "__esModule", {
  value: true
});
native.NativeMethod = void 0;
native.averageResponseTime = averageResponseTime$3;
native.canBeUsed = canBeUsed$3;
native.close = close$3;
native.create = create$3;
native.microSeconds = void 0;
native.onMessage = onMessage$3;
native.postMessage = postMessage$3;
native.type = void 0;
var _util$6 = util;
var microSeconds$3 = native.microSeconds = _util$6.microSeconds;
var type$3 = native.type = 'native';
function create$3(channelName) {
  var state = {
    time: (0, _util$6.microSeconds)(),
    messagesCallback: null,
    bc: new BroadcastChannel(channelName),
    subFns: [] // subscriberFunctions
  };

  state.bc.onmessage = function (msgEvent) {
    if (state.messagesCallback) {
      state.messagesCallback(msgEvent.data);
    }
  };
  return state;
}
function close$3(channelState) {
  channelState.bc.close();
  channelState.subFns = [];
}
function postMessage$3(channelState, messageJson) {
  try {
    channelState.bc.postMessage(messageJson, false);
    return _util$6.PROMISE_RESOLVED_VOID;
  } catch (err) {
    return Promise.reject(err);
  }
}
function onMessage$3(channelState, fn) {
  channelState.messagesCallback = fn;
}
function canBeUsed$3() {
  // Deno runtime
  // eslint-disable-next-line
  if (typeof globalThis !== 'undefined' && globalThis.Deno && globalThis.Deno.args) {
    return true;
  }

  // Browser runtime
  if ((typeof window !== 'undefined' || typeof self !== 'undefined') && typeof BroadcastChannel === 'function') {
    if (BroadcastChannel._pubkey) {
      throw new Error('BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill');
    }
    return true;
  } else {
    return false;
  }
}
function averageResponseTime$3() {
  return 150;
}
native.NativeMethod = {
  create: create$3,
  close: close$3,
  onMessage: onMessage$3,
  postMessage: postMessage$3,
  canBeUsed: canBeUsed$3,
  type: type$3,
  averageResponseTime: averageResponseTime$3,
  microSeconds: microSeconds$3
};

var indexedDb = {};

/**
 * this is a set which automatically forgets
 * a given entry when a new entry is set and the ttl
 * of the old one is over
 */
class ObliviousSet {
    ttl;
    map = new Map();
    /**
     * Creating calls to setTimeout() is expensive,
     * so we only do that if there is not timeout already open.
     */
    _to = false;
    constructor(ttl) {
        this.ttl = ttl;
    }
    has(value) {
        return this.map.has(value);
    }
    add(value) {
        this.map.set(value, now());
        /**
         * When a new value is added,
         * start the cleanup at the next tick
         * to not block the cpu for more important stuff
         * that might happen.
         */
        if (!this._to) {
            this._to = true;
            setTimeout(() => {
                this._to = false;
                removeTooOldValues(this);
            }, 0);
        }
    }
    clear() {
        this.map.clear();
    }
}
/**
 * Removes all entries from the set
 * where the TTL has expired
 */
function removeTooOldValues(obliviousSet) {
    const olderThen = now() - obliviousSet.ttl;
    const iterator = obliviousSet.map[Symbol.iterator]();
    /**
     * Because we can assume the new values are added at the bottom,
     * we start from the top and stop as soon as we reach a non-too-old value.
     */
    while (true) {
        const next = iterator.next().value;
        if (!next) {
            return; // no more elements
        }
        const value = next[0];
        const time = next[1];
        if (time < olderThen) {
            obliviousSet.map.delete(value);
        }
        else {
            // We reached a value that is not old enough
            return;
        }
    }
}
function now() {
    return Date.now();
}

const src = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ObliviousSet: ObliviousSet,
    removeTooOldValues: removeTooOldValues,
    now: now
});

const require$$0$2 = /*@__PURE__*/getAugmentedNamespace(src);

var options = {};

Object.defineProperty(options, "__esModule", {
  value: true
});
options.fillOptionsWithDefaults = fillOptionsWithDefaults$1;
function fillOptionsWithDefaults$1() {
  var originalOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = JSON.parse(JSON.stringify(originalOptions));

  // main
  if (typeof options.webWorkerSupport === 'undefined') options.webWorkerSupport = true;

  // indexed-db
  if (!options.idb) options.idb = {};
  //  after this time the messages get deleted
  if (!options.idb.ttl) options.idb.ttl = 1000 * 45;
  if (!options.idb.fallbackInterval) options.idb.fallbackInterval = 150;
  //  handles abrupt db onclose events.
  if (originalOptions.idb && typeof originalOptions.idb.onclose === 'function') options.idb.onclose = originalOptions.idb.onclose;

  // localstorage
  if (!options.localstorage) options.localstorage = {};
  if (!options.localstorage.removeTimeout) options.localstorage.removeTimeout = 1000 * 60;

  // custom methods
  if (originalOptions.methods) options.methods = originalOptions.methods;

  // node
  if (!options.node) options.node = {};
  if (!options.node.ttl) options.node.ttl = 1000 * 60 * 2; // 2 minutes;
  /**
   * On linux use 'ulimit -Hn' to get the limit of open files.
   * On ubuntu this was 4096 for me, so we use half of that as maxParallelWrites default.
   */
  if (!options.node.maxParallelWrites) options.node.maxParallelWrites = 2048;
  if (typeof options.node.useFastPath === 'undefined') options.node.useFastPath = true;
  return options;
}

Object.defineProperty(indexedDb, "__esModule", {
  value: true
});
indexedDb.TRANSACTION_SETTINGS = indexedDb.IndexedDBMethod = void 0;
indexedDb.averageResponseTime = averageResponseTime$2;
indexedDb.canBeUsed = canBeUsed$2;
indexedDb.cleanOldMessages = cleanOldMessages;
indexedDb.close = close$2;
indexedDb.commitIndexedDBTransaction = commitIndexedDBTransaction;
indexedDb.create = create$2;
indexedDb.createDatabase = createDatabase;
indexedDb.getAllMessages = getAllMessages;
indexedDb.getIdb = getIdb;
indexedDb.getMessagesHigherThan = getMessagesHigherThan;
indexedDb.getOldMessages = getOldMessages;
indexedDb.microSeconds = void 0;
indexedDb.onMessage = onMessage$2;
indexedDb.postMessage = postMessage$2;
indexedDb.removeMessagesById = removeMessagesById;
indexedDb.type = void 0;
indexedDb.writeMessage = writeMessage;
var _util$5 = util;
var _obliviousSet$1 = require$$0$2;
var _options$2 = options;
/**
 * this method uses indexeddb to store the messages
 * There is currently no observerAPI for idb
 * @link https://github.com/w3c/IndexedDB/issues/51
 * 
 * When working on this, ensure to use these performance optimizations:
 * @link https://rxdb.info/slow-indexeddb.html
 */

var microSeconds$2 = indexedDb.microSeconds = _util$5.microSeconds;
var DB_PREFIX = 'pubkey.broadcast-channel-0-';
var OBJECT_STORE_ID = 'messages';

/**
 * Use relaxed durability for faster performance on all transactions.
 * @link https://nolanlawson.com/2021/08/22/speeding-up-indexeddb-reads-and-writes/
 */
var TRANSACTION_SETTINGS = indexedDb.TRANSACTION_SETTINGS = {
  durability: 'relaxed'
};
var type$2 = indexedDb.type = 'idb';
function getIdb() {
  if (typeof indexedDB !== 'undefined') return indexedDB;
  if (typeof window !== 'undefined') {
    if (typeof window.mozIndexedDB !== 'undefined') return window.mozIndexedDB;
    if (typeof window.webkitIndexedDB !== 'undefined') return window.webkitIndexedDB;
    if (typeof window.msIndexedDB !== 'undefined') return window.msIndexedDB;
  }
  return false;
}

/**
 * If possible, we should explicitly commit IndexedDB transactions
 * for better performance.
 * @link https://nolanlawson.com/2021/08/22/speeding-up-indexeddb-reads-and-writes/
 */
function commitIndexedDBTransaction(tx) {
  if (tx.commit) {
    tx.commit();
  }
}
function createDatabase(channelName) {
  var IndexedDB = getIdb();

  // create table
  var dbName = DB_PREFIX + channelName;

  /**
   * All IndexedDB databases are opened without version
   * because it is a bit faster, especially on firefox
   * @link http://nparashuram.com/IndexedDB/perf/#Open%20Database%20with%20version
   */
  var openRequest = IndexedDB.open(dbName);
  openRequest.onupgradeneeded = function (ev) {
    var db = ev.target.result;
    db.createObjectStore(OBJECT_STORE_ID, {
      keyPath: 'id',
      autoIncrement: true
    });
  };
  return new Promise(function (res, rej) {
    openRequest.onerror = function (ev) {
      return rej(ev);
    };
    openRequest.onsuccess = function () {
      res(openRequest.result);
    };
  });
}

/**
 * writes the new message to the database
 * so other readers can find it
 */
function writeMessage(db, readerUuid, messageJson) {
  var time = Date.now();
  var writeObject = {
    uuid: readerUuid,
    time: time,
    data: messageJson
  };
  var tx = db.transaction([OBJECT_STORE_ID], 'readwrite', TRANSACTION_SETTINGS);
  return new Promise(function (res, rej) {
    tx.oncomplete = function () {
      return res();
    };
    tx.onerror = function (ev) {
      return rej(ev);
    };
    var objectStore = tx.objectStore(OBJECT_STORE_ID);
    objectStore.add(writeObject);
    commitIndexedDBTransaction(tx);
  });
}
function getAllMessages(db) {
  var tx = db.transaction(OBJECT_STORE_ID, 'readonly', TRANSACTION_SETTINGS);
  var objectStore = tx.objectStore(OBJECT_STORE_ID);
  var ret = [];
  return new Promise(function (res) {
    objectStore.openCursor().onsuccess = function (ev) {
      var cursor = ev.target.result;
      if (cursor) {
        ret.push(cursor.value);
        //alert("Name for SSN " + cursor.key + " is " + cursor.value.name);
        cursor["continue"]();
      } else {
        commitIndexedDBTransaction(tx);
        res(ret);
      }
    };
  });
}
function getMessagesHigherThan(db, lastCursorId) {
  var tx = db.transaction(OBJECT_STORE_ID, 'readonly', TRANSACTION_SETTINGS);
  var objectStore = tx.objectStore(OBJECT_STORE_ID);
  var ret = [];
  var keyRangeValue = IDBKeyRange.bound(lastCursorId + 1, Infinity);

  /**
   * Optimization shortcut,
   * if getAll() can be used, do not use a cursor.
   * @link https://rxdb.info/slow-indexeddb.html
   */
  if (objectStore.getAll) {
    var getAllRequest = objectStore.getAll(keyRangeValue);
    return new Promise(function (res, rej) {
      getAllRequest.onerror = function (err) {
        return rej(err);
      };
      getAllRequest.onsuccess = function (e) {
        res(e.target.result);
      };
    });
  }
  function openCursor() {
    // Occasionally Safari will fail on IDBKeyRange.bound, this
    // catches that error, having it open the cursor to the first
    // item. When it gets data it will advance to the desired key.
    try {
      keyRangeValue = IDBKeyRange.bound(lastCursorId + 1, Infinity);
      return objectStore.openCursor(keyRangeValue);
    } catch (e) {
      return objectStore.openCursor();
    }
  }
  return new Promise(function (res, rej) {
    var openCursorRequest = openCursor();
    openCursorRequest.onerror = function (err) {
      return rej(err);
    };
    openCursorRequest.onsuccess = function (ev) {
      var cursor = ev.target.result;
      if (cursor) {
        if (cursor.value.id < lastCursorId + 1) {
          cursor["continue"](lastCursorId + 1);
        } else {
          ret.push(cursor.value);
          cursor["continue"]();
        }
      } else {
        commitIndexedDBTransaction(tx);
        res(ret);
      }
    };
  });
}
function removeMessagesById(channelState, ids) {
  if (channelState.closed) {
    return Promise.resolve([]);
  }
  var tx = channelState.db.transaction(OBJECT_STORE_ID, 'readwrite', TRANSACTION_SETTINGS);
  var objectStore = tx.objectStore(OBJECT_STORE_ID);
  return Promise.all(ids.map(function (id) {
    var deleteRequest = objectStore["delete"](id);
    return new Promise(function (res) {
      deleteRequest.onsuccess = function () {
        return res();
      };
    });
  }));
}
function getOldMessages(db, ttl) {
  var olderThen = Date.now() - ttl;
  var tx = db.transaction(OBJECT_STORE_ID, 'readonly', TRANSACTION_SETTINGS);
  var objectStore = tx.objectStore(OBJECT_STORE_ID);
  var ret = [];
  return new Promise(function (res) {
    objectStore.openCursor().onsuccess = function (ev) {
      var cursor = ev.target.result;
      if (cursor) {
        var msgObk = cursor.value;
        if (msgObk.time < olderThen) {
          ret.push(msgObk);
          //alert("Name for SSN " + cursor.key + " is " + cursor.value.name);
          cursor["continue"]();
        } else {
          // no more old messages,
          commitIndexedDBTransaction(tx);
          res(ret);
        }
      } else {
        res(ret);
      }
    };
  });
}
function cleanOldMessages(channelState) {
  return getOldMessages(channelState.db, channelState.options.idb.ttl).then(function (tooOld) {
    return removeMessagesById(channelState, tooOld.map(function (msg) {
      return msg.id;
    }));
  });
}
function create$2(channelName, options) {
  options = (0, _options$2.fillOptionsWithDefaults)(options);
  return createDatabase(channelName).then(function (db) {
    var state = {
      closed: false,
      lastCursorId: 0,
      channelName: channelName,
      options: options,
      uuid: (0, _util$5.randomToken)(),
      /**
       * emittedMessagesIds
       * contains all messages that have been emitted before
       * @type {ObliviousSet}
       */
      eMIs: new _obliviousSet$1.ObliviousSet(options.idb.ttl * 2),
      // ensures we do not read messages in parallel
      writeBlockPromise: _util$5.PROMISE_RESOLVED_VOID,
      messagesCallback: null,
      readQueuePromises: [],
      db: db
    };

    /**
     * Handle abrupt closes that do not originate from db.close().
     * This could happen, for example, if the underlying storage is
     * removed or if the user clears the database in the browser's
     * history preferences.
     */
    db.onclose = function () {
      state.closed = true;
      if (options.idb.onclose) options.idb.onclose();
    };

    /**
     * if service-workers are used,
     * we have no 'storage'-event if they post a message,
     * therefore we also have to set an interval
     */
    _readLoop(state);
    return state;
  });
}
function _readLoop(state) {
  if (state.closed) return;
  readNewMessages(state).then(function () {
    return (0, _util$5.sleep)(state.options.idb.fallbackInterval);
  }).then(function () {
    return _readLoop(state);
  });
}
function _filterMessage(msgObj, state) {
  if (msgObj.uuid === state.uuid) return false; // send by own
  if (state.eMIs.has(msgObj.id)) return false; // already emitted
  if (msgObj.data.time < state.messagesCallbackTime) return false; // older then onMessageCallback
  return true;
}

/**
 * reads all new messages from the database and emits them
 */
function readNewMessages(state) {
  // channel already closed
  if (state.closed) return _util$5.PROMISE_RESOLVED_VOID;

  // if no one is listening, we do not need to scan for new messages
  if (!state.messagesCallback) return _util$5.PROMISE_RESOLVED_VOID;
  return getMessagesHigherThan(state.db, state.lastCursorId).then(function (newerMessages) {
    var useMessages = newerMessages
    /**
     * there is a bug in iOS where the msgObj can be undefined sometimes
     * so we filter them out
     * @link https://github.com/pubkey/broadcast-channel/issues/19
     */.filter(function (msgObj) {
      return !!msgObj;
    }).map(function (msgObj) {
      if (msgObj.id > state.lastCursorId) {
        state.lastCursorId = msgObj.id;
      }
      return msgObj;
    }).filter(function (msgObj) {
      return _filterMessage(msgObj, state);
    }).sort(function (msgObjA, msgObjB) {
      return msgObjA.time - msgObjB.time;
    }); // sort by time
    useMessages.forEach(function (msgObj) {
      if (state.messagesCallback) {
        state.eMIs.add(msgObj.id);
        state.messagesCallback(msgObj.data);
      }
    });
    return _util$5.PROMISE_RESOLVED_VOID;
  });
}
function close$2(channelState) {
  channelState.closed = true;
  channelState.db.close();
}
function postMessage$2(channelState, messageJson) {
  channelState.writeBlockPromise = channelState.writeBlockPromise.then(function () {
    return writeMessage(channelState.db, channelState.uuid, messageJson);
  }).then(function () {
    if ((0, _util$5.randomInt)(0, 10) === 0) {
      /* await (do not await) */
      cleanOldMessages(channelState);
    }
  });
  return channelState.writeBlockPromise;
}
function onMessage$2(channelState, fn, time) {
  channelState.messagesCallbackTime = time;
  channelState.messagesCallback = fn;
  readNewMessages(channelState);
}
function canBeUsed$2() {
  return !!getIdb();
}
function averageResponseTime$2(options) {
  return options.idb.fallbackInterval * 2;
}
indexedDb.IndexedDBMethod = {
  create: create$2,
  close: close$2,
  onMessage: onMessage$2,
  postMessage: postMessage$2,
  canBeUsed: canBeUsed$2,
  type: type$2,
  averageResponseTime: averageResponseTime$2,
  microSeconds: microSeconds$2
};

var localstorage = {};

Object.defineProperty(localstorage, "__esModule", {
  value: true
});
localstorage.LocalstorageMethod = void 0;
localstorage.addStorageEventListener = addStorageEventListener;
localstorage.averageResponseTime = averageResponseTime$1;
localstorage.canBeUsed = canBeUsed$1;
localstorage.close = close$1;
localstorage.create = create$1;
localstorage.getLocalStorage = getLocalStorage;
localstorage.microSeconds = void 0;
localstorage.onMessage = onMessage$1;
localstorage.postMessage = postMessage$1;
localstorage.removeStorageEventListener = removeStorageEventListener;
localstorage.storageKey = storageKey;
localstorage.type = void 0;
var _obliviousSet = require$$0$2;
var _options$1 = options;
var _util$4 = util;
/**
 * A localStorage-only method which uses localstorage and its 'storage'-event
 * This does not work inside webworkers because they have no access to localstorage
 * This is basically implemented to support IE9 or your grandmother's toaster.
 * @link https://caniuse.com/#feat=namevalue-storage
 * @link https://caniuse.com/#feat=indexeddb
 */

var microSeconds$1 = localstorage.microSeconds = _util$4.microSeconds;
var KEY_PREFIX = 'pubkey.broadcastChannel-';
var type$1 = localstorage.type = 'localstorage';

/**
 * copied from crosstab
 * @link https://github.com/tejacques/crosstab/blob/master/src/crosstab.js#L32
 */
function getLocalStorage() {
  var localStorage;
  if (typeof window === 'undefined') return null;
  try {
    localStorage = window.localStorage;
    localStorage = window['ie8-eventlistener/storage'] || window.localStorage;
  } catch (e) {
    // New versions of Firefox throw a Security exception
    // if cookies are disabled. See
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1028153
  }
  return localStorage;
}
function storageKey(channelName) {
  return KEY_PREFIX + channelName;
}

/**
* writes the new message to the storage
* and fires the storage-event so other readers can find it
*/
function postMessage$1(channelState, messageJson) {
  return new Promise(function (res) {
    (0, _util$4.sleep)().then(function () {
      var key = storageKey(channelState.channelName);
      var writeObj = {
        token: (0, _util$4.randomToken)(),
        time: Date.now(),
        data: messageJson,
        uuid: channelState.uuid
      };
      var value = JSON.stringify(writeObj);
      getLocalStorage().setItem(key, value);

      /**
       * StorageEvent does not fire the 'storage' event
       * in the window that changes the state of the local storage.
       * So we fire it manually
       */
      var ev = document.createEvent('Event');
      ev.initEvent('storage', true, true);
      ev.key = key;
      ev.newValue = value;
      window.dispatchEvent(ev);
      res();
    });
  });
}
function addStorageEventListener(channelName, fn) {
  var key = storageKey(channelName);
  var listener = function listener(ev) {
    if (ev.key === key) {
      fn(JSON.parse(ev.newValue));
    }
  };
  window.addEventListener('storage', listener);
  return listener;
}
function removeStorageEventListener(listener) {
  window.removeEventListener('storage', listener);
}
function create$1(channelName, options) {
  options = (0, _options$1.fillOptionsWithDefaults)(options);
  if (!canBeUsed$1()) {
    throw new Error('BroadcastChannel: localstorage cannot be used');
  }
  var uuid = (0, _util$4.randomToken)();

  /**
   * eMIs
   * contains all messages that have been emitted before
   * @type {ObliviousSet}
   */
  var eMIs = new _obliviousSet.ObliviousSet(options.localstorage.removeTimeout);
  var state = {
    channelName: channelName,
    uuid: uuid,
    eMIs: eMIs // emittedMessagesIds
  };

  state.listener = addStorageEventListener(channelName, function (msgObj) {
    if (!state.messagesCallback) return; // no listener
    if (msgObj.uuid === uuid) return; // own message
    if (!msgObj.token || eMIs.has(msgObj.token)) return; // already emitted
    if (msgObj.data.time && msgObj.data.time < state.messagesCallbackTime) return; // too old

    eMIs.add(msgObj.token);
    state.messagesCallback(msgObj.data);
  });
  return state;
}
function close$1(channelState) {
  removeStorageEventListener(channelState.listener);
}
function onMessage$1(channelState, fn, time) {
  channelState.messagesCallbackTime = time;
  channelState.messagesCallback = fn;
}
function canBeUsed$1() {
  var ls = getLocalStorage();
  if (!ls) return false;
  try {
    var key = '__broadcastchannel_check';
    ls.setItem(key, 'works');
    ls.removeItem(key);
  } catch (e) {
    // Safari 10 in private mode will not allow write access to local
    // storage and fail with a QuotaExceededError. See
    // https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API#Private_Browsing_Incognito_modes
    return false;
  }
  return true;
}
function averageResponseTime$1() {
  var defaultTime = 120;
  var userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
    // safari is much slower so this time is higher
    return defaultTime * 2;
  }
  return defaultTime;
}
localstorage.LocalstorageMethod = {
  create: create$1,
  close: close$1,
  onMessage: onMessage$1,
  postMessage: postMessage$1,
  canBeUsed: canBeUsed$1,
  type: type$1,
  averageResponseTime: averageResponseTime$1,
  microSeconds: microSeconds$1
};

var simulate = {};

Object.defineProperty(simulate, "__esModule", {
  value: true
});
simulate.SimulateMethod = simulate.SIMULATE_DELAY_TIME = void 0;
simulate.averageResponseTime = averageResponseTime;
simulate.canBeUsed = canBeUsed;
simulate.close = close;
simulate.create = create;
simulate.microSeconds = void 0;
simulate.onMessage = onMessage;
simulate.postMessage = postMessage;
simulate.type = void 0;
var _util$3 = util;
var microSeconds = simulate.microSeconds = _util$3.microSeconds;
var type = simulate.type = 'simulate';
var SIMULATE_CHANNELS = new Set();
function create(channelName) {
  var state = {
    time: microSeconds(),
    name: channelName,
    messagesCallback: null
  };
  SIMULATE_CHANNELS.add(state);
  return state;
}
function close(channelState) {
  SIMULATE_CHANNELS["delete"](channelState);
}
var SIMULATE_DELAY_TIME = simulate.SIMULATE_DELAY_TIME = 5;
function postMessage(channelState, messageJson) {
  return new Promise(function (res) {
    return setTimeout(function () {
      var channelArray = Array.from(SIMULATE_CHANNELS);
      channelArray.forEach(function (channel) {
        if (channel.name === channelState.name &&
        // has same name
        channel !== channelState &&
        // not own channel
        !!channel.messagesCallback &&
        // has subscribers
        channel.time < messageJson.time // channel not created after postMessage() call
        ) {
          channel.messagesCallback(messageJson);
        }
      });
      res();
    }, SIMULATE_DELAY_TIME);
  });
}
function onMessage(channelState, fn) {
  channelState.messagesCallback = fn;
}
function canBeUsed() {
  return true;
}
function averageResponseTime() {
  return SIMULATE_DELAY_TIME;
}
simulate.SimulateMethod = {
  create: create,
  close: close,
  onMessage: onMessage,
  postMessage: postMessage,
  canBeUsed: canBeUsed,
  type: type,
  averageResponseTime: averageResponseTime,
  microSeconds: microSeconds
};

Object.defineProperty(methodChooser, "__esModule", {
  value: true
});
methodChooser.chooseMethod = chooseMethod;
var _native = native;
var _indexedDb = indexedDb;
var _localstorage = localstorage;
var _simulate = simulate;
// the line below will be removed from es5/browser builds

// order is important
var METHODS = [_native.NativeMethod,
// fastest
_indexedDb.IndexedDBMethod, _localstorage.LocalstorageMethod];
function chooseMethod(options) {
  var chooseMethods = [].concat(options.methods, METHODS).filter(Boolean);

  // the line below will be removed from es5/browser builds

  // directly chosen
  if (options.type) {
    if (options.type === 'simulate') {
      // only use simulate-method if directly chosen
      return _simulate.SimulateMethod;
    }
    var ret = chooseMethods.find(function (m) {
      return m.type === options.type;
    });
    if (!ret) throw new Error('method-type ' + options.type + ' not found');else return ret;
  }

  /**
   * if no webworker support is needed,
   * remove idb from the list so that localstorage will be chosen
   */
  if (!options.webWorkerSupport) {
    chooseMethods = chooseMethods.filter(function (m) {
      return m.type !== 'idb';
    });
  }
  var useMethod = chooseMethods.find(function (method) {
    return method.canBeUsed();
  });
  if (!useMethod) {
    throw new Error("No usable method found in " + JSON.stringify(METHODS.map(function (m) {
      return m.type;
    })));
  } else {
    return useMethod;
  }
}

Object.defineProperty(broadcastChannel, "__esModule", {
  value: true
});
broadcastChannel.OPEN_BROADCAST_CHANNELS = broadcastChannel.BroadcastChannel = void 0;
broadcastChannel.clearNodeFolder = clearNodeFolder;
broadcastChannel.enforceOptions = enforceOptions;
var _util$2 = util;
var _methodChooser = methodChooser;
var _options = options;
/**
 * Contains all open channels,
 * used in tests to ensure everything is closed.
 */
var OPEN_BROADCAST_CHANNELS = broadcastChannel.OPEN_BROADCAST_CHANNELS = new Set();
var lastId = 0;
var BroadcastChannel$1 = broadcastChannel.BroadcastChannel = function BroadcastChannel(name, options) {
  // identifier of the channel to debug stuff
  this.id = lastId++;
  OPEN_BROADCAST_CHANNELS.add(this);
  this.name = name;
  if (ENFORCED_OPTIONS) {
    options = ENFORCED_OPTIONS;
  }
  this.options = (0, _options.fillOptionsWithDefaults)(options);
  this.method = (0, _methodChooser.chooseMethod)(this.options);

  // isListening
  this._iL = false;

  /**
   * _onMessageListener
   * setting onmessage twice,
   * will overwrite the first listener
   */
  this._onML = null;

  /**
   * _addEventListeners
   */
  this._addEL = {
    message: [],
    internal: []
  };

  /**
   * Unsent message promises
   * where the sending is still in progress
   * @type {Set<Promise>}
   */
  this._uMP = new Set();

  /**
   * _beforeClose
   * array of promises that will be awaited
   * before the channel is closed
   */
  this._befC = [];

  /**
   * _preparePromise
   */
  this._prepP = null;
  _prepareChannel(this);
};

// STATICS

/**
 * used to identify if someone overwrites
 * window.BroadcastChannel with this
 * See methods/native.js
 */
BroadcastChannel$1._pubkey = true;

/**
 * clears the tmp-folder if is node
 * @return {Promise<boolean>} true if has run, false if not node
 */
function clearNodeFolder(options) {
  options = (0, _options.fillOptionsWithDefaults)(options);
  var method = (0, _methodChooser.chooseMethod)(options);
  if (method.type === 'node') {
    return method.clearNodeFolder().then(function () {
      return true;
    });
  } else {
    return _util$2.PROMISE_RESOLVED_FALSE;
  }
}

/**
 * if set, this method is enforced,
 * no mather what the options are
 */
var ENFORCED_OPTIONS;
function enforceOptions(options) {
  ENFORCED_OPTIONS = options;
}

// PROTOTYPE
BroadcastChannel$1.prototype = {
  postMessage: function postMessage(msg) {
    if (this.closed) {
      throw new Error('BroadcastChannel.postMessage(): ' + 'Cannot post message after channel has closed ' +
      /**
       * In the past when this error appeared, it was really hard to debug.
       * So now we log the msg together with the error so it at least
       * gives some clue about where in your application this happens.
       */
      JSON.stringify(msg));
    }
    return _post(this, 'message', msg);
  },
  postInternal: function postInternal(msg) {
    return _post(this, 'internal', msg);
  },
  set onmessage(fn) {
    var time = this.method.microSeconds();
    var listenObj = {
      time: time,
      fn: fn
    };
    _removeListenerObject(this, 'message', this._onML);
    if (fn && typeof fn === 'function') {
      this._onML = listenObj;
      _addListenerObject(this, 'message', listenObj);
    } else {
      this._onML = null;
    }
  },
  addEventListener: function addEventListener(type, fn) {
    var time = this.method.microSeconds();
    var listenObj = {
      time: time,
      fn: fn
    };
    _addListenerObject(this, type, listenObj);
  },
  removeEventListener: function removeEventListener(type, fn) {
    var obj = this._addEL[type].find(function (obj) {
      return obj.fn === fn;
    });
    _removeListenerObject(this, type, obj);
  },
  close: function close() {
    var _this = this;
    if (this.closed) {
      return;
    }
    OPEN_BROADCAST_CHANNELS["delete"](this);
    this.closed = true;
    var awaitPrepare = this._prepP ? this._prepP : _util$2.PROMISE_RESOLVED_VOID;
    this._onML = null;
    this._addEL.message = [];
    return awaitPrepare
    // wait until all current sending are processed
    .then(function () {
      return Promise.all(Array.from(_this._uMP));
    })
    // run before-close hooks
    .then(function () {
      return Promise.all(_this._befC.map(function (fn) {
        return fn();
      }));
    })
    // close the channel
    .then(function () {
      return _this.method.close(_this._state);
    });
  },
  get type() {
    return this.method.type;
  },
  get isClosed() {
    return this.closed;
  }
};

/**
 * Post a message over the channel
 * @returns {Promise} that resolved when the message sending is done
 */
function _post(broadcastChannel, type, msg) {
  var time = broadcastChannel.method.microSeconds();
  var msgObj = {
    time: time,
    type: type,
    data: msg
  };
  var awaitPrepare = broadcastChannel._prepP ? broadcastChannel._prepP : _util$2.PROMISE_RESOLVED_VOID;
  return awaitPrepare.then(function () {
    var sendPromise = broadcastChannel.method.postMessage(broadcastChannel._state, msgObj);

    // add/remove to unsent messages list
    broadcastChannel._uMP.add(sendPromise);
    sendPromise["catch"]().then(function () {
      return broadcastChannel._uMP["delete"](sendPromise);
    });
    return sendPromise;
  });
}
function _prepareChannel(channel) {
  var maybePromise = channel.method.create(channel.name, channel.options);
  if ((0, _util$2.isPromise)(maybePromise)) {
    channel._prepP = maybePromise;
    maybePromise.then(function (s) {
      // used in tests to simulate slow runtime
      /*if (channel.options.prepareDelay) {
           await new Promise(res => setTimeout(res, this.options.prepareDelay));
      }*/
      channel._state = s;
    });
  } else {
    channel._state = maybePromise;
  }
}
function _hasMessageListeners(channel) {
  if (channel._addEL.message.length > 0) return true;
  if (channel._addEL.internal.length > 0) return true;
  return false;
}
function _addListenerObject(channel, type, obj) {
  channel._addEL[type].push(obj);
  _startListening(channel);
}
function _removeListenerObject(channel, type, obj) {
  channel._addEL[type] = channel._addEL[type].filter(function (o) {
    return o !== obj;
  });
  _stopListening(channel);
}
function _startListening(channel) {
  if (!channel._iL && _hasMessageListeners(channel)) {
    // someone is listening, start subscribing

    var listenerFn = function listenerFn(msgObj) {
      channel._addEL[msgObj.type].forEach(function (listenerObject) {
        if (msgObj.time >= listenerObject.time) {
          listenerObject.fn(msgObj.data);
        }
      });
    };
    var time = channel.method.microSeconds();
    if (channel._prepP) {
      channel._prepP.then(function () {
        channel._iL = true;
        channel.method.onMessage(channel._state, listenerFn, time);
      });
    } else {
      channel._iL = true;
      channel.method.onMessage(channel._state, listenerFn, time);
    }
  }
}
function _stopListening(channel) {
  if (channel._iL && !_hasMessageListeners(channel)) {
    // no one is listening, stop subscribing
    channel._iL = false;
    var time = channel.method.microSeconds();
    channel.method.onMessage(channel._state, null, time);
  }
}

var leaderElection = {};

var leaderElectionUtil = {};

/* global WorkerGlobalScope */

function addBrowser(fn) {
  if (typeof WorkerGlobalScope === 'function' && self instanceof WorkerGlobalScope) {
    /**
     * Because killing a worker does directly stop the excution
     * of the code, our only chance is to overwrite the close function
     * which could work some times.
     * @link https://stackoverflow.com/q/72903255/3443137
     */
    var oldClose = self.close.bind(self);
    self.close = function () {
      fn();
      return oldClose();
    };
  } else {
    /**
     * if we are on react-native, there is no window.addEventListener
     * @link https://github.com/pubkey/unload/issues/6
     */
    if (typeof window.addEventListener !== 'function') {
      return;
    }

    /**
     * for normal browser-windows, we use the beforeunload-event
     */
    window.addEventListener('beforeunload', function () {
      fn();
    }, true);

    /**
     * for iframes, we have to use the unload-event
     * @link https://stackoverflow.com/q/47533670/3443137
     */
    window.addEventListener('unload', function () {
      fn();
    }, true);
  }

  /**
   * TODO add fallback for safari-mobile
   * @link https://stackoverflow.com/a/26193516/3443137
   */
}

function addNode(fn) {
  process.on('exit', function () {
    return fn();
  });

  /**
   * on the following events,
   * the process will not end if there are
   * event-handlers attached,
   * therefore we have to call process.exit()
   */
  process.on('beforeExit', function () {
    return fn().then(function () {
      return process.exit();
    });
  });
  // catches ctrl+c event
  process.on('SIGINT', function () {
    return fn().then(function () {
      return process.exit();
    });
  });
  // catches uncaught exceptions
  process.on('uncaughtException', function (err) {
    return fn().then(function () {
      console.trace(err);
      process.exit(101);
    });
  });
}

/**
 * Use the code directly to prevent import problems
 * with the detect-node package.
 * @link https://github.com/iliakan/detect-node/blob/master/index.js
 */
var isNode$1 = Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
var USE_METHOD = isNode$1 ? addNode : addBrowser;
var LISTENERS = new Set();
var startedListening = false;
function startListening() {
  if (startedListening) {
    return;
  }
  startedListening = true;
  USE_METHOD(runAll);
}
function add(fn) {
  startListening();
  if (typeof fn !== 'function') {
    throw new Error('Listener is no function');
  }
  LISTENERS.add(fn);
  var addReturn = {
    remove: function remove() {
      return LISTENERS["delete"](fn);
    },
    run: function run() {
      LISTENERS["delete"](fn);
      return fn();
    }
  };
  return addReturn;
}
function runAll() {
  var promises = [];
  LISTENERS.forEach(function (fn) {
    promises.push(fn());
    LISTENERS["delete"](fn);
  });
  return Promise.all(promises);
}
function removeAll() {
  LISTENERS.clear();
}
function getSize() {
  return LISTENERS.size;
}

const es$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    add: add,
    runAll: runAll,
    removeAll: removeAll,
    getSize: getSize
});

const require$$0$1 = /*@__PURE__*/getAugmentedNamespace(es$1);

Object.defineProperty(leaderElectionUtil, "__esModule", {
  value: true
});
leaderElectionUtil.beLeader = beLeader;
leaderElectionUtil.sendLeaderMessage = sendLeaderMessage;
var _unload = require$$0$1;
/**
 * sends and internal message over the broadcast-channel
 */
function sendLeaderMessage(leaderElector, action) {
  var msgJson = {
    context: 'leader',
    action: action,
    token: leaderElector.token
  };
  return leaderElector.broadcastChannel.postInternal(msgJson);
}
function beLeader(leaderElector) {
  leaderElector.isLeader = true;
  leaderElector._hasLeader = true;
  var unloadFn = (0, _unload.add)(function () {
    return leaderElector.die();
  });
  leaderElector._unl.push(unloadFn);
  var isLeaderListener = function isLeaderListener(msg) {
    if (msg.context === 'leader' && msg.action === 'apply') {
      sendLeaderMessage(leaderElector, 'tell');
    }
    if (msg.context === 'leader' && msg.action === 'tell' && !leaderElector._dpLC) {
      /**
       * another instance is also leader!
       * This can happen on rare events
       * like when the CPU is at 100% for long time
       * or the tabs are open very long and the browser throttles them.
       * @link https://github.com/pubkey/broadcast-channel/issues/414
       * @link https://github.com/pubkey/broadcast-channel/issues/385
       */
      leaderElector._dpLC = true;
      leaderElector._dpL(); // message the lib user so the app can handle the problem
      sendLeaderMessage(leaderElector, 'tell'); // ensure other leader also knows the problem
    }
  };

  leaderElector.broadcastChannel.addEventListener('internal', isLeaderListener);
  leaderElector._lstns.push(isLeaderListener);
  return sendLeaderMessage(leaderElector, 'tell');
}

var leaderElectionWebLock = {};

Object.defineProperty(leaderElectionWebLock, "__esModule", {
  value: true
});
leaderElectionWebLock.LeaderElectionWebLock = void 0;
var _util$1 = util;
var _leaderElectionUtil$1 = leaderElectionUtil;
/**
 * A faster version of the leader elector that uses the WebLock API
 * @link https://developer.mozilla.org/en-US/docs/Web/API/Web_Locks_API
 */
var LeaderElectionWebLock = leaderElectionWebLock.LeaderElectionWebLock = function LeaderElectionWebLock(broadcastChannel, options) {
  var _this = this;
  this.broadcastChannel = broadcastChannel;
  broadcastChannel._befC.push(function () {
    return _this.die();
  });
  this._options = options;
  this.isLeader = false;
  this.isDead = false;
  this.token = (0, _util$1.randomToken)();
  this._lstns = [];
  this._unl = [];
  this._dpL = function () {}; // onduplicate listener
  this._dpLC = false; // true when onduplicate called

  this._wKMC = {}; // stuff for cleanup

  // lock name
  this.lN = 'pubkey-bc||' + broadcastChannel.method.type + '||' + broadcastChannel.name;
};
LeaderElectionWebLock.prototype = {
  hasLeader: function hasLeader() {
    var _this2 = this;
    return navigator.locks.query().then(function (locks) {
      var relevantLocks = locks.held ? locks.held.filter(function (lock) {
        return lock.name === _this2.lN;
      }) : [];
      if (relevantLocks && relevantLocks.length > 0) {
        return true;
      } else {
        return false;
      }
    });
  },
  awaitLeadership: function awaitLeadership() {
    var _this3 = this;
    if (!this._wLMP) {
      this._wKMC.c = new AbortController();
      var returnPromise = new Promise(function (res, rej) {
        _this3._wKMC.res = res;
        _this3._wKMC.rej = rej;
      });
      this._wLMP = new Promise(function (res) {
        navigator.locks.request(_this3.lN, {
          signal: _this3._wKMC.c.signal
        }, function () {
          // if the lock resolved, we can drop the abort controller
          _this3._wKMC.c = undefined;
          (0, _leaderElectionUtil$1.beLeader)(_this3);
          res();
          return returnPromise;
        })["catch"](function () {});
      });
    }
    return this._wLMP;
  },
  set onduplicate(_fn) {
    // Do nothing because there are no duplicates in the WebLock version
  },
  die: function die() {
    var _this4 = this;
    this._lstns.forEach(function (listener) {
      return _this4.broadcastChannel.removeEventListener('internal', listener);
    });
    this._lstns = [];
    this._unl.forEach(function (uFn) {
      return uFn.remove();
    });
    this._unl = [];
    if (this.isLeader) {
      this.isLeader = false;
    }
    this.isDead = true;
    if (this._wKMC.res) {
      this._wKMC.res();
    }
    if (this._wKMC.c) {
      this._wKMC.c.abort('LeaderElectionWebLock.die() called');
    }
    return (0, _leaderElectionUtil$1.sendLeaderMessage)(this, 'death');
  }
};

Object.defineProperty(leaderElection, "__esModule", {
  value: true
});
leaderElection.createLeaderElection = createLeaderElection;
var _util = util;
var _leaderElectionUtil = leaderElectionUtil;
var _leaderElectionWebLock = leaderElectionWebLock;
var LeaderElection = function LeaderElection(broadcastChannel, options) {
  var _this = this;
  this.broadcastChannel = broadcastChannel;
  this._options = options;
  this.isLeader = false;
  this._hasLeader = false;
  this.isDead = false;
  this.token = (0, _util.randomToken)();

  /**
   * Apply Queue,
   * used to ensure we do not run applyOnce()
   * in parallel.
   */
  this._aplQ = _util.PROMISE_RESOLVED_VOID;
  // amount of unfinished applyOnce() calls
  this._aplQC = 0;

  // things to clean up
  this._unl = []; // _unloads
  this._lstns = []; // _listeners
  this._dpL = function () {}; // onduplicate listener
  this._dpLC = false; // true when onduplicate called

  /**
   * Even when the own instance is not applying,
   * we still listen to messages to ensure the hasLeader flag
   * is set correctly.
   */
  var hasLeaderListener = function hasLeaderListener(msg) {
    if (msg.context === 'leader') {
      if (msg.action === 'death') {
        _this._hasLeader = false;
      }
      if (msg.action === 'tell') {
        _this._hasLeader = true;
      }
    }
  };
  this.broadcastChannel.addEventListener('internal', hasLeaderListener);
  this._lstns.push(hasLeaderListener);
};
LeaderElection.prototype = {
  hasLeader: function hasLeader() {
    return Promise.resolve(this._hasLeader);
  },
  /**
   * Returns true if the instance is leader,
   * false if not.
   * @async
   */
  applyOnce: function applyOnce(
  // true if the applyOnce() call came from the fallbackInterval cycle
  isFromFallbackInterval) {
    var _this2 = this;
    if (this.isLeader) {
      return (0, _util.sleep)(0, true);
    }
    if (this.isDead) {
      return (0, _util.sleep)(0, false);
    }

    /**
     * Already applying more than once,
     * -> wait for the apply queue to be finished.
     */
    if (this._aplQC > 1) {
      return this._aplQ;
    }

    /**
     * Add a new apply-run
     */
    var applyRun = function applyRun() {
      /**
       * Optimization shortcuts.
       * Directly return if a previous run
       * has already elected a leader.
       */
      if (_this2.isLeader) {
        return _util.PROMISE_RESOLVED_TRUE;
      }
      var stopCriteria = false;
      var stopCriteriaPromiseResolve;
      /**
       * Resolves when a stop criteria is reached.
       * Uses as a performance shortcut so we do not
       * have to await the responseTime when it is already clear
       * that the election failed.
       */
      var stopCriteriaPromise = new Promise(function (res) {
        stopCriteriaPromiseResolve = function stopCriteriaPromiseResolve() {
          stopCriteria = true;
          res();
        };
      });
      var handleMessage = function handleMessage(msg) {
        if (msg.context === 'leader' && msg.token != _this2.token) {
          if (msg.action === 'apply') {
            // other is applying
            if (msg.token > _this2.token) {
              /**
               * other has higher token
               * -> stop applying and let other become leader.
               */
              stopCriteriaPromiseResolve();
            }
          }
          if (msg.action === 'tell') {
            // other is already leader
            stopCriteriaPromiseResolve();
            _this2._hasLeader = true;
          }
        }
      };
      _this2.broadcastChannel.addEventListener('internal', handleMessage);

      /**
       * If the applyOnce() call came from the fallbackInterval,
       * we can assume that the election runs in the background and
       * not critical process is waiting for it.
       * When this is true, we give the other instances
       * more time to answer to messages in the election cycle.
       * This makes it less likely to elect duplicate leaders.
       * But also it takes longer which is not a problem because we anyway
       * run in the background.
       */
      var waitForAnswerTime = isFromFallbackInterval ? _this2._options.responseTime * 4 : _this2._options.responseTime;
      return (0, _leaderElectionUtil.sendLeaderMessage)(_this2, 'apply') // send out that this one is applying
      .then(function () {
        return Promise.race([(0, _util.sleep)(waitForAnswerTime), stopCriteriaPromise.then(function () {
          return Promise.reject(new Error());
        })]);
      })
      // send again in case another instance was just created
      .then(function () {
        return (0, _leaderElectionUtil.sendLeaderMessage)(_this2, 'apply');
      })
      // let others time to respond
      .then(function () {
        return Promise.race([(0, _util.sleep)(waitForAnswerTime), stopCriteriaPromise.then(function () {
          return Promise.reject(new Error());
        })]);
      })["catch"](function () {}).then(function () {
        _this2.broadcastChannel.removeEventListener('internal', handleMessage);
        if (!stopCriteria) {
          // no stop criteria -> own is leader
          return (0, _leaderElectionUtil.beLeader)(_this2).then(function () {
            return true;
          });
        } else {
          // other is leader
          return false;
        }
      });
    };
    this._aplQC = this._aplQC + 1;
    this._aplQ = this._aplQ.then(function () {
      return applyRun();
    }).then(function () {
      _this2._aplQC = _this2._aplQC - 1;
    });
    return this._aplQ.then(function () {
      return _this2.isLeader;
    });
  },
  awaitLeadership: function awaitLeadership() {
    if ( /* _awaitLeadershipPromise */
    !this._aLP) {
      this._aLP = _awaitLeadershipOnce(this);
    }
    return this._aLP;
  },
  set onduplicate(fn) {
    this._dpL = fn;
  },
  die: function die() {
    var _this3 = this;
    this._lstns.forEach(function (listener) {
      return _this3.broadcastChannel.removeEventListener('internal', listener);
    });
    this._lstns = [];
    this._unl.forEach(function (uFn) {
      return uFn.remove();
    });
    this._unl = [];
    if (this.isLeader) {
      this._hasLeader = false;
      this.isLeader = false;
    }
    this.isDead = true;
    return (0, _leaderElectionUtil.sendLeaderMessage)(this, 'death');
  }
};

/**
 * @param leaderElector {LeaderElector}
 */
function _awaitLeadershipOnce(leaderElector) {
  if (leaderElector.isLeader) {
    return _util.PROMISE_RESOLVED_VOID;
  }
  return new Promise(function (res) {
    var resolved = false;
    function finish() {
      if (resolved) {
        return;
      }
      resolved = true;
      leaderElector.broadcastChannel.removeEventListener('internal', whenDeathListener);
      res(true);
    }

    // try once now
    leaderElector.applyOnce().then(function () {
      if (leaderElector.isLeader) {
        finish();
      }
    });

    /**
     * Try on fallbackInterval
     * @recursive
     */
    var tryOnFallBack = function tryOnFallBack() {
      return (0, _util.sleep)(leaderElector._options.fallbackInterval).then(function () {
        if (leaderElector.isDead || resolved) {
          return;
        }
        if (leaderElector.isLeader) {
          finish();
        } else {
          return leaderElector.applyOnce(true).then(function () {
            if (leaderElector.isLeader) {
              finish();
            } else {
              tryOnFallBack();
            }
          });
        }
      });
    };
    tryOnFallBack();

    // try when other leader dies
    var whenDeathListener = function whenDeathListener(msg) {
      if (msg.context === 'leader' && msg.action === 'death') {
        leaderElector._hasLeader = false;
        leaderElector.applyOnce().then(function () {
          if (leaderElector.isLeader) {
            finish();
          }
        });
      }
    };
    leaderElector.broadcastChannel.addEventListener('internal', whenDeathListener);
    leaderElector._lstns.push(whenDeathListener);
  });
}
function fillOptionsWithDefaults(options, channel) {
  if (!options) options = {};
  options = JSON.parse(JSON.stringify(options));
  if (!options.fallbackInterval) {
    options.fallbackInterval = 3000;
  }
  if (!options.responseTime) {
    options.responseTime = channel.method.averageResponseTime(channel.options);
  }
  return options;
}
function createLeaderElection(channel, options) {
  if (channel._leaderElector) {
    throw new Error('BroadcastChannel already has a leader-elector');
  }
  options = fillOptionsWithDefaults(options, channel);
  var elector = (0, _util.supportsWebLockAPI)() ? new _leaderElectionWebLock.LeaderElectionWebLock(channel, options) : new LeaderElection(channel, options);
  channel._befC.push(function () {
    return elector.die();
  });
  channel._leaderElector = elector;
  return elector;
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BroadcastChannel", {
  enumerable: true,
  get: function get() {
    return _broadcastChannel.BroadcastChannel;
  }
});
Object.defineProperty(exports, "OPEN_BROADCAST_CHANNELS", {
  enumerable: true,
  get: function get() {
    return _broadcastChannel.OPEN_BROADCAST_CHANNELS;
  }
});
Object.defineProperty(exports, "beLeader", {
  enumerable: true,
  get: function get() {
    return _leaderElectionUtil.beLeader;
  }
});
Object.defineProperty(exports, "clearNodeFolder", {
  enumerable: true,
  get: function get() {
    return _broadcastChannel.clearNodeFolder;
  }
});
Object.defineProperty(exports, "createLeaderElection", {
  enumerable: true,
  get: function get() {
    return _leaderElection.createLeaderElection;
  }
});
Object.defineProperty(exports, "enforceOptions", {
  enumerable: true,
  get: function get() {
    return _broadcastChannel.enforceOptions;
  }
});
var _broadcastChannel = broadcastChannel;
var _leaderElection = leaderElection;
var _leaderElectionUtil = leaderElectionUtil;
}(lib$1));

var _index = lib$1;
/**
 * because babel can only export on default-attribute,
 * we use this for the non-module-build
 * this ensures that users do not have to use
 * var BroadcastChannel = require('broadcast-channel').default;
 * but
 * var BroadcastChannel = require('broadcast-channel');
 */

var index_es5 = {
  BroadcastChannel: _index.BroadcastChannel,
  createLeaderElection: _index.createLeaderElection,
  clearNodeFolder: _index.clearNodeFolder,
  enforceOptions: _index.enforceOptions,
  beLeader: _index.beLeader
};

var js_cookie = {exports: {}};

/*! js-cookie v3.0.5 | MIT */

(function (module, exports) {
(function (global, factory) {
  module.exports = factory() ;
})(commonjsGlobal, (function () {
  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      if (value[0] === '"') {
        value = value.slice(1, -1);
      }
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (name, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      name = encodeURIComponent(name)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie =
        name + '=' + converter.write(value, name) + stringifiedAttributes)
    }

    function get (name) {
      if (typeof document === 'undefined' || (arguments.length && !name)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        try {
          var found = decodeURIComponent(parts[0]);
          jar[found] = converter.read(value, found);

          if (name === found) {
            break
          }
        } catch (e) {}
      }

      return name ? jar[name] : jar
    }

    return Object.create(
      {
        set,
        get,
        remove: function (name, attributes) {
          set(
            name,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

}));
}(js_cookie));

const Cookies = js_cookie.exports;

const languageChannelName = 'language_channel';
const themeChannelName = 'theme_channel';
const accessibilityChannelName = 'accessibility_channel';
const alertDurationChannelName = 'alert_duration_channel';

// Regexp to match various 'token' variants
const tokenRegExp = /(token=)[^&]+/g; /* global, to handle multiple matches */
// eslint-disable-next-line spaced-comment
const emailRegExp = /([a-zA-Z0-9._+-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi; //NOSONAR email is from page URL
/**
 * Helper function to remove sensitive hash/query parameter tokens from url (ie, `id_token=...`, `access_token=...`)
 * @param url string to sanitize
 */
const sanitizeUrl = (url) => {
    const sanitizedUrl = url
        .replace(tokenRegExp, '$1' + '<token>')
        .replace(emailRegExp, '<email>');
    const odataIndex = url.toLowerCase().indexOf('/odata/');
    if (odataIndex > -1) {
        return sanitizedUrl.substring(0, odataIndex) + '/odata/<odata>';
    }
    return sanitizedUrl;
};
/**
 * Helper function to remove sensitive email addresses from objects
 * @param obj object to sanitize
 * @returns sanitized object or error object with generic error to prevent leaking sensitive data
 */
const sanitizeEmailFromObject = (obj) => {
    try {
        const objectJson = JSON.stringify(obj);
        const sanitizedJson = objectJson.replace(emailRegExp, '<email>');
        return JSON.parse(sanitizedJson);
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error('request', `Error sanitizing object: ${e.message}`);
        return { error: `Error sanitizing object` };
    }
};
function getHeaders(token) {
    return {
        'Content-Type': 'application/json; charset=UTF-8',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
    };
}
function getBody(body) {
    return body ? JSON.stringify(body) : '';
}
function defaultErrorCallback(error, method, url, requestProps) {
    // eslint-disable-next-line no-console
    console.error('request', `Error making ${method} request to ${url}: ${error.message} with props ${JSON.stringify(requestProps)}`);
    throw error;
}
async function defaultSuccessCallback(response) {
    const contentType = response.headers.get('content-type');
    let body = await response.text();
    if ((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf('application/json')) !== -1) {
        try {
            body = JSON.parse(body);
        }
        catch (_a) {
            // eslint-disable-next-line no-console
            console.warn('request', 'Response body is not JSON but content-type header is application/json');
        }
    }
    if (response.ok) {
        return body;
    }
    throw body;
}
async function safeFetch(method, url, requestProps, errorCallback = defaultErrorCallback, successCallback = defaultSuccessCallback) {
    try {
        const hasBody = method === 'POST' || method === 'PUT' || method === 'PATCH';
        const fetchProps = Object.assign({ method, headers: Object.assign(Object.assign({}, getHeaders(requestProps.token)), requestProps.headers) }, (hasBody ? { body: getBody(requestProps.body) } : {}));
        // The default value for credentials is "same-origin",
        // we want to override it only if we have a custom value defined
        // in the requestProps.credentials.
        if (requestProps.credentials != null) {
            fetchProps.credentials = requestProps.credentials;
        }
        const res = await fetch(url, fetchProps);
        return await successCallback(res);
    }
    catch (e) {
        return errorCallback(e, method, sanitizeUrl(url), Object.assign(Object.assign({}, sanitizeEmailFromObject(requestProps)), { token: requestProps.token ? '<token>' : 'none' }));
    }
}
async function get(url, requestProps, errorCallback = defaultErrorCallback, successCallback = defaultSuccessCallback) {
    return safeFetch('GET', url, requestProps, errorCallback, successCallback);
}
async function put(url, requestProps, errorCallback = defaultErrorCallback, successCallback = defaultSuccessCallback) {
    return safeFetch('PUT', url, requestProps, errorCallback, successCallback);
}
async function post(url, requestProps, errorCallback = defaultErrorCallback, successCallback = defaultSuccessCallback) {
    return safeFetch('POST', url, requestProps, errorCallback, successCallback);
}
async function patch(url, requestProps, errorCallback = defaultErrorCallback, successCallback = defaultSuccessCallback) {
    return safeFetch('PATCH', url, requestProps, errorCallback, successCallback);
}

function caseInsensitiveCompare$1(str1, str2) {
    return str1.toLowerCase() === str2.toLowerCase();
}

let languageChannelOut = null;
function createLanguageChannel() {
    return new index_es5.BroadcastChannel(languageChannelName);
}
function setCookieLocale(languageCode, env = getEnvironment()) {
    Cookies.set(`language-${env}`, languageCode, {
        domain: getEnvironmentDomain(env),
        expires: 60,
    });
}
function messageLanguageChannel(language) {
    if (!languageChannelOut) {
        languageChannelOut = createLanguageChannel();
    }
    languageChannelOut.postMessage(language);
}
function validateLanguageCode(languageCode) {
    if (!languageCode) {
        return undefined;
    }
    if (caseInsensitiveCompare$1(languageCode, 'zh-Hans')) {
        return 'zh-cn';
    }
    if (caseInsensitiveCompare$1(languageCode, 'zh-Hant')) {
        return 'zh-tw';
    }
    return Object.keys(Languages).find(language => caseInsensitiveCompare$1(language, languageCode));
}
function getCachedLanguage(env = getEnvironment()) {
    var _a;
    return validateLanguageCode((_a = Cookies.get(`language-${env}`)) !== null && _a !== void 0 ? _a : localStorage.getItem(languageStorageKey));
}
function getCachedLanguageWithDate(env = getEnvironment()) {
    var _a, _b;
    const cachedLanguage = getCachedLanguage(env);
    if (!cachedLanguage) {
        return null;
    }
    return {
        language: cachedLanguage,
        date: (_b = (_a = Cookies.get(languageDateStorageKey)) !== null && _a !== void 0 ? _a : localStorage.getItem(languageDateStorageKey)) !== null && _b !== void 0 ? _b : '0',
    };
}
function setLanguage(language, { env = getEnvironment(), shouldUpdateUserLanguage = false, shouldBroadcast = true, } = {}) {
    var _a;
    const validLanguage = (_a = validateLanguageCode(language)) !== null && _a !== void 0 ? _a : defaultLanguage;
    if (shouldBroadcast) {
        messageLanguageChannel(validLanguage);
    }
    localStorage.setItem(languageStorageKey, validLanguage);
    setCookieLocale(validLanguage, env);
    if (shouldUpdateUserLanguage) {
        const date = `${Date.now()}`;
        localStorage.setItem(languageDateStorageKey, date);
        Cookies.set(languageDateStorageKey, date, {
            domain: getEnvironmentDomain(env),
            expires: 60,
        });
    }
}
async function setUserLanguage(language, organizationStandardUrl, token, partitionGlobalId, userId, isMsi, { env = getEnvironment(), shouldBroadcast = true, } = {}) {
    var _a, _b;
    // Clean up the cached language date which was used for the language comparison.
    localStorage.removeItem(languageDateStorageKey);
    Cookies.remove(languageDateStorageKey, { domain: getEnvironmentDomain(env) });
    const validLanguage = (_a = validateLanguageCode(language)) !== null && _a !== void 0 ? _a : defaultLanguage;
    setLanguage(validLanguage, {
        env,
        shouldBroadcast,
    });
    const settingsUrl = `${organizationStandardUrl}/${isMsi ? 'identity/api' : 'portal_/api/identity'}/Setting`;
    await put(settingsUrl, {
        token,
        body: {
            settings: [
                {
                    key: ApolloSettingKey.UserLanguage,
                    value: validLanguage,
                },
                {
                    key: ApolloSettingKey.UserLanguageDate,
                    value: `${Date.now()}`,
                },
            ],
            partitionGlobalId,
            userId,
        },
    });
    if (isMsi && !isLocal$1()) {
        const changeCultureUrl = `${organizationStandardUrl}/odata/Users/UiPath.Server.Configuration.OData.ChangeCulture`;
        try {
            await post(changeCultureUrl, {
                token,
                body: { culture: validLanguage },
            });
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error(`
                Status ${(_b = e === null || e === void 0 ? void 0 : e.status) !== null && _b !== void 0 ? _b : '500'}: Failed to change culture to ${validLanguage} in OR using ${changeCultureUrl}.
                Using identity settings API instead.
            `);
        }
    }
}
/**
 * @returns The disposer
 */
function handleLanguageChange(callback) {
    const channel = createLanguageChannel();
    channel.onmessage = language => {
        callback(language);
    };
    return () => {
        channel.close();
    };
}

var _a$d;
/**
 * Static class that allows adding new media queries to listen to or subscribe/unsubscribe from existing ones.
 * It uses the window.matchMedia API to listen to media query changes (which is more performant than listening to window resize events).
 */
class MediaQueryListener {
}
_a$d = MediaQueryListener;
MediaQueryListener._subscribers = {};
MediaQueryListener._eventListenersRefs = {};
/**
 * Subscribe by passing a callback and the media query to listen to in a string format.
 * It will also instantly call the subscriber with the current state of the media query.
 *
 * @param cb - callback function to be called when the media query match changes
 * @param query - media query to listen to (default is '(max-width: 768px)')
 */
MediaQueryListener.subscribe = (cb, query = '(max-width: 768px)') => {
    var _b, _c, _d, _e;
    if (!_a$d._subscribers[query]) {
        _a$d._subscribers[query] = {
            query: (_b = window.matchMedia) === null || _b === void 0 ? void 0 : _b.call(window, query),
            subscribers: [cb],
        };
        _a$d._eventListenersRefs[query] = event => {
            _a$d._subscribers[query].subscribers.forEach(subscriber => subscriber(event.matches));
        };
        _a$d._subscribers[query].query.addEventListener('change', _a$d._eventListenersRefs[query]);
    }
    else {
        _a$d._subscribers[query].subscribers.push(cb);
    }
    // Call the callback with the current value of the media query
    cb((_e = (_d = (_c = window.matchMedia) === null || _c === void 0 ? void 0 : _c.call(window, query)) === null || _d === void 0 ? void 0 : _d.matches) !== null && _e !== void 0 ? _e : false);
};
/**
 * Unsubscribe by passing the callback and the media query to stop listening to in a string format.
 *
 * Also handles memory leaks by removing the event listener when there are no more subscribers so don't forget
 * to call unsubscribe when you're done (best place should be in `disconnectedCallback` lifecycle method of the component).
 *
 * @param cb - callback function to be called when the media query match changes
 * @param query - media query to listen to (default is '(max-width: 768px)')
 */
MediaQueryListener.unsubscribe = (cb, query = '(max-width: 768px)') => {
    if (!_a$d._subscribers[query]) {
        return;
    }
    _a$d._subscribers[query].subscribers = _a$d._subscribers[query].subscribers.filter(subscriber => subscriber !== cb);
    if (_a$d._subscribers[query].subscribers.length === 0) {
        _a$d._subscribers[query].query.removeEventListener('change', _a$d._eventListenersRefs[query]);
        delete _a$d._subscribers[query];
        delete _a$d._eventListenersRefs[query];
    }
};
/**
 * Get the current state of a media query without subscribing to changes.
 *
 * @param query - media query to check (default is '(max-width: 768px)')
 * @returns boolean indicating whether the media query matches or not
 */
MediaQueryListener.getSnapshot = (query = '(max-width: 768px)') => { var _b, _c, _d; return (_d = (_c = (_b = window.matchMedia) === null || _b === void 0 ? void 0 : _b.call(window, query)) === null || _c === void 0 ? void 0 : _c.matches) !== null && _d !== void 0 ? _d : false; };

let themeChannelOut = null;
function createThemeChannel() {
    return new index_es5.BroadcastChannel(themeChannelName);
}
function getAutoThemeValue(includeHighContrast = false) {
    const isDarkMode = MediaQueryListener.getSnapshot(darkMediaQuery);
    if (includeHighContrast) {
        const isHighContrastMode = highContrastMediaQueries.some(highContrastMediaQuery => MediaQueryListener.getSnapshot(highContrastMediaQuery));
        if (isHighContrastMode) {
            return isDarkMode ? 'dark-hc' : 'light-hc';
        }
    }
    return isDarkMode ? 'dark' : 'light';
}
function messageThemeChannel(theme) {
    if (!themeChannelOut) {
        themeChannelOut = createThemeChannel();
    }
    themeChannelOut.postMessage(theme);
}
function validateThemeCode(themeCode) {
    if (!themeCode) {
        return undefined;
    }
    return themeList.find(theme => caseInsensitiveCompare$1(theme, themeCode));
}
function getCachedTheme() {
    var _a;
    return (_a = validateThemeCode(localStorage.getItem(themeStorageKey))) !== null && _a !== void 0 ? _a : defaultTheme;
}
function setTheme(theme, { shouldBroadcast = true } = {}) {
    var _a;
    const validTheme = (_a = validateThemeCode(theme)) !== null && _a !== void 0 ? _a : defaultTheme;
    if (shouldBroadcast) {
        messageThemeChannel(validTheme);
    }
    localStorage.setItem(themeStorageKey, validTheme);
}
async function setUserTheme(theme, organizationStandardUrl, token, partitionGlobalId, userId, isMsi, { shouldBroadcast = true } = {}) {
    var _a;
    const validTheme = (_a = validateThemeCode(theme)) !== null && _a !== void 0 ? _a : defaultTheme;
    if (shouldBroadcast) {
        messageThemeChannel(validTheme);
    }
    localStorage.setItem(themeStorageKey, validTheme);
    const settingsUrl = `${organizationStandardUrl}/${isMsi ? 'identity/api' : 'portal_/api/identity'}/Setting`;
    await put(settingsUrl, {
        token,
        body: {
            settings: [
                {
                    key: ApolloSettingKey.UserTheme,
                    value: validTheme,
                },
            ],
            partitionGlobalId,
            userId,
        },
    });
}
/**
 * @returns The disposer
 */
function handleThemeChange(callback) {
    const channel = createThemeChannel();
    channel.onmessage = theme => {
        callback(theme);
    };
    return () => {
        channel.close();
    };
}

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */

function debounce$1(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  }
  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
}
// Adds compatibility for ES modules
debounce$1.debounce = debounce$1;

var debounce_1 = debounce$1;

// for now just expose the builtin process global from node.js
var process$1 = commonjsGlobal.process;

const global$1 = (typeof global !== "undefined" ? global :
  typeof self !== "undefined" ? self :
  typeof window !== "undefined" ? window : {});

const home$c = "Home";
const help$c = "Help";
const languages$c = "Languages";
const language$c = "Language";
const edit$c = "Edit";
const enter$c = "Enter";
const theme$c = "Theme";
const logout$c = "Sign out";
const tenants$c = "Tenants";
const more$c = "More";
const admin$c = "Admin";
const autoTheme$c = "Auto select theme";
const dark$c = "Dark theme";
const light$c = "Light theme";
const dismiss$c = "dismiss";
const warning$c = "warning";
const info$c = "info";
const success$c = "success";
const error$d = "error";
const more_items$c = "More Items";
const notifications$c = "Notifications";
const preview$c = "Preview";
const more_products$c = "More options";
const current_plan_upgrade$c = "You're on a {{ license }} plan";
const free_license$c = "free";
const community_license$c = "community";
const pro_trial_license$c = "pro trial";
const unlicensed$c = "Unlicensed";
const back$c = "Back";
const trademark$c = "TM";
const basic_auth_user$c = "Local user";
const local_group$c = "Local group";
const robot$c = "Robot";
const directory_group$c = "Directory group";
const directory_user$c = "Directory user";
const directory_app$c = "Directory app";
const build$c = "Build";
const discover$c = "Discover";
const operate$c = "Operate";
const feedback$c = "Feedback";
const cancel$c = "Cancel";
const confirm$c = "Confirm";
const favorites$c = "Favorites";
const apply$b = "Apply";
const date$b = "Date";
const time$b = "Time";
const en = {
	home: home$c,
	help: help$c,
	languages: languages$c,
	language: language$c,
	edit: edit$c,
	"edit-subject": "Edit {{ subject }}",
	enter: enter$c,
	theme: theme$c,
	logout: logout$c,
	tenants: tenants$c,
	more: more$c,
	admin: admin$c,
	autoTheme: autoTheme$c,
	dark: dark$c,
	light: light$c,
	"light-hc": "High contrast light theme",
	"dark-hc": "High contrast dark theme",
	"close-button": "Close button",
	"client-days": "{{ differenceInDays }} days left",
	"client-hours": "{{ differenceInHours }} hours left",
	"dropdown-placeholder": "Please select any option",
	"empty-tenant-list-placeholder": "No valid tenant",
	"tenant-picker-label": "Tenant:",
	"tenant-picker-list": "Tenant",
	"error-page-401-header": "Unauthorized",
	"error-page-403-header": "Oops! You're not on the list",
	"error-page-403-description": "You don't have permission to view {{ pageTitle }}. Please contact your administrator for necessary permissions.",
	"error-page-404-header": "Uh oh! Can't find it",
	"error-page-404-description": "The page you're looking for may have been removed, had its name changed, or is temporarily unavailable.",
	"error-page-503-header": "We will be back up soon",
	"error-page-503-description": "The system is under maintenance. Watch this space for updates.",
	"error-page-browser-header": "This browser is not supported",
	"error-page-endie-header": "Phasing out Internet Explorer",
	"error-page-endie-description": "Support for Internet Explorer has ended on 31st May, 2021. To use UiPath, we recommend the latest version of Chrome, Firefox, Safari, or Edge.",
	"error-page-ip-restricted-header": "Access restricted",
	"error-page-ip-restricted-description": "Due to organizational policies, you can't access {{ pageTitle }} from this network location. Please contact your administrator.",
	"error-page-learn-more": "Learn more",
	"error-page-learn-why": "Learn why",
	"error-page-loader-header": "Please wait while we set up things for you",
	"error-page-loader-description": "This could take a few minutes. The page will refresh when the platform is ready to use.",
	"error-page-goto-home": "Go to home",
	"error-page-goto-uipath-website": "Go to UiPath website",
	"error-page-check-service": "Check service status",
	"error-page-know-why": "Know why",
	"aria-label-logo": "The official logo of UiPath. Clicking here goes to {{ serviceName }} home",
	"aria-label-logo-v2": "UiPath Automation Cloud logo, clicking here goes to {serviceName} home",
	"language-na": "Language not supported for this service.",
	dismiss: dismiss$c,
	warning: warning$c,
	info: info$c,
	success: success$c,
	error: error$d,
	"client-days-per-service": "You have {{ differenceInDays }} days left in your trial",
	"client-days-per-service-with-name": "You have {{ differenceInDays }} days left for your Free trial of {{ serviceName }}",
	"client-hours-per-service": "You have {{ differenceInHours }} hours left in your trial",
	"client-hours-per-service-with-name": "You have {{ differenceInHours }} hours left for your Free trial of {{ serviceName }}",
	"waffle-label": "App launcher",
	"generic-error-message": "An unexpected error has occurred. Please try again later",
	"help-menu-documentation": "Documentation",
	"help-menu-product-documentation": "{{ product }} documentation",
	"help-menu-downloads": "Downloads",
	"help-menu-forum": "Community forum",
	"help-menu-training-tutorials": "Training & tutorials",
	"help-menu-uipath-academy": "UiPath Academy",
	"help-menu-youtube-tutorials": "YouTube tutorials",
	"help-menu-release-notes": "Release notes",
	"help-menu-resources": "Resources",
	"help-menu-support": "Support",
	more_items: more_items$c,
	notifications: notifications$c,
	"notifications-empty": "No notifications found",
	"notifications-all-read": "Mark all as read",
	"notifications-unread": "Mark as unread",
	"notifications-read": "Mark as read",
	"notifications-delete": "Delete",
	"notifications-mute": "Unsubscribe from {{ topicOrTenant }}",
	"notifications-muted": "Success: You have unsubscribed to {{ topicOrTenant }} notifications.",
	"notifications-unread-only": "Unread only",
	"notifications-settings": "Notification settings",
	"notifications-page": "Notifications page",
	"notifications-clear-all": "Clear all",
	"notifications-end-list": "End of list",
	"notifications-expandCollapse": "Expand/Collapse",
	"notifications-fetch-failure": "Failed to fetch notifications. Please try again later",
	preview: preview$c,
	"unread-notifications-count": "{{ count }} unread notifications",
	"people-picker-default-placeholder": "Search by name or email",
	"people-picker-groups-placeholder": "Search by group name",
	"people-picker-single-mode-placeholder": "Search by name or email",
	"people-picker-single-mode-ad-helper-text": "Search by name, email, or domain\\samAccountName",
	"people-picker-single-mode-aad-helper-text": "Search by name, email, group name, or app name",
	"people-picker-default-helper-text": "Search by name or enter emails separated by commas or semicolons. You can escape special characters using \\.",
	"people-picker-aad-helper-text": "Search by name or enter emails separated by commas or semicolons. You can escape special characters using \\.",
	"people-picker-ad-ldap-helper-text": "Search by name or enter emails or domain\\samAccountNames separated by commas or semicolons. You can escape special characters using \\.",
	"people-picker-invalid-error-helper": "Use a valid email",
	"people-picker-resolve-error-helper": "There were some entries that failed to resolve. Please remove them or try again later",
	"people-picker-resolve-error-tooltip": "Could not resolve entry. Please remove or try again later",
	"people-picker-domain-picker-helper": "Select a domain",
	"people-picker-too-many-entities": "You can only add {{ maxValue }} entities at a time",
	"people-picker-more-info": "More info",
	"autocomplete-no-results": "No results matching \"{{ query }}\"",
	"autocomplete-limit-exceeded": "Limit of {limit} exceeded",
	"autocomplete-search-text": "Type to search...",
	"autocomplete-no-results-people-picker": "No results matching \"{ query }\"",
	"autocomplete-loading": "Loading...",
	"people-picker-add-users": "Names",
	"people-picker-add-groups": "Groups",
	"people-picker-add-apps": "Apps",
	"people-picker-add-names": "Names",
	"tenant-picker-aria-label": "Select tenant. Current: ",
	"people-picker-duplicate-chip": "There are some duplicate entries. Please remove one of the duplicates and try again.",
	"profile-navigation": "Preferences",
	"remove-chip": "Remove \"{{ value }}\"",
	"default-cobranding-logo-alt-text": "Cobranding Logo",
	"canary-tenant": "Canary",
	more_products: more_products$c,
	current_plan_upgrade: current_plan_upgrade$c,
	free_license: free_license$c,
	community_license: community_license$c,
	pro_trial_license: pro_trial_license$c,
	"notification-action-menu-text": "Action on Notification",
	"notification-allaction-menu-text": "More Action on All Notifications",
	"buy-now": "Buy now",
	"contact-sales": "Contact sales",
	"skip-content": "Skip to main content",
	"object-picker-add-entry": "Add \"{{ entry }}\"",
	"start-free-trial-header": "Start your",
	"sixty-days-trial": "60 days trial",
	"with-uipath-cloud": "with UiPath Automation Cloud",
	"take-advantage-capabilities": "Take advantage of our full blown Automation Cloud capabilities.",
	"upgrade-to-enterprise": "Need to scale your automation program with enterprise-grade governance, security, and more?",
	"trial-benefit-one": "Robots to enable remote, on-demand execution",
	"trial-benefit-two": "24x7 support from UiPath",
	"trial-benefit-three": "Uptime guarantee",
	"trial-benefit-four": "Multiple tenants, each hosted in any of our regions",
	"view-pricing": "View pricing",
	"upgrade-trial-role": "Job Title",
	"upgrade-trial-company-name": "Business / Organization name",
	"upgrade-trial-business-email": "Work email",
	"notifications-clear-message": "Notification item has been deleted",
	"session-expiring": "Session expiring",
	"session-expiring-description-inactive-hours": "You have been inactive for {{hours}} hours and {{minutes}} minutes.",
	"session-expiring-description-inactive": "You have been inactive for {{minutes}} minutes.",
	"session-expiring-description-logged-out": "You will be logged out in {{n}} seconds.",
	"extend-session": "Extend session",
	"dropdown-position": "{{index}} of {{total}}",
	unlicensed: unlicensed$c,
	"copy-clipboard": "Copy to Clipboard",
	"people-picker-search-entries": "Found {{count}} search results matching \"{{query}}\"",
	"app-bar-aria-label": "App bar",
	"nav-aria-label": "Left navigation",
	"chat-no-messages": "Type a message below to start the chat",
	"chat-type-a-message": "Type a message",
	"filter-service": "Service:",
	"filter-severity": "Severity:",
	"priority-low": "Low",
	"priority-medium": "Medium",
	"priority-high": "High",
	"priority-critical": "Critical",
	"filter-option-all": "All",
	"severity-info": "Info",
	"severity-success": "Success",
	"severity-warn": "Warn",
	"severity-error": "Error",
	"severity-fatal": "Fatal",
	"breadcrumb-aria-label-default": "Breadcrumb",
	back: back$c,
	"switching-orgs": "Switching organizations",
	"switching-orgs-description": "You are attempting to switch organizations from {{ oldOrg }} to {{ newOrg }}. To continue, please sign out first.",
	"business-email-required": "Business email is required to upgrade to Pro trial",
	"check-inbox-for-invite-link": "Check your inbox for an invite link and accept it to complete the upgrade",
	"invite-business-email-help": "If you are already a member of the organization using that email address, simply log in to your account to proceed.",
	"check-email-for-invite": "Check your email for invite",
	"check-email-for-invite-description": "If you can't find the invite, check your spam folder. After accepting the invite, you can upgrade to Pro trial.",
	"no-minimum-purchase": "No minimum purchase.",
	"view-details-trial-plan": "View the details of everything included in a 60-day trial of the Pro plan",
	"get-more-cloud": "Get more from UiPath Automation Cloud",
	"start-free-trial": "Start free trial",
	trademark: trademark$c,
	"send-invite": "Send invite",
	"support-id": "Support ID",
	basic_auth_user: basic_auth_user$c,
	local_group: local_group$c,
	robot: robot$c,
	directory_group: directory_group$c,
	directory_user: directory_user$c,
	directory_app: directory_app$c,
	"unified-admin-button-label": "Manage access",
	"unified-search-placeholder": "Search marketplace and documentation",
	"unified-search-placeholder-v2": "Search for components, pages & more",
	"unified-search-recent-searches": "Recent searches",
	"unified-search-recent-pages-visited": "Pages visited",
	"unified-search-recent-resources-visited": "Resources visited",
	"unified-search-no-recent-searches": "No recent searches, type 3 or more characters to fetch results",
	"unified-search-no-recent-searches-logographic-locales": "No recent searches, type 1 or more characters to fetch results",
	"unified-search-marketplace": "Marketplace",
	"unified-search-documentation": "Documentation",
	"unified-search-open-product": "Opens in {product}",
	"unified-search-change-search-terms": "Try changing your search terms",
	"unified-search-no-results-found": "No results matching \"{term}\" were found",
	"unified-search-footer": "Not the results you expected? {feedbackLink} or {learnMoreLink}",
	"unified-search-footer-no-feedback": "Not the results you expected? {learnMoreLink}",
	"unified-search-footer-give-feedback": "Not the results you expected? {feedbackLink}",
	"unified-search-documentation-link": "Search \"{query}\" in Documentation",
	"unified-search-downloads": "{count} downloads",
	"unified-search-runs": "{count} runs",
	"unified-search-all": "All",
	"unified-search-see-all": "See all",
	"unified-search-clear-button": "Clear",
	"unified-search-filter": "Filter",
	"unified-search-all-count": "All ({count})",
	"unified-search-components-count": "Components ({count})",
	"unified-search-pages-count": "Pages ({count})",
	"unified-search-tags": "Tags: {tagList}",
	"learn-more": "Learn more",
	"my-workspace": "My Workspace",
	"give-feedback": "Give feedback",
	"ap-autocomplete-input-no-results": "No results matching \"{query}\"",
	"ap-dropdown-placeholder": "Select...",
	"ap-date-picker-placeholder": "Select date",
	"ap-time-picker-placeholder": "Select time",
	"ap-date-picker-selected-day-label": "{day} selected",
	"ap-breadcrumb-overflow-label": "Breadcrumb hidden links",
	"unified-search-Studio": "Studio",
	"unified-search-AiCenter": "AI Center",
	"unified-search-Assistant": "Assistant",
	"unified-search-ProcessMining": "Process Mining",
	"unified-search-BusinessSolutions": "Partner Solutions",
	"unified-search-UiPathApps": "Apps",
	"unified-search-IntegrationServices": "Integration Service",
	"unified-search-StudioX": "StudioX",
	"unified-search-ProfessionalServices": "Professional Services",
	"unified-search-Accelerator": "Accelerators",
	"unified-search-StudioWeb": "Studio Web",
	"unified-search-AutomationOps": "Automation Ops",
	"unified-search-DocumentUnderstanding": "Document Understanding",
	"unified-search-Insights": "Insights",
	"unified-search-Other": "Other",
	"unified-search-Activity": "Activities",
	"unified-search-CustomActivity": "Activities",
	"unified-search-Snippet": "Snippets",
	"unified-search-WorkflowTemplate": "Templates",
	"unified-search-Connector": "Connectors",
	"unified-search-Tool": "Tools",
	"unified-search-MLModel": "ML Models",
	"unified-search-Solution": "Solutions",
	"unified-search-Process": "Ready-to-Go Automations",
	"unified-search-Widget": "Widget",
	"unified-search-BusinessSolution": "Partner Solutions",
	"unified-search-App": "Apps",
	"unified-search-UiPathAppSolution": "App Solutions",
	"unified-search-UiPathAppTemplate": "App Templates",
	"unified-search-IntegrationServiceConnector": "Integration Service Connector",
	"unified-search-StudioXWorkflowTemplate": "Templates",
	"unified-search-ProfessionalService": "Professional Service",
	"unified-search-StudioWebTemplate": "Studio Web Template",
	"unified-search-AutomationOpsPipeline": "Pipelines",
	"unified-search-AutomationOpsPipelineTemplate": "Pipeline Templates",
	"unified-search-ExtractionModel": "Extraction Models",
	"unified-search-marketplace-studio-activity": "Studio activity",
	"unified-search-marketplace-studio-snippet": "Studio snippet",
	"unified-search-marketplace-studio-workflowtemplate": "Studio template",
	"unified-search-marketplace-studio-connector": "Connectors (Legacy)",
	"unified-search-marketplace-studio-tool": "Studio tool",
	"unified-search-marketplace-studio-solution": "Studio solution",
	"unified-search-marketplace-studioweb-studiowebtemplate": "Studio Web template",
	"unified-search-marketplace-studiox-studioxworkflowtemplate": "Studio X template",
	"unified-search-marketplace-assistant-process": "Ready-to-Go Automation",
	"unified-search-marketplace-aicenter-mlmodel": "ML Model",
	"unified-search-marketplace-processmining-app": "Process Mining App template",
	"unified-search-marketplace-uipathapps-uipathappsolution": "App solution",
	"unified-search-marketplace-uipathapps-uipathapptemplate": "App template",
	"unified-search-marketplace-integrationservices-integrationserviceconnector": "Connectors",
	"unified-search-marketplace-accelerator-accelerator": "Accelerator",
	"unified-search-marketplace-businesssolutions-businesssolution": "Partner solution",
	"unified-search-marketplace-professionalservices-professionalservice": "Professional services",
	"unified-search-orchestrator-asset": "Asset",
	"unified-search-orchestrator-process": "Process",
	"unified-search-orchestrator-trigger": "Trigger",
	"unified-search-orchestrator-queue": "Queue",
	"unified-search-orchestrator-bucket": "Bucket",
	"unified-search-orchestrator-actioncatalog": "Action catalog",
	"unified-search-orchestrator-machine": "Machine",
	"unified-search-orchestrator-webhook": "Webhook",
	"unified-search-integrationservice-connection": "Connection",
	"unified-search-integrationservice-trigger": "Trigger",
	"unified-search-dataservice-entity": "Entity",
	"unified-search-dataservice-choiceset": "Choice set",
	"unified-search-apps-app": "Apps",
	"unified-search-loading-search-results": "Loading search results",
	"rich-text-editor-format-bold": "Format bold",
	"rich-text-editor-bold": "Bold",
	"rich-text-editor-format-italic": "Format italics",
	"rich-text-editor-italic": "Italics",
	"rich-text-editor-format-underline": "Format underline",
	"rich-text-editor-underline": "Underline",
	"rich-text-editor-format-strikethrough": "Format strikethrough",
	"rich-text-editor-strikethrough": "Strikethrough",
	"rich-text-editor-format-ordered-list": "Format ordered list",
	"rich-text-editor-ordered-list": "Ordered list",
	"rich-text-editor-format-unordered-list": "Format unordered list",
	"rich-text-editor-unordered-list": "Unordered list",
	"rich-text-editor-insert-link": "Insert link",
	"rich-text-editor-link": "Link",
	"rich-text-editor-format-code": "Format code",
	"rich-text-editor-code": "Code",
	"ap-text-field-placeholder": "Enter a value",
	"notification-message-template": "{{ topic }} in {{ tenantName }}",
	build: build$c,
	discover: discover$c,
	operate: operate$c,
	feedback: feedback$c,
	"give-us-feedback": "Give us feedback",
	cancel: cancel$c,
	confirm: confirm$c,
	favorites: favorites$c,
	"favorites-limit-reached": "Limit reached: You can only add a maximum of 3 items.",
	"favorites-description": "Your favorite products will display here. You can add a maximum of 3 items.",
	"default-toggle": "Toggle switch",
	"default-progress-spinner": "Loading content",
	"default-icon-button": "Icon button",
	"default-radio-group": "Radio group",
	"default-checkbox": "Checkbox",
	"default-stepper-clickable": "with clickable steps",
	"default-stepper-disabled": "with disabled steps",
	"new-navigation": "New navigation",
	"product-launcher-tooltip": "Product launcher",
	"autopilot-tooltip": "Autopilot",
	"notifications-tooltip": "Notifications",
	"search-tooltip": "Search",
	"help-tooltip": "Help",
	"profile-tooltip": "Profile",
	apply: apply$b,
	date: date$b,
	time: time$b,
	"date-range": "Date range:",
	"date-range-label": "Date range",
	"date-time-label": "Date time",
	"date-time-picker-label": "Date time picker",
	"date-range-start": "Start",
	"date-range-end": "End",
	"date-range-presets": "Presets",
	"date-range-picker-all": "All",
	"date-range-picker-last-hour": "Last hour",
	"date-range-picker-today": "Today",
	"date-range-picker-last-day": "Last day",
	"date-range-picker-last-week": "Last week",
	"date-range-picker-last-two-weeks": "Last 2 weeks",
	"date-range-picker-last-month": "Last month",
	"date-range-picker-last-six-months": "Last 6 months",
	"date-range-picker-custom": "Custom",
	"date-range-picker-date-out-of-bounds": "Date cannot be outside of the threshold",
	"date-range-picker-start-greater-than-end": "Start date cannot be greater than end date",
	"date-range-picker-start-time-tooltip": "Start time cannot be greater than or equal to end time",
	"date-range-picker-label": "Date range selector",
	"time-selector": "Time selector",
	"date-range-picker-options": "Date range options",
	"no-options": "No options",
	"type-to-search": "Type to search...",
	"autopilot-chat-header": "Autopilot",
	"autopilot-chat-input-placeholder": "What would you like me to do?",
	"autopilot-chat-footer": "Autopilot can make mistakes. Please double check the responses.",
	"autopilot-chat-new-chat": "New chat",
	"autopilot-chat-close": "Close",
	"autopilot-chat-attach-file": "Attach file(s)",
	"autopilot-chat-send": "Send",
	"autopilot-chat-stop": "Stop",
	"autopilot-chat-remove-file": "Remove",
	"autopilot-chat-prompt-library": "Prompt library",
	"autopilot-chat-dropzone-overlay-title": "Drop your files here to add them to your prompt",
	"autopilot-chat-dropzone-overlay-description": "Supported file types: {{ fileTypes }}",
	"autopilot-chat-dropzone-overlay-error": "Unsupported file(s): {{ fileTypes }}.",
	"autopilot-chat-code-block-language": "Text",
	"autopilot-chat-code-block-copy": "Copy",
	"autopilot-chat-expand": "Expand",
	"autopilot-chat-collapse": "Collapse",
	"autopilot-chat-remove-file-name": "Remove {{ name }}",
	"autopilot-chat-selected-files": "Selected files ({{ count }})",
	"autopilot-chat-files-preview": "{{ files }} & {{ count }} more",
	"autopilot-chat-thinking": "Thinking",
	"autopilot-chat-analyzing": "Analyzing your request",
	"autopilot-chat-thinking-more": "Thinking a little more",
	"autopilot-chat-suggestions": "Suggestions",
	"autopilot-chat-scroll-to-bottom": "Scroll to bottom",
	"autopilot-chat-footnote-label": "Sources"
};

var STORAGE_KEYS;
(function (STORAGE_KEYS) {
    STORAGE_KEYS["PORTAL_ACCOUNT"] = "PORTAL_ACCOUNT";
    STORAGE_KEYS["PORTAL_CURRENT_TENANT"] = "PORTAL_CURRENT_TENANT";
    STORAGE_KEYS["PORTAL_CURRENT_USER_ID"] = "PORTAL_CURRENT_USER_ID";
    STORAGE_KEYS["PORTAL_SHELL_PERSONA"] = "PORTAL_SHELL_PERSONA";
    STORAGE_KEYS["PORTAL_SHELL_PERSONA_LAST_REFETCHED"] = "PORTAL_SHELL_PERSONA_LAST_REFETCHED";
    STORAGE_KEYS["PORTAL_SHELL_ACCOUNT_AND_TENANTS_LAST_REFETCHED"] = "PORTAL_SHELL_ACCOUNT_AND_TENANTS_LAST_REFETCHED";
    STORAGE_KEYS["PORTAL_GRAVATAR"] = "PORTAL_GRAVATAR";
    STORAGE_KEYS["PORTAL_SHELL_FLAGS_LAST_REFETCHED"] = "PORTAL_SHELL_FLAGS_LAST_REFETCHED";
    STORAGE_KEYS["PORTAL_FEATURE_FLAGS"] = "PORTAL_FEATURE_FLAGS";
    STORAGE_KEYS["PORTAL_SHELL_LOCALE_LAST_REFETCHED"] = "PORTAL_SHELL_LOCALE_LAST_REFETCHED";
    STORAGE_KEYS["PORTAL_SHELL_THEME_LAST_REFETCHED"] = "PORTAL_SHELL_THEME_LAST_REFETCHED";
    STORAGE_KEYS["PORTAL_SHELL_SERVICE_ORDER"] = "PORTAL_SHELL_SERVICE_ORDER";
    STORAGE_KEYS["PORTAL_SHELL_ACCESSIBILITY_MODE"] = "PORTAL_SHELL_ACCESSIBILITY_MODE";
    STORAGE_KEYS["PORTAL_SHELL_ACCESSIBILITY_MODE_LAST_REFETCHED"] = "PORTAL_SHELL_ACCESSIBILITY_MODE_LAST_REFETCHED";
    STORAGE_KEYS["PORTAL_SHELL_NOTIFICATION_PUBLISHERS"] = "PORTAL_SHELL_NOTIFICATION_PUBLISHERS";
    STORAGE_KEYS["PORTAL_SHELL_NOTIFICATION_PUBLISHERS_LAST_REFETCHED"] = "PORTAL_SHELL_NOTIFICATION_PUBLISHERS_LAST_REFETCHED";
    STORAGE_KEYS["PORTAL_SHELL_RECENT_SEARCHES"] = "PORTAL_SHELL_RECENT_SEARCHES";
    STORAGE_KEYS["PORTAL_SHELL_RECENT_ITEMS"] = "PORTAL_SHELL_RECENT_ITEMS";
    STORAGE_KEYS["PORTAL_SHELL_ALERT_DURATION"] = "PORTAL_SHELL_ALERT_DURATION";
    STORAGE_KEYS["PORTAL_SHELL_ALERT_DURATION_LAST_REFETCHED"] = "PORTAL_SHELL_ALERT_DURATION_LAST_REFETCHED";
    STORAGE_KEYS["PORTAL_SHELL_FAVORITES_DATA"] = "PORTAL_SHELL_FAVORITES_DATA";
    STORAGE_KEYS["PORTAL_SHELL_FAVORITES_DATA_LAST_REFETCHED"] = "PORTAL_SHELL_FAVORITES_DATA_LAST_REFETCHED";
    STORAGE_KEYS["PORTAL_SHELL_ENTITLEMENTS"] = "PORTAL_SHELL_ENTITLEMENTS";
    STORAGE_KEYS["PORTAL_SHELL_ENTITLEMENTS_LAST_REFETCHED"] = "PORTAL_SHELL_ENTITLEMENTS_LAST_REFETCHED";
})(STORAGE_KEYS || (STORAGE_KEYS = {}));
var Scope;
(function (Scope) {
    Scope["Global"] = "global";
    Scope["Tenant"] = "tenant";
})(Scope || (Scope = {}));
const SHARED_PENDO_API_KEY = '28a6b07f-b80b-474b-7c38-73dada1ee0a4';
const PendoApiKey = {
    [ServiceType.processMining]: 'd15cf892-cd1e-4e14-508a-b07b9fa7bff4',
    [ServiceType.apps]: '2b1fd049-7787-4b7f-5b19-ccffabc100fb',
    [ServiceType.taskMining]: '6d4bc7c8-67a9-45bd-433c-946db93ded15',
};
const LocalizationHeaderName = 'X-UIPATH-Localization';
const TenantHeaderKey = 'X-UiPath-Internal-TenantId';
var BuiltInGroups;
(function (BuiltInGroups) {
    BuiltInGroups["Admin"] = "35551807-06b1-4cda-90a1-2fb84851eee7";
    BuiltInGroups["Everyone"] = "ce684f6f-5af3-4e43-8516-1adad6e98fc9";
    BuiltInGroups["AutomationDevelopers"] = "4d161738-7204-4794-b839-8f7fed28366c";
    BuiltInGroups["AutomationUsers"] = "cdc34b5b-77d2-4ae1-9744-209d21ce557d";
})(BuiltInGroups || (BuiltInGroups = {}));
var AccountType;
(function (AccountType) {
    AccountType["Enterprise"] = "ENTERPRISE";
    AccountType["Community"] = "COMMUNITY";
    AccountType["Trial"] = "TRIAL";
    AccountType["Free"] = "FREEKIT";
    AccountType["Pro"] = "PRO";
    AccountType["ProTrial"] = "PRO-TRIAL";
})(AccountType || (AccountType = {}));
var SeverityLevel$1;
(function (SeverityLevel) {
    SeverityLevel[SeverityLevel["Verbose"] = 0] = "Verbose";
    SeverityLevel[SeverityLevel["Information"] = 1] = "Information";
    SeverityLevel[SeverityLevel["Warning"] = 2] = "Warning";
    SeverityLevel[SeverityLevel["Error"] = 3] = "Error";
    SeverityLevel[SeverityLevel["Critical"] = 4] = "Critical";
})(SeverityLevel$1 || (SeverityLevel$1 = {}));
const severityLevelToLogLevel = {
    [SeverityLevel$1.Verbose]: 'debug',
    [SeverityLevel$1.Information]: 'info',
    [SeverityLevel$1.Warning]: 'warn',
    [SeverityLevel$1.Error]: 'error',
    [SeverityLevel$1.Critical]: 'error',
};
var LanguageCodes;
(function (LanguageCodes) {
    LanguageCodes["en"] = "en";
    LanguageCodes["zhCn"] = "zh-cn";
    LanguageCodes["zhTw"] = "zh-tw";
    LanguageCodes["es"] = "es";
    LanguageCodes["esMx"] = "es-mx";
    LanguageCodes["pt"] = "pt";
    LanguageCodes["ptBr"] = "pt-br";
    LanguageCodes["ja"] = "ja";
    LanguageCodes["de"] = "de";
    LanguageCodes["fr"] = "fr";
    LanguageCodes["ko"] = "ko";
    LanguageCodes["ru"] = "ru";
    LanguageCodes["tr"] = "tr";
})(LanguageCodes || (LanguageCodes = {}));
var AuthSettings;
(function (AuthSettings) {
    AuthSettings["IdleTimeoutDuration"] = "IdleTimeoutDuration";
    AuthSettings["AllowConcurrentBrowserSessions"] = "AllowConcurrentBrowserSessions";
})(AuthSettings || (AuthSettings = {}));
const AlertDurationDefault = AlertDurationEnum.s5;

const CIS_PKCE_CLIENT_ID$8 = "73ba6224-d591-4a4f-b3ab-508e646f2932";
const APPINSIGHTS_CONNECTION_STRING$2 = "InstrumentationKey=6ec04735-862b-feb5-9a2a-2101797c659c;EndpointSuffix=applicationinsights.us;IngestionEndpoint=https://usgovvirginia-0.in.applicationinsights.azure.us";
const IDLE_TIMEOUT_INTERVAL$4 = 15;
const Notification_Hide_Services$3 = [
	"automationhub",
	"automationstore"
];
const FeatureFlags$6 = {
	"enable-portal-shell-self-auth-people-picker": true,
	"enable-loc-keys-language": true,
	"apollo-enableNotificationFilters": true
};
const agov = {
	CIS_PKCE_CLIENT_ID: CIS_PKCE_CLIENT_ID$8,
	APPINSIGHTS_CONNECTION_STRING: APPINSIGHTS_CONNECTION_STRING$2,
	IDLE_TIMEOUT_INTERVAL: IDLE_TIMEOUT_INTERVAL$4,
	Notification_Hide_Services: Notification_Hide_Services$3,
	FeatureFlags: FeatureFlags$6
};

const CIS_PKCE_CLIENT_ID$7 = "73ba6224-d591-4a4f-b3ab-508e646f2932";
const APPINSIGHTS_KEY$2 = "5ce8b48b-e1f5-4fd0-a976-1c2691fef8fc";
const alp = {
	CIS_PKCE_CLIENT_ID: CIS_PKCE_CLIENT_ID$7,
	APPINSIGHTS_KEY: APPINSIGHTS_KEY$2
};

const CIS_PKCE_CLIENT_ID$6 = "73ba6224-d591-4a4f-b3ab-508e646f2932";
const Notification_Hide_Services$2 = [
	"orchestrator",
	"automationhub",
	"automationstore"
];
const FeatureFlags$5 = {
	"enable-portal-shell-self-auth-people-picker": true,
	enableNotificationSettings: true,
	disableNotificationPreview: true,
	enableNotificationsPopoutPage: true,
	"apollo-enableNotificationFilters": true,
	"apollo-accountAndTenantsRefetchThrottleMs": 0,
	"apollo-enableTenantTrimming": true,
	"apollo-enableLeftRailExperiment": true
};
const k8s = {
	CIS_PKCE_CLIENT_ID: CIS_PKCE_CLIENT_ID$6,
	Notification_Hide_Services: Notification_Hide_Services$2,
	FeatureFlags: FeatureFlags$5
};

const DEFAULT_BASE_URL$1 = "https://alpha.uipath.com";
const CIS_PKCE_CLIENT_ID$5 = "73ba6224-d591-4a4f-b3ab-508e646f2932";
const CIS_HOST_PREFIX$1 = "https://alpha.uipath.com/identity_";
const PORTAL_ORIGIN$1 = "https://alpha.uipath.com";
const IDLE_TIMEOUT_INTERVAL$3 = 150;
const FeatureFlags$4 = {
	"enable-portal-shell-localstorage-overrides": true,
	"enable-loc-keys-language": true,
	"enable-portal-shell-self-auth-people-picker": true,
	"apollo-enablePeoplePickerIdentityBaseUrlOverride": true
};
const local = {
	DEFAULT_BASE_URL: DEFAULT_BASE_URL$1,
	CIS_PKCE_CLIENT_ID: CIS_PKCE_CLIENT_ID$5,
	CIS_HOST_PREFIX: CIS_HOST_PREFIX$1,
	PORTAL_ORIGIN: PORTAL_ORIGIN$1,
	IDLE_TIMEOUT_INTERVAL: IDLE_TIMEOUT_INTERVAL$3,
	FeatureFlags: FeatureFlags$4
};

const DEFAULT_BASE_URL = "https://as.loc";
const CIS_PKCE_CLIENT_ID$4 = "73ba6224-d591-4a4f-b3ab-508e646f2932";
const CIS_HOST_PREFIX = "https://as.loc/identity_";
const PORTAL_ORIGIN = "https://as.loc";
const IDLE_TIMEOUT_INTERVAL$2 = 150;
const FeatureFlags$3 = {
	"enable-portal-shell-localstorage-overrides": true,
	"enable-loc-keys-language": true,
	"enable-portal-shell-self-auth-people-picker": true,
	"apollo-enablePeoplePickerIdentityBaseUrlOverride": true
};
const localK8s = {
	DEFAULT_BASE_URL: DEFAULT_BASE_URL,
	CIS_PKCE_CLIENT_ID: CIS_PKCE_CLIENT_ID$4,
	CIS_HOST_PREFIX: CIS_HOST_PREFIX,
	PORTAL_ORIGIN: PORTAL_ORIGIN,
	IDLE_TIMEOUT_INTERVAL: IDLE_TIMEOUT_INTERVAL$2,
	FeatureFlags: FeatureFlags$3
};

const CIS_PKCE_CLIENT_ID$3 = "73ba6224-d591-4a4f-b3ab-508e646f2932";
const APPINSIGHTS_CONNECTION_STRING$1 = "InstrumentationKey=d8c3654d-d867-fd6e-a017-a8808a5a05e5;EndpointSuffix=applicationinsights.us;IngestionEndpoint=https://usgovvirginia-0.in.applicationinsights.azure.us";
const IDLE_TIMEOUT_INTERVAL$1 = 15;
const Notification_Hide_Services$1 = [
	"automationhub",
	"automationstore"
];
const FeatureFlags$2 = {
	"enable-portal-shell-self-auth-people-picker": true,
	"apollo-enableNotificationFilters": true
};
const pgov = {
	CIS_PKCE_CLIENT_ID: CIS_PKCE_CLIENT_ID$3,
	APPINSIGHTS_CONNECTION_STRING: APPINSIGHTS_CONNECTION_STRING$1,
	IDLE_TIMEOUT_INTERVAL: IDLE_TIMEOUT_INTERVAL$1,
	Notification_Hide_Services: Notification_Hide_Services$1,
	FeatureFlags: FeatureFlags$2
};

const APPINSIGHTS_KEY$1 = "1aa31954-fba9-4d90-91be-c4a98e158504";
const CIS_PKCE_CLIENT_ID$2 = "73ba6224-d591-4a4f-b3ab-508e646f2932";
const prd = {
	APPINSIGHTS_KEY: APPINSIGHTS_KEY$1,
	CIS_PKCE_CLIENT_ID: CIS_PKCE_CLIENT_ID$2
};

const CIS_PKCE_CLIENT_ID$1 = "73ba6224-d591-4a4f-b3ab-508e646f2932";
const APPINSIGHTS_CONNECTION_STRING = "InstrumentationKey=d20a0308-3dce-f505-9755-c53916a8ad84;EndpointSuffix=applicationinsights.us;IngestionEndpoint=https://usgovvirginia-0.in.applicationinsights.azure.us";
const IDLE_TIMEOUT_INTERVAL = 15;
const Notification_Hide_Services = [
	"automationhub",
	"automationstore"
];
const FeatureFlags$1 = {
	"enable-portal-shell-self-auth-people-picker": true,
	"apollo-enableNotificationFilters": true,
	enableNotificationSettings: false
};
const sgov = {
	CIS_PKCE_CLIENT_ID: CIS_PKCE_CLIENT_ID$1,
	APPINSIGHTS_CONNECTION_STRING: APPINSIGHTS_CONNECTION_STRING,
	IDLE_TIMEOUT_INTERVAL: IDLE_TIMEOUT_INTERVAL,
	Notification_Hide_Services: Notification_Hide_Services,
	FeatureFlags: FeatureFlags$1
};

const APPINSIGHTS_KEY = "0a5ebfe7-31dd-4307-a4b9-35eb7a7d2647";
const CIS_PKCE_CLIENT_ID = "73ba6224-d591-4a4f-b3ab-508e646f2932";
const stg = {
	APPINSIGHTS_KEY: APPINSIGHTS_KEY,
	CIS_PKCE_CLIENT_ID: CIS_PKCE_CLIENT_ID
};

const envConfigs = {
    local,
    'local-k8s': localK8s,
    alp,
    stg,
    prd,
    pgov,
    agov,
    sgov,
    k8s,
};

const appendToMap = (map, propName, value) => {
    const items = map.get(propName);
    if (!items) {
        map.set(propName, [value]);
    }
    else if (!items.includes(value)) {
        items.push(value);
    }
};
const debounce = (fn, ms) => {
    let timeoutId;
    return (...args) => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            timeoutId = 0;
            fn(...args);
        }, ms);
    };
};

/**
 * Check if a possible element isConnected.
 * The property might not be there, so we check for it.
 *
 * We want it to return true if isConnected is not a property,
 * otherwise we would remove these elements and would not update.
 *
 * Better leak in Edge than to be useless.
 */
const isConnected = (maybeElement) => !('isConnected' in maybeElement) || maybeElement.isConnected;
const cleanupElements = debounce((map) => {
    for (let key of map.keys()) {
        map.set(key, map.get(key).filter(isConnected));
    }
}, 2000);
const stencilSubscription = () => {
    if (typeof getRenderingRef !== 'function') {
        // If we are not in a stencil project, we do nothing.
        // This function is not really exported by @stencil/core.
        return {};
    }
    const elmsToUpdate = new Map();
    return {
        dispose: () => elmsToUpdate.clear(),
        get: (propName) => {
            const elm = getRenderingRef();
            if (elm) {
                appendToMap(elmsToUpdate, propName, elm);
            }
        },
        set: (propName) => {
            const elements = elmsToUpdate.get(propName);
            if (elements) {
                elmsToUpdate.set(propName, elements.filter(forceUpdate));
            }
            cleanupElements(elmsToUpdate);
        },
        reset: () => {
            elmsToUpdate.forEach((elms) => elms.forEach(forceUpdate));
            cleanupElements(elmsToUpdate);
        },
    };
};

const unwrap = (val) => (typeof val === 'function' ? val() : val);
const createObservableMap = (defaultState, shouldUpdate = (a, b) => a !== b) => {
    const unwrappedState = unwrap(defaultState);
    let states = new Map(Object.entries(unwrappedState !== null && unwrappedState !== void 0 ? unwrappedState : {}));
    const handlers = {
        dispose: [],
        get: [],
        set: [],
        reset: [],
    };
    const reset = () => {
        var _a;
        // When resetting the state, the default state may be a function - unwrap it to invoke it.
        // otherwise, the state won't be properly reset
        states = new Map(Object.entries((_a = unwrap(defaultState)) !== null && _a !== void 0 ? _a : {}));
        handlers.reset.forEach((cb) => cb());
    };
    const dispose = () => {
        // Call first dispose as resetting the state would
        // cause less updates ;)
        handlers.dispose.forEach((cb) => cb());
        reset();
    };
    const get = (propName) => {
        handlers.get.forEach((cb) => cb(propName));
        return states.get(propName);
    };
    const set = (propName, value) => {
        const oldValue = states.get(propName);
        if (shouldUpdate(value, oldValue, propName)) {
            states.set(propName, value);
            handlers.set.forEach((cb) => cb(propName, value, oldValue));
        }
    };
    const state = (typeof Proxy === 'undefined'
        ? {}
        : new Proxy(unwrappedState, {
            get(_, propName) {
                return get(propName);
            },
            ownKeys(_) {
                return Array.from(states.keys());
            },
            getOwnPropertyDescriptor() {
                return {
                    enumerable: true,
                    configurable: true,
                };
            },
            has(_, propName) {
                return states.has(propName);
            },
            set(_, propName, value) {
                set(propName, value);
                return true;
            },
        }));
    const on = (eventName, callback) => {
        handlers[eventName].push(callback);
        return () => {
            removeFromArray(handlers[eventName], callback);
        };
    };
    const onChange = (propName, cb) => {
        const unSet = on('set', (key, newValue) => {
            if (key === propName) {
                cb(newValue);
            }
        });
        // We need to unwrap the defaultState because it might be a function.
        // Otherwise we might not be sending the right reset value.
        const unReset = on('reset', () => cb(unwrap(defaultState)[propName]));
        return () => {
            unSet();
            unReset();
        };
    };
    const use = (...subscriptions) => {
        const unsubs = subscriptions.reduce((unsubs, subscription) => {
            if (subscription.set) {
                unsubs.push(on('set', subscription.set));
            }
            if (subscription.get) {
                unsubs.push(on('get', subscription.get));
            }
            if (subscription.reset) {
                unsubs.push(on('reset', subscription.reset));
            }
            if (subscription.dispose) {
                unsubs.push(on('dispose', subscription.dispose));
            }
            return unsubs;
        }, []);
        return () => unsubs.forEach((unsub) => unsub());
    };
    const forceUpdate = (key) => {
        const oldValue = states.get(key);
        handlers.set.forEach((cb) => cb(key, oldValue, oldValue));
    };
    return {
        state,
        get,
        set,
        on,
        onChange,
        use,
        dispose,
        reset,
        forceUpdate,
    };
};
const removeFromArray = (array, item) => {
    const index = array.indexOf(item);
    if (index >= 0) {
        array[index] = array[array.length - 1];
        array.length--;
    }
};

const createStore = (defaultState, shouldUpdate) => {
    const map = createObservableMap(defaultState, shouldUpdate);
    map.use(stencilSubscription());
    return map;
};

/*! https://github.com/nevware21/ts-utils v0.11.2 */
/*
 * Copyright (c) NevWare21 and contributors. All rights reserved.
 * Licensed under the MIT license.
 */
/*#__NO_SIDE_EFFECTS__*/
function _pureAssign(func1, func2) {
    return func1 || func2;
}
/*#__NO_SIDE_EFFECTS__*/
function _pureRef(value, name) {
    return value[name];
}

var UNDEF_VALUE$2 = undefined;
var NULL_VALUE$2 = null;
var EMPTY$2 = "";
var FUNCTION$2 = "function";
var OBJECT$2 = "object";
var PROTOTYPE$2 = "prototype";
var __PROTO__ = "__proto__";
var UNDEFINED$2 = "undefined";
var CONSTRUCTOR = "constructor";
var SYMBOL$1 = "Symbol";
var POLYFILL_TAG$1 = "_polyfill";
var LENGTH$1 = "length";
var NAME = "name";
var CALL = "call";
var TO_STRING = "toString";
var ObjClass$3 = ( /*#__PURE__*/_pureAssign(Object));
var ObjProto$3 = ( /*#__PURE__*/_pureRef(ObjClass$3, PROTOTYPE$2));
var StrCls$1 = ( /*#__PURE__*/_pureAssign(String));
var StrProto = ( /*#__PURE__*/_pureRef(StrCls$1, PROTOTYPE$2));
var MathCls = ( /*#__PURE__*/_pureAssign(Math));
var ArrCls$1 = ( /*#__PURE__*/_pureAssign(Array));
var ArrProto$1 = ( /*#__PURE__*/_pureRef(ArrCls$1, PROTOTYPE$2));
var ArrSlice = ( /*#__PURE__*/_pureRef(ArrProto$1, "slice"));

function safe(func, argArray) {
    try {
        return {
            v: func.apply(this, argArray)
        };
    }
    catch (e) {
        return { e: e };
    }
}

/*#__NO_SIDE_EFFECTS__*/
function safeGet$2(cb, defValue) {
    var result = safe(cb);
    return result.e ? defValue : result.v;
}

var _primitiveTypes;
/*#__NO_SIDE_EFFECTS__*/
function _createIs$2(theType) {
    return function (value) {
        return typeof value === theType;
    };
}
/*#__NO_SIDE_EFFECTS__*/
function _createObjIs$2(theName) {
    var theType = "[object " + theName + "]";
    return function (value) {
        return !!(value && objToString$2(value) === theType);
    };
}
/*#__NO_SIDE_EFFECTS__*/
function objToString$2(value) {
    return ObjProto$3[TO_STRING].call(value);
}
/*#__NO_SIDE_EFFECTS__*/
function isUndefined$1(value) {
    return typeof value === UNDEFINED$2 || value === UNDEFINED$2;
}
/*#__NO_SIDE_EFFECTS__*/
function isNullOrUndefined$1(value) {
    return value === NULL_VALUE$2 || isUndefined$1(value);
}
/*#__NO_SIDE_EFFECTS__*/
function isStrictNullOrUndefined(value) {
    return value === NULL_VALUE$2 || !isDefined$1(value);
}
/*#__NO_SIDE_EFFECTS__*/
function isDefined$1(arg) {
    return !!arg || arg !== UNDEF_VALUE$2;
}
/*#__NO_SIDE_EFFECTS__*/
function isPrimitiveType(theType) {
    !_primitiveTypes && (_primitiveTypes = ["string", "number", "boolean", UNDEFINED$2, "symbol", "bigint"]);
    return theType !== OBJECT$2 && _primitiveTypes.indexOf(theType) !== -1;
}
var isString$2 = ( /*#__PURE__*/_createIs$2("string"));
var isFunction$2 = ( /*#__PURE__*/_createIs$2(FUNCTION$2));
/*#__NO_SIDE_EFFECTS__*/
function isObject$2(value) {
    if (!value && isNullOrUndefined$1(value)) {
        return false;
    }
    return !!value && typeof value === OBJECT$2;
}
var isArray$1 = ( /* #__PURE__*/_pureRef(ArrCls$1, "isArray"));
var isDate = ( /*#__PURE__*/_createObjIs$2("Date"));
var isNumber$2 = ( /*#__PURE__*/_createIs$2("number"));
var isBoolean = ( /*#__PURE__*/_createIs$2("boolean"));
var isError$2 = ( /*#__PURE__*/_createObjIs$2("Error"));
/*#__NO_SIDE_EFFECTS__*/
function isTruthy(value) {
    return !(!value || safeGet$2(function () { return !(value && (0 + value)); }, !value));
}

var objGetOwnPropertyDescriptor$1 = ( /* #__PURE__ */_pureRef(ObjClass$3, "getOwnPropertyDescriptor"));

/*#__NO_SIDE_EFFECTS__*/
function objHasOwnProperty$1(obj, prop) {
    return !!obj && ObjProto$3.hasOwnProperty[CALL](obj, prop);
}

var objHasOwn$1 = ( /*#__PURE__*/_pureAssign(( /* #__PURE__ */_pureRef(ObjClass$3, "hasOwn")), polyObjHasOwn$1));
/*#__NO_SIDE_EFFECTS__*/
function polyObjHasOwn$1(obj, prop) {
    return objHasOwnProperty$1(obj, prop) || !!objGetOwnPropertyDescriptor$1(obj, prop);
}

function objForEachKey$1(theObject, callbackfn, thisArg) {
    if (theObject && isObject$2(theObject)) {
        for (var prop in theObject) {
            if (objHasOwn$1(theObject, prop)) {
                if (callbackfn[CALL](thisArg || theObject, prop, theObject[prop]) === -1) {
                    break;
                }
            }
        }
    }
}

/*#__NO_SIDE_EFFECTS__*/
function _createKeyValueMap$1(values, keyType, valueType, completeFn) {
    var theMap = {};
    objForEachKey$1(values, function (key, value) {
        theMap[key] = keyType ? value : key;
        theMap[value] = valueType ? value : key;
    });
    return completeFn(theMap);
}

var asString$1 = ( /* #__PURE__ */_pureAssign(StrCls$1));

var ERROR_TYPE = "[object Error]";
/*#__NO_SIDE_EFFECTS__*/
function dumpObj$2(object, format) {
    var propertyValueDump = EMPTY$2;
    var objType = ObjProto$3[TO_STRING][CALL](object);
    if (objType === ERROR_TYPE) {
        object = { stack: asString$1(object.stack), message: asString$1(object.message), name: asString$1(object.name) };
    }
    try {
        propertyValueDump = JSON.stringify(object, NULL_VALUE$2, format ? ((typeof format === "number") ? format : 4) : UNDEF_VALUE$2);
        propertyValueDump = (propertyValueDump && propertyValueDump.replace(/"(\w+)"\s*:\s{0,1}/g, "$1: ")) || asString$1(object);
    }
    catch (e) {
        propertyValueDump = " - " + dumpObj$2(e, format);
    }
    return objType + ": " + propertyValueDump;
}

function throwError(message) {
    throw new Error(message);
}
function throwTypeError$2(message) {
    throw new TypeError(message);
}

var _objFreeze$1 = ( /* #__PURE__ */_pureRef(ObjClass$3, "freeze"));
function _doNothing$1(value) {
    return value;
}
/*#__NO_SIDE_EFFECTS__*/
function _getProto(value) {
    return value[__PROTO__] || NULL_VALUE$2;
}
var objKeys = ( /*#__PURE__*/_pureRef(ObjClass$3, "keys"));
function objDeepFreeze$1(value) {
    if (_objFreeze$1) {
        objForEachKey$1(value, function (key, value) {
            if (isArray$1(value) || isObject$2(value)) {
                _objFreeze$1(value);
            }
        });
    }
    return objFreeze$1(value);
}
var objFreeze$1 = ( /* #__PURE__*/_pureAssign(_objFreeze$1, _doNothing$1));
var objGetPrototypeOf = ( /* #__PURE__*/_pureAssign(( /* #__PURE__*/_pureRef(ObjClass$3, "getPrototypeOf")), _getProto));

/*#__NO_SIDE_EFFECTS__*/
function createEnum(values) {
    return _createKeyValueMap$1(values, 1 , 0 , objDeepFreeze$1);
}
/*#__NO_SIDE_EFFECTS__*/
function createEnumKeyMap$1(values) {
    return _createKeyValueMap$1(values, 0 , 0 , objDeepFreeze$1);
}
/*#__NO_SIDE_EFFECTS__*/
function createSimpleMap(values) {
    var mapClass = {};
    objForEachKey$1(values, function (key, value) {
        mapClass[key] = value[1];
        mapClass[value[0]] = value[1];
    });
    return objDeepFreeze$1(mapClass);
}
/*#__NO_SIDE_EFFECTS__*/
function createTypeMap(values) {
    return createSimpleMap(values);
}

var _wellKnownSymbolMap$1 = /*#__PURE__*/ createEnumKeyMap$1({
    asyncIterator: 0 ,
    hasInstance: 1 ,
    isConcatSpreadable: 2 ,
    iterator: 3 ,
    match: 4 ,
    matchAll: 5 ,
    replace: 6 ,
    search: 7 ,
    species: 8 ,
    split: 9 ,
    toPrimitive: 10 ,
    toStringTag: 11 ,
    unscopables: 12
});

var GLOBAL_CONFIG_KEY$2 = "__tsUtils$gblCfg";
var _globalCfg$2;
/*#__NO_SIDE_EFFECTS__*/
function _getGlobalValue$2() {
    var result;
    if (typeof globalThis !== UNDEFINED$2) {
        result = globalThis;
    }
    if (!result && typeof self !== UNDEFINED$2) {
        result = self;
    }
    if (!result && typeof window !== UNDEFINED$2) {
        result = window;
    }
    if (!result && typeof global$1 !== UNDEFINED$2) {
        result = global$1;
    }
    return result;
}
/*#__NO_SIDE_EFFECTS__*/
function _getGlobalConfig$2() {
    if (!_globalCfg$2) {
        var gbl = safe(_getGlobalValue$2).v || {};
        _globalCfg$2 = gbl[GLOBAL_CONFIG_KEY$2] = gbl[GLOBAL_CONFIG_KEY$2] || {};
    }
    return _globalCfg$2;
}

var _unwrapFunction$1 = ( _unwrapFunctionWithPoly);
/*#__NO_SIDE_EFFECTS__*/
function _unwrapFunctionWithPoly(funcName, clsProto, polyFunc) {
    var clsFn = clsProto && clsProto[funcName];
    return function (thisArg) {
        var theFunc = (thisArg && thisArg[funcName]) || clsFn;
        if (theFunc || polyFunc) {
            var theArgs = arguments;
            return (theFunc || polyFunc).apply(thisArg, theFunc ? ArrSlice[CALL](theArgs, 1) : theArgs);
        }
        throwTypeError$2("\"" + asString$1(funcName) + "\" not defined for " + dumpObj$2(thisArg));
    };
}
/*#__NO_SIDE_EFFECTS__*/
function _unwrapProp(propName) {
    return function (thisArg) {
        return thisArg[propName];
    };
}
var mathMax = ( /*#__PURE__*/_pureRef(MathCls, "max"));

var strSlice = ( /*#__PURE__*/_unwrapFunction$1("slice", StrProto));

var strSubstring = ( /*#__PURE__*/_unwrapFunction$1("substring", StrProto));
var strSubstr = ( /*#__PURE__*/_unwrapFunctionWithPoly("substr", StrProto, polyStrSubstr));
/*#__NO_SIDE_EFFECTS__*/
function polyStrSubstr(value, start, length) {
    if (isNullOrUndefined$1(value)) {
        throwTypeError$2("Invalid " + dumpObj$2(value));
    }
    if (length < 0) {
        return EMPTY$2;
    }
    start = start || 0;
    if (start < 0) {
        start = mathMax(start + value[LENGTH$1], 0);
    }
    if (isUndefined$1(length)) {
        return strSlice(value, start);
    }
    return strSlice(value, start, start + length);
}
/*#__NO_SIDE_EFFECTS__*/
function strLeft(value, count) {
    return strSubstring(value, 0, count);
}

var UNIQUE_REGISTRY_ID = "_urid";
var _polySymbols;
/*#__NO_SIDE_EFFECTS__*/
function _globalSymbolRegistry() {
    if (!_polySymbols) {
        var gblCfg = _getGlobalConfig$2();
        _polySymbols = gblCfg.gblSym = gblCfg.gblSym || { k: {}, s: {} };
    }
    return _polySymbols;
}
var _wellKnownSymbolCache$1;
/*#__NO_SIDE_EFFECTS__*/
function polyNewSymbol$1(description) {
    var theSymbol = {
        description: asString$1(description),
        toString: function () { return SYMBOL$1 + "(" + description + ")"; }
    };
    theSymbol[POLYFILL_TAG$1] = true;
    return theSymbol;
}
/*#__NO_SIDE_EFFECTS__*/
function polySymbolFor(key) {
    var registry = _globalSymbolRegistry();
    if (!objHasOwn$1(registry.k, key)) {
        var newSymbol_1 = polyNewSymbol$1(key);
        var regId_1 = objKeys(registry.s).length;
        newSymbol_1[UNIQUE_REGISTRY_ID] = function () { return regId_1 + "_" + newSymbol_1[TO_STRING](); };
        registry.k[key] = newSymbol_1;
        registry.s[newSymbol_1[UNIQUE_REGISTRY_ID]()] = asString$1(key);
    }
    return registry.k[key];
}
/*#__NO_SIDE_EFFECTS__*/
function polyGetKnownSymbol$1(name) {
    !_wellKnownSymbolCache$1 && (_wellKnownSymbolCache$1 = {});
    var result;
    var knownName = _wellKnownSymbolMap$1[name];
    if (knownName) {
        result = _wellKnownSymbolCache$1[knownName] = _wellKnownSymbolCache$1[knownName] || polyNewSymbol$1(SYMBOL$1 + "." + knownName);
    }
    return result;
}

var propMap$1 = {
    e: "enumerable",
    c: "configurable",
    v: "value",
    w: "writable",
    g: "get",
    s: "set"
};
/*#__NO_SIDE_EFFECTS__*/
function _createProp$1(value) {
    var prop = {};
    prop[propMap$1["c"]] = true;
    prop[propMap$1["e"]] = true;
    if (value.l) {
        prop.get = function () { return value.l.v; };
        var desc = objGetOwnPropertyDescriptor$1(value.l, "v");
        if (desc && desc.set) {
            prop.set = function (newValue) {
                value.l.v = newValue;
            };
        }
    }
    objForEachKey$1(value, function (key, value) {
        prop[propMap$1[key]] = isUndefined$1(value) ? prop[propMap$1[key]] : value;
    });
    return prop;
}
var objDefineProp$2 = ( /*#__PURE__*/_pureRef(ObjClass$3, "defineProperty"));
function objDefine$1(target, key, propDesc) {
    return objDefineProp$2(target, key, _createProp$1(propDesc));
}

var _globalLazyTestHooks$2;
function _initTestHooks() {
    _globalLazyTestHooks$2 = _getGlobalConfig$2();
}
/*#__NO_SIDE_EFFECTS__*/
function getLazy$2(cb) {
    var lazyValue = {};
    !_globalLazyTestHooks$2 && _initTestHooks();
    lazyValue.b = _globalLazyTestHooks$2.lzy;
    objDefineProp$2(lazyValue, "v", {
        configurable: true,
        get: function () {
            var result = cb();
            if (!_globalLazyTestHooks$2.lzy) {
                objDefineProp$2(lazyValue, "v", {
                    value: result
                });
            }
            lazyValue.b = _globalLazyTestHooks$2.lzy;
            return result;
        }
    });
    return lazyValue;
}

/*#__NO_SIDE_EFFECTS__*/
function createCachedValue(value) {
    return objDefineProp$2({
        toJSON: function () { return value; }
    }, "v", { value: value });
}

var WINDOW$1 = "window";
var _cachedGlobal$2;
function _getGlobalInstFn(getFn, theArgs) {
    var cachedValue;
    return function () {
        !_globalLazyTestHooks$2 && _initTestHooks();
        (!cachedValue || _globalLazyTestHooks$2.lzy) && (cachedValue = createCachedValue(safe(getFn, theArgs).v));
        return cachedValue.v;
    };
}
/*#__NO_SIDE_EFFECTS__*/
function getGlobal$2(useCached) {
    !_globalLazyTestHooks$2 && _initTestHooks();
    (!_cachedGlobal$2 || useCached === false || _globalLazyTestHooks$2.lzy) && (_cachedGlobal$2 = createCachedValue(safe(_getGlobalValue$2).v || NULL_VALUE$2));
    return _cachedGlobal$2.v;
}
/*#__NO_SIDE_EFFECTS__*/
function getInst$1(name, useCached) {
    var gbl = (!_cachedGlobal$2 || useCached === false) ? getGlobal$2(useCached) : _cachedGlobal$2.v;
    if (gbl && gbl[name]) {
        return gbl[name];
    }
    if (name === WINDOW$1) {
        return getWindow$1();
    }
    return NULL_VALUE$2;
}
/*#__NO_SIDE_EFFECTS__*/
function hasDocument() {
    return !!( /*#__PURE__*/getDocument$1());
}
var getDocument$1 = ( /*#__PURE__*/_getGlobalInstFn(getInst$1, ["document"]));
/*#__NO_SIDE_EFFECTS__*/
function hasWindow() {
    return !!( /*#__PURE__*/getWindow$1());
}
var getWindow$1 = ( /*#__PURE__*/_getGlobalInstFn(getInst$1, [WINDOW$1]));
/*#__NO_SIDE_EFFECTS__*/
function hasNavigator() {
    return !!( /*#__PURE__*/getNavigator());
}
var getNavigator = ( /*#__PURE__*/_getGlobalInstFn(getInst$1, ["navigator"]));
/*#__NO_SIDE_EFFECTS__*/
function hasHistory() {
    return !!( /*#__PURE__*/getHistory());
}
var getHistory = ( /*#__PURE__*/_getGlobalInstFn(getInst$1, ["history"]));
var isWebWorker = ( /*#__PURE__*/_getGlobalInstFn(function () {
    return !!( safe(function () { return self && self instanceof WorkerGlobalScope; }).v);
}));

var _symbol$1;
var _symbolFor$1;
/*#__NO_SIDE_EFFECTS__*/
function _initSymbol() {
    _symbol$1 = ( /*#__PURE__*/createCachedValue(safe((getInst$1), [SYMBOL$1]).v));
    return _symbol$1;
}
function _getSymbolKey(key) {
    var gblSym = ((!_globalLazyTestHooks$2.lzy ? _symbol$1 : 0) || _initSymbol());
    return (gblSym.v ? gblSym.v[key] : UNDEF_VALUE$2);
}
/*#__NO_SIDE_EFFECTS__*/
function getKnownSymbol$1(name, noPoly) {
    var knownName = _wellKnownSymbolMap$1[name];
    !_globalLazyTestHooks$2 && _initTestHooks();
    var sym = ((!_globalLazyTestHooks$2.lzy ? _symbol$1 : 0) || _initSymbol());
    return sym.v ? sym.v[knownName || name] : (!noPoly ? polyGetKnownSymbol$1(name) : UNDEF_VALUE$2);
}
/*#__NO_SIDE_EFFECTS__*/
function newSymbol(description, noPoly) {
    !_globalLazyTestHooks$2 && _initTestHooks();
    var sym = ((!_globalLazyTestHooks$2.lzy ? _symbol$1 : 0) || _initSymbol());
    return sym.v ? sym.v(description) : (!noPoly ? polyNewSymbol$1(description) : NULL_VALUE$2);
}
/*#__NO_SIDE_EFFECTS__*/
function symbolFor(key) {
    !_globalLazyTestHooks$2 && _initTestHooks();
    _symbolFor$1 = ((!_globalLazyTestHooks$2.lzy ? _symbolFor$1 : 0) || ( /*#__PURE__*/createCachedValue(safe((_getSymbolKey), ["for"]).v)));
    return (_symbolFor$1.v || polySymbolFor)(key);
}

/*#__NO_SIDE_EFFECTS__*/
function isIterator(value) {
    return !!value && isFunction$2(value.next);
}
/*#__NO_SIDE_EFFECTS__*/
function isIterable(value) {
    return !isStrictNullOrUndefined(value) && isFunction$2(value[getKnownSymbol$1(3 )]);
}

var _iterSymbol$1;
function iterForOf(iter, callbackfn, thisArg) {
    if (iter) {
        if (!isIterator(iter)) {
            !_iterSymbol$1 && (_iterSymbol$1 = createCachedValue(getKnownSymbol$1(3 )));
            iter = iter[_iterSymbol$1.v] ? iter[_iterSymbol$1.v]() : null;
        }
        if (isIterator(iter)) {
            var err = UNDEF_VALUE$2;
            var iterResult = UNDEF_VALUE$2;
            try {
                var count = 0;
                while (!(iterResult = iter.next()).done) {
                    if (callbackfn[CALL](thisArg || iter, iterResult.value, count, iter) === -1) {
                        break;
                    }
                    count++;
                }
            }
            catch (failed) {
                err = { e: failed };
                if (iter.throw) {
                    iterResult = NULL_VALUE$2;
                    iter.throw(err);
                }
            }
            finally {
                try {
                    if (iterResult && !iterResult.done) {
                        iter.return && iter.return(iterResult);
                    }
                }
                finally {
                    if (err) {
                        // eslint-disable-next-line no-unsafe-finally
                        throw err.e;
                    }
                }
            }
        }
    }
}

function fnApply$1(fn, thisArg, argArray) {
    return fn.apply(thisArg, argArray);
}

function arrAppend(target, elms) {
    if (!isUndefined$1(elms) && target) {
        if (isArray$1(elms)) {
            fnApply$1(target.push, target, elms);
        }
        else if (isIterator(elms) || isIterable(elms)) {
            iterForOf(elms, function (elm) {
                target.push(elm);
            });
        }
        else {
            target.push(elms);
        }
    }
    return target;
}

function arrForEach$1(theArray, callbackfn, thisArg) {
    if (theArray) {
        var len = theArray[LENGTH$1] >>> 0;
        for (var idx = 0; idx < len; idx++) {
            if (idx in theArray) {
                if (callbackfn[CALL](thisArg || theArray, theArray[idx], idx, theArray) === -1) {
                    break;
                }
            }
        }
    }
}

var arrIndexOf = ( /*#__PURE__*/_unwrapFunction$1("indexOf", ArrProto$1));

var arrMap = ( /*#__PURE__*/_unwrapFunction$1("map", ArrProto$1));

function arrSlice$1(theArray, start, end) {
    return ((theArray && theArray["slice"]) || ArrSlice).apply(theArray, ArrSlice[CALL](arguments, 1));
}

var arrReduce = ( /*#__PURE__*/_unwrapFunction$1("reduce", ArrProto$1));

var objCreate$1 = ( /* #__PURE__*/_pureAssign(( /* #__PURE__*/_pureRef(ObjClass$3, "create")), polyObjCreate$1));
/*#__NO_SIDE_EFFECTS__*/
function polyObjCreate$1(obj) {
    if (!obj) {
        return {};
    }
    var type = typeof obj;
    if (type !== OBJECT$2 && type !== FUNCTION$2) {
        throwTypeError$2("Prototype must be an Object or function: " + dumpObj$2(obj));
    }
    function tempFunc() { }
    tempFunc[PROTOTYPE$2] = obj;
    return new tempFunc();
}

var _isProtoArray;
function objSetPrototypeOf(obj, proto) {
    var fn = ObjClass$3["setPrototypeOf"] ||
        function (d, b) {
            var _a;
            !_isProtoArray && (_isProtoArray = createCachedValue((_a = {}, _a[__PROTO__] = [], _a) instanceof Array));
            _isProtoArray.v ? d[__PROTO__] = b : objForEachKey$1(b, function (key, value) { return d[key] = value; });
        };
    return fn(obj, proto);
}

/*#__NO_SIDE_EFFECTS__*/
function _createCustomError(name, d, b) {
    safe(objDefine$1, [d, NAME, { v: name, c: true, e: false }]);
    d = objSetPrototypeOf(d, b);
    function __() {
        this[CONSTRUCTOR] = d;
        safe(objDefine$1, [this, NAME, { v: name, c: true, e: false }]);
    }
    d[PROTOTYPE$2] = b === NULL_VALUE$2 ? objCreate$1(b) : (__[PROTOTYPE$2] = b[PROTOTYPE$2], new __());
    return d;
}
function _setName(baseClass, name) {
    name && (baseClass[NAME] = name);
}
/*#__NO_SIDE_EFFECTS__*/
function createCustomError(name, constructCb, errorBase) {
    var theBaseClass = errorBase || Error;
    var orgName = theBaseClass[PROTOTYPE$2][NAME];
    var captureFn = Error.captureStackTrace;
    return _createCustomError(name, function () {
        var _this = this;
        var theArgs = arguments;
        try {
            safe(_setName, [theBaseClass, name]);
            var _self = fnApply$1(theBaseClass, _this, ArrSlice[CALL](theArgs)) || _this;
            if (_self !== _this) {
                var orgProto = objGetPrototypeOf(_this);
                if (orgProto !== objGetPrototypeOf(_self)) {
                    objSetPrototypeOf(_self, orgProto);
                }
            }
            captureFn && captureFn(_self, _this[CONSTRUCTOR]);
            constructCb && constructCb(_self, theArgs);
            return _self;
        }
        finally {
            safe(_setName, [theBaseClass, orgName]);
        }
    }, theBaseClass);
}
var _unsupportedError;
function throwUnsupported(message) {
    if (!_unsupportedError) {
        _unsupportedError = createCustomError("UnsupportedError");
    }
    throw new _unsupportedError(message);
}

/*#__NO_SIDE_EFFECTS__*/
function utcNow() {
    return (Date.now || polyUtcNow)();
}
/*#__NO_SIDE_EFFECTS__*/
function polyUtcNow() {
    return new Date().getTime();
}

/*#__NO_SIDE_EFFECTS__*/
function _createTrimFn(exp) {
    return function _doTrim(value) {
        if (isNullOrUndefined$1(value)) {
            throwTypeError$2("strTrim called [" + dumpObj$2(value) + "]");
        }
        if (value && value.replace) {
            value = value.replace(exp, EMPTY$2);
        }
        return value;
    };
}
var polyStrTrim = ( /*#__PURE__*/_createTrimFn(/^\s+|(?=\s)\s+$/g));

var strTrim = ( /*#__PURE__*/_unwrapFunctionWithPoly("trim", StrProto, polyStrTrim));

var _fnToString;
var _objCtrFnString;
var _gblWindow;
/*#__NO_SIDE_EFFECTS__*/
function isPlainObject(value) {
    if (!value || typeof value !== OBJECT$2) {
        return false;
    }
    if (!_gblWindow) {
        _gblWindow = hasWindow() ? getWindow$1() : true;
    }
    var result = false;
    if (value !== _gblWindow) {
        if (!_objCtrFnString) {
            _fnToString = Function[PROTOTYPE$2][TO_STRING];
            _objCtrFnString = _fnToString[CALL](ObjClass$3);
        }
        try {
            var proto = objGetPrototypeOf(value);
            result = !proto;
            if (!result) {
                if (objHasOwnProperty$1(proto, CONSTRUCTOR)) {
                    proto = proto[CONSTRUCTOR];
                }
                result = proto && typeof proto === FUNCTION$2 && _fnToString[CALL](proto) === _objCtrFnString;
            }
        }
        catch (ex) {
        }
    }
    return result;
}

/*#__NO_SIDE_EFFECTS__*/
function _defaultDeepCopyHandler(details) {
    details.value && plainObjDeepCopyHandler(details);
    return true;
}
var defaultDeepCopyHandlers = [
    arrayDeepCopyHandler,
    plainObjDeepCopyHandler,
    functionDeepCopyHandler,
    dateDeepCopyHandler
];
/*#__NO_SIDE_EFFECTS__*/
function _getSetVisited(visitMap, source, newPath, cb) {
    var theEntry;
    arrForEach$1(visitMap, function (entry) {
        if (entry.k === source) {
            theEntry = entry;
            return -1;
        }
    });
    if (!theEntry) {
        theEntry = { k: source, v: source };
        visitMap.push(theEntry);
        cb(theEntry);
    }
    return theEntry.v;
}
function _deepCopy(visitMap, value, ctx, key) {
    var userHandler = ctx.handler;
    var newPath = ctx.path ? (key ? ctx.path.concat(key) : ctx.path) : [];
    var newCtx = {
        handler: ctx.handler,
        src: ctx.src,
        path: newPath
    };
    var theType = typeof value;
    var isPlain = false;
    var isPrim = false;
    if (value && theType === OBJECT$2) {
        isPlain = isPlainObject(value);
    }
    else {
        isPrim = value === NULL_VALUE$2 || isPrimitiveType(theType);
    }
    var details = {
        type: theType,
        isPrim: isPrim,
        isPlain: isPlain,
        value: value,
        result: value,
        path: newPath,
        origin: ctx.src,
        copy: function (source, newKey) {
            return _deepCopy(visitMap, source, newKey ? newCtx : ctx, newKey);
        },
        copyTo: function (target, source) {
            return _copyProps(visitMap, target, source, newCtx);
        }
    };
    if (!details.isPrim) {
        return _getSetVisited(visitMap, value, newPath, function (newEntry) {
            objDefine$1(details, "result", {
                g: function () {
                    return newEntry.v;
                },
                s: function (newValue) {
                    newEntry.v = newValue;
                }
            });
            var idx = 0;
            var handler = userHandler;
            while (!(handler || (idx < defaultDeepCopyHandlers.length ? defaultDeepCopyHandlers[idx++] : _defaultDeepCopyHandler))[CALL](ctx, details)) {
                handler = NULL_VALUE$2;
            }
        });
    }
    if (userHandler && userHandler[CALL](ctx, details)) {
        return details.result;
    }
    return value;
}
function _copyProps(visitMap, target, source, ctx) {
    if (!isNullOrUndefined$1(source)) {
        for (var key in source) {
            target[key] = _deepCopy(visitMap, source[key], ctx, key);
        }
    }
    return target;
}
function objCopyProps(target, source, handler) {
    var ctx = {
        handler: handler,
        src: source,
        path: []
    };
    return _copyProps([], target, source, ctx);
}
/*#__NO_SIDE_EFFECTS__*/
function objDeepCopy(source, handler) {
    var ctx = {
        handler: handler,
        src: source
    };
    return _deepCopy([], source, ctx);
}
function arrayDeepCopyHandler(details) {
    var value = details.value;
    if (isArray$1(value)) {
        var target = details.result = [];
        target.length = value.length;
        details.copyTo(target, value);
        return true;
    }
    return false;
}
function dateDeepCopyHandler(details) {
    var value = details.value;
    if (isDate(value)) {
        details.result = new Date(value.getTime());
        return true;
    }
    return false;
}
function functionDeepCopyHandler(details) {
    if (details.type === FUNCTION$2) {
        return true;
    }
    return false;
}
function plainObjDeepCopyHandler(details) {
    var value = details.value;
    if (value && details.isPlain) {
        var target = details.result = {};
        details.copyTo(target, value);
        return true;
    }
    return false;
}

function _doExtend(target, theArgs) {
    arrForEach$1(theArgs, function (theArg) {
        objCopyProps(target, theArg);
    });
    return target;
}
function deepExtend(target, obj1, obj2, obj3, obj4, obj5, obj6) {
    return _doExtend(objDeepCopy(target) || {}, ArrSlice[CALL](arguments));
}
function objExtend$1(target, obj1, obj2, obj3, obj4, obj5, obj6) {
    return _doExtend(target || {}, ArrSlice[CALL](arguments));
}

var getLength = ( /*#__PURE__*/_unwrapProp(LENGTH$1));

var _perf;
/*#__NO_SIDE_EFFECTS__*/
function getPerformance() {
    !_globalLazyTestHooks$2 && _initTestHooks();
    (!_perf || _globalLazyTestHooks$2.lzy) && (_perf = createCachedValue(safe((getInst$1), ["performance"]).v));
    return _perf.v;
}

var strSplit = ( /*#__PURE__*/_unwrapFunction$1("split", StrProto));
function setValueByKey(target, path, value) {
    if (target && path) {
        var parts = strSplit(path, ".");
        var lastKey = parts.pop();
        arrForEach$1(parts, function (key) {
            if (isNullOrUndefined$1(target[key])) {
                target[key] = {};
            }
            target = target[key];
        });
        target[lastKey] = value;
    }
}

var strEndsWith = ( /*#__PURE__*/_unwrapFunctionWithPoly("endsWith", StrProto, polyStrEndsWith));
/*#__NO_SIDE_EFFECTS__*/
function polyStrEndsWith(value, searchString, length) {
    if (!isString$2(value)) {
        throwTypeError$2("'" + dumpObj$2(value) + "' is not a string");
    }
    var searchValue = isString$2(searchString) ? searchString : asString$1(searchString);
    var end = !isUndefined$1(length) && length < value[LENGTH$1] ? length : value[LENGTH$1];
    return strSubstring(value, end - searchValue[LENGTH$1], end) === searchValue;
}

var strIndexOf = ( /*#__PURE__*/_unwrapFunction$1("indexOf", StrProto));

var REF$1 = "ref";
var UNREF$1 = "unref";
var HAS_REF$1 = "hasRef";
var ENABLED$1 = "enabled";
/*#__NO_SIDE_EFFECTS__*/
function _createTimerHandler$1(startTimer, refreshFn, cancelFn) {
    var ref = true;
    var timerId = startTimer ? refreshFn(NULL_VALUE$2) : NULL_VALUE$2;
    var theTimerHandler;
    function _unref() {
        ref = false;
        timerId && timerId[UNREF$1] && timerId[UNREF$1]();
        return theTimerHandler;
    }
    function _cancel() {
        timerId && cancelFn(timerId);
        timerId = NULL_VALUE$2;
    }
    function _refresh() {
        timerId = refreshFn(timerId);
        if (!ref) {
            _unref();
        }
        return theTimerHandler;
    }
    function _setEnabled(value) {
        !value && timerId && _cancel();
        value && !timerId && _refresh();
    }
    theTimerHandler = {
        cancel: _cancel,
        refresh: _refresh
    };
    theTimerHandler[HAS_REF$1] = function () {
        if (timerId && timerId[HAS_REF$1]) {
            return timerId[HAS_REF$1]();
        }
        return ref;
    };
    theTimerHandler[REF$1] = function () {
        ref = true;
        timerId && timerId[REF$1] && timerId[REF$1]();
        return theTimerHandler;
    };
    theTimerHandler[UNREF$1] = _unref;
    theTimerHandler = objDefineProp$2(theTimerHandler, ENABLED$1, {
        get: function () { return !!timerId; },
        set: _setEnabled
    });
    return {
        h: theTimerHandler,
        dn: function () {
            timerId = NULL_VALUE$2;
        }
    };
}

function _createTimeoutWith$1(startTimer, overrideFn, theArgs) {
    var isArr = isArray$1(overrideFn);
    var len = isArr ? overrideFn.length : 0;
    var setFn = (len > 0 ? overrideFn[0] : (!isArr ? overrideFn : UNDEF_VALUE$2)) || setTimeout;
    var clearFn = (len > 1 ? overrideFn[1] : UNDEF_VALUE$2) || clearTimeout;
    var timerFn = theArgs[0];
    theArgs[0] = function () {
        handler.dn();
        fnApply$1(timerFn, UNDEF_VALUE$2, ArrSlice[CALL](arguments));
    };
    var handler = _createTimerHandler$1(startTimer, function (timerId) {
        if (timerId) {
            if (timerId.refresh) {
                timerId.refresh();
                return timerId;
            }
            fnApply$1(clearFn, UNDEF_VALUE$2, [timerId]);
        }
        return fnApply$1(setFn, UNDEF_VALUE$2, theArgs);
    }, function (timerId) {
        fnApply$1(clearFn, UNDEF_VALUE$2, [timerId]);
    });
    return handler.h;
}
function scheduleTimeout$1(callback, timeout) {
    return _createTimeoutWith$1(true, UNDEF_VALUE$2, ArrSlice[CALL](arguments));
}
function createTimeout(callback, timeout) {
    return _createTimeoutWith$1(false, UNDEF_VALUE$2, ArrSlice[CALL](arguments));
}

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var _a$c;
/**
 * Constant string defined to support minimization
 * @ignore
 */
var Constructor = 'constructor';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var Prototype = 'prototype';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strFunction = 'function';
/**
 * Used to define the name of the instance function lookup table
 * @ignore
 */
var DynInstFuncTable = '_dynInstFuncs';
/**
 * Name used to tag the dynamic prototype function
 * @ignore
 */
var DynProxyTag = '_isDynProxy';
/**
 * Name added to a prototype to define the dynamic prototype "class" name used to lookup the function table
 * @ignore
 */
var DynClassName = '_dynClass';
/**
 * Prefix added to the classname to avoid any name clashes with other instance level properties
 * @ignore
 */
var DynClassNamePrefix = '_dynCls$';
/**
 * A tag which is used to check if we have already to attempted to set the instance function if one is not present
 * @ignore
 */
var DynInstChkTag = '_dynInstChk';
/**
 * A tag which is used to check if we are allows to try and set an instance function is one is not present. Using the same
 * tag name as the function level but a different const name for readability only.
 */
var DynAllowInstChkTag = DynInstChkTag;
/**
 * The global (imported) instances where the global performance options are stored
 */
var DynProtoDefaultOptions = '_dfOpts';
/**
 * Value used as the name of a class when it cannot be determined
 * @ignore
 */
var UnknownValue = '_unknown_';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var str__Proto = "__proto__";
/**
 * The polyfill version of __proto__ so that it doesn't cause issues for anyone not expecting it to exist
 */
var DynProtoBaseProto = "_dyn" + str__Proto;
/**
 * Runtime Global holder for dynamicProto settings
 */
var DynProtoGlobalSettings = "__dynProto$Gbl";
/**
 * Track the current prototype for IE8 as you can't look back to get the prototype
 */
var DynProtoCurrent = "_dynInstProto";
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strUseBaseInst = 'useBaseInst';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strSetInstFuncs = 'setInstFuncs';
var Obj = Object;
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */
var _objGetPrototypeOf = Obj["getPrototypeOf"];
/**
 * Pre-lookup to check for the existence of this function
 */
var _objGetOwnProps = Obj["getOwnPropertyNames"];
// Since 1.1.7 moving these to the runtime global to work around mixed version and module issues
// See Issue https://github.com/microsoft/DynamicProto-JS/issues/57 for details
var _gbl = getGlobal$2();
var _gblInst = _gbl[DynProtoGlobalSettings] || (_gbl[DynProtoGlobalSettings] = {
    o: (_a$c = {},
        _a$c[strSetInstFuncs] = true,
        _a$c[strUseBaseInst] = true,
        _a$c),
    n: 1000 // Start new global index @ 1000 so we "fix" some cases when mixed with 1.1.6 or earlier
});
/**
 * Helper used to check whether the target is an Object prototype or Array prototype
 * @ignore
 */
function _isObjectOrArrayPrototype(target) {
    return target && (target === Obj[Prototype] || target === Array[Prototype]);
}
/**
 * Helper used to check whether the target is an Object prototype, Array prototype or Function prototype
 * @ignore
 */
function _isObjectArrayOrFunctionPrototype(target) {
    return _isObjectOrArrayPrototype(target) || target === Function[Prototype];
}
/**
 * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
 * @ignore
 */
function _getObjProto$1(target) {
    var newProto;
    if (target) {
        // This method doesn't exist in older browsers (e.g. IE8)
        if (_objGetPrototypeOf) {
            return _objGetPrototypeOf(target);
        }
        var curProto = target[str__Proto] || target[Prototype] || (target[Constructor] ? target[Constructor][Prototype] : null);
        // Using the pre-calculated value as IE8 doesn't support looking up the prototype of a prototype and thus fails for more than 1 base class
        newProto = target[DynProtoBaseProto] || curProto;
        if (!objHasOwnProperty$1(target, DynProtoBaseProto)) {
            // As this prototype doesn't have this property then this is from an inherited class so newProto is the base to return so save it
            // so we can look it up value (which for a multiple hierarchy dynamicProto will be the base class)
            delete target[DynProtoCurrent]; // Delete any current value allocated to this instance so we pick up the value from prototype hierarchy
            newProto = target[DynProtoBaseProto] = target[DynProtoCurrent] || target[DynProtoBaseProto];
            target[DynProtoCurrent] = curProto;
        }
    }
    return newProto;
}
/**
 * Helper to get the properties of an object, including none enumerable ones as functions on a prototype in ES6
 * are not enumerable.
 * @param target
 */
function _forEachProp(target, func) {
    var props = [];
    if (_objGetOwnProps) {
        props = _objGetOwnProps(target);
    }
    else {
        for (var name_1 in target) {
            if (typeof name_1 === "string" && objHasOwnProperty$1(target, name_1)) {
                props.push(name_1);
            }
        }
    }
    if (props && props.length > 0) {
        for (var lp = 0; lp < props.length; lp++) {
            func(props[lp]);
        }
    }
}
/**
 * Helper function to check whether the provided function name is a potential candidate for dynamic
 * callback and prototype generation.
 * @param target The target object, may be a prototype or class object
 * @param funcName The function name
 * @param skipOwn Skips the check for own property
 * @ignore
 */
function _isDynamicCandidate(target, funcName, skipOwn) {
    return (funcName !== Constructor && typeof target[funcName] === strFunction && (skipOwn || objHasOwnProperty$1(target, funcName)) && funcName !== str__Proto && funcName !== Prototype);
}
/**
 * Helper to throw a TypeError exception
 * @param message the message
 * @ignore
 */
function _throwTypeError(message) {
    throwTypeError$2("DynamicProto: " + message);
}
/**
 * Returns a collection of the instance functions that are defined directly on the thisTarget object, it does
 * not return any inherited functions
 * @param thisTarget The object to get the instance functions from
 * @ignore
 */
function _getInstanceFuncs(thisTarget) {
    // Get the base proto
    var instFuncs = objCreate$1(null);
    // Save any existing instance functions
    _forEachProp(thisTarget, function (name) {
        // Don't include any dynamic prototype instances - as we only want the real functions
        if (!instFuncs[name] && _isDynamicCandidate(thisTarget, name, false)) {
            // Create an instance callback for passing the base function to the caller
            instFuncs[name] = thisTarget[name];
        }
    });
    return instFuncs;
}
/**
 * Returns whether the value is included in the array
 * @param values The array of values
 * @param value  The value
 */
function _hasVisited(values, value) {
    for (var lp = values.length - 1; lp >= 0; lp--) {
        if (values[lp] === value) {
            return true;
        }
    }
    return false;
}
/**
 * Returns an object that contains callback functions for all "base/super" functions, this is used to "save"
 * enabling calling super.xxx() functions without requiring that the base "class" has defined a prototype references
 * @param target The current instance
 * @ignore
 */
function _getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
    function _instFuncProxy(target, funcHost, funcName) {
        var theFunc = funcHost[funcName];
        if (theFunc[DynProxyTag] && useBaseInst) {
            // grab and reuse the hosted looking function (if available) otherwise the original passed function
            var instFuncTable = target[DynInstFuncTable] || {};
            if (instFuncTable[DynAllowInstChkTag] !== false) {
                theFunc = (instFuncTable[funcHost[DynClassName]] || {})[funcName] || theFunc;
            }
        }
        return function () {
            // eslint-disable-next-line prefer-rest-params
            return theFunc.apply(target, arguments);
        };
    }
    // Start creating a new baseFuncs by creating proxies for the instance functions (as they may get replaced)
    var baseFuncs = objCreate$1(null);
    _forEachProp(instFuncs, function (name) {
        // Create an instance callback for passing the base function to the caller
        baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
    });
    // Get the base prototype functions
    var baseProto = _getObjProto$1(classProto);
    var visited = [];
    // Don't include base object functions for Object, Array or Function
    while (baseProto && !_isObjectArrayOrFunctionPrototype(baseProto) && !_hasVisited(visited, baseProto)) {
        // look for prototype functions
        _forEachProp(baseProto, function (name) {
            // Don't include any dynamic prototype instances - as we only want the real functions
            // For IE 7/8 the prototype lookup doesn't provide the full chain so we need to bypass the 
            // hasOwnProperty check we get all of the methods, main difference is that IE7/8 doesn't return
            // the Object prototype methods while bypassing the check
            if (!baseFuncs[name] && _isDynamicCandidate(baseProto, name, !_objGetPrototypeOf)) {
                // Create an instance callback for passing the base function to the caller
                baseFuncs[name] = _instFuncProxy(thisTarget, baseProto, name);
            }
        });
        // We need to find all possible functions that might be overloaded by walking the entire prototype chain
        // This avoids the caller from needing to check whether it's direct base class implements the function or not
        // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
        visited.push(baseProto);
        baseProto = _getObjProto$1(baseProto);
    }
    return baseFuncs;
}
function _getInstFunc(target, funcName, proto, currentDynProtoProxy) {
    var instFunc = null;
    // We need to check whether the class name is defined directly on this prototype otherwise
    // it will walk the proto chain and return any parent proto classname.
    if (target && objHasOwnProperty$1(proto, DynClassName)) {
        var instFuncTable = target[DynInstFuncTable] || objCreate$1(null);
        instFunc = (instFuncTable[proto[DynClassName]] || objCreate$1(null))[funcName];
        if (!instFunc) {
            // Avoid stack overflow from recursive calling the same function
            _throwTypeError("Missing [" + funcName + "] " + strFunction);
        }
        // We have the instance function, lets check it we can speed up further calls
        // by adding the instance function back directly on the instance (avoiding the dynamic func lookup)
        if (!instFunc[DynInstChkTag] && instFuncTable[DynAllowInstChkTag] !== false) {
            // If the instance already has an instance function we can't replace it
            var canAddInst = !objHasOwnProperty$1(target, funcName);
            // Get current prototype
            var objProto = _getObjProto$1(target);
            var visited = [];
            // Lookup the function starting at the top (instance level prototype) and traverse down, if the first matching function
            // if nothing is found or if the first hit is a dynamic proto instance then we can safely add an instance shortcut
            while (canAddInst && objProto && !_isObjectArrayOrFunctionPrototype(objProto) && !_hasVisited(visited, objProto)) {
                var protoFunc = objProto[funcName];
                if (protoFunc) {
                    canAddInst = (protoFunc === currentDynProtoProxy);
                    break;
                }
                // We need to find all possible initial functions to ensure that we don't bypass a valid override function
                visited.push(objProto);
                objProto = _getObjProto$1(objProto);
            }
            try {
                if (canAddInst) {
                    // This instance doesn't have an instance func and the class hierarchy does have a higher level prototype version
                    // so it's safe to directly assign for any subsequent calls (for better performance)
                    target[funcName] = instFunc;
                }
                // Block further attempts to set the instance function for any
                instFunc[DynInstChkTag] = 1;
            }
            catch (e) {
                // Don't crash if the object is readonly or the runtime doesn't allow changing this
                // And set a flag so we don't try again for any function
                instFuncTable[DynAllowInstChkTag] = false;
            }
        }
    }
    return instFunc;
}
function _getProtoFunc(funcName, proto, currentDynProtoProxy) {
    var protoFunc = proto[funcName];
    // Check that the prototype function is not a self reference -- try to avoid stack overflow!
    if (protoFunc === currentDynProtoProxy) {
        // It is so lookup the base prototype
        protoFunc = _getObjProto$1(proto)[funcName];
    }
    if (typeof protoFunc !== strFunction) {
        _throwTypeError("[" + funcName + "] is not a " + strFunction);
    }
    return protoFunc;
}
/**
 * Add the required dynamic prototype methods to the the class prototype
 * @param proto - The class prototype
 * @param className - The instance classname
 * @param target - The target instance
 * @param baseInstFuncs - The base instance functions
 * @param setInstanceFunc - Flag to allow prototype function to reset the instance function if one does not exist
 * @ignore
 */
function _populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
    function _createDynamicPrototype(proto, funcName) {
        var dynProtoProxy = function () {
            // Use the instance or prototype function
            var instFunc = _getInstFunc(this, funcName, proto, dynProtoProxy) || _getProtoFunc(funcName, proto, dynProtoProxy);
            // eslint-disable-next-line prefer-rest-params
            return instFunc.apply(this, arguments);
        };
        // Tag this function as a proxy to support replacing dynamic proxy elements (primary use case is for unit testing
        // via which can dynamically replace the prototype function reference)
        dynProtoProxy[DynProxyTag] = 1;
        return dynProtoProxy;
    }
    if (!_isObjectOrArrayPrototype(proto)) {
        var instFuncTable = target[DynInstFuncTable] = target[DynInstFuncTable] || objCreate$1(null);
        if (!_isObjectOrArrayPrototype(instFuncTable)) {
            var instFuncs_1 = instFuncTable[className] = (instFuncTable[className] || objCreate$1(null)); // fetch and assign if as it may not exist yet
            // Set whether we are allow to lookup instances, if someone has set to false then do not re-enable
            if (instFuncTable[DynAllowInstChkTag] !== false) {
                instFuncTable[DynAllowInstChkTag] = !!setInstanceFunc;
            }
            if (!_isObjectOrArrayPrototype(instFuncs_1)) {
                _forEachProp(target, function (name) {
                    // Only add overridden functions
                    if (_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
                        // Save the instance Function to the lookup table and remove it from the instance as it's not a dynamic proto function
                        instFuncs_1[name] = target[name];
                        delete target[name];
                        // Add a dynamic proto if one doesn't exist or if a prototype function exists and it's not a dynamic one
                        if (!objHasOwnProperty$1(proto, name) || (proto[name] && !proto[name][DynProxyTag])) {
                            proto[name] = _createDynamicPrototype(proto, name);
                        }
                    }
                });
            }
        }
    }
}
/**
 * Checks whether the passed prototype object appears to be correct by walking the prototype hierarchy of the instance
 * @param classProto The class prototype instance
 * @param thisTarget The current instance that will be checked whether the passed prototype instance is in the hierarchy
 * @ignore
 */
function _checkPrototype(classProto, thisTarget) {
    // This method doesn't existing in older browsers (e.g. IE8)
    if (_objGetPrototypeOf) {
        // As this is primarily a coding time check, don't bother checking if running in IE8 or lower
        var visited = [];
        var thisProto = _getObjProto$1(thisTarget);
        while (thisProto && !_isObjectArrayOrFunctionPrototype(thisProto) && !_hasVisited(visited, thisProto)) {
            if (thisProto === classProto) {
                return true;
            }
            // This avoids the caller from needing to check whether it's direct base class implements the function or not
            // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
            visited.push(thisProto);
            thisProto = _getObjProto$1(thisProto);
        }
        return false;
    }
    // If objGetPrototypeOf doesn't exist then just assume everything is ok.
    return true;
}
/**
 * Gets the current prototype name using the ES6 name if available otherwise falling back to a use unknown as the name.
 * It's not critical for this to return a name, it's used to decorate the generated unique name for easier debugging only.
 * @param target
 * @param unknownValue
 * @ignore
 */
function _getObjName(target, unknownValue) {
    if (objHasOwnProperty$1(target, Prototype)) {
        // Look like a prototype
        return target.name || unknownValue || UnknownValue;
    }
    return (((target || {})[Constructor]) || {}).name || unknownValue || UnknownValue;
}
/**
 * Helper function when creating dynamic (inline) functions for classes, this helper performs the following tasks :-
 * - Saves references to all defined base class functions
 * - Calls the delegateFunc with the current target (this) and a base object reference that can be used to call all "super" functions.
 * - Will populate the class prototype for all overridden functions to support class extension that call the prototype instance.
 * Callers should use this helper when declaring all function within the constructor of a class, as mentioned above the delegateFunc is
 * passed both the target "this" and an object that can be used to call any base (super) functions, using this based object in place of
 * super.XXX() (which gets expanded to _super.prototype.XXX()) provides a better minification outcome and also ensures the correct "this"
 * context is maintained as TypeScript creates incorrect references using super.XXXX() for dynamically defined functions i.e. Functions
 * defined in the constructor or some other function (rather than declared as complete typescript functions).
 * ### Usage
 * ```typescript
 * import dynamicProto from "@microsoft/dynamicproto-js";
 * class ExampleClass extends BaseClass {
 *     constructor() {
 *         dynamicProto(ExampleClass, this, (_self, base) => {
 *             // This will define a function that will be converted to a prototype function
 *             _self.newFunc = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     ...
 *                 }
 *             }
 *             // This will define a function that will be converted to a prototype function
 *             _self.myFunction = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     // Call the base version of the function that we are overriding
 *                     base.myFunction();
 *                 }
 *                 ...
 *             }
 *             _self.initialize = () => {
 *                 ...
 *             }
 *             // Warnings: While the following will work as _self is simply a reference to
 *             // this, if anyone overrides myFunction() the overridden will be called first
 *             // as the normal JavaScript method resolution will occur and the defined
 *             // _self.initialize() function is actually gets removed from the instance and
 *             // a proxy prototype version is created to reference the created method.
 *             _self.initialize();
 *         });
 *     }
 * }
 * ```
 * @typeparam DPType This is the generic type of the class, used to keep intellisense valid
 * @typeparam DPCls The type that contains the prototype of the current class
 * @param theClass - This is the current class instance which contains the prototype for the current class
 * @param target - The current "this" (target) reference, when the class has been extended this.prototype will not be the 'theClass' value.
 * @param delegateFunc - The callback function (closure) that will create the dynamic function
 * @param options - Additional options to configure how the dynamic prototype operates
 */
function dynamicProto(theClass, target, delegateFunc, options) {
    // Make sure that the passed theClass argument looks correct
    if (!objHasOwnProperty$1(theClass, Prototype)) {
        _throwTypeError("theClass is an invalid class definition.");
    }
    // Quick check to make sure that the passed theClass argument looks correct (this is a common copy/paste error)
    var classProto = theClass[Prototype];
    if (!_checkPrototype(classProto, target)) {
        _throwTypeError("[" + _getObjName(theClass) + "] not in hierarchy of [" + _getObjName(target) + "]");
    }
    var className = null;
    if (objHasOwnProperty$1(classProto, DynClassName)) {
        // Only grab the class name if it's defined on this prototype (i.e. don't walk the prototype chain)
        className = classProto[DynClassName];
    }
    else {
        // As not all browser support name on the prototype creating a unique dynamic one if we have not already
        // assigned one, so we can use a simple string as the lookup rather than an object for the dynamic instance
        // function table lookup.
        className = DynClassNamePrefix + _getObjName(theClass, "_") + "$" + _gblInst.n;
        _gblInst.n++;
        classProto[DynClassName] = className;
    }
    var perfOptions = dynamicProto[DynProtoDefaultOptions];
    var useBaseInst = !!perfOptions[strUseBaseInst];
    if (useBaseInst && options && options[strUseBaseInst] !== undefined) {
        useBaseInst = !!options[strUseBaseInst];
    }
    // Get the current instance functions
    var instFuncs = _getInstanceFuncs(target);
    // Get all of the functions for any base instance (before they are potentially overridden)
    var baseFuncs = _getBaseFuncs(classProto, target, instFuncs, useBaseInst);
    // Execute the delegate passing in both the current target "this" and "base" function references
    // Note casting the same type as we don't actually have the base class here and this will provide some intellisense support
    delegateFunc(target, baseFuncs);
    // Don't allow setting instance functions for older IE instances
    var setInstanceFunc = !!_objGetPrototypeOf && !!perfOptions[strSetInstFuncs];
    if (setInstanceFunc && options) {
        setInstanceFunc = !!options[strSetInstFuncs];
    }
    // Populate the Prototype for any overridden instance functions
    _populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
}
/**
 * Exposes the default global options to allow global configuration, if the global values are disabled these will override
 * any passed values. This is primarily exposed to support unit-testing without the need for individual classes to expose
 * their internal usage of dynamic proto.
 */
dynamicProto[DynProtoDefaultOptions] = _gblInst.o;

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var strShimFunction = "function";
var strShimObject = "object";
var strShimUndefined = "undefined";
var strShimPrototype = "prototype";
var ObjClass$2 = Object;
var ObjProto$2 = ObjClass$2[strShimPrototype];

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
// These constants are currently NOT exported directly, we may export them later associated with a frozen namespace (maybe)
// For now do NOT expect that we will export these values.
var UNDEF_VALUE$1 = undefined;
var NULL_VALUE$1 = null;
var EMPTY$1 = "";
var FUNCTION$1 = "function";
var NUMBER$1 = "number";
var OBJECT$1 = "object";
var PROTOTYPE$1 = "prototype";
var UNDEFINED$1 = "undefined";
/**
 * @ignore
 */
var ObjClass$1 = Object;
/**
 * @ignore
 */
var ObjProto$1 = ObjClass$1[PROTOTYPE$1];

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Function to safely execute a callback function, if the function throws the provided default
 * value will be returned.
 * @since 0.9.5
 * @group Safe
 * @param cb - Callback function be wrapped with an exception
 * @param defValue - The default value to return when an exception is thrown
 * @returns The result of the callback function or the default if an exception occurred calling the callback
 * function.
 * @example
 * ```ts
 * let theExpression = "{ invalid: json value";
 *
 * let result = safeGet(() => {
 *     return JSON.parse(theExpression);
 * }, {});
 *
 * // result === {};
 * ```
 */
function safeGet$1(cb, defValue) {
    var result = defValue;
    try {
        result = cb();
    }
    catch (e) {
        // Do nothing
    }
    return result;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @ignore
 * @internal
 * Create and returns a function that will return `true` if the argument passed
 * to it matches the provided type.
 * @param theType - The type to match against the `typeof value`
 * @returns A function which takes a single argument and returns a boolean
 */
function _createIs$1(theType) {
    return function (value) {
        return typeof value === theType;
    };
}
/**
 * @ignore
 * @internal
 * Create and returns a function that will return `true` if the argument passed
 * to it matches the object type specified based on {@link objToString}.
 * @param - The object name to match for the `objToString(value)`
 * @returns A function which takes a single argument and returns a boolean
 */
function _createObjIs$1(theName) {
    var theType = "[object " + theName + "]";
    return function (value) {
        return !!(value && objToString$1(value) === theType);
    };
}
/**
 * The `objToString()` method returns a string representing the object. This explicitly
 * always calls the `Object.prototype.toString()` method.
 *
 * An object's toString() method is most commonly invoked when that object undergoes:
 * - explicit type conversion to a string (for example, String(myObject))
 * - implicit type coercion into a string (for example, myObject + "hello world")
 *
 * @group Object
 * @param value - The object to be converted into a string
 * @returns A string representation of the object
 * @example
 * ```ts
 * objToString(new Date()); // [object Date]
 * objToString(new String()); // [object String]
 *
 * // Math has its Symbol.toStringTag
 * objToString(Math); // [object Math]
 *
 * objToString(undefined); // [object Undefined]
 * objToString(null); // [object Null]
 * ```
 */
function objToString$1(value) {
    return ObjProto$1.toString.call(value);
}
/**
 * Checks if the type of value is a number.
 * @group Type Identity
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a number, false otherwise.
 */
var isNumber$1 = _createIs$1(NUMBER$1);
/**
 * Checks if the type of value is a Error object.
 * @group Type Identity
 * @group Error
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a Error, false otherwise.
 */
var isError$1 = _createObjIs$1("Error");

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Throw a type error with the specified optional message
 * @group Error
 * @param message
 */
function throwTypeError$1(message) {
    throw new TypeError(message);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The `objAssign()` method copies all enumerable own properties from one or more source objects
 * to a target object. It returns the modified target object.
 *
 * Properties in the target object are overwritten by properties in the sources if they have the
 * same key. Later sources' properties overwrite earlier ones.
 *
 * The objAssign() method only copies enumerable and own properties from a source object to a
 * target object. It uses `Get` on the source and `Set` on the target, so it will invoke
 * [getters](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get) and
 * [setters](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/set).
 * Therefore it assigns properties, versus copying or defining new properties. This may make it
 * unsuitable for merging new properties into a prototype if the merge sources contain getters.
 *
 * For copying property definitions (including their enumerability) into prototypes, use
 * {@link objGetOwnPropertyDescriptor} and {@link objDefineProp} instead.
 *
 * Both String and Symbol properties are copied.
 *
 * In case of an error, for example if a property is non-writable, a TypeError is raised, and
 * the target object is changed if any properties are added before the error is raised.
 * @group Object
 * @example
 * ```ts
 * const obj = { a: 1 };
 * const copy = objAssign({}, obj);
 * console.log(copy); // { a: 1 }
 *
 * const o1 = { a: 1 };
 * const o2 = { b: 2 };
 * const o3 = { c: 3 };
 *
 * const obj = objAssign(o1, o2, o3);
 * console.log(obj); // { a: 1, b: 2, c: 3 }
 * console.log(o1);  // { a: 1, b: 2, c: 3 }, target object itself is changed.
 * ```
 */
var objAssign = ObjClass$1["assign"];

var GLOBAL_CONFIG_KEY$1 = "__tsUtils$gblCfg";
var _globalCfg$1;
/**
 * @internal
 * @ignore
 * Helper to get the current global value
 * @returns
 */
function _getGlobalValue$1() {
    var result;
    if (typeof globalThis !== UNDEFINED$1) {
        result = globalThis;
    }
    if (!result && typeof self !== UNDEFINED$1) {
        result = self;
    }
    if (!result && typeof window !== UNDEFINED$1) {
        result = window;
    }
    if (!result && typeof global$1 !== UNDEFINED$1) {
        result = global$1;
    }
    return result;
}
/**
 * @internal
 * @ignore
 * Gets/Sets the named value from the global config store, this is used to share configuration across
 * multiple modules. Primarily used for poly symbol and test hooks.
 * @returns The globally registered value.
 */
function _getGlobalConfig$1() {
    if (!_globalCfg$1) {
        var gbl = _getGlobalValue$1() || {};
        _globalCfg$1 = gbl[GLOBAL_CONFIG_KEY$1] = gbl[GLOBAL_CONFIG_KEY$1] || {};
    }
    return _globalCfg$1;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Returns string representation of an object suitable for diagnostics logging.
 * @group Error
 * @group Diagnostic
 * @param object - The object to be converted to a diagnostic string value
 * @param format - Identifies whether the JSON value should be formated
 * - `true` - Format with 4 spaces
 * - 'number' - The number of spaces to format with
 * - `false` (or not Truthy) - Do not format
 */
function dumpObj$1(object, format) {
    var propertyValueDump = EMPTY$1;
    if (isError$1(object)) {
        propertyValueDump = "{ stack: '" + object.stack + "', message: '" + object.message + "', name: '" + object.name + "'";
    }
    else {
        try {
            propertyValueDump = JSON.stringify(object, NULL_VALUE$1, format ? (isNumber$1(format) ? format : 4) : UNDEF_VALUE$1);
        }
        catch (e) {
            // Unable to convert object (probably circular)
            propertyValueDump = " - " + dumpObj$1(e, format);
        }
    }
    return objToString$1(object) + ": " + propertyValueDump;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Defines a new property directly on an object, or modifies an existing property on an object, and returns the object.
 * This is a wrapper for [Object.defineProperty](https://developer.mozilla.org/en-US/docs/web/javascript/reference/global_objects/object/defineproperty)
 *
 * This method allows a precise addition to or modification of a property on an object. Normal property addition through
 * assignment creates properties which show up during property enumeration (for...in loop or objKeys method), whose
 * values may be changed, and which may be deleted. This method allows these extra details to be changed from their
 * defaults. By default, properties added using objDefineProp() are not writable, not enumerable, and not configurable.
 *
 * Property descriptors present in objects come in two main flavors: data descriptors and accessor descriptors. A data
 * descriptor is a property that has a value, which may or may not be writable. An accessor descriptor is a property
 * described by a getter-setter pair of functions. A descriptor must be one of these two flavors; it cannot be both.
 *
 * This is an alias for Object.defineProperty
 * @group Object
 * @param target - The object on which to define the property.
 * @param key - The name or Symbol of the property to be defined or modified.
 * @param descriptor - The descriptor for the property being defined or modified.
 */
var objDefineProp$1 = ObjClass$1["defineProperty"];

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @internal
 * Internal flag which is set by the public {@link setBypassLazyCache}, should not be externally exported
 */
var _globalLazyTestHooks$1;
var _fetchLazyTestHooks$1 = function () {
    _globalLazyTestHooks$1 = _getGlobalConfig$1();
    _fetchLazyTestHooks$1 = NULL_VALUE$1;
};
/**
 * Create and return an readonly {@link ILazyValue} instance which will cache and return the value returned
 * by the callback function. The callback function will only be called once, multiple access of the value
 * does not cause re-execution of the callback as the result from the first call is cached internally.
 * @since 0.4.5
 * @group Lazy
 * @param cb - The callback function to fetch the value to be lazily evaluated and cached
 * @returns A new readonly {@link ILazyValue} instance which wraps the callback and will be used to cache
 * the result of the callback
 * @example
 * ```ts
 * // This does not cause the evaluation to occur
 * let cachedValue = getLazy(() => callSomeExpensiveFunction());
 * let theValue;
 *
 * // Just checking if there is an object still does not cause the evaluation
 * if (cachedValue) {
 *     // This will cause the evaluation to occur and the result will be cached
 *     theValue = cachedValue.v;
 * }
 *
 * // Accessing the value again will not cause the re-evaluation to occur, it will just return the same
 * // result value again.
 * theValue === cachedValue.v;  // true
 *
 * ```
 */
function getLazy$1(cb) {
    var lazyValue = {};
    _fetchLazyTestHooks$1 && _fetchLazyTestHooks$1();
    lazyValue.b = _globalLazyTestHooks$1.lzy;
    objDefineProp$1(lazyValue, "v", {
        configurable: true,
        get: function () {
            var result = cb();
            if (!_globalLazyTestHooks$1.lzy) {
                // Just replace the value
                objDefineProp$1(lazyValue, "v", {
                    value: result
                });
                if (lazyValue.b) {
                    delete lazyValue.b;
                }
            }
            if (_globalLazyTestHooks$1.lzy && lazyValue.b !== _globalLazyTestHooks$1.lzy) {
                lazyValue.b = _globalLazyTestHooks$1.lzy;
            }
            return result;
        }
    });
    return lazyValue;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Create and return an readonly {@link ILazyValue} instance which will cache and return the value returned
 * by the callback function. The callback function will only be called once, multiple access of the value
 * does not cause re-execution of the callback as the result from the first call is cached internally.
 * If the callback throws the default value will be returned.
 * @since 0.9.5
 * @group Lazy
 * @group Safe
 * @param cb - The callback function to fetch the value to be lazily evaluated and cached
 * @param defValue - The default value to return when an exception is thrown
 * @returns A new readonly {@link ILazyValue} instance which wraps the callback and will be used to cache
 * the result of the callback
 * @example
 * ```ts
 * // This does not cause the evaluation to occur
 * let cachedValue = safeGetLazy(() => callSomeExpensiveFunctionWhichMightThrow(), "someDefaultValue");
 * let theValue;
 *
 * // Just checking if there is an object still does not cause the evaluation
 * if (cachedValue) {
 *     // This will cause the evaluation to occur and the result will be cached
 *     theValue = cachedValue.v;
 * }
 *
 * // Accessing the value again will not cause the re-evaluation to occur, it will just return the same
 * // result value again.
 * theValue === cachedValue.v;  // true
 *
 * ```
 */
function safeGetLazy$1(cb, defValue) {
    return getLazy$1(function () { return safeGet$1(cb, defValue); });
}

var _cachedGlobal$1;
/**
 * Returns the current global scope object, for a normal web page this will be the current
 * window, for a Web Worker this will be current worker global scope via "self". The internal
 * implementation returns the first available instance object in the following order
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS standard)
 * - <null> (When all else fails)
 * While the return type is a Window for the normal case, not all environments will support all
 * of the properties or functions. And this caches the lookup of the global as in some environments
 * this can be an expensive operation.
 * @group Environment
 * @param useCached - [Optional] used for testing to bypass the cached lookup, when `true` this will
 * cause the cached global to be reset.
 */
var getGlobal$1 = function (useCached) {
    (!_cachedGlobal$1 || useCached === false || (_globalLazyTestHooks$1 && _globalLazyTestHooks$1.lzy && !_cachedGlobal$1.b)) && (_cachedGlobal$1 = safeGetLazy$1(_getGlobalValue$1, NULL_VALUE$1));
    return _cachedGlobal$1.v;
};

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _objCreate = ObjClass$1["create"];
/**
 * Creates an object that has the specified prototype, and that optionally contains specified properties. This helper exists to avoid adding a polyfil
 * for older browsers that do not define Object.create eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.create implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @group Object
 * @param obj Object to use as a prototype. May be null
 */
var objCreate = _objCreate || polyObjCreate;
/**
 * Creates an object that has the specified prototype, and that optionally contains specified properties. This helper exists to avoid adding a polyfil
 * for older browsers that do not define Object.create eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.create implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @group Polyfill
 * @group Object
 * @param obj Object to use as a prototype. May be null
 */
function polyObjCreate(obj) {
    if (!obj) {
        return {};
    }
    var type = typeof obj;
    if (type !== OBJECT$1 && type !== FUNCTION$1) {
        throw new TypeError("Prototype must be an Object or function: " + dumpObj$1(obj));
    }
    function tempFunc() { }
    tempFunc[PROTOTYPE$1] = obj;
    return new tempFunc();
}

// Copyright (c) Microsoft Corporation. All rights reserved.
// Most of these functions have been directly shamelessly "lifted" from the https://github.com/@microsoft/tslib and
// modified to be ES5 compatible and applying several minification and tree-shaking techniques so that Application Insights
// can successfully use TypeScript "importHelpers" which imports tslib during compilation but it will use these at runtime
// Which is also why all of the functions have not been included as Application Insights currently doesn't use or require
// them.
(getGlobal$1() || {})["Symbol"];
(getGlobal$1() || {})["Reflect"];
var strHasOwnProperty = "hasOwnProperty";
var __objAssignFnImpl = function (t) {
    // tslint:disable-next-line: ban-comma-operator
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (ObjProto$2[strHasOwnProperty].call(s, p)) {
                t[p] = s[p];
            }
        }
    }
    return t;
};
var __assignFn = objAssign || __objAssignFnImpl;
// tslint:disable-next-line: only-arrow-functions
var extendStaticsFn = function (d, b) {
    extendStaticsFn = ObjClass$2["setPrototypeOf"] ||
        // tslint:disable-next-line: only-arrow-functions
        ({ __proto__: [] } instanceof Array && function (d, b) {
            d.__proto__ = b;
        }) ||
        // tslint:disable-next-line: only-arrow-functions
        function (d, b) {
            for (var p in b) {
                if (b[strHasOwnProperty](p)) {
                    d[p] = b[p];
                }
            }
        };
    return extendStaticsFn(d, b);
};
function __extendsFn(d, b) {
    if (typeof b !== strShimFunction && b !== null) {
        throwTypeError$1("Class extends value " + String(b) + " is not a constructor or null");
    }
    extendStaticsFn(d, b);
    function __() {
        this.constructor = d;
    }
    // tslint:disable-next-line: ban-comma-operator
    d[strShimPrototype] = b === null ? objCreate(b) : (__[strShimPrototype] = b[strShimPrototype], new __());
}
function __spreadArrayFn(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
        to[j] = from[i];
    }
    return to;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * Create an enum style object which has both the key => value and value => key mappings
 * @param values - The values to populate on the new object
 * @returns
 */
var createEnumStyle = createEnum;
/**
 * Create a 2 index map that maps an enum's key and value to the defined map value, X["key"] => mapValue and X[0] => mapValue.
 * Generic values
 * - E = the const enum type (typeof eRequestHeaders);
 * - V = Identifies the valid values for the keys, this should include both the enum numeric and string key of the type. The
 * resulting "Value" of each entry identifies the valid values withing the assignments.
 * @param values - The values to populate on the new object
 * @returns
 */
var createValueMap = createTypeMap;

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_TO_LOWER_CASE$2 = "toLowerCase"; // Count: 11
var _DYN_BLK_VAL = "blkVal"; // Count: 5
var _DYN_LENGTH$5 = "length"; // Count: 51
var _DYN_RD_ONLY = "rdOnly"; // Count: 4
var _DYN_NOTIFY = "notify"; // Count: 4
var _DYN_WARN_TO_CONSOLE = "warnToConsole"; // Count: 4
var _DYN_THROW_INTERNAL = "throwInternal"; // Count: 5
var _DYN_SET_DF = "setDf"; // Count: 6
var _DYN_WATCH = "watch"; // Count: 8
var _DYN_LOGGER = "logger"; // Count: 21
var _DYN_APPLY = "apply"; // Count: 7
var _DYN_PUSH$2 = "push"; // Count: 32
var _DYN_SPLICE = "splice"; // Count: 8
var _DYN_HDLR = "hdlr"; // Count: 6
var _DYN_CANCEL = "cancel"; // Count: 6
var _DYN_INITIALIZE$1 = "initialize"; // Count: 5
var _DYN_IDENTIFIER = "identifier"; // Count: 8
var _DYN_REMOVE_NOTIFICATION_0 = "removeNotificationListener"; // Count: 4
var _DYN_ADD_NOTIFICATION_LIS1 = "addNotificationListener"; // Count: 4
var _DYN_IS_INITIALIZED = "isInitialized"; // Count: 10
var _DYN_GET_NOTIFY_MGR = "getNotifyMgr"; // Count: 5
var _DYN_GET_PLUGIN = "getPlugin"; // Count: 6
var _DYN_POLL_INTERNAL_LOGS = "pollInternalLogs"; // Count: 2
var _DYN_NAME$3 = "name"; // Count: 12
var _DYN_TIME = "time"; // Count: 6
var _DYN_PROCESS_NEXT = "processNext"; // Count: 15
var _DYN_GET_PROCESS_TEL_CONT2 = "getProcessTelContext"; // Count: 2
var _DYN_ENABLED = "enabled"; // Count: 6
var _DYN_STOP_POLLING_INTERNA3 = "stopPollingInternalLogs"; // Count: 2
var _DYN_UNLOAD = "unload"; // Count: 9
var _DYN_ON_COMPLETE = "onComplete"; // Count: 5
var _DYN_VERSION$1 = "version"; // Count: 6
var _DYN_LOGGING_LEVEL_CONSOL4 = "loggingLevelConsole"; // Count: 2
var _DYN_CREATE_NEW$1 = "createNew"; // Count: 7
var _DYN_TEARDOWN = "teardown"; // Count: 9
var _DYN_MESSAGE_ID = "messageId"; // Count: 4
var _DYN_MESSAGE$2 = "message"; // Count: 7
var _DYN_IS_ASYNC = "isAsync"; // Count: 6
var _DYN_DIAG_LOG$2 = "diagLog"; // Count: 10
var _DYN__DO_TEARDOWN = "_doTeardown"; // Count: 5
var _DYN_UPDATE$1 = "update"; // Count: 6
var _DYN_GET_NEXT = "getNext"; // Count: 12
var _DYN_SET_NEXT_PLUGIN = "setNextPlugin"; // Count: 5
var _DYN_PROTOCOL = "protocol"; // Count: 3
var _DYN_USER_AGENT = "userAgent"; // Count: 5
var _DYN_SPLIT$1 = "split"; // Count: 7
var _DYN_NODE_TYPE = "nodeType"; // Count: 3
var _DYN_REPLACE = "replace"; // Count: 9
var _DYN_LOG_INTERNAL_MESSAGE = "logInternalMessage"; // Count: 2
var _DYN_TYPE = "type"; // Count: 14
var _DYN_HANDLER = "handler"; // Count: 5
var _DYN_STATUS$1 = "status"; // Count: 5
var _DYN_GET_RESPONSE_HEADER = "getResponseHeader"; // Count: 2
var _DYN_GET_ALL_RESPONSE_HEA5 = "getAllResponseHeaders"; // Count: 2
var _DYN_IS_CHILD_EVT = "isChildEvt"; // Count: 3
var _DYN_DATA$1 = "data"; // Count: 7
var _DYN_GET_CTX = "getCtx"; // Count: 6
var _DYN_SET_CTX = "setCtx"; // Count: 10
var _DYN_COMPLETE = "complete"; // Count: 3
var _DYN_ITEMS_RECEIVED$1 = "itemsReceived"; // Count: 3
var _DYN_URL_STRING = "urlString"; // Count: 5
var _DYN_SEND_POST = "sendPOST"; // Count: 3
var _DYN_HEADERS$1 = "headers"; // Count: 5
var _DYN_TIMEOUT = "timeout"; // Count: 6
var _DYN_SET_REQUEST_HEADER$1 = "setRequestHeader"; // Count: 2
var _DYN_TRACE_ID$2 = "traceId"; // Count: 5
var _DYN_SPAN_ID$1 = "spanId"; // Count: 5
var _DYN_TRACE_FLAGS$1 = "traceFlags"; // Count: 6

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var aggregationErrorType;
/**
 * Throws an Aggregation Error which includes all of the errors that led to this error occurring
 * @param message - The message describing the aggregation error (the sourceError details are added to this)
 * @param sourceErrors - An array of the errors that caused this situation
 */
function throwAggregationError(message, sourceErrors) {
    if (!aggregationErrorType) {
        aggregationErrorType = createCustomError("AggregationError", function (self, args) {
            if (args[_DYN_LENGTH$5 /* @min:%2elength */] > 1) {
                // Save the provided errors
                self.errors = args[1];
            }
        });
    }
    var theMessage = message || "One or more errors occurred.";
    arrForEach$1(sourceErrors, function (srcError, idx) {
        theMessage += "\n".concat(idx, " > ").concat(dumpObj$2(srcError));
    });
    throw new aggregationErrorType(theMessage, sourceErrors || []);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
// These constants are currently NOT exported directly, we may export them later associated with a frozen namespace (maybe)
// For now do NOT expect that we will export these values.
var UNDEF_VALUE = undefined;
var NULL_VALUE = null;
var EMPTY = "";
var FUNCTION = "function";
var NUMBER = "number";
var OBJECT = "object";
var PROTOTYPE = "prototype";
var UNDEFINED = "undefined";
var SYMBOL = "Symbol";
var POLYFILL_TAG = "_polyfill";
var LENGTH = "length";
var VALUE = "value";
var SLICE = "slice";
/**
 * @ignore
 */
var ObjClass = Object;
/**
 * @ignore
 */
var ObjProto = ObjClass[PROTOTYPE];
/**
 * @ignore
 */
var StrCls = String;
/**
 * @ignore
 */
var ArrCls = Array;
/**
 * @ignore
 */
var ArrProto = ArrCls[PROTOTYPE];

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Function to safely execute a callback function, if the function throws the provided default
 * value will be returned.
 * @since 0.9.5
 * @group Safe
 * @param cb - Callback function be wrapped with an exception
 * @param defValue - The default value to return when an exception is thrown
 * @returns The result of the callback function or the default if an exception occurred calling the callback
 * function.
 * @example
 * ```ts
 * let theExpression = "{ invalid: json value";
 *
 * let result = safeGet(() => {
 *     return JSON.parse(theExpression);
 * }, {});
 *
 * // result === {};
 * ```
 */
function safeGet(cb, defValue) {
    var result = defValue;
    try {
        result = cb();
    }
    catch (e) {
        // Do nothing
    }
    return result;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @ignore
 * @internal
 * Create and returns a function that will return `true` if the argument passed
 * to it matches the provided type.
 * @param theType - The type to match against the `typeof value`
 * @returns A function which takes a single argument and returns a boolean
 */
function _createIs(theType) {
    return function (value) {
        return typeof value === theType;
    };
}
/**
 * @ignore
 * @internal
 * Create and returns a function that will return `true` if the argument passed
 * to it matches the object type specified based on {@link objToString}.
 * @param - The object name to match for the `objToString(value)`
 * @returns A function which takes a single argument and returns a boolean
 */
function _createObjIs(theName) {
    var theType = "[object " + theName + "]";
    return function (value) {
        return !!(value && objToString(value) === theType);
    };
}
/**
 * The `objToString()` method returns a string representing the object. This explicitly
 * always calls the `Object.prototype.toString()` method.
 *
 * An object's toString() method is most commonly invoked when that object undergoes:
 * - explicit type conversion to a string (for example, String(myObject))
 * - implicit type coercion into a string (for example, myObject + "hello world")
 *
 * @group Object
 * @param value - The object to be converted into a string
 * @returns A string representation of the object
 * @example
 * ```ts
 * objToString(new Date()); // [object Date]
 * objToString(new String()); // [object String]
 *
 * // Math has its Symbol.toStringTag
 * objToString(Math); // [object Math]
 *
 * objToString(undefined); // [object Undefined]
 * objToString(null); // [object Null]
 * ```
 */
function objToString(value) {
    return ObjProto.toString.call(value);
}
/**
 * Checks if the provided value is undefined or contains the string value "undefined",
 * if you want to consider the string value as undefined see {@link isStrictUndefined}
 * @group Type Identity
 * @group Value Check
 * @param value - The value to check
 * @returns true if the value is undefined or "undefined", otherwise false
 * @example
 * ```ts
 * isUndefined(undefined);              // true
 * isUndefined("undefined");            // true
 *
 * isUndefined(null);                   // false
 * isUndefined("null");                 // false
 * isUndefined("1");                    // false
 * isUndefined("aa");                   // false
 * isUndefined(new Date());             // false
 * isUndefined(1);                      // false
 * isUndefined("");                     // false
 * isUndefined(_dummyFunction);         // false
 * isUndefined([]);                     // false
 * isUndefined(new Array(1));           // false
 * isUndefined(true);                   // false
 * isUndefined(false);                  // false
 * isUndefined("true");                 // false
 * isUndefined("false");                // false
 * isUndefined(new Boolean(true));      // false
 * isUndefined(new Boolean(false));     // false
 * isUndefined(new Boolean("true"));    // false
 * isUndefined(new Boolean("false"));   // false
 * isUndefined(Boolean(true));          // false
 * isUndefined(Boolean(false));         // false
 * isUndefined(Boolean("true"));        // false
 * isUndefined(Boolean("false"));       // false
 * isUndefined(new RegExp(""));         // false
 * isUndefined(new ArrayBuffer(0));     // false
 * isUndefined(new Error("Test Error"));// false
 * isUndefined(new TypeError("Test TypeError"));    // false
 * isUndefined(new TestError("Test TestError"));    // false
 * isUndefined(_dummyError());          // false
 * isUndefined(Promise.reject());       // false
 * isUndefined(Promise.resolve());      // false
 * isUndefined(new Promise(() => {}));  // false
 * isUndefined(_simplePromise());       // false
 * isUndefined(_simplePromiseLike());   // false
 * isUndefined(Object.create(null));    // false
 * isUndefined(polyObjCreate(null));    // false
 * ```
 */
function isUndefined(value) {
    return typeof value === UNDEFINED || value === UNDEFINED;
}
/**
 * Checks if the provided value is null, undefined or contains the string value of "undefined".
 * @group Type Identity
 * @group Value Check
 * @param value - The value to check
 * @returns `true` if the value is `null` or `undefined`
 * @example
 * ```ts
 * isNullOrUndefined(null);         // true
 * isNullOrUndefined(undefined);    // true
 * isNullOrUndefined("undefined");  // true
 *
 * let value = null;
 * isNullOrUndefined(value);        // true
 * let value = undefined;
 * isNullOrUndefined(value);        // true
 *
 * isNullOrUndefined("");           // false
 * isNullOrUndefined(0);            // false
 * isNullOrUndefined(new Date());   // false
 * isNullOrUndefined(true);         // false
 * isNullOrUndefined(false);        // false
 * ```
 */
function isNullOrUndefined(value) {
    return value === NULL_VALUE || isUndefined(value);
}
/**
 * Checks to see if the past value is a function value
 * @group Type Identity
 * @param value - The value to check
 * @returns
 * @example
 * ```ts
 * function myFunction() { }
 * isFunction(null);            // false
 * isFunction(undefined);       // false
 * isFunction("null");          // false
 * isFunction("undefined");     // false
 * isFunction("1");             // false
 * isFunction("aa");            // false
 * isFunction(new Date());      // false
 * isFunction(1);               // false
 * isFunction("");              // false
 * isFunction(myFunction);      // true
 * isFunction([]);              // false
 * isFunction(new Array(1));    // false
 * ```
 */
var isFunction$1 = _createIs(FUNCTION);
/**
 * Checks to see if the past value is an object value
 * @group Type Identity
 * @group Object
 * @typeParam T - The object type, defaults to any
 * @param value - The value to check
 * @returns
 */
function isObject$1(value) {
    if (!value && isNullOrUndefined(value)) {
        return false;
    }
    return !!value && typeof value === OBJECT;
}
/**
 * Checks if the type of value is an Array.
 *
 * @group Type Identity
 * @group Array
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a Array, false otherwise.
 * @example
 * ```ts
 * import { isArray, isObject } from "@nevware21/ts-utils";
 *
 * function performAction(value: any) {
 *     if (isArray(value) || isObject(value)) {
 *         // Do something
 *     } else {
 *         // Do something else
 *     }
 * }
 * ```
 */
var isArray = ArrCls.isArray;
/**
 * Checks if the type of value is a number.
 * @group Type Identity
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a number, false otherwise.
 */
var isNumber = _createIs(NUMBER);
/**
 * Checks if the type of value is a Error object.
 * @group Type Identity
 * @group Error
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a Error, false otherwise.
 */
var isError = _createObjIs("Error");
/**
 * Checks if the type of value is a PromiseLike instance (contains a then function).
 * @group Type Identity
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a PromiseLike, false otherwise.
 */
function isPromiseLike(value) {
    return !!value && isFunction$1(value.then);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The objGetOwnPropertyDescriptor() method returns an object describing the configuration of a specific property on
 * a given object (that is, one directly present on an object and not in the object's prototype chain). The object
 * returned is mutable but mutating it has no effect on the original property's configuration.
 * @since 0.4.3
 * @group Object
 * @param target - Object that contains the property.
 * @param prop - Name of the property.
 * @returns A property descriptor of the given property if it exists on the object, otherwise undefined.
 *
 * @example
 * ```ts
 * o = {};
 * objDefineProp(o, 'qux', {
 *   value: 8675309,
 *   writable: false,
 *   enumerable: false
 * });
 * d = objGetOwnPropertyDescriptor(o, 'qux');
 * // d is {
 * //   value: 8675309,
 * //   writable: false,
 * //   enumerable: false,
 * //   configurable: false
 * // }
 *
 * objGetOwnPropertyDescriptor('foo', 0);
 * // TypeError: "foo" is not an object  // ES5 code
 *
 * objGetOwnPropertyDescriptor('foo', 0);
 * // Object returned by ES2015 code: {
 * //   configurable: false,
 * //   enumerable: true,
 * //   value: "f",
 * //   writable: false
 * // }
 * ```
 * Note: In ES5, if the first argument to this method is not an object (a primitive), then it will cause a TypeError. In ES2015, a non-object first argument will be coerced to an object at first.
 */
var objGetOwnPropertyDescriptor = ObjClass.getOwnPropertyDescriptor;

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The objHasOwnProperty() method returns a boolean indicating whether the object
 * has the specified property as its own property (as opposed to inheriting it).
 *
 * The objHasOwnProperty() method returns true if the specified property is a direct
 * property of the object — even if the value is null or undefined. The method returns
 * false if the property is inherited, or has not been declared at all. Unlike the in
 * operator, this method does not check for the specified property in the object's
 * prototype chain.
 *
 * The method can be called on most JavaScript objects, because most objects descend
 * from Object, and hence inherit its methods. For example Array is an Object, so you
 * can use objHasOwnProperty() method to check whether an index exists:
 * @group Object
 * @param obj - The object being evaluated
 * @param prop - The String or Symbol of the property to test
 * @returns `true` if the object has the specified property as own property; otherwise `false`
 * @example
 * ```ts
 * let example = {};
 * objHasOwnProperty(example, 'prop');   // false
 *
 * example.prop = 'exists';
 * objHasOwnProperty(example, 'prop');   // true - 'prop' has been defined
 *
 * example.prop = null;
 * objHasOwnProperty(example, 'prop');   // true - own property exists with value of null
 *
 * example.prop = undefined;
 * objHasOwnProperty(example, 'prop');   // true - own property exists with value of undefined
 * ```
 */
function objHasOwnProperty(obj, prop) {
    return obj && ObjProto.hasOwnProperty.call(obj, prop);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The objHasOwn() method returns a boolean indicating whether the object
 * has the specified property as its own property (as opposed to inheriting it).
 * If the property is inherited, or does not exist, the method returns false.
 *
 * The objHasOwn() method returns true if the specified property is a direct property
 * of the object — even if the property value is null or undefined. The method returns
 * false if the property is inherited, or has not been declared at all. Unlike the in operator,
 * this method does not check for the specified property in the object's prototype chain.
 *
 * It is recommended over {@link objHasOwnProperty} () because it works for objects created using
 * objCreate(null) and with objects that have overridden the inherited hasOwnProperty() method.
 * While it is possible to workaround these problems by calling Object.prototype.hasOwnProperty()
 * on an external object, Object.hasOwn() is more intuitive.
 *
 * @since 0.4.3
 * @group Object
 * @param obj - The object being evaluated
 * @param prop - The String or Symbol of the property to test
 * @returns `true` if the object has the specified property as own property; otherwise `false`
 * @example
 * ```ts
 * let example = {};
 * objHasOwn(example, 'prop');   // false
 *
 * example.prop = 'exists';
 * objHasOwn(example, 'prop');   // true - 'prop' has been defined
 *
 * example.prop = null;
 * objHasOwn(example, 'prop');   // true - own property exists with value of null
 *
 * example.prop = undefined;
 * objHasOwn(example, 'prop');   // true - own property exists with value of undefined
 * ```
 */
var objHasOwn = ObjClass["hasOwn"] || polyObjHasOwn;
/**
 * The polyObjHasOwn() method is a polyfill for {@link objHasOwn} when the native
 * [Object.hasOwnreturns](https://caniuse.com/?search=hasOwn) is not supported, it returns a
 * boolean indicating whether the object has the specified property as its own property (as
 * opposed to inheriting it). If the property is inherited, or does not exist, the method
 * returns false.
 *
 * The objHasOwn() method returns true if the specified property is a direct property
 * of the object — even if the property value is null or undefined. The method returns
 * false if the property is inherited, or has not been declared at all. Unlike the in operator,
 * this method does not check for the specified property in the object's prototype chain.
 *
 * It is recommended over objHasOwnProperty() because it works for objects created using
 * objCreate(null) and with objects that have overridden the inherited hasOwnProperty() method.
 * While it is possible to workaround these problems by calling Object.prototype.hasOwnProperty()
 * on an external object, Object.hasOwn() is more intuitive.
 *
 * @since 0.4.3
 * @group Object
 * @group Polyfill
 * @param obj - The object being evaluated
 * @param prop - The String or Symbol of the property to test
 * @returns `true` if the object has the specified property as own property; otherwise `false`
 * @example
 * ```ts
 * let example = {};
 * polyObjHasOwn(example, 'prop');   // false
 *
 * example.prop = 'exists';
 * polyObjHasOwn(example, 'prop');   // true - 'prop' has been defined
 *
 * example.prop = null;
 * polyObjHasOwn(example, 'prop');   // true - own property exists with value of null
 *
 * example.prop = undefined;
 * polyObjHasOwn(example, 'prop');   // true - own property exists with value of undefined
 * ```
 */
function polyObjHasOwn(obj, prop) {
    return objHasOwnProperty(obj, prop) || !!objGetOwnPropertyDescriptor(obj, prop);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Calls the provided `callbackFn` function once for each key in an object. This is equivelent to `arrForEach(Object.keys(theObject), callbackFn)` or
 * if not using the array helper `Object.keys(theObject).forEach(callbackFn)` except that this helper avoid creating a temporary of the object
 * keys before iterating over them and like the `arrForEach` helper you CAN stop or break the iteration by returning -1 from the `callbackFn` function.
 * @group Object
 * @typeParam T - The object type
 * @param callbackfn  A function that accepts up to two arguments, the key name and the current value of the property represented by the key.
 * @param thisArg  [Optional] An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, null or undefined
 * the object will be used as the this value.
 * @example
 * ```ts
 * function performAction<T>(target: T, source: any) {
 *    if (!isNullOrUndefined(source)) {
 *        objForEachKey(source, (key, value) => {
 *            // Set the target with a reference to the same value with the same name
 *            target[key] = value;
 *        });
 *    }
 *
 *    return target;
 * }
 * ```
 */
function objForEachKey(theObject, callbackfn, thisArg) {
    if (theObject && isObject$1(theObject)) {
        for (var prop in theObject) {
            if (objHasOwn(theObject, prop)) {
                if (callbackfn.call(thisArg || theObject, prop, theObject[prop]) === -1) {
                    break;
                }
            }
        }
    }
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @internal
 * @ignore
 * Internal Helper function to create a key and value mapped representation of the values
 * @param values - The source values
 * @param keyType - Identifies the value to populate against the key
 * @param valueType - Identifies the value to populate against the value
 * @param completeFn - The function to call to complete the map (used to freeze the instance)
 * @returns
 */
function _createKeyValueMap(values, keyType, valueType, completeFn) {
    var theMap = {};
    objForEachKey(values, function (key, value) {
        theMap[key] = keyType ? value : key;
        theMap[value] = valueType ? value : key;
    });
    return completeFn(theMap);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Throw a type error with the specified optional message
 * @group Error
 * @param message
 */
function throwTypeError(message) {
    throw new TypeError(message);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _objFreeze = ObjClass["freeze"];
var _doNothing = function (value) { return value; };
/**
 * Perform a deep freeze on the object and all of it's contained values / properties by recursively calling
 * `objFreeze()` on all enumerable properties of the object and on each property returned.
 * @group Object
 * @param value - the object to be completly frozen.
 * @returns The originally passed in object.
 */
function objDeepFreeze(value) {
    if (_objFreeze) {
        objForEachKey(value, function (key, value) {
            if (isArray(value) || isObject$1(value)) {
                _objFreeze(value);
            }
        });
    }
    return objFreeze(value);
}
/**
 * The `objFreeze()` method freezes an object. A frozen object can no longer be changed; freezing an object
 * prevents new properties from being added to it, existing properties from being removed, prevents changing the
 * enumerability, configurability, or writability of existing properties, and prevents the values of existing
 * properties from being changed. In addition, freezing an object also prevents its prototype from being changed.
 * `objFreeze()` returns the same object that was passed in.
 *
 * Nothing can be added to or removed from the properties set of a frozen object. Any attempt to do so will fail,
 * either silently or by throwing a TypeError exception (most commonly, but not exclusively, when in strict mode).
 *
 * For data properties of a frozen object, values cannot be changed, the writable and configurable attributes are
 * set to false. Accessor properties (getters and setters) work the same (and still give the illusion that you are
 * changing the value). Note that values that are objects can still be modified, unless they are also frozen. As
 * an object, an array can be frozen; after doing so, its elements cannot be altered and no elements can be added
 * to or removed from the array.
 *
 * `objFreeze()` returns the same object that was passed into the function. It does not create a frozen copy.
 * @group Object
 * @param value - The object to freeze.
 * @returns The object that was passed to the function.
 */
var objFreeze = _objFreeze || _doNothing;

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Create a map object which contains both the property key and value which both map to the key,
 * E[key] => key and E[value] => key.
 * @group Enum
 * @example
 * ```ts
 * const enum Animal {
 *    Dog = 0,
 *    Cat = 1,
 *    Butterfly = 2,
 *    Bear = 3
 * }
 * const animalMap = createEnumKeyMap<typeof Animal>({
 *    Dog: Animal.Dog,
 *    Cat: Animal.Cat,
 *    Butterfly: Animal.Butterfly,
 *    Bear: Animal.Bear
 * });
 * // You end up with an object that maps everything to the name
 * animalMap.Dog === "Dog";         // true
 * animalMap[0] === "Dog";          // true
 * animalMap["Dog"] === "Dog";      // true
 * animalMap.Cat === "Cat";         // true
 * animalMap[1] === "Cat";          // true
 * animalMap["Cat"] === "Cat";      // true
 * // Helper function to always return the "Name" of the type of animal
 * function getAnimalType(type: string | number | Animal) {
 *     return animalMap[type];
 * }
 * ```
 * @param values - The values to populate on the new object
 * @typeParam E - Identifies the const enum type being mapped
 * @returns A new frozen (immutable) object which contains a property for each key and value that returns the value.
 */
function createEnumKeyMap(values) {
    return _createKeyValueMap(values, 0 /* eMapValues.Key */, 0 /* eMapValues.Key */, objDeepFreeze);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @ignore
 * @internal
 */
var _wellKnownSymbolMap = createEnumKeyMap({
    asyncIterator: 0 /* WellKnownSymbols.asyncIterator */,
    hasInstance: 1 /* WellKnownSymbols.hasInstance */,
    isConcatSpreadable: 2 /* WellKnownSymbols.isConcatSpreadable */,
    iterator: 3 /* WellKnownSymbols.iterator */,
    match: 4 /* WellKnownSymbols.match */,
    matchAll: 5 /* WellKnownSymbols.matchAll */,
    replace: 6 /* WellKnownSymbols.replace */,
    search: 7 /* WellKnownSymbols.search */,
    species: 8 /* WellKnownSymbols.species */,
    split: 9 /* WellKnownSymbols.split */,
    toPrimitive: 10 /* WellKnownSymbols.toPrimitive */,
    toStringTag: 11 /* WellKnownSymbols.toStringTag */,
    unscopables: 12 /* WellKnownSymbols.unscopables */
});

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The asString() method returns a string representing the value by
 * explicitly using `String(`value`)`.
 *
 * @since 0.4.3
 * @group String
 * @group Conversion
 * @group Value
 * @param value - The value to get a string representation of
 * @example
 * ```ts
 * const arr = [ 1, 2, 3];
 * asString(arr);       // "1,2,3"
 * asString(null);      // "null"
 * asString(undefined); // "undefined"
 * asString(42);        // "42"
 * asString(Symbol.for("Hello"));   // "Symbol(Hello)"
 * ```
 */
var asString = StrCls;

var GLOBAL_CONFIG_KEY = "__tsUtils$gblCfg";
var _globalCfg;
/**
 * @internal
 * @ignore
 * Helper to get the current global value
 * @returns
 */
function _getGlobalValue() {
    var result;
    if (typeof globalThis !== UNDEFINED) {
        result = globalThis;
    }
    if (!result && typeof self !== UNDEFINED) {
        result = self;
    }
    if (!result && typeof window !== UNDEFINED) {
        result = window;
    }
    if (!result && typeof global$1 !== UNDEFINED) {
        result = global$1;
    }
    return result;
}
/**
 * @internal
 * @ignore
 * Gets/Sets the named value from the global config store, this is used to share configuration across
 * multiple modules. Primarily used for poly symbol and test hooks.
 * @returns The globally registered value.
 */
function _getGlobalConfig() {
    if (!_globalCfg) {
        var gbl = _getGlobalValue() || {};
        _globalCfg = gbl[GLOBAL_CONFIG_KEY] = gbl[GLOBAL_CONFIG_KEY] || {};
    }
    return _globalCfg;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Returns string representation of an object suitable for diagnostics logging.
 * @group Error
 * @group Diagnostic
 * @param object - The object to be converted to a diagnostic string value
 * @param format - Identifies whether the JSON value should be formated
 * - `true` - Format with 4 spaces
 * - 'number' - The number of spaces to format with
 * - `false` (or not Truthy) - Do not format
 */
function dumpObj(object, format) {
    var propertyValueDump = EMPTY;
    if (isError(object)) {
        propertyValueDump = "{ stack: '" + object.stack + "', message: '" + object.message + "', name: '" + object.name + "'";
    }
    else {
        try {
            propertyValueDump = JSON.stringify(object, NULL_VALUE, format ? (isNumber(format) ? format : 4) : UNDEF_VALUE);
        }
        catch (e) {
            // Unable to convert object (probably circular)
            propertyValueDump = " - " + dumpObj(e, format);
        }
    }
    return objToString(object) + ": " + propertyValueDump;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _arrSlice = ArrProto[SLICE];
var _throwMissingFunction = function (funcName, thisArg) {
    throwTypeError("'" + asString(funcName) + "' not defined for " + dumpObj(thisArg));
};
/**
 * @internal
 * @ignore
 * Internal helper to run the named function on the passed first argument, this does not support polyfill
 * or prototype fallback, so the function must exist on the provided first argument.
 * If the first argument is null, undefined or the function does not exist an exception will be thrown
 * by the runtime
 * @param funcName - The function name to call on the first argument passed to the wrapped function
 * @returns A function which will call the funcName against the first passed argument and pass on the remaining arguments
 */
var _unwrapInstFunction = function (funcName) {
    return function (thisArg) {
        return thisArg[funcName].apply(thisArg, _arrSlice.call(arguments, 1));
    };
};
/**
 * @internal
 * @ignore
 * Internal helper to convert an expanded function back into an instance `this` function call
 * @param funcName - The function name to call on the first argument passed to the wrapped function
 * @param clsProto - The Class or class prototype to fallback to if the instance doesn't have the function.
 * @returns A function which will call the funcName against the first passed argument and pass on the remaining arguments
 */
var _unwrapFunction = function (funcName, clsProto) {
    var clsFn = clsProto && clsProto[funcName];
    return function (thisArg) {
        var theFunc = (thisArg && thisArg[funcName]) || clsFn;
        if (theFunc) {
            return theFunc.apply(thisArg, _arrSlice.call(arguments, 1));
        }
        _throwMissingFunction(funcName, thisArg);
    };
};

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _wellKnownSymbolCache = {};
/**
 * Returns a new (polyfill) Symbol object for the provided description that's guaranteed to be unique.
 * Symbols are often used to add unique property keys to an object that won't collide with keys any
 * other code might add to the object, and which are hidden from any mechanisms other code will
 * typically use to access the object. That enables a form of weak encapsulation, or a weak form of
 * information hiding.
 * @group Polyfill
 * @group Symbol
 * @param description - The description of the symbol
 * @returns A new polyfill version of a Symbol object
 */
function polyNewSymbol(description) {
    var theSymbol = {
        description: asString(description),
        toString: function () { return SYMBOL + "(" + description + ")"; }
    };
    // Tag the symbol so we know it a polyfill
    theSymbol[POLYFILL_TAG] = true;
    return theSymbol;
}
/**
 * Returns the polyfill version of a well-known global symbol, this will only return
 * known values.
 * @example
 * ```ts
 * // Always returns the polyfill version, even if Symbols are supported in the runtime
 * polyGetKnownSymbol("toStringTag") === polyGetKnownSymbol("toStringTag");                // true
 * polyGetKnownSymbol(WellKnownSymbols.toStringTag) === polyGetKnownSymbol("toStringTag"); // true
 * polyGetKnownSymbol("toStringTag") !== Symbol.toStringTag;                // true
 * polyGetKnownSymbol(WellKnownSymbols.toStringTag) !== Symbol.toStringTag; // true
 * polyGetKnownSymbol("toStringTag") !== polySymbolFor("toStringTag");      // true
 * polyGetKnownSymbol(WellKnownSymbols.toStringTag) !== polySymbolFor("toStringTag"); // true
 * polyGetKnownSymbol("toStringTag") !== polyNewSymbol("toStringTag");      // true
 * polyGetKnownSymbol(WellKnownSymbols.toStringTag) !== polyNewSymbol("toStringTag"); // true
 * ```
 * @group Polyfill
 * @group Symbol
 * @param name - The property name to return (if it exists) for Symbol
 * @returns The value of the property if present
 */
function polyGetKnownSymbol(name) {
    var result;
    var knownName = _wellKnownSymbolMap[name];
    if (knownName) {
        result = _wellKnownSymbolCache[knownName] = _wellKnownSymbolCache[knownName] || polyNewSymbol(SYMBOL + "." + knownName);
    }
    return result;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @internal
 * @ignore
 * Mapping from ObjDefinePropDescriptor key to PropertyDescriptor key
 */
var propMap = {
    e: "enumerable",
    c: "configurable",
    v: VALUE,
    w: "writable",
    g: "get",
    s: "set"
};
/**
 * @internal
 * @ignore
 * Helper to convert ObjDefinePropDescriptor into PropertyDescriptor
 * @param value - The prop descriptor to convert
 * @returns
 */
function _createProp(value) {
    var prop = {};
    prop[propMap["c"]] = true;
    prop[propMap["e"]] = true;
    if (value.l) {
        // Asign a getter function to return the value when requested
        prop.get = function () { return value.l.v; };
        // If it has a setter then expose it as well
        var desc = objGetOwnPropertyDescriptor(value.l, "v");
        if (desc && desc.set) {
            prop.set = function (newValue) {
                value.l.v = newValue;
            };
        }
    }
    objForEachKey(value, function (key, value) {
        prop[propMap[key]] = isUndefined(value) ? prop[propMap[key]] : value;
    });
    return prop;
}
/**
 * Defines a new property directly on an object, or modifies an existing property on an object, and returns the object.
 * This is a wrapper for [Object.defineProperty](https://developer.mozilla.org/en-US/docs/web/javascript/reference/global_objects/object/defineproperty)
 *
 * This method allows a precise addition to or modification of a property on an object. Normal property addition through
 * assignment creates properties which show up during property enumeration (for...in loop or objKeys method), whose
 * values may be changed, and which may be deleted. This method allows these extra details to be changed from their
 * defaults. By default, properties added using objDefineProp() are not writable, not enumerable, and not configurable.
 *
 * Property descriptors present in objects come in two main flavors: data descriptors and accessor descriptors. A data
 * descriptor is a property that has a value, which may or may not be writable. An accessor descriptor is a property
 * described by a getter-setter pair of functions. A descriptor must be one of these two flavors; it cannot be both.
 *
 * This is an alias for Object.defineProperty
 * @group Object
 * @param target - The object on which to define the property.
 * @param key - The name or Symbol of the property to be defined or modified.
 * @param descriptor - The descriptor for the property being defined or modified.
 */
var objDefineProp = ObjClass["defineProperty"];
/**
 * The objDefine() method defines a new or modifies an existing single property accessors for the target object based
 * on the configuration defined for the propDesc argument of type {@link ObjDefinePropDescriptor}. This will call
 * {@link objDefineProp} after creating the required PropertyDescriptor populating defaults for the propDesc values.
 * Note, the default values (true) for `configurable` and `enumerable` are different from the defaults provided by objDefineProp.
 * @since 0.6.0
 * @group Object
 * @param target - The object on which to define the property.
 * @param key - The name of the property to be defined or modified
 * @param propDesc - An object which defines the Property Descriptor mappings for the mapping.
 * @returns The target object.
 */
function objDefine(target, key, propDesc) {
    return objDefineProp(target, key, _createProp(propDesc));
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @internal
 * Internal flag which is set by the public {@link setBypassLazyCache}, should not be externally exported
 */
var _globalLazyTestHooks;
var _fetchLazyTestHooks = function () {
    _globalLazyTestHooks = _getGlobalConfig();
    _fetchLazyTestHooks = NULL_VALUE;
};
/**
 * Create and return an readonly {@link ILazyValue} instance which will cache and return the value returned
 * by the callback function. The callback function will only be called once, multiple access of the value
 * does not cause re-execution of the callback as the result from the first call is cached internally.
 * @since 0.4.5
 * @group Lazy
 * @param cb - The callback function to fetch the value to be lazily evaluated and cached
 * @returns A new readonly {@link ILazyValue} instance which wraps the callback and will be used to cache
 * the result of the callback
 * @example
 * ```ts
 * // This does not cause the evaluation to occur
 * let cachedValue = getLazy(() => callSomeExpensiveFunction());
 * let theValue;
 *
 * // Just checking if there is an object still does not cause the evaluation
 * if (cachedValue) {
 *     // This will cause the evaluation to occur and the result will be cached
 *     theValue = cachedValue.v;
 * }
 *
 * // Accessing the value again will not cause the re-evaluation to occur, it will just return the same
 * // result value again.
 * theValue === cachedValue.v;  // true
 *
 * ```
 */
function getLazy(cb) {
    var lazyValue = {};
    _fetchLazyTestHooks && _fetchLazyTestHooks();
    lazyValue.b = _globalLazyTestHooks.lzy;
    objDefineProp(lazyValue, "v", {
        configurable: true,
        get: function () {
            var result = cb();
            if (!_globalLazyTestHooks.lzy) {
                // Just replace the value
                objDefineProp(lazyValue, "v", {
                    value: result
                });
                if (lazyValue.b) {
                    delete lazyValue.b;
                }
            }
            if (_globalLazyTestHooks.lzy && lazyValue.b !== _globalLazyTestHooks.lzy) {
                lazyValue.b = _globalLazyTestHooks.lzy;
            }
            return result;
        }
    });
    return lazyValue;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Create and return an readonly {@link ILazyValue} instance which will cache and return the value returned
 * by the callback function. The callback function will only be called once, multiple access of the value
 * does not cause re-execution of the callback as the result from the first call is cached internally.
 * If the callback throws the default value will be returned.
 * @since 0.9.5
 * @group Lazy
 * @group Safe
 * @param cb - The callback function to fetch the value to be lazily evaluated and cached
 * @param defValue - The default value to return when an exception is thrown
 * @returns A new readonly {@link ILazyValue} instance which wraps the callback and will be used to cache
 * the result of the callback
 * @example
 * ```ts
 * // This does not cause the evaluation to occur
 * let cachedValue = safeGetLazy(() => callSomeExpensiveFunctionWhichMightThrow(), "someDefaultValue");
 * let theValue;
 *
 * // Just checking if there is an object still does not cause the evaluation
 * if (cachedValue) {
 *     // This will cause the evaluation to occur and the result will be cached
 *     theValue = cachedValue.v;
 * }
 *
 * // Accessing the value again will not cause the re-evaluation to occur, it will just return the same
 * // result value again.
 * theValue === cachedValue.v;  // true
 *
 * ```
 */
function safeGetLazy(cb, defValue) {
    return getLazy(function () { return safeGet(cb, defValue); });
}

var WINDOW = "window";
var _cachedGlobal;
var _cachedWindow;
var _cachedDocument;
var _isNode;
/**
 * Create and return an readonly {@link ILazyValue} instance which will cache and return the named global
 * value if available, will return `null` if the named global object is not available or if the runtime
 * throws an exception when attempting to access the global object.
 * Unlike {@link getInst} the value is cached after the first access, so if the global value changes after
 * the initial fetch the original cached value is still returned.
 * @since 0.9.5
 * @group Environment
 * @group Lazy
 * @group Safe
 * @param name The name of the global object to get.
 * @returns A new readonly {@link ILazyValue} instance which will lazily attempt to return the globally
 * available named instance.
 * @example
 * ```ts
 * // This does not cause the evaluation to occur
 * window.myGlobal = "Hello";
 * let cachedValue = lazySafeGetInst("myGlobal");
 * // cachedValue.v === "Hello"
 *
 * window.myGlobal = "Darkness";
 * // cachedValue.v === "Hello"
 *
 * let promiseCls = lazySafeGetInst("Promise");
 * // null if Promise is not supported in the runtime
 * // otherwise the Promise class.
 * ```
 */
var lazySafeGetInst = function (name) { return safeGetLazy(function () { return getInst(name) || UNDEF_VALUE; }, UNDEF_VALUE); };
/**
 * Returns the current global scope object, for a normal web page this will be the current
 * window, for a Web Worker this will be current worker global scope via "self". The internal
 * implementation returns the first available instance object in the following order
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS standard)
 * - <null> (When all else fails)
 * While the return type is a Window for the normal case, not all environments will support all
 * of the properties or functions. And this caches the lookup of the global as in some environments
 * this can be an expensive operation.
 * @group Environment
 * @param useCached - [Optional] used for testing to bypass the cached lookup, when `true` this will
 * cause the cached global to be reset.
 */
var getGlobal = function (useCached) {
    (!_cachedGlobal || useCached === false || (_globalLazyTestHooks && _globalLazyTestHooks.lzy && !_cachedGlobal.b)) && (_cachedGlobal = safeGetLazy(_getGlobalValue, NULL_VALUE));
    return _cachedGlobal.v;
};
/**
 * Return the named global object if available, will return null if the object is not available.
 * @group Environment
 * @param name The globally named object
 * @param useCached - [Optional] used for testing to bypass the cached lookup, when `true` this will
 * cause the cached global to be reset.
 * @example
 * ```ts
 * // This does not cause the evaluation to occur
 * window.myGlobal = "Hello";
 * let cachedValue = getInst("myGlobal");
 * // cachedValue === "Hello"
 *
 * window.myGlobal = "Darkness";
 * // getInst("myGlobal") === "Darkness"
 *
 * let promiseCls = getInst("Promise");
 * // May throw if the global is not supported by the runtime
 * // otherwise the Promise class.
 * ```
 */
var getInst = function (name, useCached) {
    var gbl = (!_cachedGlobal || useCached === false) ? getGlobal(useCached) : _cachedGlobal.v;
    if (gbl && gbl[name]) {
        return gbl[name];
    }
    // Test workaround, for environments where <global>.window (when global == window) doesn't return the base window
    if (name === WINDOW && _cachedWindow) {
        // tslint:disable-next-line: no-angle-bracket-type-assertion
        return _cachedWindow.v;
    }
    return NULL_VALUE;
};
/**
 * Return the global `document` instance.
 * @group Environment
 * @returns
 */
var getDocument = function () {
    (!_cachedDocument || (_globalLazyTestHooks && _globalLazyTestHooks.lzy && !_cachedDocument.b)) && (_cachedDocument = lazySafeGetInst("document"));
    return _cachedDocument.v;
};
/**
 * Return the global `window` instance.
 * @group Environment
 * @returns
 */
var getWindow = function () {
    (!_cachedWindow || (_globalLazyTestHooks && _globalLazyTestHooks.lzy && !_cachedWindow.b)) && (_cachedWindow = lazySafeGetInst(WINDOW));
    return _cachedWindow.v;
};
/**
 * Simple method to determine if we are running in a node environment
 * @group Environment
 * @returns True if you are
 */
var isNode = function () {
    !_isNode && (_isNode = safeGetLazy(function () { return !!(process$1 && (process$1.versions || {}).node); }, false));
    return _isNode.v;
};

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _symbol;
var _symbolFor;
var _symbolKeyFor;
function _getSymbolValue(name) {
    return safeGetLazy(function () {
        return (_symbol.v ? _symbol.v[name] : UNDEF_VALUE);
    }, UNDEF_VALUE);
}
/**
 * Helper to identify whether the runtime support the Symbols either via native or an installed polyfill
 * @group Symbol
 * @returns true if Symbol's are support otherwise false
 */
function hasSymbol() {
    return !!getSymbol();
}
/**
 * If Symbols are supported then attempt to return the named Symbol
 * @group Symbol
 * @returns The value of the named Symbol (if available)
 */
function getSymbol() {
    var resetCache = !_symbol || (_globalLazyTestHooks && _globalLazyTestHooks.lzy && !_symbol.b);
    resetCache && (_symbol = lazySafeGetInst(SYMBOL));
    (!_symbolFor || resetCache) && (_symbolFor = _getSymbolValue("for"));
    (!_symbolKeyFor || resetCache) && (_symbolKeyFor = _getSymbolValue("keyFor"));
    return _symbol.v;
}
/**
 * If Symbols are supported then get the property of the global Symbol, if Symbol's are
 * not supported and noPoly is true it returns null. Used to access the well known symbols.
 * @group Symbol
 * @param name - The property name to return (if it exists) for Symbol
 * @param noPoly - Flag indicating whether to return a polyfill if symbols are not supported.
 * @returns The value of the property if present
 * @example
 * ```ts
 * // If Symbol is supported in the runtime
 * getKnownSymbol("toStringTag") === Symbol.toStringTag;                // true
 * getKnownSymbol(WellKnownSymbols.toStringTag) === Symbol.toStringTag; // true
 * ```
 */
function getKnownSymbol(name, noPoly) {
    var knownName = _wellKnownSymbolMap[name];
    // Cause lazy symbol to get initialized
    (!_symbol || (_globalLazyTestHooks.lzy && !_symbol.b)) && getSymbol();
    return _symbol.v ? _symbol.v[knownName || name] : (!noPoly ? polyGetKnownSymbol(name) : UNDEF_VALUE);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2023 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The `fnApply` function calls the specified `fn` function with the given `thisArg` as the `this` value,
 * and the optional `argArray` arguments provided as an array (or an Array-Like Object).
 *
 * Normally, when calling a function, the value of `this` inside the function is the object that the
 * function was accessed on. With `fnApply()`, you can assign an arbitrary value as this when calling an
 * existing function, without first attaching the function to the object as a property. This allows you
 * to use methods of one object as generic utility functions.
 *
 * You can also use any kind of object which is ArrayLike as the second parameter. In practice, this means
 * that it needs to have a length property, and integer ("index") properties in the range (0..length - 1).
 * For example, you could use a NodeList, or a custom object like `{ 'length': 2, '0': 'eat', '1': 'bananas' }`.
 * You can also use `arguments`.
 *
 * @since 0.9.8
 * @group Function
 *
 * @param fn - The function to be called
 * @param thisArg - The value of `this` provided for the call to `fn`. If the function is not in strict mode,
 * `null` and `undefined` will be replaced with the global object, and primitive values will be converted to objects.
 * @param argArray - An array-like object, specifying the arguments with which `fn` should be called, or `null` or
 * `undefined` if no arguments should be provided to the function.
 * @returns The result of calling the function with the specified `this` value and arguments.
 * @example
 * ```ts
 * // min / max number in an array
 * let max = fnApply(Math.max, null, [ 21, 42, 84, 168, 7, 3 ]);
 * // 168
 *
 * let min = fnApply(Math.min, null, [ 21, 42, 84, 168, 7, 3 ]);
 * // 3
 *
 * const module1 = {
 *     prefix: "Hello",
 *     x: 21,
 *     getX() {
 *         return this.x;
 *     },
 *     log(value: string) {
 *         return this.prefix + " " + value + " : " + this.x
 *     }
 * };
 *
 * // The 'this' parameter of 'getX' is bound to 'module'.
 * module1.getX(); // 21
 * module1.log("Darkness"); // Hello Darkness : 21
 *
 * // Create a new function 'boundGetX' with the 'this' parameter bound to 'module'.
 * let module2 = {
 *     prefix: "my",
 *     x: 42
 * };
 *
 * // Call the function of module1 with module2 as it's this
 * fnApply(module1.getX, module2); // 42
 * fnApply(module1.log, module2, [ "friend" ]); // my friend : 42
 * ```
 */
var fnApply = _unwrapInstFunction("apply");

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Calls the provided `callbackFn` function once for each element in an array in ascending index order. It is not invoked for index properties
 * that have been deleted or are uninitialized. And unlike the ES6 forEach() you CAN stop or break the iteration by returning -1 from the
 * `callbackFn` function.
 *
 * The range (number of elements) processed by arrForEach() is set before the first call to the `callbackFn`. Any elements added beyond the range
 * or elements which as assigned to indexes already processed will not be visited by the `callbackFn`.
 * @group Array
 * @group ArrayLike
 * @typeParam T - Identifies the element type of the array
 * @param theArray - The array or array like object of elements to be searched.
 * @param callbackfn A `synchronous` function that accepts up to three arguments. arrForEach calls the callbackfn function one time for each element in the array.
 * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, null or undefined
 * the array will be used as the this value.
 * @remarks
 * arrForEach expects a `synchronous` function.
 * arrForEach does not wait for promises. Make sure you are aware of the implications while using promises (or async functions) as forEach callback.
 * @example
 * ```ts
 * const items = ['item1', 'item2', 'item3'];
 * const copyItems = [];
 *
 * // before using for loop
 * for (let i = 0; i < items.length; i++) {
 *   copyItems.push(items[i]);
 * }
 *
 * // before using forEach()
 * items.forEach((item) => {
 *   copyItems.push(item);
 * });
 *
 * // after
 * arrForEach(items, (item) => {
 *   copyItems.push(item);
 *   // May return -1 to abort the iteration
 * });
 *
 * // Also supports input as an array like object
 * const items = { length: 3, 0: 'item1', 1: 'item2', 2: 'item3' };
 * ```
 */
function arrForEach(theArray, callbackfn, thisArg) {
    if (theArray) {
        var len = theArray[LENGTH] >>> 0;
        for (var idx = 0; idx < len; idx++) {
            if (idx in theArray) {
                if (callbackfn.call(thisArg || theArray, theArray[idx], idx, theArray) === -1) {
                    break;
                }
            }
        }
    }
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The arrSlice() method returns a shallow copy of a portion of an array into a new array object
 * selected from start to end (end not included) where start and end represent the index of items
 * in that array. The original array will not be modified.
 *
 * The `arrSlice()` method is a copying method. It does not alter this but instead returns a shallow
 * copy that contains some of the same elements as the ones from the original array.
 *
 * The `arrSlice()` method preserves empty slots. If the sliced portion is sparse, the returned arra
 * is sparse as well.
 *
 * The `arrSlice()` method is generic. It only expects the this value to have a length property and
 * integer-keyed properties.
 *
 * For both start and end, a negative index can be used to indicate an offset from the end of the array.
 * For example, -2 refers to the second to last element of the array.
 * @since 0.9.3
 * @group Array
 * @group ArrayLike
 * @param start Zero-based index at which to start extraction, converted to an integer.
 * - Negative index counts back from the end of the array — if start < 0, start + array.length is used.
 * - If start < -array.length or start is omitted, 0 is used.
 * - If start >= array.length, nothing is extracted.
 * @param end Zero-based index at which to end extraction, converted to an integer. slice() extracts
 * up to but not including end.
 * - Negative index counts back from the end of the array — if end < 0, end + array.length is used.
 * - If end < -array.length, 0 is used.
 * - If end >= array.length or end is omitted, array.length is used, causing all elements until the
 * end to be extracted.
 * - If end is positioned before or at start after normalization, nothing is extracted.
 * @example
 * ```ts
 * const lyrics = ["Hello", "Darkness", "my", "old", "friend.", "I've", "come", "to", "talk" ];
 *
 * arrSlice(lyrics);        // [ "Hello", "Darkness", "my", "old", "friend.", "I've", "come", "to", "talk" ]
 * arrSlice(lyrics, 1, 3);  // [ "Darkness", "my" ]
 * arrSlicw(lyrics, 2);     // [ "my", "old", "friend.", "I've", "come", "to", "talk" ]
 * arrSlice(lyrics, 2, 4);  // [ "my", "old" ]
 * arrSlice(lyrics, 1, 5);  // [ "Darkness", "my", "old", "friend." ]
 * arrSlice(lyrics, -2);    // [ "to", "talk" ]
 * arrSlice(lyrics, 2, -1); // [ "my", "old", "friend.", "I've", "come", "to" ]
 * ```
 */
var arrSlice = _unwrapFunction(SLICE, ArrProto);

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var REF = "ref";
var UNREF = "un" + REF;
var HAS_REF = "hasRef";
var ENABLED = "enabled";
/**
 * @ignore
 * @internal
 * Internal function to create and manage an ITimerHandler implementation, the object returned from this function
 * it directly used / returned by the pulic functions used to create timers (idle, interval and timeout)
 * @param startTimer - Should the timer be started as part of creating the handler
 * @param refreshFn - The function used to create/start or refresh the timer
 * @param cancelFn - The function used to cancel the timer.
 * @returns The new ITimerHandler instance
 */
function _createTimerHandler(startTimer, refreshFn, cancelFn) {
    var _a;
    var ref = true;
    var timerId = startTimer ? refreshFn(NULL_VALUE) : NULL_VALUE;
    var theTimerHandler;
    var _unref = function () {
        ref = false;
        timerId && timerId[UNREF] && timerId[UNREF]();
        return theTimerHandler;
    };
    var _ref = function () {
        ref = true;
        timerId && timerId[REF] && timerId[REF]();
        return theTimerHandler;
    };
    var _hasRef = function () {
        if (timerId && timerId[HAS_REF]) {
            return timerId[HAS_REF]();
        }
        return ref;
    };
    var _refresh = function () {
        timerId = refreshFn(timerId);
        if (!ref) {
            _unref();
        }
        return theTimerHandler;
    };
    var _cancel = function () {
        timerId && cancelFn(timerId);
        timerId = NULL_VALUE;
    };
    var _setEnabled = function (value) {
        !value && timerId && _cancel();
        value && !timerId && _refresh();
    };
    theTimerHandler = (_a = {
            cancel: _cancel,
            refresh: _refresh
        },
        _a[HAS_REF] = _hasRef,
        _a[REF] = _ref,
        _a[UNREF] = _unref,
        _a[ENABLED] = false,
        _a);
    objDefineProp(theTimerHandler, ENABLED, {
        get: function () { return !!timerId; },
        set: _setEnabled
    });
    return {
        h: theTimerHandler,
        dn: function () {
            timerId = NULL_VALUE;
        }
    };
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
function _createTimeoutWith(self, startTimer, overrideFn, theArgs) {
    var isArr = isArray(overrideFn);
    var len = isArr ? overrideFn.length : 0;
    var setFn = (len > 0 ? overrideFn[0] : (!isArr ? overrideFn : UNDEF_VALUE)) || setTimeout;
    var clearFn = (len > 1 ? overrideFn[1] : UNDEF_VALUE) || clearTimeout;
    var timerFn = theArgs[0];
    theArgs[0] = function () {
        handler.dn();
        fnApply(timerFn, self, arrSlice(arguments));
    };
    var handler = _createTimerHandler(startTimer, function (timerId) {
        if (timerId) {
            if (timerId.refresh) {
                timerId.refresh();
                return timerId;
            }
            fnApply(clearFn, self, [timerId]);
        }
        return fnApply(setFn, self, theArgs);
    }, function (timerId) {
        fnApply(clearFn, self, [timerId]);
    });
    return handler.h;
}
function scheduleTimeout(callback, timeout) {
    return _createTimeoutWith(this, true, UNDEF_VALUE, arrSlice(arguments));
}

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Helper to coallesce the promise resolved / reject into a single callback to simplify error handling.
 * @group Await Helper
 * @param value - The value or promise like value to wait to be resolved or rejected.
 * @param cb - The callback function to call with the resulting value, if the value is not a
 * promise like value then the callback is called synchronously, if the value is a promise then
 * the callback will be called once the promise completes the resulting value will be passed as an
 * IAwaitResponse instance, it will be called whether any promise resolves or rejects.
 * @returns The value returned by the `cb` callback function, if the value is a promise then the return value
 * of the callback will be returned as a promise whether the callback returns a promise or not.
 * @example
 * ```ts
 * let promise = createPromise<number>((resolve, reject) => {
 *     resolve(42);
 * });
 *
 * // Handle via doAwaitResponse
 * doAwaitResponse(promise, (value) => {
 *     if (!value.rejected) {
 *          // Do something with the value
 *     } else {
 *         // Do something with the reason
 *     }
 * });
 *
 * // It can also handle the raw value, so you could process the result of either a
 * // synchrounous return of the value or a Promise
 * doAwaitResponse(42, (value) => {
 *     if (!value.rejected) {
 *         // Do something with the value
 *     } else {
 *        // This will never be true as the value is not a promise
 *     }
 * });
 * ```
 */
function doAwaitResponse(value, cb) {
    return doAwait(value, function (value) {
        return cb ? cb({
            value: value,
            rejected: false
        }) : value;
    }, function (reason) {
        return cb ? cb({
            rejected: true,
            reason: reason
        }) : reason;
    });
}
/**
 * Wait for the promise to resolve or reject, if resolved the callback function will be called with it's value and if
 * rejected the rejectFn will be called with the reason. If the passed promise argument is not a promise the callback
 * will be called synchronously with the value.
 * @group Await Helper
 * @param value - The value or promise like value to wait for
 * @param resolveFn - The callback to call on the promise successful resolving.
 * @param rejectFn - The callback to call when the promise rejects
 * @returns The passed value, if it is a promise and there is either a resolve or reject handler
 * then it will return a chained promise with the value from the resolve or reject handler (depending
 * whether it resolve or rejects)
 * @example
 * ```ts
 * let promise = createPromise<number>((resolve, reject) => {
 *     resolve(42);
 * });
 *
 * // Handle via a chained promise
 * let chainedPromise = promise.then((value) => {
 *     // Do something with the value
 * });
 *
 * // Handle via doAwait
 * doAwait(promise, (value) => {
 *     // Do something with the value
 * });
 *
 * // It can also handle the raw value, so you could process the result of either a
 * // synchrounous return of the value or a Promise
 * doAwait(42, (value) => {
 *     // Do something with the value
 * });
 * ```
 */
function doAwait(value, resolveFn, rejectFn, finallyFn) {
    var result = value;
    if (isPromiseLike(value)) {
        if (resolveFn || rejectFn) {
            result = value.then(resolveFn, rejectFn);
        }
    }
    else {
        if (resolveFn) {
            result = resolveFn(value);
        }
    }
    if (finallyFn) {
        doFinally(result, finallyFn);
    }
    return result;
}
/**
 * Wait for the promise to resolve or reject and then call the finallyFn. If the passed promise argument is not a promise the callback
 * will be called synchronously with the value. If the passed promise doesn't implement finally then a finally implementation will be
 * simulated using then(..., ...).
 * @group Await Helper
 * @param value - The value or promise like value to wait for
 * @param finallyFn - The finally function to call once the promise has resolved or rejected
 */
function doFinally(value, finallyFn) {
    var result = value;
    if (finallyFn) {
        if (isPromiseLike(value)) {
            if (value.finally) {
                result = value.finally(finallyFn);
            }
            else {
                // Simulate finally if not available
                result = value.then(function (value) {
                    finallyFn();
                    return value;
                }, function (reason) {
                    finallyFn();
                    throw reason;
                });
            }
        }
        else {
            finallyFn();
        }
    }
    return result;
}

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _debugState;
var _debugResult;
var _debugHandled;
/**
 * @internal
 * @ignore
 */
var _promiseDebugEnabled = false;
/**
 * @internal
 * @ignore
 * Internal function to add the debug state to the promise so that it provides simular visibility as you would
 * see from native promises
 * @param thePromise - The Promise implementation
 * @param stateFn - The function to return the state of the promise
 * @param resultFn - The function to return the result (settled value) of the promise
 * @param handledFn - The function to return whether the promise has been handled (used for throwing
 * unhandled rejection events)
 */
function _addDebugState(thePromise, stateFn, resultFn, handledFn) {
    // While the IPromise implementations provide a `state` property, keeping the `[[PromiseState]]`
    // as native promises also have a non-enumerable property of the same name
    _debugState = _debugState || { toString: function () { return "[[PromiseState]]"; } };
    _debugResult = _debugResult || { toString: function () { return "[[PromiseResult]]"; } };
    _debugHandled = _debugHandled || { toString: function () { return "[[PromiseIsHandled]]"; } };
    objDefineProp(thePromise, _debugState, { get: stateFn });
    objDefineProp(thePromise, _debugResult, { get: resultFn });
    objDefineProp(thePromise, _debugHandled, { get: handledFn });
}

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @ignore -- Don't include in the generated documentation
 * @internal
 */
var STRING_STATES = [
    "pending", "resolving", "resolved", "rejected"
];

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var DISPATCH_EVENT = "dispatchEvent";
var _hasInitEvent;
/**
 * @internal
 * @ignore
 * @param target
 * @param evtName
 * @param populateEvent
 * @param useNewEvent
 */
function emitEvent(target, evtName, populateEvent, useNewEvent) {
    var doc = getDocument();
    !_hasInitEvent && (_hasInitEvent = safeGetLazy(function () {
        var evt;
        if (doc && doc.createEvent) {
            evt = doc.createEvent("Event");
        }
        return (!!evt && evt.initEvent);
    }, null));
    var theEvt = _hasInitEvent.v ? doc.createEvent("Event") : (useNewEvent ? new Event(evtName) : {});
    populateEvent && populateEvent(theEvt);
    if (_hasInitEvent.v) {
        theEvt.initEvent(evtName, false, true);
    }
    if (theEvt && target[DISPATCH_EVENT]) {
        target[DISPATCH_EVENT](theEvt);
    }
    else {
        var handler = target["on" + evtName];
        if (handler) {
            handler(theEvt);
        }
        else {
            var theConsole = getInst("console");
            theConsole && (theConsole["error"] || theConsole["log"])(evtName, dumpObj(theEvt));
        }
    }
}

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2023 Nevware21
 * Licensed under the MIT license.
 */
var STR_PROMISE = "Promise";

var NODE_UNHANDLED_REJECTION = "unhandledRejection";
var UNHANDLED_REJECTION = NODE_UNHANDLED_REJECTION.toLowerCase();
var _unhandledRejectionTimeout = 10;
var _hasPromiseRejectionEvent;
function dumpFnObj(value) {
    if (isFunction$1(value)) {
        return value.toString();
    }
    return dumpObj(value);
}
function _createPromise(newPromise, processor, executor) {
    var additionalArgs = arrSlice(arguments, 3);
    var _state = 0 /* ePromiseState.Pending */;
    var _hasResolved = false;
    var _settledValue;
    var _queue = [];
    var _handled = false;
    var _unHandledRejectionHandler = null;
    var _thePromise;
    !_hasPromiseRejectionEvent && (_hasPromiseRejectionEvent = lazySafeGetInst(STR_PROMISE + "RejectionEvent"));
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    var _then = function (onResolved, onRejected) {
        try {
            _handled = true;
            _unHandledRejectionHandler && _unHandledRejectionHandler.cancel();
            _unHandledRejectionHandler = null;
            //#ifdef DEBUG
            //#:(!DEBUG) _debugLog(_toString(), "then(" + dumpFnObj(onResolved)+ ", " + dumpFnObj(onResolved) +  ")");
            //#endif
            var thenPromise = newPromise(function (resolve, reject) {
                // Queue the new promise returned to be resolved or rejected
                // when this promise settles.
                _queue.push(function () {
                    // https://tc39.es/ecma262/#sec-newpromisereactionjob
                    //let value: any;
                    try {
                        // First call the onFulfilled or onRejected handler, on the settled value
                        // of this promise. If the corresponding `handler` does not exist, simply
                        // pass through the settled value.
                        //#ifdef DEBUG
                        //#:(!DEBUG) _debugLog(_toString(), "Handling settled value " + dumpFnObj(_settledValue));
                        //#endif
                        var handler = _state === 2 /* ePromiseState.Resolved */ ? onResolved : onRejected;
                        var value = isUndefined(handler) ? _settledValue : (isFunction$1(handler) ? handler(_settledValue) : handler);
                        //#ifdef DEBUG
                        //#:(!DEBUG) _debugLog(_toString(), "Handling Result " + dumpFnObj(value));
                        //#endif
                        if (isPromiseLike(value)) {
                            // The called handlers returned a new promise, so the chained promise
                            // will follow the state of this promise.
                            value.then(resolve, reject);
                        }
                        else if (handler) {
                            // If we have a handler then chained promises are always "resolved" with the result returned
                            resolve(value);
                        }
                        else if (_state === 3 /* ePromiseState.Rejected */) {
                            // If this promise is rejected then the chained promise should be rejected
                            // with either the settled value of this promise or the return value of the handler.
                            reject(value);
                        }
                        else {
                            // If this promise is fulfilled, then the chained promise is also fulfilled
                            // with either the settled value of this promise or the return value of the handler.
                            resolve(value);
                        }
                    }
                    catch (e) {
                        reject(e);
                    }
                });
                //#ifdef DEBUG
                //#:(!DEBUG) _debugLog(_toString(), "Added to Queue " + _queue.length);
                //#endif
                // If this promise is already settled, then immediately process the callback we
                // just added to the queue.
                if (_hasResolved) {
                    _processQueue();
                }
            }, additionalArgs);
            //#ifdef DEBUG
            //#:(!DEBUG) _debugLog(_toString(), "Created -> " + thenPromise.toString());
            //#endif
            return thenPromise;
        }
        finally {
        }
    };
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    var _catch = function (onRejected) {
        // Reuse then onRejected to support rejection
        return _then(undefined, onRejected);
    };
    // https://tc39.es/ecma262/#sec-promise.prototype.finally
    var _finally = function (onFinally) {
        var thenFinally = onFinally;
        var catchFinally = onFinally;
        if (isFunction$1(onFinally)) {
            thenFinally = function (value) {
                onFinally && onFinally();
                return value;
            };
            catchFinally = function (reason) {
                onFinally && onFinally();
                throw reason;
            };
        }
        return _then(thenFinally, catchFinally);
    };
    var _strState = function () {
        return STRING_STATES[_state];
    };
    var _processQueue = function () {
        if (_queue.length > 0) {
            // The onFulfilled and onRejected handlers must be called asynchronously. Thus,
            // we make a copy of the queue and work on it once the current call stack unwinds.
            var pending = _queue.slice();
            _queue = [];
            //#ifdef DEBUG
            //#:(!DEBUG) _debugLog(_toString(), "Processing queue " + pending.length);
            //#endif
            _handled = true;
            processor(pending);
            //#ifdef DEBUG
            //#:(!DEBUG) _debugLog(_toString(), "Processing done");
            //#endif
            _unHandledRejectionHandler && _unHandledRejectionHandler.cancel();
            _unHandledRejectionHandler = null;
        }
    };
    var _createSettleIfFn = function (newState, allowState) {
        return function (theValue) {
            if (_state === allowState) {
                if (newState === 2 /* ePromiseState.Resolved */ && isPromiseLike(theValue)) {
                    _state = 1 /* ePromiseState.Resolving */;
                    //#ifdef DEBUG
                    //#:(!DEBUG) _debugLog(_toString(), "Resolving");
                    //#endif
                    theValue.then(_createSettleIfFn(2 /* ePromiseState.Resolved */, 1 /* ePromiseState.Resolving */), _createSettleIfFn(3 /* ePromiseState.Rejected */, 1 /* ePromiseState.Resolving */));
                    return;
                }
                _state = newState;
                _hasResolved = true;
                _settledValue = theValue;
                //#ifdef DEBUG
                //#:(!DEBUG) _debugLog(_toString(), _strState());
                //#endif
                _processQueue();
                if (!_handled && newState === 3 /* ePromiseState.Rejected */ && !_unHandledRejectionHandler) {
                    _unHandledRejectionHandler = scheduleTimeout(_notifyUnhandledRejection, _unhandledRejectionTimeout);
                }
            }
        };
    };
    var _notifyUnhandledRejection = function () {
        if (!_handled) {
            if (isNode()) {
                //#ifdef DEBUG
                //#:(!DEBUG) _debugLog(_toString(), "Emitting " + NODE_UNHANDLED_REJECTION);
                //#endif
                process$1.emit(NODE_UNHANDLED_REJECTION, _settledValue, _thePromise);
            }
            else {
                var gbl = getWindow() || getGlobal();
                //#ifdef DEBUG
                //#:(!DEBUG) _debugLog(_toString(), "Emitting " + UNHANDLED_REJECTION);
                //#endif
                emitEvent(gbl, UNHANDLED_REJECTION, function (theEvt) {
                    objDefine(theEvt, "promise", { g: function () { return _thePromise; } });
                    theEvt.reason = _settledValue;
                    return theEvt;
                }, !!_hasPromiseRejectionEvent.v);
            }
        }
    };
    _thePromise = {
        then: _then,
        "catch": _catch,
        finally: _finally
    };
    objDefineProp(_thePromise, "state", {
        get: _strState
    });
    if (_promiseDebugEnabled) {
        // eslint-disable-next-line brace-style
        _addDebugState(_thePromise, _strState, function () { return objToString(_settledValue); }, function () { return _handled; });
    }
    if (hasSymbol()) {
        _thePromise[getKnownSymbol(11 /* WellKnownSymbols.toStringTag */)] = "IPromise";
    }
    var _toString = function () {
        return "IPromise" + ("") + " " + _strState() + (_hasResolved ? (" - " + dumpFnObj(_settledValue)) : "");
    };
    _thePromise.toString = _toString;
    (function _initialize() {
        if (!isFunction$1(executor)) {
            throwTypeError(STR_PROMISE + ": executor is not a function - " + dumpFnObj(executor));
        }
        var _rejectFn = _createSettleIfFn(3 /* ePromiseState.Rejected */, 0 /* ePromiseState.Pending */);
        try {
            //#ifdef DEBUG
            //#:(!DEBUG) _debugLog(_toString(), "Executing");
            //#endif
            executor.call(_thePromise, _createSettleIfFn(2 /* ePromiseState.Resolved */, 0 /* ePromiseState.Pending */), _rejectFn);
        }
        catch (e) {
            _rejectFn(e);
        }
    })();
    //#ifdef DEBUG
    //#:(!DEBUG) _debugLog(_toString(), "Returning");
    //#endif
    return _thePromise;
}
/**
 * @ignore
 * @internal
 * Returns a function which when called will return a new Promise object that resolves to an array of the
 * results from the input promises. The returned promise will resolve when all of the inputs' promises have
 * resolved, or if the input contains no promises. It rejects immediately upon any of the input promises
 * rejected or non-promises throwing an error, and will reject with this first rejection message / error.
 * @param newPromise - The delegate function used to create a new promise object the new promise instance.
 * @returns A function to create a promise that will be resolved when all arguments are resolved.
 */
function _createAllPromise(newPromise) {
    return function (input) {
        var additionalArgs = arrSlice(arguments, 1);
        return newPromise(function (resolve, reject) {
            try {
                var values_1 = [];
                var pending_1 = 1; // Prefix to 1 so we finish iterating over all of the input promises first
                arrForEach(input, function (item, idx) {
                    if (item) {
                        pending_1++;
                        doAwait(item, function (value) {
                            // Set the result values
                            values_1[idx] = value;
                            if (--pending_1 === 0) {
                                resolve(values_1);
                            }
                        }, reject);
                    }
                });
                // Now decrement the pending so that we finish correctly
                pending_1--;
                if (pending_1 === 0) {
                    // All promises were either resolved or where not a promise
                    resolve(values_1);
                }
            }
            catch (e) {
                reject(e);
            }
        }, additionalArgs);
    };
}

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _processPendingItems = function (pending) {
    arrForEach(pending, function (fn) {
        try {
            fn();
        }
        catch (e) {
            // Don't let 1 failing handler break all others
            // TODO: Add some form of error reporting (i.e. Call any registered JS error handler so the error is reported)
        }
    });
};
/**
 * @internal
 * @ignore
 * Return an item processor that processes all of the pending items asynchronously using the optional timeout.
 * @param timeout - Optional timeout to wait before processing the items, defaults to zero.
 * @return An item processor
 */
function timeoutItemProcessor(timeout) {
    var callbackTimeout = isNumber(timeout) ? timeout : 0;
    return function (pending) {
        scheduleTimeout(function () {
            _processPendingItems(pending);
        }, callbackTimeout);
    };
}

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Creates an asynchronous Promise instance that when resolved or rejected will execute it's pending chained operations
 * __asynchronously__ using the optional provided timeout value to schedule when the chained items will be ececuted.
 * @group Async
 * @group Promise
 * @param executor - The function to be executed during the creation of the promise. Any errors thrown in the executor will
 * cause the promise to be rejected. The return value of the executor is always ignored
 * @param timeout - Optional timeout to wait before processing the items, defaults to zero.
 */
function createAsyncPromise(executor, timeout) {
    return _createPromise(createAsyncPromise, timeoutItemProcessor(timeout), executor, timeout);
}

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _isPromiseSupported;
/**
 * Creates a Promise instance that when resolved or rejected will execute it's pending chained operations using the
 * available native Promise implementation.
 * If runtime does not support native `Promise` class (or no polyfill is available) this function will fallback to using
 * `createAsyncPromise` which will resolve them __asynchronously__ using the optional provided timeout value to
 * schedule when the chained items will be executed.
 * @group Alias
 * @group Promise
 * @group Native
 * @param executor - The function to be executed during the creation of the promise. Any errors thrown in the executor will
 * cause the promise to be rejected. The return value of the executor is always ignored
 * @param timeout - Optional timeout to wait before processing the items, defaults to zero.
 */
function createNativePromise(executor, timeout) {
    !_isPromiseSupported && (_isPromiseSupported = lazySafeGetInst(STR_PROMISE));
    var PrmCls = _isPromiseSupported.v;
    if (!PrmCls) {
        return createAsyncPromise(executor);
    }
    if (!isFunction$1(executor)) {
        throwTypeError(STR_PROMISE + ": executor is not a function - " + dumpObj(executor));
    }
    var _state = 0 /* ePromiseState.Pending */;
    function _strState() {
        return STRING_STATES[_state];
    }
    var thePromise = new PrmCls(function (resolve, reject) {
        function _resolve(value) {
            _state = 2 /* ePromiseState.Resolved */;
            resolve(value);
        }
        function _reject(reason) {
            _state = 3 /* ePromiseState.Rejected */;
            reject(reason);
        }
        executor(_resolve, _reject);
    });
    objDefineProp(thePromise, "state", {
        get: _strState
    });
    return thePromise;
}

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _promiseCreator;
/**
 * Creates a Promise instance using the current default promise creator that when resolved or rejected will execute
 * it's pending chained operations.
 * @group Alias
 * @group Promise
 * @param executor - The function to be executed during the creation of the promise. Any errors thrown in the executor will
 * cause the promise to be rejected. The return value of the executor is always ignored
 * @param timeout - [Optional] timeout to wait before processing the items, defaults to zero.
 */
function createPromise(executor, timeout) {
    !_promiseCreator && (_promiseCreator = getLazy(function () { return createNativePromise; }));
    return _promiseCreator.v.call(this, executor, timeout);
}
/**
 * Returns a single asynchronous Promise instance that resolves to an array of the results from the input promises.
 * This returned promise will resolve and execute it's pending chained operations __asynchronously__ using the optional
 * provided timeout value to schedule when the chained items will be executed, or if the input contains no promises.
 * It rejects immediately upon any of the input promises rejected or non-promises throwing an error,
 * and will reject with this first rejection message / error.
 * If the runtime doesn't support the Promise.all it will fallback back to an asynchronous Promise implementation.
 * @group Alias
 * @group All
 * @param input - The array of promises to wait to be resolved / rejected before resolving or rejecting the new promise
 * @param timeout
 * @returns
 * <ul>
 * <li> An already resolved `Promise`, if the input passed is empty.
 * <li> A pending `Promise` in all other cases. This returned promise is then resolved/rejected __synchronously__
 * (as soon as the pending items is empty) when all the promises in the given input have resolved, or if any of the
 * promises reject.
 * </ul>
 */
var createAllPromise = _createAllPromise(createPromise);

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
var UNDEFINED_VALUE$2 = undefined;
var STR_EMPTY$1 = "";
var STR_CHANNELS = "channels";
var STR_CORE = "core";
var STR_CREATE_PERF_MGR = "createPerfMgr";
var STR_DISABLED = "disabled";
var STR_EXTENSION_CONFIG = "extensionConfig";
var STR_EXTENSIONS = "extensions";
var STR_PROCESS_TELEMETRY = "processTelemetry";
var STR_PRIORITY = "priority";
var STR_EVENTS_SENT = "eventsSent";
var STR_EVENTS_DISCARDED = "eventsDiscarded";
var STR_EVENTS_SEND_REQUEST = "eventsSendRequest";
var STR_PERF_EVENT = "perfEvent";
var STR_OFFLINE_STORE = "offlineEventsStored";
var STR_OFFLINE_SENT = "offlineBatchSent";
var STR_OFFLINE_DROP = "offlineBatchDrop";
var STR_GET_PERF_MGR = "getPerfMgr";
var STR_DOMAIN = "domain";
var STR_PATH = "path";
var STR_NOT_DYNAMIC_ERROR = "Not dynamic - ";

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
// RESTRICT and AVOID circular dependencies you should not import other contained modules or export the contents of this file directly
// Added to help with minification
var strGetPrototypeOf = "getPrototypeOf";
var rCamelCase = /-([a-z])/g;
var rNormalizeInvalid = /([^\w\d_$])/g;
var rLeadingNumeric = /^(\d+[\w\d_$])/;
var _getObjProto = Object[strGetPrototypeOf];
function isNotNullOrUndefined(value) {
    return !isNullOrUndefined$1(value);
}
/**
 * Validates that the string name conforms to the JS IdentifierName specification and if not
 * normalizes the name so that it would. This method does not identify or change any keywords
 * meaning that if you pass in a known keyword the same value will be returned.
 * This is a simplified version
 * @param name - The name to validate
 */
function normalizeJsName(name) {
    var value = name;
    if (value && isString$2(value)) {
        // CamelCase everything after the "-" and remove the dash
        value = value[_DYN_REPLACE /* @min:%2ereplace */](rCamelCase, function (_all, letter) {
            return letter.toUpperCase();
        });
        value = value[_DYN_REPLACE /* @min:%2ereplace */](rNormalizeInvalid, "_");
        value = value[_DYN_REPLACE /* @min:%2ereplace */](rLeadingNumeric, function (_all, match) {
            return "_" + match;
        });
    }
    return value;
}
/**
 * A simple wrapper (for minification support) to check if the value contains the search string.
 * @param value - The string value to check for the existence of the search value
 * @param search - The value search within the value
 */
function strContains(value, search) {
    if (value && search) {
        return strIndexOf(value, search) !== -1;
    }
    return false;
}
/**
 * Convert a date to I.S.O. format in IE8
 */
function toISOString(date) {
    return date && date.toISOString() || "";
}
/**
 * Returns the name of object if it's an Error. Otherwise, returns empty string.
 */
function getExceptionName(object) {
    if (isError$2(object)) {
        return object[_DYN_NAME$3 /* @min:%2ename */];
    }
    return STR_EMPTY$1;
}
/**
 * Sets the provided value on the target instance using the field name when the provided chk function returns true, the chk
 * function will only be called if the new value is no equal to the original value.
 * @param target - The target object
 * @param field - The key of the target
 * @param value - The value to set
 * @param valChk - [Optional] Callback to check the value that if supplied will be called check if the new value can be set
 * @param srcChk - [Optional] Callback to check to original value that if supplied will be called if the new value should be set (if allowed)
 * @returns The existing or new value, depending what was set
 */
function setValue(target, field, value, valChk, srcChk) {
    var theValue = value;
    if (target) {
        theValue = target[field];
        if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
            theValue = value;
            target[field] = theValue;
        }
    }
    return theValue;
}
/**
 * Returns the current value from the target object if not null or undefined otherwise sets the new value and returns it
 * @param target - The target object to return or set the default value
 * @param field - The key for the field to set on the target
 * @param defValue - [Optional] The value to set if not already present, when not provided a empty object will be added
 */
function getSetValue(target, field, defValue) {
    var theValue;
    if (target) {
        theValue = target[field];
        if (!theValue && isNullOrUndefined$1(theValue)) {
            // Supports having the default as null
            theValue = !isUndefined$1(defValue) ? defValue : {};
            target[field] = theValue;
        }
    }
    else {
        // Expanded for performance so we only check defValue if required
        theValue = !isUndefined$1(defValue) ? defValue : {};
    }
    return theValue;
}
function _createProxyFunction(source, funcName) {
    var srcFunc = null;
    var src = null;
    if (isFunction$2(source)) {
        srcFunc = source;
    }
    else {
        src = source;
    }
    return function () {
        // Capture the original arguments passed to the method
        var originalArguments = arguments;
        if (srcFunc) {
            src = srcFunc();
        }
        if (src) {
            return src[funcName][_DYN_APPLY /* @min:%2eapply */](src, originalArguments);
        }
    };
}
/**
 * Effectively assigns all enumerable properties (not just own properties) and functions (including inherited prototype) from
 * the source object to the target, it attempts to use proxy getters / setters (if possible) and proxy functions to avoid potential
 * implementation issues by assigning prototype functions as instance ones
 *
 * This method is the primary method used to "update" the snippet proxy with the ultimate implementations.
 *
 * Special ES3 Notes:
 * Updates (setting) of direct property values on the target or indirectly on the source object WILL NOT WORK PROPERLY, updates to the
 * properties of "referenced" object will work (target.context.newValue = 10 => will be reflected in the source.context as it's the
 * same object). ES3 Failures: assigning target.myProp = 3 -> Won't change source.myProp = 3, likewise the reverse would also fail.
 * @param target - The target object to be assigned with the source properties and functions
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param chkSet - An optional callback to determine whether a specific property/function should be proxied
 */
function proxyAssign(target, source, chkSet) {
    if (target && source && isObject$2(target) && isObject$2(source)) {
        var _loop_1 = function (field) {
            if (isString$2(field)) {
                var value = source[field];
                if (isFunction$2(value)) {
                    if (!chkSet || chkSet(field, true, source, target)) {
                        // Create a proxy function rather than just copying the (possible) prototype to the new object as an instance function
                        target[field] = _createProxyFunction(source, field);
                    }
                }
                else if (!chkSet || chkSet(field, false, source, target)) {
                    if (objHasOwn$1(target, field)) {
                        // Remove any previous instance property
                        delete target[field];
                    }
                    objDefine$1(target, field, {
                        g: function () {
                            return source[field];
                        },
                        s: function (theValue) {
                            source[field] = theValue;
                        }
                    });
                }
            }
        };
        // effectively apply/proxy full source to the target instance
        for (var field in source) {
            _loop_1(field);
        }
    }
    return target;
}
/**
 * Creates a proxy function on the target which internally will call the source version with all arguments passed to the target method.
 *
 * @param target - The target object to be assigned with the source properties and functions
 * @param name - The function name that will be added on the target
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param theFunc - The function name on the source that will be proxied on the target
 * @param overwriteTarget - If `false` this will not replace any pre-existing name otherwise (the default) it will overwrite any existing name
 */
function proxyFunctionAs(target, name, source, theFunc, overwriteTarget) {
    if (target && name && source) {
        if (overwriteTarget !== false || isUndefined$1(target[name])) {
            target[name] = _createProxyFunction(source, theFunc);
        }
    }
}
/**
 * Creates proxy functions on the target which internally will call the source version with all arguments passed to the target method.
 *
 * @param target - The target object to be assigned with the source properties and functions
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param functionsToProxy - An array of function names that will be proxied on the target
 * @param overwriteTarget - If false this will not replace any pre-existing name otherwise (the default) it will overwrite any existing name
 */
function proxyFunctions(target, source, functionsToProxy, overwriteTarget) {
    if (target && source && isObject$2(target) && isArray$1(functionsToProxy)) {
        arrForEach$1(functionsToProxy, function (theFuncName) {
            if (isString$2(theFuncName)) {
                proxyFunctionAs(target, theFuncName, source, theFuncName, overwriteTarget);
            }
        });
    }
    return target;
}
/**
 * Simpler helper to create a dynamic class that implements the interface and populates the values with the defaults.
 * Only instance properties (hasOwnProperty) values are copied from the defaults to the new instance
 * @param defaults - Simple helper
 */
function createClassFromInterface(defaults) {
    return /** @class */ (function () {
        function class_1() {
            var _this = this;
            if (defaults) {
                objForEachKey$1(defaults, function (field, value) {
                    _this[field] = value;
                });
            }
        }
        return class_1;
    }());
}
/**
 * A helper function to assist with JIT performance for objects that have properties added / removed dynamically
 * this is primarily for chromium based browsers and has limited effects on Firefox and none of IE. Only call this
 * function after you have finished "updating" the object, calling this within loops reduces or defeats the benefits.
 * This helps when iterating using for..in, objKeys() and objForEach()
 * @param theObject - The object to be optimized if possible
 */
function optimizeObject(theObject) {
    // V8 Optimization to cause the JIT compiler to create a new optimized object for looking up the own properties
    // primarily for object with <= 19 properties for >= 20 the effect is reduced or non-existent
    if (theObject && objAssign) {
        theObject = ObjClass$2(objAssign({}, theObject));
    }
    return theObject;
}
function objExtend(obj1, obj2, obj3, obj4, obj5, obj6) {
    // Variables
    var theArgs = arguments;
    var extended = theArgs[0] || {};
    var argLen = theArgs[_DYN_LENGTH$5 /* @min:%2elength */];
    var deep = false;
    var idx = 1;
    // Check for "Deep" flag
    if (argLen > 0 && isBoolean(extended)) {
        deep = extended;
        extended = theArgs[idx] || {};
        idx++;
    }
    // Handle case when target is a string or something (possible in deep copy)
    if (!isObject$2(extended)) {
        extended = {};
    }
    // Loop through each remaining object and conduct a merge
    for (; idx < argLen; idx++) {
        var arg = theArgs[idx];
        var isArgArray = isArray$1(arg);
        var isArgObj = isObject$2(arg);
        for (var prop in arg) {
            var propOk = (isArgArray && (prop in arg)) || (isArgObj && objHasOwn$1(arg, prop));
            if (!propOk) {
                continue;
            }
            var newValue = arg[prop];
            var isNewArray = void 0;
            // If deep merge and property is an object, merge properties
            if (deep && newValue && ((isNewArray = isArray$1(newValue)) || isPlainObject(newValue))) {
                // Grab the current value of the extended object
                var clone = extended[prop];
                if (isNewArray) {
                    if (!isArray$1(clone)) {
                        // We can't "merge" an array with a non-array so overwrite the original
                        clone = [];
                    }
                }
                else if (!isPlainObject(clone)) {
                    // We can't "merge" an object with a non-object
                    clone = {};
                }
                // Never move the original objects always clone them
                newValue = objExtend(deep, clone, newValue);
            }
            // Assign the new (or previous) value (unless undefined)
            if (newValue !== undefined) {
                extended[prop] = newValue;
            }
        }
    }
    return extended;
}
function isFeatureEnabled(feature, cfg) {
    var rlt = false;
    var ft = cfg && cfg.featureOptIn && cfg.featureOptIn[feature];
    if (feature && ft) {
        var mode = ft.mode;
        // NOTE: None will be considered as true
        rlt = (mode == 3 /* FeatureOptInMode.enable */) || (mode == 1 /* FeatureOptInMode.none */);
    }
    return rlt;
}
function getResponseText(xhr) {
    try {
        return xhr.responseText;
    }
    catch (e) {
        // Best effort, as XHR may throw while XDR wont so just ignore
    }
    return null;
}
function formatErrorMessageXdr(xdr, message) {
    if (xdr) {
        return "XDomainRequest,Response:" + getResponseText(xdr) || "";
    }
    return message;
}
function formatErrorMessageXhr(xhr, message) {
    if (xhr) {
        return "XMLHttpRequest,Status:" + xhr[_DYN_STATUS$1 /* @min:%2estatus */] + ",Response:" + getResponseText(xhr) || xhr.response || "";
    }
    return message;
}
function prependTransports(theTransports, newTransports) {
    if (newTransports) {
        if (isNumber$2(newTransports)) {
            theTransports = [newTransports].concat(theTransports);
        }
        else if (isArray$1(newTransports)) {
            theTransports = newTransports.concat(theTransports);
        }
    }
    return theTransports;
}
var strDisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var strWithCredentials = "withCredentials";
var strTimeout = "timeout";
/**
 * Create and open an XMLHttpRequest object
 * @param method - The request method
 * @param urlString - The url
 * @param withCredentials - Option flag indicating that credentials should be sent
 * @param disabled - Optional flag indicating that the XHR object should be marked as disabled and not tracked (default is false)
 * @param isSync - Optional flag indicating if the instance should be a synchronous request (defaults to false)
 * @param timeout - Optional value identifying the timeout value that should be assigned to the XHR request
 * @returns A new opened XHR request
 */
function openXhr(method, urlString, withCredentials, disabled, isSync, timeout) {
    if (disabled === void 0) { disabled = false; }
    if (isSync === void 0) { isSync = false; }
    function _wrapSetXhrProp(xhr, prop, value) {
        try {
            xhr[prop] = value;
        }
        catch (e) {
            // - Wrapping as depending on the environment setting the property may fail (non-terminally)
        }
    }
    var xhr = new XMLHttpRequest();
    if (disabled) {
        // Tag the instance so it's not tracked (trackDependency)
        // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
        // cause the request to fail and we no telemetry would be sent
        _wrapSetXhrProp(xhr, strDisabledPropertyName, disabled);
    }
    if (withCredentials) {
        // Some libraries require that the withCredentials flag is set "before" open and
        // - Wrapping as IE 10 has started throwing when setting before open
        _wrapSetXhrProp(xhr, strWithCredentials, withCredentials);
    }
    xhr.open(method, urlString, !isSync);
    if (withCredentials) {
        // withCredentials should be set AFTER open (https://xhr.spec.whatwg.org/#the-withcredentials-attribute)
        // And older firefox instances from 11+ will throw for sync events (current versions don't) which happens during unload processing
        _wrapSetXhrProp(xhr, strWithCredentials, withCredentials);
    }
    // Only set the timeout for asynchronous requests as
    // "Timeout shouldn't be used for synchronous XMLHttpRequests requests used in a document environment or it will throw an InvalidAccessError exception.""
    // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/timeout
    if (!isSync && timeout) {
        _wrapSetXhrProp(xhr, strTimeout, timeout);
    }
    return xhr;
}
/**
* Converts the XHR getAllResponseHeaders to a map containing the header key and value.
* @internal
*/
// tslint:disable-next-line: align
function convertAllHeadersToMap(headersString) {
    var headers = {};
    if (isString$2(headersString)) {
        var headersArray = strTrim(headersString)[_DYN_SPLIT$1 /* @min:%2esplit */](/[\r\n]+/);
        arrForEach$1(headersArray, function (headerEntry) {
            if (headerEntry) {
                var idx = headerEntry.indexOf(": ");
                if (idx !== -1) {
                    // The new spec has the headers returning all as lowercase -- but not all browsers do this yet
                    var header = strTrim(headerEntry.substring(0, idx))[_DYN_TO_LOWER_CASE$2 /* @min:%2etoLowerCase */]();
                    var value = strTrim(headerEntry.substring(idx + 1));
                    headers[header] = value;
                }
                else {
                    headers[strTrim(headerEntry)] = 1;
                }
            }
        });
    }
    return headers;
}
/**
* append the XHR headers.
* @internal
*/
function _appendHeader(theHeaders, xhr, name) {
    if (!theHeaders[name] && xhr && xhr[_DYN_GET_RESPONSE_HEADER /* @min:%2egetResponseHeader */]) {
        var value = xhr[_DYN_GET_RESPONSE_HEADER /* @min:%2egetResponseHeader */](name);
        if (value) {
            theHeaders[name] = strTrim(value);
        }
    }
    return theHeaders;
}
var STR_KILL_DURATION_HEADER = "kill-duration";
var STR_KILL_DURATION_SECONDS_HEADER = "kill-duration-seconds";
var STR_TIME_DELTA_HEADER = "time-delta-millis";
/**
* get the XHR getAllResponseHeaders.
* @internal
*/
function _getAllResponseHeaders(xhr, isOneDs) {
    var theHeaders = {};
    if (!xhr[_DYN_GET_ALL_RESPONSE_HEA5 /* @min:%2egetAllResponseHeaders */]) {
        // Firefox 2-63 doesn't have getAllResponseHeaders function but it does have getResponseHeader
        // Only call these if getAllResponseHeaders doesn't exist, otherwise we can get invalid response errors
        // as collector is not currently returning the correct header to allow JS to access these headers
        if (!!isOneDs) {
            theHeaders = _appendHeader(theHeaders, xhr, STR_TIME_DELTA_HEADER);
            theHeaders = _appendHeader(theHeaders, xhr, STR_KILL_DURATION_HEADER);
            theHeaders = _appendHeader(theHeaders, xhr, STR_KILL_DURATION_SECONDS_HEADER);
        }
    }
    else {
        theHeaders = convertAllHeadersToMap(xhr[_DYN_GET_ALL_RESPONSE_HEA5 /* @min:%2egetAllResponseHeaders */]());
    }
    return theHeaders;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * This file exists to hold environment utilities that are required to check and
 * validate the current operating environment. Unless otherwise required, please
 * only use defined methods (functions) in this class so that users of these
 * functions/properties only need to include those that are used within their own modules.
 */
var strDocumentMode = "documentMode";
var strLocation = "location";
var strConsole = "console";
var strJSON = "JSON";
var strCrypto = "crypto";
var strMsCrypto = "msCrypto";
var strReactNative = "ReactNative";
var strMsie = "msie";
var strTrident = "trident/";
var strXMLHttpRequest = "XMLHttpRequest";
var _isTrident = null;
var _navUserAgentCheck = null;
var _enableMocks = false;
var _useXDomainRequest = null;
var _beaconsSupported = null;
function _hasProperty(theClass, property) {
    var supported = false;
    if (theClass) {
        try {
            supported = property in theClass;
            if (!supported) {
                var proto = theClass[strShimPrototype];
                if (proto) {
                    supported = property in proto;
                }
            }
        }
        catch (e) {
            // Do Nothing
        }
        if (!supported) {
            try {
                var tmp = new theClass();
                supported = !isUndefined$1(tmp[property]);
            }
            catch (e) {
                // Do Nothing
            }
        }
    }
    return supported;
}
/**
 * Returns the global location object if it is present otherwise null.
 * This helper is used to access the location object without causing an exception
 * "Uncaught ReferenceError: location is not defined"
 */
function getLocation(checkForMock) {
    if (checkForMock && _enableMocks) {
        var mockLocation = getInst$1("__mockLocation");
        if (mockLocation) {
            return mockLocation;
        }
    }
    if (typeof location === strShimObject && location) {
        return location;
    }
    return getInst$1(strLocation);
}
/**
 * Returns the global console object
 */
function getConsole() {
    if (typeof console !== strShimUndefined) {
        return console;
    }
    return getInst$1(strConsole);
}
/**
 * Checks if JSON object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a history
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: JSON is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasJSON() {
    return Boolean((typeof JSON === strShimObject && JSON) || getInst$1(strJSON) !== null);
}
/**
 * Returns the global JSON object if it is present otherwise null.
 * This helper is used to access the JSON object without causing an exception
 * "Uncaught ReferenceError: JSON is not defined"
 */
function getJSON() {
    if (hasJSON()) {
        return JSON || getInst$1(strJSON);
    }
    return null;
}
/**
 * Returns the crypto object if it is present otherwise null.
 * This helper is used to access the crypto object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getCrypto() {
    return getInst$1(strCrypto);
}
/**
 * Returns the crypto object if it is present otherwise null.
 * This helper is used to access the crypto object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getMsCrypto() {
    return getInst$1(strMsCrypto);
}
/**
 * Returns whether the environment is reporting that we are running in a React Native Environment
 */
function isReactNative() {
    // If running in React Native, navigator.product will be populated
    var nav = getNavigator();
    if (nav && nav.product) {
        return nav.product === strReactNative;
    }
    return false;
}
/**
 * Identifies whether the current environment appears to be IE
 */
function isIE() {
    var nav = getNavigator();
    if (nav && (nav[_DYN_USER_AGENT /* @min:%2euserAgent */] !== _navUserAgentCheck || _isTrident === null)) {
        // Added to support test mocking of the user agent
        _navUserAgentCheck = nav[_DYN_USER_AGENT /* @min:%2euserAgent */];
        var userAgent = (_navUserAgentCheck || STR_EMPTY$1)[_DYN_TO_LOWER_CASE$2 /* @min:%2etoLowerCase */]();
        _isTrident = (strContains(userAgent, strMsie) || strContains(userAgent, strTrident));
    }
    return _isTrident;
}
/**
 * Gets IE version returning the document emulation mode if we are running on IE, or null otherwise
 */
function getIEVersion(userAgentStr) {
    if (userAgentStr === void 0) { userAgentStr = null; }
    if (!userAgentStr) {
        var navigator_1 = getNavigator() || {};
        userAgentStr = navigator_1 ? (navigator_1.userAgent || STR_EMPTY$1)[_DYN_TO_LOWER_CASE$2 /* @min:%2etoLowerCase */]() : STR_EMPTY$1;
    }
    var ua = (userAgentStr || STR_EMPTY$1)[_DYN_TO_LOWER_CASE$2 /* @min:%2etoLowerCase */]();
    // Also check for documentMode in case X-UA-Compatible meta tag was included in HTML.
    if (strContains(ua, strMsie)) {
        var doc = getDocument$1() || {};
        return Math.max(parseInt(ua[_DYN_SPLIT$1 /* @min:%2esplit */](strMsie)[1]), (doc[strDocumentMode] || 0));
    }
    else if (strContains(ua, strTrident)) {
        var tridentVer = parseInt(ua[_DYN_SPLIT$1 /* @min:%2esplit */](strTrident)[1]);
        if (tridentVer) {
            return tridentVer + 4;
        }
    }
    return null;
}
/**
 * Checks if HTML5 Beacons are supported in the current environment.
 * @param useCached - [Optional] used for testing to bypass the cached lookup, when `true` this will
 * cause the cached global to be reset.
 * @returns True if supported, false otherwise.
 */
function isBeaconsSupported(useCached) {
    if (_beaconsSupported === null || useCached === false) {
        _beaconsSupported = hasNavigator() && Boolean(getNavigator().sendBeacon);
    }
    return _beaconsSupported;
}
/**
 * Checks if the Fetch API is supported in the current environment.
 * @param withKeepAlive - [Optional] If True, check if fetch is available and it supports the keepalive feature, otherwise only check if fetch is supported
 * @returns True if supported, otherwise false
 */
function isFetchSupported(withKeepAlive) {
    var isSupported = false;
    try {
        isSupported = !!getInst$1("fetch");
        var request = getInst$1("Request");
        if (isSupported && withKeepAlive && request) {
            isSupported = _hasProperty(request, "keepalive");
        }
    }
    catch (e) {
        // Just Swallow any failure during availability checks
    }
    return isSupported;
}
function useXDomainRequest() {
    if (_useXDomainRequest === null) {
        _useXDomainRequest = (typeof XDomainRequest !== strShimUndefined);
        if (_useXDomainRequest && isXhrSupported()) {
            _useXDomainRequest = _useXDomainRequest && !_hasProperty(getInst$1(strXMLHttpRequest), "withCredentials");
        }
    }
    return _useXDomainRequest;
}
/**
 * Checks if XMLHttpRequest is supported
 * @returns True if supported, otherwise false
 */
function isXhrSupported() {
    var isSupported = false;
    try {
        var xmlHttpRequest = getInst$1(strXMLHttpRequest);
        isSupported = !!xmlHttpRequest;
    }
    catch (e) {
        // Just Swallow any failure during availability checks
    }
    return isSupported;
}
// TODO: should reuse this method for analytics plugin
function dispatchEvent(target, evnt) {
    if (target && target.dispatchEvent && evnt) {
        target.dispatchEvent(evnt);
        return true;
    }
    return false;
}
function createCustomDomEvent(eventName, details) {
    var event = null;
    var detail = { detail: details || null };
    if (isFunction$2(CustomEvent)) { // Use CustomEvent constructor when available
        event = new CustomEvent(eventName, detail);
    }
    else { // CustomEvent has no constructor in IE
        var doc = getDocument$1();
        if (doc && doc.createEvent) {
            event = doc.createEvent("CustomEvent");
            event.initCustomEvent(eventName, true, true, detail);
        }
    }
    return event;
}
function sendCustomEvent(evtName, cfg, customDetails) {
    var global = getGlobal$1();
    if (global && global.CustomEvent) {
        try {
            var details = { cfg: cfg || null, customDetails: customDetails || null };
            return dispatchEvent(global, createCustomDomEvent(evtName, details));
        }
        catch (e) {
            // eslint-disable-next-line no-empty
        }
    }
    return false;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var UInt32Mask = 0x100000000;
var MaxUInt32 = 0xffffffff;
var SEED1 = 123456789;
var SEED2 = 987654321;
// MWC based Random generator (for IE)
var _mwcSeeded = false;
var _mwcW = SEED1;
var _mwcZ = SEED2;
// Takes any integer
function _mwcSeed(seedValue) {
    if (seedValue < 0) {
        // Make sure we end up with a positive number and not -ve one.
        seedValue >>>= 0;
    }
    _mwcW = (SEED1 + seedValue) & MaxUInt32;
    _mwcZ = (SEED2 - seedValue) & MaxUInt32;
    _mwcSeeded = true;
}
function _autoSeedMwc() {
    // Simple initialization using default Math.random() - So we inherit any entropy from the browser
    // and bitwise XOR with the current milliseconds
    try {
        var now = utcNow() & 0x7fffffff;
        _mwcSeed(((Math.random() * UInt32Mask) ^ now) + now);
    }
    catch (e) {
        // Don't crash if something goes wrong
    }
}
/**
 * Generate a random value between 0 and maxValue, max value should be limited to a 32-bit maximum.
 * So maxValue(16) will produce a number from 0..16 (range of 17)
 * @param maxValue
 */
function randomValue(maxValue) {
    if (maxValue > 0) {
        return Math.floor((random32() / MaxUInt32) * (maxValue + 1)) >>> 0;
    }
    return 0;
}
/**
 * generate a random 32-bit number (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), defaults un-unsigned.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function random32(signed) {
    var value = 0;
    var c = getCrypto() || getMsCrypto();
    if (c && c.getRandomValues) {
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = c.getRandomValues(new Uint32Array(1))[0] & MaxUInt32;
    }
    if (value === 0 && isIE()) {
        // For IE 6, 7, 8 (especially on XP) Math.random is not very random
        if (!_mwcSeeded) {
            // Set the seed for the Mwc algorithm
            _autoSeedMwc();
        }
        // Don't use Math.random for IE
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = mwcRandom32() & MaxUInt32;
    }
    if (value === 0) {
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = Math.floor((UInt32Mask * Math.random()) | 0);
    }
    if (!signed) {
        // Make sure we end up with a positive number and not -ve one.
        value >>>= 0;
    }
    return value;
}
/**
 * Generate a random 32-bit number between (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), using MWC (Multiply with carry)
 * instead of Math.random() defaults to un-signed.
 * Used as a replacement random generator for IE to avoid issues with older IE instances.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function mwcRandom32(signed) {
    _mwcZ = (36969 * (_mwcZ & 0xFFFF) + (_mwcZ >> 16)) & MaxUInt32;
    _mwcW = (18000 * (_mwcW & 0xFFFF) + (_mwcW >> 16)) & MaxUInt32;
    var value = (((_mwcZ << 16) + (_mwcW & 0xFFFF)) >>> 0) & MaxUInt32 | 0;
    if (!signed) {
        // Make sure we end up with a positive number and not -ve one.
        value >>>= 0;
    }
    return value;
}
/**
 * Generate random base64 id string.
 * The default length is 22 which is 132-bits so almost the same as a GUID but as base64 (the previous default was 5)
 * @param maxLength - Optional value to specify the length of the id to be generated, defaults to 22
 */
function newId(maxLength) {
    if (maxLength === void 0) { maxLength = 22; }
    var base64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Start with an initial random number, consuming the value in reverse byte order
    var number = random32() >>> 0; // Make sure it's a +ve number
    var chars = 0;
    var result = STR_EMPTY$1;
    while (result[_DYN_LENGTH$5 /* @min:%2elength */] < maxLength) {
        chars++;
        result += base64chars.charAt(number & 0x3F);
        number >>>= 6; // Zero fill with right shift
        if (chars === 5) {
            // 5 base64 characters === 30 bits so we don't have enough bits for another base64 char
            // So add on another 30 bits and make sure it's +ve
            number = (((random32() << 2) & 0xFFFFFFFF) | (number & 0x03)) >>> 0;
            chars = 0; // We need to reset the number every 5 chars (30 bits)
        }
    }
    return result;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var version = "3.0.5";
var instanceName = "." + newId(6);
var _dataUid = 0;
// Accepts only:
//  - Node
//    - Node.ELEMENT_NODE
//    - Node.DOCUMENT_NODE
//  - Object
//    - Any
function _canAcceptData(target) {
    return target[_DYN_NODE_TYPE /* @min:%2enodeType */] === 1 || target[_DYN_NODE_TYPE /* @min:%2enodeType */] === 9 || !(+target[_DYN_NODE_TYPE /* @min:%2enodeType */]);
}
function _getCache(data, target) {
    var theCache = target[data.id];
    if (!theCache) {
        theCache = {};
        try {
            if (_canAcceptData(target)) {
                objDefine$1(target, data.id, {
                    e: false,
                    v: theCache
                });
            }
        }
        catch (e) {
            // Not all environments allow extending all objects, so just ignore the cache in those cases
        }
    }
    return theCache;
}
function createUniqueNamespace(name, includeVersion) {
    if (includeVersion === void 0) { includeVersion = false; }
    return normalizeJsName(name + (_dataUid++) + (includeVersion ? "." + version : STR_EMPTY$1) + instanceName);
}
function createElmNodeData(name) {
    var data = {
        id: createUniqueNamespace("_aiData-" + (name || STR_EMPTY$1) + "." + version),
        accept: function (target) {
            return _canAcceptData(target);
        },
        get: function (target, name, defValue, addDefault) {
            var theCache = target[data.id];
            if (!theCache) {
                if (addDefault) {
                    // Side effect is adds the cache
                    theCache = _getCache(data, target);
                    theCache[normalizeJsName(name)] = defValue;
                }
                return defValue;
            }
            return theCache[normalizeJsName(name)];
        },
        kill: function (target, name) {
            if (target && target[name]) {
                try {
                    delete target[name];
                }
                catch (e) {
                    // Just cleaning up, so if this fails -- ignore
                }
            }
        }
    };
    return data;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
function _isConfigDefaults(value) {
    return (value && isObject$2(value) && (value.isVal || value.fb || objHasOwn$1(value, "v") || objHasOwn$1(value, "mrg") || objHasOwn$1(value, "ref") || value.set));
}
function _getDefault(dynamicHandler, theConfig, cfgDefaults) {
    var defValue;
    var isDefaultValid = cfgDefaults.dfVal || isDefined$1;
    // There is a fallback config key so try and grab that first
    if (theConfig && cfgDefaults.fb) {
        var fallbacks = cfgDefaults.fb;
        if (!isArray$1(fallbacks)) {
            fallbacks = [fallbacks];
        }
        for (var lp = 0; lp < fallbacks[_DYN_LENGTH$5 /* @min:%2elength */]; lp++) {
            var fallback = fallbacks[lp];
            var fbValue = theConfig[fallback];
            if (isDefaultValid(fbValue)) {
                defValue = fbValue;
            }
            else if (dynamicHandler) {
                // Needed to ensure that the fallback value (and potentially) new field is also dynamic even if null/undefined
                fbValue = dynamicHandler.cfg[fallback];
                if (isDefaultValid(fbValue)) {
                    defValue = fbValue;
                }
                // Needed to ensure that the fallback value (and potentially) new field is also dynamic even if null/undefined
                dynamicHandler.set(dynamicHandler.cfg, asString$1(fallback), fbValue);
            }
            if (isDefaultValid(defValue)) {
                // We have a valid default so break out of the look
                break;
            }
        }
    }
    // If the value is still not defined and we have a default value then use that
    if (!isDefaultValid(defValue) && isDefaultValid(cfgDefaults.v)) {
        defValue = cfgDefaults.v;
    }
    return defValue;
}
/**
 * Recursively resolve the default value
 * @param dynamicHandler
 * @param theConfig
 * @param cfgDefaults
 * @returns
 */
function _resolveDefaultValue(dynamicHandler, theConfig, cfgDefaults) {
    var theValue = cfgDefaults;
    if (cfgDefaults && _isConfigDefaults(cfgDefaults)) {
        theValue = _getDefault(dynamicHandler, theConfig, cfgDefaults);
    }
    if (theValue) {
        if (_isConfigDefaults(theValue)) {
            theValue = _resolveDefaultValue(dynamicHandler, theConfig, theValue);
        }
        var newValue_1;
        if (isArray$1(theValue)) {
            newValue_1 = [];
            newValue_1[_DYN_LENGTH$5 /* @min:%2elength */] = theValue[_DYN_LENGTH$5 /* @min:%2elength */];
        }
        else if (isPlainObject(theValue)) {
            newValue_1 = {};
        }
        if (newValue_1) {
            objForEachKey$1(theValue, function (key, value) {
                if (value && _isConfigDefaults(value)) {
                    value = _resolveDefaultValue(dynamicHandler, theConfig, value);
                }
                newValue_1[key] = value;
            });
            theValue = newValue_1;
        }
    }
    return theValue;
}
/**
 * Applies the default value on the config property and makes sure that it's dynamic
 * @param theConfig
 * @param name
 * @param defaultValue
 */
function _applyDefaultValue(dynamicHandler, theConfig, name, defaultValue) {
    // Resolve the initial config value from the provided value or use the defined default
    var isValid;
    var setFn;
    var defValue;
    var cfgDefaults = defaultValue;
    var mergeDf;
    var reference;
    var readOnly;
    var blkDynamicValue;
    if (_isConfigDefaults(cfgDefaults)) {
        // looks like a IConfigDefault
        isValid = cfgDefaults.isVal;
        setFn = cfgDefaults.set;
        readOnly = cfgDefaults[_DYN_RD_ONLY /* @min:%2erdOnly */];
        blkDynamicValue = cfgDefaults[_DYN_BLK_VAL /* @min:%2eblkVal */];
        mergeDf = cfgDefaults.mrg;
        reference = cfgDefaults.ref;
        if (!reference && isUndefined$1(reference)) {
            reference = !!mergeDf;
        }
        defValue = _getDefault(dynamicHandler, theConfig, cfgDefaults);
    }
    else {
        defValue = defaultValue;
    }
    if (blkDynamicValue) {
        // Mark the property so that any value assigned will be blocked from conversion, we need to do this
        // before assigning or fetching the value to ensure it's not converted
        dynamicHandler[_DYN_BLK_VAL /* @min:%2eblkVal */](theConfig, name);
    }
    // Set the value to the default value;
    var theValue;
    var usingDefault = true;
    var cfgValue = theConfig[name];
    // try and get and user provided values
    if (cfgValue || !isNullOrUndefined$1(cfgValue)) {
        // Use the defined theConfig[name] value
        theValue = cfgValue;
        usingDefault = false;
        // The values are different and we have a special default value check, which is used to
        // override config values like empty strings to continue using the default
        if (isValid && theValue !== defValue && !isValid(theValue)) {
            theValue = defValue;
            usingDefault = true;
        }
        if (setFn) {
            theValue = setFn(theValue, defValue, theConfig);
            usingDefault = theValue === defValue;
        }
    }
    if (!usingDefault) {
        if (isPlainObject(theValue) || isArray$1(defValue)) {
            // we are using the user supplied value and it's an object
            if (mergeDf && defValue && (isPlainObject(defValue) || isArray$1(defValue))) {
                // Resolve/apply the defaults
                objForEachKey$1(defValue, function (dfName, dfValue) {
                    // Sets the value and makes it dynamic (if it doesn't already exist)
                    _applyDefaultValue(dynamicHandler, theValue, dfName, dfValue);
                });
            }
        }
    }
    else if (defValue) {
        // Just resolve the default
        theValue = _resolveDefaultValue(dynamicHandler, theConfig, defValue);
    }
    else {
        theValue = defValue;
    }
    // if (theValue && usingDefault && (isPlainObject(theValue) || isArray(theValue))) {
    //     theValue = _cfgDeepCopy(theValue);
    // }
    // Needed to ensure that the (potentially) new field is dynamic even if null/undefined
    dynamicHandler.set(theConfig, name, theValue);
    if (reference) {
        dynamicHandler.ref(theConfig, name);
    }
    if (readOnly) {
        dynamicHandler[_DYN_RD_ONLY /* @min:%2erdOnly */](theConfig, name);
    }
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
// Using Symbol.for so that if the same symbol was already created it would be returned
// To handle multiple instances using potentially different versions we are not using
// createUniqueNamespace()
var CFG_HANDLER_LINK = symbolFor("[[ai_dynCfg_1]]");
/**
 * @internal
 * @ignore
 * The symbol to tag objects / arrays with if they should not be converted
 */
var BLOCK_DYNAMIC = symbolFor("[[ai_blkDynCfg_1]]");
/**
 * @internal
 * @ignore
 * The symbol to tag objects to indicate that when included into the configuration that
 * they should be converted into a trackable dynamic object.
 */
var FORCE_DYNAMIC = symbolFor("[[ai_frcDynCfg_1]]");
function _cfgDeepCopy(source) {
    if (source) {
        var target_1;
        if (isArray$1(source)) {
            target_1 = [];
            target_1[_DYN_LENGTH$5 /* @min:%2elength */] = source[_DYN_LENGTH$5 /* @min:%2elength */];
        }
        else if (isPlainObject(source)) {
            target_1 = {};
        }
        if (target_1) {
            // Copying index values by property name as the extensionConfig can be an array or object
            objForEachKey$1(source, function (key, value) {
                // Perform a deep copy of the object
                target_1[key] = _cfgDeepCopy(value);
            });
            return target_1;
        }
    }
    return source;
}
/**
 * @internal
 * Get the dynamic config handler if the value is already dynamic
 * @param value
 * @returns
 */
function getDynamicConfigHandler(value) {
    if (value) {
        var handler = value[CFG_HANDLER_LINK] || value;
        if (handler.cfg && (handler.cfg === value || handler.cfg[CFG_HANDLER_LINK] === handler)) {
            return handler;
        }
    }
    return null;
}
/**
 * Mark the provided value so that if it's included into the configuration it will NOT have
 * its properties converted into a dynamic (reactive) object. If the object is not a plain object
 * or an array (ie. a class) this function has not affect as only Objects and Arrays are converted
 * into dynamic objects in the dynamic configuration.
 *
 * When you have tagged a value as both {@link forceDynamicConversion} and blocked force will take precedence.
 *
 * You should only need to use this function, if you are creating dynamic "classes" from objects
 * which confirm to the require interface. A common case for this is during unit testing where it's
 * easier to create mock extensions.
 *
 * If `value` is falsy (null / undefined / 0 / empty string etc) it will not be tagged and
 * if there is an exception adding the property to the value (because its frozen etc) the
 * exception will be swallowed
 *
 * @example
 * ```ts
 * // This is a valid "extension", but it is technically an object
 * // So when included in the config.extensions it WILL be cloned and then
 * // converted into a dynamic object, where all of its properties will become
 * // get/set object properties and will be tracked. While this WILL still
 * // function, when attempt to use a mocking framework on top of this the
 * // functions are now technically get accessors which return a function
 * // and this can cause some mocking frameworks to fail.
 * let mockChannel = {
 *      pause: () => { },
*      resume: () => { },
*      teardown: () => { },
*      flush: (async: any, callBack: any) => { },
*      processTelemetry: (env: any) => { },
*      setNextPlugin: (next: any) => { },
*      initialize: (config: any, core: any, extensions: any) => { },
*      identifier: "testChannel",
*      priority: 1003
* };
 * ```
 * @param value - The object that you want to block from being converted into a
 * trackable dynamic object
 * @returns The original value
 */
function blockDynamicConversion(value) {
    if (value && (isPlainObject(value) || isArray$1(value))) {
        try {
            value[BLOCK_DYNAMIC] = true;
        }
        catch (e) {
            // Don't throw for this case as it's an ask only
        }
    }
    return value;
}
/**
 * @internal
 * @ignore
 * Helper function to check whether an object can or should be converted into a dynamic
 * object.
 * @param value - The object to check whether it should be converted
 * @returns `true` if the value should be converted otherwise `false`.
 */
function _canMakeDynamic(getFunc, state, value) {
    var result = false;
    // Object must exist and be truthy
    if (value && !getFunc[state.blkVal]) {
        // Tagged as always convert
        result = value[FORCE_DYNAMIC];
        // Check that it's not explicitly tagged as blocked
        if (!result && !value[BLOCK_DYNAMIC]) {
            // Only convert plain objects or arrays by default
            result = isPlainObject(value) || isArray$1(value);
        }
    }
    return result;
}
/**
 * Throws an invalid access exception
 * @param message - The message to include in the exception
 */
function throwInvalidAccess(message) {
    throwTypeError$2("InvalidAccess:" + message);
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var arrayMethodsToPatch = [
    "push",
    "pop",
    "shift",
    "unshift",
    "splice"
];
var _throwDynamicError = function (logger, name, desc, e) {
    logger && logger[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */](3 /* eLoggingSeverity.DEBUG */, 108 /* _eInternalMessageId.DynamicConfigException */, "".concat(desc, " [").concat(name, "] failed - ") + dumpObj$2(e));
};
function _patchArray(state, target, name) {
    if (isArray$1(target)) {
        // Monkey Patch the methods that might change the array
        arrForEach$1(arrayMethodsToPatch, function (method) {
            var orgMethod = target[method];
            target[method] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var result = orgMethod[_DYN_APPLY /* @min:%2eapply */](this, args);
                // items may be added, removed or moved so need to make some new dynamic properties
                _makeDynamicObject(state, target, name, "Patching");
                return result;
            };
        });
    }
}
function _getOwnPropGetter(target, name) {
    var propDesc = objGetOwnPropertyDescriptor$1(target, name);
    return propDesc && propDesc.get;
}
function _createDynamicProperty(state, theConfig, name, value) {
    // Does not appear to be dynamic so lets make it so
    var detail = {
        n: name,
        h: [],
        trk: function (handler) {
            if (handler && handler.fn) {
                if (arrIndexOf(detail.h, handler) === -1) {
                    // Add this handler to the collection that should be notified when the value changes
                    detail.h[_DYN_PUSH$2 /* @min:%2epush */](handler);
                }
                state.trk(handler, detail);
            }
        },
        clr: function (handler) {
            var idx = arrIndexOf(detail.h, handler);
            if (idx !== -1) {
                detail.h[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
            }
        }
    };
    // Flag to optimize lookup response time by avoiding additional function calls
    var checkDynamic = true;
    var isObjectOrArray = false;
    function _getProperty() {
        if (checkDynamic) {
            isObjectOrArray = isObjectOrArray || _canMakeDynamic(_getProperty, state, value);
            // Make sure that if it's an object that we make it dynamic
            if (value && !value[CFG_HANDLER_LINK] && isObjectOrArray) {
                // It doesn't look like it's already dynamic so lets make sure it's converted the object into a dynamic Config as well
                value = _makeDynamicObject(state, value, name, "Converting");
            }
            // If it needed to be converted it now has been
            checkDynamic = false;
        }
        // If there is an active handler then add it to the tracking set of handlers
        var activeHandler = state.act;
        if (activeHandler) {
            detail.trk(activeHandler);
        }
        return value;
    }
    // Tag this getter as our dynamic property and provide shortcut for notifying a change
    _getProperty[state.prop] = {
        chng: function () {
            state.add(detail);
        }
    };
    function _setProperty(newValue) {
        if (value !== newValue) {
            if (!!_getProperty[state.ro] && !state.upd) {
                // field is marked as readonly so return false
                throwInvalidAccess("[" + name + "] is read-only:" + dumpObj$2(theConfig));
            }
            if (checkDynamic) {
                isObjectOrArray = isObjectOrArray || _canMakeDynamic(_getProperty, state, value);
                checkDynamic = false;
            }
            // The value must be a plain object or an array to enforce the reference (in-place updates)
            var isReferenced = isObjectOrArray && _getProperty[state.rf];
            if (isObjectOrArray) {
                // We are about to replace a plain object or an array
                if (isReferenced) {
                    // Reassign the properties from the current value to the same properties from the newValue
                    // This will set properties not in the newValue to undefined
                    objForEachKey$1(value, function (key) {
                        value[key] = newValue ? newValue[key] : UNDEFINED_VALUE$2;
                    });
                    // Now assign / re-assign value with all of the keys from newValue
                    try {
                        objForEachKey$1(newValue, function (key, theValue) {
                            _setDynamicProperty(state, value, key, theValue);
                        });
                        // Now drop newValue so when we assign value later it keeps the existing reference
                        newValue = value;
                    }
                    catch (e) {
                        // Unable to convert to dynamic property so just leave as non-dynamic
                        _throwDynamicError((state.hdlr || {})[_DYN_LOGGER /* @min:%2elogger */], name, "Assigning", e);
                        // Mark as not an object or array so we don't try and do this again
                        isObjectOrArray = false;
                    }
                }
                else if (value && value[CFG_HANDLER_LINK]) {
                    // As we are replacing the value, if it's already dynamic then we need to notify the listeners
                    // for every property it has already
                    objForEachKey$1(value, function (key) {
                        // Check if the value is dynamic
                        var getter = _getOwnPropGetter(value, key);
                        if (getter) {
                            // And if it is tell it's listeners that the value has changed
                            var valueState = getter[state.prop];
                            valueState && valueState.chng();
                        }
                    });
                }
            }
            if (newValue !== value) {
                var newIsObjectOrArray = newValue && _canMakeDynamic(_getProperty, state, newValue);
                if (!isReferenced && newIsObjectOrArray) {
                    // As the newValue is an object/array lets preemptively make it dynamic
                    newValue = _makeDynamicObject(state, newValue, name, "Converting");
                }
                // Now assign the internal "value" to the newValue
                value = newValue;
                isObjectOrArray = newIsObjectOrArray;
            }
            // Cause any listeners to be scheduled for notification
            state.add(detail);
        }
    }
    objDefine$1(theConfig, detail.n, { g: _getProperty, s: _setProperty });
}
function _setDynamicProperty(state, target, name, value) {
    if (target) {
        // To be a dynamic property it needs to have a get function
        var getter = _getOwnPropGetter(target, name);
        var isDynamic = getter && !!getter[state.prop];
        if (!isDynamic) {
            _createDynamicProperty(state, target, name, value);
        }
        else {
            // Looks like it's already dynamic just assign the new value
            target[name] = value;
        }
    }
    return target;
}
function _setDynamicPropertyState(state, target, name, flags) {
    if (target) {
        // To be a dynamic property it needs to have a get function
        var getter = _getOwnPropGetter(target, name);
        var isDynamic = getter && !!getter[state.prop];
        var inPlace = flags && flags[0 /* _eSetDynamicPropertyFlags.inPlace */];
        var rdOnly = flags && flags[1 /* _eSetDynamicPropertyFlags.readOnly */];
        var blkProp = flags && flags[2 /* _eSetDynamicPropertyFlags.blockDynamicProperty */];
        if (!isDynamic) {
            if (blkProp) {
                try {
                    // Attempt to mark the target as blocked from conversion
                    blockDynamicConversion(target);
                }
                catch (e) {
                    _throwDynamicError((state.hdlr || {})[_DYN_LOGGER /* @min:%2elogger */], name, "Blocking", e);
                }
            }
            try {
                // Make sure it's dynamic so that we can tag the property as per the state
                _setDynamicProperty(state, target, name, target[name]);
                getter = _getOwnPropGetter(target, name);
            }
            catch (e) {
                // Unable to convert to dynamic property so just leave as non-dynamic
                _throwDynamicError((state.hdlr || {})[_DYN_LOGGER /* @min:%2elogger */], name, "State", e);
            }
        }
        // Assign the optional flags if true
        if (inPlace) {
            getter[state.rf] = inPlace;
        }
        if (rdOnly) {
            getter[state.ro] = rdOnly;
        }
        if (blkProp) {
            getter[state.blkVal] = true;
        }
    }
    return target;
}
function _makeDynamicObject(state, target, name, desc) {
    try {
        // Assign target with new value properties (converting into dynamic properties in the process)
        objForEachKey$1(target, function (key, value) {
            // Assign and/or make the property dynamic
            _setDynamicProperty(state, target, key, value);
        });
        if (!target[CFG_HANDLER_LINK]) {
            // Link the config back to the dynamic config details
            objDefineProp$2(target, CFG_HANDLER_LINK, {
                get: function () {
                    return state[_DYN_HDLR /* @min:%2ehdlr */];
                }
            });
            _patchArray(state, target, name);
        }
    }
    catch (e) {
        // Unable to convert to dynamic property so just leave as non-dynamic
        _throwDynamicError((state.hdlr || {})[_DYN_LOGGER /* @min:%2elogger */], name, desc, e);
    }
    return target;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var symPrefix = "[[ai_";
var symPostfix = "]]";
function _createState(cfgHandler) {
    var _a;
    var dynamicPropertySymbol = newSymbol(symPrefix + "get" + cfgHandler.uid + symPostfix);
    var dynamicPropertyReadOnly = newSymbol(symPrefix + "ro" + cfgHandler.uid + symPostfix);
    var dynamicPropertyReferenced = newSymbol(symPrefix + "rf" + cfgHandler.uid + symPostfix);
    var dynamicPropertyBlockValue = newSymbol(symPrefix + "blkVal" + cfgHandler.uid + symPostfix);
    var dynamicPropertyDetail = newSymbol(symPrefix + "dtl" + cfgHandler.uid + symPostfix);
    var _waitingHandlers = null;
    var _watcherTimer = null;
    var theState;
    function _useHandler(activeHandler, callback) {
        var prevWatcher = theState.act;
        try {
            theState.act = activeHandler;
            if (activeHandler && activeHandler[dynamicPropertyDetail]) {
                // Clear out the previously tracked details for this handler, so that access are re-evaluated
                arrForEach$1(activeHandler[dynamicPropertyDetail], function (detail) {
                    detail.clr(activeHandler);
                });
                activeHandler[dynamicPropertyDetail] = [];
            }
            callback({
                cfg: cfgHandler.cfg,
                set: cfgHandler.set.bind(cfgHandler),
                setDf: cfgHandler[_DYN_SET_DF /* @min:%2esetDf */].bind(cfgHandler),
                ref: cfgHandler.ref.bind(cfgHandler),
                rdOnly: cfgHandler[_DYN_RD_ONLY /* @min:%2erdOnly */].bind(cfgHandler)
            });
        }
        catch (e) {
            var logger = cfgHandler[_DYN_LOGGER /* @min:%2elogger */];
            if (logger) {
                // Don't let one individual failure break everyone
                logger[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */](1 /* eLoggingSeverity.CRITICAL */, 107 /* _eInternalMessageId.ConfigWatcherException */, dumpObj$2(e));
            }
            // Re-throw the exception so that any true "error" is reported back to the called
            throw e;
        }
        finally {
            theState.act = prevWatcher || null;
        }
    }
    function _notifyWatchers() {
        if (_waitingHandlers) {
            var notifyHandlers = _waitingHandlers;
            _waitingHandlers = null;
            // Stop any timer as we are running them now anyway
            _watcherTimer && _watcherTimer[_DYN_CANCEL /* @min:%2ecancel */]();
            _watcherTimer = null;
            var watcherFailures_1 = [];
            // Now run the handlers
            arrForEach$1(notifyHandlers, function (handler) {
                if (handler) {
                    if (handler[dynamicPropertyDetail]) {
                        arrForEach$1(handler[dynamicPropertyDetail], function (detail) {
                            // Clear out this handler from  previously tracked details, so that access are re-evaluated
                            detail.clr(handler);
                        });
                        handler[dynamicPropertyDetail] = null;
                    }
                    // The handler may have self removed as part of another handler so re-check
                    if (handler.fn) {
                        try {
                            _useHandler(handler, handler.fn);
                        }
                        catch (e) {
                            // Don't let a single failing watcher cause other watches to fail
                            watcherFailures_1[_DYN_PUSH$2 /* @min:%2epush */](e);
                        }
                    }
                }
            });
            // During notification we may have had additional updates -- so notify those updates as well
            if (_waitingHandlers) {
                try {
                    _notifyWatchers();
                }
                catch (e) {
                    watcherFailures_1[_DYN_PUSH$2 /* @min:%2epush */](e);
                }
            }
            if (watcherFailures_1[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                throwAggregationError("Watcher error(s): ", watcherFailures_1);
            }
        }
    }
    function _addWatcher(detail) {
        if (detail && detail.h[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
            if (!_waitingHandlers) {
                _waitingHandlers = [];
            }
            if (!_watcherTimer) {
                _watcherTimer = scheduleTimeout$1(function () {
                    _watcherTimer = null;
                    _notifyWatchers();
                }, 0);
            }
            // Add all of the handlers for this detail (if not already present) - using normal for-loop for performance
            for (var idx = 0; idx < detail.h[_DYN_LENGTH$5 /* @min:%2elength */]; idx++) {
                var handler = detail.h[idx];
                // Add this handler to the collection of handlers to re-execute
                if (handler && arrIndexOf(_waitingHandlers, handler) === -1) {
                    _waitingHandlers[_DYN_PUSH$2 /* @min:%2epush */](handler);
                }
            }
        }
    }
    function _trackHandler(handler, detail) {
        if (handler) {
            var details = handler[dynamicPropertyDetail] = handler[dynamicPropertyDetail] || [];
            if (arrIndexOf(details, detail) === -1) {
                // If this detail is not already listed as tracked then add it so that we re-evaluate it's usage
                details[_DYN_PUSH$2 /* @min:%2epush */](detail);
            }
        }
    }
    theState = (_a = {
            prop: dynamicPropertySymbol,
            ro: dynamicPropertyReadOnly,
            rf: dynamicPropertyReferenced
        },
        _a[_DYN_BLK_VAL /* @min:blkVal */] = dynamicPropertyBlockValue,
        _a[_DYN_HDLR /* @min:hdlr */] = cfgHandler,
        _a.add = _addWatcher,
        _a[_DYN_NOTIFY /* @min:notify */] = _notifyWatchers,
        _a.use = _useHandler,
        _a.trk = _trackHandler,
        _a);
    return theState;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * Identifies a function which will be re-called whenever any of it's accessed configuration values
 * change.
 * @param configHandler - The callback that will be called for the initial request and then whenever any
 * accessed configuration changes are identified.
 */
function _createAndUseHandler(state, configHandler) {
    var handler = {
        fn: configHandler,
        rm: function () {
            // Clear all references to the handler so it can be garbage collected
            // This will also cause this handler to never get called and eventually removed
            handler.fn = null;
            state = null;
            configHandler = null;
        }
    };
    objDefine$1(handler, "toJSON", { v: function () { return "WatcherHandler" + (handler.fn ? "" : "[X]"); } });
    state.use(handler, configHandler);
    return handler;
}
/**
 * Creates the dynamic config handler and associates with the target config as the root object
 * @param target - The config that you want to be root of the dynamic config
 * @param inPlace - Should the passed config be converted in-place or a new proxy returned
 * @returns The existing dynamic handler or a new instance with the provided config values
 */
function _createDynamicHandler(logger, target, inPlace) {
    var _a;
    var dynamicHandler = getDynamicConfigHandler(target);
    if (dynamicHandler) {
        // The passed config is already dynamic so return it's tracker
        return dynamicHandler;
    }
    var uid = createUniqueNamespace("dyncfg", true);
    var newTarget = (target && inPlace !== false) ? target : _cfgDeepCopy(target);
    var theState;
    function _notifyWatchers() {
        theState[_DYN_NOTIFY /* @min:%2enotify */]();
    }
    function _setValue(target, name, value) {
        try {
            target = _setDynamicProperty(theState, target, name, value);
        }
        catch (e) {
            // Unable to convert to dynamic property so just leave as non-dynamic
            _throwDynamicError(logger, name, "Setting value", e);
        }
        return target[name];
    }
    function _watch(configHandler) {
        return _createAndUseHandler(theState, configHandler);
    }
    function _block(configHandler, allowUpdate) {
        theState.use(null, function (details) {
            var prevUpd = theState.upd;
            try {
                if (!isUndefined$1(allowUpdate)) {
                    theState.upd = allowUpdate;
                }
                configHandler(details);
            }
            finally {
                theState.upd = prevUpd;
            }
        });
    }
    function _ref(target, name) {
        var _a;
        // Make sure it's dynamic and mark as referenced with it's current value
        return _setDynamicPropertyState(theState, target, name, (_a = {}, _a[0 /* _eSetDynamicPropertyFlags.inPlace */] = true, _a))[name];
    }
    function _rdOnly(target, name) {
        var _a;
        // Make sure it's dynamic and mark as readonly with it's current value
        return _setDynamicPropertyState(theState, target, name, (_a = {}, _a[1 /* _eSetDynamicPropertyFlags.readOnly */] = true, _a))[name];
    }
    function _blkPropValue(target, name) {
        var _a;
        // Make sure it's dynamic and mark as readonly with it's current value
        return _setDynamicPropertyState(theState, target, name, (_a = {}, _a[2 /* _eSetDynamicPropertyFlags.blockDynamicProperty */] = true, _a))[name];
    }
    function _applyDefaults(theConfig, defaultValues) {
        if (defaultValues) {
            // Resolve/apply the defaults
            objForEachKey$1(defaultValues, function (name, value) {
                // Sets the value and makes it dynamic (if it doesn't already exist)
                _applyDefaultValue(cfgHandler, theConfig, name, value);
            });
        }
        return theConfig;
    }
    var cfgHandler = (_a = {
            uid: null,
            cfg: newTarget
        },
        _a[_DYN_LOGGER /* @min:logger */] = logger,
        _a[_DYN_NOTIFY /* @min:notify */] = _notifyWatchers,
        _a.set = _setValue,
        _a[_DYN_SET_DF /* @min:setDf */] = _applyDefaults,
        _a[_DYN_WATCH /* @min:watch */] = _watch,
        _a.ref = _ref,
        _a[_DYN_RD_ONLY /* @min:rdOnly */] = _rdOnly,
        _a[_DYN_BLK_VAL /* @min:blkVal */] = _blkPropValue,
        _a._block = _block,
        _a);
    objDefine$1(cfgHandler, "uid", {
        c: false,
        e: false,
        w: false,
        v: uid
    });
    theState = _createState(cfgHandler);
    // Setup tracking for all defined default keys
    _makeDynamicObject(theState, newTarget, "config", "Creating");
    return cfgHandler;
}
/**
 * Log an invalid access message to the console
 * @param message
 */
function _logInvalidAccess(logger, message) {
    if (logger) {
        logger[_DYN_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */](message);
        logger[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */](2 /* eLoggingSeverity.WARNING */, 108 /* _eInternalMessageId.DynamicConfigException */, message);
    }
    else {
        // We don't have a logger so just throw an exception
        throwInvalidAccess(message);
    }
}
/**
 * Create or return a dynamic version of the passed config, if it is not already dynamic
 * @param config - The config to be converted into a dynamic config
 * @param defaultConfig - The default values to apply on the config if the properties don't already exist
 * @param inPlace - Should the config be converted in-place into a dynamic config or a new instance returned, defaults to true
 * @returns The dynamic config handler for the config (whether new or existing)
 */
function createDynamicConfig(config, defaultConfig, logger, inPlace) {
    var dynamicHandler = _createDynamicHandler(logger, config || {}, inPlace);
    if (defaultConfig) {
        dynamicHandler[_DYN_SET_DF /* @min:%2esetDf */](dynamicHandler.cfg, defaultConfig);
    }
    return dynamicHandler;
}
/**
 * Watch and track changes for accesses to the current config, the provided config MUST already be
 * a dynamic config or a child accessed via the dynamic config
 * @param config
 * @param configHandler
 * @param logger - The logger instance to use if there is no existing handler
 * @returns A watcher handler instance that can be used to remove itself when being unloaded
 * @throws TypeError if the provided config is not a dynamic config instance
 */
function onConfigChange(config, configHandler, logger) {
    var handler = config[CFG_HANDLER_LINK] || config;
    if (handler.cfg && (handler.cfg === config || handler.cfg[CFG_HANDLER_LINK] === handler)) {
        return handler[_DYN_WATCH /* @min:%2ewatch */](configHandler);
    }
    _logInvalidAccess(logger, STR_NOT_DYNAMIC_ERROR + dumpObj$2(config));
    return createDynamicConfig(config, null, logger)[_DYN_WATCH /* @min:%2ewatch */](configHandler);
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * Run the unload function of the target object if it exists
 * @param target - The target object that contains the unload function
 * @param isAsync - The caller identifies whether it is expecting the operation to complete synchronously or asynchronously. Even
 * if the caller is not waiting the operation may still be performed asynchronously depending on the component and the reverse is
 * also true.
 * @returns The result of the target function
 */
function runTargetUnload(target, isAsync) {
    if (target && target[_DYN_UNLOAD /* @min:%2eunload */]) {
        return target[_DYN_UNLOAD /* @min:%2eunload */](isAsync);
    }
}
/**
 * Call the unload function on all targets handling any returned [IPromise](https://nevware21.github.io/ts-async/typedoc/interfaces/IPromise.html)
 * / Promise before calling the next targets unload
 * @param targets - An array of the targets to unload
 * @param isAsync - The caller identifies whether it is expecting the operations to complete synchronously or asynchronously.  Even
 * if the caller is not waiting the operation may still be performed asynchronously depending on the component and the reverse is
 * also true.
 * @param done - Optional callback function to call once all of the unload functions have been called.
 */
function doUnloadAll(targets, isAsync, done) {
    var result;
    if (!done) {
        result = createPromise(function (resolved) {
            done = resolved;
        });
    }
    if (targets && getLength(targets) > 0) {
        doAwaitResponse(runTargetUnload(targets[0], isAsync), function () {
            doUnloadAll(arrSlice$1(targets, 1), isAsync, done);
        });
    }
    else {
        done();
    }
    return result;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var ChannelControllerPriority = 500;
var DisabledPropertyName$1 = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
// export const SampleRate = "sampleRate";
// export const ProcessLegacy = "ProcessLegacy";
// export const HttpMethod = "http.method";
// export const DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
// export const DEFAULT_BREEZE_PATH = "/v2/track";
// export const strNotSpecified = "not_specified";
// export const strIkey = "iKey";

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * @internal
 * @ignore
 * @param str
 * @param defaultValue
 * @returns
 */
function _stringToBoolOrDefault(theValue, defaultValue, theConfig) {
    if (!theValue && isNullOrUndefined$1(theValue)) {
        return defaultValue;
    }
    if (isBoolean(theValue)) {
        return theValue;
    }
    return asString$1(theValue)[_DYN_TO_LOWER_CASE$2 /* @min:%2etoLowerCase */]() === "true";
}
/**
 * Helper which returns an IConfigDefaultCheck instance with the field defined as an object
 * that should be merged
 * @param defaultValue - The default value to apply it not provided or it's not valid
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfMerge(defaultValue) {
    return {
        mrg: true,
        v: defaultValue
    };
}
/**
 * Helper which returns an IConfigDefaultCheck instance with the provided field set function
 * @param setter - The IConfigCheckFn function to validate the user provided value
 * @param defaultValue - The default value to apply it not provided or it's not valid
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfSet(setter, defaultValue) {
    return {
        set: setter,
        v: defaultValue
    };
}
/**
 * Helper which returns an IConfigDefaultCheck instance with the provided field validator
 * @param validator - The IConfigCheckFn function to validate the user provided value
 * @param defaultValue - The default value to apply it not provided or it's not valid
 * @param fallBackName - The fallback configuration name if the current value is not available
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfValidate(validator, defaultValue, fallBackName) {
    return {
        fb: fallBackName,
        isVal: validator,
        v: defaultValue
    };
}
/**
 * Helper which returns an IConfigDefaultCheck instance that will validate and convert the user
 * provided value to a boolean from a string or boolean value
 * @param defaultValue - The default value to apply it not provided or it's not valid
 * @param fallBackName - The fallback configuration name if the current value is not available
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfBoolean(defaultValue, fallBackName) {
    return {
        fb: fallBackName,
        set: _stringToBoolOrDefault,
        v: !!defaultValue
    };
}
/**
 * Helper which returns an IConfigDefaultCheck instance that will validate that the user
 * provided value is a function.
 * @param defaultValue - The default string value to apply it not provided or it's not valid, defaults to an empty string
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfString(defaultValue) {
    return {
        isVal: isString$2,
        v: asString$1(defaultValue || STR_EMPTY$1)
    };
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var listenerFuncs = [STR_EVENTS_SENT, STR_EVENTS_DISCARDED, STR_EVENTS_SEND_REQUEST, STR_PERF_EVENT];
var _aiNamespace = null;
var _debugListener;
function _listenerProxyFunc(name, config) {
    return function () {
        var args = arguments;
        var dbgExt = getDebugExt(config);
        if (dbgExt) {
            var listener = dbgExt.listener;
            if (listener && listener[name]) {
                listener[name][_DYN_APPLY /* @min:%2eapply */](listener, args);
            }
        }
    };
}
function _getExtensionNamespace() {
    // Cache the lookup of the global namespace object
    var target = getInst$1("Microsoft");
    if (target) {
        _aiNamespace = target["ApplicationInsights"];
    }
    return _aiNamespace;
}
function getDebugExt(config) {
    var ns = _aiNamespace;
    if (!ns && config.disableDbgExt !== true) {
        ns = _aiNamespace || _getExtensionNamespace();
    }
    return ns ? ns["ChromeDbgExt"] : null;
}
function getDebugListener(config) {
    if (!_debugListener) {
        _debugListener = {};
        for (var lp = 0; lp < listenerFuncs[_DYN_LENGTH$5 /* @min:%2elength */]; lp++) {
            _debugListener[listenerFuncs[lp]] = _listenerProxyFunc(listenerFuncs[lp], config);
        }
    }
    return _debugListener;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var _a$b;
var STR_WARN_TO_CONSOLE = "warnToConsole";
/**
 * For user non actionable traces use AI Internal prefix.
 */
var AiNonUserActionablePrefix = "AI (Internal): ";
/**
 * Prefix of the traces in portal.
 */
var AiUserActionablePrefix = "AI: ";
/**
 *  Session storage key for the prefix for the key indicating message type already logged
 */
var AIInternalMessagePrefix = "AITR_";
var defaultValues$3 = {
    loggingLevelConsole: 0,
    loggingLevelTelemetry: 1,
    maxMessageLimit: 25,
    enableDebug: false
};
var _logFuncs = (_a$b = {},
    _a$b[0 /* eLoggingSeverity.DISABLED */] = null,
    _a$b[1 /* eLoggingSeverity.CRITICAL */] = "errorToConsole",
    _a$b[2 /* eLoggingSeverity.WARNING */] = STR_WARN_TO_CONSOLE,
    _a$b[3 /* eLoggingSeverity.DEBUG */] = "debugToConsole",
    _a$b);
function _sanitizeDiagnosticText(text) {
    if (text) {
        return "\"" + text[_DYN_REPLACE /* @min:%2ereplace */](/\"/g, STR_EMPTY$1) + "\"";
    }
    return STR_EMPTY$1;
}
function _logToConsole(func, message) {
    var theConsole = getConsole();
    if (!!theConsole) {
        var logFunc = "log";
        if (theConsole[func]) {
            logFunc = func;
        }
        if (isFunction$2(theConsole[logFunc])) {
            theConsole[logFunc](message);
        }
    }
}
var _InternalLogMessage = /** @class */ (function () {
    function _InternalLogMessage(msgId, msg, isUserAct, properties) {
        if (isUserAct === void 0) { isUserAct = false; }
        var _self = this;
        _self[_DYN_MESSAGE_ID /* @min:%2emessageId */] = msgId;
        _self[_DYN_MESSAGE$2 /* @min:%2emessage */] =
            (isUserAct ? AiUserActionablePrefix : AiNonUserActionablePrefix) +
                msgId;
        var strProps = STR_EMPTY$1;
        if (hasJSON()) {
            strProps = getJSON().stringify(properties);
        }
        var diagnosticText = (msg ? " message:" + _sanitizeDiagnosticText(msg) : STR_EMPTY$1) +
            (properties ? " props:" + _sanitizeDiagnosticText(strProps) : STR_EMPTY$1);
        _self[_DYN_MESSAGE$2 /* @min:%2emessage */] += diagnosticText;
    }
    _InternalLogMessage.dataType = "MessageData";
    return _InternalLogMessage;
}());
function safeGetLogger(core, config) {
    return (core || {})[_DYN_LOGGER /* @min:%2elogger */] || new DiagnosticLogger(config);
}
var DiagnosticLogger = /** @class */ (function () {
    function DiagnosticLogger(config) {
        this.identifier = "DiagnosticLogger";
        /**
         * The internal logging queue
         */
        this.queue = [];
        /**
         * Count of internal messages sent
         */
        var _messageCount = 0;
        /**
         * Holds information about what message types were already logged to console or sent to server.
         */
        var _messageLogged = {};
        var _loggingLevelConsole;
        var _loggingLevelTelemetry;
        var _maxInternalMessageLimit;
        var _enableDebug;
        var _unloadHandler;
        dynamicProto(DiagnosticLogger, this, function (_self) {
            _unloadHandler = _setDefaultsFromConfig(config || {});
            _self.consoleLoggingLevel = function () { return _loggingLevelConsole; };
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity - {LoggingSeverity} - The severity of the log message
             * @param message - {_InternalLogMessage} - The log message.
             */
            _self[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */] = function (severity, msgId, msg, properties, isUserAct) {
                if (isUserAct === void 0) { isUserAct = false; }
                var message = new _InternalLogMessage(msgId, msg, isUserAct, properties);
                if (_enableDebug) {
                    throw dumpObj$2(message);
                }
                else {
                    // Get the logging function and fallback to warnToConsole of for some reason errorToConsole doesn't exist
                    var logFunc = _logFuncs[severity] || STR_WARN_TO_CONSOLE;
                    if (!isUndefined$1(message[_DYN_MESSAGE$2 /* @min:%2emessage */])) {
                        if (isUserAct) {
                            // check if this message type was already logged to console for this page view and if so, don't log it again
                            var messageKey = +message[_DYN_MESSAGE_ID /* @min:%2emessageId */];
                            if (!_messageLogged[messageKey] && _loggingLevelConsole >= severity) {
                                _self[logFunc](message[_DYN_MESSAGE$2 /* @min:%2emessage */]);
                                _messageLogged[messageKey] = true;
                            }
                        }
                        else {
                            // Only log traces if the console Logging Level is >= the throwInternal severity level
                            if (_loggingLevelConsole >= severity) {
                                _self[logFunc](message[_DYN_MESSAGE$2 /* @min:%2emessage */]);
                            }
                        }
                        _logInternalMessage(severity, message);
                    }
                    else {
                        _debugExtMsg("throw" + (severity === 1 /* eLoggingSeverity.CRITICAL */ ? "Critical" : "Warning"), message);
                    }
                }
            };
            _self.debugToConsole = function (message) {
                _logToConsole("debug", message);
                _debugExtMsg("warning", message);
            };
            _self[_DYN_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */] = function (message) {
                _logToConsole("warn", message);
                _debugExtMsg("warning", message);
            };
            _self.errorToConsole = function (message) {
                _logToConsole("error", message);
                _debugExtMsg("error", message);
            };
            _self.resetInternalMessageCount = function () {
                _messageCount = 0;
                _messageLogged = {};
            };
            _self[_DYN_LOG_INTERNAL_MESSAGE /* @min:%2elogInternalMessage */] = _logInternalMessage;
            _self[_DYN_UNLOAD /* @min:%2eunload */] = function (isAsync) {
                _unloadHandler && _unloadHandler.rm();
                _unloadHandler = null;
            };
            function _logInternalMessage(severity, message) {
                if (_areInternalMessagesThrottled()) {
                    return;
                }
                // check if this message type was already logged for this session and if so, don't log it again
                var logMessage = true;
                var messageKey = AIInternalMessagePrefix + message[_DYN_MESSAGE_ID /* @min:%2emessageId */];
                // if the session storage is not available, limit to only one message type per page view
                if (_messageLogged[messageKey]) {
                    logMessage = false;
                }
                else {
                    _messageLogged[messageKey] = true;
                }
                if (logMessage) {
                    // Push the event in the internal queue
                    if (severity <= _loggingLevelTelemetry) {
                        _self.queue[_DYN_PUSH$2 /* @min:%2epush */](message);
                        _messageCount++;
                        _debugExtMsg((severity === 1 /* eLoggingSeverity.CRITICAL */ ? "error" : "warn"), message);
                    }
                    // When throttle limit reached, send a special event
                    if (_messageCount === _maxInternalMessageLimit) {
                        var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
                        var throttleMessage = new _InternalLogMessage(23 /* _eInternalMessageId.MessageLimitPerPVExceeded */, throttleLimitMessage, false);
                        _self.queue[_DYN_PUSH$2 /* @min:%2epush */](throttleMessage);
                        if (severity === 1 /* eLoggingSeverity.CRITICAL */) {
                            _self.errorToConsole(throttleLimitMessage);
                        }
                        else {
                            _self[_DYN_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */](throttleLimitMessage);
                        }
                    }
                }
            }
            function _setDefaultsFromConfig(config) {
                // make sure the config is dynamic
                return onConfigChange(createDynamicConfig(config, defaultValues$3, _self).cfg, function (details) {
                    var config = details.cfg;
                    _loggingLevelConsole = config[_DYN_LOGGING_LEVEL_CONSOL4 /* @min:%2eloggingLevelConsole */];
                    _loggingLevelTelemetry = config.loggingLevelTelemetry;
                    _maxInternalMessageLimit = config.maxMessageLimit;
                    _enableDebug = config.enableDebug;
                });
            }
            function _areInternalMessagesThrottled() {
                return _messageCount >= _maxInternalMessageLimit;
            }
            function _debugExtMsg(name, data) {
                var dbgExt = getDebugExt(config || {});
                if (dbgExt && dbgExt[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */]) {
                    dbgExt[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */](name, data);
                }
            }
        });
    }
// Removed Stub for DiagnosticLogger.prototype.consoleLoggingLevel.
// Removed Stub for DiagnosticLogger.prototype.throwInternal.
// Removed Stub for DiagnosticLogger.prototype.debugToConsole.
// Removed Stub for DiagnosticLogger.prototype.warnToConsole.
// Removed Stub for DiagnosticLogger.prototype.errorToConsole.
// Removed Stub for DiagnosticLogger.prototype.resetInternalMessageCount.
// Removed Stub for DiagnosticLogger.prototype.logInternalMessage.
// Removed Stub for DiagnosticLogger.prototype.unload.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    DiagnosticLogger.__ieDyn=1;

    return DiagnosticLogger;
}());
function _getLogger(logger) {
    return (logger || new DiagnosticLogger());
}
/**
 * This is a helper method which will call throwInternal on the passed logger, will throw exceptions in
 * debug mode or attempt to log the error as a console warning. This helper is provided mostly to better
 * support minification as logger.throwInternal() will not compress the publish "throwInternal" used throughout
 * the code.
 * @param logger - The Diagnostic Logger instance to use.
 * @param severity - {LoggingSeverity} - The severity of the log message
 * @param message - {_InternalLogMessage} - The log message.
 */
function _throwInternal(logger, severity, msgId, msg, properties, isUserAct) {
    if (isUserAct === void 0) { isUserAct = false; }
    _getLogger(logger)[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */](severity, msgId, msg, properties, isUserAct);
}
/**
 * This is a helper method which will call warnToConsole on the passed logger with the provided message.
 * @param logger - The Diagnostic Logger instance to use.
 * @param message - {_InternalLogMessage} - The log message.
 */
function _warnToConsole(logger, message) {
    _getLogger(logger)[_DYN_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */](message);
}
/**
 * Logs a message to the internal queue.
 * @param logger - The Diagnostic Logger instance to use.
 * @param severity - {LoggingSeverity} - The severity of the log message
 * @param message - {_InternalLogMessage} - The message to log.
 */
function _logInternalMessage(logger, severity, message) {
    _getLogger(logger)[_DYN_LOG_INTERNAL_MESSAGE /* @min:%2elogInternalMessage */](severity, message);
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var _a$a, _b$2;
var strToGMTString = "toGMTString";
var strToUTCString = "toUTCString";
var strCookie = "cookie";
var strExpires = "expires";
var strIsCookieUseDisabled = "isCookieUseDisabled";
var strDisableCookiesUsage = "disableCookiesUsage";
var strConfigCookieMgr = "_ckMgr";
var _supportsCookies = null;
var _allowUaSameSite = null;
var _parsedCookieValue = null;
var _doc;
var _cookieCache = {};
var _globalCookieConfig = {};
// // `isCookieUseDisabled` is deprecated, so explicitly casting as a key of IConfiguration to avoid typing error
// // when both isCookieUseDisabled and disableCookiesUsage are used disableCookiesUsage will take precedent, which is
// // why its listed first
/**
 * Set the supported dynamic config values as undefined (or an empty object) so that
 * any listeners will be informed of any changes.
 * Explicitly NOT including the deprecated `isCookieUseDisabled` as we don't want to support
 * the v1 deprecated field as dynamic for updates
 */
var rootDefaultConfig = (_a$a = {
        cookieCfg: cfgDfMerge((_b$2 = {},
            _b$2[STR_DOMAIN] = { fb: "cookieDomain", dfVal: isNotNullOrUndefined },
            _b$2.path = { fb: "cookiePath", dfVal: isNotNullOrUndefined },
            _b$2.enabled = UNDEFINED_VALUE$2,
            _b$2.ignoreCookies = UNDEFINED_VALUE$2,
            _b$2.blockedCookies = UNDEFINED_VALUE$2,
            _b$2)),
        cookieDomain: UNDEFINED_VALUE$2,
        cookiePath: UNDEFINED_VALUE$2
    },
    _a$a[strDisableCookiesUsage] = UNDEFINED_VALUE$2,
    _a$a);
function _getDoc() {
    !_doc && (_doc = getLazy$2(function () { return getDocument$1(); }));
}
/**
 * @ignore
 * DO NOT USE or export from the module, this is exposed as public to support backward compatibility of previous static utility methods only.
 * If you want to manager cookies either use the ICookieMgr available from the core instance via getCookieMgr() or create
 * your own instance of the CookieMgr and use that.
 * Using this directly for enabling / disabling cookie handling will not only affect your usage but EVERY user of cookies.
 * Example, if you are using a shared component that is also using Application Insights you will affect their cookie handling.
 * @param logger - The DiagnosticLogger to use for reporting errors.
 */
function _gblCookieMgr(config, logger) {
    // Stash the global instance against the BaseCookieMgr class
    var inst = createCookieMgr[strConfigCookieMgr] || _globalCookieConfig[strConfigCookieMgr];
    if (!inst) {
        // Note: not using the getSetValue() helper as that would require always creating a temporary cookieMgr
        // that ultimately is never used
        inst = createCookieMgr[strConfigCookieMgr] = createCookieMgr(config, logger);
        _globalCookieConfig[strConfigCookieMgr] = inst;
    }
    return inst;
}
function _isMgrEnabled(cookieMgr) {
    if (cookieMgr) {
        return cookieMgr.isEnabled();
    }
    return true;
}
function _isIgnoredCookie(cookieMgrCfg, name) {
    if (name && cookieMgrCfg && isArray$1(cookieMgrCfg.ignoreCookies)) {
        return arrIndexOf(cookieMgrCfg.ignoreCookies, name) !== -1;
    }
    return false;
}
function _isBlockedCookie(cookieMgrCfg, name) {
    if (name && cookieMgrCfg && isArray$1(cookieMgrCfg.blockedCookies)) {
        if (arrIndexOf(cookieMgrCfg.blockedCookies, name) !== -1) {
            return true;
        }
    }
    return _isIgnoredCookie(cookieMgrCfg, name);
}
function _isCfgEnabled(rootConfig, cookieMgrConfig) {
    var isCfgEnabled = cookieMgrConfig[_DYN_ENABLED /* @min:%2eenabled */];
    if (isNullOrUndefined$1(isCfgEnabled)) {
        // Set the enabled from the provided setting or the legacy root values
        var cookieEnabled = void 0;
        // This field is deprecated and dynamic updates will not be fully supported
        if (!isUndefined$1(rootConfig[strIsCookieUseDisabled])) {
            cookieEnabled = !rootConfig[strIsCookieUseDisabled];
        }
        // If this value is defined it takes precedent over the above
        if (!isUndefined$1(rootConfig[strDisableCookiesUsage])) {
            cookieEnabled = !rootConfig[strDisableCookiesUsage];
        }
        // Not setting the cookieMgrConfig.enabled as that will update (set) the global dynamic config
        // So future "updates" then may not be as expected
        isCfgEnabled = cookieEnabled;
    }
    return isCfgEnabled;
}
/**
 * Helper to return the ICookieMgr from the core (if not null/undefined) or a default implementation
 * associated with the configuration or a legacy default.
 * @param core
 * @param config
 * @returns
 */
function safeGetCookieMgr(core, config) {
    var cookieMgr;
    if (core) {
        // Always returns an instance
        cookieMgr = core.getCookieMgr();
    }
    else if (config) {
        var cookieCfg = config.cookieCfg;
        if (cookieCfg && cookieCfg[strConfigCookieMgr]) {
            cookieMgr = cookieCfg[strConfigCookieMgr];
        }
        else {
            cookieMgr = createCookieMgr(config);
        }
    }
    if (!cookieMgr) {
        // Get or initialize the default global (legacy) cookie manager if we couldn't find one
        cookieMgr = _gblCookieMgr(config, (core || {})[_DYN_LOGGER /* @min:%2elogger */]);
    }
    return cookieMgr;
}
function createCookieMgr(rootConfig, logger) {
    var _a;
    var cookieMgrConfig;
    var _path;
    var _domain;
    var unloadHandler;
    // Explicitly checking against false, so that setting to undefined will === true
    var _enabled;
    var _getCookieFn;
    var _setCookieFn;
    var _delCookieFn;
    // Make sure the root config is dynamic as it may be the global config
    rootConfig = createDynamicConfig(rootConfig || _globalCookieConfig, null, logger).cfg;
    // Will get recalled if the referenced configuration is changed
    unloadHandler = onConfigChange(rootConfig, function (details) {
        // Make sure the root config has all of the the defaults to the root config to ensure they are dynamic
        details[_DYN_SET_DF /* @min:%2esetDf */](details.cfg, rootDefaultConfig);
        // Create and apply the defaults to the cookieCfg element
        cookieMgrConfig = details.ref(details.cfg, "cookieCfg"); // details.setDf(details.cfg.cookieCfg, defaultConfig);
        _path = cookieMgrConfig[STR_PATH /* @min:%2epath */] || "/";
        _domain = cookieMgrConfig[STR_DOMAIN /* @min:%2edomain */];
        // Explicitly checking against false, so that setting to undefined will === true
        _enabled = _isCfgEnabled(rootConfig, cookieMgrConfig) !== false;
        _getCookieFn = cookieMgrConfig.getCookie || _getCookieValue;
        _setCookieFn = cookieMgrConfig.setCookie || _setCookieValue;
        _delCookieFn = cookieMgrConfig.delCookie || _setCookieValue;
    }, logger);
    var cookieMgr = (_a = {
            isEnabled: function () {
                var enabled = _isCfgEnabled(rootConfig, cookieMgrConfig) !== false && _enabled && areCookiesSupported(logger);
                // Using an indirect lookup for any global cookie manager to support tree shaking for SDK's
                // that don't use the "applicationinsights-core" version of the default cookie function
                var gblManager = _globalCookieConfig[strConfigCookieMgr];
                if (enabled && gblManager && cookieMgr !== gblManager) {
                    // Make sure the GlobalCookie Manager instance (if not this instance) is also enabled.
                    // As the global (deprecated) functions may have been called (for backward compatibility)
                    enabled = _isMgrEnabled(gblManager);
                }
                return enabled;
            },
            setEnabled: function (value) {
                // Explicitly checking against false, so that setting to undefined will === true
                _enabled = value !== false;
                cookieMgrConfig[_DYN_ENABLED /* @min:%2eenabled */] = value;
            },
            set: function (name, value, maxAgeSec, domain, path) {
                var result = false;
                if (_isMgrEnabled(cookieMgr) && !_isBlockedCookie(cookieMgrConfig, name)) {
                    var values = {};
                    var theValue = strTrim(value || STR_EMPTY$1);
                    var idx = strIndexOf(theValue, ";");
                    if (idx !== -1) {
                        theValue = strTrim(strLeft(value, idx));
                        values = _extractParts(strSubstring(value, idx + 1));
                    }
                    // Only update domain if not already present (isUndefined) and the value is truthy (not null, undefined or empty string)
                    setValue(values, STR_DOMAIN, domain || _domain, isTruthy, isUndefined$1);
                    if (!isNullOrUndefined$1(maxAgeSec)) {
                        var _isIE = isIE();
                        if (isUndefined$1(values[strExpires])) {
                            var nowMs = utcNow();
                            // Only add expires if not already present
                            var expireMs = nowMs + (maxAgeSec * 1000);
                            // Sanity check, if zero or -ve then ignore
                            if (expireMs > 0) {
                                var expiry = new Date();
                                expiry.setTime(expireMs);
                                setValue(values, strExpires, _formatDate(expiry, !_isIE ? strToUTCString : strToGMTString) || _formatDate(expiry, _isIE ? strToGMTString : strToUTCString) || STR_EMPTY$1, isTruthy);
                            }
                        }
                        if (!_isIE) {
                            // Only replace if not already present
                            setValue(values, "max-age", STR_EMPTY$1 + maxAgeSec, null, isUndefined$1);
                        }
                    }
                    var location_1 = getLocation();
                    if (location_1 && location_1[_DYN_PROTOCOL /* @min:%2eprotocol */] === "https:") {
                        setValue(values, "secure", null, null, isUndefined$1);
                        // Only set same site if not also secure
                        if (_allowUaSameSite === null) {
                            _allowUaSameSite = !uaDisallowsSameSiteNone((getNavigator() || {})[_DYN_USER_AGENT /* @min:%2euserAgent */]);
                        }
                        if (_allowUaSameSite) {
                            setValue(values, "SameSite", "None", null, isUndefined$1);
                        }
                    }
                    setValue(values, STR_PATH, path || _path, null, isUndefined$1);
                    //let setCookieFn = cookieMgrConfig.setCookie || _setCookieValue;
                    _setCookieFn(name, _formatCookieValue(theValue, values));
                    result = true;
                }
                return result;
            },
            get: function (name) {
                var value = STR_EMPTY$1;
                if (_isMgrEnabled(cookieMgr) && !_isIgnoredCookie(cookieMgrConfig, name)) {
                    value = _getCookieFn(name);
                }
                return value;
            },
            del: function (name, path) {
                var result = false;
                if (_isMgrEnabled(cookieMgr)) {
                    // Only remove the cookie if the manager and cookie support has not been disabled
                    result = cookieMgr.purge(name, path);
                }
                return result;
            },
            purge: function (name, path) {
                var _a;
                var result = false;
                if (areCookiesSupported(logger)) {
                    // Setting the expiration date in the past immediately removes the cookie
                    var values = (_a = {},
                        _a[STR_PATH] = path ? path : "/",
                        _a[strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT",
                        _a);
                    if (!isIE()) {
                        // Set max age to expire now
                        values["max-age"] = "0";
                    }
                    // let delCookie = cookieMgrConfig.delCookie || _setCookieValue;
                    _delCookieFn(name, _formatCookieValue(STR_EMPTY$1, values));
                    result = true;
                }
                return result;
            }
        },
        _a[_DYN_UNLOAD /* @min:unload */] = function (isAsync) {
            unloadHandler && unloadHandler.rm();
            unloadHandler = null;
        },
        _a);
    // Associated this cookie manager with the config
    cookieMgr[strConfigCookieMgr] = cookieMgr;
    return cookieMgr;
}
/*
* Helper method to tell if document.cookie object is supported by the runtime
*/
function areCookiesSupported(logger) {
    if (_supportsCookies === null) {
        _supportsCookies = false;
        !_doc && _getDoc();
        try {
            var doc = _doc.v || {};
            _supportsCookies = doc[strCookie] !== undefined;
        }
        catch (e) {
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 68 /* _eInternalMessageId.CannotAccessCookie */, "Cannot access document.cookie - " + getExceptionName(e), { exception: dumpObj$2(e) });
        }
    }
    return _supportsCookies;
}
function _extractParts(theValue) {
    var values = {};
    if (theValue && theValue[_DYN_LENGTH$5 /* @min:%2elength */]) {
        var parts = strTrim(theValue)[_DYN_SPLIT$1 /* @min:%2esplit */](";");
        arrForEach$1(parts, function (thePart) {
            thePart = strTrim(thePart || STR_EMPTY$1);
            if (thePart) {
                var idx = strIndexOf(thePart, "=");
                if (idx === -1) {
                    values[thePart] = null;
                }
                else {
                    values[strTrim(strLeft(thePart, idx))] = strTrim(strSubstring(thePart, idx + 1));
                }
            }
        });
    }
    return values;
}
function _formatDate(theDate, func) {
    if (isFunction$2(theDate[func])) {
        return theDate[func]();
    }
    return null;
}
function _formatCookieValue(value, values) {
    var cookieValue = value || STR_EMPTY$1;
    objForEachKey$1(values, function (name, theValue) {
        cookieValue += "; " + name + (!isNullOrUndefined$1(theValue) ? "=" + theValue : STR_EMPTY$1);
    });
    return cookieValue;
}
function _getCookieValue(name) {
    var cookieValue = STR_EMPTY$1;
    !_doc && _getDoc();
    if (_doc.v) {
        var theCookie = _doc.v[strCookie] || STR_EMPTY$1;
        if (_parsedCookieValue !== theCookie) {
            _cookieCache = _extractParts(theCookie);
            _parsedCookieValue = theCookie;
        }
        cookieValue = strTrim(_cookieCache[name] || STR_EMPTY$1);
    }
    return cookieValue;
}
function _setCookieValue(name, cookieValue) {
    !_doc && _getDoc();
    if (_doc.v) {
        _doc.v[strCookie] = name + "=" + cookieValue;
    }
}
function uaDisallowsSameSiteNone(userAgent) {
    if (!isString$2(userAgent)) {
        return false;
    }
    // Cover all iOS based browsers here. This includes:
    // - Safari on iOS 12 for iPhone, iPod Touch, iPad
    // - WkWebview on iOS 12 for iPhone, iPod Touch, iPad
    // - Chrome on iOS 12 for iPhone, iPod Touch, iPad
    // All of which are broken by SameSite=None, because they use the iOS networking stack
    if (strContains(userAgent, "CPU iPhone OS 12") || strContains(userAgent, "iPad; CPU OS 12")) {
        return true;
    }
    // Cover Mac OS X based browsers that use the Mac OS networking stack. This includes:
    // - Safari on Mac OS X
    // This does not include:
    // - Internal browser on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if (strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && strContains(userAgent, "Version/") && strContains(userAgent, "Safari")) {
        return true;
    }
    // Cover Mac OS X internal browsers that use the Mac OS networking stack. This includes:
    // - Internal browser on Mac OS X
    // This does not include:
    // - Safari on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if (strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && strEndsWith(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) {
        return true;
    }
    // Cover Chrome 50-69, because some versions are broken by SameSite=None, and none in this range require it.
    // Note: this covers some pre-Chromium Edge versions, but pre-Chromim Edge does not require SameSite=None, so this is fine.
    // Note: this regex applies to Windows, Mac OS X, and Linux, deliberately.
    if (strContains(userAgent, "Chrome/5") || strContains(userAgent, "Chrome/6")) {
        return true;
    }
    // Unreal Engine runs Chromium 59, but does not advertise as Chrome until 4.23. Treat versions of Unreal
    // that don't specify their Chrome version as lacking support for SameSite=None.
    if (strContains(userAgent, "UnrealEngine") && !strContains(userAgent, "Chrome")) {
        return true;
    }
    // UCBrowser < 12.13.2 ignores Set-Cookie headers with SameSite=None
    // NB: this rule isn't complete - you need regex to make a complete rule.
    // See: https://www.chromium.org/updates/same-site/incompatible-clients
    if (strContains(userAgent, "UCBrowser/12") || strContains(userAgent, "UCBrowser/11")) {
        return true;
    }
    return false;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var defaultValues$2 = {
    perfEvtsSendAll: false
};
function _runScheduledListeners(asyncNotifications) {
    asyncNotifications.h = null;
    var callbacks = asyncNotifications.cb;
    asyncNotifications.cb = [];
    arrForEach$1(callbacks, function (cb) {
        // Run the listener in a try-catch to ensure that a single listener failing doesn't prevent the others from running
        safe(cb.fn, [cb.arg]);
    });
}
// This function is used to combine the logic of running the listeners and handling the async notifications so that they don't
// create multiple timers if there are multiple async listeners.
function _runListeners(listeners, name, asyncNotifications, callback) {
    arrForEach$1(listeners, function (listener) {
        if (listener && listener[name]) {
            if (asyncNotifications) {
                // Schedule the callback to be called after the current call stack has cleared.
                asyncNotifications.cb[_DYN_PUSH$2 /* @min:%2epush */]({
                    fn: callback,
                    arg: listener
                });
                asyncNotifications.h = asyncNotifications.h || scheduleTimeout$1(_runScheduledListeners, 0, asyncNotifications);
            }
            else {
                // Run the listener in a try-catch to ensure that a single listener failing doesn't prevent the others from running
                safe(callback, [listener]);
            }
        }
    });
}
/**
 * Class to manage sending notifications to all the listeners.
 */
var NotificationManager = /** @class */ (function () {
    function NotificationManager(config) {
        this.listeners = [];
        var perfEvtsSendAll;
        var unloadHandler;
        var _listeners = [];
        var _asyncNotifications = {
            h: null,
            cb: []
        };
        var cfgHandler = createDynamicConfig(config, defaultValues$2);
        unloadHandler = cfgHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
            perfEvtsSendAll = !!details.cfg.perfEvtsSendAll;
        });
        dynamicProto(NotificationManager, this, function (_self) {
            objDefine$1(_self, "listeners", {
                g: function () { return _listeners; }
            });
            _self[_DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */] = function (listener) {
                _listeners[_DYN_PUSH$2 /* @min:%2epush */](listener);
            };
            /**
             * Removes all instances of the listener.
             * @param listener - AWTNotificationListener to remove.
             */
            _self[_DYN_REMOVE_NOTIFICATION_0 /* @min:%2eremoveNotificationListener */] = function (listener) {
                var index = arrIndexOf(_listeners, listener);
                while (index > -1) {
                    _listeners[_DYN_SPLICE /* @min:%2esplice */](index, 1);
                    index = arrIndexOf(_listeners, listener);
                }
            };
            /**
             * Notification for events sent.
             * @param events - The array of events that have been sent.
             */
            _self[STR_EVENTS_SENT /* @min:%2eeventsSent */] = function (events) {
                _runListeners(_listeners, STR_EVENTS_SENT, _asyncNotifications, function (listener) {
                    listener[STR_EVENTS_SENT /* @min:%2eeventsSent */](events);
                });
            };
            /**
             * Notification for events being discarded.
             * @param events - The array of events that have been discarded by the SDK.
             * @param reason - The reason for which the SDK discarded the events. The EventsDiscardedReason
             * constant should be used to check the different values.
             */
            _self[STR_EVENTS_DISCARDED /* @min:%2eeventsDiscarded */] = function (events, reason) {
                _runListeners(_listeners, STR_EVENTS_DISCARDED, _asyncNotifications, function (listener) {
                    listener[STR_EVENTS_DISCARDED /* @min:%2eeventsDiscarded */](events, reason);
                });
            };
            /**
             * [Optional] A function called when the events have been requested to be sent to the sever.
             * @param sendReason - The reason why the event batch is being sent.
             * @param isAsync - A flag which identifies whether the requests are being sent in an async or sync manner.
             */
            _self[STR_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */] = function (sendReason, isAsync) {
                _runListeners(_listeners, STR_EVENTS_SEND_REQUEST, isAsync ? _asyncNotifications : null, function (listener) {
                    listener[STR_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */](sendReason, isAsync);
                });
            };
            _self[STR_PERF_EVENT /* @min:%2eperfEvent */] = function (perfEvent) {
                if (perfEvent) {
                    // Send all events or only parent events
                    if (perfEvtsSendAll || !perfEvent[_DYN_IS_CHILD_EVT /* @min:%2eisChildEvt */]()) {
                        _runListeners(_listeners, STR_PERF_EVENT, null, function (listener) {
                            if (perfEvent[_DYN_IS_ASYNC /* @min:%2eisAsync */]) {
                                scheduleTimeout$1(function () { return listener[STR_PERF_EVENT /* @min:%2eperfEvent */](perfEvent); }, 0);
                            }
                            else {
                                listener[STR_PERF_EVENT /* @min:%2eperfEvent */](perfEvent);
                            }
                        });
                    }
                }
            };
            _self[STR_OFFLINE_STORE /* @min:%2eofflineEventsStored */] = function (events) {
                if (events && events[_DYN_LENGTH$5 /* @min:%2elength */]) {
                    _runListeners(_listeners, STR_OFFLINE_STORE, _asyncNotifications, function (listener) {
                        listener[STR_OFFLINE_STORE /* @min:%2eofflineEventsStored */](events);
                    });
                }
            };
            _self[STR_OFFLINE_SENT /* @min:%2eofflineBatchSent */] = function (batch) {
                if (batch && batch[_DYN_DATA$1 /* @min:%2edata */]) {
                    _runListeners(_listeners, STR_OFFLINE_SENT, _asyncNotifications, function (listener) {
                        listener[STR_OFFLINE_SENT /* @min:%2eofflineBatchSent */](batch);
                    });
                }
            };
            _self[STR_OFFLINE_DROP /* @min:%2eofflineBatchDrop */] = function (cnt, reason) {
                if (cnt > 0) {
                    var rn_1 = reason || 0; // default is unknown
                    _runListeners(_listeners, STR_OFFLINE_DROP, _asyncNotifications, function (listener) {
                        listener[STR_OFFLINE_DROP /* @min:%2eofflineBatchDrop */](cnt, rn_1);
                    });
                }
            };
            _self[_DYN_UNLOAD /* @min:%2eunload */] = function (isAsync) {
                var _finishUnload = function () {
                    unloadHandler && unloadHandler.rm();
                    unloadHandler = null;
                    _listeners = [];
                    // Clear any async listener
                    _asyncNotifications.h && _asyncNotifications.h[_DYN_CANCEL /* @min:%2ecancel */]();
                    _asyncNotifications.h = null;
                    _asyncNotifications.cb = [];
                };
                var waiting;
                _runListeners(_listeners, "unload", null, function (listener) {
                    var asyncUnload = listener[_DYN_UNLOAD /* @min:%2eunload */](isAsync);
                    if (asyncUnload) {
                        if (!waiting) {
                            waiting = [];
                        }
                        waiting[_DYN_PUSH$2 /* @min:%2epush */](asyncUnload);
                    }
                });
                if (waiting) {
                    return createPromise(function (resolve) {
                        return doAwaitResponse(createAllPromise(waiting), function () {
                            _finishUnload();
                            resolve();
                        });
                    });
                }
                else {
                    _finishUnload();
                }
            };
        });
    }
// Removed Stub for NotificationManager.prototype.addNotificationListener.
// Removed Stub for NotificationManager.prototype.removeNotificationListener.
// Removed Stub for NotificationManager.prototype.eventsSent.
// Removed Stub for NotificationManager.prototype.eventsDiscarded.
// Removed Stub for NotificationManager.prototype.eventsSendRequest.
// Removed Stub for NotificationManager.prototype.perfEvent.
// Removed Stub for NotificationManager.prototype.unload.
// Removed Stub for NotificationManager.prototype.offlineEventsStored.
// Removed Stub for NotificationManager.prototype.offlineBatchSent.
// Removed Stub for NotificationManager.prototype.offlineBatchDrop.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    NotificationManager.__ieDyn=1;

    return NotificationManager;
}());

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var strExecutionContextKey = "ctx";
var strParentContextKey = "ParentContextKey";
var strChildrenContextKey = "ChildrenContextKey";
var _defaultPerfManager = null;
var PerfEvent = /** @class */ (function () {
    function PerfEvent(name, payloadDetails, isAsync) {
        var _self = this;
        _self.start = utcNow();
        _self[_DYN_NAME$3 /* @min:%2ename */] = name;
        _self[_DYN_IS_ASYNC /* @min:%2eisAsync */] = isAsync;
        _self[_DYN_IS_CHILD_EVT /* @min:%2eisChildEvt */] = function () { return false; };
        if (isFunction$2(payloadDetails)) {
            // Create an accessor to minimize the potential performance impact of executing the payloadDetails callback
            var theDetails_1;
            objDefine$1(_self, "payload", {
                g: function () {
                    // Delay the execution of the payloadDetails until needed
                    if (!theDetails_1 && isFunction$2(payloadDetails)) {
                        theDetails_1 = payloadDetails();
                        // clear it out now so the referenced objects can be garbage collected
                        payloadDetails = null;
                    }
                    return theDetails_1;
                }
            });
        }
        _self[_DYN_GET_CTX /* @min:%2egetCtx */] = function (key) {
            if (key) {
                // The parent and child links are located directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent[strParentContextKey] || key === PerfEvent[strChildrenContextKey]) {
                    return _self[key];
                }
                return (_self[strExecutionContextKey] || {})[key];
            }
            return null;
        };
        _self[_DYN_SET_CTX /* @min:%2esetCtx */] = function (key, value) {
            if (key) {
                // Put the parent and child links directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent[strParentContextKey]) {
                    // Simple assumption, if we are setting a parent then we must be a child
                    if (!_self[key]) {
                        _self[_DYN_IS_CHILD_EVT /* @min:%2eisChildEvt */] = function () { return true; };
                    }
                    _self[key] = value;
                }
                else if (key === PerfEvent[strChildrenContextKey]) {
                    _self[key] = value;
                }
                else {
                    var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            }
        };
        _self[_DYN_COMPLETE /* @min:%2ecomplete */] = function () {
            var childTime = 0;
            var childEvts = _self[_DYN_GET_CTX /* @min:%2egetCtx */](PerfEvent[strChildrenContextKey]);
            if (isArray$1(childEvts)) {
                for (var lp = 0; lp < childEvts[_DYN_LENGTH$5 /* @min:%2elength */]; lp++) {
                    var childEvt = childEvts[lp];
                    if (childEvt) {
                        childTime += childEvt[_DYN_TIME /* @min:%2etime */];
                    }
                }
            }
            _self[_DYN_TIME /* @min:%2etime */] = utcNow() - _self.start;
            _self.exTime = _self[_DYN_TIME /* @min:%2etime */] - childTime;
            _self[_DYN_COMPLETE /* @min:%2ecomplete */] = function () { };
        };
    }
    PerfEvent.ParentContextKey = "parent";
    PerfEvent.ChildrenContextKey = "childEvts";
    return PerfEvent;
}());
var PerfManager = /** @class */ (function () {
    function PerfManager(manager) {
        /**
         * General bucket used for execution context set and retrieved via setCtx() and getCtx.
         * Defined as private so it can be visualized via the DebugPlugin
         */
        this.ctx = {};
        dynamicProto(PerfManager, this, function (_self) {
            _self.create = function (src, payloadDetails, isAsync) {
                // TODO (@MSNev): at some point we will want to add additional configuration to "select" which events to instrument
                // for now this is just a simple do everything.
                return new PerfEvent(src, payloadDetails, isAsync);
            };
            _self.fire = function (perfEvent) {
                if (perfEvent) {
                    perfEvent[_DYN_COMPLETE /* @min:%2ecomplete */]();
                    if (manager && isFunction$2(manager[STR_PERF_EVENT /* @min:%2eperfEvent */])) {
                        manager[STR_PERF_EVENT /* @min:%2eperfEvent */](perfEvent);
                    }
                }
            };
            _self[_DYN_SET_CTX /* @min:%2esetCtx */] = function (key, value) {
                if (key) {
                    var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            };
            _self[_DYN_GET_CTX /* @min:%2egetCtx */] = function (key) {
                return (_self[strExecutionContextKey] || {})[key];
            };
        });
    }
// Removed Stub for PerfManager.prototype.create.
// Removed Stub for PerfManager.prototype.fire.
// Removed Stub for PerfManager.prototype.setCtx.
// Removed Stub for PerfManager.prototype.getCtx.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PerfManager.__ieDyn=1;

    return PerfManager;
}());
var doPerfActiveKey = "CoreUtils.doPerf";
/**
 * Helper function to wrap a function with a perf event
 * @param mgrSource - The Performance Manager or a Performance provider source (may be null)
 * @param getSource - The callback to create the source name for the event (if perf monitoring is enabled)
 * @param func - The function to call and measure
 * @param details - A function to return the payload details
 * @param isAsync - Is the event / function being call asynchronously or synchronously
 */
function doPerf(mgrSource, getSource, func, details, isAsync) {
    if (mgrSource) {
        var perfMgr = mgrSource;
        if (perfMgr[STR_GET_PERF_MGR]) {
            // Looks like a perf manager provider object
            perfMgr = perfMgr[STR_GET_PERF_MGR]();
        }
        if (perfMgr) {
            var perfEvt = void 0;
            var currentActive = perfMgr[_DYN_GET_CTX /* @min:%2egetCtx */](doPerfActiveKey);
            try {
                perfEvt = perfMgr.create(getSource(), details, isAsync);
                if (perfEvt) {
                    if (currentActive && perfEvt[_DYN_SET_CTX /* @min:%2esetCtx */]) {
                        perfEvt[_DYN_SET_CTX /* @min:%2esetCtx */](PerfEvent[strParentContextKey], currentActive);
                        if (currentActive[_DYN_GET_CTX /* @min:%2egetCtx */] && currentActive[_DYN_SET_CTX /* @min:%2esetCtx */]) {
                            var children = currentActive[_DYN_GET_CTX /* @min:%2egetCtx */](PerfEvent[strChildrenContextKey]);
                            if (!children) {
                                children = [];
                                currentActive[_DYN_SET_CTX /* @min:%2esetCtx */](PerfEvent[strChildrenContextKey], children);
                            }
                            children[_DYN_PUSH$2 /* @min:%2epush */](perfEvt);
                        }
                    }
                    // Set this event as the active event now
                    perfMgr[_DYN_SET_CTX /* @min:%2esetCtx */](doPerfActiveKey, perfEvt);
                    return func(perfEvt);
                }
            }
            catch (ex) {
                if (perfEvt && perfEvt[_DYN_SET_CTX /* @min:%2esetCtx */]) {
                    perfEvt[_DYN_SET_CTX /* @min:%2esetCtx */]("exception", ex);
                }
            }
            finally {
                // fire the perf event
                if (perfEvt) {
                    perfMgr.fire(perfEvt);
                }
                // Reset the active event to the previous value
                perfMgr[_DYN_SET_CTX /* @min:%2esetCtx */](doPerfActiveKey, currentActive);
            }
        }
    }
    return func();
}
/**
 * Get the current global performance manager that will be used with no performance manager is supplied.
 * @returns - The current default manager
 */
function getGblPerfMgr() {
    return _defaultPerfManager;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * generate W3C trace id
 */
function generateW3CId() {
    var hexValues = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    // rfc4122 version 4 UUID without dashes and with lowercase letters
    var oct = STR_EMPTY$1, tmp;
    for (var a = 0; a < 4; a++) {
        tmp = random32();
        oct +=
            hexValues[tmp & 0xF] +
                hexValues[tmp >> 4 & 0xF] +
                hexValues[tmp >> 8 & 0xF] +
                hexValues[tmp >> 12 & 0xF] +
                hexValues[tmp >> 16 & 0xF] +
                hexValues[tmp >> 20 & 0xF] +
                hexValues[tmp >> 24 & 0xF] +
                hexValues[tmp >> 28 & 0xF];
    }
    // "Set the two most significant bits (bits 6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively"
    var clockSequenceHi = hexValues[8 + (random32() & 0x03) | 0];
    return strSubstr(oct, 0, 8) + strSubstr(oct, 9, 4) + "4" + strSubstr(oct, 13, 3) + clockSequenceHi + strSubstr(oct, 16, 3) + strSubstr(oct, 19, 12);
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var DEFAULT_VERSION = "00";
var INVALID_VERSION = "ff";
var INVALID_TRACE_ID = "00000000000000000000000000000000";
var INVALID_SPAN_ID = "0000000000000000";
function _isValid(value, len, invalidValue) {
    if (value && value[_DYN_LENGTH$5 /* @min:%2elength */] === len && value !== invalidValue) {
        return !!value.match(/^[\da-f]*$/i);
    }
    return false;
}
function _formatValue(value, len, defValue) {
    if (_isValid(value, len)) {
        return value;
    }
    return defValue;
}
function _formatFlags(value) {
    if (isNaN(value) || value < 0 || value > 255) {
        value = 0x01;
    }
    var result = value.toString(16);
    while (result[_DYN_LENGTH$5 /* @min:%2elength */] < 2) {
        result = "0" + result;
    }
    return result;
}
/**
 * Create a new ITraceParent instance using the provided values.
 * @param traceId - The traceId to use, when invalid a new random W3C id will be generated.
 * @param spanId - The parent/span id to use, a new random value will be generated if it is invalid.
 * @param flags - The traceFlags to use, defaults to zero (0) if not supplied or invalid
 * @param version - The version to used, defaults to version "01" if not supplied or invalid.
 * @returns
 */
function createTraceParent(traceId, spanId, flags, version) {
    var _a;
    return _a = {},
        _a[_DYN_VERSION$1 /* @min:version */] = _isValid(version, 2, INVALID_VERSION) ? version : DEFAULT_VERSION,
        _a[_DYN_TRACE_ID$2 /* @min:traceId */] = isValidTraceId(traceId) ? traceId : generateW3CId(),
        _a[_DYN_SPAN_ID$1 /* @min:spanId */] = isValidSpanId(spanId) ? spanId : strLeft(generateW3CId(), 16),
        _a.traceFlags = flags >= 0 && flags <= 0xFF ? flags : 1,
        _a;
}
/**
 * Is the provided W3c Trace Id a valid string representation, it must be a 32-character string
 * of lowercase hexadecimal characters for example, 4bf92f3577b34da6a3ce929d0e0e4736.
 * If all characters as zero (00000000000000000000000000000000) it will be considered an invalid value.
 * @param value - The W3c trace Id to be validated
 * @returns true if valid otherwise false
 */
function isValidTraceId(value) {
    return _isValid(value, 32, INVALID_TRACE_ID);
}
/**
 * Is the provided W3c span id (aka. parent id) a valid string representation, it must be a 16-character
 * string of lowercase hexadecimal characters, for example, 00f067aa0ba902b7.
 * If all characters are zero (0000000000000000) this is considered an invalid value.
 * @param value - The W3c span id to be validated
 * @returns true if valid otherwise false
 */
function isValidSpanId(value) {
    return _isValid(value, 16, INVALID_SPAN_ID);
}
/**
 * Format the ITraceParent value as a string using the supported and know version formats.
 * So even if the passed traceParent is a later version the string value returned from this
 * function will convert it to only the known version formats.
 * This currently only supports version "00" and invalid "ff"
 * @param value - The parsed traceParent value
 * @returns
 */
function formatTraceParent(value) {
    if (value) {
        // Special Note: This only supports formatting as version 00, future versions should encode any known supported version
        // So parsing a future version will populate the correct version value but reformatting will reduce it to version 00.
        var flags = _formatFlags(value[_DYN_TRACE_FLAGS$1 /* @min:%2etraceFlags */]);
        if (!_isValid(flags, 2)) {
            flags = "01";
        }
        var version = value[_DYN_VERSION$1 /* @min:%2eversion */] || DEFAULT_VERSION;
        if (version !== "00" && version !== "ff") {
            // Reduce version to "00"
            version = DEFAULT_VERSION;
        }
        // Format as version 00
        return "".concat(version.toLowerCase(), "-").concat(_formatValue(value.traceId, 32, INVALID_TRACE_ID).toLowerCase(), "-").concat(_formatValue(value.spanId, 16, INVALID_SPAN_ID).toLowerCase(), "-").concat(flags.toLowerCase());
    }
    return "";
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var pluginStateData = createElmNodeData("plugin");
function _getPluginState(plugin) {
    return pluginStateData.get(plugin, "state", {}, true);
}
/**
 * Initialize the queue of plugins
 * @param plugins - The array of plugins to initialize and setting of the next plugin
 * @param config - The current config for the instance
 * @param core - THe current core instance
 * @param extensions - The extensions
 */
function initializePlugins(processContext, extensions) {
    // Set the next plugin and identified the uninitialized plugins
    var initPlugins = [];
    var lastPlugin = null;
    var proxy = processContext[_DYN_GET_NEXT /* @min:%2egetNext */]();
    var pluginState;
    while (proxy) {
        var thePlugin = proxy[_DYN_GET_PLUGIN /* @min:%2egetPlugin */]();
        if (thePlugin) {
            if (lastPlugin && lastPlugin[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */] && thePlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */]) {
                // Set this plugin as the next for the previous one
                lastPlugin[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */](thePlugin);
            }
            pluginState = _getPluginState(thePlugin);
            var isInitialized = !!pluginState[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */];
            if (thePlugin[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]) {
                isInitialized = thePlugin[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]();
            }
            if (!isInitialized) {
                initPlugins[_DYN_PUSH$2 /* @min:%2epush */](thePlugin);
            }
            lastPlugin = thePlugin;
            proxy = proxy[_DYN_GET_NEXT /* @min:%2egetNext */]();
        }
    }
    // Now initialize the plugins
    arrForEach$1(initPlugins, function (thePlugin) {
        var core = processContext[STR_CORE /* @min:%2ecore */]();
        thePlugin[_DYN_INITIALIZE$1 /* @min:%2einitialize */](processContext.getCfg(), core, extensions, processContext[_DYN_GET_NEXT /* @min:%2egetNext */]());
        pluginState = _getPluginState(thePlugin);
        // Only add the core to the state if the plugin didn't set it (doesn't extend from BaseTelemetryPlugin)
        if (!thePlugin[STR_CORE] && !pluginState[STR_CORE]) {
            pluginState[STR_CORE] = core;
        }
        pluginState[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */] = true;
        delete pluginState[_DYN_TEARDOWN /* @min:%2eteardown */];
    });
}
function sortPlugins(plugins) {
    // Sort by priority
    return plugins.sort(function (extA, extB) {
        var result = 0;
        if (extB) {
            var bHasProcess = extB[STR_PROCESS_TELEMETRY];
            if (extA[STR_PROCESS_TELEMETRY]) {
                result = bHasProcess ? extA[STR_PRIORITY] - extB[STR_PRIORITY] : 1;
            }
            else if (bHasProcess) {
                result = -1;
            }
        }
        else {
            result = extA ? 1 : -1;
        }
        return result;
    });
    // sort complete
}
/**
 * Creates a IDistributedTraceContext which optionally also "sets" the value on a parent
 * @param parentCtx - An optional parent distributed trace instance
 * @returns A new IDistributedTraceContext instance that uses an internal temporary object
 */
function createDistributedTraceContext(parentCtx) {
    var trace = {};
    return {
        getName: function () {
            return trace[_DYN_NAME$3 /* @min:%2ename */];
        },
        setName: function (newValue) {
            parentCtx && parentCtx.setName(newValue);
            trace[_DYN_NAME$3 /* @min:%2ename */] = newValue;
        },
        getTraceId: function () {
            return trace[_DYN_TRACE_ID$2 /* @min:%2etraceId */];
        },
        setTraceId: function (newValue) {
            parentCtx && parentCtx.setTraceId(newValue);
            if (isValidTraceId(newValue)) {
                trace[_DYN_TRACE_ID$2 /* @min:%2etraceId */] = newValue;
            }
        },
        getSpanId: function () {
            return trace[_DYN_SPAN_ID$1 /* @min:%2espanId */];
        },
        setSpanId: function (newValue) {
            parentCtx && parentCtx.setSpanId(newValue);
            if (isValidSpanId(newValue)) {
                trace[_DYN_SPAN_ID$1 /* @min:%2espanId */] = newValue;
            }
        },
        getTraceFlags: function () {
            return trace[_DYN_TRACE_FLAGS$1 /* @min:%2etraceFlags */];
        },
        setTraceFlags: function (newTraceFlags) {
            parentCtx && parentCtx.setTraceFlags(newTraceFlags);
            trace[_DYN_TRACE_FLAGS$1 /* @min:%2etraceFlags */] = newTraceFlags;
        }
    };
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var strTelemetryPluginChain = "TelemetryPluginChain";
var strHasRunFlags = "_hasRun";
var strGetTelCtx = "_getTelCtx";
var _chainId = 0;
function _getNextProxyStart(proxy, core, startAt) {
    while (proxy) {
        if (proxy[_DYN_GET_PLUGIN /* @min:%2egetPlugin */]() === startAt) {
            return proxy;
        }
        proxy = proxy[_DYN_GET_NEXT /* @min:%2egetNext */]();
    }
    // This wasn't found in the existing chain so create an isolated one with just this plugin
    return createTelemetryProxyChain([startAt], core.config || {}, core);
}
/**
 * @ignore
 * @param telemetryChain
 * @param dynamicHandler
 * @param core
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 * @returns
 */
function _createInternalContext(telemetryChain, dynamicHandler, core, startAt) {
    // We have a special case where we want to start execution from this specific plugin
    // or we simply reuse the existing telemetry plugin chain (normal execution case)
    var _nextProxy = null; // By Default set as no next plugin
    var _onComplete = [];
    if (!dynamicHandler) {
        dynamicHandler = createDynamicConfig({}, null, core[_DYN_LOGGER /* @min:%2elogger */]);
    }
    if (startAt !== null) {
        // There is no next element (null) vs not defined (undefined) so use the full chain
        _nextProxy = startAt ? _getNextProxyStart(telemetryChain, core, startAt) : telemetryChain;
    }
    var context = {
        _next: _moveNext,
        ctx: {
            core: function () {
                return core;
            },
            diagLog: function () {
                return safeGetLogger(core, dynamicHandler.cfg);
            },
            getCfg: function () {
                return dynamicHandler.cfg;
            },
            getExtCfg: _resolveExtCfg,
            getConfig: _getConfig,
            hasNext: function () {
                return !!_nextProxy;
            },
            getNext: function () {
                return _nextProxy;
            },
            setNext: function (nextPlugin) {
                _nextProxy = nextPlugin;
            },
            iterate: _iterateChain,
            onComplete: _addOnComplete
        }
    };
    function _addOnComplete(onComplete, that) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        if (onComplete) {
            _onComplete[_DYN_PUSH$2 /* @min:%2epush */]({
                func: onComplete,
                self: !isUndefined$1(that) ? that : context.ctx,
                args: args
            });
        }
    }
    function _moveNext() {
        var nextProxy = _nextProxy;
        // Automatically move to the next plugin
        _nextProxy = nextProxy ? nextProxy[_DYN_GET_NEXT /* @min:%2egetNext */]() : null;
        if (!nextProxy) {
            var onComplete = _onComplete;
            if (onComplete && onComplete[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                arrForEach$1(onComplete, function (completeDetails) {
                    try {
                        completeDetails.func.call(completeDetails.self, completeDetails.args);
                    }
                    catch (e) {
                        _throwInternal(core[_DYN_LOGGER /* @min:%2elogger */], 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, "Unexpected Exception during onComplete - " + dumpObj$2(e));
                    }
                });
                _onComplete = [];
            }
        }
        return nextProxy;
    }
    function _getExtCfg(identifier, createIfMissing) {
        var idCfg = null;
        var cfg = dynamicHandler.cfg;
        if (cfg && identifier) {
            var extCfg = cfg[STR_EXTENSION_CONFIG /* @min:%2eextensionConfig */];
            if (!extCfg && createIfMissing) {
                extCfg = {};
            }
            // Always set the value so that the property always exists
            cfg[STR_EXTENSION_CONFIG] = extCfg; // Note: it is valid for the "value" to be undefined
            // Calling `ref()` has a side effect of causing the referenced property to become dynamic  (if not already)
            extCfg = dynamicHandler.ref(cfg, STR_EXTENSION_CONFIG);
            if (extCfg) {
                idCfg = extCfg[identifier];
                if (!idCfg && createIfMissing) {
                    idCfg = {};
                }
                // Always set the value so that the property always exists
                extCfg[identifier] = idCfg; // Note: it is valid for the "value" to be undefined
                // Calling `ref()` has a side effect of causing the referenced property to become dynamic  (if not already)
                idCfg = dynamicHandler.ref(extCfg, identifier);
            }
        }
        return idCfg;
    }
    function _resolveExtCfg(identifier, defaultValues) {
        var newConfig = _getExtCfg(identifier, true);
        if (defaultValues) {
            // Enumerate over the defaultValues and if not already populated attempt to
            // find a value from the root config or use the default value
            objForEachKey$1(defaultValues, function (field, defaultValue) {
                // for each unspecified field, set the default value
                if (isNullOrUndefined$1(newConfig[field])) {
                    var cfgValue = dynamicHandler.cfg[field];
                    if (cfgValue || !isNullOrUndefined$1(cfgValue)) {
                        newConfig[field] = cfgValue;
                    }
                }
                _applyDefaultValue(dynamicHandler, newConfig, field, defaultValue);
            });
        }
        return dynamicHandler[_DYN_SET_DF /* @min:%2esetDf */](newConfig, defaultValues);
    }
    function _getConfig(identifier, field, defaultValue) {
        if (defaultValue === void 0) { defaultValue = false; }
        var theValue;
        var extConfig = _getExtCfg(identifier, false);
        var rootConfig = dynamicHandler.cfg;
        if (extConfig && (extConfig[field] || !isNullOrUndefined$1(extConfig[field]))) {
            theValue = extConfig[field];
        }
        else if (rootConfig[field] || !isNullOrUndefined$1(rootConfig[field])) {
            theValue = rootConfig[field];
        }
        return (theValue || !isNullOrUndefined$1(theValue)) ? theValue : defaultValue;
    }
    function _iterateChain(cb) {
        // Keep processing until we reach the end of the chain
        var nextPlugin;
        while (!!(nextPlugin = context._next())) {
            var plugin = nextPlugin[_DYN_GET_PLUGIN /* @min:%2egetPlugin */]();
            if (plugin) {
                // callback with the current on
                cb(plugin);
            }
        }
    }
    return context;
}
/**
 * Creates a new Telemetry Item context with the current config, core and plugin execution chain
 * @param plugins - The plugin instances that will be executed
 * @param config - The current config
 * @param core - The current core instance
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 */
function createProcessTelemetryContext(telemetryChain, cfg, core, startAt) {
    var config = createDynamicConfig(cfg);
    var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(env) {
        var nextPlugin = internalContext._next();
        if (nextPlugin) {
            // Run the next plugin which will call "processNext()"
            nextPlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */](env, context);
        }
        return !nextPlugin;
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) { plugins = null; }
        if (isArray$1(plugins)) {
            plugins = createTelemetryProxyChain(plugins, config.cfg, core, startAt);
        }
        return createProcessTelemetryContext(plugins || context[_DYN_GET_NEXT /* @min:%2egetNext */](), config.cfg, core, startAt);
    }
    context[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */] = _processNext;
    context[_DYN_CREATE_NEW$1 /* @min:%2ecreateNew */] = _createNew;
    return context;
}
/**
 * Creates a new Telemetry Item context with the current config, core and plugin execution chain for handling the unloading of the chain
 * @param plugins - The plugin instances that will be executed
 * @param config - The current config
 * @param core - The current core instance
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 */
function createProcessTelemetryUnloadContext(telemetryChain, core, startAt) {
    var config = createDynamicConfig(core.config);
    var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(unloadState) {
        var nextPlugin = internalContext._next();
        nextPlugin && nextPlugin[_DYN_UNLOAD /* @min:%2eunload */](context, unloadState);
        return !nextPlugin;
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) { plugins = null; }
        if (isArray$1(plugins)) {
            plugins = createTelemetryProxyChain(plugins, config.cfg, core, startAt);
        }
        return createProcessTelemetryUnloadContext(plugins || context[_DYN_GET_NEXT /* @min:%2egetNext */](), core, startAt);
    }
    context[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */] = _processNext;
    context[_DYN_CREATE_NEW$1 /* @min:%2ecreateNew */] = _createNew;
    return context;
}
/**
 * Creates a new Telemetry Item context with the current config, core and plugin execution chain for updating the configuration
 * @param plugins - The plugin instances that will be executed
 * @param config - The current config
 * @param core - The current core instance
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 */
function createProcessTelemetryUpdateContext(telemetryChain, core, startAt) {
    var config = createDynamicConfig(core.config);
    var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(updateState) {
        return context.iterate(function (plugin) {
            if (isFunction$2(plugin[_DYN_UPDATE$1 /* @min:%2eupdate */])) {
                plugin[_DYN_UPDATE$1 /* @min:%2eupdate */](context, updateState);
            }
        });
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) { plugins = null; }
        if (isArray$1(plugins)) {
            plugins = createTelemetryProxyChain(plugins, config.cfg, core, startAt);
        }
        return createProcessTelemetryUpdateContext(plugins || context[_DYN_GET_NEXT /* @min:%2egetNext */](), core, startAt);
    }
    context[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */] = _processNext;
    context[_DYN_CREATE_NEW$1 /* @min:%2ecreateNew */] = _createNew;
    return context;
}
/**
 * Creates an execution chain from the array of plugins
 * @param plugins - The array of plugins that will be executed in this order
 * @param defItemCtx - The default execution context to use when no telemetry context is passed to processTelemetry(), this
 * should be for legacy plugins only. Currently, only used for passing the current core instance and to provide better error
 * reporting (hasRun) when errors occur.
 */
function createTelemetryProxyChain(plugins, config, core, startAt) {
    var firstProxy = null;
    var add = startAt ? false : true;
    if (isArray$1(plugins) && plugins[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
        // Create the proxies and wire up the next plugin chain
        var lastProxy_1 = null;
        arrForEach$1(plugins, function (thePlugin) {
            if (!add && startAt === thePlugin) {
                add = true;
            }
            if (add && thePlugin && isFunction$2(thePlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */])) {
                // Only add plugins that are processors
                var newProxy = createTelemetryPluginProxy(thePlugin, config, core);
                if (!firstProxy) {
                    firstProxy = newProxy;
                }
                if (lastProxy_1) {
                    // Set this new proxy as the next for the previous one
                    lastProxy_1._setNext(newProxy);
                }
                lastProxy_1 = newProxy;
            }
        });
    }
    if (startAt && !firstProxy) {
        // Special case where the "startAt" was not in the original list of plugins
        return createTelemetryProxyChain([startAt], config, core);
    }
    return firstProxy;
}
/**
 * Create the processing telemetry proxy instance, the proxy is used to abstract the current plugin to allow monitoring and
 * execution plugins while passing around the dynamic execution state (IProcessTelemetryContext), the proxy instance no longer
 * contains any execution state and can be reused between requests (this was not the case for 2.7.2 and earlier with the
 * TelemetryPluginChain class).
 * @param plugin - The plugin instance to proxy
 * @param config - The default execution context to use when no telemetry context is passed to processTelemetry(), this
 * should be for legacy plugins only. Currently, only used for passing the current core instance and to provide better error
 * reporting (hasRun) when errors occur.
 * @returns
 */
function createTelemetryPluginProxy(plugin, config, core) {
    var nextProxy = null;
    var hasProcessTelemetry = isFunction$2(plugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */]);
    var hasSetNext = isFunction$2(plugin[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */]);
    var chainId;
    if (plugin) {
        chainId = plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */] + "-" + plugin[STR_PRIORITY /* @min:%2epriority */] + "-" + _chainId++;
    }
    else {
        chainId = "Unknown-0-" + _chainId++;
    }
    var proxyChain = {
        getPlugin: function () {
            return plugin;
        },
        getNext: function () {
            return nextProxy;
        },
        processTelemetry: _processTelemetry,
        unload: _unloadPlugin,
        update: _updatePlugin,
        _id: chainId,
        _setNext: function (nextPlugin) {
            nextProxy = nextPlugin;
        }
    };
    function _getTelCtx() {
        var itemCtx;
        // Looks like a plugin didn't pass the (optional) context, so create a new one
        if (plugin && isFunction$2(plugin[strGetTelCtx])) {
            // This plugin extends from the BaseTelemetryPlugin so lets use it
            itemCtx = plugin[strGetTelCtx]();
        }
        if (!itemCtx) {
            // Create a temporary one
            itemCtx = createProcessTelemetryContext(proxyChain, config, core);
        }
        return itemCtx;
    }
    function _processChain(itemCtx, processPluginFn, name, details, isAsync) {
        var hasRun = false;
        var identifier = plugin ? plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */] : strTelemetryPluginChain;
        var hasRunContext = itemCtx[strHasRunFlags];
        if (!hasRunContext) {
            // Assign and populate
            hasRunContext = itemCtx[strHasRunFlags] = {};
        }
        // Ensure that we keep the context in sync
        itemCtx.setNext(nextProxy);
        if (plugin) {
            doPerf(itemCtx[STR_CORE /* @min:%2ecore */](), function () { return identifier + ":" + name; }, function () {
                // Mark this component as having run
                hasRunContext[chainId] = true;
                try {
                    // Set a flag on the next plugin so we know if it was attempted to be executed
                    var nextId = nextProxy ? nextProxy._id : STR_EMPTY$1;
                    if (nextId) {
                        hasRunContext[nextId] = false;
                    }
                    hasRun = processPluginFn(itemCtx);
                }
                catch (error) {
                    var hasNextRun = nextProxy ? hasRunContext[nextProxy._id] : true;
                    if (hasNextRun) {
                        // The next plugin after us has already run so set this one as complete
                        hasRun = true;
                    }
                    if (!nextProxy || !hasNextRun) {
                        // Either we have no next plugin or the current one did not attempt to call the next plugin
                        // Which means the current one is the root of the failure so log/report this failure
                        _throwInternal(itemCtx[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 73 /* _eInternalMessageId.PluginException */, "Plugin [" + identifier + "] failed during " + name + " - " + dumpObj$2(error) + ", run flags: " + dumpObj$2(hasRunContext));
                    }
                }
            }, details, isAsync);
        }
        return hasRun;
    }
    function _processTelemetry(env, itemCtx) {
        itemCtx = itemCtx || _getTelCtx();
        function _callProcessTelemetry(itemCtx) {
            if (!plugin || !hasProcessTelemetry) {
                return false;
            }
            var pluginState = _getPluginState(plugin);
            if (pluginState[_DYN_TEARDOWN /* @min:%2eteardown */] || pluginState[STR_DISABLED]) {
                return false;
            }
            // Ensure that we keep the context in sync (for processNext()), just in case a plugin
            // doesn't calls processTelemetry() instead of itemContext.processNext() or some
            // other form of error occurred
            if (hasSetNext) {
                // Backward compatibility setting the next plugin on the instance
                plugin[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */](nextProxy);
            }
            plugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */](env, itemCtx);
            // Process Telemetry is expected to call itemCtx.processNext() or nextPlugin.processTelemetry()
            return true;
        }
        if (!_processChain(itemCtx, _callProcessTelemetry, "processTelemetry", function () { return ({ item: env }); }, !(env.sync))) {
            // The underlying plugin is either not defined, not enabled or does not have a processTelemetry implementation
            // so we still want the next plugin to be executed.
            itemCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](env);
        }
    }
    function _unloadPlugin(unloadCtx, unloadState) {
        function _callTeardown() {
            // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
            var hasRun = false;
            if (plugin) {
                var pluginState = _getPluginState(plugin);
                var pluginCore = plugin[STR_CORE] || pluginState[STR_CORE /* @min:%2ecore */];
                // Only teardown the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
                if (plugin && (!pluginCore || pluginCore === unloadCtx.core()) && !pluginState[_DYN_TEARDOWN /* @min:%2eteardown */]) {
                    // Handle plugins that don't extend from the BaseTelemetryPlugin
                    pluginState[STR_CORE /* @min:%2ecore */] = null;
                    pluginState[_DYN_TEARDOWN /* @min:%2eteardown */] = true;
                    pluginState[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */] = false;
                    if (plugin[_DYN_TEARDOWN /* @min:%2eteardown */] && plugin[_DYN_TEARDOWN /* @min:%2eteardown */](unloadCtx, unloadState) === true) {
                        // plugin told us that it was going to (or has) call unloadCtx.processNext()
                        hasRun = true;
                    }
                }
            }
            return hasRun;
        }
        if (!_processChain(unloadCtx, _callTeardown, "unload", function () { }, unloadState[_DYN_IS_ASYNC /* @min:%2eisAsync */])) {
            // Only called if we hasRun was not true
            unloadCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](unloadState);
        }
    }
    function _updatePlugin(updateCtx, updateState) {
        function _callUpdate() {
            // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
            var hasRun = false;
            if (plugin) {
                var pluginState = _getPluginState(plugin);
                var pluginCore = plugin[STR_CORE] || pluginState[STR_CORE /* @min:%2ecore */];
                // Only update the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
                if (plugin && (!pluginCore || pluginCore === updateCtx.core()) && !pluginState[_DYN_TEARDOWN /* @min:%2eteardown */]) {
                    if (plugin[_DYN_UPDATE$1 /* @min:%2eupdate */] && plugin[_DYN_UPDATE$1 /* @min:%2eupdate */](updateCtx, updateState) === true) {
                        // plugin told us that it was going to (or has) call unloadCtx.processNext()
                        hasRun = true;
                    }
                }
            }
            return hasRun;
        }
        if (!_processChain(updateCtx, _callUpdate, "update", function () { }, false)) {
            // Only called if we hasRun was not true
            updateCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](updateState);
        }
    }
    return objFreeze$1(proxyChain);
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
function createUnloadHandlerContainer() {
    var handlers = [];
    function _addHandler(handler) {
        if (handler) {
            handlers[_DYN_PUSH$2 /* @min:%2epush */](handler);
        }
    }
    function _runHandlers(unloadCtx, unloadState) {
        arrForEach$1(handlers, function (handler) {
            try {
                handler(unloadCtx, unloadState);
            }
            catch (e) {
                _throwInternal(unloadCtx[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, "Unexpected error calling unload handler - " + dumpObj$2(e));
            }
        });
        handlers = [];
    }
    return {
        add: _addHandler,
        run: _runHandlers
    };
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * Create a IUnloadHookContainer which can be used to remember unload hook functions to be executed during the component unloading
 * process.
 * @returns A new IUnloadHookContainer instance
 */
function createUnloadHookContainer() {
    var _hooks = [];
    function _doUnload(logger) {
        var oldHooks = _hooks;
        _hooks = [];
        // Remove all registered unload hooks
        arrForEach$1(oldHooks, function (fn) {
            // allow either rm or remove callback function
            try {
                (fn.rm || fn.remove).call(fn);
            }
            catch (e) {
                _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, "Unloading:" + dumpObj$2(e));
            }
        });
    }
    function _addHook(hooks) {
        if (hooks) {
            arrAppend(_hooks, hooks);
        }
    }
    return {
        run: _doUnload,
        add: _addHook
    };
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var _a$9;
var strGetPlugin = "getPlugin";
var defaultValues$1 = (_a$9 = {},
    _a$9[STR_EXTENSION_CONFIG] = { isVal: isNotNullOrUndefined, v: {} },
    _a$9);
/**
 * BaseTelemetryPlugin provides a basic implementation of the ITelemetryPlugin interface so that plugins
 * can avoid implementation the same set of boiler plate code as well as provide a base
 * implementation so that new default implementations can be added without breaking all plugins.
 */
var BaseTelemetryPlugin = /** @class */ (function () {
    function BaseTelemetryPlugin() {
        var _self = this; // Setting _self here as it's used outside of the dynamicProto as well
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _isinitialized;
        var _rootCtx; // Used as the root context, holding the current config and initialized core
        var _nextPlugin; // Used for backward compatibility where plugins don't call the main pipeline
        var _unloadHandlerContainer;
        var _hookContainer;
        _initDefaults();
        dynamicProto(BaseTelemetryPlugin, _self, function (_self) {
            _self[_DYN_INITIALIZE$1 /* @min:%2einitialize */] = function (config, core, extensions, pluginChain) {
                _setDefaults(config, core, pluginChain);
                _isinitialized = true;
            };
            _self[_DYN_TEARDOWN /* @min:%2eteardown */] = function (unloadCtx, unloadState) {
                var _a;
                // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
                // or the core being used for unload was not the same core used for initialization.
                var core = _self[STR_CORE /* @min:%2ecore */];
                if (!core || (unloadCtx && core !== unloadCtx[STR_CORE /* @min:%2ecore */]())) {
                    // Do Nothing as either the plugin is not initialized or was not initialized by the current core
                    return;
                }
                var result;
                var unloadDone = false;
                var theUnloadCtx = unloadCtx || createProcessTelemetryUnloadContext(null, core, _nextPlugin && _nextPlugin[strGetPlugin] ? _nextPlugin[strGetPlugin]() : _nextPlugin);
                var theUnloadState = unloadState || (_a = {
                        reason: 0 /* TelemetryUnloadReason.ManualTeardown */
                    },
                    _a[_DYN_IS_ASYNC /* @min:isAsync */] = false,
                    _a);
                function _unloadCallback() {
                    if (!unloadDone) {
                        unloadDone = true;
                        _unloadHandlerContainer.run(theUnloadCtx, unloadState);
                        _hookContainer.run(theUnloadCtx[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */]());
                        if (result === true) {
                            theUnloadCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](theUnloadState);
                        }
                        _initDefaults();
                    }
                }
                if (!_self[_DYN__DO_TEARDOWN /* @min:%2e_doTeardown */] || _self[_DYN__DO_TEARDOWN /* @min:%2e_doTeardown */](theUnloadCtx, theUnloadState, _unloadCallback) !== true) {
                    _unloadCallback();
                }
                else {
                    // Tell the caller that we will be calling processNext()
                    result = true;
                }
                return result;
            };
            _self[_DYN_UPDATE$1 /* @min:%2eupdate */] = function (updateCtx, updateState) {
                // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
                // or the core being used for unload was not the same core used for initialization.
                var core = _self[STR_CORE /* @min:%2ecore */];
                if (!core || (updateCtx && core !== updateCtx[STR_CORE /* @min:%2ecore */]())) {
                    // Do Nothing
                    return;
                }
                var result;
                var updateDone = false;
                var theUpdateCtx = updateCtx || createProcessTelemetryUpdateContext(null, core, _nextPlugin && _nextPlugin[strGetPlugin] ? _nextPlugin[strGetPlugin]() : _nextPlugin);
                var theUpdateState = updateState || {
                    reason: 0 /* TelemetryUpdateReason.Unknown */
                };
                function _updateCallback() {
                    if (!updateDone) {
                        updateDone = true;
                        _setDefaults(theUpdateCtx.getCfg(), theUpdateCtx.core(), theUpdateCtx[_DYN_GET_NEXT /* @min:%2egetNext */]());
                    }
                }
                if (!_self._doUpdate || _self._doUpdate(theUpdateCtx, theUpdateState, _updateCallback) !== true) {
                    _updateCallback();
                }
                else {
                    result = true;
                }
                return result;
            };
            proxyFunctionAs(_self, "_addUnloadCb", function () { return _unloadHandlerContainer; }, "add");
            proxyFunctionAs(_self, "_addHook", function () { return _hookContainer; }, "add");
            objDefine$1(_self, "_unloadHooks", { g: function () { return _hookContainer; } });
        });
        // These are added after the dynamicProto so that are not moved to the prototype
        _self[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */] = function (itemCtx) {
            return _getTelCtx(itemCtx)[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */]();
        };
        _self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */] = function () {
            return _isinitialized;
        };
        _self.setInitialized = function (isInitialized) {
            _isinitialized = isInitialized;
        };
        // _self.getNextPlugin = () => DO NOT IMPLEMENT
        // Sub-classes of this base class *should* not be relying on this value and instead
        // should use processNext() function. If you require access to the plugin use the
        // IProcessTelemetryContext.getNext().getPlugin() while in the pipeline, Note getNext() may return null.
        _self[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */] = function (next) {
            _nextPlugin = next;
        };
        _self[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */] = function (env, itemCtx) {
            if (itemCtx) {
                // Normal core execution sequence
                itemCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](env);
            }
            else if (_nextPlugin && isFunction$2(_nextPlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */])) {
                // Looks like backward compatibility or out of band processing. And as it looks
                // like a ITelemetryPlugin or ITelemetryPluginChain, just call processTelemetry
                _nextPlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */](env, null);
            }
        };
        _self._getTelCtx = _getTelCtx;
        function _getTelCtx(currentCtx) {
            if (currentCtx === void 0) { currentCtx = null; }
            var itemCtx = currentCtx;
            if (!itemCtx) {
                var rootCtx = _rootCtx || createProcessTelemetryContext(null, {}, _self[STR_CORE /* @min:%2ecore */]);
                // tslint:disable-next-line: prefer-conditional-expression
                if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                    // Looks like a chain object
                    itemCtx = rootCtx[_DYN_CREATE_NEW$1 /* @min:%2ecreateNew */](null, _nextPlugin[strGetPlugin]);
                }
                else {
                    itemCtx = rootCtx[_DYN_CREATE_NEW$1 /* @min:%2ecreateNew */](null, _nextPlugin);
                }
            }
            return itemCtx;
        }
        function _setDefaults(config, core, pluginChain) {
            // Make sure the extensionConfig exists and the config is dynamic
            createDynamicConfig(config, defaultValues$1, safeGetLogger(core));
            if (!pluginChain && core) {
                // Get the first plugin from the core
                pluginChain = core[_DYN_GET_PROCESS_TEL_CONT2 /* @min:%2egetProcessTelContext */]()[_DYN_GET_NEXT /* @min:%2egetNext */]();
            }
            var nextPlugin = _nextPlugin;
            if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                // If it looks like a proxy/chain then get the plugin
                nextPlugin = _nextPlugin[strGetPlugin]();
            }
            // Support legacy plugins where core was defined as a property
            _self[STR_CORE /* @min:%2ecore */] = core;
            _rootCtx = createProcessTelemetryContext(pluginChain, config, core, nextPlugin);
        }
        function _initDefaults() {
            _isinitialized = false;
            _self[STR_CORE /* @min:%2ecore */] = null;
            _rootCtx = null;
            _nextPlugin = null;
            _hookContainer = createUnloadHookContainer();
            _unloadHandlerContainer = createUnloadHandlerContainer();
        }
    }
// Removed Stub for BaseTelemetryPlugin.prototype.initialize.
// Removed Stub for BaseTelemetryPlugin.prototype.teardown.
// Removed Stub for BaseTelemetryPlugin.prototype.update.
// Removed Stub for BaseTelemetryPlugin.prototype._addUnloadCb.
// Removed Stub for BaseTelemetryPlugin.prototype._addHook.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    BaseTelemetryPlugin.__ieDyn=1;

    return BaseTelemetryPlugin;
}());

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
function _addInitializer(_initializers, id, telemetryInitializer) {
    var theInitializer = {
        id: id,
        fn: telemetryInitializer
    };
    arrAppend(_initializers, theInitializer);
    var handler = {
        remove: function () {
            arrForEach$1(_initializers, function (initializer, idx) {
                if (initializer.id === theInitializer.id) {
                    _initializers[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
                    return -1;
                }
            });
        }
    };
    return handler;
}
function _runInitializers(_initializers, item, logger) {
    var doNotSendItem = false;
    var telemetryInitializersCount = _initializers[_DYN_LENGTH$5 /* @min:%2elength */];
    for (var i = 0; i < telemetryInitializersCount; ++i) {
        var telemetryInitializer = _initializers[i];
        if (telemetryInitializer) {
            try {
                if (telemetryInitializer.fn[_DYN_APPLY /* @min:%2eapply */](null, [item]) === false) {
                    doNotSendItem = true;
                    break;
                }
            }
            catch (e) {
                // log error but dont stop executing rest of the telemetry initializers
                // doNotSendItem = true;
                _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 64 /* _eInternalMessageId.TelemetryInitializerFailed */, "Telemetry initializer failed: " + getExceptionName(e), { exception: dumpObj$2(e) }, true);
            }
        }
    }
    return !doNotSendItem;
}
var TelemetryInitializerPlugin = /** @class */ (function (_super) {
    __extendsFn(TelemetryInitializerPlugin, _super);
    function TelemetryInitializerPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = "TelemetryInitializerPlugin";
        _this.priority = 199;
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _id;
        var _initializers;
        _initDefaults();
        dynamicProto(TelemetryInitializerPlugin, _this, function (_self, _base) {
            _self.addTelemetryInitializer = function (telemetryInitializer) {
                return _addInitializer(_initializers, _id++, telemetryInitializer);
            };
            _self[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */] = function (item, itemCtx) {
                if (_runInitializers(_initializers, item, itemCtx ? itemCtx[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */]() : _self[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */]())) {
                    _self[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](item, itemCtx);
                }
            };
            _self[_DYN__DO_TEARDOWN /* @min:%2e_doTeardown */] = function () {
                _initDefaults();
            };
        });
        function _initDefaults() {
            _id = 0;
            _initializers = [];
        }
        return _this;
    }
// Removed Stub for TelemetryInitializerPlugin.prototype.addTelemetryInitializer.
// Removed Stub for TelemetryInitializerPlugin.prototype.processTelemetry.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    TelemetryInitializerPlugin.__ieDyn=1;

    return TelemetryInitializerPlugin;
}(BaseTelemetryPlugin));

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var _a$8;
var strValidationError = "Plugins must provide initialize method";
var strNotificationManager = "_notificationManager";
var strSdkUnloadingError = "SDK is still unloading...";
var strSdkNotInitialized = "SDK is not initialized";
// const strPluginUnloadFailed = "Failed to unload plugin";
/**
 * The default settings for the config.
 * WE MUST include all defaults here to ensure that the config is created with all of the properties
 * defined as dynamic.
 */
var defaultConfig = objDeepFreeze$1((_a$8 = {
        cookieCfg: {}
    },
    _a$8[STR_EXTENSIONS] = { rdOnly: true, ref: true, v: [] },
    _a$8[STR_CHANNELS] = { rdOnly: true, ref: true, v: [] },
    _a$8[STR_EXTENSION_CONFIG] = { ref: true, v: {} },
    _a$8[STR_CREATE_PERF_MGR] = UNDEFINED_VALUE$2,
    _a$8.loggingLevelConsole = 0 /* eLoggingSeverity.DISABLED */,
    _a$8.diagnosticLogInterval = UNDEFINED_VALUE$2,
    _a$8));
/**
 * Helper to create the default performance manager
 * @param core
 * @param notificationMgr
 */
function _createPerfManager(core, notificationMgr) {
    return new PerfManager(notificationMgr);
}
function _validateExtensions(logger, channelPriority, allExtensions) {
    var _a;
    // Concat all available extensions
    var coreExtensions = [];
    var channels = [];
    // Check if any two extensions have the same priority, then warn to console
    // And extract the local extensions from the
    var extPriorities = {};
    // Extension validation
    arrForEach$1(allExtensions, function (ext) {
        // Check for ext.initialize
        if (isNullOrUndefined$1(ext) || isNullOrUndefined$1(ext[_DYN_INITIALIZE$1 /* @min:%2einitialize */])) {
            throwError(strValidationError);
        }
        var extPriority = ext[STR_PRIORITY /* @min:%2epriority */];
        var identifier = ext[_DYN_IDENTIFIER /* @min:%2eidentifier */];
        if (ext && extPriority) {
            if (!isNullOrUndefined$1(extPriorities[extPriority])) {
                _warnToConsole(logger, "Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
            }
            else {
                // set a value
                extPriorities[extPriority] = identifier;
            }
        }
        // Split extensions to core and channels
        if (!extPriority || extPriority < channelPriority) {
            // Add to core extension that will be managed by AppInsightsCore
            coreExtensions[_DYN_PUSH$2 /* @min:%2epush */](ext);
        }
        else {
            channels[_DYN_PUSH$2 /* @min:%2epush */](ext);
        }
    });
    return _a = {},
        _a[STR_CORE /* @min:core */] = coreExtensions,
        _a[STR_CHANNELS /* @min:channels */] = channels,
        _a;
}
function _isPluginPresent(thePlugin, plugins) {
    var exists = false;
    arrForEach$1(plugins, function (plugin) {
        if (plugin === thePlugin) {
            exists = true;
            return -1;
        }
    });
    return exists;
}
function _deepMergeConfig(details, target, newValues, merge) {
    // Lets assign the new values to the existing config
    if (newValues) {
        objForEachKey$1(newValues, function (key, value) {
            if (merge) {
                if (isPlainObject(value) && isPlainObject(target[key])) {
                    // The target is an object and it has a value
                    _deepMergeConfig(details, target[key], value, merge);
                }
            }
            if (merge && isPlainObject(value) && isPlainObject(target[key])) {
                // The target is an object and it has a value
                _deepMergeConfig(details, target[key], value, merge);
            }
            else {
                // Just Assign (replace) and/or make the property dynamic
                details.set(target, key, value);
            }
        });
    }
}
function _findWatcher(listeners, newWatcher) {
    var theListener = null;
    var idx = -1;
    arrForEach$1(listeners, function (listener, lp) {
        if (listener.w === newWatcher) {
            theListener = listener;
            idx = lp;
            return -1;
        }
    });
    return { i: idx, l: theListener };
}
function _addDelayedCfgListener(listeners, newWatcher) {
    var theListener = _findWatcher(listeners, newWatcher).l;
    if (!theListener) {
        theListener = {
            w: newWatcher,
            rm: function () {
                var fnd = _findWatcher(listeners, newWatcher);
                if (fnd.i !== -1) {
                    listeners[_DYN_SPLICE /* @min:%2esplice */](fnd.i, 1);
                }
            }
        };
        listeners[_DYN_PUSH$2 /* @min:%2epush */](theListener);
    }
    return theListener;
}
function _registerDelayedCfgListener(config, listeners, logger) {
    arrForEach$1(listeners, function (listener) {
        var unloadHdl = onConfigChange(config, listener.w, logger);
        delete listener.w; // Clear the listener reference so it will get garbage collected.
        // replace the remove function
        listener.rm = function () {
            unloadHdl.rm();
        };
    });
}
// Moved this outside of the closure to reduce the retained memory footprint
function _initDebugListener(configHandler, unloadContainer, notificationManager, debugListener) {
    // Will get recalled if any referenced config values are changed
    unloadContainer.add(configHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
        var disableDbgExt = details.cfg.disableDbgExt;
        if (disableDbgExt === true && debugListener) {
            // Remove any previously loaded debug listener
            notificationManager[_DYN_REMOVE_NOTIFICATION_0 /* @min:%2eremoveNotificationListener */](debugListener);
            debugListener = null;
        }
        if (notificationManager && !debugListener && disableDbgExt !== true) {
            debugListener = getDebugListener(details.cfg);
            notificationManager[_DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */](debugListener);
        }
    }));
    return debugListener;
}
// Moved this outside of the closure to reduce the retained memory footprint
function _createUnloadHook(unloadHook) {
    return objDefine$1({
        rm: function () {
            unloadHook.rm();
        }
    }, "toJSON", { v: function () { return "aicore::onCfgChange<" + JSON.stringify(unloadHook) + ">"; } });
}
/**
 * @group Classes
 * @group Entrypoint
 */
var AppInsightsCore = /** @class */ (function () {
    function AppInsightsCore() {
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _configHandler;
        var _isInitialized;
        var _logger;
        var _eventQueue;
        var _notificationManager;
        var _perfManager;
        var _cfgPerfManager;
        var _cookieManager;
        var _pluginChain;
        var _configExtensions;
        var _channelConfig;
        var _channels;
        var _isUnloading;
        var _telemetryInitializerPlugin;
        var _internalLogsEventName;
        var _evtNamespace;
        var _unloadHandlers;
        var _hookContainer;
        var _debugListener;
        var _traceCtx;
        var _instrumentationKey;
        var _cfgListeners;
        var _extensions;
        var _pluginVersionStringArr;
        var _pluginVersionString;
        /**
         * Internal log poller
         */
        var _internalLogPoller;
        var _internalLogPollerListening;
        var _forceStopInternalLogPoller;
        dynamicProto(AppInsightsCore, this, function (_self) {
            // Set the default values (also called during teardown)
            _initDefaults();
            // Special internal method to allow the unit tests and DebugPlugin to hook embedded objects
            _self["_getDbgPlgTargets"] = function () {
                return [_extensions];
            };
            _self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */] = function () { return _isInitialized; };
            // Creating the self.initialize = ()
            _self[_DYN_INITIALIZE$1 /* @min:%2einitialize */] = function (config, extensions, logger, notificationManager) {
                if (_isUnloading) {
                    throwError(strSdkUnloadingError);
                }
                // Make sure core is only initialized once
                if (_self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]()) {
                    throwError("Core cannot be initialized more than once");
                }
                _configHandler = createDynamicConfig(config, defaultConfig, logger || _self[_DYN_LOGGER /* @min:%2elogger */], false);
                // Re-assigning the local config property so we don't have any references to the passed value and it can be garbage collected
                config = _configHandler.cfg;
                // This will be "re-run" if the referenced config properties are changed
                _addUnloadHook(_configHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
                    _instrumentationKey = details.cfg.instrumentationKey;
                    // Mark the extensionConfig and all first level keys as referenced
                    // This is so that calls to getExtCfg() will always return the same object
                    // Even when a user may "re-assign" the plugin properties (or it's unloaded/reloaded)
                    var extCfg = details.ref(details.cfg, STR_EXTENSION_CONFIG);
                    objForEachKey$1(extCfg, function (key) {
                        details.ref(extCfg, key);
                    });
                    if (isNullOrUndefined$1(_instrumentationKey)) {
                        throwError("Please provide instrumentation key");
                    }
                }));
                _notificationManager = notificationManager;
                // Initialize the debug listener outside of the closure to reduce the retained memory footprint
                _debugListener = _initDebugListener(_configHandler, _hookContainer, _notificationManager && _self[_DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */](), _debugListener);
                _initPerfManager();
                _self[_DYN_LOGGER /* @min:%2elogger */] = logger;
                var cfgExtensions = config[STR_EXTENSIONS /* @min:%2eextensions */];
                // Extension validation
                _configExtensions = [];
                _configExtensions[_DYN_PUSH$2 /* @min:%2epush */].apply(_configExtensions, __spreadArrayFn(__spreadArrayFn([], extensions, false), cfgExtensions));
                _channelConfig = config[STR_CHANNELS /* @min:%2echannels */];
                _initPluginChain(null);
                if (!_channels || _channels[_DYN_LENGTH$5 /* @min:%2elength */] === 0) {
                    throwError("No " + STR_CHANNELS + " available");
                }
                if (_channelConfig && _channelConfig[_DYN_LENGTH$5 /* @min:%2elength */] > 1) {
                    var teeController = _self[_DYN_GET_PLUGIN /* @min:%2egetPlugin */]("TeeChannelController");
                    if (!teeController || !teeController.plugin) {
                        _throwInternal(_logger, 1 /* eLoggingSeverity.CRITICAL */, 28 /* _eInternalMessageId.SenderNotInitialized */, "TeeChannel required");
                    }
                }
                _registerDelayedCfgListener(config, _cfgListeners, _logger);
                _cfgListeners = null;
                _isInitialized = true;
                _self.releaseQueue();
                _self[_DYN_POLL_INTERNAL_LOGS /* @min:%2epollInternalLogs */]();
            };
            _self.getChannels = function () {
                var controls = [];
                if (_channels) {
                    arrForEach$1(_channels, function (channel) {
                        controls[_DYN_PUSH$2 /* @min:%2epush */](channel);
                    });
                }
                return objFreeze$1(controls);
            };
            _self.track = function (telemetryItem) {
                doPerf(_self[STR_GET_PERF_MGR /* @min:%2egetPerfMgr */](), function () { return "AppInsightsCore:track"; }, function () {
                    if (telemetryItem === null) {
                        _notifyInvalidEvent(telemetryItem);
                        // throw error
                        throwError("Invalid telemetry item");
                    }
                    // do basic validation before sending it through the pipeline
                    if (!telemetryItem[_DYN_NAME$3 /* @min:%2ename */] && isNullOrUndefined$1(telemetryItem[_DYN_NAME$3 /* @min:%2ename */])) {
                        _notifyInvalidEvent(telemetryItem);
                        throwError("telemetry name required");
                    }
                    // setup default iKey if not passed in
                    telemetryItem.iKey = telemetryItem.iKey || _instrumentationKey;
                    // add default timestamp if not passed in
                    telemetryItem[_DYN_TIME /* @min:%2etime */] = telemetryItem[_DYN_TIME /* @min:%2etime */] || toISOString(new Date());
                    // Common Schema 4.0
                    telemetryItem.ver = telemetryItem.ver || "4.0";
                    if (!_isUnloading && _self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]()) {
                        // Process the telemetry plugin chain
                        _createTelCtx()[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](telemetryItem);
                    }
                    else {
                        // Queue events until all extensions are initialized
                        _eventQueue[_DYN_PUSH$2 /* @min:%2epush */](telemetryItem);
                    }
                }, function () { return ({ item: telemetryItem }); }, !(telemetryItem.sync));
            };
            _self[_DYN_GET_PROCESS_TEL_CONT2 /* @min:%2egetProcessTelContext */] = _createTelCtx;
            _self[_DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */] = function () {
                if (!_notificationManager) {
                    _notificationManager = new NotificationManager(_configHandler.cfg);
                    // For backward compatibility only
                    _self[strNotificationManager] = _notificationManager;
                }
                return _notificationManager;
            };
            /**
             * Adds a notification listener. The SDK calls methods on the listener when an appropriate notification is raised.
             * The added plugins must raise notifications. If the plugins do not implement the notifications, then no methods will be
             * called.
             * @param listener - An INotificationListener object.
             */
            _self[_DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */] = function (listener) {
                _self.getNotifyMgr()[_DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */](listener);
            };
            /**
             * Removes all instances of the listener.
             * @param listener - INotificationListener to remove.
             */
            _self[_DYN_REMOVE_NOTIFICATION_0 /* @min:%2eremoveNotificationListener */] = function (listener) {
                if (_notificationManager) {
                    _notificationManager[_DYN_REMOVE_NOTIFICATION_0 /* @min:%2eremoveNotificationListener */](listener);
                }
            };
            _self.getCookieMgr = function () {
                if (!_cookieManager) {
                    _cookieManager = createCookieMgr(_configHandler.cfg, _self[_DYN_LOGGER /* @min:%2elogger */]);
                }
                return _cookieManager;
            };
            _self.setCookieMgr = function (cookieMgr) {
                if (_cookieManager !== cookieMgr) {
                    runTargetUnload(_cookieManager, false);
                    _cookieManager = cookieMgr;
                }
            };
            _self[STR_GET_PERF_MGR /* @min:%2egetPerfMgr */] = function () {
                return _perfManager || _cfgPerfManager || getGblPerfMgr();
            };
            _self.setPerfMgr = function (perfMgr) {
                _perfManager = perfMgr;
            };
            _self.eventCnt = function () {
                return _eventQueue[_DYN_LENGTH$5 /* @min:%2elength */];
            };
            _self.releaseQueue = function () {
                if (_isInitialized && _eventQueue[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                    var eventQueue = _eventQueue;
                    _eventQueue = [];
                    arrForEach$1(eventQueue, function (event) {
                        _createTelCtx()[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](event);
                    });
                }
            };
            _self[_DYN_POLL_INTERNAL_LOGS /* @min:%2epollInternalLogs */] = function (eventName) {
                _internalLogsEventName = eventName || null;
                _forceStopInternalLogPoller = false;
                _internalLogPoller && _internalLogPoller[_DYN_CANCEL /* @min:%2ecancel */]();
                return _startLogPoller(true);
            };
            function _startLogPoller(alwaysStart) {
                if ((!_internalLogPoller || !_internalLogPoller[_DYN_ENABLED /* @min:%2eenabled */]) && !_forceStopInternalLogPoller) {
                    var shouldStart = alwaysStart || (_logger && _logger.queue[_DYN_LENGTH$5 /* @min:%2elength */] > 0);
                    if (shouldStart) {
                        if (!_internalLogPollerListening) {
                            _internalLogPollerListening = true;
                            // listen for any configuration changes so that changes to the
                            // interval will cause the timer to be re-initialized
                            _addUnloadHook(_configHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
                                var interval = details.cfg.diagnosticLogInterval;
                                if (!interval || !(interval > 0)) {
                                    interval = 10000;
                                }
                                var isRunning = false;
                                if (_internalLogPoller) {
                                    // It was already created so remember it's running and cancel
                                    isRunning = _internalLogPoller[_DYN_ENABLED /* @min:%2eenabled */];
                                    _internalLogPoller[_DYN_CANCEL /* @min:%2ecancel */]();
                                }
                                // Create / reconfigure
                                _internalLogPoller = createTimeout(_flushInternalLogs, interval);
                                _internalLogPoller.unref();
                                // Restart if previously running
                                _internalLogPoller[_DYN_ENABLED /* @min:%2eenabled */] = isRunning;
                            }));
                        }
                        _internalLogPoller[_DYN_ENABLED /* @min:%2eenabled */] = true;
                    }
                }
                return _internalLogPoller;
            }
            _self[_DYN_STOP_POLLING_INTERNA3 /* @min:%2estopPollingInternalLogs */] = function () {
                _forceStopInternalLogPoller = true;
                _internalLogPoller && _internalLogPoller[_DYN_CANCEL /* @min:%2ecancel */]();
                _flushInternalLogs();
            };
            // Add addTelemetryInitializer
            proxyFunctions(_self, function () { return _telemetryInitializerPlugin; }, ["addTelemetryInitializer"]);
            _self[_DYN_UNLOAD /* @min:%2eunload */] = function (isAsync, unloadComplete, cbTimeout) {
                var _a;
                if (isAsync === void 0) { isAsync = true; }
                if (!_isInitialized) {
                    // The SDK is not initialized
                    throwError(strSdkNotInitialized);
                }
                // Check if the SDK still unloading so throw
                if (_isUnloading) {
                    // The SDK is already unloading
                    throwError(strSdkUnloadingError);
                }
                var unloadState = (_a = {
                        reason: 50 /* TelemetryUnloadReason.SdkUnload */
                    },
                    _a[_DYN_IS_ASYNC /* @min:isAsync */] = isAsync,
                    _a.flushComplete = false,
                    _a);
                var result;
                if (isAsync && !unloadComplete) {
                    result = createPromise(function (resolve) {
                        // Set the callback to the promise resolve callback
                        unloadComplete = resolve;
                    });
                }
                var processUnloadCtx = createProcessTelemetryUnloadContext(_getPluginChain(), _self);
                processUnloadCtx[_DYN_ON_COMPLETE /* @min:%2eonComplete */](function () {
                    _hookContainer.run(_self[_DYN_LOGGER /* @min:%2elogger */]);
                    // Run any "unload" functions for the _cookieManager, _notificationManager and _logger
                    doUnloadAll([_cookieManager, _notificationManager, _logger], isAsync, function () {
                        _initDefaults();
                        unloadComplete && unloadComplete(unloadState);
                    });
                }, _self);
                function _doUnload(flushComplete) {
                    unloadState.flushComplete = flushComplete;
                    _isUnloading = true;
                    // Run all of the unload handlers first (before unloading the plugins)
                    _unloadHandlers.run(processUnloadCtx, unloadState);
                    // Stop polling the internal logs
                    _self[_DYN_STOP_POLLING_INTERNA3 /* @min:%2estopPollingInternalLogs */]();
                    // Start unloading the components, from this point onwards the SDK should be considered to be in an unstable state
                    processUnloadCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](unloadState);
                }
                _flushInternalLogs();
                if (!_flushChannels(isAsync, _doUnload, 6 /* SendRequestReason.SdkUnload */, cbTimeout)) ;
                return result;
            };
            _self[_DYN_GET_PLUGIN /* @min:%2egetPlugin */] = _getPlugin;
            _self.addPlugin = function (plugin, replaceExisting, isAsync, addCb) {
                if (!plugin) {
                    addCb && addCb(false);
                    _logOrThrowError(strValidationError);
                    return;
                }
                var existingPlugin = _getPlugin(plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */]);
                if (existingPlugin && !replaceExisting) {
                    addCb && addCb(false);
                    _logOrThrowError("Plugin [" + plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */] + "] is already loaded!");
                    return;
                }
                var updateState = {
                    reason: 16 /* TelemetryUpdateReason.PluginAdded */
                };
                function _addPlugin(removed) {
                    _configExtensions[_DYN_PUSH$2 /* @min:%2epush */](plugin);
                    updateState.added = [plugin];
                    // Re-Initialize the plugin chain
                    _initPluginChain(updateState);
                    addCb && addCb(true);
                }
                if (existingPlugin) {
                    var removedPlugins_1 = [existingPlugin.plugin];
                    var unloadState = {
                        reason: 2 /* TelemetryUnloadReason.PluginReplace */,
                        isAsync: !!isAsync
                    };
                    _removePlugins(removedPlugins_1, unloadState, function (removed) {
                        if (!removed) {
                            // Previous plugin was successfully removed or was not installed
                            addCb && addCb(false);
                        }
                        else {
                            updateState.removed = removedPlugins_1;
                            updateState.reason |= 32 /* TelemetryUpdateReason.PluginRemoved */;
                            _addPlugin();
                        }
                    });
                }
                else {
                    _addPlugin();
                }
            };
            _self.updateCfg = function (newConfig, mergeExisting) {
                if (mergeExisting === void 0) { mergeExisting = true; }
                var updateState;
                if (_self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]()) {
                    updateState = {
                        reason: 1 /* TelemetryUpdateReason.ConfigurationChanged */,
                        cfg: _configHandler.cfg,
                        oldCfg: deepExtend({}, _configHandler.cfg),
                        newConfig: deepExtend({}, newConfig),
                        merge: mergeExisting
                    };
                    newConfig = updateState.newConfig;
                    var cfg = _configHandler.cfg;
                    // replace the immutable (if initialized) values
                    // We don't currently allow updating the extensions and channels via the update config
                    // So overwriting any user provided values to reuse the existing values
                    newConfig[STR_EXTENSIONS /* @min:%2eextensions */] = cfg[STR_EXTENSIONS /* @min:%2eextensions */];
                    newConfig[STR_CHANNELS /* @min:%2echannels */] = cfg[STR_CHANNELS /* @min:%2echannels */];
                }
                // Explicitly blocking any previous config watchers so that they don't get called because
                // of this bulk update (Probably not necessary)
                _configHandler._block(function (details) {
                    // Lets assign the new values to the existing config either overwriting or re-assigning
                    var theConfig = details.cfg;
                    _deepMergeConfig(details, theConfig, newConfig, mergeExisting);
                    if (!mergeExisting) {
                        // Remove (unassign) the values "missing" from the newConfig and also not in the default config
                        objForEachKey$1(theConfig, function (key) {
                            if (!objHasOwn$1(newConfig, key)) {
                                // Set the value to undefined
                                details.set(theConfig, key, UNDEFINED_VALUE$2);
                            }
                        });
                    }
                    // Apply defaults to the new config
                    details[_DYN_SET_DF /* @min:%2esetDf */](theConfig, defaultConfig);
                }, true);
                // Now execute all of the listeners (synchronously) so they update their values immediately
                _configHandler[_DYN_NOTIFY /* @min:%2enotify */]();
                if (updateState) {
                    _doUpdate(updateState);
                }
            };
            _self.evtNamespace = function () {
                return _evtNamespace;
            };
            _self.flush = _flushChannels;
            _self.getTraceCtx = function (createNew) {
                if (!_traceCtx) {
                    _traceCtx = createDistributedTraceContext();
                }
                return _traceCtx;
            };
            _self.setTraceCtx = function (traceCtx) {
                _traceCtx = traceCtx || null;
            };
            _self.addUnloadHook = _addUnloadHook;
            // Create the addUnloadCb
            proxyFunctionAs(_self, "addUnloadCb", function () { return _unloadHandlers; }, "add");
            _self.onCfgChange = function (handler) {
                var unloadHook;
                if (!_isInitialized) {
                    unloadHook = _addDelayedCfgListener(_cfgListeners, handler);
                }
                else {
                    unloadHook = onConfigChange(_configHandler.cfg, handler, _self[_DYN_LOGGER /* @min:%2elogger */]);
                }
                return _createUnloadHook(unloadHook);
            };
            _self.getWParam = function () {
                return (hasDocument() || !!_configHandler.cfg.enableWParam) ? 0 : -1;
            };
            function _setPluginVersions() {
                var thePlugins = {};
                _pluginVersionStringArr = [];
                var _addPluginVersions = function (plugins) {
                    if (plugins) {
                        arrForEach$1(plugins, function (plugin) {
                            if (plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */] && plugin[_DYN_VERSION$1 /* @min:%2eversion */] && !thePlugins[plugin.identifier]) {
                                var ver = plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */] + "=" + plugin[_DYN_VERSION$1 /* @min:%2eversion */];
                                _pluginVersionStringArr[_DYN_PUSH$2 /* @min:%2epush */](ver);
                                thePlugins[plugin.identifier] = plugin;
                            }
                        });
                    }
                };
                _addPluginVersions(_channels);
                if (_channelConfig) {
                    arrForEach$1(_channelConfig, function (channels) {
                        _addPluginVersions(channels);
                    });
                }
                _addPluginVersions(_configExtensions);
            }
            function _initDefaults() {
                _isInitialized = false;
                // Use a default logger so initialization errors are not dropped on the floor with full logging
                _configHandler = createDynamicConfig({}, defaultConfig, _self[_DYN_LOGGER /* @min:%2elogger */]);
                // Set the logging level to critical so that any critical initialization failures are displayed on the console
                _configHandler.cfg[_DYN_LOGGING_LEVEL_CONSOL4 /* @min:%2eloggingLevelConsole */] = 1 /* eLoggingSeverity.CRITICAL */;
                // Define _self.config
                objDefine$1(_self, "config", {
                    g: function () { return _configHandler.cfg; },
                    s: function (newValue) {
                        _self.updateCfg(newValue, false);
                    }
                });
                objDefine$1(_self, "pluginVersionStringArr", {
                    g: function () {
                        if (!_pluginVersionStringArr) {
                            _setPluginVersions();
                        }
                        return _pluginVersionStringArr;
                    }
                });
                objDefine$1(_self, "pluginVersionString", {
                    g: function () {
                        if (!_pluginVersionString) {
                            if (!_pluginVersionStringArr) {
                                _setPluginVersions();
                            }
                            _pluginVersionString = _pluginVersionStringArr.join(";");
                        }
                        return _pluginVersionString || STR_EMPTY$1;
                    }
                });
                objDefine$1(_self, "logger", {
                    g: function () {
                        if (!_logger) {
                            _logger = new DiagnosticLogger(_configHandler.cfg);
                            _configHandler[_DYN_LOGGER /* @min:%2elogger */] = _logger;
                        }
                        return _logger;
                    },
                    s: function (newLogger) {
                        _configHandler[_DYN_LOGGER /* @min:%2elogger */] = newLogger;
                        if (_logger !== newLogger) {
                            runTargetUnload(_logger, false);
                            _logger = newLogger;
                        }
                    }
                });
                _self[_DYN_LOGGER /* @min:%2elogger */] = new DiagnosticLogger(_configHandler.cfg);
                _extensions = [];
                var cfgExtensions = _self.config[STR_EXTENSIONS /* @min:%2eextensions */] || [];
                cfgExtensions.splice(0, cfgExtensions[_DYN_LENGTH$5 /* @min:%2elength */]);
                arrAppend(cfgExtensions, _extensions);
                _telemetryInitializerPlugin = new TelemetryInitializerPlugin();
                _eventQueue = [];
                runTargetUnload(_notificationManager, false);
                _notificationManager = null;
                _perfManager = null;
                _cfgPerfManager = null;
                runTargetUnload(_cookieManager, false);
                _cookieManager = null;
                _pluginChain = null;
                _configExtensions = [];
                _channelConfig = null;
                _channels = null;
                _isUnloading = false;
                _internalLogsEventName = null;
                _evtNamespace = createUniqueNamespace("AIBaseCore", true);
                _unloadHandlers = createUnloadHandlerContainer();
                _traceCtx = null;
                _instrumentationKey = null;
                _hookContainer = createUnloadHookContainer();
                _cfgListeners = [];
                _pluginVersionString = null;
                _pluginVersionStringArr = null;
                _forceStopInternalLogPoller = false;
                _internalLogPoller = null;
                _internalLogPollerListening = false;
            }
            function _createTelCtx() {
                var theCtx = createProcessTelemetryContext(_getPluginChain(), _configHandler.cfg, _self);
                theCtx[_DYN_ON_COMPLETE /* @min:%2eonComplete */](_startLogPoller);
                return theCtx;
            }
            // Initialize or Re-initialize the plugins
            function _initPluginChain(updateState) {
                // Extension validation
                var theExtensions = _validateExtensions(_self[_DYN_LOGGER /* @min:%2elogger */], ChannelControllerPriority, _configExtensions);
                _pluginChain = null;
                _pluginVersionString = null;
                _pluginVersionStringArr = null;
                // Get the primary channel queue and include as part of the normal extensions
                _channels = (_channelConfig || [])[0] || [];
                // Add any channels provided in the extensions and sort them
                _channels = sortPlugins(arrAppend(_channels, theExtensions[STR_CHANNELS /* @min:%2echannels */]));
                // Create an array of all extensions, including the _channels
                var allExtensions = arrAppend(sortPlugins(theExtensions[STR_CORE /* @min:%2ecore */]), _channels);
                // Required to allow plugins to call core.getPlugin() during their own initialization
                _extensions = objFreeze$1(allExtensions);
                // This has a side effect of adding the extensions passed during initialization
                // into the config.extensions, so you can see all of the extensions loaded.
                // This will also get updated by the addPlugin() and remove plugin code.
                var cfgExtensions = _self.config[STR_EXTENSIONS /* @min:%2eextensions */] || [];
                cfgExtensions.splice(0, cfgExtensions[_DYN_LENGTH$5 /* @min:%2elength */]);
                arrAppend(cfgExtensions, _extensions);
                var rootCtx = _createTelCtx();
                // Initializing the channels first
                if (_channels && _channels[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                    initializePlugins(rootCtx[_DYN_CREATE_NEW$1 /* @min:%2ecreateNew */](_channels), allExtensions);
                }
                // Now initialize the normal extensions (explicitly not including the _channels as this can cause duplicate initialization)
                initializePlugins(rootCtx, allExtensions);
                if (updateState) {
                    _doUpdate(updateState);
                }
            }
            function _getPlugin(pluginIdentifier) {
                var theExt = null;
                var thePlugin = null;
                var channelHosts = [];
                arrForEach$1(_extensions, function (ext) {
                    if (ext[_DYN_IDENTIFIER /* @min:%2eidentifier */] === pluginIdentifier && ext !== _telemetryInitializerPlugin) {
                        thePlugin = ext;
                        return -1;
                    }
                    if (ext.getChannel) {
                        channelHosts[_DYN_PUSH$2 /* @min:%2epush */](ext);
                    }
                });
                if (!thePlugin && channelHosts[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                    arrForEach$1(channelHosts, function (host) {
                        thePlugin = host.getChannel(pluginIdentifier);
                        if (!thePlugin) {
                            return -1;
                        }
                    });
                }
                if (thePlugin) {
                    theExt = {
                        plugin: thePlugin,
                        setEnabled: function (enabled) {
                            _getPluginState(thePlugin)[STR_DISABLED] = !enabled;
                        },
                        isEnabled: function () {
                            var pluginState = _getPluginState(thePlugin);
                            return !pluginState[_DYN_TEARDOWN /* @min:%2eteardown */] && !pluginState[STR_DISABLED];
                        },
                        remove: function (isAsync, removeCb) {
                            var _a;
                            if (isAsync === void 0) { isAsync = true; }
                            var pluginsToRemove = [thePlugin];
                            var unloadState = (_a = {
                                    reason: 1 /* TelemetryUnloadReason.PluginUnload */
                                },
                                _a[_DYN_IS_ASYNC /* @min:isAsync */] = isAsync,
                                _a);
                            _removePlugins(pluginsToRemove, unloadState, function (removed) {
                                if (removed) {
                                    // Re-Initialize the plugin chain
                                    _initPluginChain({
                                        reason: 32 /* TelemetryUpdateReason.PluginRemoved */,
                                        removed: pluginsToRemove
                                    });
                                }
                                removeCb && removeCb(removed);
                            });
                        }
                    };
                }
                return theExt;
            }
            function _getPluginChain() {
                if (!_pluginChain) {
                    // copy the collection of extensions
                    var extensions = (_extensions || []).slice();
                    // During add / remove this may get called again, so don't read if already present
                    if (arrIndexOf(extensions, _telemetryInitializerPlugin) === -1) {
                        extensions[_DYN_PUSH$2 /* @min:%2epush */](_telemetryInitializerPlugin);
                    }
                    _pluginChain = createTelemetryProxyChain(sortPlugins(extensions), _configHandler.cfg, _self);
                }
                return _pluginChain;
            }
            function _removePlugins(thePlugins, unloadState, removeComplete) {
                if (thePlugins && thePlugins[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                    var unloadChain = createTelemetryProxyChain(thePlugins, _configHandler.cfg, _self);
                    var unloadCtx = createProcessTelemetryUnloadContext(unloadChain, _self);
                    unloadCtx[_DYN_ON_COMPLETE /* @min:%2eonComplete */](function () {
                        var removed = false;
                        // Remove the listed config extensions
                        var newConfigExtensions = [];
                        arrForEach$1(_configExtensions, function (plugin, idx) {
                            if (!_isPluginPresent(plugin, thePlugins)) {
                                newConfigExtensions[_DYN_PUSH$2 /* @min:%2epush */](plugin);
                            }
                            else {
                                removed = true;
                            }
                        });
                        _configExtensions = newConfigExtensions;
                        _pluginVersionString = null;
                        _pluginVersionStringArr = null;
                        // Re-Create the channel config
                        var newChannelConfig = [];
                        if (_channelConfig) {
                            arrForEach$1(_channelConfig, function (queue, idx) {
                                var newQueue = [];
                                arrForEach$1(queue, function (channel) {
                                    if (!_isPluginPresent(channel, thePlugins)) {
                                        newQueue[_DYN_PUSH$2 /* @min:%2epush */](channel);
                                    }
                                    else {
                                        removed = true;
                                    }
                                });
                                newChannelConfig[_DYN_PUSH$2 /* @min:%2epush */](newQueue);
                            });
                            _channelConfig = newChannelConfig;
                        }
                        removeComplete && removeComplete(removed);
                        _startLogPoller();
                    });
                    unloadCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](unloadState);
                }
                else {
                    removeComplete(false);
                }
            }
            function _flushInternalLogs() {
                if (_logger && _logger.queue) {
                    var queue = _logger.queue.slice(0);
                    _logger.queue[_DYN_LENGTH$5 /* @min:%2elength */] = 0;
                    arrForEach$1(queue, function (logMessage) {
                        var _a;
                        var item = (_a = {},
                            _a[_DYN_NAME$3 /* @min:name */] = _internalLogsEventName ? _internalLogsEventName : "InternalMessageId: " + logMessage[_DYN_MESSAGE_ID /* @min:%2emessageId */],
                            _a.iKey = _instrumentationKey,
                            _a[_DYN_TIME /* @min:time */] = toISOString(new Date()),
                            _a.baseType = _InternalLogMessage.dataType,
                            _a.baseData = { message: logMessage[_DYN_MESSAGE$2 /* @min:%2emessage */] },
                            _a);
                        _self.track(item);
                    });
                }
            }
            function _flushChannels(isAsync, callBack, sendReason, cbTimeout) {
                // Setting waiting to one so that we don't call the callBack until we finish iterating
                var waiting = 1;
                var doneIterating = false;
                var cbTimer = null;
                cbTimeout = cbTimeout || 5000;
                function doCallback() {
                    waiting--;
                    if (doneIterating && waiting === 0) {
                        cbTimer && cbTimer[_DYN_CANCEL /* @min:%2ecancel */]();
                        cbTimer = null;
                        callBack && callBack(doneIterating);
                        callBack = null;
                    }
                }
                if (_channels && _channels[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                    var flushCtx = _createTelCtx()[_DYN_CREATE_NEW$1 /* @min:%2ecreateNew */](_channels);
                    flushCtx.iterate(function (plugin) {
                        if (plugin.flush) {
                            waiting++;
                            var handled_1 = false;
                            // Not all channels will call this callback for every scenario
                            if (!plugin.flush(isAsync, function () {
                                handled_1 = true;
                                doCallback();
                            }, sendReason)) {
                                if (!handled_1) {
                                    // If any channel doesn't return true and it didn't call the callback, then we should assume that the callback
                                    // will never be called, so use a timeout to allow the channel(s) some time to "finish" before triggering any
                                    // followup function (such as unloading)
                                    if (isAsync && cbTimer == null) {
                                        cbTimer = scheduleTimeout$1(function () {
                                            cbTimer = null;
                                            doCallback();
                                        }, cbTimeout);
                                    }
                                    else {
                                        doCallback();
                                    }
                                }
                            }
                        }
                    });
                }
                doneIterating = true;
                doCallback();
                return true;
            }
            function _initPerfManager() {
                // Save the previous config based performance manager creator to avoid creating new perf manager instances if unchanged
                var prevCfgPerfMgr;
                // Will get recalled if any referenced config values are changed
                _addUnloadHook(_configHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
                    var enablePerfMgr = details.cfg.enablePerfMgr;
                    if (enablePerfMgr) {
                        var createPerfMgr = details.cfg[STR_CREATE_PERF_MGR /* @min:%2ecreatePerfMgr */];
                        if (prevCfgPerfMgr !== createPerfMgr) {
                            if (!createPerfMgr) {
                                createPerfMgr = _createPerfManager;
                            }
                            // Set the performance manager creation function if not defined
                            getSetValue(details.cfg, STR_CREATE_PERF_MGR, createPerfMgr);
                            prevCfgPerfMgr = createPerfMgr;
                            // Remove any existing config based performance manager
                            _cfgPerfManager = null;
                        }
                        // Only create the performance manager if it's not already created or manually set
                        if (!_perfManager && !_cfgPerfManager && isFunction$2(createPerfMgr)) {
                            // Create a new config based performance manager
                            _cfgPerfManager = createPerfMgr(_self, _self[_DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */]());
                        }
                    }
                    else {
                        // Remove any existing config based performance manager
                        _cfgPerfManager = null;
                        // Clear the previous cached value so it can be GC'd
                        prevCfgPerfMgr = null;
                    }
                }));
            }
            function _doUpdate(updateState) {
                var updateCtx = createProcessTelemetryUpdateContext(_getPluginChain(), _self);
                updateCtx[_DYN_ON_COMPLETE /* @min:%2eonComplete */](_startLogPoller);
                if (!_self._updateHook || _self._updateHook(updateCtx, updateState) !== true) {
                    updateCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](updateState);
                }
            }
            function _logOrThrowError(message) {
                var logger = _self[_DYN_LOGGER /* @min:%2elogger */];
                if (logger) {
                    // there should always be a logger
                    _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, message);
                    _startLogPoller();
                }
                else {
                    throwError(message);
                }
            }
            function _notifyInvalidEvent(telemetryItem) {
                var manager = _self[_DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */]();
                if (manager) {
                    manager[STR_EVENTS_DISCARDED /* @min:%2eeventsDiscarded */]([telemetryItem], 2 /* eEventsDiscardedReason.InvalidEvent */);
                }
            }
            function _addUnloadHook(hooks) {
                _hookContainer.add(hooks);
            }
        });
    }
// Removed Stub for AppInsightsCore.prototype.initialize.
// Removed Stub for AppInsightsCore.prototype.getChannels.
// Removed Stub for AppInsightsCore.prototype.track.
// Removed Stub for AppInsightsCore.prototype.getProcessTelContext.
// Removed Stub for AppInsightsCore.prototype.getNotifyMgr.
// Removed Stub for AppInsightsCore.prototype.addNotificationListener.
// Removed Stub for AppInsightsCore.prototype.removeNotificationListener.
// Removed Stub for AppInsightsCore.prototype.getCookieMgr.
// Removed Stub for AppInsightsCore.prototype.setCookieMgr.
// Removed Stub for AppInsightsCore.prototype.getPerfMgr.
// Removed Stub for AppInsightsCore.prototype.setPerfMgr.
// Removed Stub for AppInsightsCore.prototype.eventCnt.
// Removed Stub for AppInsightsCore.prototype.pollInternalLogs.
// Removed Stub for AppInsightsCore.prototype.stopPollingInternalLogs.
// Removed Stub for AppInsightsCore.prototype.addTelemetryInitializer.
// Removed Stub for AppInsightsCore.prototype.unload.
// Removed Stub for AppInsightsCore.prototype.getPlugin.
// Removed Stub for AppInsightsCore.prototype.addPlugin.
// Removed Stub for AppInsightsCore.prototype.updateCfg.
// Removed Stub for AppInsightsCore.prototype.evtNamespace.
// Removed Stub for AppInsightsCore.prototype.addUnloadCb.
// Removed Stub for AppInsightsCore.prototype.flush.
// Removed Stub for AppInsightsCore.prototype.getTraceCtx.
// Removed Stub for AppInsightsCore.prototype.setTraceCtx.
// Removed Stub for AppInsightsCore.prototype.addUnloadHook.
// Removed Stub for AppInsightsCore.prototype.onCfgChange.
// Removed Stub for AppInsightsCore.prototype.releaseQueue.
// Removed Stub for AppInsightsCore.prototype._updateHook.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    AppInsightsCore.__ieDyn=1;

    return AppInsightsCore;
}());

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * Parses the response from the backend.
 * @param response - XMLHttpRequest or XDomainRequest response
 */
function parseResponse(response, diagLog) {
    try {
        if (response && response !== "") {
            var result = getJSON().parse(response);
            if (result && result[_DYN_ITEMS_RECEIVED$1 /* @min:%2eitemsReceived */] && result[_DYN_ITEMS_RECEIVED$1 /* @min:%2eitemsReceived */] >= result.itemsAccepted &&
                result.itemsReceived - result.itemsAccepted === result.errors[_DYN_LENGTH$5 /* @min:%2elength */]) {
                return result;
            }
        }
    }
    catch (e) {
        _throwInternal(diagLog, 1 /* eLoggingSeverity.CRITICAL */, 43 /* _eInternalMessageId.InvalidBackendResponse */, "Cannot parse the response. " + (e[_DYN_NAME$3 /* @min:%2ename */] || dumpObj$2(e)), {
            response: response
        });
    }
    return null;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var STR_EMPTY = "";
var STR_NO_RESPONSE_BODY = "NoResponseBody";
var _noResponseQs = "&" + STR_NO_RESPONSE_BODY + "=true";
var STR_POST_METHOD = "POST";
/**
 * This Internal component
 * Manager SendPost functions
 * SendPostManger
 * @internal for internal use only
 */
var SenderPostManager = /** @class */ (function () {
    function SenderPostManager() {
        var _syncFetchPayload = 0; // Keep track of the outstanding sync fetch payload total (as sync fetch has limits)
        var _enableSendPromise;
        var _isInitialized;
        var _diagLog;
        var _isOneDs;
        var _onCompleteFuncs;
        var _disableCredentials;
        var _fallbackInst;
        var _disableXhr;
        var _disableBeacon;
        var _disableBeaconSync;
        var _disableFetchKeepAlive;
        var _addNoResponse;
        var _timeoutWrapper;
        dynamicProto(SenderPostManager, this, function (_self, _base) {
            var _sendCredentials = true; // for 1ds
            _initDefaults();
            _self[_DYN_INITIALIZE$1 /* @min:%2einitialize */] = function (config, diagLog) {
                _diagLog = diagLog;
                if (_isInitialized) {
                    _throwInternal(_diagLog, 1 /* eLoggingSeverity.CRITICAL */, 28 /* _eInternalMessageId.SenderNotInitialized */, "Sender is already initialized");
                }
                _self.SetConfig(config);
                _isInitialized = true;
            };
            _self["_getDbgPlgTargets"] = function () {
                return [_isInitialized, _isOneDs, _disableCredentials, _enableSendPromise];
            };
            // This componet might get its config from sender, offline sender, 1ds post
            // so set this function to mock dynamic changes
            _self.SetConfig = function (config) {
                try {
                    _onCompleteFuncs = config.senderOnCompleteCallBack || {};
                    _disableCredentials = !!config.disableCredentials;
                    _isOneDs = !!config.isOneDs;
                    _enableSendPromise = !!config.enableSendPromise;
                    _disableXhr = !!config.disableXhr;
                    _disableBeacon = !!config.disableBeacon;
                    _disableBeaconSync = !!config.disableBeaconSync;
                    _timeoutWrapper = config.timeWrapper;
                    _addNoResponse = !!config.addNoResponse;
                    _disableFetchKeepAlive = !!config.disableFetchKeepAlive;
                    _fallbackInst = { sendPOST: _xhrSender };
                    if (!_isOneDs) {
                        _sendCredentials = false; // for appInsights, set it to false always
                    }
                    if (_disableCredentials) {
                        var location_1 = getLocation();
                        if (location_1 && location_1.protocol && location_1.protocol[_DYN_TO_LOWER_CASE$2 /* @min:%2etoLowerCase */]() === "file:") {
                            // Special case where a local html file fails with a CORS error on Chromium browsers
                            _sendCredentials = false;
                        }
                    }
                    return true;
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return false;
            };
            _self.getSyncFetchPayload = function () {
                return _syncFetchPayload;
            };
            _self.getSenderInst = function (transports, sync) {
                if (transports && transports[_DYN_LENGTH$5 /* @min:%2elength */]) {
                    return _getSenderInterface(transports, sync);
                }
                return null;
            };
            _self.getFallbackInst = function () {
                return _fallbackInst;
            };
            _self[_DYN__DO_TEARDOWN /* @min:%2e_doTeardown */] = function (unloadCtx, unloadState) {
                _initDefaults();
            };
            /**
             * success handler
             */
            function _onSuccess(res, onComplete) {
                _doOnComplete(onComplete, 200, {}, res);
            }
            /**
             * error handler
             */
            function _onError(message, onComplete) {
                _throwInternal(_diagLog, 2 /* eLoggingSeverity.WARNING */, 26 /* _eInternalMessageId.OnError */, "Failed to send telemetry.", { message: message });
                _doOnComplete(onComplete, 400, {});
            }
            function _onNoPayloadUrl(onComplete) {
                _onError("No endpoint url is provided for the batch", onComplete);
            }
            function _getSenderInterface(transports, syncSupport) {
                var _a;
                var transportType = 0 /* TransportType.NotSet */;
                var sendPostFunc = null;
                var lp = 0;
                while (sendPostFunc == null && lp < transports[_DYN_LENGTH$5 /* @min:%2elength */]) {
                    transportType = transports[lp];
                    if (!_disableXhr && transportType === 1 /* TransportType.Xhr */) {
                        if (useXDomainRequest()) {
                            // IE 8 and 9
                            sendPostFunc = _xdrSender;
                        }
                        else if (isXhrSupported()) {
                            sendPostFunc = _xhrSender;
                        }
                    }
                    else if (transportType === 2 /* TransportType.Fetch */ && isFetchSupported(syncSupport) && (!syncSupport || !_disableFetchKeepAlive)) {
                        sendPostFunc = _doFetchSender;
                    }
                    else if (transportType === 3 /* TransportType.Beacon */ && isBeaconsSupported() && (syncSupport ? !_disableBeaconSync : !_disableBeacon)) {
                        sendPostFunc = _beaconSender;
                    }
                    lp++;
                }
                if (sendPostFunc) {
                    return _a = {
                            _transport: transportType,
                            _isSync: syncSupport
                        },
                        _a[_DYN_SEND_POST /* @min:sendPOST */] = sendPostFunc,
                        _a;
                }
                return null;
            }
            function _doOnComplete(oncomplete, status, headers, response) {
                try {
                    oncomplete && oncomplete(status, headers, response);
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
            }
            function _doBeaconSend(payload, oncomplete) {
                var nav = getNavigator();
                var url = payload[_DYN_URL_STRING /* @min:%2eurlString */];
                if (!url) {
                    _onNoPayloadUrl(oncomplete);
                    // return true here, because we don't want to retry it with fallback sender
                    return true;
                }
                url = payload[_DYN_URL_STRING /* @min:%2eurlString */] + (_addNoResponse ? _noResponseQs : STR_EMPTY);
                var data = payload[_DYN_DATA$1 /* @min:%2edata */];
                // Chrome only allows CORS-safelisted values for the sendBeacon data argument
                // see: https://bugs.chromium.org/p/chromium/issues/detail?id=720283
                // Chrome only allows CORS-safelisted values for the sendBeacon data argument
                // see: https://bugs.chromium.org/p/chromium/issues/detail?id=720283
                var plainTextBatch = _isOneDs ? data : new Blob([data], { type: "text/plain;charset=UTF-8" });
                // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
                var queued = nav.sendBeacon(url, plainTextBatch);
                return queued;
            }
            /**
             * Send Beacon API request
             * @param payload - {string} - The data payload to be sent.
             * @param sync - {boolean} - not used
             * Note: Beacon API does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */
            function _beaconSender(payload, oncomplete, sync) {
                var data = payload[_DYN_DATA$1 /* @min:%2edata */];
                try {
                    if (data) {
                        // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
                        if (!_doBeaconSend(payload, oncomplete)) {
                            var onRetry = _onCompleteFuncs && _onCompleteFuncs.beaconOnRetry;
                            if (onRetry && isFunction$2(onRetry)) {
                                onRetry(payload, oncomplete, _doBeaconSend);
                            }
                            else {
                                _fallbackInst && _fallbackInst[_DYN_SEND_POST /* @min:%2esendPOST */](payload, oncomplete, true);
                                _throwInternal(_diagLog, 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + "Failed to send telemetry with Beacon API, retried with normal sender.");
                            }
                        }
                        else {
                            // if can send
                            _onSuccess(STR_EMPTY, oncomplete);
                        }
                    }
                }
                catch (e) {
                    _isOneDs && _warnToConsole(_diagLog, "Failed to send telemetry using sendBeacon API. Ex:" + dumpObj$2(e));
                    _doOnComplete(oncomplete, _isOneDs ? 0 : 400, {}, STR_EMPTY);
                }
                return;
            }
            /**
             * Send XMLHttpRequest
             * @param payload - {string} - The data payload to be sent.
             * @param sync - {boolean} - Indicates if the request should be sent synchronously
             */
            function _xhrSender(payload, oncomplete, sync) {
                //let  internalPayload = payload as IInternalPayloadData;
                var thePromise;
                var resolveFunc;
                var rejectFunc;
                var headers = payload[_DYN_HEADERS$1 /* @min:%2eheaders */] || {};
                if (!sync && _enableSendPromise) {
                    thePromise = createPromise(function (resolve, reject) {
                        resolveFunc = resolve;
                        rejectFunc = reject;
                    });
                }
                if (_isOneDs && sync && payload.disableXhrSync) {
                    sync = false;
                }
                //const xhr = new XMLHttpRequest();
                var endPointUrl = payload[_DYN_URL_STRING /* @min:%2eurlString */];
                if (!endPointUrl) {
                    _onNoPayloadUrl(oncomplete);
                    resolveFunc && resolveFunc(false);
                    return;
                }
                var xhr = openXhr(STR_POST_METHOD, endPointUrl, _sendCredentials, true, sync, payload[_DYN_TIMEOUT /* @min:%2etimeout */]);
                xhr[_DYN_SET_REQUEST_HEADER$1 /* @min:%2esetRequestHeader */]("Content-type", "application/json");
                arrForEach$1(objKeys(headers), function (headerName) {
                    xhr[_DYN_SET_REQUEST_HEADER$1 /* @min:%2esetRequestHeader */](headerName, headers[headerName]);
                });
                xhr.onreadystatechange = function () {
                    if (!_isOneDs) {
                        _doOnReadyFunc(xhr);
                        if (xhr.readyState === 4) {
                            resolveFunc && resolveFunc(true);
                        }
                    }
                };
                xhr.onload = function () {
                    if (_isOneDs) {
                        _doOnReadyFunc(xhr);
                    }
                };
                function _doOnReadyFunc(xhr) {
                    var onReadyFunc = _onCompleteFuncs && _onCompleteFuncs.xhrOnComplete;
                    var onReadyFuncExist = onReadyFunc && isFunction$2(onReadyFunc);
                    if (onReadyFuncExist) {
                        onReadyFunc(xhr, oncomplete, payload);
                    }
                    else {
                        var response = getResponseText(xhr);
                        _doOnComplete(oncomplete, xhr[_DYN_STATUS$1 /* @min:%2estatus */], _getAllResponseHeaders(xhr, _isOneDs), response);
                    }
                }
                xhr.onerror = function (event) {
                    _doOnComplete(oncomplete, _isOneDs ? xhr[_DYN_STATUS$1 /* @min:%2estatus */] : 400, _getAllResponseHeaders(xhr, _isOneDs), _isOneDs ? STR_EMPTY : formatErrorMessageXhr(xhr));
                    rejectFunc && rejectFunc(event);
                };
                xhr.ontimeout = function () {
                    _doOnComplete(oncomplete, _isOneDs ? xhr[_DYN_STATUS$1 /* @min:%2estatus */] : 500, _getAllResponseHeaders(xhr, _isOneDs), _isOneDs ? STR_EMPTY : formatErrorMessageXhr(xhr));
                    resolveFunc && resolveFunc(false);
                };
                xhr.send(payload[_DYN_DATA$1 /* @min:%2edata */]);
                return thePromise;
            }
            /**
             * Send fetch API request
             * @param payload - {string} - The data payload to be sent.
             * @param sync - {boolean} - For fetch this identifies whether we are "unloading" (false) or a normal request
             */
            function _doFetchSender(payload, oncomplete, sync) {
                var _a;
                var endPointUrl = payload[_DYN_URL_STRING /* @min:%2eurlString */];
                var batch = payload[_DYN_DATA$1 /* @min:%2edata */];
                var plainTextBatch = _isOneDs ? batch : new Blob([batch], { type: "application/json" });
                var thePromise;
                var resolveFunc;
                var rejectFunc;
                var requestHeaders = new Headers();
                var batchLength = batch[_DYN_LENGTH$5 /* @min:%2elength */];
                var ignoreResponse = false;
                var responseHandled = false;
                var headers = payload[_DYN_HEADERS$1 /* @min:%2eheaders */] || {};
                //TODO: handle time out for 1ds
                var init = (_a = {
                        method: STR_POST_METHOD,
                        body: plainTextBatch
                    },
                    _a[DisabledPropertyName$1] = true // Mark so we don't attempt to track this request
                ,
                    _a);
                // Only add headers if there are headers to add, due to issue with some polyfills
                if (payload.headers && objKeys(payload.headers)[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                    arrForEach$1(objKeys(headers), function (headerName) {
                        requestHeaders.append(headerName, headers[headerName]);
                    });
                    init[_DYN_HEADERS$1 /* @min:%2eheaders */] = requestHeaders;
                }
                if (_sendCredentials && _isOneDs) {
                    // for 1ds, Don't send credentials when URL is file://
                    init.credentials = "include";
                }
                if (sync) {
                    init.keepalive = true;
                    _syncFetchPayload += batchLength;
                    if (_isOneDs) {
                        if (payload["_sendReason"] === 2 /* SendRequestReason.Unload */) {
                            // As a sync request (during unload), it is unlikely that we will get a chance to process the response so
                            // just like beacon send assume that the events have been accepted and processed
                            ignoreResponse = true;
                            if (_addNoResponse) {
                                endPointUrl += _noResponseQs;
                            }
                        }
                    }
                    else {
                        // for appinsights, set to true for all sync request
                        ignoreResponse = true;
                    }
                }
                var request = new Request(endPointUrl, init);
                try {
                    // Also try and tag the request (just in case the value in init is not copied over)
                    request[DisabledPropertyName$1] = true;
                }
                catch (e) {
                    // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
                    // cause the request to fail and we no telemetry would be sent
                }
                if (!sync && _enableSendPromise) {
                    thePromise = createPromise(function (resolve, reject) {
                        resolveFunc = resolve;
                        rejectFunc = reject;
                    });
                }
                if (!endPointUrl) {
                    _onNoPayloadUrl(oncomplete);
                    resolveFunc && resolveFunc(false);
                    return;
                }
                function _handleError(res) {
                    // In case there is an error in the request. Set the status to 0 for 1ds and 400 for appInsights
                    // so that the events can be retried later.
                    _doOnComplete(oncomplete, _isOneDs ? 0 : 400, {}, _isOneDs ? STR_EMPTY : res);
                }
                function _onFetchComplete(response, payload, value) {
                    var status = response[_DYN_STATUS$1 /* @min:%2estatus */];
                    var onCompleteFunc = _onCompleteFuncs.fetchOnComplete;
                    if (onCompleteFunc && isFunction$2(onCompleteFunc)) {
                        onCompleteFunc(response, oncomplete, value || STR_EMPTY, payload);
                    }
                    else {
                        _doOnComplete(oncomplete, status, {}, value || STR_EMPTY);
                    }
                }
                try {
                    doAwaitResponse(fetch(_isOneDs ? endPointUrl : request, _isOneDs ? init : null), function (result) {
                        if (sync) {
                            _syncFetchPayload -= batchLength;
                            batchLength = 0;
                        }
                        if (!responseHandled) {
                            responseHandled = true;
                            if (!result.rejected) {
                                var response_1 = result.value;
                                try {
                                    /**
                                     * The Promise returned from fetch() won’t reject on HTTP error status even if the response is an HTTP 404 or 500.
                                     * Instead, it will resolve normally (with ok status set to false), and it will only reject on network failure
                                     * or if anything prevented the request from completing.
                                     */
                                    if (!_isOneDs && !response_1.ok) {
                                        // this is for appInsights only
                                        _handleError(response_1.statusText);
                                        resolveFunc && resolveFunc(false);
                                    }
                                    else {
                                        if (_isOneDs && !response_1.body) {
                                            _onFetchComplete(response_1, null, STR_EMPTY);
                                            resolveFunc && resolveFunc(true);
                                        }
                                        else {
                                            doAwaitResponse(response_1.text(), function (resp) {
                                                _onFetchComplete(response_1, payload, resp.value);
                                                resolveFunc && resolveFunc(true);
                                            });
                                        }
                                    }
                                }
                                catch (e) {
                                    _handleError(dumpObj$2(e));
                                    rejectFunc && rejectFunc(e);
                                }
                            }
                            else {
                                _handleError(result.reason && result.reason[_DYN_MESSAGE$2 /* @min:%2emessage */]);
                                rejectFunc && rejectFunc(result.reason);
                            }
                        }
                    });
                }
                catch (e) {
                    if (!responseHandled) {
                        _handleError(dumpObj$2(e));
                        rejectFunc && rejectFunc(e);
                    }
                }
                if (ignoreResponse && !responseHandled) {
                    // Assume success during unload processing as we most likely won't get the response
                    responseHandled = true;
                    _doOnComplete(oncomplete, 200, {});
                    resolveFunc && resolveFunc(true);
                }
                if (_isOneDs && !responseHandled && payload[_DYN_TIMEOUT /* @min:%2etimeout */] > 0) {
                    // Simulate timeout
                    _timeoutWrapper && _timeoutWrapper.set(function () {
                        if (!responseHandled) {
                            // Assume a 500 response (which will cause a retry)
                            responseHandled = true;
                            _doOnComplete(oncomplete, 500, {});
                            resolveFunc && resolveFunc(true);
                        }
                    }, payload[_DYN_TIMEOUT /* @min:%2etimeout */]);
                }
                return thePromise;
            }
            /**
             * Send XDomainRequest
             * @param payload - {string} - The data payload to be sent.
             * @param sync - {boolean} - Indicates if the request should be sent synchronously
             *
             * Note: XDomainRequest does not support sync requests. This 'isAsync' parameter is added
             * to maintain consistency with the xhrSender's contract
             * Note: XDomainRequest does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */
            function _xdrSender(payload, oncomplete, sync) {
                // It doesn't support custom headers, so no action is taken with current requestHeaders
                var _window = getWindow$1();
                var xdr = new XDomainRequest();
                var data = payload[_DYN_DATA$1 /* @min:%2edata */];
                xdr.onload = function () {
                    var response = getResponseText(xdr);
                    var onloadFunc = _onCompleteFuncs && _onCompleteFuncs.xdrOnComplete;
                    if (onloadFunc && isFunction$2(onloadFunc)) {
                        onloadFunc(xdr, oncomplete, payload);
                    }
                    else {
                        _doOnComplete(oncomplete, 200, {}, response);
                    }
                };
                xdr.onerror = function () {
                    _doOnComplete(oncomplete, 400, {}, _isOneDs ? STR_EMPTY : formatErrorMessageXdr(xdr));
                };
                xdr.ontimeout = function () {
                    _doOnComplete(oncomplete, 500, {});
                };
                xdr.onprogress = function () { };
                // XDomainRequest requires the same protocol as the hosting page.
                // If the protocol doesn't match, we can't send the telemetry :(.
                var hostingProtocol = _window && _window.location && _window.location[_DYN_PROTOCOL /* @min:%2eprotocol */] || "";
                var endpoint = payload[_DYN_URL_STRING /* @min:%2eurlString */];
                if (!endpoint) {
                    _onNoPayloadUrl(oncomplete);
                    return;
                }
                if (!_isOneDs && endpoint.lastIndexOf(hostingProtocol, 0) !== 0) {
                    var msg = "Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.";
                    _throwInternal(_diagLog, 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + msg);
                    _onError(msg, oncomplete);
                    return;
                }
                var endpointUrl = _isOneDs ? endpoint : endpoint[_DYN_REPLACE /* @min:%2ereplace */](/^(https?:)/, "");
                xdr.open(STR_POST_METHOD, endpointUrl);
                if (payload[_DYN_TIMEOUT /* @min:%2etimeout */]) {
                    xdr[_DYN_TIMEOUT /* @min:%2etimeout */] = payload[_DYN_TIMEOUT /* @min:%2etimeout */];
                }
                xdr.send(data);
                if (_isOneDs && sync) {
                    _timeoutWrapper && _timeoutWrapper.set(function () {
                        xdr.send(data);
                    }, 0);
                }
                else {
                    xdr.send(data);
                }
            }
            function _initDefaults() {
                _syncFetchPayload = 0;
                _isInitialized = false;
                _enableSendPromise = false;
                _diagLog = null;
                _isOneDs = null;
                _onCompleteFuncs = null;
                _disableCredentials = null;
                _fallbackInst = null;
                _disableXhr = false;
                _disableBeacon = false;
                _disableBeaconSync = false;
                _disableFetchKeepAlive = false;
                _addNoResponse = false;
                _timeoutWrapper = null;
            }
        });
    }
// Removed Stub for SenderPostManager.prototype.initialize.
// Removed Stub for SenderPostManager.prototype.getSyncFetchPayload.
// Removed Stub for SenderPostManager.prototype.SetConfig.
// Removed Stub for SenderPostManager.prototype.getSenderInst.
// Removed Stub for SenderPostManager.prototype.getFallbackInst.
// Removed Stub for SenderPostManager.prototype._doTeardown.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    SenderPostManager.__ieDyn=1;

    return SenderPostManager;
}());

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
// Added to help with minfication
var strOnPrefix = "on";
var strAttachEvent = "attachEvent";
var strAddEventHelper = "addEventListener";
var strDetachEvent = "detachEvent";
var strRemoveEventListener = "removeEventListener";
var strEvents = "events";
var strVisibilityChangeEvt = "visibilitychange";
var strPageHide = "pagehide";
var strUnload = "unload";
var strBeforeUnload = "beforeunload";
var strPageHideNamespace = createUniqueNamespace("aiEvtPageHide");
createUniqueNamespace("aiEvtPageShow");
var rRemoveEmptyNs = /\.[\.]+/g;
var rRemoveTrailingEmptyNs = /[\.]+$/;
var _guid = 1;
var elmNodeData = createElmNodeData("events");
var eventNamespace = /^([^.]*)(?:\.(.+)|)/;
function _normalizeNamespace(name) {
    if (name && name[_DYN_REPLACE /* @min:%2ereplace */]) {
        return name[_DYN_REPLACE /* @min:%2ereplace */](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g, STR_EMPTY$1);
    }
    return name;
}
function _getEvtNamespace(eventName, evtNamespace) {
    var _a;
    if (evtNamespace) {
        var theNamespace_1 = STR_EMPTY$1;
        if (isArray$1(evtNamespace)) {
            theNamespace_1 = STR_EMPTY$1;
            arrForEach$1(evtNamespace, function (name) {
                name = _normalizeNamespace(name);
                if (name) {
                    if (name[0] !== ".") {
                        name = "." + name;
                    }
                    theNamespace_1 += name;
                }
            });
        }
        else {
            theNamespace_1 = _normalizeNamespace(evtNamespace);
        }
        if (theNamespace_1) {
            if (theNamespace_1[0] !== ".") {
                theNamespace_1 = "." + theNamespace_1;
            }
            // We may only have the namespace and not an eventName
            eventName = (eventName || STR_EMPTY$1) + theNamespace_1;
        }
    }
    var parsedEvent = (eventNamespace.exec(eventName || STR_EMPTY$1) || []);
    return _a = {},
        _a[_DYN_TYPE /* @min:type */] = parsedEvent[1],
        _a.ns = ((parsedEvent[2] || STR_EMPTY$1).replace(rRemoveEmptyNs, ".").replace(rRemoveTrailingEmptyNs, STR_EMPTY$1)[_DYN_SPLIT$1 /* @min:%2esplit */](".").sort()).join("."),
        _a;
}
// Exported for internal unit testing only
function _getRegisteredEvents(target, evtName, addDefault) {
    if (addDefault === void 0) { addDefault = true; }
    var aiEvts = elmNodeData.get(target, strEvents, {}, addDefault);
    var registeredEvents = aiEvts[evtName];
    if (!registeredEvents) {
        registeredEvents = aiEvts[evtName] = [];
    }
    return registeredEvents;
}
function _doDetach(obj, evtName, handlerRef, useCapture) {
    if (obj && evtName && evtName[_DYN_TYPE /* @min:%2etype */]) {
        if (obj[strRemoveEventListener]) {
            obj[strRemoveEventListener](evtName[_DYN_TYPE /* @min:%2etype */], handlerRef, useCapture);
        }
        else if (obj[strDetachEvent]) {
            obj[strDetachEvent](strOnPrefix + evtName[_DYN_TYPE /* @min:%2etype */], handlerRef);
        }
    }
}
function _doAttach(obj, evtName, handlerRef, useCapture) {
    var result = false;
    if (obj && evtName && evtName[_DYN_TYPE /* @min:%2etype */] && handlerRef) {
        if (obj[strAddEventHelper]) {
            // all browsers except IE before version 9
            obj[strAddEventHelper](evtName[_DYN_TYPE /* @min:%2etype */], handlerRef, useCapture);
            result = true;
        }
        else if (obj[strAttachEvent]) {
            // IE before version 9
            obj[strAttachEvent](strOnPrefix + evtName[_DYN_TYPE /* @min:%2etype */], handlerRef);
            result = true;
        }
    }
    return result;
}
function _doUnregister(target, events, evtName, unRegFn) {
    var idx = events[_DYN_LENGTH$5 /* @min:%2elength */];
    while (idx--) {
        var theEvent = events[idx];
        if (theEvent) {
            if (!evtName.ns || evtName.ns === theEvent.evtName.ns) {
                if (!unRegFn || unRegFn(theEvent)) {
                    _doDetach(target, theEvent.evtName, theEvent[_DYN_HANDLER /* @min:%2ehandler */], theEvent.capture);
                    // Remove the registered event
                    events[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
                }
            }
        }
    }
}
function _unregisterEvents(target, evtName, unRegFn) {
    if (evtName[_DYN_TYPE /* @min:%2etype */]) {
        _doUnregister(target, _getRegisteredEvents(target, evtName[_DYN_TYPE /* @min:%2etype */]), evtName, unRegFn);
    }
    else {
        var eventCache = elmNodeData.get(target, strEvents, {});
        objForEachKey$1(eventCache, function (evtType, events) {
            _doUnregister(target, events, evtName, unRegFn);
        });
        // Cleanup
        if (objKeys(eventCache)[_DYN_LENGTH$5 /* @min:%2elength */] === 0) {
            elmNodeData.kill(target, strEvents);
        }
    }
}
function mergeEvtNamespace(theNamespace, namespaces) {
    var newNamespaces;
    if (namespaces) {
        if (isArray$1(namespaces)) {
            newNamespaces = [theNamespace].concat(namespaces);
        }
        else {
            newNamespaces = [theNamespace, namespaces];
        }
        // resort the namespaces so they are always in order
        newNamespaces = (_getEvtNamespace("xx", newNamespaces).ns)[_DYN_SPLIT$1 /* @min:%2esplit */](".");
    }
    else {
        newNamespaces = theNamespace;
    }
    return newNamespaces;
}
/**
 * Binds the specified function to an event, so that the function gets called whenever the event fires on the object
 * @param obj - Object to add the event too.
 * @param eventName - String that specifies any of the standard DHTML Events without "on" prefix, if may also include an optional (dot "." prefixed)
 * namespaces "click" "click.mynamespace" in addition to specific namespaces.
 * @param handlerRef - Pointer that specifies the function to call when event fires
 * @param evtNamespace - [Optional] Additional namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace,
 * if the eventName also includes a namespace the namespace(s) are merged into a single namespace
 * @param useCapture - [Optional] Defaults to false
 * @returns True if the function was bound successfully to the event, otherwise false
 */
function eventOn(target, eventName, handlerRef, evtNamespace, useCapture) {
    var _a;
    if (useCapture === void 0) { useCapture = false; }
    var result = false;
    if (target) {
        try {
            var evtName = _getEvtNamespace(eventName, evtNamespace);
            result = _doAttach(target, evtName, handlerRef, useCapture);
            if (result && elmNodeData.accept(target)) {
                var registeredEvent = (_a = {
                        guid: _guid++,
                        evtName: evtName
                    },
                    _a[_DYN_HANDLER /* @min:handler */] = handlerRef,
                    _a.capture = useCapture,
                    _a);
                _getRegisteredEvents(target, evtName.type)[_DYN_PUSH$2 /* @min:%2epush */](registeredEvent);
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
    return result;
}
/**
 * Removes an event handler for the specified event
 * @param Object - to remove the event from
 * @param eventName - {string} - The name of the event, with optional namespaces or just the namespaces,
 * such as "click", "click.mynamespace" or ".mynamespace"
 * @param handlerRef - {any} - The callback function that needs to be removed from the given event, when using a
 * namespace (with or without a qualifying event) this may be null to remove all previously attached event handlers
 * otherwise this will only remove events with this specific handler.
 * @param evtNamespace - [Optional] Additional namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace,
 * if the eventName also includes a namespace the namespace(s) are merged into a single namespace
 * @param useCapture - [Optional] Defaults to false
 */
function eventOff(target, eventName, handlerRef, evtNamespace, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    if (target) {
        try {
            var evtName_1 = _getEvtNamespace(eventName, evtNamespace);
            var found_1 = false;
            _unregisterEvents(target, evtName_1, function (regEvent) {
                if ((evtName_1.ns && !handlerRef) || regEvent[_DYN_HANDLER /* @min:%2ehandler */] === handlerRef) {
                    found_1 = true;
                    return true;
                }
                return false;
            });
            if (!found_1) {
                // fallback to try and remove as requested
                _doDetach(target, evtName_1, handlerRef, useCapture);
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
}
/**
 * Trys to add an event handler for the specified event to the window, body and document
 * @param eventName - {string} - The name of the event
 * @param callback - {any} - The callback function that needs to be executed for the given event
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @return {boolean} - true if the handler was successfully added
 */
function addEventHandler(eventName, callback, evtNamespace) {
    var result = false;
    var w = getWindow$1();
    if (w) {
        result = eventOn(w, eventName, callback, evtNamespace);
        result = eventOn(w["body"], eventName, callback, evtNamespace) || result;
    }
    var doc = getDocument$1();
    if (doc) {
        result = eventOn(doc, eventName, callback, evtNamespace) || result;
    }
    return result;
}
/**
 * Trys to remove event handler(s) for the specified event/namespace to the window, body and document
 * @param eventName - {string} - The name of the event, with optional namespaces or just the namespaces,
 * such as "click", "click.mynamespace" or ".mynamespace"
 * @param callback - {any} - - The callback function that needs to be removed from the given event, when using a
 * namespace (with or without a qualifying event) this may be null to remove all previously attached event handlers
 * otherwise this will only remove events with this specific handler.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 */
function removeEventHandler(eventName, callback, evtNamespace) {
    var w = getWindow$1();
    if (w) {
        eventOff(w, eventName, callback, evtNamespace);
        eventOff(w["body"], eventName, callback, evtNamespace);
    }
    var doc = getDocument$1();
    if (doc) {
        eventOff(doc, eventName, callback, evtNamespace);
    }
}
/**
 * Bind the listener to the array of events
 * @param events - An string array of event names to bind the listener to
 * @param listener - The event callback to call when the event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function _addEventListeners(events, listener, excludeEvents, evtNamespace) {
    var added = false;
    if (listener && events && events[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
        arrForEach$1(events, function (name) {
            if (name) {
                if (!excludeEvents || arrIndexOf(excludeEvents, name) === -1) {
                    added = addEventHandler(name, listener, evtNamespace) || added;
                }
            }
        });
    }
    return added;
}
/**
 * Bind the listener to the array of events
 * @param events - An string array of event names to bind the listener to
 * @param listener - The event callback to call when the event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function addEventListeners(events, listener, excludeEvents, evtNamespace) {
    var added = false;
    if (listener && events && isArray$1(events)) {
        added = _addEventListeners(events, listener, excludeEvents, evtNamespace);
        if (!added && excludeEvents && excludeEvents[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
            // Failed to add any listeners and we excluded some, so just attempt to add the excluded events
            added = _addEventListeners(events, listener, null, evtNamespace);
        }
    }
    return added;
}
/**
 * Remove the listener from the array of events
 * @param events - An string array of event names to bind the listener to
 * @param listener - The event callback to call when the event is triggered
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 */
function removeEventListeners(events, listener, evtNamespace) {
    if (events && isArray$1(events)) {
        arrForEach$1(events, function (name) {
            if (name) {
                removeEventHandler(name, listener, evtNamespace);
            }
        });
    }
}
/**
 * Listen to the 'beforeunload', 'unload' and 'pagehide' events which indicates a page unload is occurring,
 * this does NOT listen to the 'visibilitychange' event as while it does indicate that the page is being hidden
 * it does not *necessarily* mean that the page is being completely unloaded, it can mean that the user is
 * just navigating to a different Tab and may come back (without unloading the page). As such you may also
 * need to listen to the 'addPageHideEventListener' and 'addPageShowEventListener' events.
 * @param listener - The event callback to call when a page unload event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked, unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function addPageUnloadEventListener(listener, excludeEvents, evtNamespace) {
    // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
    // As just hooking the window does not always fire (on chrome) for page navigation's.
    return addEventListeners([strBeforeUnload, strUnload, strPageHide], listener, excludeEvents, evtNamespace);
}
/**
 * Remove any matching 'beforeunload', 'unload' and 'pagehide' events that may have been added via addEventListener,
 * addEventListeners, addPageUnloadEventListener or addPageHideEventListener.
 * @param listener - The specific event callback to to be removed
 * @param evtNamespace - [Optional] Namespace(s) uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function removePageUnloadEventListener(listener, evtNamespace) {
    removeEventListeners([strBeforeUnload, strUnload, strPageHide], listener, evtNamespace);
}
/**
 * Listen to the pagehide and visibility changing to 'hidden' events, because the 'visibilitychange' uses
 * an internal proxy to detect the visibility state you SHOULD use a unique namespace when if you plan to call
 * removePageShowEventListener as the remove ignores the listener argument for the 'visibilitychange' event.
 * @param listener - The event callback to call when a page hide event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] A Namespace to append to the event listeners so they can be uniquely identified and removed
 * based on this namespace. This call also adds an additional unique "pageshow" namespace to the events
 * so that only the matching "removePageHideEventListener" can remove these events.
 * Suggestion: pass as true if you are also calling addPageUnloadEventListener as that also hooks pagehide
 * @returns true - when at least one of the events was registered otherwise false
 */
function addPageHideEventListener(listener, excludeEvents, evtNamespace) {
    function _handlePageVisibility(evt) {
        var doc = getDocument$1();
        if (listener && doc && doc.visibilityState === "hidden") {
            listener(evt);
        }
    }
    // add the unique page show namespace to any provided namespace so we can only remove the ones added by "pagehide"
    var newNamespaces = mergeEvtNamespace(strPageHideNamespace, evtNamespace);
    var pageUnloadAdded = _addEventListeners([strPageHide], listener, excludeEvents, newNamespaces);
    if (!excludeEvents || arrIndexOf(excludeEvents, strVisibilityChangeEvt) === -1) {
        pageUnloadAdded = _addEventListeners([strVisibilityChangeEvt], _handlePageVisibility, excludeEvents, newNamespaces) || pageUnloadAdded;
    }
    if (!pageUnloadAdded && excludeEvents) {
        // Failed to add any listeners and we where requested to exclude some, so just call again without excluding anything
        pageUnloadAdded = addPageHideEventListener(listener, null, evtNamespace);
    }
    return pageUnloadAdded;
}
/**
 * Removes the pageHide event listeners added by addPageHideEventListener, because the 'visibilitychange' uses
 * an internal proxy to detect the visibility state you SHOULD use a unique namespace when calling addPageHideEventListener
 * as the remove ignores the listener argument for the 'visibilitychange' event.
 * @param listener - The specific listener to remove for the 'pageshow' event only (ignored for 'visibilitychange')
 * @param evtNamespace - The unique namespace used when calling addPageShowEventListener
 */
function removePageHideEventListener(listener, evtNamespace) {
    // add the unique page show namespace to any provided namespace so we only remove the ones added by "pagehide"
    var newNamespaces = mergeEvtNamespace(strPageHideNamespace, evtNamespace);
    removeEventListeners([strPageHide], listener, newNamespaces);
    removeEventListeners([strVisibilityChangeEvt], null, newNamespaces);
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var aiInstrumentHooks = "_aiHooks";
var cbNames = [
    "req", "rsp", "hkErr", "fnErr"
];
/** @ignore */
function _arrLoop(arr, fn) {
    if (arr) {
        for (var lp = 0; lp < arr[_DYN_LENGTH$5 /* @min:%2elength */]; lp++) {
            if (fn(arr[lp], lp)) {
                break;
            }
        }
    }
}
/** @ignore */
function _doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
    if (type >= 0 /* CallbackType.Request */ && type <= 2 /* CallbackType.HookError */) {
        _arrLoop(hooks, function (hook, idx) {
            var cbks = hook.cbks;
            var cb = cbks[cbNames[type]];
            if (cb) {
                // Set the specific hook context implementation using a lazy creation pattern
                callDetails.ctx = function () {
                    var ctx = hookCtx[idx] = (hookCtx[idx] || {});
                    return ctx;
                };
                try {
                    cb[_DYN_APPLY /* @min:%2eapply */](callDetails.inst, cbArgs);
                }
                catch (err) {
                    var orgEx = callDetails.err;
                    try {
                        // Report Hook error via the callback
                        var hookErrorCb = cbks[cbNames[2 /* CallbackType.HookError */]];
                        if (hookErrorCb) {
                            callDetails.err = err;
                            hookErrorCb[_DYN_APPLY /* @min:%2eapply */](callDetails.inst, cbArgs);
                        }
                    }
                    catch (e) {
                        // Not much we can do here -- swallowing the exception to avoid crashing the hosting app
                    }
                    finally {
                        // restore the original exception (if any)
                        callDetails.err = orgEx;
                    }
                }
            }
        });
    }
}
/** @ignore */
function _createFunctionHook(aiHook) {
    // Define a temporary method that queues-up a the real method call
    return function () {
        var _a;
        var funcThis = this;
        // Capture the original arguments passed to the method
        var orgArgs = arguments;
        var hooks = aiHook.h;
        var funcArgs = (_a = {},
            _a[_DYN_NAME$3 /* @min:name */] = aiHook.n,
            _a.inst = funcThis,
            _a.ctx = null,
            _a.set = _replaceArg,
            _a);
        var hookCtx = [];
        var cbArgs = _createArgs([funcArgs], orgArgs);
        funcArgs.evt = getInst$1("event");
        function _createArgs(target, theArgs) {
            _arrLoop(theArgs, function (arg) {
                target[_DYN_PUSH$2 /* @min:%2epush */](arg);
            });
            return target;
        }
        function _replaceArg(idx, value) {
            orgArgs = _createArgs([], orgArgs);
            orgArgs[idx] = value;
            cbArgs = _createArgs([funcArgs], orgArgs);
        }
        // Call the pre-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0 /* CallbackType.Request */);
        // Call the original function was called
        var theFunc = aiHook.f;
        if (theFunc) {
            try {
                funcArgs.rslt = theFunc[_DYN_APPLY /* @min:%2eapply */](funcThis, orgArgs);
            }
            catch (err) {
                // Report the request callback
                funcArgs.err = err;
                _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3 /* CallbackType.FunctionError */);
                // rethrow the original exception so anyone listening for it can catch the exception
                throw err;
            }
        }
        // Call the post-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1 /* CallbackType.Response */);
        return funcArgs.rslt;
    };
}
/** @ignore */
function _getOwner(target, name, checkPrototype, checkParentProto) {
    var owner = null;
    if (target) {
        if (objHasOwnProperty$1(target, name)) {
            owner = target;
        }
        else if (checkPrototype) {
            owner = _getOwner(_getObjProto(target), name, checkParentProto, false);
        }
    }
    return owner;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 */
function InstrumentProto(target, funcName, callbacks) {
    if (target) {
        return InstrumentFunc(target[strShimPrototype], funcName, callbacks, false);
    }
    return null;
}
function _createInstrumentHook(owner, funcName, fn, callbacks) {
    var aiHook = fn && fn[aiInstrumentHooks];
    if (!aiHook) {
        // Only hook the function once
        aiHook = {
            i: 0,
            n: funcName,
            f: fn,
            h: []
        };
        // Override (hook) the original function
        var newFunc = _createFunctionHook(aiHook);
        newFunc[aiInstrumentHooks] = aiHook; // Tag and store the function hooks
        owner[funcName] = newFunc;
    }
    var theHook = {
        // tslint:disable:object-literal-shorthand
        id: aiHook.i,
        cbks: callbacks,
        rm: function () {
            // DO NOT Use () => { shorthand for the function as the this gets replaced
            // with the outer this and not the this for theHook instance.
            var id = this.id;
            _arrLoop(aiHook.h, function (hook, idx) {
                if (hook.id === id) {
                    aiHook.h[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
                    return 1;
                }
            });
        }
        // tslint:enable:object-literal-shorthand
    };
    aiHook.i++;
    aiHook.h[_DYN_PUSH$2 /* @min:%2epush */](theHook);
    return theHook;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 * @param checkParentProto - If the function doesn't exist on the target or it's prototype should it attempt to hook the parent's prototype
 */
function InstrumentFunc(target, funcName, callbacks, checkPrototype, checkParentProto) {
    if (checkPrototype === void 0) { checkPrototype = true; }
    if (target && funcName && callbacks) {
        var owner = _getOwner(target, funcName, checkPrototype, checkParentProto);
        if (owner) {
            var fn = owner[funcName];
            if (typeof fn === strShimFunction) {
                return _createInstrumentHook(owner, funcName, fn, callbacks);
            }
        }
    }
    return null;
}
/**
 * Add an instrumentation hook to the provided named "event" for the target class / object, this doesn't check whether the
 * named "event" is in fact a function and just assigns the instrumentation hook to the target[evtName]
 * @param target - The target object
 * @param evtName - The name of the event
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 * @param checkParentProto - If the function doesn't exist on the target or it's prototype should it attempt to hook the parent's prototype
 */
function InstrumentEvent(target, evtName, callbacks, checkPrototype, checkParentProto) {
    if (target && evtName && callbacks) {
        var owner = _getOwner(target, evtName, checkPrototype, checkParentProto) || target;
        if (owner) {
            return _createInstrumentHook(owner, evtName, owner[evtName], callbacks);
        }
    }
    return null;
}

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * This is an internal property used to cause internal (reporting) requests to be ignored from reporting
 * additional telemetry, to handle polyfil implementations ALL urls used with a disabled request will
 * also be ignored for future requests even when this property is not provided.
 * Tagging as Ignore as this is an internal value and is not expected to be used outside of the SDK
 * @ignore
 */
var DisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var SampleRate = "sampleRate";
var ProcessLegacy = "ProcessLegacy";
var HttpMethod = "http.method";
var DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
var DEFAULT_BREEZE_PATH = "/v2/track";
var strNotSpecified = "not_specified";
var strIkey = "iKey";

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var RequestHeaders = createValueMap({
    requestContextHeader: [0 /* eRequestHeaders.requestContextHeader */, "Request-Context"],
    requestContextTargetKey: [1 /* eRequestHeaders.requestContextTargetKey */, "appId"],
    requestContextAppIdFormat: [2 /* eRequestHeaders.requestContextAppIdFormat */, "appId=cid-v1:"],
    requestIdHeader: [3 /* eRequestHeaders.requestIdHeader */, "Request-Id"],
    traceParentHeader: [4 /* eRequestHeaders.traceParentHeader */, "traceparent"],
    traceStateHeader: [5 /* eRequestHeaders.traceStateHeader */, "tracestate"],
    sdkContextHeader: [6 /* eRequestHeaders.sdkContextHeader */, "Sdk-Context"],
    sdkContextHeaderAppIdRequest: [7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */, "appId"],
    requestContextHeaderLowerCase: [8 /* eRequestHeaders.requestContextHeaderLowerCase */, "request-context"]
});

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_SPLIT = "split"; // Count: 6
var _DYN_LENGTH$4 = "length"; // Count: 41
var _DYN_TO_LOWER_CASE$1 = "toLowerCase"; // Count: 6
var _DYN_INGESTIONENDPOINT = "ingestionendpoint"; // Count: 6
var _DYN_TO_STRING$2 = "toString"; // Count: 9
var _DYN_PUSH$1 = "push"; // Count: 5
var _DYN_REMOVE_ITEM = "removeItem"; // Count: 3
var _DYN_NAME$2 = "name"; // Count: 11
var _DYN_MESSAGE$1 = "message"; // Count: 10
var _DYN_COUNT$1 = "count"; // Count: 8
var _DYN_PRE_TRIGGER_DATE = "preTriggerDate"; // Count: 4
var _DYN_DISABLED = "disabled"; // Count: 3
var _DYN_INTERVAL = "interval"; // Count: 3
var _DYN_DAYS_OF_MONTH = "daysOfMonth"; // Count: 3
var _DYN_DATE = "date"; // Count: 5
var _DYN_GET_UTCDATE = "getUTCDate"; // Count: 3
var _DYN_STRINGIFY$1 = "stringify"; // Count: 4
var _DYN_PATHNAME = "pathname"; // Count: 4
var _DYN_CORRELATION_HEADER_E0 = "correlationHeaderExcludePatterns"; // Count: 2
var _DYN_EXCEPTIONS = "exceptions"; // Count: 6
var _DYN_PARSED_STACK = "parsedStack"; // Count: 13
var _DYN_PROPERTIES$1 = "properties"; // Count: 9
var _DYN_MEASUREMENTS$1 = "measurements"; // Count: 9
var _DYN_SIZE_IN_BYTES = "sizeInBytes"; // Count: 11
var _DYN_TYPE_NAME = "typeName"; // Count: 11
var _DYN_SEVERITY_LEVEL = "severityLevel"; // Count: 5
var _DYN_PROBLEM_GROUP = "problemGroup"; // Count: 3
var _DYN_IS_MANUAL = "isManual"; // Count: 3
var _DYN__CREATE_FROM_INTERFA1 = "CreateFromInterface"; // Count: 2
var _DYN_ASSEMBLY = "assembly"; // Count: 7
var _DYN_FILE_NAME = "fileName"; // Count: 8
var _DYN_HAS_FULL_STACK = "hasFullStack"; // Count: 6
var _DYN_LEVEL = "level"; // Count: 5
var _DYN_METHOD$1 = "method"; // Count: 7
var _DYN_LINE = "line"; // Count: 6
var _DYN_DURATION$1 = "duration"; // Count: 4
var _DYN_RECEIVED_RESPONSE = "receivedResponse"; // Count: 2

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
function dataSanitizeKeyAndAddUniqueness(logger, key, map) {
    var origLength = key[_DYN_LENGTH$4 /* @min:%2elength */];
    var field = dataSanitizeKey(logger, key);
    // validation truncated the length.  We need to add uniqueness
    if (field[_DYN_LENGTH$4 /* @min:%2elength */] !== origLength) {
        var i = 0;
        var uniqueField = field;
        while (map[uniqueField] !== undefined) {
            i++;
            uniqueField = strSubstring(field, 0, 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ - 3) + dsPadNumber(i);
        }
        field = uniqueField;
    }
    return field;
}
function dataSanitizeKey(logger, name) {
    var nameTrunc;
    if (name) {
        // Remove any leading or trailing whitespace
        name = strTrim(asString$1(name));
        // truncate the string to 150 chars
        if (name[_DYN_LENGTH$4 /* @min:%2elength */] > 150 /* DataSanitizerValues.MAX_NAME_LENGTH */) {
            nameTrunc = strSubstring(name, 0, 150 /* DataSanitizerValues.MAX_NAME_LENGTH */);
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 57 /* _eInternalMessageId.NameTooLong */, "name is too long.  It has been truncated to " + 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ + " characters.", { name: name }, true);
        }
    }
    return nameTrunc || name;
}
function dataSanitizeString(logger, value, maxLength) {
    if (maxLength === void 0) { maxLength = 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */; }
    var valueTrunc;
    if (value) {
        maxLength = maxLength ? maxLength : 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */; // in case default parameters dont work
        value = strTrim(asString$1(value));
        if (value[_DYN_LENGTH$4 /* @min:%2elength */] > maxLength) {
            valueTrunc = strSubstring(value, 0, maxLength);
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 61 /* _eInternalMessageId.StringValueTooLong */, "string value is too long. It has been truncated to " + maxLength + " characters.", { value: value }, true);
        }
    }
    return valueTrunc || value;
}
function dataSanitizeUrl(logger, url) {
    return dataSanitizeInput(logger, url, 2048 /* DataSanitizerValues.MAX_URL_LENGTH */, 66 /* _eInternalMessageId.UrlTooLong */);
}
function dataSanitizeMessage(logger, message) {
    var messageTrunc;
    if (message) {
        if (message[_DYN_LENGTH$4 /* @min:%2elength */] > 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */) {
            messageTrunc = strSubstring(message, 0, 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */);
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 56 /* _eInternalMessageId.MessageTruncated */, "message is too long, it has been truncated to " + 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */ + " characters.", { message: message }, true);
        }
    }
    return messageTrunc || message;
}
function dataSanitizeException(logger, exception) {
    var exceptionTrunc;
    if (exception) {
        // Make surte its a string
        var value = "" + exception;
        if (value[_DYN_LENGTH$4 /* @min:%2elength */] > 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */) {
            exceptionTrunc = strSubstring(value, 0, 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */);
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 52 /* _eInternalMessageId.ExceptionTruncated */, "exception is too long, it has been truncated to " + 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */ + " characters.", { exception: exception }, true);
        }
    }
    return exceptionTrunc || exception;
}
function dataSanitizeProperties(logger, properties) {
    if (properties) {
        var tempProps_1 = {};
        objForEachKey$1(properties, function (prop, value) {
            if (isObject$2(value) && hasJSON()) {
                // Stringify any part C properties
                try {
                    value = getJSON()[_DYN_STRINGIFY$1 /* @min:%2estringify */](value);
                }
                catch (e) {
                    _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */, "custom property is not valid", { exception: e }, true);
                }
            }
            value = dataSanitizeString(logger, value, 8192 /* DataSanitizerValues.MAX_PROPERTY_LENGTH */);
            prop = dataSanitizeKeyAndAddUniqueness(logger, prop, tempProps_1);
            tempProps_1[prop] = value;
        });
        properties = tempProps_1;
    }
    return properties;
}
function dataSanitizeMeasurements(logger, measurements) {
    if (measurements) {
        var tempMeasurements_1 = {};
        objForEachKey$1(measurements, function (measure, value) {
            measure = dataSanitizeKeyAndAddUniqueness(logger, measure, tempMeasurements_1);
            tempMeasurements_1[measure] = value;
        });
        measurements = tempMeasurements_1;
    }
    return measurements;
}
function dataSanitizeId(logger, id) {
    return id ? dataSanitizeInput(logger, id, 128 /* DataSanitizerValues.MAX_ID_LENGTH */, 69 /* _eInternalMessageId.IdTooLong */)[_DYN_TO_STRING$2 /* @min:%2etoString */]() : id;
}
function dataSanitizeInput(logger, input, maxLength, _msgId) {
    var inputTrunc;
    if (input) {
        input = strTrim(asString$1(input));
        if (input[_DYN_LENGTH$4 /* @min:%2elength */] > maxLength) {
            inputTrunc = strSubstring(input, 0, maxLength);
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", { data: input }, true);
        }
    }
    return inputTrunc || input;
}
function dsPadNumber(num) {
    var s = "00" + num;
    return strSubstr(s, s[_DYN_LENGTH$4 /* @min:%2elength */] - 3);
}

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var _document = getDocument$1() || {};
var _htmlAnchorIdx = 0;
// Use an array of temporary values as it's possible for multiple calls to parseUrl() will be called with different URLs
// Using a cache size of 5 for now as it current depth usage is at least 2, so adding a minor buffer to handle future updates
var _htmlAnchorElement = [null, null, null, null, null];
function urlParseUrl(url) {
    var anchorIdx = _htmlAnchorIdx;
    var anchorCache = _htmlAnchorElement;
    var tempAnchor = anchorCache[anchorIdx];
    if (!_document.createElement) {
        // Always create the temp instance if createElement is not available
        tempAnchor = { host: urlParseHost(url, true) };
    }
    else if (!anchorCache[anchorIdx]) {
        // Create and cache the unattached anchor instance
        tempAnchor = anchorCache[anchorIdx] = _document.createElement("a");
    }
    tempAnchor.href = url;
    // Move the cache index forward
    anchorIdx++;
    if (anchorIdx >= anchorCache[_DYN_LENGTH$4 /* @min:%2elength */]) {
        anchorIdx = 0;
    }
    _htmlAnchorIdx = anchorIdx;
    return tempAnchor;
}
function urlGetAbsoluteUrl(url) {
    var result;
    var a = urlParseUrl(url);
    if (a) {
        result = a.href;
    }
    return result;
}
function urlGetCompleteUrl(method, absoluteUrl) {
    if (method) {
        return method.toUpperCase() + " " + absoluteUrl;
    }
    return absoluteUrl;
}
// Fallback method to grab host from url if document.createElement method is not available
function urlParseHost(url, inclPort) {
    var fullHost = urlParseFullHost(url, inclPort) || "";
    if (fullHost) {
        var match = fullHost.match(/(www\d{0,5}\.)?([^\/:]{1,256})(:\d{1,20})?/i);
        if (match != null && match[_DYN_LENGTH$4 /* @min:%2elength */] > 3 && isString$2(match[2]) && match[2][_DYN_LENGTH$4 /* @min:%2elength */] > 0) {
            return match[2] + (match[3] || "");
        }
    }
    return fullHost;
}
function urlParseFullHost(url, inclPort) {
    var result = null;
    if (url) {
        var match = url.match(/(\w{1,150}):\/\/([^\/:]{1,256})(:\d{1,20})?/i);
        if (match != null && match[_DYN_LENGTH$4 /* @min:%2elength */] > 2 && isString$2(match[2]) && match[2][_DYN_LENGTH$4 /* @min:%2elength */] > 0) {
            result = match[2] || "";
            if (inclPort && match[_DYN_LENGTH$4 /* @min:%2elength */] > 2) {
                var protocol = (match[1] || "")[_DYN_TO_LOWER_CASE$1 /* @min:%2etoLowerCase */]();
                var port = match[3] || "";
                // IE includes the standard port so pass it off if it's the same as the protocol
                if (protocol === "http" && port === ":80") {
                    port = "";
                }
                else if (protocol === "https" && port === ":443") {
                    port = "";
                }
                result += port;
            }
        }
    }
    return result;
}

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
// listing only non-geo specific locations
var _internalEndpoints = [
    DEFAULT_BREEZE_ENDPOINT + DEFAULT_BREEZE_PATH,
    "https://breeze.aimon.applicationinsights.io" + DEFAULT_BREEZE_PATH,
    "https://dc-int.services.visualstudio.com" + DEFAULT_BREEZE_PATH
];
var _correlationIdPrefix = "cid-v1:";
function isInternalApplicationInsightsEndpoint(endpointUrl) {
    return arrIndexOf(_internalEndpoints, endpointUrl[_DYN_TO_LOWER_CASE$1 /* @min:%2etoLowerCase */]()) !== -1;
}
/**
 * Checks if a request url is not on a excluded domain list and if it is safe to add correlation headers.
 * Headers are always included if the current domain matches the request domain. If they do not match (CORS),
 * they are regex-ed across correlationHeaderDomains and correlationHeaderExcludedDomains to determine if headers are included.
 * Some environments don't give information on currentHost via window.location.host (e.g. Cordova). In these cases, the user must
 * manually supply domains to include correlation headers on. Else, no headers will be included at all.
 */
function correlationIdCanIncludeCorrelationHeader(config, requestUrl, currentHost) {
    if (!requestUrl || (config && config.disableCorrelationHeaders)) {
        return false;
    }
    if (config && config[_DYN_CORRELATION_HEADER_E0 /* @min:%2ecorrelationHeaderExcludePatterns */]) {
        for (var i = 0; i < config.correlationHeaderExcludePatterns[_DYN_LENGTH$4 /* @min:%2elength */]; i++) {
            if (config[_DYN_CORRELATION_HEADER_E0 /* @min:%2ecorrelationHeaderExcludePatterns */][i].test(requestUrl)) {
                return false;
            }
        }
    }
    var requestHost = urlParseUrl(requestUrl).host[_DYN_TO_LOWER_CASE$1 /* @min:%2etoLowerCase */]();
    if (requestHost && (strIndexOf(requestHost, ":443") !== -1 || strIndexOf(requestHost, ":80") !== -1)) {
        // [Bug #1260] IE can include the port even for http and https URLs so if present
        // try and parse it to remove if it matches the default protocol port
        requestHost = (urlParseFullHost(requestUrl, true) || "")[_DYN_TO_LOWER_CASE$1 /* @min:%2etoLowerCase */]();
    }
    if ((!config || !config.enableCorsCorrelation) && (requestHost && requestHost !== currentHost)) {
        return false;
    }
    var includedDomains = config && config.correlationHeaderDomains;
    if (includedDomains) {
        var matchExists_1;
        arrForEach$1(includedDomains, function (domain) {
            var regex = new RegExp(domain.toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
            matchExists_1 = matchExists_1 || regex.test(requestHost);
        });
        if (!matchExists_1) {
            return false;
        }
    }
    var excludedDomains = config && config.correlationHeaderExcludedDomains;
    if (!excludedDomains || excludedDomains[_DYN_LENGTH$4 /* @min:%2elength */] === 0) {
        return true;
    }
    for (var i = 0; i < excludedDomains[_DYN_LENGTH$4 /* @min:%2elength */]; i++) {
        var regex = new RegExp(excludedDomains[i].toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
        if (regex.test(requestHost)) {
            return false;
        }
    }
    // if we don't know anything about the requestHost, require the user to use included/excludedDomains.
    // Previously we always returned false for a falsy requestHost
    return requestHost && requestHost[_DYN_LENGTH$4 /* @min:%2elength */] > 0;
}
/**
 * Combines target appId and target role name from response header.
 */
function correlationIdGetCorrelationContext(responseHeader) {
    if (responseHeader) {
        var correlationId = correlationIdGetCorrelationContextValue(responseHeader, RequestHeaders[1 /* eRequestHeaders.requestContextTargetKey */]);
        if (correlationId && correlationId !== _correlationIdPrefix) {
            return correlationId;
        }
    }
}
/**
 * Gets key from correlation response header
 */
function correlationIdGetCorrelationContextValue(responseHeader, key) {
    if (responseHeader) {
        var keyValues = responseHeader[_DYN_SPLIT /* @min:%2esplit */](",");
        for (var i = 0; i < keyValues[_DYN_LENGTH$4 /* @min:%2elength */]; ++i) {
            var keyValue = keyValues[i][_DYN_SPLIT /* @min:%2esplit */]("=");
            if (keyValue[_DYN_LENGTH$4 /* @min:%2elength */] === 2 && keyValue[0] === key) {
                return keyValue[1];
            }
        }
    }
}
function AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName) {
    var target, name = commandName, data = commandName;
    if (absoluteUrl && absoluteUrl[_DYN_LENGTH$4 /* @min:%2elength */] > 0) {
        var parsedUrl = urlParseUrl(absoluteUrl);
        target = parsedUrl.host;
        if (!name) {
            if (parsedUrl[_DYN_PATHNAME /* @min:%2epathname */] != null) {
                var pathName = (parsedUrl.pathname[_DYN_LENGTH$4 /* @min:%2elength */] === 0) ? "/" : parsedUrl[_DYN_PATHNAME /* @min:%2epathname */];
                if (pathName.charAt(0) !== "/") {
                    pathName = "/" + pathName;
                }
                data = parsedUrl[_DYN_PATHNAME /* @min:%2epathname */];
                name = dataSanitizeString(logger, method ? method + " " + pathName : pathName);
            }
            else {
                name = dataSanitizeString(logger, absoluteUrl);
            }
        }
    }
    else {
        target = commandName;
        name = commandName;
    }
    return {
        target: target,
        name: name,
        data: data
    };
}
function dateTimeUtilsNow() {
    // returns the window or webworker performance object
    var perf = getPerformance();
    if (perf && perf.now && perf.timing) {
        var now = perf.now() + perf.timing.navigationStart;
        // Known issue with IE where this calculation can be negative, so if it is then ignore and fallback
        if (now > 0) {
            return now;
        }
    }
    return utcNow();
}
function dateTimeUtilsDuration(start, end) {
    var result = null;
    if (start !== 0 && end !== 0 && !isNullOrUndefined$1(start) && !isNullOrUndefined$1(end)) {
        result = end - start;
    }
    return result;
}
/**
 * Creates a IDistributedTraceContext from an optional telemetryTrace
 * @param telemetryTrace - The telemetryTrace instance that is being wrapped
 * @param parentCtx - An optional parent distributed trace instance, almost always undefined as this scenario is only used in the case of multiple property handlers.
 * @returns A new IDistributedTraceContext instance that is backed by the telemetryTrace or temporary object
 */
function createDistributedTraceContextFromTrace(telemetryTrace, parentCtx) {
    var trace = telemetryTrace || {};
    return {
        getName: function () {
            return trace[_DYN_NAME$2 /* @min:%2ename */];
        },
        setName: function (newValue) {
            parentCtx && parentCtx.setName(newValue);
            trace[_DYN_NAME$2 /* @min:%2ename */] = newValue;
        },
        getTraceId: function () {
            return trace.traceID;
        },
        setTraceId: function (newValue) {
            parentCtx && parentCtx.setTraceId(newValue);
            if (isValidTraceId(newValue)) {
                trace.traceID = newValue;
            }
        },
        getSpanId: function () {
            return trace.parentID;
        },
        setSpanId: function (newValue) {
            parentCtx && parentCtx.setSpanId(newValue);
            if (isValidSpanId(newValue)) {
                trace.parentID = newValue;
            }
        },
        getTraceFlags: function () {
            return trace.traceFlags;
        },
        setTraceFlags: function (newTraceFlags) {
            parentCtx && parentCtx.setTraceFlags(newTraceFlags);
            trace.traceFlags = newTraceFlags;
        }
    };
}

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var StorageType = createEnumStyle({
    LocalStorage: 0 /* eStorageType.LocalStorage */,
    SessionStorage: 1 /* eStorageType.SessionStorage */
});
createEnumStyle({
    AI: 0 /* eDistributedTracingModes.AI */,
    AI_AND_W3C: 1 /* eDistributedTracingModes.AI_AND_W3C */,
    W3C: 2 /* eDistributedTracingModes.W3C */
});
/**
 * The EventPersistence contains a set of values that specify the event's persistence.
 */
createEnumStyle({
    /**
     * Normal persistence.
     */
    Normal: 1 /* EventPersistenceValue.Normal */,
    /**
     * Critical persistence.
     */
    Critical: 2 /* EventPersistenceValue.Critical */
});

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var _canUseLocalStorage = undefined;
var _canUseSessionStorage = undefined;
var _storagePrefix = "";
/**
 * Gets the localStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */
function _getLocalStorageObject() {
    if (utlCanUseLocalStorage()) {
        return _getVerifiedStorageObject(StorageType.LocalStorage);
    }
    return null;
}
/**
 * Tests storage object (localStorage or sessionStorage) to verify that it is usable
 * More details here: https://mathiasbynens.be/notes/localstorage-pattern
 * @param storageType - Type of storage
 * @return {Storage} Returns storage object verified that it is usable
 */
function _getVerifiedStorageObject(storageType) {
    try {
        if (isNullOrUndefined$1(getGlobal$1())) {
            return null;
        }
        var uid = (new Date)[_DYN_TO_STRING$2 /* @min:%2etoString */]();
        var storage = getInst$1(storageType === StorageType.LocalStorage ? "localStorage" : "sessionStorage");
        var name_1 = _storagePrefix + uid;
        storage.setItem(name_1, uid);
        var fail = storage.getItem(name_1) !== uid;
        storage[_DYN_REMOVE_ITEM /* @min:%2eremoveItem */](name_1);
        if (!fail) {
            return storage;
        }
    }
    catch (exception) {
        // eslint-disable-next-line no-empty
    }
    return null;
}
/**
 * Gets the sessionStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */
function _getSessionStorageObject() {
    if (utlCanUseSessionStorage()) {
        return _getVerifiedStorageObject(StorageType.SessionStorage);
    }
    return null;
}
/**
 * Disables the global SDK usage of local or session storage if available
 */
function utlDisableStorage() {
    _canUseLocalStorage = false;
    _canUseSessionStorage = false;
}
function utlSetStoragePrefix(storagePrefix) {
    _storagePrefix = storagePrefix || "";
}
/**
 * Re-enables the global SDK usage of local or session storage if available
 */
function utlEnableStorage() {
    _canUseLocalStorage = utlCanUseLocalStorage(true);
    _canUseSessionStorage = utlCanUseSessionStorage(true);
}
/**
 * Returns whether LocalStorage can be used, if the reset parameter is passed a true this will override
 * any previous disable calls.
 * @param reset - Should the usage be reset and determined only based on whether LocalStorage is available
 */
function utlCanUseLocalStorage(reset) {
    if (reset || _canUseLocalStorage === undefined) {
        _canUseLocalStorage = !!_getVerifiedStorageObject(StorageType.LocalStorage);
    }
    return _canUseLocalStorage;
}
function utlGetLocalStorage(logger, name) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            return storage.getItem(name);
        }
        catch (e) {
            _canUseLocalStorage = false;
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 1 /* _eInternalMessageId.BrowserCannotReadLocalStorage */, "Browser failed read of local storage. " + getExceptionName(e), { exception: dumpObj$2(e) });
        }
    }
    return null;
}
function utlSetLocalStorage(logger, name, data) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            storage.setItem(name, data);
            return true;
        }
        catch (e) {
            _canUseLocalStorage = false;
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 3 /* _eInternalMessageId.BrowserCannotWriteLocalStorage */, "Browser failed write to local storage. " + getExceptionName(e), { exception: dumpObj$2(e) });
        }
    }
    return false;
}
function utlRemoveStorage(logger, name) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            storage[_DYN_REMOVE_ITEM /* @min:%2eremoveItem */](name);
            return true;
        }
        catch (e) {
            _canUseLocalStorage = false;
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 5 /* _eInternalMessageId.BrowserFailedRemovalFromLocalStorage */, "Browser failed removal of local storage item. " + getExceptionName(e), { exception: dumpObj$2(e) });
        }
    }
    return false;
}
function utlCanUseSessionStorage(reset) {
    if (reset || _canUseSessionStorage === undefined) {
        _canUseSessionStorage = !!_getVerifiedStorageObject(StorageType.SessionStorage);
    }
    return _canUseSessionStorage;
}
function utlGetSessionStorage(logger, name) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            return storage.getItem(name);
        }
        catch (e) {
            _canUseSessionStorage = false;
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 2 /* _eInternalMessageId.BrowserCannotReadSessionStorage */, "Browser failed read of session storage. " + getExceptionName(e), { exception: dumpObj$2(e) });
        }
    }
    return null;
}
function utlSetSessionStorage(logger, name, data) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            storage.setItem(name, data);
            return true;
        }
        catch (e) {
            _canUseSessionStorage = false;
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 4 /* _eInternalMessageId.BrowserCannotWriteSessionStorage */, "Browser failed write to session storage. " + getExceptionName(e), { exception: dumpObj$2(e) });
        }
    }
    return false;
}
function utlRemoveSessionStorage(logger, name) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            storage[_DYN_REMOVE_ITEM /* @min:%2eremoveItem */](name);
            return true;
        }
        catch (e) {
            _canUseSessionStorage = false;
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 6 /* _eInternalMessageId.BrowserFailedRemovalFromSessionStorage */, "Browser failed removal of session storage item. " + getExceptionName(e), { exception: dumpObj$2(e) });
        }
    }
    return false;
}

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var THROTTLE_STORAGE_PREFIX = "appInsightsThrottle";
var ThrottleMgr = /** @class */ (function () {
    function ThrottleMgr(core, namePrefix) {
        var _self = this;
        var _canUseLocalStorage;
        var _logger;
        var _config;
        var _localStorageObj;
        var _isTriggered; //_isTriggered is to make sure that we only trigger throttle once a day
        var _namePrefix;
        var _queue;
        var _isReady = false;
        var _isSpecificDaysGiven = false;
        _initConfig();
        // Special internal method to allow the unit tests and DebugPlugin to hook embedded objects
        _self["_getDbgPlgTargets"] = function () {
            return [_queue];
        };
        _self.getConfig = function () {
            return _config;
        };
        /**
         * Check if it is the correct day to send message.
         * If _isTriggered is true, even if canThrottle returns true, message will not be sent,
         * because we only allow triggering sendMessage() once a day.
         * @returns if the current date is the valid date to send message
         */
        _self.canThrottle = function (msgId) {
            var localObj = _getLocalStorageObjByKey(msgId);
            var cfg = _getCfgByKey(msgId);
            return _canThrottle(cfg, _canUseLocalStorage, localObj);
        };
        /**
         * Check if throttle is triggered on current day(UTC)
         * if canThrottle returns false, isTriggered will return false
         * @returns if throttle is triggered on current day(UTC)
         */
        _self.isTriggered = function (msgId) {
            return _isTrigger(msgId);
        };
        /**
         * Before isReady set to true, all message will be stored in queue.
         * Message will only be sent out after isReady set to true.
         * Initial and default value: false
         * @returns isReady state
         */
        _self.isReady = function () {
            return _isReady;
        };
        /**
         * Flush all message with given message key in queue with isReady state set to true.
         * @returns if message queue is flushed
         */
        _self.flush = function (msgId) {
            try {
                var queue = _getQueueByKey(msgId);
                if (queue && queue[_DYN_LENGTH$4 /* @min:%2elength */] > 0) {
                    var items = queue.slice(0);
                    _queue[msgId] = [];
                    arrForEach$1(items, function (item) {
                        _flushMessage(item.msgID, item[_DYN_MESSAGE$1 /* @min:%2emessage */], item.severity, false);
                    });
                    return true;
                }
            }
            catch (err) {
                // eslint-disable-next-line no-empty
            }
            return false;
        };
        /**
         * Flush all message in queue with isReady state set to true.
         * @returns if message queue is flushed
         */
        _self.flushAll = function () {
            try {
                if (_queue) {
                    var result_1 = true;
                    objForEachKey$1(_queue, function (key) {
                        var isFlushed = _self.flush(parseInt(key));
                        result_1 = result_1 && isFlushed;
                    });
                    return result_1;
                }
            }
            catch (err) {
                // eslint-disable-next-line no-empty
            }
            return false;
        };
        /**
         * Set isReady State
         * if isReady set to true, message queue will be flushed automatically.
         * @param isReady isReady State
         * @pa
         * @returns if message queue is flushed
         */
        _self.onReadyState = function (isReady, flushAll) {
            if (flushAll === void 0) { flushAll = true; }
            _isReady = isNullOrUndefined$1(isReady) ? true : isReady;
            if (_isReady && flushAll) {
                return _self.flushAll();
            }
            return null;
        };
        _self.sendMessage = function (msgID, message, severity) {
            return _flushMessage(msgID, message, severity, true);
        };
        function _flushMessage(msgID, message, severity, saveUnsentMsg) {
            if (_isReady) {
                var isSampledIn = _canSampledIn(msgID);
                if (!isSampledIn) {
                    return;
                }
                var cfg = _getCfgByKey(msgID);
                var localStorageObj = _getLocalStorageObjByKey(msgID);
                var canThrottle = _canThrottle(cfg, _canUseLocalStorage, localStorageObj);
                var throttled = false;
                var number = 0;
                var isTriggered = _isTrigger(msgID);
                try {
                    if (canThrottle && !isTriggered) {
                        number = Math.min(cfg.limit.maxSendNumber, localStorageObj[_DYN_COUNT$1 /* @min:%2ecount */] + 1);
                        localStorageObj[_DYN_COUNT$1 /* @min:%2ecount */] = 0;
                        throttled = true;
                        _isTriggered[msgID] = true;
                        localStorageObj[_DYN_PRE_TRIGGER_DATE /* @min:%2epreTriggerDate */] = new Date();
                    }
                    else {
                        _isTriggered[msgID] = canThrottle;
                        localStorageObj[_DYN_COUNT$1 /* @min:%2ecount */] += 1;
                    }
                    var localStorageName = _getLocalStorageName(msgID);
                    _resetLocalStorage(_logger, localStorageName, localStorageObj);
                    for (var i = 0; i < number; i++) {
                        _sendMessage(msgID, _logger, message, severity);
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return {
                    isThrottled: throttled,
                    throttleNum: number
                };
            }
            else {
                if (!!saveUnsentMsg) {
                    var queue = _getQueueByKey(msgID);
                    queue[_DYN_PUSH$1 /* @min:%2epush */]({
                        msgID: msgID,
                        message: message,
                        severity: severity
                    });
                }
            }
            return null;
        }
        function _initConfig() {
            _logger = safeGetLogger(core);
            _isTriggered = {};
            _localStorageObj = {};
            _queue = {};
            _config = {};
            _setCfgByKey(109 /* _eInternalMessageId.DefaultThrottleMsgKey */);
            _namePrefix = isNotNullOrUndefined(namePrefix) ? namePrefix : "";
            core.addUnloadHook(onConfigChange(core.config, function (details) {
                var coreConfig = details.cfg;
                _canUseLocalStorage = utlCanUseLocalStorage();
                var configMgr = coreConfig.throttleMgrCfg || {};
                objForEachKey$1(configMgr, function (key, cfg) {
                    _setCfgByKey(parseInt(key), cfg);
                });
            }));
        }
        function _getCfgByKey(msgID) {
            return _config[msgID] || _config[109 /* _eInternalMessageId.DefaultThrottleMsgKey */];
        }
        function _setCfgByKey(msgID, config) {
            var _a, _b;
            try {
                var cfg = config || {};
                var curCfg = {};
                curCfg[_DYN_DISABLED /* @min:%2edisabled */] = !!cfg[_DYN_DISABLED /* @min:%2edisabled */];
                var configInterval = cfg[_DYN_INTERVAL /* @min:%2einterval */] || {};
                _isSpecificDaysGiven = (configInterval === null || configInterval === void 0 ? void 0 : configInterval.daysOfMonth) && (configInterval === null || configInterval === void 0 ? void 0 : configInterval.daysOfMonth[_DYN_LENGTH$4 /* @min:%2elength */]) > 0;
                curCfg[_DYN_INTERVAL /* @min:%2einterval */] = _getIntervalConfig(configInterval);
                var limit = {
                    samplingRate: ((_a = cfg.limit) === null || _a === void 0 ? void 0 : _a.samplingRate) || 100,
                    // dafault: every time sent only 1 event
                    maxSendNumber: ((_b = cfg.limit) === null || _b === void 0 ? void 0 : _b.maxSendNumber) || 1
                };
                curCfg.limit = limit;
                _config[msgID] = curCfg;
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
        }
        function _getIntervalConfig(interval) {
            interval = interval || {};
            var monthInterval = interval === null || interval === void 0 ? void 0 : interval.monthInterval;
            var dayInterval = interval === null || interval === void 0 ? void 0 : interval.dayInterval;
            // default: send data every 3 month each year
            if (isNullOrUndefined$1(monthInterval) && isNullOrUndefined$1(dayInterval)) {
                interval.monthInterval = 3;
                if (!_isSpecificDaysGiven) {
                    // default: send data on 28th
                    interval[_DYN_DAYS_OF_MONTH /* @min:%2edaysOfMonth */] = [28];
                    _isSpecificDaysGiven = true;
                }
            }
            interval = {
                // dafault: sent every three months
                monthInterval: interval === null || interval === void 0 ? void 0 : interval.monthInterval,
                dayInterval: interval === null || interval === void 0 ? void 0 : interval.dayInterval,
                daysOfMonth: interval === null || interval === void 0 ? void 0 : interval.daysOfMonth
            };
            return interval;
        }
        function _canThrottle(config, canUseLocalStorage, localStorageObj) {
            if (config && !config[_DYN_DISABLED /* @min:%2edisabled */] && canUseLocalStorage && isNotNullOrUndefined(localStorageObj)) {
                var curDate = _getThrottleDate();
                var date = localStorageObj[_DYN_DATE /* @min:%2edate */];
                var interval = config[_DYN_INTERVAL /* @min:%2einterval */];
                var monthCheck = 1;
                if (interval === null || interval === void 0 ? void 0 : interval.monthInterval) {
                    var monthExpand = (curDate.getUTCFullYear() - date.getUTCFullYear()) * 12 + curDate.getUTCMonth() - date.getUTCMonth();
                    monthCheck = _checkInterval(interval.monthInterval, 0, monthExpand);
                }
                var dayCheck = 1;
                if (_isSpecificDaysGiven) {
                    dayCheck = arrIndexOf(interval[_DYN_DAYS_OF_MONTH /* @min:%2edaysOfMonth */], curDate[_DYN_GET_UTCDATE /* @min:%2egetUTCDate */]());
                }
                else if (interval === null || interval === void 0 ? void 0 : interval.dayInterval) {
                    var daySpan = Math.floor((curDate.getTime() - date.getTime()) / 86400000);
                    dayCheck = _checkInterval(interval.dayInterval, 0, daySpan);
                }
                return monthCheck >= 0 && dayCheck >= 0;
            }
            return false;
        }
        function _getLocalStorageName(msgKey, prefix) {
            var fix = isNotNullOrUndefined(prefix) ? prefix : "";
            if (msgKey) {
                return THROTTLE_STORAGE_PREFIX + fix + "-" + msgKey;
            }
            return null;
        }
        // returns if throttle is triggered on current Date
        function _isTriggeredOnCurDate(preTriggerDate) {
            try {
                if (preTriggerDate) {
                    var curDate = new Date();
                    return preTriggerDate.getUTCFullYear() === curDate.getUTCFullYear() &&
                        preTriggerDate.getUTCMonth() === curDate.getUTCMonth() &&
                        preTriggerDate[_DYN_GET_UTCDATE /* @min:%2egetUTCDate */]() === curDate[_DYN_GET_UTCDATE /* @min:%2egetUTCDate */]();
                }
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return false;
        }
        // transfer local storage string value to object that identifies start date, current count and preTriggerDate
        function _getLocalStorageObj(value, logger, storageName) {
            try {
                var storageObj = {
                    date: _getThrottleDate(),
                    count: 0
                };
                if (value) {
                    var obj = JSON.parse(value);
                    var curObj = {
                        date: _getThrottleDate(obj[_DYN_DATE /* @min:%2edate */]) || storageObj[_DYN_DATE /* @min:%2edate */],
                        count: obj[_DYN_COUNT$1 /* @min:%2ecount */] || storageObj[_DYN_COUNT$1 /* @min:%2ecount */],
                        preTriggerDate: obj.preTriggerDate ? _getThrottleDate(obj[_DYN_PRE_TRIGGER_DATE /* @min:%2epreTriggerDate */]) : undefined
                    };
                    return curObj;
                }
                else {
                    _resetLocalStorage(logger, storageName, storageObj);
                    return storageObj;
                }
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return null;
        }
        // if datestr is not defined, current date will be returned
        function _getThrottleDate(dateStr) {
            // if new Date() can't be created through the provided dateStr, null will be returned.
            try {
                if (dateStr) {
                    var date = new Date(dateStr);
                    //make sure it is a valid Date Object
                    if (!isNaN(date.getDate())) {
                        return date;
                    }
                }
                else {
                    return new Date();
                }
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return null;
        }
        function _resetLocalStorage(logger, storageName, obj) {
            try {
                return utlSetLocalStorage(logger, storageName, strTrim(JSON[_DYN_STRINGIFY$1 /* @min:%2estringify */](obj)));
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return false;
        }
        function _checkInterval(interval, start, current) {
            if (interval <= 0) {
                return 1;
            }
            // count from start year
            return (current >= start) && (current - start) % interval == 0 ? Math.floor((current - start) / interval) + 1 : -1;
        }
        function _sendMessage(msgID, logger, message, severity) {
            _throwInternal(logger, severity || 1 /* eLoggingSeverity.CRITICAL */, msgID, message);
        }
        // NOTE: config.limit.samplingRate is set to 4 decimal places,
        // so config.limit.samplingRate = 1 means 0.0001%
        function _canSampledIn(msgID) {
            try {
                var cfg = _getCfgByKey(msgID);
                return randomValue(1000000) <= cfg.limit.samplingRate;
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return false;
        }
        function _getLocalStorageObjByKey(key) {
            try {
                var curObj = _localStorageObj[key];
                if (!curObj) {
                    var localStorageName = _getLocalStorageName(key, _namePrefix);
                    curObj = _getLocalStorageObj(utlGetLocalStorage(_logger, localStorageName), _logger, localStorageName);
                    _localStorageObj[key] = curObj;
                }
                return _localStorageObj[key];
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return null;
        }
        function _isTrigger(key) {
            var isTrigger = _isTriggered[key];
            if (isNullOrUndefined$1(isTrigger)) {
                isTrigger = false;
                var localStorageObj = _getLocalStorageObjByKey(key);
                if (localStorageObj) {
                    isTrigger = _isTriggeredOnCurDate(localStorageObj[_DYN_PRE_TRIGGER_DATE /* @min:%2epreTriggerDate */]);
                }
                _isTriggered[key] = isTrigger;
            }
            return _isTriggered[key];
        }
        function _getQueueByKey(key) {
            _queue = _queue || {};
            if (isNullOrUndefined$1(_queue[key])) {
                _queue[key] = [];
            }
            return _queue[key];
        }
    }
    return ThrottleMgr;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var _FIELDS_SEPARATOR = ";";
var _FIELD_KEY_VALUE_SEPARATOR = "=";
function parseConnectionString(connectionString) {
    if (!connectionString) {
        return {};
    }
    var kvPairs = connectionString[_DYN_SPLIT /* @min:%2esplit */](_FIELDS_SEPARATOR);
    var result = arrReduce(kvPairs, function (fields, kv) {
        var kvParts = kv[_DYN_SPLIT /* @min:%2esplit */](_FIELD_KEY_VALUE_SEPARATOR);
        if (kvParts[_DYN_LENGTH$4 /* @min:%2elength */] === 2) { // only save fields with valid formats
            var key = kvParts[0][_DYN_TO_LOWER_CASE$1 /* @min:%2etoLowerCase */]();
            var value = kvParts[1];
            fields[key] = value;
        }
        return fields;
    }, {});
    if (objKeys(result)[_DYN_LENGTH$4 /* @min:%2elength */] > 0) {
        // this is a valid connection string, so parse the results
        if (result.endpointsuffix) {
            // apply the default endpoints
            var locationPrefix = result.location ? result.location + "." : "";
            result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] = result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] || ("https://" + locationPrefix + "dc." + result.endpointsuffix);
        }
        // apply user override endpoint or the default endpoints
        result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] = result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] || DEFAULT_BREEZE_ENDPOINT;
        if (strEndsWith(result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */], "/")) {
            result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] = result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */].slice(0, -1);
        }
    }
    return result;
}

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var Envelope = /** @class */ (function () {
    /**
     * Constructs a new instance of telemetry data.
     */
    function Envelope(logger, data, name) {
        var _this = this;
        var _self = this;
        _self.ver = 1;
        _self.sampleRate = 100.0;
        _self.tags = {};
        _self[_DYN_NAME$2 /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
        _self.data = data;
        _self.time = toISOString(new Date());
        _self.aiDataContract = {
            time: 1 /* FieldType.Required */,
            iKey: 1 /* FieldType.Required */,
            name: 1 /* FieldType.Required */,
            sampleRate: function () {
                return (_this.sampleRate === 100) ? 4 /* FieldType.Hidden */ : 1 /* FieldType.Required */;
            },
            tags: 1 /* FieldType.Required */,
            data: 1 /* FieldType.Required */
        };
    }
    return Envelope;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var Event$1 = /** @class */ (function () {
    /**
     * Constructs a new instance of the EventTelemetry object
     */
    function Event(logger, name, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            name: 1 /* FieldType.Required */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        _self[_DYN_NAME$2 /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
        _self[_DYN_PROPERTIES$1 /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
    }
    Event.envelopeType = "Microsoft.ApplicationInsights.{0}.Event";
    Event.dataType = "EventData";
    return Event;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var NoMethod = "<no_method>";
var strError = "error";
var strStack = "stack";
var strStackDetails = "stackDetails";
var strErrorSrc = "errorSrc";
var strMessage = "message";
var strDescription = "description";
function _stringify(value, convertToString) {
    var result = value;
    if (result && !isString$2(result)) {
        if (JSON && JSON[_DYN_STRINGIFY$1 /* @min:%2estringify */]) {
            result = JSON[_DYN_STRINGIFY$1 /* @min:%2estringify */](value);
            if (convertToString && (!result || result === "{}")) {
                if (isFunction$2(value[_DYN_TO_STRING$2 /* @min:%2etoString */])) {
                    result = value[_DYN_TO_STRING$2 /* @min:%2etoString */]();
                }
                else {
                    result = "" + value;
                }
            }
        }
        else {
            result = "" + value + " - (Missing JSON.stringify)";
        }
    }
    return result || "";
}
function _formatMessage(theEvent, errorType) {
    var evtMessage = theEvent;
    if (theEvent) {
        if (evtMessage && !isString$2(evtMessage)) {
            evtMessage = theEvent[strMessage] || theEvent[strDescription] || evtMessage;
        }
        // Make sure the message is a string
        if (evtMessage && !isString$2(evtMessage)) {
            // tslint:disable-next-line: prefer-conditional-expression
            evtMessage = _stringify(evtMessage, true);
        }
        if (theEvent["filename"]) {
            // Looks like an event object with filename
            evtMessage = evtMessage + " @" + (theEvent["filename"] || "") + ":" + (theEvent["lineno"] || "?") + ":" + (theEvent["colno"] || "?");
        }
    }
    // Automatically add the error type to the message if it does already appear to be present
    if (errorType && errorType !== "String" && errorType !== "Object" && errorType !== "Error" && strIndexOf(evtMessage || "", errorType) === -1) {
        evtMessage = errorType + ": " + evtMessage;
    }
    return evtMessage || "";
}
function _isExceptionDetailsInternal(value) {
    try {
        if (isObject$2(value)) {
            return "hasFullStack" in value && "typeName" in value;
        }
    }
    catch (e) {
        // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
    return false;
}
function _isExceptionInternal(value) {
    try {
        if (isObject$2(value)) {
            return ("ver" in value && "exceptions" in value && "properties" in value);
        }
    }
    catch (e) {
        // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
    return false;
}
function _isStackDetails(details) {
    return details && details.src && isString$2(details.src) && details.obj && isArray$1(details.obj);
}
function _convertStackObj(errorStack) {
    var src = errorStack || "";
    if (!isString$2(src)) {
        if (isString$2(src[strStack])) {
            src = src[strStack];
        }
        else {
            src = "" + src;
        }
    }
    var items = src[_DYN_SPLIT /* @min:%2esplit */]("\n");
    return {
        src: src,
        obj: items
    };
}
function _getOperaStack(errorMessage) {
    var stack = [];
    var lines = errorMessage[_DYN_SPLIT /* @min:%2esplit */]("\n");
    for (var lp = 0; lp < lines[_DYN_LENGTH$4 /* @min:%2elength */]; lp++) {
        var entry = lines[lp];
        if (lines[lp + 1]) {
            entry += "@" + lines[lp + 1];
            lp++;
        }
        stack[_DYN_PUSH$1 /* @min:%2epush */](entry);
    }
    return {
        src: errorMessage,
        obj: stack
    };
}
function _getStackFromErrorObj(errorObj) {
    var details = null;
    if (errorObj) {
        try {
            /* Using bracket notation is support older browsers (IE 7/8 -- dont remember the version) that throw when using dot
            notation for undefined objects and we don't want to loose the error from being reported */
            if (errorObj[strStack]) {
                // Chrome/Firefox
                details = _convertStackObj(errorObj[strStack]);
            }
            else if (errorObj[strError] && errorObj[strError][strStack]) {
                // Edge error event provides the stack and error object
                details = _convertStackObj(errorObj[strError][strStack]);
            }
            else if (errorObj["exception"] && errorObj.exception[strStack]) {
                details = _convertStackObj(errorObj.exception[strStack]);
            }
            else if (_isStackDetails(errorObj)) {
                details = errorObj;
            }
            else if (_isStackDetails(errorObj[strStackDetails])) {
                details = errorObj[strStackDetails];
            }
            else if (getWindow$1() && getWindow$1()["opera"] && errorObj[strMessage]) {
                // Opera
                details = _getOperaStack(errorObj[_DYN_MESSAGE$1 /* @min:%2emessage */]);
            }
            else if (errorObj["reason"] && errorObj.reason[strStack]) {
                // UnhandledPromiseRejection
                details = _convertStackObj(errorObj.reason[strStack]);
            }
            else if (isString$2(errorObj)) {
                details = _convertStackObj(errorObj);
            }
            else {
                var evtMessage = errorObj[strMessage] || errorObj[strDescription] || "";
                if (isString$2(errorObj[strErrorSrc])) {
                    if (evtMessage) {
                        evtMessage += "\n";
                    }
                    evtMessage += " from " + errorObj[strErrorSrc];
                }
                if (evtMessage) {
                    details = _convertStackObj(evtMessage);
                }
            }
        }
        catch (e) {
            // something unexpected happened so to avoid failing to report any error lets swallow the exception
            // and fallback to the callee/caller method
            details = _convertStackObj(e);
        }
    }
    return details || {
        src: "",
        obj: null
    };
}
function _formatStackTrace(stackDetails) {
    var stack = "";
    if (stackDetails) {
        if (stackDetails.obj) {
            arrForEach$1(stackDetails.obj, function (entry) {
                stack += entry + "\n";
            });
        }
        else {
            stack = stackDetails.src || "";
        }
    }
    return stack;
}
function _parseStack(stack) {
    var parsedStack;
    var frames = stack.obj;
    if (frames && frames[_DYN_LENGTH$4 /* @min:%2elength */] > 0) {
        parsedStack = [];
        var level_1 = 0;
        var totalSizeInBytes_1 = 0;
        arrForEach$1(frames, function (frame) {
            var theFrame = frame[_DYN_TO_STRING$2 /* @min:%2etoString */]();
            if (_StackFrame.regex.test(theFrame)) {
                var parsedFrame = new _StackFrame(theFrame, level_1++);
                totalSizeInBytes_1 += parsedFrame[_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */];
                parsedStack[_DYN_PUSH$1 /* @min:%2epush */](parsedFrame);
            }
        });
        // DP Constraint - exception parsed stack must be < 32KB
        // remove frames from the middle to meet the threshold
        var exceptionParsedStackThreshold = 32 * 1024;
        if (totalSizeInBytes_1 > exceptionParsedStackThreshold) {
            var left = 0;
            var right = parsedStack[_DYN_LENGTH$4 /* @min:%2elength */] - 1;
            var size = 0;
            var acceptedLeft = left;
            var acceptedRight = right;
            while (left < right) {
                // check size
                var lSize = parsedStack[left][_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */];
                var rSize = parsedStack[right][_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */];
                size += lSize + rSize;
                if (size > exceptionParsedStackThreshold) {
                    // remove extra frames from the middle
                    var howMany = acceptedRight - acceptedLeft + 1;
                    parsedStack.splice(acceptedLeft, howMany);
                    break;
                }
                // update pointers
                acceptedLeft = left;
                acceptedRight = right;
                left++;
                right--;
            }
        }
    }
    return parsedStack;
}
function _getErrorType(errorType) {
    // Gets the Error Type by passing the constructor (used to get the true type of native error object).
    var typeName = "";
    if (errorType) {
        typeName = errorType.typeName || errorType[_DYN_NAME$2 /* @min:%2ename */] || "";
        if (!typeName) {
            try {
                var funcNameRegex = /function (.{1,200})\(/;
                var results = (funcNameRegex).exec((errorType).constructor[_DYN_TO_STRING$2 /* @min:%2etoString */]());
                typeName = (results && results[_DYN_LENGTH$4 /* @min:%2elength */] > 1) ? results[1] : "";
            }
            catch (e) {
                // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
            }
        }
    }
    return typeName;
}
/**
 * Formats the provided errorObj for display and reporting, it may be a String, Object, integer or undefined depending on the browser.
 * @param errorObj - The supplied errorObj
 */
function _formatErrorCode(errorObj) {
    if (errorObj) {
        try {
            if (!isString$2(errorObj)) {
                var errorType = _getErrorType(errorObj);
                var result = _stringify(errorObj, false);
                if (!result || result === "{}") {
                    if (errorObj[strError]) {
                        // Looks like an MS Error Event
                        errorObj = errorObj[strError];
                        errorType = _getErrorType(errorObj);
                    }
                    result = _stringify(errorObj, true);
                }
                if (strIndexOf(result, errorType) !== 0 && errorType !== "String") {
                    return errorType + ":" + result;
                }
                return result;
            }
        }
        catch (e) {
            // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
        }
    }
    // Fallback to just letting the object format itself into a string
    return "" + (errorObj || "");
}
var Exception = /** @class */ (function () {
    /**
     * Constructs a new instance of the ExceptionTelemetry object
     */
    function Exception(logger, exception, properties, measurements, severityLevel, id) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            exceptions: 1 /* FieldType.Required */,
            severityLevel: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2; // TODO: handle the CS"4.0" ==> breeze 2 conversion in a better way
        if (!_isExceptionInternal(exception)) {
            if (!properties) {
                properties = {};
            }
            if (id) {
                properties.id = id;
            }
            _self[_DYN_EXCEPTIONS /* @min:%2eexceptions */] = [new _ExceptionDetails(logger, exception, properties)];
            _self[_DYN_PROPERTIES$1 /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
            _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
            if (severityLevel) {
                _self[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */] = severityLevel;
            }
            if (id) {
                _self.id = id;
            }
        }
        else {
            _self[_DYN_EXCEPTIONS /* @min:%2eexceptions */] = exception[_DYN_EXCEPTIONS /* @min:%2eexceptions */] || [];
            _self[_DYN_PROPERTIES$1 /* @min:%2eproperties */] = exception[_DYN_PROPERTIES$1 /* @min:%2eproperties */];
            _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = exception[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */];
            if (exception[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */]) {
                _self[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */] = exception[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */];
            }
            if (exception.id) {
                _self.id = exception.id;
                exception[_DYN_PROPERTIES$1 /* @min:%2eproperties */].id = exception.id;
            }
            if (exception[_DYN_PROBLEM_GROUP /* @min:%2eproblemGroup */]) {
                _self[_DYN_PROBLEM_GROUP /* @min:%2eproblemGroup */] = exception[_DYN_PROBLEM_GROUP /* @min:%2eproblemGroup */];
            }
            // bool/int types, use isNullOrUndefined
            if (!isNullOrUndefined$1(exception[_DYN_IS_MANUAL /* @min:%2eisManual */])) {
                _self[_DYN_IS_MANUAL /* @min:%2eisManual */] = exception[_DYN_IS_MANUAL /* @min:%2eisManual */];
            }
        }
    }
    Exception.CreateAutoException = function (message, url, lineNumber, columnNumber, error, evt, stack, errorSrc) {
        var _a;
        var errorType = _getErrorType(error || evt || message);
        return _a = {},
            _a[_DYN_MESSAGE$1 /* @min:message */] = _formatMessage(message, errorType),
            _a.url = url,
            _a.lineNumber = lineNumber,
            _a.columnNumber = columnNumber,
            _a.error = _formatErrorCode(error || evt || message),
            _a.evt = _formatErrorCode(evt || message),
            _a[_DYN_TYPE_NAME /* @min:typeName */] = errorType,
            _a.stackDetails = _getStackFromErrorObj(stack || error || evt),
            _a.errorSrc = errorSrc,
            _a;
    };
    Exception.CreateFromInterface = function (logger, exception, properties, measurements) {
        var exceptions = exception[_DYN_EXCEPTIONS /* @min:%2eexceptions */]
            && arrMap(exception[_DYN_EXCEPTIONS /* @min:%2eexceptions */], function (ex) { return _ExceptionDetails[_DYN__CREATE_FROM_INTERFA1 /* @min:%2eCreateFromInterface */](logger, ex); });
        var exceptionData = new Exception(logger, __assignFn(__assignFn({}, exception), { exceptions: exceptions }), properties, measurements);
        return exceptionData;
    };
    Exception.prototype.toInterface = function () {
        var _a;
        var _b = this, exceptions = _b.exceptions, properties = _b.properties, measurements = _b.measurements, severityLevel = _b.severityLevel, problemGroup = _b.problemGroup, id = _b.id, isManual = _b.isManual;
        var exceptionDetailsInterface = exceptions instanceof Array
            && arrMap(exceptions, function (exception) { return exception.toInterface(); })
            || undefined;
        return _a = {
                ver: "4.0"
            },
            _a[_DYN_EXCEPTIONS /* @min:exceptions */] = exceptionDetailsInterface,
            _a.severityLevel = severityLevel,
            _a.properties = properties,
            _a.measurements = measurements,
            _a.problemGroup = problemGroup,
            _a.id = id,
            _a.isManual = isManual,
            _a;
    };
    /**
     * Creates a simple exception with 1 stack frame. Useful for manual constracting of exception.
     */
    Exception.CreateSimpleException = function (message, typeName, assembly, fileName, details, line) {
        var _a;
        return {
            exceptions: [
                (_a = {},
                    _a[_DYN_HAS_FULL_STACK /* @min:hasFullStack */] = true,
                    _a.message = message,
                    _a.stack = details,
                    _a.typeName = typeName,
                    _a)
            ]
        };
    };
    Exception.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception";
    Exception.dataType = "ExceptionData";
    Exception.formatError = _formatErrorCode;
    return Exception;
}());
var _ExceptionDetails = /** @class */ (function () {
    function _ExceptionDetails(logger, exception, properties) {
        this.aiDataContract = {
            id: 0 /* FieldType.Default */,
            outerId: 0 /* FieldType.Default */,
            typeName: 1 /* FieldType.Required */,
            message: 1 /* FieldType.Required */,
            hasFullStack: 0 /* FieldType.Default */,
            stack: 0 /* FieldType.Default */,
            parsedStack: 2 /* FieldType.Array */
        };
        var _self = this;
        if (!_isExceptionDetailsInternal(exception)) {
            var error = exception;
            var evt = error && error.evt;
            if (!isError$2(error)) {
                error = error[strError] || evt || error;
            }
            _self[_DYN_TYPE_NAME /* @min:%2etypeName */] = dataSanitizeString(logger, _getErrorType(error)) || strNotSpecified;
            _self[_DYN_MESSAGE$1 /* @min:%2emessage */] = dataSanitizeMessage(logger, _formatMessage(exception || error, _self[_DYN_TYPE_NAME /* @min:%2etypeName */])) || strNotSpecified;
            var stack = exception[strStackDetails] || _getStackFromErrorObj(exception);
            _self[_DYN_PARSED_STACK /* @min:%2eparsedStack */] = _parseStack(stack);
            // after parsedStack is inited, iterate over each frame object, sanitize its assembly field
            if (isArray$1(_self[_DYN_PARSED_STACK /* @min:%2eparsedStack */])) {
                arrMap(_self[_DYN_PARSED_STACK /* @min:%2eparsedStack */], function (frame) {
                    frame[_DYN_ASSEMBLY /* @min:%2eassembly */] = dataSanitizeString(logger, frame[_DYN_ASSEMBLY /* @min:%2eassembly */]);
                    frame[_DYN_FILE_NAME /* @min:%2efileName */] = dataSanitizeString(logger, frame[_DYN_FILE_NAME /* @min:%2efileName */]);
                });
            }
            _self[strStack] = dataSanitizeException(logger, _formatStackTrace(stack));
            _self.hasFullStack = isArray$1(_self.parsedStack) && _self.parsedStack[_DYN_LENGTH$4 /* @min:%2elength */] > 0;
            if (properties) {
                properties[_DYN_TYPE_NAME /* @min:%2etypeName */] = properties[_DYN_TYPE_NAME /* @min:%2etypeName */] || _self[_DYN_TYPE_NAME /* @min:%2etypeName */];
            }
        }
        else {
            _self[_DYN_TYPE_NAME /* @min:%2etypeName */] = exception[_DYN_TYPE_NAME /* @min:%2etypeName */];
            _self[_DYN_MESSAGE$1 /* @min:%2emessage */] = exception[_DYN_MESSAGE$1 /* @min:%2emessage */];
            _self[strStack] = exception[strStack];
            _self[_DYN_PARSED_STACK /* @min:%2eparsedStack */] = exception[_DYN_PARSED_STACK /* @min:%2eparsedStack */] || [];
            _self[_DYN_HAS_FULL_STACK /* @min:%2ehasFullStack */] = exception[_DYN_HAS_FULL_STACK /* @min:%2ehasFullStack */];
        }
    }
    _ExceptionDetails.prototype.toInterface = function () {
        var _a;
        var _self = this;
        var parsedStack = _self[_DYN_PARSED_STACK /* @min:%2eparsedStack */] instanceof Array
            && arrMap(_self[_DYN_PARSED_STACK /* @min:%2eparsedStack */], function (frame) { return frame.toInterface(); });
        var exceptionDetailsInterface = (_a = {
                id: _self.id,
                outerId: _self.outerId,
                typeName: _self[_DYN_TYPE_NAME /* @min:%2etypeName */],
                message: _self[_DYN_MESSAGE$1 /* @min:%2emessage */],
                hasFullStack: _self[_DYN_HAS_FULL_STACK /* @min:%2ehasFullStack */],
                stack: _self[strStack]
            },
            _a[_DYN_PARSED_STACK /* @min:parsedStack */] = parsedStack || undefined,
            _a);
        return exceptionDetailsInterface;
    };
    _ExceptionDetails.CreateFromInterface = function (logger, exception) {
        var parsedStack = (exception[_DYN_PARSED_STACK /* @min:%2eparsedStack */] instanceof Array
            && arrMap(exception[_DYN_PARSED_STACK /* @min:%2eparsedStack */], function (frame) { return _StackFrame[_DYN__CREATE_FROM_INTERFA1 /* @min:%2eCreateFromInterface */](frame); }))
            || exception[_DYN_PARSED_STACK /* @min:%2eparsedStack */];
        var exceptionDetails = new _ExceptionDetails(logger, __assignFn(__assignFn({}, exception), { parsedStack: parsedStack }));
        return exceptionDetails;
    };
    return _ExceptionDetails;
}());
var _StackFrame = /** @class */ (function () {
    function _StackFrame(sourceFrame, level) {
        this.aiDataContract = {
            level: 1 /* FieldType.Required */,
            method: 1 /* FieldType.Required */,
            assembly: 0 /* FieldType.Default */,
            fileName: 0 /* FieldType.Default */,
            line: 0 /* FieldType.Default */
        };
        var _self = this;
        _self[_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */] = 0;
        // Not converting this to isString() as typescript uses this logic to "understand" the different
        // types for the 2 different code paths
        if (typeof sourceFrame === "string") {
            var frame = sourceFrame;
            _self[_DYN_LEVEL /* @min:%2elevel */] = level;
            _self[_DYN_METHOD$1 /* @min:%2emethod */] = NoMethod;
            _self[_DYN_ASSEMBLY /* @min:%2eassembly */] = strTrim(frame);
            _self[_DYN_FILE_NAME /* @min:%2efileName */] = "";
            _self[_DYN_LINE /* @min:%2eline */] = 0;
            var matches = frame.match(_StackFrame.regex);
            if (matches && matches[_DYN_LENGTH$4 /* @min:%2elength */] >= 5) {
                _self[_DYN_METHOD$1 /* @min:%2emethod */] = strTrim(matches[2]) || _self[_DYN_METHOD$1 /* @min:%2emethod */];
                _self[_DYN_FILE_NAME /* @min:%2efileName */] = strTrim(matches[4]);
                _self[_DYN_LINE /* @min:%2eline */] = parseInt(matches[5]) || 0;
            }
        }
        else {
            _self[_DYN_LEVEL /* @min:%2elevel */] = sourceFrame[_DYN_LEVEL /* @min:%2elevel */];
            _self[_DYN_METHOD$1 /* @min:%2emethod */] = sourceFrame[_DYN_METHOD$1 /* @min:%2emethod */];
            _self[_DYN_ASSEMBLY /* @min:%2eassembly */] = sourceFrame[_DYN_ASSEMBLY /* @min:%2eassembly */];
            _self[_DYN_FILE_NAME /* @min:%2efileName */] = sourceFrame[_DYN_FILE_NAME /* @min:%2efileName */];
            _self[_DYN_LINE /* @min:%2eline */] = sourceFrame[_DYN_LINE /* @min:%2eline */];
            _self[_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */] = 0;
        }
        _self.sizeInBytes += _self.method[_DYN_LENGTH$4 /* @min:%2elength */];
        _self.sizeInBytes += _self.fileName[_DYN_LENGTH$4 /* @min:%2elength */];
        _self.sizeInBytes += _self.assembly[_DYN_LENGTH$4 /* @min:%2elength */];
        // todo: these might need to be removed depending on how the back-end settles on their size calculation
        _self[_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */] += _StackFrame.baseSize;
        _self.sizeInBytes += _self.level.toString()[_DYN_LENGTH$4 /* @min:%2elength */];
        _self.sizeInBytes += _self.line.toString()[_DYN_LENGTH$4 /* @min:%2elength */];
    }
    _StackFrame.CreateFromInterface = function (frame) {
        return new _StackFrame(frame, null /* level is available in frame interface */);
    };
    _StackFrame.prototype.toInterface = function () {
        var _self = this;
        return {
            level: _self[_DYN_LEVEL /* @min:%2elevel */],
            method: _self[_DYN_METHOD$1 /* @min:%2emethod */],
            assembly: _self[_DYN_ASSEMBLY /* @min:%2eassembly */],
            fileName: _self[_DYN_FILE_NAME /* @min:%2efileName */],
            line: _self[_DYN_LINE /* @min:%2eline */]
        };
    };
    // regex to match stack frames from ie/chrome/ff
    // methodName=$2, fileName=$4, lineNo=$5, column=$6
    _StackFrame.regex = /^([\s]+at)?[\s]{0,50}([^\@\()]+?)[\s]{0,50}(\@|\()([^\(\n]+):([0-9]+):([0-9]+)(\)?)$/;
    _StackFrame.baseSize = 58; // '{"method":"","level":,"assembly":"","fileName":"","line":}'.length
    return _StackFrame;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var DataPoint = /** @class */ (function () {
    function DataPoint() {
        /**
         * The data contract for serializing this object.
         */
        this.aiDataContract = {
            name: 1 /* FieldType.Required */,
            kind: 0 /* FieldType.Default */,
            value: 1 /* FieldType.Required */,
            count: 0 /* FieldType.Default */,
            min: 0 /* FieldType.Default */,
            max: 0 /* FieldType.Default */,
            stdDev: 0 /* FieldType.Default */
        };
        /**
         * Metric type. Single measurement or the aggregated value.
         */
        this.kind = 0 /* DataPointType.Measurement */;
    }
    return DataPoint;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var Metric = /** @class */ (function () {
    /**
     * Constructs a new instance of the MetricTelemetry object
     */
    function Metric(logger, name, value, count, min, max, stdDev, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            metrics: 1 /* FieldType.Required */,
            properties: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        var dataPoint = new DataPoint();
        dataPoint[_DYN_COUNT$1 /* @min:%2ecount */] = count > 0 ? count : undefined;
        dataPoint.max = isNaN(max) || max === null ? undefined : max;
        dataPoint.min = isNaN(min) || min === null ? undefined : min;
        dataPoint[_DYN_NAME$2 /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
        dataPoint.value = value;
        dataPoint.stdDev = isNaN(stdDev) || stdDev === null ? undefined : stdDev;
        _self.metrics = [dataPoint];
        _self[_DYN_PROPERTIES$1 /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
    }
    Metric.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric";
    Metric.dataType = "MetricData";
    return Metric;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var strEmpty = "";
/**
 * Convert ms to c# time span format
 */
function msToTimeSpan(totalms) {
    if (isNaN(totalms) || totalms < 0) {
        totalms = 0;
    }
    totalms = Math.round(totalms);
    var ms = strEmpty + totalms % 1000;
    var sec = strEmpty + Math.floor(totalms / 1000) % 60;
    var min = strEmpty + Math.floor(totalms / (1000 * 60)) % 60;
    var hour = strEmpty + Math.floor(totalms / (1000 * 60 * 60)) % 24;
    var days = Math.floor(totalms / (1000 * 60 * 60 * 24));
    ms = ms[_DYN_LENGTH$4 /* @min:%2elength */] === 1 ? "00" + ms : ms[_DYN_LENGTH$4 /* @min:%2elength */] === 2 ? "0" + ms : ms;
    sec = sec[_DYN_LENGTH$4 /* @min:%2elength */] < 2 ? "0" + sec : sec;
    min = min[_DYN_LENGTH$4 /* @min:%2elength */] < 2 ? "0" + min : min;
    hour = hour[_DYN_LENGTH$4 /* @min:%2elength */] < 2 ? "0" + hour : hour;
    return (days > 0 ? days + "." : strEmpty) + hour + ":" + min + ":" + sec + "." + ms;
}
function isCrossOriginError(message, url, lineNumber, columnNumber, error) {
    return !error && isString$2(message) && (message === "Script error." || message === "Script error");
}

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var PageView = /** @class */ (function () {
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageView(logger, name, url, durationMs, properties, measurements, id) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            name: 0 /* FieldType.Default */,
            url: 0 /* FieldType.Default */,
            duration: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */,
            id: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        _self.id = dataSanitizeId(logger, id);
        _self.url = dataSanitizeUrl(logger, url);
        _self[_DYN_NAME$2 /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
        if (!isNaN(durationMs)) {
            _self[_DYN_DURATION$1 /* @min:%2eduration */] = msToTimeSpan(durationMs);
        }
        _self[_DYN_PROPERTIES$1 /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
    }
    PageView.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
    PageView.dataType = "PageviewData";
    return PageView;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var RemoteDependencyData = /** @class */ (function () {
    /**
     * Constructs a new instance of the RemoteDependencyData object
     */
    function RemoteDependencyData(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
        if (requestAPI === void 0) { requestAPI = "Ajax"; }
        this.aiDataContract = {
            id: 1 /* FieldType.Required */,
            ver: 1 /* FieldType.Required */,
            name: 0 /* FieldType.Default */,
            resultCode: 0 /* FieldType.Default */,
            duration: 0 /* FieldType.Default */,
            success: 0 /* FieldType.Default */,
            data: 0 /* FieldType.Default */,
            target: 0 /* FieldType.Default */,
            type: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */,
            kind: 0 /* FieldType.Default */,
            value: 0 /* FieldType.Default */,
            count: 0 /* FieldType.Default */,
            min: 0 /* FieldType.Default */,
            max: 0 /* FieldType.Default */,
            stdDev: 0 /* FieldType.Default */,
            dependencyKind: 0 /* FieldType.Default */,
            dependencySource: 0 /* FieldType.Default */,
            commandName: 0 /* FieldType.Default */,
            dependencyTypeName: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        _self.id = id;
        _self[_DYN_DURATION$1 /* @min:%2eduration */] = msToTimeSpan(value);
        _self.success = success;
        _self.resultCode = resultCode + "";
        _self.type = dataSanitizeString(logger, requestAPI);
        var dependencyFields = AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName);
        _self.data = dataSanitizeUrl(logger, commandName) || dependencyFields.data; // get a value from hosturl if commandName not available
        _self.target = dataSanitizeString(logger, dependencyFields.target);
        if (correlationContext) {
            _self.target = "".concat(_self.target, " | ").concat(correlationContext);
        }
        _self[_DYN_NAME$2 /* @min:%2ename */] = dataSanitizeString(logger, dependencyFields[_DYN_NAME$2 /* @min:%2ename */]);
        _self[_DYN_PROPERTIES$1 /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
    }
    RemoteDependencyData.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
    RemoteDependencyData.dataType = "RemoteDependencyData";
    return RemoteDependencyData;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var Trace = /** @class */ (function () {
    /**
     * Constructs a new instance of the TraceTelemetry object
     */
    function Trace(logger, message, severityLevel, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            message: 1 /* FieldType.Required */,
            severityLevel: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        message = message || strNotSpecified;
        _self[_DYN_MESSAGE$1 /* @min:%2emessage */] = dataSanitizeMessage(logger, message);
        _self[_DYN_PROPERTIES$1 /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
        if (severityLevel) {
            _self[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */] = severityLevel;
        }
    }
    Trace.envelopeType = "Microsoft.ApplicationInsights.{0}.Message";
    Trace.dataType = "MessageData";
    return Trace;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var PageViewPerformance = /** @class */ (function () {
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageViewPerformance(logger, name, url, unused, properties, measurements, cs4BaseData) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            name: 0 /* FieldType.Default */,
            url: 0 /* FieldType.Default */,
            duration: 0 /* FieldType.Default */,
            perfTotal: 0 /* FieldType.Default */,
            networkConnect: 0 /* FieldType.Default */,
            sentRequest: 0 /* FieldType.Default */,
            receivedResponse: 0 /* FieldType.Default */,
            domProcessing: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        _self.url = dataSanitizeUrl(logger, url);
        _self[_DYN_NAME$2 /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
        _self[_DYN_PROPERTIES$1 /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
        if (cs4BaseData) {
            _self.domProcessing = cs4BaseData.domProcessing;
            _self[_DYN_DURATION$1 /* @min:%2eduration */] = cs4BaseData[_DYN_DURATION$1 /* @min:%2eduration */];
            _self.networkConnect = cs4BaseData.networkConnect;
            _self.perfTotal = cs4BaseData.perfTotal;
            _self[_DYN_RECEIVED_RESPONSE /* @min:%2ereceivedResponse */] = cs4BaseData[_DYN_RECEIVED_RESPONSE /* @min:%2ereceivedResponse */];
            _self.sentRequest = cs4BaseData.sentRequest;
        }
    }
    PageViewPerformance.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance";
    PageViewPerformance.dataType = "PageviewPerformanceData";
    return PageViewPerformance;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Data = /** @class */ (function () {
    /**
     * Constructs a new instance of telemetry data.
     */
    function Data(baseType, data) {
        /**
         * The data contract for serializing this object.
         */
        this.aiDataContract = {
            baseType: 1 /* FieldType.Required */,
            baseData: 1 /* FieldType.Required */
        };
        this.baseType = baseType;
        this.baseData = data;
    }
    return Data;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
function _aiNameFunc(baseName) {
    var aiName = "ai." + baseName + ".";
    return function (name) {
        return aiName + name;
    };
}
var _aiApplication = _aiNameFunc("application");
var _aiDevice = _aiNameFunc("device");
var _aiLocation = _aiNameFunc("location");
var _aiOperation = _aiNameFunc("operation");
var _aiSession = _aiNameFunc("session");
var _aiUser = _aiNameFunc("user");
var _aiCloud = _aiNameFunc("cloud");
var _aiInternal = _aiNameFunc("internal");
var ContextTagKeys = /** @class */ (function (_super) {
    __extendsFn(ContextTagKeys, _super);
    function ContextTagKeys() {
        return _super.call(this) || this;
    }
    return ContextTagKeys;
}(createClassFromInterface({
    applicationVersion: _aiApplication("ver"),
    applicationBuild: _aiApplication("build"),
    applicationTypeId: _aiApplication("typeId"),
    applicationId: _aiApplication("applicationId"),
    applicationLayer: _aiApplication("layer"),
    deviceId: _aiDevice("id"),
    deviceIp: _aiDevice("ip"),
    deviceLanguage: _aiDevice("language"),
    deviceLocale: _aiDevice("locale"),
    deviceModel: _aiDevice("model"),
    deviceFriendlyName: _aiDevice("friendlyName"),
    deviceNetwork: _aiDevice("network"),
    deviceNetworkName: _aiDevice("networkName"),
    deviceOEMName: _aiDevice("oemName"),
    deviceOS: _aiDevice("os"),
    deviceOSVersion: _aiDevice("osVersion"),
    deviceRoleInstance: _aiDevice("roleInstance"),
    deviceRoleName: _aiDevice("roleName"),
    deviceScreenResolution: _aiDevice("screenResolution"),
    deviceType: _aiDevice("type"),
    deviceMachineName: _aiDevice("machineName"),
    deviceVMName: _aiDevice("vmName"),
    deviceBrowser: _aiDevice("browser"),
    deviceBrowserVersion: _aiDevice("browserVersion"),
    locationIp: _aiLocation("ip"),
    locationCountry: _aiLocation("country"),
    locationProvince: _aiLocation("province"),
    locationCity: _aiLocation("city"),
    operationId: _aiOperation("id"),
    operationName: _aiOperation("name"),
    operationParentId: _aiOperation("parentId"),
    operationRootId: _aiOperation("rootId"),
    operationSyntheticSource: _aiOperation("syntheticSource"),
    operationCorrelationVector: _aiOperation("correlationVector"),
    sessionId: _aiSession("id"),
    sessionIsFirst: _aiSession("isFirst"),
    sessionIsNew: _aiSession("isNew"),
    userAccountAcquisitionDate: _aiUser("accountAcquisitionDate"),
    userAccountId: _aiUser("accountId"),
    userAgent: _aiUser("userAgent"),
    userId: _aiUser("id"),
    userStoreRegion: _aiUser("storeRegion"),
    userAuthUserId: _aiUser("authUserId"),
    userAnonymousUserAcquisitionDate: _aiUser("anonUserAcquisitionDate"),
    userAuthenticatedUserAcquisitionDate: _aiUser("authUserAcquisitionDate"),
    cloudName: _aiCloud("name"),
    cloudRole: _aiCloud("role"),
    cloudRoleVer: _aiCloud("roleVer"),
    cloudRoleInstance: _aiCloud("roleInstance"),
    cloudEnvironment: _aiCloud("environment"),
    cloudLocation: _aiCloud("location"),
    cloudDeploymentUnit: _aiCloud("deploymentUnit"),
    internalNodeName: _aiInternal("nodeName"),
    internalSdkVersion: _aiInternal("sdkVersion"),
    internalAgentVersion: _aiInternal("agentVersion"),
    internalSnippet: _aiInternal("snippet"),
    internalSdkSrc: _aiInternal("sdkSrc")
})));

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * Create a telemetry item that the 1DS channel understands
 * @param item - domain specific properties; part B
 * @param baseType - telemetry item type. ie PageViewData
 * @param envelopeName - name of the envelope. ie Microsoft.ApplicationInsights.<instrumentation key>.PageView
 * @param customProperties - user defined custom properties; part C
 * @param systemProperties - system properties that are added to the context; part A
 * @returns ITelemetryItem that is sent to channel
 */
function createTelemetryItem(item, baseType, envelopeName, logger, customProperties, systemProperties) {
    var _a;
    envelopeName = dataSanitizeString(logger, envelopeName) || strNotSpecified;
    if (isNullOrUndefined$1(item) ||
        isNullOrUndefined$1(baseType) ||
        isNullOrUndefined$1(envelopeName)) {
        throwError("Input doesn't contain all required fields");
    }
    var iKey = "";
    if (item[strIkey]) {
        iKey = item[strIkey];
        delete item[strIkey];
    }
    var telemetryItem = (_a = {},
        _a[_DYN_NAME$2 /* @min:name */] = envelopeName,
        _a.time = toISOString(new Date()),
        _a.iKey = iKey,
        _a.ext = systemProperties ? systemProperties : {},
        _a.tags = [],
        _a.data = {},
        _a.baseType = baseType,
        _a.baseData = item // Part B
    ,
        _a);
    // Part C
    if (!isNullOrUndefined$1(customProperties)) {
        objForEachKey$1(customProperties, function (prop, value) {
            telemetryItem.data[prop] = value;
        });
    }
    return telemetryItem;
}

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var Extensions = {
    UserExt: "user",
    DeviceExt: "device",
    TraceExt: "trace",
    WebExt: "web",
    AppExt: "app",
    OSExt: "os",
    SessionExt: "ses",
    SDKExt: "sdk"
};
var CtxTagKeys = new ContextTagKeys();

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
function createDomEvent(eventName) {
    var event = null;
    if (isFunction$2(Event)) { // Use Event constructor when available
        event = new Event(eventName);
    }
    else { // Event has no constructor in IE
        var doc = getDocument$1();
        if (doc && doc.createEvent) {
            event = doc.createEvent("Event");
            event.initEvent(eventName, true, true);
        }
    }
    return event;
}

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
function _disableEvents(target, evtNamespace) {
    eventOff(target, null, null, evtNamespace);
}
/**
 * Create a new OfflineListener instance to monitor browser online / offline events
 * @param parentEvtNamespace - The parent event namespace to append to any specific events for this instance
 */
function createOfflineListener(parentEvtNamespace) {
    var _document = getDocument$1();
    var _navigator = getNavigator(); // Gets the window.navigator or workerNavigator depending on the global
    var _isListening = false;
    var listenerList = [];
    // Set the initial state
    // rState is changed by the browser, both via events and when we check the navigator.onLine property
    var rState = 1 /* eOfflineValue.Online */;
    if (_navigator && !isNullOrUndefined$1(_navigator.onLine) && !_navigator.onLine) { // navigator.onLine is undefined in react-native
        rState = 2 /* eOfflineValue.Offline */;
    }
    // ustate is changed by the user calling setOnlineState
    var uState = 0 /* eOfflineValue.Unknown */;
    // current state would be updated each time rState or uState is changed
    // it is a resolved value of rState and uState
    var _currentState = calCurrentState();
    var _evtNamespace = mergeEvtNamespace(createUniqueNamespace("OfflineListener"), parentEvtNamespace);
    try {
        if (_enableEvents(getWindow$1())) {
            _isListening = true;
        }
        if (_document) {
            // Also attach to the document.body or document
            var target = _document.body || _document;
            if (target.ononline) {
                if (_enableEvents(target)) {
                    _isListening = true;
                }
            }
        }
    }
    catch (e) {
        // this makes react-native less angry
        _isListening = false;
    }
    function _enableEvents(target) {
        var enabled = false;
        if (target) {
            enabled = eventOn(target, "online", _setOnline, _evtNamespace);
            if (enabled) {
                eventOn(target, "offline", _setOffline, _evtNamespace);
            }
        }
        return enabled;
    }
    function _isOnline() {
        return _currentState;
    }
    function calCurrentState() {
        if (uState === 2 /* eOfflineValue.Offline */ || rState === 2 /* eOfflineValue.Offline */) {
            return false;
        }
        return true; // if both unknown, then we assume the network is good
    }
    function listnerNoticeCheck() {
        // we were offline and are now online or we were online and now offline
        var newState = calCurrentState();
        if (_currentState !== newState) {
            _currentState = newState; // use the resolved state to update
            // send all the callbacks with the current state
            arrForEach$1(listenerList, function (callback) {
                var offlineState = {
                    isOnline: _currentState,
                    rState: rState,
                    uState: uState
                };
                try {
                    callback(offlineState);
                }
                catch (e) {
                    // Do nothing, just making sure we run all of the callbacks
                }
            });
        }
    }
    function setOnlineState(newState) {
        uState = newState;
        listnerNoticeCheck();
    }
    function _setOnline() {
        rState = 1 /* eOfflineValue.Online */;
        listnerNoticeCheck();
    }
    function _setOffline() {
        rState = 2 /* eOfflineValue.Offline */;
        listnerNoticeCheck();
    }
    function _unload() {
        var win = getWindow$1();
        if (win && _isListening) {
            _disableEvents(win, _evtNamespace);
            if (_document) {
                // Also attach to the document.body or document
                var target = _document.body || _document;
                if (!isUndefined$1(target.ononline)) {
                    _disableEvents(target, _evtNamespace);
                }
            }
            _isListening = false;
        }
    }
    function addListener(callback) {
        listenerList[_DYN_PUSH$1 /* @min:%2epush */](callback);
        // Define rm as an instance of IUnloadHook
        return {
            rm: function () {
                var index = listenerList.indexOf(callback);
                if (index > -1) {
                    return listenerList.splice(index, 1);
                }
                else {
                    return;
                }
            }
        };
    }
    return {
        isOnline: _isOnline,
        isListening: function () { return _isListening; },
        unload: _unload,
        addListener: addListener,
        setOnlineState: setOnlineState
    };
}

/*
 * Application Insights JavaScript SDK - Common, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var PropertiesPluginIdentifier = "AppInsightsPropertiesPlugin";
var BreezeChannelIdentifier = "AppInsightsChannelPlugin";
var AnalyticsPluginIdentifier = "ApplicationInsightsAnalytics";

/*
 * Application Insights JavaScript SDK - Web Analytics, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_TO_STRING$1 = "toString"; // Count: 4
var _DYN_IS_STORAGE_USE_DISAB0 = "isStorageUseDisabled"; // Count: 3
var _DYN__ADD_HOOK$1 = "_addHook"; // Count: 6
var _DYN_CORE$1 = "core"; // Count: 7
var _DYN_DATA_TYPE$1 = "dataType"; // Count: 8
var _DYN_ENVELOPE_TYPE$1 = "envelopeType"; // Count: 7
var _DYN_DIAG_LOG$1 = "diagLog"; // Count: 13
var _DYN_TRACK = "track"; // Count: 7
var _DYN_TRACK_PAGE_VIEW = "trackPageView"; // Count: 4
var _DYN_TRACK_PREVIOUS_PAGE_1 = "trackPreviousPageVisit"; // Count: 3
var _DYN_SEND_PAGE_VIEW_INTER2 = "sendPageViewInternal"; // Count: 7
var _DYN_START_TIME$1 = "startTime"; // Count: 6
var _DYN_PROPERTIES = "properties"; // Count: 3
var _DYN_DURATION = "duration"; // Count: 12
var _DYN_SEND_PAGE_VIEW_PERFO3 = "sendPageViewPerformanceInternal"; // Count: 3
var _DYN_POPULATE_PAGE_VIEW_P4 = "populatePageViewPerformanceEvent"; // Count: 3
var _DYN_HREF = "href"; // Count: 6
var _DYN_SEND_EXCEPTION_INTER5 = "sendExceptionInternal"; // Count: 2
var _DYN_EXCEPTION$1 = "exception"; // Count: 3
var _DYN_ERROR = "error"; // Count: 5
var _DYN__ONERROR = "_onerror"; // Count: 3
var _DYN_ERROR_SRC = "errorSrc"; // Count: 3
var _DYN_LINE_NUMBER = "lineNumber"; // Count: 5
var _DYN_COLUMN_NUMBER = "columnNumber"; // Count: 5
var _DYN_MESSAGE = "message"; // Count: 4
var _DYN__CREATE_AUTO_EXCEPTI6 = "CreateAutoException"; // Count: 3
var _DYN_ADD_TELEMETRY_INITIA7 = "addTelemetryInitializer"; // Count: 4
var _DYN_OVERRIDE_PAGE_VIEW_D8 = "overridePageViewDuration"; // Count: 2
var _DYN_AUTO_TRACK_PAGE_VISI9 = "autoTrackPageVisitTime"; // Count: 2
var _DYN_IS_BROWSER_LINK_TRAC10 = "isBrowserLinkTrackingEnabled"; // Count: 2
var _DYN_LENGTH$3 = "length"; // Count: 5
var _DYN_ENABLE_AUTO_ROUTE_TR11 = "enableAutoRouteTracking"; // Count: 2
var _DYN_ENABLE_UNHANDLED_PRO12 = "enableUnhandledPromiseRejectionTracking"; // Count: 2
var _DYN_AUTO_UNHANDLED_PROMI13 = "autoUnhandledPromiseInstrumented"; // Count: 3
var _DYN_GET_ENTRIES_BY_TYPE = "getEntriesByType"; // Count: 5
var _DYN_IS_PERFORMANCE_TIMIN14 = "isPerformanceTimingSupported"; // Count: 2
var _DYN_GET_PERFORMANCE_TIMI15 = "getPerformanceTiming"; // Count: 2
var _DYN_NAVIGATION_START = "navigationStart"; // Count: 4
var _DYN_SHOULD_COLLECT_DURAT16 = "shouldCollectDuration"; // Count: 3
var _DYN_IS_PERFORMANCE_TIMIN17 = "isPerformanceTimingDataReady"; // Count: 2
var _DYN_RESPONSE_START = "responseStart"; // Count: 5
var _DYN_REQUEST_START = "requestStart"; // Count: 3
var _DYN_LOAD_EVENT_END = "loadEventEnd"; // Count: 4
var _DYN_RESPONSE_END = "responseEnd"; // Count: 5
var _DYN_CONNECT_END = "connectEnd"; // Count: 4
var _DYN_PAGE_VISIT_START_TIM18 = "pageVisitStartTime"; // Count: 2

/*
 * Application Insights JavaScript SDK - Web Analytics, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * Class encapsulates sending page views and page view performance telemetry.
 */
var PageViewManager = /** @class */ (function () {
    function PageViewManager(appInsights, overridePageViewDuration, core, pageViewPerformanceManager) {
        dynamicProto(PageViewManager, this, function (_self) {
            var queueTimer = null;
            var itemQueue = [];
            var pageViewPerformanceSent = false;
            var firstPageViewSent = false;
            var _logger;
            if (core) {
                _logger = core.logger;
            }
            function _flushChannels(isAsync) {
                if (core) {
                    core.flush(isAsync, function () {
                        // Event flushed, callback added to prevent promise creation
                    });
                }
            }
            function _startTimer() {
                if (!queueTimer) {
                    queueTimer = scheduleTimeout$1((function () {
                        queueTimer = null;
                        var allItems = itemQueue.slice(0);
                        var doFlush = false;
                        itemQueue = [];
                        arrForEach$1(allItems, function (item) {
                            if (!item()) {
                                // Not processed so rescheduled
                                itemQueue.push(item);
                            }
                            else {
                                doFlush = true;
                            }
                        });
                        if (itemQueue[_DYN_LENGTH$3 /* @min:%2elength */] > 0) {
                            _startTimer();
                        }
                        if (doFlush) {
                            // We process at least one item so flush the queue
                            _flushChannels(true);
                        }
                    }), 100);
                }
            }
            function _addQueue(cb) {
                itemQueue.push(cb);
                _startTimer();
            }
            _self[_DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */] = function (pageView, customProperties) {
                var name = pageView.name;
                if (isNullOrUndefined$1(name) || typeof name !== "string") {
                    var doc = getDocument$1();
                    name = pageView.name = doc && doc.title || "";
                }
                var uri = pageView.uri;
                if (isNullOrUndefined$1(uri) || typeof uri !== "string") {
                    var location_1 = getLocation();
                    uri = pageView.uri = location_1 && location_1[_DYN_HREF /* @min:%2ehref */] || "";
                }
                if (!firstPageViewSent) {
                    var perf = getPerformance();
                    // Access the performance timing object
                    var navigationEntries = (perf && perf[_DYN_GET_ENTRIES_BY_TYPE /* @min:%2egetEntriesByType */] && perf[_DYN_GET_ENTRIES_BY_TYPE /* @min:%2egetEntriesByType */]("navigation"));
                    // Edge Case the navigation Entries may return an empty array and the timeOrigin is not supported on IE
                    if (navigationEntries && navigationEntries[0] && !isUndefined$1(perf.timeOrigin)) {
                        // Get the value of loadEventStart
                        var loadEventStart = navigationEntries[0].loadEventStart;
                        pageView[_DYN_START_TIME$1 /* @min:%2estartTime */] = new Date(perf.timeOrigin + loadEventStart);
                    }
                    else {
                        // calculate the start time manually
                        var duration_1 = ((customProperties || pageView[_DYN_PROPERTIES /* @min:%2eproperties */] || {})[_DYN_DURATION /* @min:%2eduration */] || 0);
                        pageView[_DYN_START_TIME$1 /* @min:%2estartTime */] = new Date(new Date().getTime() - duration_1);
                    }
                    firstPageViewSent = true;
                }
                // case 1a. if performance timing is not supported by the browser, send the page view telemetry with the duration provided by the user. If the user
                // do not provide the duration, set duration to undefined
                // Also this is case 4
                if (!pageViewPerformanceManager[_DYN_IS_PERFORMANCE_TIMIN14 /* @min:%2eisPerformanceTimingSupported */]()) {
                    appInsights[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageView, customProperties);
                    _flushChannels(true);
                    if (!isWebWorker()) {
                        // no navigation timing (IE 8, iOS Safari 8.4, Opera Mini 8 - see http://caniuse.com/#feat=nav-timing)
                        _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 25 /* _eInternalMessageId.NavigationTimingNotSupported */, "trackPageView: navigation timing API used for calculation of page duration is not supported in this browser. This page view will be collected without duration and timing info.");
                    }
                    return;
                }
                var pageViewSent = false;
                var customDuration;
                // if the performance timing is supported by the browser, calculate the custom duration
                var start = pageViewPerformanceManager[_DYN_GET_PERFORMANCE_TIMI15 /* @min:%2egetPerformanceTiming */]()[_DYN_NAVIGATION_START /* @min:%2enavigationStart */];
                if (start > 0) {
                    customDuration = dateTimeUtilsDuration(start, +new Date);
                    if (!pageViewPerformanceManager[_DYN_SHOULD_COLLECT_DURAT16 /* @min:%2eshouldCollectDuration */](customDuration)) {
                        customDuration = undefined;
                    }
                }
                // if the user has provided duration, send a page view telemetry with the provided duration. Otherwise, if
                // overridePageViewDuration is set to true, send a page view telemetry with the custom duration calculated earlier
                var duration;
                if (!isNullOrUndefined$1(customProperties) &&
                    !isNullOrUndefined$1(customProperties[_DYN_DURATION /* @min:%2eduration */])) {
                    duration = customProperties[_DYN_DURATION /* @min:%2eduration */];
                }
                if (overridePageViewDuration || !isNaN(duration)) {
                    if (isNaN(duration)) {
                        // case 3
                        if (!customProperties) {
                            customProperties = {};
                        }
                        customProperties[_DYN_DURATION /* @min:%2eduration */] = customDuration;
                    }
                    // case 2
                    appInsights[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageView, customProperties);
                    _flushChannels(true);
                    pageViewSent = true;
                }
                // now try to send the page view performance telemetry
                var maxDurationLimit = 60000;
                if (!customProperties) {
                    customProperties = {};
                }
                // Queue the event for processing
                _addQueue(function () {
                    var processed = false;
                    try {
                        if (pageViewPerformanceManager[_DYN_IS_PERFORMANCE_TIMIN17 /* @min:%2eisPerformanceTimingDataReady */]()) {
                            processed = true;
                            var pageViewPerformance = {
                                name: name,
                                uri: uri
                            };
                            pageViewPerformanceManager[_DYN_POPULATE_PAGE_VIEW_P4 /* @min:%2epopulatePageViewPerformanceEvent */](pageViewPerformance);
                            if (!pageViewPerformance.isValid && !pageViewSent) {
                                // If navigation timing gives invalid numbers, then go back to "override page view duration" mode.
                                // That's the best value we can get that makes sense.
                                customProperties[_DYN_DURATION /* @min:%2eduration */] = customDuration;
                                appInsights[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageView, customProperties);
                            }
                            else {
                                if (!pageViewSent) {
                                    customProperties[_DYN_DURATION /* @min:%2eduration */] = pageViewPerformance.durationMs;
                                    appInsights[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageView, customProperties);
                                }
                                if (!pageViewPerformanceSent) {
                                    appInsights[_DYN_SEND_PAGE_VIEW_PERFO3 /* @min:%2esendPageViewPerformanceInternal */](pageViewPerformance, customProperties);
                                    pageViewPerformanceSent = true;
                                }
                            }
                        }
                        else if (start > 0 && dateTimeUtilsDuration(start, +new Date) > maxDurationLimit) {
                            // if performance timings are not ready but we exceeded the maximum duration limit, just log a page view telemetry
                            // with the maximum duration limit. Otherwise, keep waiting until performance timings are ready
                            processed = true;
                            if (!pageViewSent) {
                                customProperties[_DYN_DURATION /* @min:%2eduration */] = maxDurationLimit;
                                appInsights[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageView, customProperties);
                            }
                        }
                    }
                    catch (e) {
                        _throwInternal(_logger, 1 /* eLoggingSeverity.CRITICAL */, 38 /* _eInternalMessageId.TrackPVFailedCalc */, "trackPageView failed on page load calculation: " + getExceptionName(e), { exception: dumpObj$2(e) });
                    }
                    return processed;
                });
            };
            _self.teardown = function (unloadCtx, unloadState) {
                if (queueTimer) {
                    queueTimer.cancel();
                    queueTimer = null;
                    var allItems = itemQueue.slice(0);
                    itemQueue = [];
                    arrForEach$1(allItems, function (item) {
                        if (item()) ;
                    });
                }
            };
        });
    }
// Removed Stub for PageViewManager.prototype.trackPageView.
// Removed Stub for PageViewManager.prototype.teardown.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PageViewManager.__ieDyn=1;

    return PageViewManager;
}());

/*
 * Application Insights JavaScript SDK - Web Analytics, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var MAX_DURATION_ALLOWED = 3600000; // 1h
var botAgentNames = ["googlebot", "adsbot-google", "apis-google", "mediapartners-google"];
function _isPerformanceTimingSupported() {
    var perf = getPerformance();
    return perf && !!perf.timing;
}
function _isPerformanceNavigationTimingSupported() {
    var perf = getPerformance();
    return perf && perf.getEntriesByType && perf.getEntriesByType("navigation")[_DYN_LENGTH$3 /* @min:%2elength */] > 0;
}
function _isPerformanceTimingDataReady() {
    var perf = getPerformance();
    var timing = perf ? perf.timing : 0;
    return timing
        && timing.domainLookupStart > 0
        && timing[_DYN_NAVIGATION_START /* @min:%2enavigationStart */] > 0
        && timing[_DYN_RESPONSE_START /* @min:%2eresponseStart */] > 0
        && timing[_DYN_REQUEST_START /* @min:%2erequestStart */] > 0
        && timing[_DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */] > 0
        && timing[_DYN_RESPONSE_END /* @min:%2eresponseEnd */] > 0
        && timing[_DYN_CONNECT_END /* @min:%2econnectEnd */] > 0
        && timing.domLoading > 0;
}
function _getPerformanceTiming() {
    if (_isPerformanceTimingSupported()) {
        return getPerformance().timing;
    }
    return null;
}
function _getPerformanceNavigationTiming() {
    if (_isPerformanceNavigationTimingSupported()) {
        return getPerformance()[_DYN_GET_ENTRIES_BY_TYPE /* @min:%2egetEntriesByType */]("navigation")[0];
    }
    return null;
}
/**
* This method tells if given durations should be excluded from collection.
*/
function _shouldCollectDuration() {
    var durations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        durations[_i] = arguments[_i];
    }
    var _navigator = getNavigator() || {};
    // a full list of Google crawlers user agent strings - https://support.google.com/webmasters/answer/1061943?hl=en
    var userAgent = _navigator.userAgent;
    var isGoogleBot = false;
    if (userAgent) {
        for (var i = 0; i < botAgentNames[_DYN_LENGTH$3 /* @min:%2elength */]; i++) {
            isGoogleBot = isGoogleBot || strIndexOf(userAgent.toLowerCase(), botAgentNames[i]) !== -1;
        }
    }
    if (isGoogleBot) {
        // Don't report durations for GoogleBot, it is returning invalid values in performance.timing API.
        return false;
    }
    else {
        // for other page views, don't report if it's outside of a reasonable range
        for (var i = 0; i < durations[_DYN_LENGTH$3 /* @min:%2elength */]; i++) {
            if (durations[i] < 0 || durations[i] >= MAX_DURATION_ALLOWED) {
                return false;
            }
        }
    }
    return true;
}
/**
 * Class encapsulates sending page view performance telemetry.
 */
var PageViewPerformanceManager = /** @class */ (function () {
    function PageViewPerformanceManager(core) {
        var _logger = safeGetLogger(core);
        dynamicProto(PageViewPerformanceManager, this, function (_self) {
            _self[_DYN_POPULATE_PAGE_VIEW_P4 /* @min:%2epopulatePageViewPerformanceEvent */] = function (pageViewPerformance) {
                pageViewPerformance.isValid = false;
                /*
                 * http://www.w3.org/TR/navigation-timing/#processing-model
                 *  |-navigationStart
                 *  |             |-connectEnd
                 *  |             ||-requestStart
                 *  |             ||             |-responseStart
                 *  |             ||             |              |-responseEnd
                 *  |             ||             |              |
                 *  |             ||             |              |         |-loadEventEnd
                 *  |---network---||---request---|---response---|---dom---|
                 *  |--------------------------total----------------------|
                 *
                 *  total = The difference between the load event of the current document is completed and the first recorded timestamp of the performance entry : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#duration
                 *  network = Redirect time + App Cache + DNS lookup time + TCP connection time
                 *  request = Request time : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#request_time
                 *  response = Response time
                 *  dom = Document load time : https://html.spec.whatwg.org/multipage/dom.html#document-load-timing-info
                 *      = Document processing time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#document_processing
                 *      + Loading time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#loading
                 */
                var navigationTiming = _getPerformanceNavigationTiming();
                var timing = _getPerformanceTiming();
                var total = 0;
                var network = 0;
                var request = 0;
                var response = 0;
                var dom = 0;
                if (navigationTiming || timing) {
                    if (navigationTiming) {
                        total = navigationTiming[_DYN_DURATION /* @min:%2eduration */];
                        /**
                         * support both cases:
                         * - startTime is always zero: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming
                         * - for older browsers where the startTime is not zero
                         */
                        network = navigationTiming[_DYN_START_TIME$1 /* @min:%2estartTime */] === 0 ? navigationTiming[_DYN_CONNECT_END /* @min:%2econnectEnd */] : dateTimeUtilsDuration(navigationTiming[_DYN_START_TIME$1 /* @min:%2estartTime */], navigationTiming[_DYN_CONNECT_END /* @min:%2econnectEnd */]);
                        request = dateTimeUtilsDuration(navigationTiming.requestStart, navigationTiming[_DYN_RESPONSE_START /* @min:%2eresponseStart */]);
                        response = dateTimeUtilsDuration(navigationTiming[_DYN_RESPONSE_START /* @min:%2eresponseStart */], navigationTiming[_DYN_RESPONSE_END /* @min:%2eresponseEnd */]);
                        dom = dateTimeUtilsDuration(navigationTiming.responseEnd, navigationTiming[_DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */]);
                    }
                    else {
                        total = dateTimeUtilsDuration(timing[_DYN_NAVIGATION_START /* @min:%2enavigationStart */], timing[_DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */]);
                        network = dateTimeUtilsDuration(timing[_DYN_NAVIGATION_START /* @min:%2enavigationStart */], timing[_DYN_CONNECT_END /* @min:%2econnectEnd */]);
                        request = dateTimeUtilsDuration(timing.requestStart, timing[_DYN_RESPONSE_START /* @min:%2eresponseStart */]);
                        response = dateTimeUtilsDuration(timing[_DYN_RESPONSE_START /* @min:%2eresponseStart */], timing[_DYN_RESPONSE_END /* @min:%2eresponseEnd */]);
                        dom = dateTimeUtilsDuration(timing.responseEnd, timing[_DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */]);
                    }
                    if (total === 0) {
                        _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 10 /* _eInternalMessageId.ErrorPVCalc */, "error calculating page view performance.", { total: total, network: network, request: request, response: response, dom: dom });
                    }
                    else if (!_self[_DYN_SHOULD_COLLECT_DURAT16 /* @min:%2eshouldCollectDuration */](total, network, request, response, dom)) {
                        _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 45 /* _eInternalMessageId.InvalidDurationValue */, "Invalid page load duration value. Browser perf data won't be sent.", { total: total, network: network, request: request, response: response, dom: dom });
                    }
                    else if (total < Math.floor(network) + Math.floor(request) + Math.floor(response) + Math.floor(dom)) {
                        // some browsers may report individual components incorrectly so that the sum of the parts will be bigger than total PLT
                        // in this case, don't report client performance from this page
                        _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 8 /* _eInternalMessageId.ClientPerformanceMathError */, "client performance math error.", { total: total, network: network, request: request, response: response, dom: dom });
                    }
                    else {
                        pageViewPerformance.durationMs = total;
                        // // convert to timespans
                        pageViewPerformance.perfTotal = pageViewPerformance[_DYN_DURATION /* @min:%2eduration */] = msToTimeSpan(total);
                        pageViewPerformance.networkConnect = msToTimeSpan(network);
                        pageViewPerformance.sentRequest = msToTimeSpan(request);
                        pageViewPerformance.receivedResponse = msToTimeSpan(response);
                        pageViewPerformance.domProcessing = msToTimeSpan(dom);
                        pageViewPerformance.isValid = true;
                    }
                }
            };
            _self[_DYN_GET_PERFORMANCE_TIMI15 /* @min:%2egetPerformanceTiming */] = _getPerformanceTiming;
            _self[_DYN_IS_PERFORMANCE_TIMIN14 /* @min:%2eisPerformanceTimingSupported */] = _isPerformanceTimingSupported;
            _self[_DYN_IS_PERFORMANCE_TIMIN17 /* @min:%2eisPerformanceTimingDataReady */] = _isPerformanceTimingDataReady;
            _self[_DYN_SHOULD_COLLECT_DURAT16 /* @min:%2eshouldCollectDuration */] = _shouldCollectDuration;
        });
    }
// Removed Stub for PageViewPerformanceManager.prototype.populatePageViewPerformanceEvent.
// Removed Stub for PageViewPerformanceManager.prototype.getPerformanceTiming.
// Removed Stub for PageViewPerformanceManager.prototype.isPerformanceTimingSupported.
// Removed Stub for PageViewPerformanceManager.prototype.isPerformanceTimingDataReady.
// Removed Stub for PageViewPerformanceManager.prototype.shouldCollectDuration.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PageViewPerformanceManager.__ieDyn=1;

    return PageViewPerformanceManager;
}());

/*
 * Application Insights JavaScript SDK - Web Analytics, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * Used to track page visit durations
 */
var PageVisitTimeManager = /** @class */ (function () {
    /**
     * Creates a new instance of PageVisitTimeManager
     * @param pageVisitTimeTrackingHandler - Delegate that will be called to send telemetry data to AI (when trackPreviousPageVisit is called)
     * @returns {}
     */
    function PageVisitTimeManager(logger, pageVisitTimeTrackingHandler) {
        var prevPageVisitDataKeyName = "prevPageVisitData";
        dynamicProto(PageVisitTimeManager, this, function (_self) {
            _self[_DYN_TRACK_PREVIOUS_PAGE_1 /* @min:%2etrackPreviousPageVisit */] = function (currentPageName, currentPageUrl) {
                try {
                    // Restart timer for new page view
                    var prevPageVisitTimeData = restartPageVisitTimer(currentPageName, currentPageUrl);
                    // If there was a page already being timed, track the visit time for it now.
                    if (prevPageVisitTimeData) {
                        pageVisitTimeTrackingHandler(prevPageVisitTimeData.pageName, prevPageVisitTimeData.pageUrl, prevPageVisitTimeData.pageVisitTime);
                    }
                }
                catch (e) {
                    _warnToConsole(logger, "Auto track page visit time failed, metric will not be collected: " + dumpObj$2(e));
                }
            };
            /**
             * Stops timing of current page (if exists) and starts timing for duration of visit to pageName
             * @param pageName - Name of page to begin timing visit duration
             * @returns {PageVisitData} Page visit data (including duration) of pageName from last call to start or restart, if exists. Null if not.
             */
            function restartPageVisitTimer(pageName, pageUrl) {
                var prevPageVisitData = null;
                try {
                    prevPageVisitData = stopPageVisitTimer();
                    if (utlCanUseSessionStorage()) {
                        if (utlGetSessionStorage(logger, prevPageVisitDataKeyName) != null) {
                            throwError("Cannot call startPageVisit consecutively without first calling stopPageVisit");
                        }
                        var currPageVisitDataStr = getJSON().stringify(new PageVisitData(pageName, pageUrl));
                        utlSetSessionStorage(logger, prevPageVisitDataKeyName, currPageVisitDataStr);
                    }
                }
                catch (e) {
                    _warnToConsole(logger, "Call to restart failed: " + dumpObj$2(e));
                    prevPageVisitData = null;
                }
                return prevPageVisitData;
            }
            /**
             * Stops timing of current page, if exists.
             * @returns {PageVisitData} Page visit data (including duration) of pageName from call to start, if exists. Null if not.
             */
            function stopPageVisitTimer() {
                var prevPageVisitData = null;
                try {
                    if (utlCanUseSessionStorage()) {
                        // Define end time of page's visit
                        var pageVisitEndTime = utcNow();
                        // Try to retrieve  page name and start time from session storage
                        var pageVisitDataJsonStr = utlGetSessionStorage(logger, prevPageVisitDataKeyName);
                        if (pageVisitDataJsonStr && hasJSON()) {
                            // if previous page data exists, set end time of visit
                            prevPageVisitData = getJSON().parse(pageVisitDataJsonStr);
                            prevPageVisitData.pageVisitTime = pageVisitEndTime - prevPageVisitData[_DYN_PAGE_VISIT_START_TIM18 /* @min:%2epageVisitStartTime */];
                            // Remove data from storage since we already used it
                            utlRemoveSessionStorage(logger, prevPageVisitDataKeyName);
                        }
                    }
                }
                catch (e) {
                    _warnToConsole(logger, "Stop page visit timer failed: " + dumpObj$2(e));
                    prevPageVisitData = null;
                }
                return prevPageVisitData;
            }
            // For backward compatibility
            objDefine$1(_self, "_logger", { g: function () { return logger; } });
            objDefine$1(_self, "pageVisitTimeTrackingHandler", { g: function () { return pageVisitTimeTrackingHandler; } });
        });
    }
// Removed Stub for PageVisitTimeManager.prototype.trackPreviousPageVisit.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PageVisitTimeManager.__ieDyn=1;

    return PageVisitTimeManager;
}());
var PageVisitData = /** @class */ (function () {
    function PageVisitData(pageName, pageUrl) {
        this[_DYN_PAGE_VISIT_START_TIM18 /* @min:%2epageVisitStartTime */] = utcNow();
        this.pageName = pageName;
        this.pageUrl = pageUrl;
    }
    return PageVisitData;
}());

/*
 * Application Insights JavaScript SDK - Web Analytics, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * Used to record timed events and page views.
 */
var Timing = /** @class */ (function () {
    function Timing(logger, name) {
        var _self = this;
        var _events = {};
        _self.start = function (name) {
            if (typeof _events[name] !== "undefined") {
                _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 62 /* _eInternalMessageId.StartCalledMoreThanOnce */, "start was called more than once for this event without calling stop.", { name: name, key: name }, true);
            }
            _events[name] = +new Date;
        };
        _self.stop = function (name, url, properties, measurements) {
            var start = _events[name];
            if (isNaN(start)) {
                _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 63 /* _eInternalMessageId.StopCalledWithoutStart */, "stop was called without a corresponding start.", { name: name, key: name }, true);
            }
            else {
                var end = +new Date;
                var duration = dateTimeUtilsDuration(start, end);
                _self.action(name, url, duration, properties, measurements);
            }
            delete _events[name];
            _events[name] = undefined;
        };
    }
    return Timing;
}());

/*
 * Application Insights JavaScript SDK - Web Analytics, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* ApplicationInsights.ts
* @copyright Microsoft 2018
*/
var _a$7;
var strEvent = "event";
function _dispatchEvent(target, evnt) {
    if (target && target.dispatchEvent && evnt) {
        target.dispatchEvent(evnt);
    }
}
function _getReason(error) {
    if (error && error.reason) {
        var reason = error.reason;
        if (!isString$2(reason) && isFunction$2(reason[_DYN_TO_STRING$1 /* @min:%2etoString */])) {
            return reason[_DYN_TO_STRING$1 /* @min:%2etoString */]();
        }
        return dumpObj$2(reason);
    }
    // Pass the original object down which will eventually get evaluated for any message or description
    return error || "";
}
var MinMilliSeconds = 60000;
var defaultValues = objDeepFreeze$1((_a$7 = {
        sessionRenewalMs: cfgDfSet(_chkConfigMilliseconds, 30 * 60 * 1000),
        sessionExpirationMs: cfgDfSet(_chkConfigMilliseconds, 24 * 60 * 60 * 1000),
        disableExceptionTracking: cfgDfBoolean()
    },
    _a$7[_DYN_AUTO_TRACK_PAGE_VISI9 /* @min:autoTrackPageVisitTime */] = cfgDfBoolean(),
    _a$7[_DYN_OVERRIDE_PAGE_VIEW_D8 /* @min:overridePageViewDuration */] = cfgDfBoolean(),
    _a$7[_DYN_ENABLE_UNHANDLED_PRO12 /* @min:enableUnhandledPromiseRejectionTracking */] = cfgDfBoolean(),
    _a$7[_DYN_AUTO_UNHANDLED_PROMI13 /* @min:autoUnhandledPromiseInstrumented */] = false,
    _a$7.samplingPercentage = cfgDfValidate(_chkSampling$1, 100),
    _a$7[_DYN_IS_STORAGE_USE_DISAB0 /* @min:isStorageUseDisabled */] = cfgDfBoolean(),
    _a$7[_DYN_IS_BROWSER_LINK_TRAC10 /* @min:isBrowserLinkTrackingEnabled */] = cfgDfBoolean(),
    _a$7[_DYN_ENABLE_AUTO_ROUTE_TR11 /* @min:enableAutoRouteTracking */] = cfgDfBoolean(),
    _a$7.namePrefix = cfgDfString(),
    _a$7.enableDebug = cfgDfBoolean(),
    _a$7.disableFlushOnBeforeUnload = cfgDfBoolean(),
    _a$7.disableFlushOnUnload = cfgDfBoolean(false, "disableFlushOnBeforeUnload"),
    _a$7));
function _chkConfigMilliseconds(value, defValue) {
    value = value || defValue;
    if (value < MinMilliSeconds) {
        value = MinMilliSeconds;
    }
    return +value;
}
function _chkSampling$1(value) {
    return !isNaN(value) && value > 0 && value <= 100;
}
function _updateStorageUsage(extConfig) {
    // Not resetting the storage usage as someone may have manually called utlDisableStorage, so this will only
    // reset based if the configuration option is provided
    if (!isUndefined$1(extConfig[_DYN_IS_STORAGE_USE_DISAB0 /* @min:%2eisStorageUseDisabled */])) {
        if (extConfig[_DYN_IS_STORAGE_USE_DISAB0 /* @min:%2eisStorageUseDisabled */]) {
            utlDisableStorage();
        }
        else {
            utlEnableStorage();
        }
    }
}
var AnalyticsPlugin = /** @class */ (function (_super) {
    __extendsFn(AnalyticsPlugin, _super);
    function AnalyticsPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = AnalyticsPluginIdentifier; // do not change name or priority
        _this.priority = 180; // take from reserved priority range 100- 200
        _this.autoRoutePVDelay = 500; // ms; Time to wait after a route change before triggering a pageview to allow DOM changes to take place
        var _eventTracking;
        var _pageTracking;
        var _pageViewManager;
        var _pageViewPerformanceManager;
        var _pageVisitTimeManager;
        var _preInitTelemetryInitializers;
        var _isBrowserLinkTrackingEnabled;
        var _browserLinkInitializerAdded;
        var _enableAutoRouteTracking;
        var _historyListenerAdded;
        var _disableExceptionTracking;
        var _autoExceptionInstrumented;
        var _enableUnhandledPromiseRejectionTracking;
        var _autoUnhandledPromiseInstrumented;
        var _extConfig;
        var _autoTrackPageVisitTime;
        // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
        var _prevUri; // Assigned in the constructor
        var _currUri;
        var _evtNamespace;
        dynamicProto(AnalyticsPlugin, _this, function (_self, _base) {
            var _addHook = _base[_DYN__ADD_HOOK$1 /* @min:%2e_addHook */];
            _initDefaults();
            _self.getCookieMgr = function () {
                return safeGetCookieMgr(_self[_DYN_CORE$1 /* @min:%2ecore */]);
            };
            _self.processTelemetry = function (env, itemCtx) {
                _self.processNext(env, itemCtx);
            };
            _self.trackEvent = function (event, customProperties) {
                try {
                    var telemetryItem = createTelemetryItem(event, Event$1[_DYN_DATA_TYPE$1 /* @min:%2edataType */], Event$1[_DYN_ENVELOPE_TYPE$1 /* @min:%2eenvelopeType */], _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), customProperties);
                    _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
                }
                catch (e) {
                    _throwInternal(2 /* eLoggingSeverity.WARNING */, 39 /* _eInternalMessageId.TrackTraceFailed */, "trackTrace failed, trace will not be collected: " + getExceptionName(e), { exception: dumpObj$2(e) });
                }
            };
            /**
             * Start timing an extended event. Call `stopTrackEvent` to log the event when it ends.
             * @param   name    A string that identifies this event uniquely within the document.
             */
            _self.startTrackEvent = function (name) {
                try {
                    _eventTracking.start(name);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 29 /* _eInternalMessageId.StartTrackEventFailed */, "startTrackEvent failed, event will not be collected: " + getExceptionName(e), { exception: dumpObj$2(e) });
                }
            };
            /**
             * Log an extended event that you started timing with `startTrackEvent`.
             * @param   name    The string you used to identify this event in `startTrackEvent`.
             * @param   properties  map[string, string] - additional data used to filter events and metrics in the portal. Defaults to empty.
             * @param   measurements    map[string, number] - metrics associated with this event, displayed in Metrics Explorer on the portal. Defaults to empty.
             */
            _self.stopTrackEvent = function (name, properties, measurements) {
                try {
                    _eventTracking.stop(name, undefined, properties, measurements);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 30 /* _eInternalMessageId.StopTrackEventFailed */, "stopTrackEvent failed, event will not be collected: " + getExceptionName(e), { exception: dumpObj$2(e) });
                }
            };
            /**
             * @description Log a diagnostic message
             * @param trace
             * @param ICustomProperties.
             * @memberof ApplicationInsights
             */
            _self.trackTrace = function (trace, customProperties) {
                try {
                    var telemetryItem = createTelemetryItem(trace, Trace[_DYN_DATA_TYPE$1 /* @min:%2edataType */], Trace[_DYN_ENVELOPE_TYPE$1 /* @min:%2eenvelopeType */], _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), customProperties);
                    _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
                }
                catch (e) {
                    _throwInternal(2 /* eLoggingSeverity.WARNING */, 39 /* _eInternalMessageId.TrackTraceFailed */, "trackTrace failed, trace will not be collected: " + getExceptionName(e), { exception: dumpObj$2(e) });
                }
            };
            /**
             * @description Log a numeric value that is not associated with a specific event. Typically
             * used to send regular reports of performance indicators. To send single measurement, just
             * use the name and average fields of {@link IMetricTelemetry}. If you take measurements
             * frequently, you can reduce the telemetry bandwidth by aggregating multiple measurements
             * and sending the resulting average at intervals
             * @param metric - input object argument. Only name and average are mandatory.
             * @param } customProperties additional data used to filter metrics in the
             * portal. Defaults to empty.
             * @memberof ApplicationInsights
             */
            _self.trackMetric = function (metric, customProperties) {
                try {
                    var telemetryItem = createTelemetryItem(metric, Metric[_DYN_DATA_TYPE$1 /* @min:%2edataType */], Metric[_DYN_ENVELOPE_TYPE$1 /* @min:%2eenvelopeType */], _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), customProperties);
                    _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 36 /* _eInternalMessageId.TrackMetricFailed */, "trackMetric failed, metric will not be collected: " + getExceptionName(e), { exception: dumpObj$2(e) });
                }
            };
            /**
             * Logs that a page or other item was viewed.
             * @param IPageViewTelemetry - The string you used as the name in startTrackPage. Defaults to the document title.
             * @param customProperties - Additional data used to filter events and metrics. Defaults to empty.
             * If a user wants to provide duration for pageLoad, it'll have to be in pageView.properties.duration
             */
            _self[_DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */] = function (pageView, customProperties) {
                try {
                    var inPv = pageView || {};
                    _pageViewManager[_DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */](inPv, __assignFn(__assignFn(__assignFn({}, inPv.properties), inPv.measurements), customProperties));
                    if (_autoTrackPageVisitTime) {
                        _pageVisitTimeManager[_DYN_TRACK_PREVIOUS_PAGE_1 /* @min:%2etrackPreviousPageVisit */](inPv.name, inPv.uri);
                    }
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 37 /* _eInternalMessageId.TrackPVFailed */, "trackPageView failed, page view will not be collected: " + getExceptionName(e), { exception: dumpObj$2(e) });
                }
            };
            /**
             * Create a page view telemetry item and send it to the SDK pipeline through the core.track API
             * @param pageView - Page view item to be sent
             * @param properties - Custom properties (Part C) that a user can add to the telemetry item
             * @param systemProperties - System level properties (Part A) that a user can add to the telemetry item
             */
            _self[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */] = function (pageView, properties, systemProperties) {
                var doc = getDocument$1();
                if (doc) {
                    pageView.refUri = pageView.refUri === undefined ? doc.referrer : pageView.refUri;
                }
                if (isNullOrUndefined$1(pageView[_DYN_START_TIME$1 /* @min:%2estartTime */])) {
                    // calculate the start time manually
                    var duration = ((properties || pageView[_DYN_PROPERTIES /* @min:%2eproperties */] || {})[_DYN_DURATION /* @min:%2eduration */] || 0);
                    pageView[_DYN_START_TIME$1 /* @min:%2estartTime */] = new Date(new Date().getTime() - duration);
                }
                var telemetryItem = createTelemetryItem(pageView, PageView[_DYN_DATA_TYPE$1 /* @min:%2edataType */], PageView[_DYN_ENVELOPE_TYPE$1 /* @min:%2eenvelopeType */], _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), properties, systemProperties);
                _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
            };
            /**
             * @ignore INTERNAL ONLY
             * @param pageViewPerformance
             * @param properties
             */
            _self[_DYN_SEND_PAGE_VIEW_PERFO3 /* @min:%2esendPageViewPerformanceInternal */] = function (pageViewPerformance, properties, systemProperties) {
                var telemetryItem = createTelemetryItem(pageViewPerformance, PageViewPerformance[_DYN_DATA_TYPE$1 /* @min:%2edataType */], PageViewPerformance[_DYN_ENVELOPE_TYPE$1 /* @min:%2eenvelopeType */], _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), properties, systemProperties);
                _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
            };
            /**
             * Send browser performance metrics.
             * @param pageViewPerformance
             * @param customProperties
             */
            _self.trackPageViewPerformance = function (pageViewPerformance, customProperties) {
                var inPvp = pageViewPerformance || {};
                try {
                    _pageViewPerformanceManager[_DYN_POPULATE_PAGE_VIEW_P4 /* @min:%2epopulatePageViewPerformanceEvent */](inPvp);
                    _self[_DYN_SEND_PAGE_VIEW_PERFO3 /* @min:%2esendPageViewPerformanceInternal */](inPvp, customProperties);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 37 /* _eInternalMessageId.TrackPVFailed */, "trackPageViewPerformance failed, page view will not be collected: " + getExceptionName(e), { exception: dumpObj$2(e) });
                }
            };
            /**
             * Starts the timer for tracking a page load time. Use this instead of `trackPageView` if you want to control when the page view timer starts and stops,
             * but don't want to calculate the duration yourself. This method doesn't send any telemetry. Call `stopTrackPage` to log the end of the page view
             * and send the event.
             * @param name - A string that idenfities this item, unique within this HTML document. Defaults to the document title.
             */
            _self.startTrackPage = function (name) {
                try {
                    if (typeof name !== "string") {
                        var doc = getDocument$1();
                        name = doc && doc.title || "";
                    }
                    _pageTracking.start(name);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 31 /* _eInternalMessageId.StartTrackFailed */, "startTrackPage failed, page view may not be collected: " + getExceptionName(e), { exception: dumpObj$2(e) });
                }
            };
            /**
             * Stops the timer that was started by calling `startTrackPage` and sends the pageview load time telemetry with the specified properties and measurements.
             * The duration of the page view will be the time between calling `startTrackPage` and `stopTrackPage`.
             * @param   name  The string you used as the name in startTrackPage. Defaults to the document title.
             * @param   url   String - a relative or absolute URL that identifies the page or other item. Defaults to the window location.
             * @param   properties  map[string, string] - additional data used to filter pages and metrics in the portal. Defaults to empty.
             * @param   measurements    map[string, number] - metrics associated with this page, displayed in Metrics Explorer on the portal. Defaults to empty.
             */
            _self.stopTrackPage = function (name, url, properties, measurement) {
                try {
                    if (typeof name !== "string") {
                        var doc = getDocument$1();
                        name = doc && doc.title || "";
                    }
                    if (typeof url !== "string") {
                        var loc = getLocation();
                        url = loc && loc[_DYN_HREF /* @min:%2ehref */] || "";
                    }
                    _pageTracking.stop(name, url, properties, measurement);
                    if (_autoTrackPageVisitTime) {
                        _pageVisitTimeManager[_DYN_TRACK_PREVIOUS_PAGE_1 /* @min:%2etrackPreviousPageVisit */](name, url);
                    }
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 32 /* _eInternalMessageId.StopTrackFailed */, "stopTrackPage failed, page view will not be collected: " + getExceptionName(e), { exception: dumpObj$2(e) });
                }
            };
            /**
            * @ignore INTERNAL ONLY
            * @param exception
            * @param properties
            * @param systemProperties
            */
            _self[_DYN_SEND_EXCEPTION_INTER5 /* @min:%2esendExceptionInternal */] = function (exception, customProperties, systemProperties) {
                // Adding additional edge cases to handle
                // - Not passing anything (null / undefined)
                var theError = (exception && (exception[_DYN_EXCEPTION$1 /* @min:%2eexception */] || exception[_DYN_ERROR /* @min:%2eerror */])) ||
                    // - Handle someone calling trackException based of v1 API where the exception was the Error
                    isError$2(exception) && exception ||
                    // - Handles no error being defined and instead of creating a new Error() instance attempt to map so any stacktrace
                    //   is preserved and does not list ApplicationInsights code as the source
                    { name: (exception && typeof exception), message: exception || strNotSpecified };
                // If no exception object was passed assign to an empty object to avoid internal exceptions
                exception = exception || {};
                var exceptionPartB = new Exception(_self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), theError, exception[_DYN_PROPERTIES /* @min:%2eproperties */] || customProperties, exception.measurements, exception.severityLevel, exception.id).toInterface();
                var telemetryItem = createTelemetryItem(exceptionPartB, Exception[_DYN_DATA_TYPE$1 /* @min:%2edataType */], Exception[_DYN_ENVELOPE_TYPE$1 /* @min:%2eenvelopeType */], _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), customProperties, systemProperties);
                _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
            };
            /**
             * Log an exception you have caught.
             *
             * @param exception -   Object which contains exception to be sent
             * @param } customProperties   Additional data used to filter pages and metrics in the portal. Defaults to empty.
             *
             * Any property of type double will be considered a measurement, and will be treated by Application Insights as a metric.
             * @memberof ApplicationInsights
             */
            _self.trackException = function (exception, customProperties) {
                if (exception && !exception[_DYN_EXCEPTION$1 /* @min:%2eexception */] && exception[_DYN_ERROR /* @min:%2eerror */]) {
                    exception[_DYN_EXCEPTION$1 /* @min:%2eexception */] = exception[_DYN_ERROR /* @min:%2eerror */];
                }
                try {
                    _self[_DYN_SEND_EXCEPTION_INTER5 /* @min:%2esendExceptionInternal */](exception, customProperties);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 35 /* _eInternalMessageId.TrackExceptionFailed */, "trackException failed, exception will not be collected: " + getExceptionName(e), { exception: dumpObj$2(e) });
                }
            };
            /**
             * @description Custom error handler for Application Insights Analytics
             * @param exception
             * @memberof ApplicationInsights
             */
            _self[_DYN__ONERROR /* @min:%2e_onerror */] = function (exception) {
                var error = exception && exception[_DYN_ERROR /* @min:%2eerror */];
                var evt = exception && exception.evt;
                try {
                    if (!evt) {
                        var _window = getWindow$1();
                        if (_window) {
                            evt = _window[strEvent];
                        }
                    }
                    var url = (exception && exception.url) || (getDocument$1() || {}).URL;
                    // If no error source is provided assume the default window.onerror handler
                    var errorSrc = exception[_DYN_ERROR_SRC /* @min:%2eerrorSrc */] || "window.onerror@" + url + ":" + (exception[_DYN_LINE_NUMBER /* @min:%2elineNumber */] || 0) + ":" + (exception[_DYN_COLUMN_NUMBER /* @min:%2ecolumnNumber */] || 0);
                    var properties = {
                        errorSrc: errorSrc,
                        url: url,
                        lineNumber: exception[_DYN_LINE_NUMBER /* @min:%2elineNumber */] || 0,
                        columnNumber: exception[_DYN_COLUMN_NUMBER /* @min:%2ecolumnNumber */] || 0,
                        message: exception[_DYN_MESSAGE /* @min:%2emessage */]
                    };
                    if (isCrossOriginError(exception.message, exception.url, exception.lineNumber, exception.columnNumber, exception[_DYN_ERROR /* @min:%2eerror */])) {
                        _sendCORSException(Exception[_DYN__CREATE_AUTO_EXCEPTI6 /* @min:%2eCreateAutoException */]("Script error: The browser's same-origin policy prevents us from getting the details of this exception. Consider using the 'crossorigin' attribute.", url, exception[_DYN_LINE_NUMBER /* @min:%2elineNumber */] || 0, exception[_DYN_COLUMN_NUMBER /* @min:%2ecolumnNumber */] || 0, error, evt, null, errorSrc), properties);
                    }
                    else {
                        if (!exception[_DYN_ERROR_SRC /* @min:%2eerrorSrc */]) {
                            exception[_DYN_ERROR_SRC /* @min:%2eerrorSrc */] = errorSrc;
                        }
                        _self.trackException({ exception: exception, severityLevel: 3 /* eSeverityLevel.Error */ }, properties);
                    }
                }
                catch (e) {
                    var errorString = error ? (error.name + ", " + error[_DYN_MESSAGE /* @min:%2emessage */]) : "null";
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 11 /* _eInternalMessageId.ExceptionWhileLoggingError */, "_onError threw exception while logging error, error will not be collected: "
                        + getExceptionName(e), { exception: dumpObj$2(e), errorString: errorString });
                }
            };
            _self[_DYN_ADD_TELEMETRY_INITIA7 /* @min:%2eaddTelemetryInitializer */] = function (telemetryInitializer) {
                if (_self[_DYN_CORE$1 /* @min:%2ecore */]) {
                    // Just add to the core
                    return _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_ADD_TELEMETRY_INITIA7 /* @min:%2eaddTelemetryInitializer */](telemetryInitializer);
                }
                // Handle "pre-initialization" telemetry initializers (for backward compatibility)
                if (!_preInitTelemetryInitializers) {
                    _preInitTelemetryInitializers = [];
                }
                _preInitTelemetryInitializers.push(telemetryInitializer);
            };
            _self.initialize = function (config, core, extensions, pluginChain) {
                if (_self.isInitialized()) {
                    return;
                }
                if (isNullOrUndefined$1(core)) {
                    throwError("Error initializing");
                }
                _base.initialize(config, core, extensions, pluginChain);
                try {
                    _evtNamespace = mergeEvtNamespace(createUniqueNamespace(_self.identifier), core.evtNamespace && core.evtNamespace());
                    if (_preInitTelemetryInitializers) {
                        arrForEach$1(_preInitTelemetryInitializers, function (initializer) {
                            core[_DYN_ADD_TELEMETRY_INITIA7 /* @min:%2eaddTelemetryInitializer */](initializer);
                        });
                        _preInitTelemetryInitializers = null;
                    }
                    _populateDefaults(config);
                    _pageViewPerformanceManager = new PageViewPerformanceManager(_self[_DYN_CORE$1 /* @min:%2ecore */]);
                    _pageViewManager = new PageViewManager(_self, _extConfig.overridePageViewDuration, _self[_DYN_CORE$1 /* @min:%2ecore */], _pageViewPerformanceManager);
                    _pageVisitTimeManager = new PageVisitTimeManager(_self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), function (pageName, pageUrl, pageVisitTime) { return trackPageVisitTime(pageName, pageUrl, pageVisitTime); });
                    _eventTracking = new Timing(_self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), "trackEvent");
                    _eventTracking.action =
                        function (name, url, duration, properties, measurements) {
                            if (!properties) {
                                properties = {};
                            }
                            if (!measurements) {
                                measurements = {};
                            }
                            properties.duration = duration[_DYN_TO_STRING$1 /* @min:%2etoString */]();
                            _self.trackEvent({ name: name, properties: properties, measurements: measurements });
                        };
                    // initialize page view timing
                    _pageTracking = new Timing(_self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), "trackPageView");
                    _pageTracking.action = function (name, url, duration, properties, measurements) {
                        // duration must be a custom property in order for the collector to extract it
                        if (isNullOrUndefined$1(properties)) {
                            properties = {};
                        }
                        properties.duration = duration[_DYN_TO_STRING$1 /* @min:%2etoString */]();
                        var pageViewItem = {
                            name: name,
                            uri: url,
                            properties: properties,
                            measurements: measurements
                        };
                        _self[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageViewItem, properties);
                    };
                    if (hasWindow()) {
                        _updateExceptionTracking();
                        _updateLocationChange();
                    }
                }
                catch (e) {
                    // resetting the initialized state because of failure
                    _self.setInitialized(false);
                    throw e;
                }
            };
            _self._doTeardown = function (unloadCtx, unloadState) {
                _pageViewManager && _pageViewManager.teardown(unloadCtx, unloadState);
                // Just register to remove all events associated with this namespace
                eventOff(window, null, null, _evtNamespace);
                _initDefaults();
            };
            function _populateDefaults(config) {
                var identifier = _self.identifier;
                var core = _self[_DYN_CORE$1 /* @min:%2ecore */];
                _self[_DYN__ADD_HOOK$1 /* @min:%2e_addHook */](onConfigChange(config, function () {
                    var ctx = createProcessTelemetryContext(null, config, core);
                    _extConfig = ctx.getExtCfg(identifier, defaultValues);
                    _autoTrackPageVisitTime = _extConfig[_DYN_AUTO_TRACK_PAGE_VISI9 /* @min:%2eautoTrackPageVisitTime */];
                    if (config.storagePrefix) {
                        utlSetStoragePrefix(config.storagePrefix);
                    }
                    _updateStorageUsage(_extConfig);
                    // _updateBrowserLinkTracking
                    _isBrowserLinkTrackingEnabled = _extConfig[_DYN_IS_BROWSER_LINK_TRAC10 /* @min:%2eisBrowserLinkTrackingEnabled */];
                    _addDefaultTelemetryInitializers();
                }));
            }
            /**
             * Log a page visit time
             * @param    pageName    Name of page
             * @param    pageVisitDuration Duration of visit to the page in milliseconds
             */
            function trackPageVisitTime(pageName, pageUrl, pageVisitTime) {
                var properties = { PageName: pageName, PageUrl: pageUrl };
                _self.trackMetric({
                    name: "PageVisitTime",
                    average: pageVisitTime,
                    max: pageVisitTime,
                    min: pageVisitTime,
                    sampleCount: 1
                }, properties);
            }
            function _addDefaultTelemetryInitializers() {
                if (!_browserLinkInitializerAdded && _isBrowserLinkTrackingEnabled) {
                    var browserLinkPaths_1 = ["/browserLinkSignalR/", "/__browserLink/"];
                    var dropBrowserLinkRequests = function (envelope) {
                        if (_isBrowserLinkTrackingEnabled && envelope.baseType === RemoteDependencyData[_DYN_DATA_TYPE$1 /* @min:%2edataType */]) {
                            var remoteData = envelope.baseData;
                            if (remoteData) {
                                for (var i = 0; i < browserLinkPaths_1[_DYN_LENGTH$3 /* @min:%2elength */]; i++) {
                                    if (remoteData.target && strIndexOf(remoteData.target, browserLinkPaths_1[i]) >= 0) {
                                        return false;
                                    }
                                }
                            }
                        }
                        return true;
                    };
                    _self[_DYN__ADD_HOOK$1 /* @min:%2e_addHook */](_self[_DYN_ADD_TELEMETRY_INITIA7 /* @min:%2eaddTelemetryInitializer */](dropBrowserLinkRequests));
                    _browserLinkInitializerAdded = true;
                }
            }
            function _sendCORSException(exception, properties) {
                var telemetryItem = createTelemetryItem(exception, Exception[_DYN_DATA_TYPE$1 /* @min:%2edataType */], Exception[_DYN_ENVELOPE_TYPE$1 /* @min:%2eenvelopeType */], _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), properties);
                _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
            }
            function _updateExceptionTracking() {
                var _window = getWindow$1();
                var locn = getLocation(true);
                _self[_DYN__ADD_HOOK$1 /* @min:%2e_addHook */](onConfigChange(_extConfig, function () {
                    _disableExceptionTracking = _extConfig.disableExceptionTracking;
                    if (!_disableExceptionTracking && !_autoExceptionInstrumented && !_extConfig.autoExceptionInstrumented) {
                        // We want to enable exception auto collection and it has not been done so yet
                        _addHook(InstrumentEvent(_window, "onerror", {
                            ns: _evtNamespace,
                            rsp: function (callDetails, message, url, lineNumber, columnNumber, error) {
                                if (!_disableExceptionTracking && callDetails.rslt !== true) {
                                    _self[_DYN__ONERROR /* @min:%2e_onerror */](Exception[_DYN__CREATE_AUTO_EXCEPTI6 /* @min:%2eCreateAutoException */](message, url, lineNumber, columnNumber, error, callDetails.evt));
                                }
                            }
                        }, false));
                        _autoExceptionInstrumented = true;
                    }
                }));
                _addUnhandledPromiseRejectionTracking(_window, locn);
            }
            function _updateLocationChange() {
                var win = getWindow$1();
                var locn = getLocation(true);
                _self[_DYN__ADD_HOOK$1 /* @min:%2e_addHook */](onConfigChange(_extConfig, function () {
                    _enableAutoRouteTracking = _extConfig[_DYN_ENABLE_AUTO_ROUTE_TR11 /* @min:%2eenableAutoRouteTracking */] === true;
                    /**
                     * Create a custom "locationchange" event which is triggered each time the history object is changed
                     */
                    if (win && _enableAutoRouteTracking && !_historyListenerAdded && hasHistory()) {
                        var _history = getHistory();
                        if (isFunction$2(_history.pushState) && isFunction$2(_history.replaceState) && typeof Event !== strShimUndefined) {
                            _addHistoryListener(win, _history, locn);
                        }
                    }
                }));
            }
            function _getDistributedTraceCtx() {
                var distributedTraceCtx = null;
                if (_self[_DYN_CORE$1 /* @min:%2ecore */] && _self[_DYN_CORE$1 /* @min:%2ecore */].getTraceCtx) {
                    distributedTraceCtx = _self[_DYN_CORE$1 /* @min:%2ecore */].getTraceCtx(false);
                }
                if (!distributedTraceCtx) {
                    // Fallback when using an older Core and PropertiesPlugin
                    var properties = _self[_DYN_CORE$1 /* @min:%2ecore */].getPlugin(PropertiesPluginIdentifier);
                    if (properties) {
                        var context = properties.plugin.context;
                        if (context) {
                            distributedTraceCtx = createDistributedTraceContextFromTrace(context.telemetryTrace);
                        }
                    }
                }
                return distributedTraceCtx;
            }
            /**
             * Create a custom "locationchange" event which is triggered each time the history object is changed
             */
            function _addHistoryListener(win, history, locn) {
                if (_historyListenerAdded) {
                    return;
                }
                // Name Prefix is only referenced during the initial initialization and cannot be changed afterwards
                var namePrefix = _extConfig.namePrefix || "";
                function _popstateHandler() {
                    if (_enableAutoRouteTracking) {
                        _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
                    }
                }
                function _locationChangeHandler() {
                    // We always track the changes (if the handler is installed) to handle the feature being disabled between location changes
                    if (_currUri) {
                        _prevUri = _currUri;
                        _currUri = locn && locn[_DYN_HREF /* @min:%2ehref */] || "";
                    }
                    else {
                        _currUri = locn && locn[_DYN_HREF /* @min:%2ehref */] || "";
                    }
                    if (_enableAutoRouteTracking) {
                        var distributedTraceCtx = _getDistributedTraceCtx();
                        if (distributedTraceCtx) {
                            distributedTraceCtx.setTraceId(generateW3CId());
                            var traceLocationName = "_unknown_";
                            if (locn && locn.pathname) {
                                traceLocationName = locn.pathname + (locn.hash || "");
                            }
                            // This populates the ai.operation.name which has a maximum size of 1024 so we need to sanitize it
                            distributedTraceCtx.setName(dataSanitizeString(_self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), traceLocationName));
                        }
                        scheduleTimeout$1((function (uri) {
                            // todo: override start time so that it is not affected by autoRoutePVDelay
                            _self[_DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */]({ refUri: uri, properties: { duration: 0 } }); // SPA route change loading durations are undefined, so send 0
                        }).bind(_self, _prevUri), _self.autoRoutePVDelay);
                    }
                }
                _addHook(InstrumentEvent(history, "pushState", {
                    ns: _evtNamespace,
                    rsp: function () {
                        if (_enableAutoRouteTracking) {
                            _dispatchEvent(win, createDomEvent(namePrefix + "pushState"));
                            _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
                        }
                    }
                }, true));
                _addHook(InstrumentEvent(history, "replaceState", {
                    ns: _evtNamespace,
                    rsp: function () {
                        if (_enableAutoRouteTracking) {
                            _dispatchEvent(win, createDomEvent(namePrefix + "replaceState"));
                            _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
                        }
                    }
                }, true));
                eventOn(win, namePrefix + "popstate", _popstateHandler, _evtNamespace);
                eventOn(win, namePrefix + "locationchange", _locationChangeHandler, _evtNamespace);
                _historyListenerAdded = true;
            }
            function _addUnhandledPromiseRejectionTracking(_window, _location) {
                _self[_DYN__ADD_HOOK$1 /* @min:%2e_addHook */](onConfigChange(_extConfig, function () {
                    _enableUnhandledPromiseRejectionTracking = _extConfig[_DYN_ENABLE_UNHANDLED_PRO12 /* @min:%2eenableUnhandledPromiseRejectionTracking */] === true;
                    _autoExceptionInstrumented = _autoExceptionInstrumented || _extConfig[_DYN_AUTO_UNHANDLED_PROMI13 /* @min:%2eautoUnhandledPromiseInstrumented */];
                    if (_enableUnhandledPromiseRejectionTracking && !_autoUnhandledPromiseInstrumented) {
                        // We want to enable exception auto collection and it has not been done so yet
                        _addHook(InstrumentEvent(_window, "onunhandledrejection", {
                            ns: _evtNamespace,
                            rsp: function (callDetails, error) {
                                if (_enableUnhandledPromiseRejectionTracking && callDetails.rslt !== true) { // handled could be typeof function
                                    _self[_DYN__ONERROR /* @min:%2e_onerror */](Exception[_DYN__CREATE_AUTO_EXCEPTI6 /* @min:%2eCreateAutoException */](_getReason(error), _location ? _location[_DYN_HREF /* @min:%2ehref */] : "", 0, 0, error, callDetails.evt));
                                }
                            }
                        }, false));
                        _extConfig[_DYN_AUTO_UNHANDLED_PROMI13 /* @min:%2eautoUnhandledPromiseInstrumented */] = _autoUnhandledPromiseInstrumented = true;
                    }
                }));
            }
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity - {eLoggingSeverity} - The severity of the log message
             * @param msgId - {_eInternalLogMessage} - The log message.
             */
            function _throwInternal(severity, msgId, msg, properties, isUserAct) {
                _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */]().throwInternal(severity, msgId, msg, properties, isUserAct);
            }
            function _initDefaults() {
                _eventTracking = null;
                _pageTracking = null;
                _pageViewManager = null;
                _pageViewPerformanceManager = null;
                _pageVisitTimeManager = null;
                _preInitTelemetryInitializers = null;
                _isBrowserLinkTrackingEnabled = false;
                _browserLinkInitializerAdded = false;
                _enableAutoRouteTracking = false;
                _historyListenerAdded = false;
                _disableExceptionTracking = false;
                _autoExceptionInstrumented = false;
                _enableUnhandledPromiseRejectionTracking = false;
                _autoUnhandledPromiseInstrumented = false;
                _autoTrackPageVisitTime = false;
                // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
                var location = getLocation(true);
                _prevUri = location && location[_DYN_HREF /* @min:%2ehref */] || "";
                _currUri = null;
                _evtNamespace = null;
                _extConfig = null;
                // Define _self.config
                objDefine$1(_self, "config", {
                    g: function () { return _extConfig; }
                });
            }
            // For backward compatibility
            objDefine$1(_self, "_pageViewManager", { g: function () { return _pageViewManager; } });
            objDefine$1(_self, "_pageViewPerformanceManager", { g: function () { return _pageViewPerformanceManager; } });
            objDefine$1(_self, "_pageVisitTimeManager", { g: function () { return _pageVisitTimeManager; } });
            objDefine$1(_self, "_evtNamespace", { g: function () { return "." + _evtNamespace; } });
        });
        return _this;
    }
// Removed Stub for AnalyticsPlugin.prototype.getCookieMgr.
// Removed Stub for AnalyticsPlugin.prototype.processTelemetry.
// Removed Stub for AnalyticsPlugin.prototype.trackEvent.
// Removed Stub for AnalyticsPlugin.prototype.startTrackEvent.
// Removed Stub for AnalyticsPlugin.prototype.stopTrackEvent.
// Removed Stub for AnalyticsPlugin.prototype.trackTrace.
// Removed Stub for AnalyticsPlugin.prototype.trackMetric.
// Removed Stub for AnalyticsPlugin.prototype.trackPageView.
// Removed Stub for AnalyticsPlugin.prototype.sendPageViewInternal.
// Removed Stub for AnalyticsPlugin.prototype.sendPageViewPerformanceInternal.
// Removed Stub for AnalyticsPlugin.prototype.trackPageViewPerformance.
// Removed Stub for AnalyticsPlugin.prototype.startTrackPage.
// Removed Stub for AnalyticsPlugin.prototype.stopTrackPage.
// Removed Stub for AnalyticsPlugin.prototype.sendExceptionInternal.
// Removed Stub for AnalyticsPlugin.prototype.trackException.
// Removed Stub for AnalyticsPlugin.prototype._onerror.
// Removed Stub for AnalyticsPlugin.prototype.addTelemetryInitializer.
// Removed Stub for AnalyticsPlugin.prototype.initialize.
    AnalyticsPlugin.Version = '3.1.2'; // Not currently used anywhere
    return AnalyticsPlugin;
}(BaseTelemetryPlugin));

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_FEATURE_OPT_IN = "featureOptIn"; // Count: 4
var _DYN_ON_CFG_CHANGE_RECEIV0 = "onCfgChangeReceive"; // Count: 2
var _DYN_NON_OVERRIDE_CONFIGS = "nonOverrideConfigs"; // Count: 2
var _DYN_SCHEDULE_FETCH_TIMEO1 = "scheduleFetchTimeout"; // Count: 2

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * Delete a config key in the given cfg, if the config key exists in nonOverrideConfigs and its value is set to true
 * @param cfg cfg to modify
 * @param nonOverrideConfigs nonOverrideConfigs
 * @param curLevel cur config level, starting at 0
 * @param maxLevel max config level
 * @returns new copy of modified configs
 */
function replaceByNonOverrideCfg(cfg, nonOverrideConfigs, curLevel, maxLevel) {
    try {
        var exceedMaxLevel = curLevel > maxLevel;
        if (exceedMaxLevel) {
            cfg = null;
        }
        var curCfg_1 = curLevel == 0 ? objExtend$1({}, cfg) : cfg; // only copy cfg at the begining level
        if (curCfg_1 && nonOverrideConfigs && !exceedMaxLevel) {
            objForEachKey$1(curCfg_1, function (key) {
                var nonOverrideVal = nonOverrideConfigs[key];
                if (!!nonOverrideVal) {
                    if (isObject$2(curCfg_1[key]) && isObject$2(nonOverrideVal)) {
                        curCfg_1[key] = replaceByNonOverrideCfg(curCfg_1[key], nonOverrideVal, ++curLevel, maxLevel);
                    }
                    else {
                        delete curCfg_1[key];
                    }
                }
            });
        }
        return curCfg_1;
    }
    catch (e) {
        // eslint-disable-next-line no-empty
    }
    // if errors happen, do nothing
    return cfg;
}
//                                                     CDN Mode, value = B (CDN value = B)
//                                |--------------------------------------------------------------------------|-----------|
//                                |                    | none        | disabled    | enabled     | forceOn   | forceOff  |
//                                | ------------------ | ----------- | ----------- | ----------- | --------- | --------- |
// | User Mode, value = A         | none               | none        | disabled    | enabled     | enabled   | disabled  |
// (user Value = A)               | disabled           | disabled    | disabled    | disabled    | enabled   | disabled  |
//                                | enabled            | enabled     | disabled    | enabled     | enabled   | disabled  |
//                                | none(blockCdn)     | none        | none        | none        | none      | none      |
//                                | disabled(blockCdn) | disabled    | disabled    | disabled    | disabled  | disabled  |
//                                | enabled(blockCdn)  | enabled     | enabled     | enabled     | enabled   | enabled   |
// This matrix identifies how feature based overrides are selected (if present)
//                                cdn Mode (cdn Value = B)
//                   |---------------------------------------------------------------------------|
//                   |                    | none     | disabled | enabled  | forceOn  | forceOff |
//                   | ------------------ | ---------| ---------| ---------| ---------|----------|
// | User Mode       | none               | A        | A        | A || B   | B || A   | B || A   |
// (user Value = A)  | disabled           | A        | A        | A        | B || A   | B || A   |
//                   | enabled            | A        | A        | A || B   | B || A   | B || A   |
//                   | none(blockCdn)     | A        | A        | A        | A        | A        |
//                   | disabled(blockCdn) | A        | A        | A        | A        | A        |
//                   | enabled(blockCdn)  | A        | A        | A        | A        | A        |
// Note:
// Where the "value" is an object (map) of encoded key/values which will be used to override the real configuration
// A = either the user supplied enable/disable value (via the `config.featureOptIn[name]`) or if not defined by the user the SDK defaults of the same.
// B = The enable/disable value obtained from the CDN for the named feature
// These are evaluated based on the above matrix to either
// - A (Always the user/sdk value)
// - B (Always the value from the CDN)
// - A || B (If A is null or undefined use the value from the CDN (B) otherwise A)
// - B || A (If B is null or undefined use the user/SDK value otherwise use the value from the CDN)
//
// The result of the value may also be null / undefined, which means there are no overrides to apply when the feature is enabled
var F = "featureOptIn.";
var M = ".mode";
var ON = ".onCfg";
var OFF = ".offCfg";
function resolveCdnFeatureCfg(field, cdnCfg, userOptInDetails) {
    var _a;
    // cdn conifg value
    if (!cdnCfg || !cdnCfg.enabled) {
        return null;
    }
    var cdnFt = (cdnCfg[_DYN_FEATURE_OPT_IN /* @min:%2efeatureOptIn */] || {})[field] || { mode: 1 /* CdnFeatureMode.none */ };
    var cdnM = cdnFt.mode;
    var cdnOnV = cdnFt.onCfg;
    var cdnOffV = cdnFt.offCfg;
    var userFt = (userOptInDetails || {})[field] || { mode: 2 /* FeatureOptInMode.disable */ }; // default user mode is disable
    var userM = userFt.mode;
    var userOnV = userFt.onCfg;
    var userOffV = userFt.offCfg;
    var blockCdn = !!userFt.blockCdnCfg;
    var mFld = F + field + M;
    var onFld = F + field + ON;
    var offFld = F + field + OFF;
    var mode = userM;
    var onV = userOnV;
    var offV = userOffV;
    if (!blockCdn) {
        if (cdnM === 4 /* CdnFeatureMode.forceOn */ || cdnM === 5 /* CdnFeatureMode.forceOff */) {
            mode = (cdnM == 4 /* CdnFeatureMode.forceOn */ ? 3 /* FeatureOptInMode.enable */ : 2 /* FeatureOptInMode.disable */);
            onV = cdnOnV || userOnV;
            offV = cdnOffV || userOffV;
        }
        else if (cdnM === 2 /* CdnFeatureMode.disable */ || userM === 2 /* FeatureOptInMode.disable */) {
            mode = 2 /* FeatureOptInMode.disable */;
            onV = userOnV || cdnOnV;
            offV = userOffV || cdnOffV;
        }
        else if (cdnM === 3 /* CdnFeatureMode.enable */) {
            mode = 3 /* FeatureOptInMode.enable */;
            onV = userOnV || cdnOnV;
            offV = userOffV || cdnOffV;
        }
        else if (cdnM === 1 /* CdnFeatureMode.none */ && userM === 1 /* FeatureOptInMode.none */) {
            mode = 1 /* FeatureOptInMode.none */;
        }
    }
    return _a = {},
        _a[mFld] = mode,
        _a[onFld] = onV,
        _a[offFld] = offV,
        _a;
}
// helper function to get cdn config with opt-in features
function applyCdnfeatureCfg(cdnCfg, core) {
    try {
        if (!cdnCfg || !cdnCfg.enabled) {
            return null;
        }
        if (!cdnCfg[_DYN_FEATURE_OPT_IN /* @min:%2efeatureOptIn */]) {
            return cdnCfg.config;
        }
        var optInMap = cdnCfg[_DYN_FEATURE_OPT_IN /* @min:%2efeatureOptIn */];
        var cdnConfig_1 = cdnCfg.config || {};
        objForEachKey$1(optInMap, function (key) {
            var featureVal = resolveCdnFeatureCfg(key, cdnCfg, core.config[_DYN_FEATURE_OPT_IN /* @min:%2efeatureOptIn */]);
            if (!isNullOrUndefined$1(featureVal)) {
                objForEachKey$1(featureVal, function (config, val) {
                    setValueByKey(cdnConfig_1, config, val);
                });
                _overrideCdnCfgByFeature(key, featureVal, cdnConfig_1);
            }
        });
        return cdnConfig_1;
    }
    catch (e) {
        // eslint-disable-next-line no-empty
    }
    return null;
}
function _overrideCdnCfgByFeature(field, ftVal, config) {
    var mode = ftVal[F + field + M];
    var val = ftVal[F + field + ON];
    var dVal = ftVal[F + field + OFF];
    var target = null;
    if (mode === 3 /* FeatureOptInMode.enable */) {
        target = val;
    }
    if (mode === 2 /* FeatureOptInMode.disable */) {
        target = dVal;
    }
    if (target) {
        objForEachKey$1(target, function (key, cfg) {
            setValueByKey(config, key, cfg);
        });
    }
}

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* CfgSyncPlugin.ts
* @copyright Microsoft 2018
*/
var _a$6;
var EVENT_NAME = "ai_cfgsync";
var STR_GET_METHOD = "GET";
var FETCH_TIMEOUT = 1800000; // 30 minutes
var udfVal = undefined;
var defaultNonOverrideCfg = { instrumentationKey: true, connectionString: true, endpointUrl: true };
var _defaultConfig$2 = objDeepFreeze$1((_a$6 = {
        syncMode: 1 /* ICfgSyncMode.Broadcast */,
        blkCdnCfg: udfVal,
        customEvtName: udfVal,
        cfgUrl: udfVal,
        overrideSyncFn: udfVal,
        overrideFetchFn: udfVal
    },
    _a$6[_DYN_ON_CFG_CHANGE_RECEIV0 /* @min:onCfgChangeReceive */] = udfVal,
    _a$6[_DYN_SCHEDULE_FETCH_TIMEO1 /* @min:scheduleFetchTimeout */] = FETCH_TIMEOUT,
    _a$6[_DYN_NON_OVERRIDE_CONFIGS /* @min:nonOverrideConfigs */] = defaultNonOverrideCfg,
    _a$6));
var CfgSyncPlugin = /** @class */ (function (_super) {
    __extendsFn(CfgSyncPlugin, _super);
    function CfgSyncPlugin() {
        var _this = _super.call(this) || this;
        _this.priority = 198;
        _this.identifier = "AppInsightsCfgSyncPlugin";
        var _extensionConfig;
        var _mainConfig; // throttle config should be wrapped in IConfiguration
        var _evtName;
        var _evtNamespace;
        var _cfgUrl;
        var _timeoutHandle;
        var _receiveChanges;
        var _broadcastChanges;
        var _blkCdnCfg;
        var _fetchTimeout;
        var _retryCnt;
        var _onCfgChangeReceive;
        var _nonOverrideConfigs;
        var _fetchFn;
        var _overrideFetchFn;
        var _overrideSyncFn;
        var _paused = false;
        dynamicProto(CfgSyncPlugin, _this, function (_self, _base) {
            _initDefaults();
            _self.initialize = function (config, core, extensions, pluginChain) {
                _base.initialize(config, core, extensions, pluginChain);
                _evtNamespace = mergeEvtNamespace(createUniqueNamespace(_self.identifier), core.evtNamespace && core.evtNamespace());
                _populateDefaults(config);
            };
            _self.getCfg = function () {
                return _mainConfig;
            };
            _self.pause = function () {
                _paused = true;
                _clearScheduledTimer();
            };
            _self.resume = function () {
                _paused = false;
                _setupTimer();
            };
            // used for V2 to manaully trigger config udpate
            _self.setCfg = function (config) {
                return _setCfg(config);
            };
            _self.sync = function (customDetails) {
                return _sendCfgsyncEvents(customDetails);
            };
            _self.updateEventListenerName = function (eventName) {
                return _updateEventListenerName(eventName);
            };
            _self._doTeardown = function (unloadCtx, unloadState) {
                _eventOff();
                _clearScheduledTimer();
                _initDefaults();
            };
            _self["_getDbgPlgTargets"] = function () {
                return [_broadcastChanges, _receiveChanges, _evtName, _blkCdnCfg];
            };
            function _initDefaults() {
                _mainConfig = null;
                _evtName = null;
                _evtNamespace = null;
                _cfgUrl = null;
                _receiveChanges = null;
                _broadcastChanges = null;
                _nonOverrideConfigs = null;
                _timeoutHandle = null;
                _fetchTimeout = null;
                _retryCnt = null;
                _blkCdnCfg = null;
                _overrideFetchFn = null;
                _overrideSyncFn = null;
                _onCfgChangeReceive = null;
            }
            function _populateDefaults(config) {
                var identifier = _self.identifier;
                var core = _self.core;
                _self._addHook(onConfigChange(config, function () {
                    var ctx = createProcessTelemetryContext(null, config, core);
                    _extensionConfig = ctx.getExtCfg(identifier, _defaultConfig$2);
                    var preBlkCdn = _blkCdnCfg;
                    _blkCdnCfg = !!_extensionConfig.blkCdnCfg;
                    // avoid initial call
                    if (!isNullOrUndefined$1(preBlkCdn) && preBlkCdn !== _blkCdnCfg) {
                        if (!_blkCdnCfg && _cfgUrl) {
                            _fetchFn && _fetchFn(_cfgUrl, _onFetchComplete, _broadcastChanges);
                        }
                        else {
                            _clearScheduledTimer();
                        }
                    }
                    if (isNullOrUndefined$1(_receiveChanges)) {
                        _receiveChanges = _extensionConfig.syncMode === 2 /* ICfgSyncMode.Receive */;
                    }
                    if (isNullOrUndefined$1(_broadcastChanges)) {
                        _broadcastChanges = _extensionConfig.syncMode === 1 /* ICfgSyncMode.Broadcast */;
                    }
                    var newEvtName = _extensionConfig.customEvtName || EVENT_NAME;
                    if (_evtName !== newEvtName) {
                        if (_receiveChanges) {
                            _updateEventListenerName(newEvtName);
                        }
                        else {
                            _eventOff();
                            _evtName = newEvtName;
                        }
                    }
                    if (isNullOrUndefined$1(_cfgUrl)) {
                        _cfgUrl = _extensionConfig.cfgUrl;
                    }
                    // if cfgUrl is set, we will ignore core config change
                    if (!_cfgUrl) {
                        _mainConfig = config;
                        if (_broadcastChanges) {
                            _sendCfgsyncEvents();
                        }
                    }
                }));
                _overrideSyncFn = _extensionConfig.overrideSyncFn;
                _overrideFetchFn = _extensionConfig.overrideFetchFn;
                _onCfgChangeReceive = _extensionConfig[_DYN_ON_CFG_CHANGE_RECEIV0 /* @min:%2eonCfgChangeReceive */];
                _nonOverrideConfigs = _extensionConfig[_DYN_NON_OVERRIDE_CONFIGS /* @min:%2enonOverrideConfigs */];
                _fetchTimeout = _extensionConfig[_DYN_SCHEDULE_FETCH_TIMEO1 /* @min:%2escheduleFetchTimeout */];
                _fetchFn = _getFetchFnInterface();
                _retryCnt = 0;
                // NOT support cfgURL change to avoid mutiple fetch calls
                if (_cfgUrl && !_blkCdnCfg) {
                    _fetchFn && _fetchFn(_cfgUrl, _onFetchComplete, _broadcastChanges);
                }
            }
            function _setCfg(config, isAutoSync) {
                if (config) {
                    _mainConfig = config;
                    if (!!isAutoSync && !_paused) {
                        return _sendCfgsyncEvents();
                    }
                    if (_receiveChanges && !_paused) {
                        _self.core.updateCfg(config);
                        return true;
                    }
                }
                return false;
            }
            function _eventOff() {
                try {
                    var global_1 = getGlobal$1();
                    if (global_1) {
                        eventOff(global_1, null, null, _evtNamespace);
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
            }
            function _sendCfgsyncEvents(customDetails) {
                try {
                    if (!!_overrideSyncFn && isFunction$2(_overrideSyncFn)) {
                        return _overrideSyncFn(_mainConfig, customDetails);
                    }
                    return sendCustomEvent(_evtName, _mainConfig, customDetails);
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return false;
            }
            function _updateEventListenerName(name) {
                try {
                    _eventOff();
                    if (name) {
                        _evtName = name;
                        _addEventListener();
                    }
                    return true;
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return false;
            }
            function _getFetchFnInterface() {
                var _fetchFn = _overrideFetchFn;
                if (isNullOrUndefined$1(_fetchFn)) {
                    if (isFetchSupported()) {
                        _fetchFn = _fetchSender;
                    }
                    else if (isXhrSupported()) {
                        _fetchFn = _xhrSender;
                    }
                }
                return _fetchFn;
            }
            function _fetchSender(url, oncomplete, isAutoSync) {
                var global = getGlobal$1();
                var fetchFn = (global && global.fetch) || null;
                if (url && fetchFn && isFunction$2(fetchFn)) {
                    try {
                        var init = {
                            method: STR_GET_METHOD
                        };
                        var request = new Request(url, init);
                        doAwaitResponse(fetch(request), function (result) {
                            var response = result.value;
                            if (!result.rejected) {
                                if (response.ok) {
                                    doAwaitResponse(response.text(), function (res) {
                                        _doOnComplete(oncomplete, response.status, res.value, isAutoSync);
                                    });
                                }
                                else {
                                    _doOnComplete(oncomplete, response.status, null, isAutoSync);
                                }
                            }
                            else {
                                _doOnComplete(oncomplete, 400);
                            }
                        });
                    }
                    catch (e) {
                        // eslint-disable-next-line no-empty
                    }
                }
            }
            function _xhrSender(url, oncomplete, isAutoSync) {
                try {
                    var xhr_1 = new XMLHttpRequest();
                    xhr_1.open(STR_GET_METHOD, url);
                    xhr_1.onreadystatechange = function () {
                        if (xhr_1.readyState === XMLHttpRequest.DONE) {
                            _doOnComplete(oncomplete, xhr_1.status, xhr_1.responseText, isAutoSync);
                        }
                    };
                    xhr_1.onerror = function () {
                        _doOnComplete(oncomplete, 400);
                    };
                    xhr_1.ontimeout = function () {
                        _doOnComplete(oncomplete, 400);
                    };
                    xhr_1.send();
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
            }
            function _onFetchComplete(status, response, isAutoSync) {
                try {
                    if (status >= 200 && status < 400 && response) {
                        _retryCnt = 0; // any successful response will reset retry count to 0
                        var JSON_1 = getJSON();
                        if (JSON_1) {
                            var cdnCfg = JSON_1.parse(response); //comments are not allowed
                            var cfg = applyCdnfeatureCfg(cdnCfg, _self.core);
                            cfg && _setCfg(cfg, isAutoSync);
                        }
                    }
                    else {
                        _retryCnt++;
                    }
                    if (_retryCnt < 3) {
                        _setupTimer();
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
            }
            function _doOnComplete(oncomplete, status, response, isAutoSync) {
                try {
                    oncomplete(status, response, isAutoSync);
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
            }
            function _addEventListener() {
                if (_receiveChanges) {
                    var global_2 = getGlobal$1();
                    if (global_2) {
                        try {
                            eventOn(global_2, _evtName, function (event) {
                                // TODO: add more validation here
                                // may include a "name" or some other features to check
                                var cfgEvent = event && event.detail;
                                if (_onCfgChangeReceive && cfgEvent) {
                                    _onCfgChangeReceive(cfgEvent);
                                }
                                else {
                                    var cfg = cfgEvent && cfgEvent.cfg;
                                    var newCfg = cfg && isPlainObject(cfg) && _replaceTartgetByKeys(cfg);
                                    newCfg && _setCfg(newCfg);
                                }
                            }, _evtNamespace, true);
                        }
                        catch (e) {
                            // eslint-disable-next-line no-empty
                        }
                    }
                }
            }
            // 4 levels
            function _replaceTartgetByKeys(cfg, level) {
                var _cfg = null;
                try {
                    if (cfg) {
                        _cfg = replaceByNonOverrideCfg(cfg, _nonOverrideConfigs, 0, 5);
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return _cfg;
            }
            /**
             * Sets up the timer which triggers fetching cdn every 30mins after inital call
             */
            function _setupTimer() {
                if (!_timeoutHandle && _fetchTimeout) {
                    _timeoutHandle = scheduleTimeout$1(function () {
                        _timeoutHandle = null;
                        _fetchFn(_cfgUrl, _onFetchComplete, _broadcastChanges);
                    }, _fetchTimeout);
                    _timeoutHandle.unref();
                }
            }
            function _clearScheduledTimer() {
                _timeoutHandle && _timeoutHandle.cancel();
                _timeoutHandle = null;
                _retryCnt = 0;
            }
            _self.processTelemetry = function (env, itemCtx) {
                _self.processNext(env, itemCtx);
            };
        });
        return _this;
    }
// Removed Stub for CfgSyncPlugin.prototype.initialize.
// Removed Stub for CfgSyncPlugin.prototype.getCfg.
// Removed Stub for CfgSyncPlugin.prototype.setCfg.
// Removed Stub for CfgSyncPlugin.prototype.sync.
// Removed Stub for CfgSyncPlugin.prototype.updateEventListenerName.
// Removed Stub for CfgSyncPlugin.prototype.pause.
// Removed Stub for CfgSyncPlugin.prototype.resume.
    //// Removed Stub for CfgSyncPlugin.prototype.processTelemetry.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    CfgSyncPlugin.__ieDyn=1;

    return CfgSyncPlugin;
}(BaseTelemetryPlugin));

/*
 * Application Insights JavaScript SDK - Channel, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var STR_DURATION$1 = "duration";

/*
 * Application Insights JavaScript SDK - Channel, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_TAGS = "tags"; // Count: 17
var _DYN_DEVICE_TYPE = "deviceType"; // Count: 3
var _DYN_DATA = "data"; // Count: 15
var _DYN_NAME$1 = "name"; // Count: 8
var _DYN_TRACE_ID$1 = "traceID"; // Count: 5
var _DYN_LENGTH$2 = "length"; // Count: 37
var _DYN_STRINGIFY = "stringify"; // Count: 5
var _DYN_MEASUREMENTS = "measurements"; // Count: 7
var _DYN_DATA_TYPE = "dataType"; // Count: 10
var _DYN_ENVELOPE_TYPE = "envelopeType"; // Count: 7
var _DYN_TO_STRING = "toString"; // Count: 7
var _DYN__GET = "_get"; // Count: 5
var _DYN_ENQUEUE = "enqueue"; // Count: 7
var _DYN_COUNT = "count"; // Count: 7
var _DYN_EVENTS_LIMIT_IN_MEM = "eventsLimitInMem"; // Count: 2
var _DYN_PUSH = "push"; // Count: 6
var _DYN_EMIT_LINE_DELIMITED_0 = "emitLineDelimitedJson"; // Count: 3
var _DYN_CLEAR = "clear"; // Count: 6
var _DYN_CREATE_NEW = "createNew"; // Count: 3
var _DYN_MARK_AS_SENT = "markAsSent"; // Count: 4
var _DYN_CLEAR_SENT = "clearSent"; // Count: 5
var _DYN_BUFFER_OVERRIDE = "bufferOverride"; // Count: 3
var _DYN__BUFFER__KEY = "BUFFER_KEY"; // Count: 5
var _DYN__SENT__BUFFER__KEY = "SENT_BUFFER_KEY"; // Count: 8
var _DYN__MAX__BUFFER__SIZE = "MAX_BUFFER_SIZE"; // Count: 5
var _DYN_TRIGGER_SEND = "triggerSend"; // Count: 5
var _DYN_DIAG_LOG = "diagLog"; // Count: 16
var _DYN_INITIALIZE = "initialize"; // Count: 3
var _DYN__SENDER = "_sender"; // Count: 5
var _DYN_CUSTOM_HEADERS = "customHeaders"; // Count: 3
var _DYN_MAX_BATCH_SIZE_IN_BY1 = "maxBatchSizeInBytes"; // Count: 2
var _DYN_ONUNLOAD_DISABLE_BEA2 = "onunloadDisableBeacon"; // Count: 3
var _DYN_IS_BEACON_API_DISABL3 = "isBeaconApiDisabled"; // Count: 3
var _DYN_ALWAYS_USE_XHR_OVERR4 = "alwaysUseXhrOverride"; // Count: 2
var _DYN_DISABLE_XHR = "disableXhr"; // Count: 3
var _DYN_ENABLE_SESSION_STORA5 = "enableSessionStorageBuffer"; // Count: 2
var _DYN__BUFFER = "_buffer"; // Count: 9
var _DYN_ONUNLOAD_DISABLE_FET6 = "onunloadDisableFetch"; // Count: 2
var _DYN_DISABLE_SEND_BEACON_7 = "disableSendBeaconSplit"; // Count: 2
var _DYN_INSTRUMENTATION_KEY$1 = "instrumentationKey"; // Count: 2
var _DYN_ENABLE_SEND_PROMISE = "enableSendPromise"; // Count: 2
var _DYN_GET_SENDER_INST = "getSenderInst"; // Count: 4
var _DYN_UNLOAD_TRANSPORTS = "unloadTransports"; // Count: 2
var _DYN_CONVERT_UNDEFINED = "convertUndefined"; // Count: 2
var _DYN_MAX_BATCH_INTERVAL = "maxBatchInterval"; // Count: 2
var _DYN_SERIALIZE = "serialize"; // Count: 4
var _DYN__ON_ERROR = "_onError"; // Count: 7
var _DYN__ON_PARTIAL_SUCCESS = "_onPartialSuccess"; // Count: 3
var _DYN__ON_SUCCESS = "_onSuccess"; // Count: 6
var _DYN_ITEMS_ACCEPTED = "itemsAccepted"; // Count: 3
var _DYN_ITEMS_RECEIVED = "itemsReceived"; // Count: 3
var _DYN_ORI_PAYLOAD = "oriPayload"; // Count: 3
var _DYN_BASE_TYPE = "baseType"; // Count: 4
var _DYN_SAMPLE_RATE = "sampleRate"; // Count: 4
var _DYN_EVENTS_SEND_REQUEST = "eventsSendRequest"; // Count: 2
var _DYN_GET_SAMPLING_SCORE = "getSamplingScore"; // Count: 2
var _DYN_GET_HASH_CODE_SCORE = "getHashCodeScore"; // Count: 4

/*
 * Application Insights JavaScript SDK - Channel, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
// these two constants are used to filter out properties not needed when trying to extract custom properties and measurements from the incoming payload
var strBaseType = "baseType";
var strBaseData = "baseData";
var strProperties = "properties";
var strTrue = "true";
function _setValueIf(target, field, value) {
    return setValue(target, field, value, isTruthy);
}
/*
 * Maps Part A data from CS 4.0
 */
function _extractPartAExtensions(logger, item, env) {
    // todo: switch to keys from common in this method
    var envTags = env[_DYN_TAGS /* @min:%2etags */] = env[_DYN_TAGS /* @min:%2etags */] || {};
    var itmExt = item.ext = item.ext || {};
    var itmTags = item[_DYN_TAGS /* @min:%2etags */] = item[_DYN_TAGS /* @min:%2etags */] || [];
    var extUser = itmExt.user;
    if (extUser) {
        _setValueIf(envTags, CtxTagKeys.userAuthUserId, extUser.authId);
        _setValueIf(envTags, CtxTagKeys.userId, extUser.id || extUser.localId);
    }
    var extApp = itmExt.app;
    if (extApp) {
        _setValueIf(envTags, CtxTagKeys.sessionId, extApp.sesId);
    }
    var extDevice = itmExt.device;
    if (extDevice) {
        _setValueIf(envTags, CtxTagKeys.deviceId, extDevice.id || extDevice.localId);
        _setValueIf(envTags, CtxTagKeys[_DYN_DEVICE_TYPE /* @min:%2edeviceType */], extDevice.deviceClass);
        _setValueIf(envTags, CtxTagKeys.deviceIp, extDevice.ip);
        _setValueIf(envTags, CtxTagKeys.deviceModel, extDevice.model);
        _setValueIf(envTags, CtxTagKeys[_DYN_DEVICE_TYPE /* @min:%2edeviceType */], extDevice[_DYN_DEVICE_TYPE /* @min:%2edeviceType */]);
    }
    var web = item.ext.web;
    if (web) {
        _setValueIf(envTags, CtxTagKeys.deviceLanguage, web.browserLang);
        _setValueIf(envTags, CtxTagKeys.deviceBrowserVersion, web.browserVer);
        _setValueIf(envTags, CtxTagKeys.deviceBrowser, web.browser);
        var envData = env[_DYN_DATA /* @min:%2edata */] = env[_DYN_DATA /* @min:%2edata */] || {};
        var envBaseData = envData[strBaseData] = envData[strBaseData] || {};
        var envProps = envBaseData[strProperties] = envBaseData[strProperties] || {};
        _setValueIf(envProps, "domain", web.domain);
        _setValueIf(envProps, "isManual", web.isManual ? strTrue : null);
        _setValueIf(envProps, "screenRes", web.screenRes);
        _setValueIf(envProps, "userConsent", web.userConsent ? strTrue : null);
    }
    var extOs = itmExt.os;
    if (extOs) {
        _setValueIf(envTags, CtxTagKeys.deviceOS, extOs[_DYN_NAME$1 /* @min:%2ename */]);
    }
    // No support for mapping Trace.traceState to 2.0 as it is currently empty
    var extTrace = itmExt.trace;
    if (extTrace) {
        _setValueIf(envTags, CtxTagKeys.operationParentId, extTrace.parentID);
        _setValueIf(envTags, CtxTagKeys.operationName, dataSanitizeString(logger, extTrace[_DYN_NAME$1 /* @min:%2ename */]));
        _setValueIf(envTags, CtxTagKeys.operationId, extTrace[_DYN_TRACE_ID$1 /* @min:%2etraceID */]);
    }
    // Sample 4.0 schema
    //  {
    //     "time" : "2018-09-05T22:51:22.4936Z",
    //     "name" : "MetricWithNamespace",
    //     "iKey" : "ABC-5a4cbd20-e601-4ef5-a3c6-5d6577e4398e",
    //     "ext": {  "cloud": {
    //          "role": "WATSON3",
    //          "roleInstance": "CO4AEAP00000260"
    //      },
    //      "device": {}, "correlation": {} },
    //      "tags": [
    //        { "amazon.region" : "east2" },
    //        { "os.expid" : "wp:02df239" }
    //     ]
    //   }
    var tgs = {};
    // deals with tags.push({object})
    for (var i = itmTags[_DYN_LENGTH$2 /* @min:%2elength */] - 1; i >= 0; i--) {
        var tg = itmTags[i];
        objForEachKey$1(tg, function (key, value) {
            tgs[key] = value;
        });
        itmTags.splice(i, 1);
    }
    // deals with tags[key]=value (and handles hasOwnProperty)
    objForEachKey$1(itmTags, function (tg, value) {
        tgs[tg] = value;
    });
    var theTags = __assignFn(__assignFn({}, envTags), tgs);
    if (!theTags[CtxTagKeys.internalSdkVersion]) {
        // Append a version in case it is not already set
        theTags[CtxTagKeys.internalSdkVersion] = dataSanitizeString(logger, "javascript:".concat(EnvelopeCreator.Version), 64);
    }
    env[_DYN_TAGS /* @min:%2etags */] = optimizeObject(theTags);
}
function _extractPropsAndMeasurements(data, properties, measurements) {
    if (!isNullOrUndefined$1(data)) {
        objForEachKey$1(data, function (key, value) {
            if (isNumber$2(value)) {
                measurements[key] = value;
            }
            else if (isString$2(value)) {
                properties[key] = value;
            }
            else if (hasJSON()) {
                properties[key] = getJSON()[_DYN_STRINGIFY /* @min:%2estringify */](value);
            }
        });
    }
}
function _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue) {
    if (!isNullOrUndefined$1(properties)) {
        objForEachKey$1(properties, function (key, value) {
            properties[key] = value || customUndefinedValue;
        });
    }
}
// TODO: Do we want this to take logger as arg or use this._logger as nonstatic?
function _createEnvelope(logger, envelopeType, telemetryItem, data) {
    var envelope = new Envelope(logger, data, envelopeType);
    _setValueIf(envelope, "sampleRate", telemetryItem[SampleRate]);
    if ((telemetryItem[strBaseData] || {}).startTime) {
        // Starting from Version 3.0.3, the time property will be assigned by the startTime value,
        // which records the loadEvent time for the pageView event.
        envelope.time = toISOString(telemetryItem[strBaseData].startTime);
    }
    envelope.iKey = telemetryItem.iKey;
    var iKeyNoDashes = telemetryItem.iKey.replace(/-/g, "");
    envelope[_DYN_NAME$1 /* @min:%2ename */] = envelope[_DYN_NAME$1 /* @min:%2ename */].replace("{0}", iKeyNoDashes);
    // extract all extensions from ctx
    _extractPartAExtensions(logger, telemetryItem, envelope);
    // loop through the envelope tags (extension of Part A) and pick out the ones that should go in outgoing envelope tags
    telemetryItem[_DYN_TAGS /* @min:%2etags */] = telemetryItem[_DYN_TAGS /* @min:%2etags */] || [];
    return optimizeObject(envelope);
}
function EnvelopeCreatorInit(logger, telemetryItem) {
    if (isNullOrUndefined$1(telemetryItem[strBaseData])) {
        _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 46 /* _eInternalMessageId.TelemetryEnvelopeInvalid */, "telemetryItem.baseData cannot be null.");
    }
}
var EnvelopeCreator = {
    Version: '3.1.2'
};
function DependencyEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var customMeasurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    var customProperties = telemetryItem[strBaseData][strProperties] || {};
    _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], customProperties, customMeasurements);
    if (!isNullOrUndefined$1(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    }
    var bd = telemetryItem[strBaseData];
    if (isNullOrUndefined$1(bd)) {
        _warnToConsole(logger, "Invalid input for dependency data");
        return null;
    }
    var method = bd[strProperties] && bd[strProperties][HttpMethod] ? bd[strProperties][HttpMethod] : "GET";
    var remoteDepData = new RemoteDependencyData(logger, bd.id, bd.target, bd[_DYN_NAME$1 /* @min:%2ename */], bd[STR_DURATION$1 /* @min:%2eduration */], bd.success, bd.responseCode, method, bd.type, bd.correlationContext, customProperties, customMeasurements);
    var data = new Data(RemoteDependencyData[_DYN_DATA_TYPE /* @min:%2edataType */], remoteDepData);
    return _createEnvelope(logger, RemoteDependencyData[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function EventEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var customProperties = {};
    var customMeasurements = {};
    if (telemetryItem[strBaseType] !== Event$1[_DYN_DATA_TYPE /* @min:%2edataType */]) {
        customProperties["baseTypeSource"] = telemetryItem[strBaseType]; // save the passed in base type as a property
    }
    if (telemetryItem[strBaseType] === Event$1[_DYN_DATA_TYPE /* @min:%2edataType */]) { // take collection
        customProperties = telemetryItem[strBaseData][strProperties] || {};
        customMeasurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    }
    else { // if its not a known type, convert to custom event
        if (telemetryItem[strBaseData]) {
            _extractPropsAndMeasurements(telemetryItem[strBaseData], customProperties, customMeasurements);
        }
    }
    // Extract root level properties from part C telemetryItem.data
    _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], customProperties, customMeasurements);
    if (!isNullOrUndefined$1(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    }
    var eventName = telemetryItem[strBaseData][_DYN_NAME$1 /* @min:%2ename */];
    var eventData = new Event$1(logger, eventName, customProperties, customMeasurements);
    var data = new Data(Event$1[_DYN_DATA_TYPE /* @min:%2edataType */], eventData);
    return _createEnvelope(logger, Event$1[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function ExceptionEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    // Extract root level properties from part C telemetryItem.data
    var customMeasurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    var customProperties = telemetryItem[strBaseData][strProperties] || {};
    _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], customProperties, customMeasurements);
    if (!isNullOrUndefined$1(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    }
    var bd = telemetryItem[strBaseData];
    var exData = Exception.CreateFromInterface(logger, bd, customProperties, customMeasurements);
    var data = new Data(Exception[_DYN_DATA_TYPE /* @min:%2edataType */], exData);
    return _createEnvelope(logger, Exception[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function MetricEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var baseData = telemetryItem[strBaseData];
    var props = baseData[strProperties] || {};
    var measurements = baseData[_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], props, measurements);
    if (!isNullOrUndefined$1(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
    }
    var baseMetricData = new Metric(logger, baseData[_DYN_NAME$1 /* @min:%2ename */], baseData.average, baseData.sampleCount, baseData.min, baseData.max, baseData.stdDev, props, measurements);
    var data = new Data(Metric[_DYN_DATA_TYPE /* @min:%2edataType */], baseMetricData);
    return _createEnvelope(logger, Metric[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function PageViewEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    // Since duration is not part of the domain properties in Common Schema, extract it from part C
    var duration;
    var baseData = telemetryItem[strBaseData];
    if (!isNullOrUndefined$1(baseData) &&
        !isNullOrUndefined$1(baseData[strProperties]) &&
        !isNullOrUndefined$1(baseData[strProperties][STR_DURATION$1])) { // from part B properties
        duration = baseData[strProperties][STR_DURATION$1];
        delete baseData[strProperties][STR_DURATION$1];
    }
    else if (!isNullOrUndefined$1(telemetryItem[_DYN_DATA /* @min:%2edata */]) &&
        !isNullOrUndefined$1(telemetryItem[_DYN_DATA /* @min:%2edata */][STR_DURATION$1])) { // from custom properties
        duration = telemetryItem[_DYN_DATA /* @min:%2edata */][STR_DURATION$1];
        delete telemetryItem[_DYN_DATA /* @min:%2edata */][STR_DURATION$1];
    }
    var bd = telemetryItem[strBaseData];
    // special case: pageview.id is grabbed from current operation id. Analytics plugin is decoupled from properties plugin, so this is done here instead. This can be made a default telemetry intializer instead if needed to be decoupled from channel
    var currentContextId;
    if (((telemetryItem.ext || {}).trace || {})[_DYN_TRACE_ID$1 /* @min:%2etraceID */]) {
        currentContextId = telemetryItem.ext.trace[_DYN_TRACE_ID$1 /* @min:%2etraceID */];
    }
    var id = bd.id || currentContextId;
    var name = bd[_DYN_NAME$1 /* @min:%2ename */];
    var url = bd.uri;
    var properties = bd[strProperties] || {};
    var measurements = bd[_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    // refUri is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!isNullOrUndefined$1(bd.refUri)) {
        properties["refUri"] = bd.refUri;
    }
    // pageType is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!isNullOrUndefined$1(bd.pageType)) {
        properties["pageType"] = bd.pageType;
    }
    // isLoggedIn is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!isNullOrUndefined$1(bd.isLoggedIn)) {
        properties["isLoggedIn"] = bd.isLoggedIn[_DYN_TO_STRING /* @min:%2etoString */]();
    }
    // pageTags is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!isNullOrUndefined$1(bd[strProperties])) {
        var pageTags = bd[strProperties];
        objForEachKey$1(pageTags, function (key, value) {
            properties[key] = value;
        });
    }
    _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], properties, measurements);
    if (!isNullOrUndefined$1(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
    }
    var pageViewData = new PageView(logger, name, url, duration, properties, measurements, id);
    var data = new Data(PageView[_DYN_DATA_TYPE /* @min:%2edataType */], pageViewData);
    return _createEnvelope(logger, PageView[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function PageViewPerformanceEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var bd = telemetryItem[strBaseData];
    var name = bd[_DYN_NAME$1 /* @min:%2ename */];
    var url = bd.uri || bd.url;
    var properties = bd[strProperties] || {};
    var measurements = bd[_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], properties, measurements);
    if (!isNullOrUndefined$1(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
    }
    var baseData = new PageViewPerformance(logger, name, url, undefined, properties, measurements, bd);
    var data = new Data(PageViewPerformance[_DYN_DATA_TYPE /* @min:%2edataType */], baseData);
    return _createEnvelope(logger, PageViewPerformance[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function TraceEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var message = telemetryItem[strBaseData].message;
    var severityLevel = telemetryItem[strBaseData].severityLevel;
    var props = telemetryItem[strBaseData][strProperties] || {};
    var measurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], props, measurements);
    if (!isNullOrUndefined$1(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
    }
    var baseData = new Trace(logger, message, severityLevel, props, measurements);
    var data = new Data(Trace[_DYN_DATA_TYPE /* @min:%2edataType */], baseData);
    return _createEnvelope(logger, Trace[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}

/*
 * Application Insights JavaScript SDK - Channel, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var BaseSendBuffer = /** @class */ (function () {
    function BaseSendBuffer(logger, config) {
        var _buffer = [];
        var _bufferFullMessageSent = false;
        this[_DYN__GET /* @min:%2e_get */] = function () {
            return _buffer;
        };
        this._set = function (buffer) {
            _buffer = buffer;
            return _buffer;
        };
        dynamicProto(BaseSendBuffer, this, function (_self) {
            _self[_DYN_ENQUEUE /* @min:%2eenqueue */] = function (payload) {
                if (_self[_DYN_COUNT /* @min:%2ecount */]() >= config[_DYN_EVENTS_LIMIT_IN_MEM /* @min:%2eeventsLimitInMem */]) {
                    // sent internal log only once per page view
                    if (!_bufferFullMessageSent) {
                        _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 105 /* _eInternalMessageId.InMemoryStorageBufferFull */, "Maximum in-memory buffer size reached: " + _self[_DYN_COUNT /* @min:%2ecount */](), true);
                        _bufferFullMessageSent = true;
                    }
                    return;
                }
                _buffer[_DYN_PUSH /* @min:%2epush */](payload);
            };
            _self[_DYN_COUNT /* @min:%2ecount */] = function () {
                return _buffer[_DYN_LENGTH$2 /* @min:%2elength */];
            };
            _self.size = function () {
                var size = _buffer[_DYN_LENGTH$2 /* @min:%2elength */];
                for (var lp = 0; lp < _buffer[_DYN_LENGTH$2 /* @min:%2elength */]; lp++) {
                    size += _buffer[lp][_DYN_LENGTH$2 /* @min:%2elength */];
                }
                if (!config[_DYN_EMIT_LINE_DELIMITED_0 /* @min:%2eemitLineDelimitedJson */]) {
                    size += 2;
                }
                return size;
            };
            _self[_DYN_CLEAR /* @min:%2eclear */] = function () {
                _buffer = [];
                _bufferFullMessageSent = false;
            };
            _self.getItems = function () {
                return _buffer.slice(0);
            };
            _self.batchPayloads = function (payload) {
                if (payload && payload[_DYN_LENGTH$2 /* @min:%2elength */] > 0) {
                    var batch = config[_DYN_EMIT_LINE_DELIMITED_0 /* @min:%2eemitLineDelimitedJson */] ?
                        payload.join("\n") :
                        "[" + payload.join(",") + "]";
                    return batch;
                }
                return null;
            };
            _self[_DYN_CREATE_NEW /* @min:%2ecreateNew */] = function (newLogger, newConfig, canUseSessionStorage) {
                var items = _buffer.slice(0);
                newLogger = newLogger || logger;
                newConfig = newConfig || {};
                var newBuffer = !!canUseSessionStorage ? new SessionStorageSendBuffer(newLogger, newConfig) : new ArraySendBuffer(newLogger, newConfig);
                arrForEach$1(items, function (payload) {
                    newBuffer[_DYN_ENQUEUE /* @min:%2eenqueue */](payload);
                });
                return newBuffer;
            };
        });
    }
// Removed Stub for BaseSendBuffer.prototype.enqueue.
// Removed Stub for BaseSendBuffer.prototype.count.
// Removed Stub for BaseSendBuffer.prototype.size.
// Removed Stub for BaseSendBuffer.prototype.clear.
// Removed Stub for BaseSendBuffer.prototype.getItems.
// Removed Stub for BaseSendBuffer.prototype.batchPayloads.
// Removed Stub for BaseSendBuffer.prototype.createNew.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    BaseSendBuffer.__ieDyn=1;

    return BaseSendBuffer;
}());
/*
 * An array based send buffer.
 */
var ArraySendBuffer = /** @class */ (function (_super) {
    __extendsFn(ArraySendBuffer, _super);
    function ArraySendBuffer(logger, config) {
        var _this = _super.call(this, logger, config) || this;
        dynamicProto(ArraySendBuffer, _this, function (_self, _base) {
            _self[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */] = function (payload) {
                _base[_DYN_CLEAR /* @min:%2eclear */]();
            };
            _self[_DYN_CLEAR_SENT /* @min:%2eclearSent */] = function (payload) {
                // not supported
            };
        });
        return _this;
    }
// Removed Stub for ArraySendBuffer.prototype.markAsSent.
// Removed Stub for ArraySendBuffer.prototype.clearSent.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    ArraySendBuffer.__ieDyn=1;

    return ArraySendBuffer;
}(BaseSendBuffer));
/*
 * Session storage buffer holds a copy of all unsent items in the browser session storage.
 */
var SessionStorageSendBuffer = /** @class */ (function (_super) {
    __extendsFn(SessionStorageSendBuffer, _super);
    function SessionStorageSendBuffer(logger, config) {
        var _this = _super.call(this, logger, config) || this;
        var _bufferFullMessageSent = false;
        //Note: should not use config.namePrefix directly, because it will always refers to the latest namePrefix
        var _namePrefix = config === null || config === void 0 ? void 0 : config.namePrefix;
        var _a = config[_DYN_BUFFER_OVERRIDE /* @min:%2ebufferOverride */] || { getItem: utlGetSessionStorage, setItem: utlSetSessionStorage }, getItem = _a.getItem, setItem = _a.setItem;
        dynamicProto(SessionStorageSendBuffer, _this, function (_self, _base) {
            var bufferItems = _getBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */]);
            var notDeliveredItems = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */]);
            var buffer = _self._set(bufferItems.concat(notDeliveredItems));
            // If the buffer has too many items, drop items from the end.
            if (buffer[_DYN_LENGTH$2 /* @min:%2elength */] > SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */]) {
                buffer[_DYN_LENGTH$2 /* @min:%2elength */] = SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */];
            }
            _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */], []);
            _setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */], buffer);
            _self[_DYN_ENQUEUE /* @min:%2eenqueue */] = function (payload) {
                if (_self[_DYN_COUNT /* @min:%2ecount */]() >= SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */]) {
                    // sent internal log only once per page view
                    if (!_bufferFullMessageSent) {
                        _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 67 /* _eInternalMessageId.SessionStorageBufferFull */, "Maximum buffer size reached: " + _self[_DYN_COUNT /* @min:%2ecount */](), true);
                        _bufferFullMessageSent = true;
                    }
                    return;
                }
                _base[_DYN_ENQUEUE /* @min:%2eenqueue */](payload);
                _setBuffer(SessionStorageSendBuffer.BUFFER_KEY, _self[_DYN__GET /* @min:%2e_get */]());
            };
            _self[_DYN_CLEAR /* @min:%2eclear */] = function () {
                _base[_DYN_CLEAR /* @min:%2eclear */]();
                _setBuffer(SessionStorageSendBuffer.BUFFER_KEY, _self[_DYN__GET /* @min:%2e_get */]());
                _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */], []);
                _bufferFullMessageSent = false;
            };
            _self[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */] = function (payload) {
                _setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */], _self._set(_removePayloadsFromBuffer(payload, _self[_DYN__GET /* @min:%2e_get */]())));
                var sentElements = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */]);
                if (sentElements instanceof Array && payload instanceof Array) {
                    sentElements = sentElements.concat(payload);
                    if (sentElements[_DYN_LENGTH$2 /* @min:%2elength */] > SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */]) {
                        // We send telemetry normally. If the SENT_BUFFER is too big we don't add new elements
                        // until we receive a response from the backend and the buffer has free space again (see clearSent method)
                        _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 67 /* _eInternalMessageId.SessionStorageBufferFull */, "Sent buffer reached its maximum size: " + sentElements[_DYN_LENGTH$2 /* @min:%2elength */], true);
                        sentElements[_DYN_LENGTH$2 /* @min:%2elength */] = SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */];
                    }
                    _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */], sentElements);
                }
            };
            _self[_DYN_CLEAR_SENT /* @min:%2eclearSent */] = function (payload) {
                var sentElements = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */]);
                sentElements = _removePayloadsFromBuffer(payload, sentElements);
                _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */], sentElements);
            };
            _self[_DYN_CREATE_NEW /* @min:%2ecreateNew */] = function (newLogger, newConfig, canUseSessionStorage) {
                canUseSessionStorage = !!canUseSessionStorage;
                var unsentItems = _self[_DYN__GET /* @min:%2e_get */]().slice(0);
                var sentItems = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */]).slice(0);
                newLogger = newLogger || logger;
                newConfig = newConfig || {};
                // to make sure that we do not send duplicated payloads when it is switched back to previous one
                _self[_DYN_CLEAR /* @min:%2eclear */]();
                var newBuffer = canUseSessionStorage ? new SessionStorageSendBuffer(newLogger, newConfig) : new ArraySendBuffer(newLogger, newConfig);
                arrForEach$1(unsentItems, function (payload) {
                    newBuffer[_DYN_ENQUEUE /* @min:%2eenqueue */](payload);
                });
                if (canUseSessionStorage) {
                    // arr buffer will clear all payloads if markAsSent() is called
                    newBuffer[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */](sentItems);
                }
                return newBuffer;
            };
            function _removePayloadsFromBuffer(payloads, buffer) {
                var remaining = [];
                arrForEach$1(buffer, function (value) {
                    if (!isFunction$2(value) && arrIndexOf(payloads, value) === -1) {
                        remaining[_DYN_PUSH /* @min:%2epush */](value);
                    }
                });
                return remaining;
            }
            function _getBuffer(key) {
                var prefixedKey = key;
                try {
                    prefixedKey = _namePrefix ? _namePrefix + "_" + prefixedKey : prefixedKey;
                    var bufferJson = getItem(logger, prefixedKey);
                    if (bufferJson) {
                        var buffer_1 = getJSON().parse(bufferJson);
                        if (isString$2(buffer_1)) {
                            // When using some version prototype.js the stringify / parse cycle does not decode array's correctly
                            buffer_1 = getJSON().parse(buffer_1);
                        }
                        if (buffer_1 && isArray$1(buffer_1)) {
                            return buffer_1;
                        }
                    }
                }
                catch (e) {
                    _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 42 /* _eInternalMessageId.FailedToRestoreStorageBuffer */, " storage key: " + prefixedKey + ", " + getExceptionName(e), { exception: dumpObj$2(e) });
                }
                return [];
            }
            function _setBuffer(key, buffer) {
                var prefixedKey = key;
                try {
                    prefixedKey = _namePrefix ? _namePrefix + "_" + prefixedKey : prefixedKey;
                    var bufferJson = JSON[_DYN_STRINGIFY /* @min:%2estringify */](buffer);
                    setItem(logger, prefixedKey, bufferJson);
                }
                catch (e) {
                    // if there was an error, clear the buffer
                    // telemetry is stored in the _buffer array so we won't loose any items
                    setItem(logger, prefixedKey, JSON[_DYN_STRINGIFY /* @min:%2estringify */]([]));
                    _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 41 /* _eInternalMessageId.FailedToSetStorageBuffer */, " storage key: " + prefixedKey + ", " + getExceptionName(e) + ". Buffer cleared", { exception: dumpObj$2(e) });
                }
            }
        });
        return _this;
    }
// Removed Stub for SessionStorageSendBuffer.prototype.enqueue.
// Removed Stub for SessionStorageSendBuffer.prototype.clear.
// Removed Stub for SessionStorageSendBuffer.prototype.markAsSent.
// Removed Stub for SessionStorageSendBuffer.prototype.clearSent.
// Removed Stub for SessionStorageSendBuffer.prototype.createNew.
    SessionStorageSendBuffer.BUFFER_KEY = "AI_buffer";
    SessionStorageSendBuffer.SENT_BUFFER_KEY = "AI_sentBuffer";
    // Maximum number of payloads stored in the buffer. If the buffer is full, new elements will be dropped.
    SessionStorageSendBuffer.MAX_BUFFER_SIZE = 2000;
    return SessionStorageSendBuffer;
}(BaseSendBuffer));

/*
 * Application Insights JavaScript SDK - Channel, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var Serializer = /** @class */ (function () {
    function Serializer(logger) {
        dynamicProto(Serializer, this, function (_self) {
            /**
             * Serializes the current object to a JSON string.
             */
            _self[_DYN_SERIALIZE /* @min:%2eserialize */] = function (input) {
                var output = _serializeObject(input, "root");
                try {
                    return getJSON()[_DYN_STRINGIFY /* @min:%2estringify */](output);
                }
                catch (e) {
                    // if serialization fails return an empty string
                    _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.CannotSerializeObject */, (e && isFunction$2(e[_DYN_TO_STRING /* @min:%2etoString */])) ? e[_DYN_TO_STRING /* @min:%2etoString */]() : "Error serializing object", null, true);
                }
            };
            function _serializeObject(source, name) {
                var circularReferenceCheck = "__aiCircularRefCheck";
                var output = {};
                if (!source) {
                    _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.CannotSerializeObject */, "cannot serialize object because it is null or undefined", { name: name }, true);
                    return output;
                }
                if (source[circularReferenceCheck]) {
                    _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 50 /* _eInternalMessageId.CircularReferenceDetected */, "Circular reference detected while serializing object", { name: name }, true);
                    return output;
                }
                if (!source.aiDataContract) {
                    // special case for measurements/properties/tags
                    if (name === "measurements") {
                        output = _serializeStringMap(source, "number", name);
                    }
                    else if (name === "properties") {
                        output = _serializeStringMap(source, "string", name);
                    }
                    else if (name === "tags") {
                        output = _serializeStringMap(source, "string", name);
                    }
                    else if (isArray$1(source)) {
                        output = _serializeArray(source, name);
                    }
                    else {
                        _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */, "Attempting to serialize an object which does not implement ISerializable", { name: name }, true);
                        try {
                            // verify that the object can be stringified
                            getJSON()[_DYN_STRINGIFY /* @min:%2estringify */](source);
                            output = source;
                        }
                        catch (e) {
                            // if serialization fails return an empty string
                            _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.CannotSerializeObject */, (e && isFunction$2(e[_DYN_TO_STRING /* @min:%2etoString */])) ? e[_DYN_TO_STRING /* @min:%2etoString */]() : "Error serializing object", null, true);
                        }
                    }
                    return output;
                }
                source[circularReferenceCheck] = true;
                objForEachKey$1(source.aiDataContract, function (field, contract) {
                    var isRequired = (isFunction$2(contract)) ? (contract() & 1 /* FieldType.Required */) : (contract & 1 /* FieldType.Required */);
                    var isHidden = (isFunction$2(contract)) ? (contract() & 4 /* FieldType.Hidden */) : (contract & 4 /* FieldType.Hidden */);
                    var isArray = contract & 2 /* FieldType.Array */;
                    var isPresent = source[field] !== undefined;
                    var isObj = isObject$2(source[field]) && source[field] !== null;
                    if (isRequired && !isPresent && !isArray) {
                        _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 24 /* _eInternalMessageId.MissingRequiredFieldSpecification */, "Missing required field specification. The field is required but not present on source", { field: field, name: name });
                        // If not in debug mode, continue and hope the error is permissible
                    }
                    else if (!isHidden) { // Don't serialize hidden fields
                        var value = void 0;
                        if (isObj) {
                            if (isArray) {
                                // special case; recurse on each object in the source array
                                value = _serializeArray(source[field], field);
                            }
                            else {
                                // recurse on the source object in this field
                                value = _serializeObject(source[field], field);
                            }
                        }
                        else {
                            // assign the source field to the output even if undefined or required
                            value = source[field];
                        }
                        // only emit this field if the value is defined
                        if (value !== undefined) {
                            output[field] = value;
                        }
                    }
                });
                delete source[circularReferenceCheck];
                return output;
            }
            function _serializeArray(sources, name) {
                var output;
                if (!!sources) {
                    if (!isArray$1(sources)) {
                        _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 54 /* _eInternalMessageId.ItemNotInArray */, "This field was specified as an array in the contract but the item is not an array.\r\n", { name: name }, true);
                    }
                    else {
                        output = [];
                        for (var i = 0; i < sources[_DYN_LENGTH$2 /* @min:%2elength */]; i++) {
                            var source = sources[i];
                            var item = _serializeObject(source, name + "[" + i + "]");
                            output[_DYN_PUSH /* @min:%2epush */](item);
                        }
                    }
                }
                return output;
            }
            function _serializeStringMap(map, expectedType, name) {
                var output;
                if (map) {
                    output = {};
                    objForEachKey$1(map, function (field, value) {
                        if (expectedType === "string") {
                            if (value === undefined) {
                                output[field] = "undefined";
                            }
                            else if (value === null) {
                                output[field] = "null";
                            }
                            else if (!value[_DYN_TO_STRING /* @min:%2etoString */]) {
                                output[field] = "invalid field: toString() is not defined.";
                            }
                            else {
                                output[field] = value[_DYN_TO_STRING /* @min:%2etoString */]();
                            }
                        }
                        else if (expectedType === "number") {
                            if (value === undefined) {
                                output[field] = "undefined";
                            }
                            else if (value === null) {
                                output[field] = "null";
                            }
                            else {
                                var num = parseFloat(value);
                                output[field] = num;
                            }
                        }
                        else {
                            output[field] = "invalid field: " + name + " is of unknown type.";
                            _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, output[field], null, true);
                        }
                    });
                }
                return output;
            }
        });
    }
// Removed Stub for Serializer.prototype.serialize.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    Serializer.__ieDyn=1;

    return Serializer;
}());

/*
 * Application Insights JavaScript SDK - Channel, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
// (Magic number) DJB algorithm can't work on shorter strings (results in poor distribution
var MIN_INPUT_LENGTH = 8;
var HashCodeScoreGenerator = /** @class */ (function () {
    function HashCodeScoreGenerator() {
    }
    HashCodeScoreGenerator.prototype.getHashCodeScore = function (key) {
        var score = this.getHashCode(key) / HashCodeScoreGenerator.INT_MAX_VALUE;
        return score * 100;
    };
    HashCodeScoreGenerator.prototype.getHashCode = function (input) {
        if (input === "") {
            return 0;
        }
        while (input[_DYN_LENGTH$2 /* @min:%2elength */] < MIN_INPUT_LENGTH) {
            input = input.concat(input);
        }
        // 5381 is a magic number: http://stackoverflow.com/questions/10696223/reason-for-5381-number-in-djb-hash-function
        var hash = 5381;
        for (var i = 0; i < input[_DYN_LENGTH$2 /* @min:%2elength */]; ++i) {
            hash = ((hash << 5) + hash) + input.charCodeAt(i);
            // 'hash' is of number type which means 53 bit integer (http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types-number-type)
            // 'hash & hash' will keep it 32 bit integer - just to make it clearer what the result is.
            hash = hash & hash;
        }
        return Math.abs(hash);
    };
    // We're using 32 bit math, hence max value is (2^31 - 1)
    HashCodeScoreGenerator.INT_MAX_VALUE = 2147483647;
    return HashCodeScoreGenerator;
}());

/*
 * Application Insights JavaScript SDK - Channel, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var SamplingScoreGenerator = /** @class */ (function () {
    function SamplingScoreGenerator() {
        var _self = this;
        var hashCodeGenerator = new HashCodeScoreGenerator();
        var keys = new ContextTagKeys();
        _self[_DYN_GET_SAMPLING_SCORE /* @min:%2egetSamplingScore */] = function (item) {
            var score = 0;
            if (item[_DYN_TAGS /* @min:%2etags */] && item[_DYN_TAGS /* @min:%2etags */][keys.userId]) { // search in tags first, then ext
                score = hashCodeGenerator.getHashCodeScore(item[_DYN_TAGS /* @min:%2etags */][keys.userId]);
            }
            else if (item.ext && item.ext.user && item.ext.user.id) {
                score = hashCodeGenerator[_DYN_GET_HASH_CODE_SCORE /* @min:%2egetHashCodeScore */](item.ext.user.id);
            }
            else if (item[_DYN_TAGS /* @min:%2etags */] && item[_DYN_TAGS /* @min:%2etags */][keys.operationId]) { // search in tags first, then ext
                score = hashCodeGenerator.getHashCodeScore(item[_DYN_TAGS /* @min:%2etags */][keys.operationId]);
            }
            else if (item.ext && item.ext.telemetryTrace && item.ext.telemetryTrace[_DYN_TRACE_ID$1 /* @min:%2etraceID */]) {
                score = hashCodeGenerator.getHashCodeScore(item.ext.telemetryTrace[_DYN_TRACE_ID$1 /* @min:%2etraceID */]);
            }
            else {
                // tslint:disable-next-line:insecure-random
                score = (Math.random() * 100);
            }
            return score;
        };
    }
    return SamplingScoreGenerator;
}());

/*
 * Application Insights JavaScript SDK - Channel, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var Sample = /** @class */ (function () {
    function Sample(sampleRate, logger) {
        // We're using 32 bit math, hence max value is (2^31 - 1)
        this.INT_MAX_VALUE = 2147483647;
        var _logger = logger || safeGetLogger(null);
        if (sampleRate > 100 || sampleRate < 0) {
            _logger.throwInternal(2 /* eLoggingSeverity.WARNING */, 58 /* _eInternalMessageId.SampleRateOutOfRange */, "Sampling rate is out of range (0..100). Sampling will be disabled, you may be sending too much data which may affect your AI service level.", { samplingRate: sampleRate }, true);
            sampleRate = 100;
        }
        this[_DYN_SAMPLE_RATE /* @min:%2esampleRate */] = sampleRate;
        this.samplingScoreGenerator = new SamplingScoreGenerator();
    }
    /**
    * Determines if an envelope is sampled in (i.e. will be sent) or not (i.e. will be dropped).
    */
    Sample.prototype.isSampledIn = function (envelope) {
        var samplingPercentage = this[_DYN_SAMPLE_RATE /* @min:%2esampleRate */]; // 0 - 100
        var isSampledIn = false;
        if (samplingPercentage === null || samplingPercentage === undefined || samplingPercentage >= 100) {
            return true;
        }
        else if (envelope.baseType === Metric[_DYN_DATA_TYPE /* @min:%2edataType */]) {
            // exclude MetricData telemetry from sampling
            return true;
        }
        isSampledIn = this.samplingScoreGenerator[_DYN_GET_SAMPLING_SCORE /* @min:%2egetSamplingScore */](envelope) < samplingPercentage;
        return isSampledIn;
    };
    return Sample;
}());

/*
 * Application Insights JavaScript SDK - Channel, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var _a$5, _b$1;
var UNDEFINED_VALUE$1 = undefined;
var EMPTY_STR = "";
var FetchSyncRequestSizeLimitBytes = 65000; // approx 64kb (the current Edge, Firefox and Chrome max limit)
function _getResponseText(xhr) {
    try {
        return xhr.responseText;
    }
    catch (e) {
        // Best effort, as XHR may throw while XDR wont so just ignore
    }
    return null;
}
function isOverrideFn(httpXHROverride) {
    return httpXHROverride && httpXHROverride.sendPOST;
}
var defaultAppInsightsChannelConfig = objDeepFreeze$1((_a$5 = {
        // Use the default value (handles empty string in the configuration)
        endpointUrl: cfgDfValidate(isTruthy, DEFAULT_BREEZE_ENDPOINT + DEFAULT_BREEZE_PATH)
    },
    _a$5[_DYN_EMIT_LINE_DELIMITED_0 /* @min:emitLineDelimitedJson */] = cfgDfBoolean(),
    _a$5[_DYN_MAX_BATCH_INTERVAL /* @min:maxBatchInterval */] = 15000,
    _a$5[_DYN_MAX_BATCH_SIZE_IN_BY1 /* @min:maxBatchSizeInBytes */] = 102400,
    _a$5.disableTelemetry = cfgDfBoolean(),
    _a$5[_DYN_ENABLE_SESSION_STORA5 /* @min:enableSessionStorageBuffer */] = cfgDfBoolean(true),
    _a$5.isRetryDisabled = cfgDfBoolean(),
    _a$5[_DYN_IS_BEACON_API_DISABL3 /* @min:isBeaconApiDisabled */] = cfgDfBoolean(true),
    _a$5[_DYN_DISABLE_SEND_BEACON_7 /* @min:disableSendBeaconSplit */] = cfgDfBoolean(true),
    _a$5[_DYN_DISABLE_XHR /* @min:disableXhr */] = cfgDfBoolean(),
    _a$5[_DYN_ONUNLOAD_DISABLE_FET6 /* @min:onunloadDisableFetch */] = cfgDfBoolean(),
    _a$5[_DYN_ONUNLOAD_DISABLE_BEA2 /* @min:onunloadDisableBeacon */] = cfgDfBoolean(),
    _a$5[_DYN_INSTRUMENTATION_KEY$1 /* @min:instrumentationKey */] = UNDEFINED_VALUE$1,
    _a$5.namePrefix = UNDEFINED_VALUE$1,
    _a$5.samplingPercentage = cfgDfValidate(_chkSampling, 100),
    _a$5[_DYN_CUSTOM_HEADERS /* @min:customHeaders */] = UNDEFINED_VALUE$1,
    _a$5[_DYN_CONVERT_UNDEFINED /* @min:convertUndefined */] = UNDEFINED_VALUE$1,
    _a$5[_DYN_EVENTS_LIMIT_IN_MEM /* @min:eventsLimitInMem */] = 10000,
    _a$5[_DYN_BUFFER_OVERRIDE /* @min:bufferOverride */] = false,
    _a$5.httpXHROverride = { isVal: isOverrideFn, v: UNDEFINED_VALUE$1 },
    _a$5[_DYN_ALWAYS_USE_XHR_OVERR4 /* @min:alwaysUseXhrOverride */] = cfgDfBoolean(),
    _a$5.transports = UNDEFINED_VALUE$1,
    _a$5.retryCodes = UNDEFINED_VALUE$1,
    _a$5));
function _chkSampling(value) {
    return !isNaN(value) && value > 0 && value <= 100;
}
var EnvelopeTypeCreator = (_b$1 = {},
    _b$1[Event$1.dataType] = EventEnvelopeCreator,
    _b$1[Trace.dataType] = TraceEnvelopeCreator,
    _b$1[PageView.dataType] = PageViewEnvelopeCreator,
    _b$1[PageViewPerformance.dataType] = PageViewPerformanceEnvelopeCreator,
    _b$1[Exception.dataType] = ExceptionEnvelopeCreator,
    _b$1[Metric.dataType] = MetricEnvelopeCreator,
    _b$1[RemoteDependencyData.dataType] = DependencyEnvelopeCreator,
    _b$1);
var Sender = /** @class */ (function (_super) {
    __extendsFn(Sender, _super);
    function Sender() {
        var _this = _super.call(this) || this;
        _this.priority = 1001;
        _this.identifier = BreezeChannelIdentifier;
        // Don't set the defaults here, set them in the _initDefaults() as this is also called during unload
        var _consecutiveErrors; // How many times in a row a retryable error condition has occurred.
        var _retryAt; // The time to retry at in milliseconds from 1970/01/01 (this makes the timer calculation easy).
        var _paused; // Flag indicating that the sending should be paused
        var _timeoutHandle; // Handle to the timer for delayed sending of batches of data.
        var _serializer;
        var _stamp_specific_redirects;
        var _headers;
        var _syncFetchPayload = 0; // Keep track of the outstanding sync fetch payload total (as sync fetch has limits)
        var _syncUnloadSender; // The identified sender to use for the synchronous unload stage
        var _offlineListener;
        var _evtNamespace;
        var _endpointUrl;
        var _orgEndpointUrl;
        var _maxBatchSizeInBytes;
        var _beaconSupported;
        var _beaconOnUnloadSupported;
        var _beaconNormalSupported;
        var _customHeaders;
        var _disableTelemetry;
        var _instrumentationKey;
        var _convertUndefined;
        var _isRetryDisabled;
        var _maxBatchInterval;
        var _sessionStorageUsed;
        var _bufferOverrideUsed;
        var _namePrefix;
        var _enableSendPromise;
        var _alwaysUseCustomSend;
        var _disableXhr;
        var _fetchKeepAlive;
        var _xhrSend;
        var _fallbackSend;
        var _disableBeaconSplit;
        var _sendPostMgr;
        var _retryCodes;
        dynamicProto(Sender, _this, function (_self, _base) {
            _initDefaults();
            _self.pause = function () {
                _clearScheduledTimer();
                _paused = true;
            };
            _self.resume = function () {
                if (_paused) {
                    _paused = false;
                    _retryAt = null;
                    // flush if we have exceeded the max-size already
                    _checkMaxSize();
                    _setupTimer();
                }
            };
            _self.flush = function (isAsync, callBack, sendReason) {
                if (isAsync === void 0) { isAsync = true; }
                if (!_paused) {
                    // Clear the normal schedule timer as we are going to try and flush ASAP
                    _clearScheduledTimer();
                    try {
                        return _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */](isAsync, null, sendReason || 1 /* SendRequestReason.ManualFlush */);
                    }
                    catch (e) {
                        _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 22 /* _eInternalMessageId.FlushFailed */, "flush failed, telemetry will not be collected: " + getExceptionName(e), { exception: dumpObj$2(e) });
                    }
                }
            };
            _self.onunloadFlush = function () {
                if (!_paused) {
                    if (_beaconSupported || _alwaysUseCustomSend) {
                        try {
                            return _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */](true, _doUnloadSend, 2 /* SendRequestReason.Unload */);
                        }
                        catch (e) {
                            _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 20 /* _eInternalMessageId.FailedToSendQueuedTelemetry */, "failed to flush with beacon sender on page unload, telemetry will not be collected: " + getExceptionName(e), { exception: dumpObj$2(e) });
                        }
                    }
                    else {
                        _self.flush(false);
                    }
                }
            };
            _self.addHeader = function (name, value) {
                _headers[name] = value;
            };
            _self[_DYN_INITIALIZE /* @min:%2einitialize */] = function (config, core, extensions, pluginChain) {
                if (_self.isInitialized()) {
                    _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 28 /* _eInternalMessageId.SenderNotInitialized */, "Sender is already initialized");
                }
                _base[_DYN_INITIALIZE /* @min:%2einitialize */](config, core, extensions, pluginChain);
                var identifier = _self.identifier;
                _serializer = new Serializer(core.logger);
                _consecutiveErrors = 0;
                _retryAt = null;
                _self[_DYN__SENDER /* @min:%2e_sender */] = null;
                _stamp_specific_redirects = 0;
                var diagLog = _self[_DYN_DIAG_LOG /* @min:%2ediagLog */]();
                _evtNamespace = mergeEvtNamespace(createUniqueNamespace("Sender"), core.evtNamespace && core.evtNamespace());
                _offlineListener = createOfflineListener(_evtNamespace);
                // This function will be re-called whenever any referenced configuration is changed
                _self._addHook(onConfigChange(config, function (details) {
                    var config = details.cfg;
                    if (config.storagePrefix) {
                        utlSetStoragePrefix(config.storagePrefix);
                    }
                    var ctx = createProcessTelemetryContext(null, config, core);
                    var senderConfig = ctx.getExtCfg(identifier, defaultAppInsightsChannelConfig);
                    objDefine$1(_self, "_senderConfig", {
                        g: function () {
                            return senderConfig;
                        }
                    });
                    // Only update the endpoint if the original config !== the current config
                    // This is so any redirect endpointUrl is not overwritten
                    if (_orgEndpointUrl !== senderConfig.endpointUrl) {
                        _endpointUrl = _orgEndpointUrl = senderConfig.endpointUrl;
                    }
                    if (_customHeaders && _customHeaders !== senderConfig[_DYN_CUSTOM_HEADERS /* @min:%2ecustomHeaders */]) {
                        // Removing any previously defined custom headers as they have changed
                        arrForEach$1(_customHeaders, function (customHeader) {
                            delete _headers[customHeader.header];
                        });
                    }
                    _maxBatchSizeInBytes = senderConfig[_DYN_MAX_BATCH_SIZE_IN_BY1 /* @min:%2emaxBatchSizeInBytes */];
                    _beaconSupported = (senderConfig[_DYN_ONUNLOAD_DISABLE_BEA2 /* @min:%2eonunloadDisableBeacon */] === false || senderConfig[_DYN_IS_BEACON_API_DISABL3 /* @min:%2eisBeaconApiDisabled */] === false) && isBeaconsSupported();
                    _beaconOnUnloadSupported = senderConfig[_DYN_ONUNLOAD_DISABLE_BEA2 /* @min:%2eonunloadDisableBeacon */] === false && isBeaconsSupported();
                    _beaconNormalSupported = senderConfig[_DYN_IS_BEACON_API_DISABL3 /* @min:%2eisBeaconApiDisabled */] === false && isBeaconsSupported();
                    _alwaysUseCustomSend = senderConfig[_DYN_ALWAYS_USE_XHR_OVERR4 /* @min:%2ealwaysUseXhrOverride */];
                    _disableXhr = !!senderConfig[_DYN_DISABLE_XHR /* @min:%2edisableXhr */];
                    _retryCodes = senderConfig.retryCodes;
                    var bufferOverride = senderConfig[_DYN_BUFFER_OVERRIDE /* @min:%2ebufferOverride */];
                    var canUseSessionStorage = !!senderConfig[_DYN_ENABLE_SESSION_STORA5 /* @min:%2eenableSessionStorageBuffer */] &&
                        (!!bufferOverride || utlCanUseSessionStorage());
                    var namePrefix = senderConfig.namePrefix;
                    //Note: emitLineDelimitedJson and eventsLimitInMem is directly accessed via config in senderBuffer
                    //Therefore, if canUseSessionStorage is not changed, we do not need to re initialize a new one
                    var shouldUpdate = (canUseSessionStorage !== _sessionStorageUsed)
                        || (canUseSessionStorage && (_namePrefix !== namePrefix)) // prefixName is only used in session storage
                        || (canUseSessionStorage && (_bufferOverrideUsed !== bufferOverride));
                    if (_self[_DYN__BUFFER /* @min:%2e_buffer */]) {
                        // case1 (Pre and Now enableSessionStorageBuffer settings are same)
                        // if namePrefix changes, transfer current buffer to new buffer
                        // else no action needed
                        //case2 (Pre and Now enableSessionStorageBuffer settings are changed)
                        // transfer current buffer to new buffer
                        if (shouldUpdate) {
                            try {
                                _self._buffer = _self._buffer[_DYN_CREATE_NEW /* @min:%2ecreateNew */](diagLog, senderConfig, canUseSessionStorage);
                            }
                            catch (e) {
                                _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 12 /* _eInternalMessageId.FailedAddingTelemetryToBuffer */, "failed to transfer telemetry to different buffer storage, telemetry will be lost: " + getExceptionName(e), { exception: dumpObj$2(e) });
                            }
                        }
                        _checkMaxSize();
                    }
                    else {
                        _self[_DYN__BUFFER /* @min:%2e_buffer */] = canUseSessionStorage
                            ? new SessionStorageSendBuffer(diagLog, senderConfig) : new ArraySendBuffer(diagLog, senderConfig);
                    }
                    _namePrefix = namePrefix;
                    _sessionStorageUsed = canUseSessionStorage;
                    _bufferOverrideUsed = bufferOverride;
                    _fetchKeepAlive = !senderConfig[_DYN_ONUNLOAD_DISABLE_FET6 /* @min:%2eonunloadDisableFetch */] && isFetchSupported(true);
                    _disableBeaconSplit = !!senderConfig[_DYN_DISABLE_SEND_BEACON_7 /* @min:%2edisableSendBeaconSplit */];
                    _self._sample = new Sample(senderConfig.samplingPercentage, diagLog);
                    _instrumentationKey = senderConfig[_DYN_INSTRUMENTATION_KEY$1 /* @min:%2einstrumentationKey */];
                    if (!_validateInstrumentationKey(_instrumentationKey, config)) {
                        _throwInternal(diagLog, 1 /* eLoggingSeverity.CRITICAL */, 100 /* _eInternalMessageId.InvalidInstrumentationKey */, "Invalid Instrumentation key " + _instrumentationKey);
                    }
                    _customHeaders = senderConfig[_DYN_CUSTOM_HEADERS /* @min:%2ecustomHeaders */];
                    if (!isInternalApplicationInsightsEndpoint(_endpointUrl) && _customHeaders && _customHeaders[_DYN_LENGTH$2 /* @min:%2elength */] > 0) {
                        arrForEach$1(_customHeaders, function (customHeader) {
                            _this.addHeader(customHeader.header, customHeader.value);
                        });
                    }
                    else {
                        _customHeaders = null;
                    }
                    _enableSendPromise = senderConfig[_DYN_ENABLE_SEND_PROMISE /* @min:%2eenableSendPromise */];
                    var sendPostConfig = _getSendPostMgrConfig();
                    // only init it once
                    if (!_sendPostMgr) {
                        _sendPostMgr = new SenderPostManager();
                        _sendPostMgr[_DYN_INITIALIZE /* @min:%2einitialize */](sendPostConfig, diagLog);
                    }
                    else {
                        _sendPostMgr.SetConfig(sendPostConfig);
                    }
                    var customInterface = senderConfig.httpXHROverride;
                    var httpInterface = null;
                    var syncInterface = null;
                    // User requested transport(s) values > Beacon > Fetch > XHR
                    // Beacon would be filtered out if user has set disableBeaconApi to true at _getSenderInterface
                    var theTransports = prependTransports([3 /* TransportType.Beacon */, 1 /* TransportType.Xhr */, 2 /* TransportType.Fetch */], senderConfig.transports);
                    httpInterface = _sendPostMgr && _sendPostMgr[_DYN_GET_SENDER_INST /* @min:%2egetSenderInst */](theTransports, false);
                    var xhrInterface = _sendPostMgr && _sendPostMgr.getFallbackInst();
                    _xhrSend = function (payload, isAsync) {
                        return _doSend(xhrInterface, payload, isAsync);
                    };
                    _fallbackSend = function (payload, isAsync) {
                        return _doSend(xhrInterface, payload, isAsync, false);
                    };
                    httpInterface = _alwaysUseCustomSend ? customInterface : (httpInterface || customInterface || xhrInterface);
                    _self[_DYN__SENDER /* @min:%2e_sender */] = function (payload, isAsync) {
                        return _doSend(httpInterface, payload, isAsync);
                    };
                    if (_fetchKeepAlive) {
                        // Try and use the fetch with keepalive
                        _syncUnloadSender = _fetchKeepAliveSender;
                    }
                    var syncTransports = prependTransports([3 /* TransportType.Beacon */, 1 /* TransportType.Xhr */], senderConfig[_DYN_UNLOAD_TRANSPORTS /* @min:%2eunloadTransports */]);
                    if (!_fetchKeepAlive) {
                        // remove fetch from theTransports
                        syncTransports = syncTransports.filter(function (transport) { return transport !== 2 /* TransportType.Fetch */; });
                    }
                    syncInterface = _sendPostMgr && _sendPostMgr[_DYN_GET_SENDER_INST /* @min:%2egetSenderInst */](syncTransports, true);
                    syncInterface = _alwaysUseCustomSend ? customInterface : (syncInterface || customInterface);
                    if ((_alwaysUseCustomSend || senderConfig[_DYN_UNLOAD_TRANSPORTS /* @min:%2eunloadTransports */] || !_syncUnloadSender) && syncInterface) {
                        _syncUnloadSender = function (payload, isAsync) {
                            return _doSend(syncInterface, payload, isAsync);
                        };
                    }
                    if (!_syncUnloadSender) {
                        _syncUnloadSender = _xhrSend;
                    }
                    _disableTelemetry = senderConfig.disableTelemetry;
                    _convertUndefined = senderConfig[_DYN_CONVERT_UNDEFINED /* @min:%2econvertUndefined */] || UNDEFINED_VALUE$1;
                    _isRetryDisabled = senderConfig.isRetryDisabled;
                    _maxBatchInterval = senderConfig[_DYN_MAX_BATCH_INTERVAL /* @min:%2emaxBatchInterval */];
                }));
            };
            _self.processTelemetry = function (telemetryItem, itemCtx) {
                itemCtx = _self._getTelCtx(itemCtx);
                var diagLogger = itemCtx[_DYN_DIAG_LOG /* @min:%2ediagLog */]();
                try {
                    var isValidate = _validate(telemetryItem, diagLogger);
                    if (!isValidate) {
                        return;
                    }
                    var aiEnvelope = _getEnvelope(telemetryItem, diagLogger);
                    if (!aiEnvelope) {
                        return;
                    }
                    // check if the incoming payload is too large, truncate if necessary
                    var payload = _serializer[_DYN_SERIALIZE /* @min:%2eserialize */](aiEnvelope);
                    // flush if we would exceed the max-size limit by adding this item
                    var buffer = _self[_DYN__BUFFER /* @min:%2e_buffer */];
                    _checkMaxSize(payload);
                    // enqueue the payload
                    buffer[_DYN_ENQUEUE /* @min:%2eenqueue */](payload);
                    // ensure an invocation timeout is set
                    _setupTimer();
                }
                catch (e) {
                    _throwInternal(diagLogger, 2 /* eLoggingSeverity.WARNING */, 12 /* _eInternalMessageId.FailedAddingTelemetryToBuffer */, "Failed adding telemetry to the sender's buffer, some telemetry will be lost: " + getExceptionName(e), { exception: dumpObj$2(e) });
                }
                // hand off the telemetry item to the next plugin
                _self.processNext(telemetryItem, itemCtx);
            };
            _self.isCompletelyIdle = function () {
                return !_paused && _syncFetchPayload === 0 && _self._buffer[_DYN_COUNT /* @min:%2ecount */]() === 0;
            };
            /**
             * xhr state changes
             */
            _self._xhrReadyStateChange = function (xhr, payload, countOfItemsInPayload) {
                return _xhrReadyStateChange(xhr, payload, countOfItemsInPayload);
            };
            /**
             * Immediately send buffered data
             * @param async - {boolean} - Indicates if the events should be sent asynchronously
             * @param forcedSender - {SenderFunction} - Indicates the forcedSender, undefined if not passed
             */
            _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */] = function (async, forcedSender, sendReason) {
                if (async === void 0) { async = true; }
                var result;
                if (!_paused) {
                    try {
                        var buffer = _self[_DYN__BUFFER /* @min:%2e_buffer */];
                        // Send data only if disableTelemetry is false
                        if (!_disableTelemetry) {
                            if (buffer[_DYN_COUNT /* @min:%2ecount */]() > 0) {
                                var payload = buffer.getItems();
                                _notifySendRequest(sendReason || 0 /* SendRequestReason.Undefined */, async);
                                // invoke send
                                if (forcedSender) {
                                    result = forcedSender.call(_self, payload, async);
                                }
                                else {
                                    result = _self[_DYN__SENDER /* @min:%2e_sender */](payload, async);
                                }
                            }
                        }
                        else {
                            buffer[_DYN_CLEAR /* @min:%2eclear */]();
                        }
                        _clearScheduledTimer();
                    }
                    catch (e) {
                        /* Ignore this error for IE under v10 */
                        var ieVer = getIEVersion();
                        if (!ieVer || ieVer > 9) {
                            _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 40 /* _eInternalMessageId.TransmissionFailed */, "Telemetry transmission failed, some telemetry will be lost: " + getExceptionName(e), { exception: dumpObj$2(e) });
                        }
                    }
                }
                return result;
            };
            _self.getOfflineSupport = function () {
                var _a;
                return _a = {
                        getUrl: function () {
                            return _endpointUrl;
                        },
                        createPayload: _createPayload
                    },
                    _a[_DYN_SERIALIZE /* @min:serialize */] = _serialize,
                    _a.batch = _batch,
                    _a.shouldProcess = function (evt) {
                        return !!_validate(evt);
                    },
                    _a;
            };
            _self._doTeardown = function (unloadCtx, unloadState) {
                _self.onunloadFlush();
                runTargetUnload(_offlineListener, false);
                _initDefaults();
            };
            /**
             * error handler
             */
            _self[_DYN__ON_ERROR /* @min:%2e_onError */] = function (payload, message, event) {
                _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 26 /* _eInternalMessageId.OnError */, "Failed to send telemetry.", { message: message });
                _self._buffer && _self._buffer[_DYN_CLEAR_SENT /* @min:%2eclearSent */](payload);
            };
            /**
             * partial success handler
             */
            _self[_DYN__ON_PARTIAL_SUCCESS /* @min:%2e_onPartialSuccess */] = function (payload, results) {
                var failed = [];
                var retry = [];
                // Iterate through the reversed array of errors so that splicing doesn't have invalid indexes after the first item.
                var errors = results.errors.reverse();
                for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
                    var error = errors_1[_i];
                    var extracted = payload.splice(error.index, 1)[0];
                    if (_isRetriable(error.statusCode)) {
                        retry[_DYN_PUSH /* @min:%2epush */](extracted);
                    }
                    else {
                        // All other errors, including: 402 (Monthly quota exceeded) and 439 (Too many requests and refresh cache).
                        failed[_DYN_PUSH /* @min:%2epush */](extracted);
                    }
                }
                if (payload[_DYN_LENGTH$2 /* @min:%2elength */] > 0) {
                    _self[_DYN__ON_SUCCESS /* @min:%2e_onSuccess */](payload, results[_DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */]);
                }
                if (failed[_DYN_LENGTH$2 /* @min:%2elength */] > 0) {
                    _self[_DYN__ON_ERROR /* @min:%2e_onError */](failed, formatErrorMessageXhr(null, ["partial success", results[_DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */], "of", results.itemsReceived].join(" ")));
                }
                if (retry[_DYN_LENGTH$2 /* @min:%2elength */] > 0) {
                    _resendPayload(retry);
                    _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, "Partial success. " +
                        "Delivered: " + payload[_DYN_LENGTH$2 /* @min:%2elength */] + ", Failed: " + failed[_DYN_LENGTH$2 /* @min:%2elength */] +
                        ". Will retry to send " + retry[_DYN_LENGTH$2 /* @min:%2elength */] + " our of " + results[_DYN_ITEMS_RECEIVED /* @min:%2eitemsReceived */] + " items");
                }
            };
            /**
             * success handler
             */
            _self[_DYN__ON_SUCCESS /* @min:%2e_onSuccess */] = function (payload, countOfItemsInPayload) {
                _self._buffer && _self._buffer[_DYN_CLEAR_SENT /* @min:%2eclearSent */](payload);
            };
            /**
             * xdr state changes
             */
            _self._xdrOnLoad = function (xdr, payload) {
                return _xdrOnLoad(xdr, payload);
            };
            function _xdrOnLoad(xdr, payload) {
                var responseText = _getResponseText(xdr);
                if (xdr && (responseText + "" === "200" || responseText === "")) {
                    _consecutiveErrors = 0;
                    _self[_DYN__ON_SUCCESS /* @min:%2e_onSuccess */](payload, 0);
                }
                else {
                    var results = parseResponse(responseText);
                    if (results && results.itemsReceived && results.itemsReceived > results[_DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */]
                        && !_isRetryDisabled) {
                        _self[_DYN__ON_PARTIAL_SUCCESS /* @min:%2e_onPartialSuccess */](payload, results);
                    }
                    else {
                        _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, formatErrorMessageXdr(xdr));
                    }
                }
            }
            function _getSendPostMgrConfig() {
                var _a;
                try {
                    var onCompleteFuncs = {
                        xdrOnComplete: function (xdr, oncomplete, payload) {
                            var data = _getPayloadArr(payload);
                            if (!data) {
                                return;
                            }
                            return _xdrOnLoad(xdr, data);
                        },
                        fetchOnComplete: function (response, onComplete, resValue, payload) {
                            var data = _getPayloadArr(payload);
                            if (!data) {
                                return;
                            }
                            return _checkResponsStatus(response.status, data, response.url, data[_DYN_LENGTH$2 /* @min:%2elength */], response.statusText, resValue || "");
                        },
                        xhrOnComplete: function (request, oncomplete, payload) {
                            var data = _getPayloadArr(payload);
                            if (!data) {
                                return;
                            }
                            return _xhrReadyStateChange(request, data, data[_DYN_LENGTH$2 /* @min:%2elength */]);
                        },
                        beaconOnRetry: function (data, onComplete, canSend) {
                            return _onBeaconRetry(data, onComplete, canSend);
                        }
                    };
                    var config = (_a = {},
                        _a[_DYN_ENABLE_SEND_PROMISE /* @min:enableSendPromise */] = _enableSendPromise,
                        _a.isOneDs = false,
                        _a.disableCredentials = false,
                        _a[_DYN_DISABLE_XHR /* @min:disableXhr */] = _disableXhr,
                        _a.disableBeacon = !_beaconNormalSupported,
                        _a.disableBeaconSync = !_beaconOnUnloadSupported,
                        _a.senderOnCompleteCallBack = onCompleteFuncs,
                        _a);
                    return config;
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return null;
            }
            /**
             * xhr state changes
             */
            function _xhrReadyStateChange(xhr, payload, countOfItemsInPayload) {
                if (xhr.readyState === 4) {
                    _checkResponsStatus(xhr.status, payload, xhr.responseURL, countOfItemsInPayload, formatErrorMessageXhr(xhr), _getResponseText(xhr) || xhr.response);
                }
            }
            function _getPayloadArr(payload) {
                try {
                    if (payload) {
                        var internalPayload = payload;
                        var arr = internalPayload[_DYN_ORI_PAYLOAD /* @min:%2eoriPayload */];
                        if (arr && arr[_DYN_LENGTH$2 /* @min:%2elength */]) {
                            return arr;
                        }
                        return null;
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return null;
            }
            function _validate(telemetryItem, diagLogger) {
                if (_disableTelemetry) {
                    // Do not send/save data
                    return false;
                }
                // validate input
                if (!telemetryItem) {
                    diagLogger && _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 7 /* _eInternalMessageId.CannotSendEmptyTelemetry */, "Cannot send empty telemetry");
                    return false;
                }
                // validate event
                if (telemetryItem.baseData && !telemetryItem[_DYN_BASE_TYPE /* @min:%2ebaseType */]) {
                    diagLogger && _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 70 /* _eInternalMessageId.InvalidEvent */, "Cannot send telemetry without baseData and baseType");
                    return false;
                }
                if (!telemetryItem[_DYN_BASE_TYPE /* @min:%2ebaseType */]) {
                    // Default
                    telemetryItem[_DYN_BASE_TYPE /* @min:%2ebaseType */] = "EventData";
                }
                // ensure a sender was constructed
                if (!_self[_DYN__SENDER /* @min:%2e_sender */]) {
                    diagLogger && _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 28 /* _eInternalMessageId.SenderNotInitialized */, "Sender was not initialized");
                    return false;
                }
                // check if this item should be sampled in, else add sampleRate tag
                if (!_isSampledIn(telemetryItem)) {
                    // Item is sampled out, do not send it
                    diagLogger && _throwInternal(diagLogger, 2 /* eLoggingSeverity.WARNING */, 33 /* _eInternalMessageId.TelemetrySampledAndNotSent */, "Telemetry item was sampled out and not sent", { SampleRate: _self._sample[_DYN_SAMPLE_RATE /* @min:%2esampleRate */] });
                    return false;
                }
                else {
                    telemetryItem[SampleRate] = _self._sample[_DYN_SAMPLE_RATE /* @min:%2esampleRate */];
                }
                return true;
            }
            function _getEnvelope(telemetryItem, diagLogger) {
                // construct an envelope that Application Insights endpoint can understand
                // if ikey of telemetry is provided and not empty, envelope will use this iKey instead of senderConfig iKey
                var defaultEnvelopeIkey = telemetryItem.iKey || _instrumentationKey;
                var aiEnvelope = Sender.constructEnvelope(telemetryItem, defaultEnvelopeIkey, diagLogger, _convertUndefined);
                if (!aiEnvelope) {
                    _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 47 /* _eInternalMessageId.CreateEnvelopeError */, "Unable to create an AppInsights envelope");
                    return;
                }
                var doNotSendItem = false;
                // this is for running in legacy mode, where customer may already have a custom initializer present
                if (telemetryItem[_DYN_TAGS /* @min:%2etags */] && telemetryItem[_DYN_TAGS /* @min:%2etags */][ProcessLegacy]) {
                    arrForEach$1(telemetryItem[_DYN_TAGS /* @min:%2etags */][ProcessLegacy], function (callBack) {
                        try {
                            if (callBack && callBack(aiEnvelope) === false) {
                                doNotSendItem = true;
                                _warnToConsole(diagLogger, "Telemetry processor check returns false");
                            }
                        }
                        catch (e) {
                            // log error but dont stop executing rest of the telemetry initializers
                            // doNotSendItem = true;
                            _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 64 /* _eInternalMessageId.TelemetryInitializerFailed */, "One of telemetry initializers failed, telemetry item will not be sent: " + getExceptionName(e), { exception: dumpObj$2(e) }, true);
                        }
                    });
                    delete telemetryItem[_DYN_TAGS /* @min:%2etags */][ProcessLegacy];
                }
                if (doNotSendItem) {
                    return; // do not send, no need to execute next plugin
                }
                return aiEnvelope;
            }
            function _serialize(item) {
                var rlt = EMPTY_STR;
                var diagLogger = _self[_DYN_DIAG_LOG /* @min:%2ediagLog */]();
                try {
                    var valid = _validate(item, diagLogger);
                    var envelope = null;
                    if (valid) {
                        envelope = _getEnvelope(item, diagLogger);
                    }
                    if (envelope) {
                        rlt = _serializer[_DYN_SERIALIZE /* @min:%2eserialize */](envelope);
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return rlt;
            }
            function _batch(arr) {
                var rlt = EMPTY_STR;
                if (arr && arr[_DYN_LENGTH$2 /* @min:%2elength */]) {
                    rlt = "[" + arr.join(",") + "]";
                }
                return rlt;
            }
            function _createPayload(data) {
                var _a;
                var headers = _getHeaders();
                return _a = {
                        urlString: _endpointUrl
                    },
                    _a[_DYN_DATA /* @min:data */] = data,
                    _a.headers = headers,
                    _a;
            }
            function _isSampledIn(envelope) {
                return _self._sample.isSampledIn(envelope);
            }
            function _getOnComplete(payload, status, headers, response) {
                // ***********************************************************************************************
                //TODO: handle other status codes
                if (status === 200 && payload) {
                    _self._onSuccess(payload, payload[_DYN_LENGTH$2 /* @min:%2elength */]);
                }
                else {
                    response && _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, response);
                }
            }
            function _doSend(sendInterface, payload, isAsync, markAsSent) {
                if (markAsSent === void 0) { markAsSent = true; }
                var onComplete = function (status, headers, response) {
                    return _getOnComplete(payload, status, headers, response);
                };
                var payloadData = _getPayload(payload);
                var sendPostFunc = sendInterface && sendInterface.sendPOST;
                if (sendPostFunc && payloadData) {
                    // ***********************************************************************************************
                    // mark payload as sent at the beginning of calling each send function
                    if (markAsSent) {
                        _self._buffer[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */](payload);
                    }
                    return sendPostFunc(payloadData, onComplete, !isAsync);
                }
                return null;
            }
            function _getPayload(payload) {
                var _a;
                if (isArray$1(payload) && payload[_DYN_LENGTH$2 /* @min:%2elength */] > 0) {
                    var batch = _self[_DYN__BUFFER /* @min:%2e_buffer */].batchPayloads(payload);
                    var headers = _getHeaders();
                    var payloadData = (_a = {},
                        _a[_DYN_DATA /* @min:data */] = batch,
                        _a.urlString = _endpointUrl,
                        _a.headers = headers,
                        _a.disableXhrSync = _disableXhr,
                        _a.disableFetchKeepAlive = !_fetchKeepAlive,
                        _a[_DYN_ORI_PAYLOAD /* @min:oriPayload */] = payload,
                        _a);
                    return payloadData;
                }
                return null;
            }
            function _getHeaders() {
                try {
                    var headers = _headers || {};
                    if (isInternalApplicationInsightsEndpoint(_endpointUrl)) {
                        headers[RequestHeaders[6 /* eRequestHeaders.sdkContextHeader */]] = RequestHeaders[7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */];
                    }
                    return headers;
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return null;
            }
            function _checkMaxSize(incomingPayload) {
                var incomingSize = incomingPayload ? incomingPayload[_DYN_LENGTH$2 /* @min:%2elength */] : 0;
                if ((_self[_DYN__BUFFER /* @min:%2e_buffer */].size() + incomingSize) > _maxBatchSizeInBytes) {
                    if (!_offlineListener || _offlineListener.isOnline()) { // only trigger send when currently online
                        _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */](true, null, 10 /* SendRequestReason.MaxBatchSize */);
                    }
                    return true;
                }
                return false;
            }
            function _checkResponsStatus(status, payload, responseUrl, countOfItemsInPayload, errorMessage, res) {
                var response = null;
                if (!_self._appId) {
                    response = parseResponse(res);
                    if (response && response.appId) {
                        _self._appId = response.appId;
                    }
                }
                if ((status < 200 || status >= 300) && status !== 0) {
                    // Update End Point url if permanent redirect or moved permanently
                    // Updates the end point url before retry
                    if (status === 301 || status === 307 || status === 308) {
                        if (!_checkAndUpdateEndPointUrl(responseUrl)) {
                            _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, errorMessage);
                            return;
                        }
                    }
                    if (!_isRetryDisabled && _isRetriable(status)) {
                        _resendPayload(payload);
                        _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " +
                            "Response code " + status + ". Will retry to send " + payload[_DYN_LENGTH$2 /* @min:%2elength */] + " items.");
                    }
                    else {
                        _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, errorMessage);
                    }
                }
                else if (_offlineListener && !_offlineListener.isOnline()) { // offline
                    // Note: Don't check for status == 0, since adblock gives this code
                    if (!_isRetryDisabled) {
                        var offlineBackOffMultiplier = 10; // arbritrary number
                        _resendPayload(payload, offlineBackOffMultiplier);
                        _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". Offline - Response Code: ".concat(status, ". Offline status: ").concat(!_offlineListener.isOnline(), ". Will retry to send ").concat(payload.length, " items."));
                    }
                }
                else {
                    // check if the xhr's responseURL or fetch's response.url is same as endpoint url
                    // TODO after 10 redirects force send telemetry with 'redirect=false' as query parameter.
                    _checkAndUpdateEndPointUrl(responseUrl);
                    if (status === 206) {
                        if (!response) {
                            response = parseResponse(res);
                        }
                        if (response && !_isRetryDisabled) {
                            _self[_DYN__ON_PARTIAL_SUCCESS /* @min:%2e_onPartialSuccess */](payload, response);
                        }
                        else {
                            _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, errorMessage);
                        }
                    }
                    else {
                        _consecutiveErrors = 0;
                        _self[_DYN__ON_SUCCESS /* @min:%2e_onSuccess */](payload, countOfItemsInPayload);
                    }
                }
            }
            function _checkAndUpdateEndPointUrl(responseUrl) {
                // Maximum stamp specific redirects allowed(uncomment this when breeze is ready with not allowing redirects feature)
                if (_stamp_specific_redirects >= 10) {
                    //  _self._senderConfig.endpointUrl = () => Sender._getDefaultAppInsightsChannelConfig().endpointUrl()+"/?redirect=false";
                    //  _stamp_specific_redirects = 0;
                    return false;
                }
                if (!isNullOrUndefined$1(responseUrl) && responseUrl !== "") {
                    if (responseUrl !== _endpointUrl) {
                        _endpointUrl = responseUrl;
                        ++_stamp_specific_redirects;
                        return true;
                    }
                }
                return false;
            }
            function _doUnloadSend(payload, isAsync) {
                if (_syncUnloadSender) {
                    // We are unloading so always call the sender with sync set to false
                    _syncUnloadSender(payload, false);
                }
                else {
                    // Fallback to the previous beacon Sender (which causes a CORB warning on chrome now)
                    var beaconInst = _sendPostMgr && _sendPostMgr[_DYN_GET_SENDER_INST /* @min:%2egetSenderInst */]([3 /* TransportType.Beacon */], true);
                    return _doSend(beaconInst, payload, isAsync);
                }
            }
            function _onBeaconRetry(payload, onComplete, canSend) {
                var internalPayload = payload;
                var data = internalPayload && internalPayload[_DYN_ORI_PAYLOAD /* @min:%2eoriPayload */];
                if (!_disableBeaconSplit) {
                    // Failed to send entire payload so try and split data and try to send as much events as possible
                    var droppedPayload = [];
                    for (var lp = 0; lp < data[_DYN_LENGTH$2 /* @min:%2elength */]; lp++) {
                        var thePayload = data[lp];
                        var arr = [thePayload];
                        var item = _getPayload(arr);
                        if (!canSend(item, onComplete)) {
                            // Can't send anymore, so split the batch and drop the rest
                            droppedPayload[_DYN_PUSH /* @min:%2epush */](thePayload);
                        }
                        else {
                            _self._onSuccess(arr, arr[_DYN_LENGTH$2 /* @min:%2elength */]);
                        }
                    }
                    if (droppedPayload[_DYN_LENGTH$2 /* @min:%2elength */] > 0) {
                        _fallbackSend && _fallbackSend(droppedPayload, true);
                        _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + "Failed to send telemetry with Beacon API, retried with normal sender.");
                    }
                }
                else {
                    _fallbackSend && _fallbackSend(data, true);
                    _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + "Failed to send telemetry with Beacon API, retried with normal sender.");
                }
            }
            function _fetchKeepAliveSender(payload, isAsync) {
                var transport = null;
                if (isArray$1(payload)) {
                    var payloadSize = payload[_DYN_LENGTH$2 /* @min:%2elength */];
                    for (var lp = 0; lp < payload[_DYN_LENGTH$2 /* @min:%2elength */]; lp++) {
                        payloadSize += payload[lp][_DYN_LENGTH$2 /* @min:%2elength */];
                    }
                    var syncFetchPayload = _sendPostMgr.getSyncFetchPayload();
                    if ((syncFetchPayload + payloadSize) <= FetchSyncRequestSizeLimitBytes) {
                        transport = 2 /* TransportType.Fetch */;
                    }
                    else if (isBeaconsSupported()) {
                        // Fallback to beacon sender as we at least get told which events can't be scheduled
                        transport = 3 /* TransportType.Beacon */;
                    }
                    else {
                        // Payload is going to be too big so just try and send via XHR
                        transport = 1 /* TransportType.Xhr */;
                        _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + "Failed to send telemetry with Beacon API, retried with xhrSender.");
                    }
                    var inst = _sendPostMgr && _sendPostMgr[_DYN_GET_SENDER_INST /* @min:%2egetSenderInst */]([transport], true);
                    return _doSend(inst, payload, isAsync);
                }
                return null;
            }
            /**
             * Resend payload. Adds payload back to the send buffer and setup a send timer (with exponential backoff).
             * @param payload
             */
            function _resendPayload(payload, linearFactor) {
                if (linearFactor === void 0) { linearFactor = 1; }
                if (!payload || payload[_DYN_LENGTH$2 /* @min:%2elength */] === 0) {
                    return;
                }
                var buffer = _self[_DYN__BUFFER /* @min:%2e_buffer */];
                buffer[_DYN_CLEAR_SENT /* @min:%2eclearSent */](payload);
                _consecutiveErrors++;
                for (var _i = 0, payload_1 = payload; _i < payload_1.length; _i++) {
                    var item = payload_1[_i];
                    buffer[_DYN_ENQUEUE /* @min:%2eenqueue */](item);
                }
                // setup timer
                _setRetryTime(linearFactor);
                _setupTimer();
            }
            /**
             * Calculates the time to wait before retrying in case of an error based on
             * http://en.wikipedia.org/wiki/Exponential_backoff
             */
            function _setRetryTime(linearFactor) {
                var SlotDelayInSeconds = 10;
                var delayInSeconds;
                if (_consecutiveErrors <= 1) {
                    delayInSeconds = SlotDelayInSeconds;
                }
                else {
                    var backOffSlot = (Math.pow(2, _consecutiveErrors) - 1) / 2;
                    // tslint:disable-next-line:insecure-random
                    var backOffDelay = Math.floor(Math.random() * backOffSlot * SlotDelayInSeconds) + 1;
                    backOffDelay = linearFactor * backOffDelay;
                    delayInSeconds = Math.max(Math.min(backOffDelay, 3600), SlotDelayInSeconds);
                }
                // TODO: Log the backoff time like the C# version does.
                var retryAfterTimeSpan = utcNow() + (delayInSeconds * 1000);
                // TODO: Log the retry at time like the C# version does.
                _retryAt = retryAfterTimeSpan;
            }
            /**
             * Sets up the timer which triggers actually sending the data.
             */
            function _setupTimer() {
                if (!_timeoutHandle && !_paused) {
                    var retryInterval = _retryAt ? Math.max(0, _retryAt - utcNow()) : 0;
                    var timerValue = Math.max(_maxBatchInterval, retryInterval);
                    _timeoutHandle = scheduleTimeout$1(function () {
                        _timeoutHandle = null;
                        _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */](true, null, 1 /* SendRequestReason.NormalSchedule */);
                    }, timerValue);
                }
            }
            function _clearScheduledTimer() {
                _timeoutHandle && _timeoutHandle.cancel();
                _timeoutHandle = null;
                _retryAt = null;
            }
            /**
             * Checks if the SDK should resend the payload after receiving this status code from the backend.
             * @param statusCode
             */
            function _isRetriable(statusCode) {
                // retryCodes = [] means should not retry
                if (!isNullOrUndefined$1(_retryCodes)) {
                    return _retryCodes[_DYN_LENGTH$2 /* @min:%2elength */] && _retryCodes.indexOf(statusCode) > -1;
                }
                return statusCode === 401 // Unauthorized
                    // Removing as private links can return a 403 which causes excessive retries and session storage usage
                    // || statusCode === 403 // Forbidden
                    || statusCode === 408 // Timeout
                    || statusCode === 429 // Too many requests.
                    || statusCode === 500 // Internal server error.
                    || statusCode === 502 // Bad Gateway.
                    || statusCode === 503 // Service unavailable.
                    || statusCode === 504; // Gateway timeout.
            }
            // Using function lookups for backward compatibility as the getNotifyMgr() did not exist until after v2.5.6
            function _getNotifyMgr() {
                var func = "getNotifyMgr";
                if (_self.core[func]) {
                    return _self.core[func]();
                }
                // using _self.core['_notificationManager'] for backward compatibility
                return _self.core["_notificationManager"];
            }
            function _notifySendRequest(sendRequest, isAsync) {
                var manager = _getNotifyMgr();
                if (manager && manager[_DYN_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */]) {
                    try {
                        manager[_DYN_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */](sendRequest, isAsync);
                    }
                    catch (e) {
                        _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 74 /* _eInternalMessageId.NotificationException */, "send request notification failed: " + getExceptionName(e), { exception: dumpObj$2(e) });
                    }
                }
            }
            /**
             * Validate UUID Format
             * Specs taken from https://tools.ietf.org/html/rfc4122 and breeze repo
             */
            function _validateInstrumentationKey(instrumentationKey, config) {
                var disableValidation = config.disableInstrumentationKeyValidation;
                var disableIKeyValidationFlag = isNullOrUndefined$1(disableValidation) ? false : disableValidation;
                if (disableIKeyValidationFlag) {
                    return true;
                }
                var UUID_Regex = "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$";
                var regexp = new RegExp(UUID_Regex);
                return regexp.test(instrumentationKey);
            }
            function _initDefaults() {
                _self[_DYN__SENDER /* @min:%2e_sender */] = null;
                _self[_DYN__BUFFER /* @min:%2e_buffer */] = null;
                _self._appId = null;
                _self._sample = null;
                _headers = {};
                _offlineListener = null;
                _consecutiveErrors = 0;
                _retryAt = null;
                _paused = false;
                _timeoutHandle = null;
                _serializer = null;
                _stamp_specific_redirects = 0;
                _syncFetchPayload = 0;
                _syncUnloadSender = null;
                _evtNamespace = null;
                _endpointUrl = null;
                _orgEndpointUrl = null;
                _maxBatchSizeInBytes = 0;
                _beaconSupported = false;
                _customHeaders = null;
                _disableTelemetry = false;
                _instrumentationKey = null;
                _convertUndefined = UNDEFINED_VALUE$1;
                _isRetryDisabled = false;
                _sessionStorageUsed = null;
                _namePrefix = UNDEFINED_VALUE$1;
                _disableXhr = false;
                _fetchKeepAlive = false;
                _disableBeaconSplit = false;
                _xhrSend = null;
                _fallbackSend = null;
                _sendPostMgr = null;
                objDefine$1(_self, "_senderConfig", {
                    g: function () {
                        return objExtend({}, defaultAppInsightsChannelConfig);
                    }
                });
            }
        });
        return _this;
    }
    Sender.constructEnvelope = function (orig, iKey, logger, convertUndefined) {
        var envelope;
        if (iKey !== orig.iKey && !isNullOrUndefined$1(iKey)) {
            envelope = __assignFn(__assignFn({}, orig), { iKey: iKey });
        }
        else {
            envelope = orig;
        }
        var creator = EnvelopeTypeCreator[envelope.baseType] || EventEnvelopeCreator;
        return creator(logger, envelope, convertUndefined);
    };
// Removed Stub for Sender.prototype.pause.
// Removed Stub for Sender.prototype.resume.
// Removed Stub for Sender.prototype.flush.
// Removed Stub for Sender.prototype.onunloadFlush.
// Removed Stub for Sender.prototype.initialize.
// Removed Stub for Sender.prototype.processTelemetry.
// Removed Stub for Sender.prototype._xhrReadyStateChange.
// Removed Stub for Sender.prototype.triggerSend.
// Removed Stub for Sender.prototype._onError.
// Removed Stub for Sender.prototype._onPartialSuccess.
// Removed Stub for Sender.prototype._onSuccess.
// Removed Stub for Sender.prototype._xdrOnLoad.
// Removed Stub for Sender.prototype.addHeader.
// Removed Stub for Sender.prototype.isCompletelyIdle.
// Removed Stub for Sender.prototype.getOfflineSupport.
    return Sender;
}(BaseTelemetryPlugin));

/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var STR_DURATION = "duration";
var STR_PROPERTIES = "properties";

/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_REQUEST_URL = "requestUrl"; // Count: 11
var _DYN_INST = "inst"; // Count: 5
var _DYN_LENGTH$1 = "length"; // Count: 10
var _DYN_TRACE_ID = "traceID"; // Count: 9
var _DYN_SPAN_ID = "spanID"; // Count: 8
var _DYN_TRACE_FLAGS = "traceFlags"; // Count: 13
var _DYN_CONTEXT$1 = "context"; // Count: 7
var _DYN_ABORTED = "aborted"; // Count: 7
var _DYN_TRACE_ID0 = "traceId"; // Count: 5
var _DYN_SPAN_ID1 = "spanId"; // Count: 5
var _DYN__ADD_HOOK = "_addHook"; // Count: 4
var _DYN_CORE = "core"; // Count: 8
var _DYN_INCLUDE_CORRELATION_2 = "includeCorrelationHeaders"; // Count: 4
var _DYN_GET_ABSOLUTE_URL = "getAbsoluteUrl"; // Count: 3
var _DYN_HEADERS = "headers"; // Count: 6
var _DYN_REQUEST_HEADERS = "requestHeaders"; // Count: 13
var _DYN_SET_REQUEST_HEADER = "setRequestHeader"; // Count: 3
var _DYN_TRACK_DEPENDENCY_DAT3 = "trackDependencyDataInternal"; // Count: 2
var _DYN_START_TIME = "startTime"; // Count: 6
var _DYN_TO_LOWER_CASE = "toLowerCase"; // Count: 6
var _DYN_ENABLE_REQUEST_HEADE4 = "enableRequestHeaderTracking"; // Count: 3
var _DYN_ENABLE_AJAX_ERROR_ST5 = "enableAjaxErrorStatusText"; // Count: 2
var _DYN_ENABLE_AJAX_PERF_TRA6 = "enableAjaxPerfTracking"; // Count: 2
var _DYN_MAX_AJAX_CALLS_PER_V7 = "maxAjaxCallsPerView"; // Count: 2
var _DYN_EXCLUDE_REQUEST_FROM8 = "excludeRequestFromAutoTrackingPatterns"; // Count: 2
var _DYN_ADD_REQUEST_CONTEXT = "addRequestContext"; // Count: 2
var _DYN_DISABLE_AJAX_TRACKIN9 = "disableAjaxTracking"; // Count: 3
var _DYN_AJAX_PERF_LOOKUP_DEL10 = "ajaxPerfLookupDelay"; // Count: 2
var _DYN_DISABLE_FETCH_TRACKI11 = "disableFetchTracking"; // Count: 2
var _DYN_ENABLE_RESPONSE_HEAD12 = "enableResponseHeaderTracking"; // Count: 2
var _DYN_STATUS = "status"; // Count: 11
var _DYN_STATUS_TEXT = "statusText"; // Count: 9
var _DYN_HEADER_MAP = "headerMap"; // Count: 8
var _DYN_OPEN_DONE = "openDone"; // Count: 3
var _DYN_SEND_DONE = "sendDone"; // Count: 3
var _DYN_REQUEST_SENT_TIME = "requestSentTime"; // Count: 9
var _DYN_ABORT_DONE = "abortDone"; // Count: 3
var _DYN_GET_TRACE_ID = "getTraceId"; // Count: 3
var _DYN_GET_TRACE_FLAGS = "getTraceFlags"; // Count: 3
var _DYN_METHOD = "method"; // Count: 8
var _DYN_ERROR_STATUS_TEXT = "errorStatusText"; // Count: 3
var _DYN_STATE_CHANGE_ATTACHE13 = "stateChangeAttached"; // Count: 2
var _DYN_RESPONSE_TEXT = "responseText"; // Count: 6
var _DYN_RESPONSE_FINISHED_TI14 = "responseFinishedTime"; // Count: 7
var _DYN__CREATE_TRACK_ITEM = "CreateTrackItem"; // Count: 3
var _DYN_RESPONSE = "response"; // Count: 4
var _DYN_GET_ALL_RESPONSE_HEA15 = "getAllResponseHeaders"; // Count: 2
var _DYN_GET_PART_APROPS = "getPartAProps"; // Count: 3
var _DYN_PERF_MARK = "perfMark"; // Count: 4
var _DYN_NAME = "name"; // Count: 6
var _DYN_PERF_TIMING = "perfTiming"; // Count: 3
var _DYN_EXCEPTION = "exception"; // Count: 5
var _DYN_AJAX_DIAGNOSTICS_MES16 = "ajaxDiagnosticsMessage"; // Count: 3
var _DYN_CORRELATION_CONTEXT = "correlationContext"; // Count: 3
var _DYN_AJAX_TOTAL_DURATION = "ajaxTotalDuration"; // Count: 3
var _DYN_EVENT_TRACE_CTX = "eventTraceCtx"; // Count: 3

/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/** @ignore */
function _calcPerfDuration(resourceEntry, start, end) {
    var result = 0;
    var from = resourceEntry[start];
    var to = resourceEntry[end];
    if (from && to) {
        result = dateTimeUtilsDuration(from, to);
    }
    return result;
}
/** @ignore */
function _setPerfDuration(props, name, resourceEntry, start, end) {
    var result = 0;
    var value = _calcPerfDuration(resourceEntry, start, end);
    if (value) {
        result = _setPerfValue(props, name, msToTimeSpan(value));
    }
    return result;
}
/** @ignore */
function _setPerfValue(props, name, value) {
    var strPerf = "ajaxPerf";
    var result = 0;
    if (props && name && value) {
        var perfData = props[strPerf] = (props[strPerf] || {});
        perfData[name] = value;
        result = 1;
    }
    return result;
}
/** @ignore */
function _populatePerfData(ajaxData, dependency) {
    /*
    * https://developer.mozilla.org/en-US/docs/Web/API/Resource_Timing_API/Using_the_Resource_Timing_API
    *  | -startTime
    *  | -redirectStart
    *  |            | -redirectEnd
    *  |            | | -fetchStart
    *  |            | |   | -domainLookupStart
    *  |            | |   |                |- domainLookupEnd
    *  |            | |   |                | | -connectStart
    *  |            | |   |                | |  | -secureConnectionStart
    *  |            | |   |                | |  |        | -connectEnd
    *  |            | |   |                | |  |        | | -requestStart
    *  |            | |   |                | |  |        | |           | | -responseStart
    *  |            | |   |                | |  |        | |           | |            | | -responseEnd
    *  +------------+-+---+----------------+-+--+--------+-+-----------+-+------------+-+
    *  |--redirect--| |---|--domainLookup--| |--connect--| |--request--| |--response--| |
    *  |-------------------networkConnect----------------|
    *  |                                                   |---------sentRequest--------|
    *  |------------------------------------perfTotal-----------------------------------|
    */
    var resourceEntry = ajaxData[_DYN_PERF_TIMING /* @min:%2eperfTiming */];
    var props = dependency[STR_PROPERTIES /* @min:%2eproperties */] || {};
    var propsSet = 0;
    var strName = "name";
    var strStart = "Start";
    var strEnd = "End";
    var strDomainLookup = "domainLookup";
    var strConnect = "connect";
    var strRedirect = "redirect";
    var strRequest = "request";
    var strResponse = "response";
    var strStartTime = "startTime";
    var strDomainLookupStart = strDomainLookup + strStart;
    var strDomainLookupEnd = strDomainLookup + strEnd;
    var strConnectStart = strConnect + strStart;
    var strConnectEnd = strConnect + strEnd;
    var strRequestStart = strRequest + strStart;
    var strRequestEnd = strRequest + strEnd;
    var strResponseStart = strResponse + strStart;
    var strResponseEnd = strResponse + strEnd;
    var strRedirectStart = strRedirect + strStart;
    var strRedirectEnd = strRedirect = strEnd;
    var strTransferSize = "transferSize";
    var strEncodedBodySize = "encodedBodySize";
    var strDecodedBodySize = "decodedBodySize";
    var strServerTiming = "serverTiming";
    if (resourceEntry) {
        // redirect
        propsSet |= _setPerfDuration(props, strRedirect, resourceEntry, strRedirectStart, strRedirectEnd);
        // domainLookup
        propsSet |= _setPerfDuration(props, strDomainLookup, resourceEntry, strDomainLookupStart, strDomainLookupEnd);
        // connect
        propsSet |= _setPerfDuration(props, strConnect, resourceEntry, strConnectStart, strConnectEnd);
        // request
        propsSet |= _setPerfDuration(props, strRequest, resourceEntry, strRequestStart, strRequestEnd);
        // response
        propsSet |= _setPerfDuration(props, strResponse, resourceEntry, strResponseStart, strResponseEnd);
        // Network connection time
        propsSet |= _setPerfDuration(props, "networkConnect", resourceEntry, strStartTime, strConnectEnd);
        // Sent Request
        propsSet |= _setPerfDuration(props, "sentRequest", resourceEntry, strRequestStart, strResponseEnd);
        // PerfTotal / Duration
        var duration = resourceEntry[STR_DURATION /* @min:%2eduration */];
        if (!duration) {
            duration = _calcPerfDuration(resourceEntry, strStartTime, strResponseEnd) || 0;
        }
        propsSet |= _setPerfValue(props, STR_DURATION, duration);
        propsSet |= _setPerfValue(props, "perfTotal", duration);
        var serverTiming = resourceEntry[strServerTiming];
        if (serverTiming) {
            var server_1 = {};
            arrForEach$1(serverTiming, function (value, idx) {
                var name = normalizeJsName(value[strName] || "" + idx);
                var newValue = server_1[name] || {};
                objForEachKey$1(value, function (key, val) {
                    if (key !== strName && isString$2(val) || isNumber$2(val)) {
                        if (newValue[key]) {
                            val = newValue[key] + ";" + val;
                        }
                        if (val || !isString$2(val)) {
                            // Only set the value if it has a value and it's not an empty string
                            newValue[key] = val;
                        }
                    }
                });
                server_1[name] = newValue;
            });
            propsSet |= _setPerfValue(props, strServerTiming, server_1);
        }
        propsSet |= _setPerfValue(props, strTransferSize, resourceEntry[strTransferSize]);
        propsSet |= _setPerfValue(props, strEncodedBodySize, resourceEntry[strEncodedBodySize]);
        propsSet |= _setPerfValue(props, strDecodedBodySize, resourceEntry[strDecodedBodySize]);
    }
    else {
        if (ajaxData[_DYN_PERF_MARK /* @min:%2eperfMark */]) {
            propsSet |= _setPerfValue(props, "missing", ajaxData.perfAttempts);
        }
    }
    if (propsSet) {
        dependency[STR_PROPERTIES /* @min:%2eproperties */] = props;
    }
}
var XHRMonitoringState = /** @class */ (function () {
    function XHRMonitoringState() {
        var self = this;
        self[_DYN_OPEN_DONE /* @min:%2eopenDone */] = false;
        self.setRequestHeaderDone = false;
        self[_DYN_SEND_DONE /* @min:%2esendDone */] = false;
        self[_DYN_ABORT_DONE /* @min:%2eabortDone */] = false;
        // <summary>True, if onreadyStateChangeCallback function attached to xhr, otherwise false</summary>
        self[_DYN_STATE_CHANGE_ATTACHE13 /* @min:%2estateChangeAttached */] = false;
    }
    return XHRMonitoringState;
}());
var ajaxRecord = /** @class */ (function () {
    function ajaxRecord(traceId, spanId, logger, traceCtx) {
        var _a;
        var self = this;
        var _logger = logger;
        var strResponseText = "responseText";
        // Assigning the initial/default values within the constructor to avoid typescript from creating a bunch of
        // this.XXXX = null
        self[_DYN_PERF_MARK /* @min:%2eperfMark */] = null;
        self.completed = false;
        self.requestHeadersSize = null;
        self[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */] = null;
        self.responseReceivingDuration = null;
        self.callbackDuration = null;
        self[_DYN_AJAX_TOTAL_DURATION /* @min:%2eajaxTotalDuration */] = null;
        self[_DYN_ABORTED /* @min:%2eaborted */] = 0;
        self.pageUrl = null;
        self[_DYN_REQUEST_URL /* @min:%2erequestUrl */] = null;
        self.requestSize = 0;
        self[_DYN_METHOD /* @min:%2emethod */] = null;
        self[_DYN_STATUS /* @min:%2estatus */] = null;
        self[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */] = null;
        self.responseStartedTime = null;
        self[_DYN_RESPONSE_FINISHED_TI14 /* @min:%2eresponseFinishedTime */] = null;
        self.callbackFinishedTime = null;
        self.endTime = null;
        self.xhrMonitoringState = new XHRMonitoringState();
        self.clientFailure = 0;
        self[_DYN_TRACE_ID /* @min:%2etraceID */] = traceId;
        self[_DYN_SPAN_ID /* @min:%2espanID */] = spanId;
        self[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = traceCtx === null || traceCtx === void 0 ? void 0 : traceCtx.getTraceFlags();
        if (traceCtx) {
            self[_DYN_EVENT_TRACE_CTX /* @min:%2eeventTraceCtx */] = (_a = {},
                _a[_DYN_TRACE_ID0 /* @min:traceId */] = traceCtx[_DYN_GET_TRACE_ID /* @min:%2egetTraceId */](),
                _a[_DYN_SPAN_ID1 /* @min:spanId */] = traceCtx.getSpanId(),
                _a[_DYN_TRACE_FLAGS /* @min:traceFlags */] = traceCtx[_DYN_GET_TRACE_FLAGS /* @min:%2egetTraceFlags */](),
                _a);
        }
        else {
            self[_DYN_EVENT_TRACE_CTX /* @min:%2eeventTraceCtx */] = null;
        }
        dynamicProto(ajaxRecord, self, function (self) {
            self.getAbsoluteUrl = function () {
                return self[_DYN_REQUEST_URL /* @min:%2erequestUrl */] ? urlGetAbsoluteUrl(self[_DYN_REQUEST_URL /* @min:%2erequestUrl */]) : null;
            };
            self.getPathName = function () {
                return self[_DYN_REQUEST_URL /* @min:%2erequestUrl */] ? dataSanitizeUrl(_logger, urlGetCompleteUrl(self[_DYN_METHOD /* @min:%2emethod */], self[_DYN_REQUEST_URL /* @min:%2erequestUrl */])) : null;
            };
            self[_DYN__CREATE_TRACK_ITEM /* @min:%2eCreateTrackItem */] = function (ajaxType, enableRequestHeaderTracking, getResponse) {
                var _a;
                // round to 3 decimal points
                self.ajaxTotalDuration = Math.round(dateTimeUtilsDuration(self.requestSentTime, self.responseFinishedTime) * 1000) / 1000;
                if (self[_DYN_AJAX_TOTAL_DURATION /* @min:%2eajaxTotalDuration */] < 0) {
                    return null;
                }
                var dependency = (_a = {
                        id: "|" + self[_DYN_TRACE_ID /* @min:%2etraceID */] + "." + self[_DYN_SPAN_ID /* @min:%2espanID */],
                        target: self[_DYN_GET_ABSOLUTE_URL /* @min:%2egetAbsoluteUrl */]()
                    },
                    _a[_DYN_NAME /* @min:name */] = self.getPathName(),
                    _a.type = ajaxType,
                    _a[_DYN_START_TIME /* @min:startTime */] = null,
                    _a.duration = self[_DYN_AJAX_TOTAL_DURATION /* @min:%2eajaxTotalDuration */],
                    _a.success = (+(self[_DYN_STATUS /* @min:%2estatus */])) >= 200 && (+(self[_DYN_STATUS /* @min:%2estatus */])) < 400,
                    _a.responseCode = (+(self[_DYN_STATUS /* @min:%2estatus */])),
                    _a[STR_PROPERTIES] = { HttpMethod: self[_DYN_METHOD /* @min:%2emethod */] },
                    _a);
                var props = dependency[STR_PROPERTIES];
                if (self[_DYN_ABORTED /* @min:%2eaborted */]) {
                    props[_DYN_ABORTED /* @min:%2eaborted */] = true;
                }
                if (self[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */]) {
                    // Set the correct dependency start time
                    dependency[_DYN_START_TIME /* @min:%2estartTime */] = new Date();
                    dependency[_DYN_START_TIME /* @min:%2estartTime */].setTime(self[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */]);
                }
                // Add Ajax perf details if available
                _populatePerfData(self, dependency);
                if (enableRequestHeaderTracking) {
                    if (objKeys(self.requestHeaders)[_DYN_LENGTH$1 /* @min:%2elength */] > 0) {
                        props[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */] = self[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */];
                    }
                }
                if (getResponse) {
                    var response = getResponse();
                    if (response) {
                        // enrich dependency target with correlation context from the server
                        var correlationContext = response[_DYN_CORRELATION_CONTEXT /* @min:%2ecorrelationContext */];
                        if (correlationContext) {
                            dependency.correlationContext = /* dependency.target + " | " + */ correlationContext;
                        }
                        if (response[_DYN_HEADER_MAP /* @min:%2eheaderMap */]) {
                            if (objKeys(response.headerMap)[_DYN_LENGTH$1 /* @min:%2elength */] > 0) {
                                props.responseHeaders = response[_DYN_HEADER_MAP /* @min:%2eheaderMap */];
                            }
                        }
                        if (self[_DYN_ERROR_STATUS_TEXT /* @min:%2eerrorStatusText */]) {
                            if (self[_DYN_STATUS /* @min:%2estatus */] >= 400) {
                                var responseType = response.type;
                                if (responseType === "" || responseType === "text") {
                                    props.responseText = response.responseText ? response[_DYN_STATUS_TEXT /* @min:%2estatusText */] + " - " + response[strResponseText] : response[_DYN_STATUS_TEXT /* @min:%2estatusText */];
                                }
                                if (responseType === "json") {
                                    props.responseText = response.response ? response[_DYN_STATUS_TEXT /* @min:%2estatusText */] + " - " + JSON.stringify(response[_DYN_RESPONSE /* @min:%2eresponse */]) : response[_DYN_STATUS_TEXT /* @min:%2estatusText */];
                                }
                            }
                            else if (self[_DYN_STATUS /* @min:%2estatus */] === 0) {
                                props.responseText = response[_DYN_STATUS_TEXT /* @min:%2estatusText */] || "";
                            }
                        }
                    }
                }
                return dependency;
            };
            self[_DYN_GET_PART_APROPS /* @min:%2egetPartAProps */] = function () {
                var _a;
                var partA = null;
                var traceCtx = self[_DYN_EVENT_TRACE_CTX /* @min:%2eeventTraceCtx */];
                if (traceCtx && (traceCtx[_DYN_TRACE_ID0 /* @min:%2etraceId */] || traceCtx[_DYN_SPAN_ID1 /* @min:%2espanId */])) {
                    partA = {};
                    var traceExt = partA[Extensions.TraceExt] = (_a = {},
                        _a[_DYN_TRACE_ID /* @min:traceID */] = traceCtx[_DYN_TRACE_ID0 /* @min:%2etraceId */],
                        _a.parentID = traceCtx[_DYN_SPAN_ID1 /* @min:%2espanId */],
                        _a);
                    if (!isNullOrUndefined$1(traceCtx[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */])) {
                        traceExt[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = traceCtx[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */];
                    }
                }
                return partA;
            };
        });
    }
// Removed Stub for ajaxRecord.prototype.getAbsoluteUrl.
// Removed Stub for ajaxRecord.prototype.getPathName.
// Removed Stub for ajaxRecord.prototype.CreateTrackItem.
// Removed Stub for ajaxRecord.prototype.getPartAProps.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    ajaxRecord.__ieDyn=1;

    return ajaxRecord;
}());

/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var _a$4;
var AJAX_MONITOR_PREFIX = "ai.ajxmn.";
var strDiagLog = "diagLog";
var AJAX_DATA_CONTAINER = "_ajaxData";
var STR_FETCH = "fetch";
var ERROR_HEADER = "Failed to monitor XMLHttpRequest";
var ERROR_PREFIX = ", monitoring data for this ajax call ";
var ERROR_POSTFIX = ERROR_PREFIX + "may be incorrect.";
var ERROR_NOT_SENT = ERROR_PREFIX + "won't be sent.";
var CORRELATION_HEADER_ERROR = "Failed to get Request-Context correlation header as it may be not included in the response or not accessible.";
var CUSTOM_REQUEST_CONTEXT_ERROR = "Failed to add custom defined request context as configured call back may missing a null check.";
var FAILED_TO_CALCULATE_DURATION_ERROR = "Failed to calculate the duration of the ";
// Using a global value so that to handle same iKey with multiple app insights instances (mostly for testing)
var _markCount = 0;
/** @Ignore */
function _supportsFetch() {
    var _global = getGlobal$1();
    if (!_global ||
        isNullOrUndefined$1(_global.Request) ||
        isNullOrUndefined$1(_global.Request[strShimPrototype]) ||
        isNullOrUndefined$1(_global[STR_FETCH])) {
        return null;
    }
    return _global[STR_FETCH];
}
/**
 * Determines whether ajax monitoring can be enabled on this document
 * @returns True if Ajax monitoring is supported on this page, otherwise false
 * @ignore
 */
function _supportsAjaxMonitoring(ajaxMonitorInstance, ajaxDataId) {
    var _a, _b;
    var result = false;
    if (isXhrSupported()) {
        var proto = XMLHttpRequest[strShimPrototype];
        result = !isNullOrUndefined$1(proto) &&
            !isNullOrUndefined$1(proto.open) && // eslint-disable-line security/detect-non-literal-fs-filename -- false positive
            !isNullOrUndefined$1(proto.send) &&
            !isNullOrUndefined$1(proto.abort);
    }
    var ieVer = getIEVersion();
    if (ieVer && ieVer < 9) {
        result = false;
    }
    if (result) {
        // Disable if the XmlHttpRequest can't be extended or hooked
        try {
            var xhr = new XMLHttpRequest();
            var xhrData = {
                xh: [],
                i: (_a = {},
                    _a[ajaxDataId] = {},
                    _a)
            };
            xhr[AJAX_DATA_CONTAINER] = xhrData;
            // Check that we can update the prototype
            var theOpen = XMLHttpRequest[strShimPrototype].open;
            XMLHttpRequest[strShimPrototype].open = theOpen;
        }
        catch (e) {
            // We can't decorate the xhr object so disable monitoring
            result = false;
            _throwInternalCritical(ajaxMonitorInstance, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */, "Failed to enable XMLHttpRequest monitoring, extension is not supported", (_b = {},
                _b[_DYN_EXCEPTION /* @min:exception */] = dumpObj$2(e),
                _b));
        }
    }
    return result;
}
/**
 * Internal helper to fetch the SDK instance tracking data for this XHR request
 * @param xhr
 * @param ajaxDataId
 * @returns
 */
var _getAjaxData = function (xhr, ajaxDataId) {
    if (xhr && ajaxDataId && xhr[AJAX_DATA_CONTAINER]) {
        return (xhr[AJAX_DATA_CONTAINER].i || {})[ajaxDataId];
    }
    return null;
};
/**
 * @ignore
 * Internal helper to track the singleton shared tracking headers, so we can attempt to not create headers
 * that might cause an issue if multiple values are populated.
 * @param xhr - The instrumented XHR instance
 */
var _addSharedXhrHeaders = function (xhr, name, value) {
    if (xhr) {
        var headers = (xhr[AJAX_DATA_CONTAINER] || {}).xh;
        if (headers) {
            headers.push({
                n: name,
                v: value
            });
        }
    }
};
var _isHeaderSet = function (xhr, name) {
    var isPresent = false;
    if (xhr) {
        var headers = (xhr[AJAX_DATA_CONTAINER] || {}).xh;
        if (headers) {
            arrForEach$1(headers, function (header) {
                if (header.n === name) {
                    isPresent = true;
                    return -1;
                }
            });
        }
    }
    return isPresent;
};
/** @Ignore */
function _getFailedAjaxDiagnosticsMessage(xhr, ajaxDataId) {
    var result = "";
    try {
        var ajaxData = _getAjaxData(xhr, ajaxDataId);
        if (ajaxData && ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */]) {
            result += "(url: '" + ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */] + "')";
        }
    }
    catch (e) {
        // eslint-disable-next-line no-empty
    }
    return result;
}
/** @ignore */
function _throwInternalCritical(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
    _throwInternal(ajaxMonitorInstance[strDiagLog](), 1 /* eLoggingSeverity.CRITICAL */, msgId, message, properties, isUserAct);
}
/** @ignore */
function _throwInternalWarning(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
    _throwInternal(ajaxMonitorInstance[strDiagLog](), 2 /* eLoggingSeverity.WARNING */, msgId, message, properties, isUserAct);
}
/** @Ignore */
function _createErrorCallbackFunc(ajaxMonitorInstance, internalMessage, message) {
    // tslint:disable-next-line
    return function (callDetails) {
        var _a;
        _throwInternalCritical(ajaxMonitorInstance, internalMessage, message, (_a = {
                ajaxDiagnosticsMessage: _getFailedAjaxDiagnosticsMessage(callDetails[_DYN_INST /* @min:%2einst */], ajaxMonitorInstance._ajaxDataId)
            },
            _a[_DYN_EXCEPTION /* @min:exception */] = dumpObj$2(callDetails.err),
            _a));
    };
}
function _indexOf(value, match) {
    if (value && match) {
        return strIndexOf(value, match);
    }
    return -1;
}
function _addHandler(container, id, theFunc) {
    var theHandler = {
        id: id,
        fn: theFunc
    };
    container.push(theHandler);
    return {
        remove: function () {
            arrForEach$1(container, function (initializer, idx) {
                if (initializer.id === theHandler.id) {
                    container.splice(idx, 1);
                    return -1;
                }
            });
        }
    };
}
function _processDependencyContainer(core, container, details, message) {
    var result = true;
    arrForEach$1(container, function (theFunc, idx) {
        try {
            if (theFunc.fn.call(null, details) === false) {
                result = false;
            }
        }
        catch (e) {
            _throwInternal(core && core.logger, 1 /* eLoggingSeverity.CRITICAL */, 64 /* _eInternalMessageId.TelemetryInitializerFailed */, "Dependency " + message + " [#" + idx + "] failed: " + getExceptionName(e), { exception: dumpObj$2(e) }, true);
        }
    });
    return result;
}
function _processDependencyListeners(listeners, core, ajaxData, xhr, input, init) {
    var _a;
    var initializersCount = listeners[_DYN_LENGTH$1 /* @min:%2elength */];
    if (initializersCount > 0) {
        var details = (_a = {},
            _a[_DYN_CORE /* @min:core */] = core,
            _a.xhr = xhr,
            _a.input = input,
            _a.init = init,
            _a.traceId = ajaxData[_DYN_TRACE_ID /* @min:%2etraceID */],
            _a.spanId = ajaxData[_DYN_SPAN_ID /* @min:%2espanID */],
            _a.traceFlags = ajaxData[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */],
            _a.context = ajaxData[_DYN_CONTEXT$1 /* @min:%2econtext */] || {},
            _a.aborted = !!ajaxData[_DYN_ABORTED /* @min:%2eaborted */],
            _a);
        _processDependencyContainer(core, listeners, details, "listener");
        ajaxData[_DYN_TRACE_ID /* @min:%2etraceID */] = details[_DYN_TRACE_ID0 /* @min:%2etraceId */];
        ajaxData[_DYN_SPAN_ID /* @min:%2espanID */] = details[_DYN_SPAN_ID1 /* @min:%2espanId */];
        ajaxData[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = details[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */];
        ajaxData[_DYN_CONTEXT$1 /* @min:%2econtext */] = details[_DYN_CONTEXT$1 /* @min:%2econtext */];
    }
}
var BLOB_CORE = "*.blob.core.";
var DfltAjaxCorrelationHeaderExDomains = objFreeze$1([
    BLOB_CORE + "windows.net",
    BLOB_CORE + "chinacloudapi.cn",
    BLOB_CORE + "cloudapi.de",
    BLOB_CORE + "usgovcloudapi.net"
]);
var _internalExcludeEndpoints = [
    /https:\/\/[^\/]*(\.pipe\.aria|aria\.pipe|events\.data|collector\.azure)\.[^\/]+\/(OneCollector\/1|Collector\/3)\.0/i
];
var _defaultConfig$1 = objFreeze$1((_a$4 = {},
    _a$4[_DYN_MAX_AJAX_CALLS_PER_V7 /* @min:maxAjaxCallsPerView */] = 500,
    _a$4[_DYN_DISABLE_AJAX_TRACKIN9 /* @min:disableAjaxTracking */] = false,
    _a$4[_DYN_DISABLE_FETCH_TRACKI11 /* @min:disableFetchTracking */] = false,
    _a$4[_DYN_EXCLUDE_REQUEST_FROM8 /* @min:excludeRequestFromAutoTrackingPatterns */] = undefined,
    _a$4.disableCorrelationHeaders = false,
    _a$4.distributedTracingMode = 1 /* eDistributedTracingModes.AI_AND_W3C */,
    _a$4.correlationHeaderExcludedDomains = DfltAjaxCorrelationHeaderExDomains,
    _a$4.correlationHeaderDomains = undefined,
    _a$4.correlationHeaderExcludePatterns = undefined,
    _a$4.appId = undefined,
    _a$4.enableCorsCorrelation = false,
    _a$4[_DYN_ENABLE_REQUEST_HEADE4 /* @min:enableRequestHeaderTracking */] = false,
    _a$4[_DYN_ENABLE_RESPONSE_HEAD12 /* @min:enableResponseHeaderTracking */] = false,
    _a$4[_DYN_ENABLE_AJAX_ERROR_ST5 /* @min:enableAjaxErrorStatusText */] = false,
    _a$4[_DYN_ENABLE_AJAX_PERF_TRA6 /* @min:enableAjaxPerfTracking */] = false,
    _a$4.maxAjaxPerfLookupAttempts = 3,
    _a$4[_DYN_AJAX_PERF_LOOKUP_DEL10 /* @min:ajaxPerfLookupDelay */] = 25,
    _a$4.ignoreHeaders = [
        "Authorization",
        "X-API-Key",
        "WWW-Authenticate"
    ],
    _a$4[_DYN_ADD_REQUEST_CONTEXT /* @min:addRequestContext */] = undefined,
    _a$4.addIntEndpoints = true,
    _a$4));
var AjaxMonitor = /** @class */ (function (_super) {
    __extendsFn(AjaxMonitor, _super);
    function AjaxMonitor() {
        var _this = _super.call(this) || this;
        _this.identifier = AjaxMonitor.identifier;
        _this.priority = 120;
        var _fetchInitialized; // fetch monitoring initialized
        var _xhrInitialized; // XHR monitoring initialized
        var _currentWindowHost;
        var _extensionConfig;
        var _enableRequestHeaderTracking;
        var _enableAjaxErrorStatusText;
        var _trackAjaxAttempts;
        var _context;
        var _isUsingW3CHeaders;
        var _isUsingAIHeaders;
        var _markPrefix;
        var _enableAjaxPerfTracking;
        var _maxAjaxCallsPerView;
        var _enableResponseHeaderTracking;
        var _disabledUrls;
        var _disableAjaxTracking;
        var _disableFetchTracking;
        var _excludeRequestFromAutoTrackingPatterns;
        var _addRequestContext;
        var _evtNamespace;
        var _ajaxDataId;
        var _dependencyHandlerId;
        var _dependencyListeners;
        var _dependencyInitializers;
        var _ignoreHeaders;
        var _maxAjaxPerfLookupAttempts;
        var _ajaxPerfLookupDelay;
        var _distributedTracingMode;
        var _appId;
        var _polyfillInitialized;
        dynamicProto(AjaxMonitor, _this, function (_self, _base) {
            var _addHook = _base[_DYN__ADD_HOOK /* @min:%2e_addHook */];
            _initDefaults();
            _self.initialize = function (config, core, extensions, pluginChain) {
                if (!_self.isInitialized()) {
                    _base.initialize(config, core, extensions, pluginChain);
                    _evtNamespace = mergeEvtNamespace(createUniqueNamespace("ajax"), core && core.evtNamespace && core.evtNamespace());
                    _populateDefaults(config);
                    _instrumentXhr();
                    _instrumentFetch();
                    _populateContext();
                }
            };
            _self._doTeardown = function () {
                _initDefaults();
            };
            _self.trackDependencyData = function (dependency, properties) {
                _reportDependencyInternal(_dependencyInitializers, _self[_DYN_CORE /* @min:%2ecore */], null, dependency, properties);
            };
            _self[_DYN_INCLUDE_CORRELATION_2 /* @min:%2eincludeCorrelationHeaders */] = function (ajaxData, input, init, xhr) {
                // Test Hook to allow the overriding of the location host
                var currentWindowHost = _self["_currentWindowHost"] || _currentWindowHost;
                _processDependencyListeners(_dependencyListeners, _self[_DYN_CORE /* @min:%2ecore */], ajaxData, xhr, input, init);
                if (input || input === "") { // Fetch
                    if (correlationIdCanIncludeCorrelationHeader(_extensionConfig, ajaxData[_DYN_GET_ABSOLUTE_URL /* @min:%2egetAbsoluteUrl */](), currentWindowHost)) {
                        if (!init) {
                            init = {};
                        }
                        // init headers override original request headers
                        // so, if they exist use only them, otherwise use request's because they should have been applied in the first place
                        // not using original request headers will result in them being lost
                        var headers = new Headers(init[_DYN_HEADERS /* @min:%2eheaders */] || (input instanceof Request ? (input[_DYN_HEADERS /* @min:%2eheaders */] || {}) : {}));
                        if (_isUsingAIHeaders) {
                            var id = "|" + ajaxData[_DYN_TRACE_ID /* @min:%2etraceID */] + "." + ajaxData[_DYN_SPAN_ID /* @min:%2espanID */];
                            headers.set(RequestHeaders[3 /* eRequestHeaders.requestIdHeader */], id);
                            if (_enableRequestHeaderTracking) {
                                ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[3 /* eRequestHeaders.requestIdHeader */]] = id;
                            }
                        }
                        var appId = _appId || (_context && _context.appId());
                        if (appId) {
                            headers.set(RequestHeaders[0 /* eRequestHeaders.requestContextHeader */], RequestHeaders[2 /* eRequestHeaders.requestContextAppIdFormat */] + appId);
                            if (_enableRequestHeaderTracking) {
                                ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[0 /* eRequestHeaders.requestContextHeader */]] = RequestHeaders[2 /* eRequestHeaders.requestContextAppIdFormat */] + appId;
                            }
                        }
                        if (_isUsingW3CHeaders) {
                            var traceFlags = ajaxData[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */];
                            if (isNullOrUndefined$1(traceFlags)) {
                                traceFlags = 0x01;
                            }
                            var traceParent = formatTraceParent(createTraceParent(ajaxData[_DYN_TRACE_ID /* @min:%2etraceID */], ajaxData[_DYN_SPAN_ID /* @min:%2espanID */], traceFlags));
                            headers.set(RequestHeaders[4 /* eRequestHeaders.traceParentHeader */], traceParent);
                            if (_enableRequestHeaderTracking) {
                                ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[4 /* eRequestHeaders.traceParentHeader */]] = traceParent;
                            }
                        }
                        init[_DYN_HEADERS /* @min:%2eheaders */] = headers;
                    }
                    return init;
                }
                else if (xhr) { // XHR
                    if (correlationIdCanIncludeCorrelationHeader(_extensionConfig, ajaxData[_DYN_GET_ABSOLUTE_URL /* @min:%2egetAbsoluteUrl */](), currentWindowHost)) {
                        if (_isUsingAIHeaders) {
                            if (!_isHeaderSet(xhr, RequestHeaders[3 /* eRequestHeaders.requestIdHeader */])) {
                                var id = "|" + ajaxData[_DYN_TRACE_ID /* @min:%2etraceID */] + "." + ajaxData[_DYN_SPAN_ID /* @min:%2espanID */];
                                xhr[_DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */](RequestHeaders[3 /* eRequestHeaders.requestIdHeader */], id);
                                if (_enableRequestHeaderTracking) {
                                    ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[3 /* eRequestHeaders.requestIdHeader */]] = id;
                                }
                            }
                            else {
                                _throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */, "Unable to set [" + RequestHeaders[3 /* eRequestHeaders.requestIdHeader */] + "] as it has already been set by another instance");
                            }
                        }
                        var appId = _appId || (_context && _context.appId());
                        if (appId) {
                            if (!_isHeaderSet(xhr, RequestHeaders[0 /* eRequestHeaders.requestContextHeader */])) {
                                xhr[_DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */](RequestHeaders[0 /* eRequestHeaders.requestContextHeader */], RequestHeaders[2 /* eRequestHeaders.requestContextAppIdFormat */] + appId);
                                if (_enableRequestHeaderTracking) {
                                    ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[0 /* eRequestHeaders.requestContextHeader */]] = RequestHeaders[2 /* eRequestHeaders.requestContextAppIdFormat */] + appId;
                                }
                            }
                            else {
                                _throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */, "Unable to set [" + RequestHeaders[0 /* eRequestHeaders.requestContextHeader */] + "] as it has already been set by another instance");
                            }
                        }
                        if (_isUsingW3CHeaders) {
                            var traceFlags = ajaxData[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */];
                            if (isNullOrUndefined$1(traceFlags)) {
                                traceFlags = 0x01;
                            }
                            if (!_isHeaderSet(xhr, RequestHeaders[4 /* eRequestHeaders.traceParentHeader */])) {
                                var traceParent = formatTraceParent(createTraceParent(ajaxData[_DYN_TRACE_ID /* @min:%2etraceID */], ajaxData[_DYN_SPAN_ID /* @min:%2espanID */], traceFlags));
                                xhr[_DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */](RequestHeaders[4 /* eRequestHeaders.traceParentHeader */], traceParent);
                                if (_enableRequestHeaderTracking) {
                                    ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[4 /* eRequestHeaders.traceParentHeader */]] = traceParent;
                                }
                            }
                            else {
                                _throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */, "Unable to set [" + RequestHeaders[4 /* eRequestHeaders.traceParentHeader */] + "] as it has already been set by another instance");
                            }
                        }
                    }
                    return xhr;
                }
                return undefined;
            };
            _self[_DYN_TRACK_DEPENDENCY_DAT3 /* @min:%2etrackDependencyDataInternal */] = function (dependency, properties, systemProperties) {
                if (_maxAjaxCallsPerView === -1 || _trackAjaxAttempts < _maxAjaxCallsPerView) {
                    // Hack since expected format in w3c mode is |abc.def.
                    // Non-w3c format is |abc.def
                    // @todo Remove if better solution is available, e.g. handle in portal
                    if ((_distributedTracingMode === 2 /* eDistributedTracingModes.W3C */
                        || _distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */)
                        && typeof dependency.id === "string" && dependency.id[dependency.id[_DYN_LENGTH$1 /* @min:%2elength */] - 1] !== ".") {
                        dependency.id += ".";
                    }
                    if (isNullOrUndefined$1(dependency[_DYN_START_TIME /* @min:%2estartTime */])) {
                        dependency[_DYN_START_TIME /* @min:%2estartTime */] = new Date();
                    }
                    var item = createTelemetryItem(dependency, RemoteDependencyData.dataType, RemoteDependencyData.envelopeType, _self[strDiagLog](), properties, systemProperties);
                    _self[_DYN_CORE /* @min:%2ecore */].track(item);
                }
                else if (_trackAjaxAttempts === _maxAjaxCallsPerView) {
                    _throwInternalCritical(_self, 55 /* _eInternalMessageId.MaxAjaxPerPVExceeded */, "Maximum ajax per page view limit reached, ajax monitoring is paused until the next trackPageView(). In order to increase the limit set the maxAjaxCallsPerView configuration parameter.", true);
                }
                ++_trackAjaxAttempts;
            };
            _self.addDependencyListener = function (dependencyListener) {
                return _addHandler(_dependencyListeners, _dependencyHandlerId++, dependencyListener);
            };
            _self.addDependencyInitializer = function (dependencyInitializer) {
                return _addHandler(_dependencyInitializers, _dependencyHandlerId++, dependencyInitializer);
            };
            function _initDefaults() {
                var location = getLocation();
                _fetchInitialized = false; // fetch monitoring initialized
                _xhrInitialized = false; // XHR monitoring initialized
                _polyfillInitialized = false; // polyfill monitoring initialized
                _currentWindowHost = location && location.host && location.host[_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
                _extensionConfig = null;
                _enableRequestHeaderTracking = false;
                _enableAjaxErrorStatusText = false;
                _trackAjaxAttempts = 0;
                _context = null;
                _isUsingW3CHeaders = false;
                _isUsingAIHeaders = false;
                _markPrefix = null;
                _enableAjaxPerfTracking = false;
                _maxAjaxCallsPerView = 0;
                _enableResponseHeaderTracking = false;
                _disabledUrls = {};
                _disableAjaxTracking = false;
                _disableFetchTracking = false;
                _excludeRequestFromAutoTrackingPatterns = null;
                _addRequestContext = null;
                _evtNamespace = null;
                _dependencyHandlerId = 0;
                _dependencyListeners = [];
                _dependencyInitializers = [];
                _ajaxDataId = createUniqueNamespace("ajaxData");
                _self._ajaxDataId = _ajaxDataId;
                _ignoreHeaders = null;
                _maxAjaxPerfLookupAttempts = 1;
                _ajaxPerfLookupDelay = 1;
                _distributedTracingMode = 1 /* eDistributedTracingModes.AI_AND_W3C */;
                _appId = null;
            }
            function _populateDefaults(config) {
                _self[_DYN__ADD_HOOK /* @min:%2e_addHook */](onConfigChange(config, function (details) {
                    var config = details.cfg;
                    var ctx = createProcessTelemetryContext(null, config, _self[_DYN_CORE /* @min:%2ecore */]);
                    _extensionConfig = ctx.getExtCfg(AjaxMonitor.identifier, _defaultConfig$1);
                    _distributedTracingMode = _extensionConfig.distributedTracingMode;
                    _enableRequestHeaderTracking = _extensionConfig[_DYN_ENABLE_REQUEST_HEADE4 /* @min:%2eenableRequestHeaderTracking */];
                    _enableAjaxErrorStatusText = _extensionConfig[_DYN_ENABLE_AJAX_ERROR_ST5 /* @min:%2eenableAjaxErrorStatusText */];
                    _enableAjaxPerfTracking = _extensionConfig[_DYN_ENABLE_AJAX_PERF_TRA6 /* @min:%2eenableAjaxPerfTracking */];
                    _maxAjaxCallsPerView = _extensionConfig[_DYN_MAX_AJAX_CALLS_PER_V7 /* @min:%2emaxAjaxCallsPerView */];
                    _excludeRequestFromAutoTrackingPatterns = [].concat(_extensionConfig[_DYN_EXCLUDE_REQUEST_FROM8 /* @min:%2eexcludeRequestFromAutoTrackingPatterns */] || [], _extensionConfig.addIntEndpoints !== false ? _internalExcludeEndpoints : []);
                    _addRequestContext = _extensionConfig[_DYN_ADD_REQUEST_CONTEXT /* @min:%2eaddRequestContext */];
                    _isUsingAIHeaders = _distributedTracingMode === 0 /* eDistributedTracingModes.AI */ || _distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */;
                    _isUsingW3CHeaders = _distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */ || _distributedTracingMode === 2 /* eDistributedTracingModes.W3C */;
                    if (_enableAjaxPerfTracking) {
                        var iKey = config.instrumentationKey || "unkwn";
                        if (iKey[_DYN_LENGTH$1 /* @min:%2elength */] > 5) {
                            _markPrefix = AJAX_MONITOR_PREFIX + strSubstring(iKey, iKey[_DYN_LENGTH$1 /* @min:%2elength */] - 5) + ".";
                        }
                        else {
                            _markPrefix = AJAX_MONITOR_PREFIX + iKey + ".";
                        }
                    }
                    _disableAjaxTracking = !!_extensionConfig[_DYN_DISABLE_AJAX_TRACKIN9 /* @min:%2edisableAjaxTracking */];
                    _maxAjaxPerfLookupAttempts = _extensionConfig.maxAjaxPerfLookupAttempts;
                    _ajaxPerfLookupDelay = _extensionConfig[_DYN_AJAX_PERF_LOOKUP_DEL10 /* @min:%2eajaxPerfLookupDelay */];
                    _ignoreHeaders = _extensionConfig.ignoreHeaders;
                    _appId = _extensionConfig.appId;
                }));
            }
            function _populateContext() {
                var propExt = _self[_DYN_CORE /* @min:%2ecore */].getPlugin(PropertiesPluginIdentifier);
                if (propExt) {
                    _context = propExt.plugin[_DYN_CONTEXT$1 /* @min:%2econtext */]; // we could move IPropertiesPlugin to common as well
                }
            }
            // discard the header if it's defined as ignoreHeaders in ICorrelationConfig
            function _canIncludeHeaders(header) {
                var rlt = true;
                if (header || _ignoreHeaders) {
                    arrForEach$1(_ignoreHeaders, (function (key) {
                        if (key[_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]() === header[_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]()) {
                            rlt = false;
                            return -1;
                        }
                    }));
                }
                return rlt;
            }
            // Fetch Stuff
            function _instrumentFetch() {
                var fetch = _supportsFetch();
                if (!fetch) {
                    return;
                }
                var global = getGlobal$1();
                var isPolyfill = fetch.polyfill;
                _self[_DYN__ADD_HOOK /* @min:%2e_addHook */](onConfigChange(_extensionConfig, function () {
                    _disableFetchTracking = !!_extensionConfig[_DYN_DISABLE_FETCH_TRACKI11 /* @min:%2edisableFetchTracking */];
                    _enableResponseHeaderTracking = _extensionConfig[_DYN_ENABLE_RESPONSE_HEAD12 /* @min:%2eenableResponseHeaderTracking */];
                    if (!_disableFetchTracking && !_fetchInitialized) {
                        _addHook(InstrumentFunc(global, STR_FETCH, {
                            ns: _evtNamespace,
                            // Add request hook
                            req: function (callDetails, input, init) {
                                var fetchData;
                                if (!_disableFetchTracking && _fetchInitialized &&
                                    !_isDisabledRequest(null, input, init) &&
                                    // If we have a polyfil and XHR instrumented then let XHR report otherwise we get duplicates
                                    !(isPolyfill && _xhrInitialized)) {
                                    var ctx = callDetails.ctx();
                                    fetchData = _createFetchRecord(input, init);
                                    var newInit = _self[_DYN_INCLUDE_CORRELATION_2 /* @min:%2eincludeCorrelationHeaders */](fetchData, input, init);
                                    if (newInit !== init) {
                                        callDetails.set(1, newInit);
                                    }
                                    ctx.data = fetchData;
                                }
                            },
                            rsp: function (callDetails, input) {
                                if (!_disableFetchTracking) {
                                    var fetchData_1 = callDetails.ctx().data;
                                    if (fetchData_1) {
                                        // Replace the result with the new promise from this code
                                        callDetails.rslt = callDetails.rslt.then(function (response) {
                                            _reportFetchMetrics(callDetails, (response || {})[_DYN_STATUS /* @min:%2estatus */], input, response, fetchData_1, function () {
                                                var _a;
                                                var ajaxResponse = (_a = {
                                                        statusText: (response || {})[_DYN_STATUS_TEXT /* @min:%2estatusText */]
                                                    },
                                                    _a[_DYN_HEADER_MAP /* @min:headerMap */] = null,
                                                    _a[_DYN_CORRELATION_CONTEXT /* @min:correlationContext */] = _getFetchCorrelationContext(response),
                                                    _a);
                                                if (_enableResponseHeaderTracking && response) {
                                                    var responseHeaderMap_1 = {};
                                                    response.headers.forEach(function (value, name) {
                                                        if (_canIncludeHeaders(name)) {
                                                            responseHeaderMap_1[name] = value;
                                                        }
                                                    });
                                                    ajaxResponse[_DYN_HEADER_MAP /* @min:%2eheaderMap */] = responseHeaderMap_1;
                                                }
                                                return ajaxResponse;
                                            });
                                            return response;
                                        })
                                            .catch(function (reason) {
                                            _reportFetchMetrics(callDetails, 0, input, null, fetchData_1, null, { error: reason.message || dumpObj$2(reason) });
                                            throw reason;
                                        });
                                    }
                                }
                            },
                            // Create an error callback to report any hook errors
                            hkErr: _createErrorCallbackFunc(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */, "Failed to monitor Window.fetch" + ERROR_POSTFIX)
                        }, true, isWebWorker()));
                        _fetchInitialized = true;
                    }
                    else if (isPolyfill && !_polyfillInitialized) {
                        // If fetch is a polyfill we need to capture the request to ensure that we correctly track
                        // disabled request URLS (i.e. internal urls) to ensure we don't end up in a constant loop
                        // of reporting ourselves, for example React Native uses a polyfill for fetch
                        // Note: Polyfill implementations that don't support the "polyfill" tag are not supported
                        // the workaround is to add a polyfill property to your fetch implementation before initializing
                        // App Insights
                        _addHook(InstrumentFunc(global, STR_FETCH, {
                            ns: _evtNamespace,
                            req: function (callDetails, input, init) {
                                // Just call so that we record any disabled URL
                                _isDisabledRequest(null, input, init);
                            }
                        }));
                        _polyfillInitialized = true;
                    }
                }));
                if (isPolyfill) {
                    // retag the instrumented fetch with the same polyfill settings this is mostly for testing
                    // But also supports multiple App Insights usages
                    global[STR_FETCH].polyfill = isPolyfill;
                }
            }
            function _hookProto(target, funcName, callbacks) {
                _addHook(InstrumentProto(target, funcName, callbacks));
            }
            function _instrumentXhr() {
                if (!_supportsAjaxMonitoring(_self, _ajaxDataId)) {
                    return;
                }
                _self[_DYN__ADD_HOOK /* @min:%2e_addHook */](onConfigChange(_extensionConfig, function () {
                    _disableAjaxTracking = !!_extensionConfig[_DYN_DISABLE_AJAX_TRACKIN9 /* @min:%2edisableAjaxTracking */];
                    _enableRequestHeaderTracking = _extensionConfig[_DYN_ENABLE_REQUEST_HEADE4 /* @min:%2eenableRequestHeaderTracking */];
                    if (!_disableAjaxTracking && !_xhrInitialized) {
                        // Instrument open
                        _hookProto(XMLHttpRequest, "open", {
                            ns: _evtNamespace,
                            req: function (callDetails, method, url, async) {
                                if (!_disableAjaxTracking) {
                                    var xhr = callDetails[_DYN_INST /* @min:%2einst */];
                                    var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                                    if (!_isDisabledRequest(xhr, url) && _isMonitoredXhrInstance(xhr, ajaxData, true)) {
                                        if (!ajaxData || !ajaxData.xhrMonitoringState[_DYN_OPEN_DONE /* @min:%2eopenDone */]) {
                                            // Only create a single ajaxData (even when multiple AI instances are running)
                                            ajaxData = _openHandler(xhr, method, url, async);
                                        }
                                        // always attach to the on ready state change (required for handling multiple instances)
                                        _attachToOnReadyStateChange(xhr, ajaxData);
                                    }
                                }
                            },
                            hkErr: _createErrorCallbackFunc(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */, ERROR_HEADER + ".open" + ERROR_POSTFIX)
                        });
                        // Instrument send
                        _hookProto(XMLHttpRequest, "send", {
                            ns: _evtNamespace,
                            req: function (callDetails, context) {
                                if (!_disableAjaxTracking) {
                                    var xhr = callDetails[_DYN_INST /* @min:%2einst */];
                                    var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                                    if (_isMonitoredXhrInstance(xhr, ajaxData) && !ajaxData.xhrMonitoringState[_DYN_SEND_DONE /* @min:%2esendDone */]) {
                                        _createMarkId("xhr", ajaxData);
                                        ajaxData[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */] = dateTimeUtilsNow();
                                        _self[_DYN_INCLUDE_CORRELATION_2 /* @min:%2eincludeCorrelationHeaders */](ajaxData, undefined, undefined, xhr);
                                        ajaxData.xhrMonitoringState[_DYN_SEND_DONE /* @min:%2esendDone */] = true;
                                    }
                                }
                            },
                            hkErr: _createErrorCallbackFunc(_self, 17 /* _eInternalMessageId.FailedMonitorAjaxSend */, ERROR_HEADER + ERROR_POSTFIX)
                        });
                        // Instrument abort
                        _hookProto(XMLHttpRequest, "abort", {
                            ns: _evtNamespace,
                            req: function (callDetails) {
                                if (!_disableAjaxTracking) {
                                    var xhr = callDetails[_DYN_INST /* @min:%2einst */];
                                    var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                                    if (_isMonitoredXhrInstance(xhr, ajaxData) && !ajaxData.xhrMonitoringState[_DYN_ABORT_DONE /* @min:%2eabortDone */]) {
                                        ajaxData[_DYN_ABORTED /* @min:%2eaborted */] = 1;
                                        ajaxData.xhrMonitoringState[_DYN_ABORT_DONE /* @min:%2eabortDone */] = true;
                                    }
                                }
                            },
                            hkErr: _createErrorCallbackFunc(_self, 13 /* _eInternalMessageId.FailedMonitorAjaxAbort */, ERROR_HEADER + ".abort" + ERROR_POSTFIX)
                        });
                        // Instrument setRequestHeader
                        _hookProto(XMLHttpRequest, "setRequestHeader", {
                            ns: _evtNamespace,
                            req: function (callDetails, header, value) {
                                if (!_disableAjaxTracking) {
                                    var xhr = callDetails[_DYN_INST /* @min:%2einst */];
                                    var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                                    if (ajaxData && _isMonitoredXhrInstance(xhr, ajaxData)) {
                                        _addSharedXhrHeaders(xhr, header, value);
                                        if (_enableRequestHeaderTracking && _canIncludeHeaders(header)) {
                                            if (ajaxData) {
                                                ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][header] = value;
                                            }
                                        }
                                    }
                                }
                            },
                            hkErr: _createErrorCallbackFunc(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */, ERROR_HEADER + ".setRequestHeader" + ERROR_POSTFIX)
                        });
                        _xhrInitialized = true;
                    }
                }));
            }
            function _isDisabledRequest(xhr, request, init) {
                var isDisabled = false;
                var theUrl = ((!isString$2(request) ? (request || {}).url || "" : request) || "")[_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
                // check excludeRequestFromAutoTrackingPatterns before stripping off any query string
                arrForEach$1(_excludeRequestFromAutoTrackingPatterns, function (regex) {
                    var theRegex = regex;
                    if (isString$2(regex)) {
                        theRegex = new RegExp(regex);
                    }
                    if (!isDisabled) {
                        isDisabled = theRegex.test(theUrl);
                    }
                });
                // if request url matches with exclude regex pattern, return true and no need to check for headers
                if (isDisabled) {
                    return isDisabled;
                }
                var idx = _indexOf(theUrl, "?");
                var idx2 = _indexOf(theUrl, "#");
                if (idx === -1 || (idx2 !== -1 && idx2 < idx)) {
                    idx = idx2;
                }
                if (idx !== -1) {
                    // Strip off any Query string
                    theUrl = theUrl.substring(0, idx);
                }
                // check that this instance is not not used by ajax call performed inside client side monitoring to send data to collector
                if (!isNullOrUndefined$1(xhr)) {
                    // Look on the XMLHttpRequest of the URL string value
                    isDisabled = xhr[DisabledPropertyName] === true || theUrl[DisabledPropertyName] === true;
                }
                else if (!isNullOrUndefined$1(request)) { // fetch
                    // Look for DisabledPropertyName in either Request or RequestInit
                    isDisabled = (typeof request === "object" ? request[DisabledPropertyName] === true : false) ||
                        (init ? init[DisabledPropertyName] === true : false);
                }
                // Also add extra check just in case the XHR or fetch objects where not decorated with the DisableProperty due to sealing or freezing
                if (!isDisabled && theUrl && isInternalApplicationInsightsEndpoint(theUrl)) {
                    isDisabled = true;
                }
                if (isDisabled) {
                    // Add the disabled url if not present
                    if (!_disabledUrls[theUrl]) {
                        _disabledUrls[theUrl] = 1;
                    }
                }
                else {
                    // Check to see if the url is listed as disabled
                    if (_disabledUrls[theUrl]) {
                        isDisabled = true;
                    }
                }
                return isDisabled;
            }
            /// <summary>Verifies that particular instance of XMLHttpRequest needs to be monitored</summary>
            /// <param name="excludeAjaxDataValidation">Optional parameter. True if ajaxData must be excluded from verification</param>
            /// <returns type="bool">True if instance needs to be monitored, otherwise false</returns>
            function _isMonitoredXhrInstance(xhr, ajaxData, excludeAjaxDataValidation) {
                var ajaxValidation = true;
                var initialized = _xhrInitialized;
                if (!isNullOrUndefined$1(xhr)) {
                    ajaxValidation = excludeAjaxDataValidation === true || !isNullOrUndefined$1(ajaxData);
                }
                // checking to see that all interested functions on xhr were instrumented
                return initialized
                    // checking on ajaxData to see that it was not removed in user code
                    && ajaxValidation;
            }
            function _getDistributedTraceCtx() {
                var distributedTraceCtx = null;
                if (_self[_DYN_CORE /* @min:%2ecore */] && _self[_DYN_CORE /* @min:%2ecore */].getTraceCtx) {
                    distributedTraceCtx = _self[_DYN_CORE /* @min:%2ecore */].getTraceCtx(false);
                }
                // Fall back
                if (!distributedTraceCtx && _context && _context.telemetryTrace) {
                    distributedTraceCtx = createDistributedTraceContextFromTrace(_context.telemetryTrace);
                }
                return distributedTraceCtx;
            }
            function _openHandler(xhr, method, url, async) {
                var _a;
                var distributedTraceCtx = _getDistributedTraceCtx();
                var traceID = (distributedTraceCtx && distributedTraceCtx[_DYN_GET_TRACE_ID /* @min:%2egetTraceId */]()) || generateW3CId();
                var spanID = strSubstr(generateW3CId(), 0, 16);
                var xhrRequestData = xhr[AJAX_DATA_CONTAINER] = (xhr[AJAX_DATA_CONTAINER] || { xh: [], i: {} });
                var ajaxDataCntr = xhrRequestData.i = (xhrRequestData.i || {});
                var ajaxData = ajaxDataCntr[_ajaxDataId] = (ajaxDataCntr[_ajaxDataId] || new ajaxRecord(traceID, spanID, _self[strDiagLog](), (_a = _self.core) === null || _a === void 0 ? void 0 : _a.getTraceCtx()));
                ajaxData[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = distributedTraceCtx && distributedTraceCtx[_DYN_GET_TRACE_FLAGS /* @min:%2egetTraceFlags */]();
                ajaxData[_DYN_METHOD /* @min:%2emethod */] = method;
                ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */] = url;
                ajaxData.xhrMonitoringState[_DYN_OPEN_DONE /* @min:%2eopenDone */] = true;
                ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */] = {};
                ajaxData.async = async;
                ajaxData[_DYN_ERROR_STATUS_TEXT /* @min:%2eerrorStatusText */] = _enableAjaxErrorStatusText;
                return ajaxData;
            }
            function _attachToOnReadyStateChange(xhr, ajaxData) {
                ajaxData.xhrMonitoringState[_DYN_STATE_CHANGE_ATTACHE13 /* @min:%2estateChangeAttached */] = eventOn(xhr, "readystatechange", function () {
                    var _a;
                    try {
                        if (xhr && xhr.readyState === 4 && _isMonitoredXhrInstance(xhr, ajaxData)) {
                            _onAjaxComplete(xhr);
                        }
                    }
                    catch (e) {
                        var exceptionText = dumpObj$2(e);
                        // ignore messages with c00c023f, as this a known IE9 XHR abort issue
                        if (!exceptionText || _indexOf(exceptionText[_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */](), "c00c023f") === -1) {
                            _throwInternalCritical(_self, 16 /* _eInternalMessageId.FailedMonitorAjaxRSC */, ERROR_HEADER + " 'readystatechange' event handler" + ERROR_POSTFIX, (_a = {},
                                _a[_DYN_AJAX_DIAGNOSTICS_MES16 /* @min:ajaxDiagnosticsMessage */] = _getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId),
                                _a[_DYN_EXCEPTION /* @min:exception */] = exceptionText,
                                _a));
                        }
                    }
                }, _evtNamespace);
            }
            function _getResponseText(xhr) {
                try {
                    var responseType = xhr.responseType;
                    if (responseType === "" || responseType === "text") {
                        // As per the specification responseText is only valid if the type is an empty string or "text"
                        return xhr[_DYN_RESPONSE_TEXT /* @min:%2eresponseText */];
                    }
                }
                catch (e) {
                    // This shouldn't happen because of the above check -- but just in case, so just ignore
                }
                return null;
            }
            function _onAjaxComplete(xhr) {
                var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                ajaxData[_DYN_RESPONSE_FINISHED_TI14 /* @min:%2eresponseFinishedTime */] = dateTimeUtilsNow();
                ajaxData[_DYN_STATUS /* @min:%2estatus */] = xhr[_DYN_STATUS /* @min:%2estatus */];
                function _reportXhrError(e, failedProps) {
                    var errorProps = failedProps || {};
                    errorProps["ajaxDiagnosticsMessage"] = _getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId);
                    if (e) {
                        errorProps["exception"] = dumpObj$2(e);
                    }
                    _throwInternalWarning(_self, 14 /* _eInternalMessageId.FailedMonitorAjaxDur */, FAILED_TO_CALCULATE_DURATION_ERROR + "ajax call" + ERROR_NOT_SENT, errorProps);
                }
                _findPerfResourceEntry("xmlhttprequest", ajaxData, function () {
                    try {
                        var dependency = ajaxData[_DYN__CREATE_TRACK_ITEM /* @min:%2eCreateTrackItem */]("Ajax", _enableRequestHeaderTracking, function () {
                            var _a;
                            var ajaxResponse = (_a = {
                                    statusText: xhr[_DYN_STATUS_TEXT /* @min:%2estatusText */]
                                },
                                _a[_DYN_HEADER_MAP /* @min:headerMap */] = null,
                                _a[_DYN_CORRELATION_CONTEXT /* @min:correlationContext */] = _getAjaxCorrelationContext(xhr),
                                _a.type = xhr.responseType,
                                _a[_DYN_RESPONSE_TEXT /* @min:responseText */] = _getResponseText(xhr),
                                _a.response = xhr[_DYN_RESPONSE /* @min:%2eresponse */],
                                _a);
                            if (_enableResponseHeaderTracking) {
                                var headers = xhr[_DYN_GET_ALL_RESPONSE_HEA15 /* @min:%2egetAllResponseHeaders */]();
                                if (headers) {
                                    // xhr.getAllResponseHeaders() method returns all the response headers, separated by CRLF, as a string or null
                                    // the regex converts the header string into an array of individual headers
                                    var arr = strTrim(headers).split(/[\r\n]+/);
                                    var responseHeaderMap_2 = {};
                                    arrForEach$1(arr, function (line) {
                                        var parts = line.split(": ");
                                        var header = parts.shift();
                                        var value = parts.join(": ");
                                        if (_canIncludeHeaders(header)) {
                                            responseHeaderMap_2[header] = value;
                                        }
                                    });
                                    ajaxResponse[_DYN_HEADER_MAP /* @min:%2eheaderMap */] = responseHeaderMap_2;
                                }
                            }
                            return ajaxResponse;
                        });
                        var properties = void 0;
                        try {
                            if (!!_addRequestContext) {
                                properties = _addRequestContext({ status: xhr[_DYN_STATUS /* @min:%2estatus */], xhr: xhr });
                            }
                        }
                        catch (e) {
                            _throwInternalWarning(_self, 104 /* _eInternalMessageId.FailedAddingCustomDefinedRequestContext */, CUSTOM_REQUEST_CONTEXT_ERROR);
                        }
                        if (dependency) {
                            if (properties !== undefined) {
                                dependency[STR_PROPERTIES /* @min:%2eproperties */] = __assignFn(__assignFn({}, dependency.properties), properties);
                            }
                            var sysProperties = ajaxData[_DYN_GET_PART_APROPS /* @min:%2egetPartAProps */]();
                            _reportDependencyInternal(_dependencyInitializers, _self[_DYN_CORE /* @min:%2ecore */], ajaxData, dependency, null, sysProperties);
                        }
                        else {
                            _reportXhrError(null, {
                                requestSentTime: ajaxData[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */],
                                responseFinishedTime: ajaxData[_DYN_RESPONSE_FINISHED_TI14 /* @min:%2eresponseFinishedTime */]
                            });
                        }
                    }
                    finally {
                        // cleanup telemetry data
                        try {
                            var xhrRequestData = (xhr[AJAX_DATA_CONTAINER] || { i: {} });
                            var ajaxDataCntr = (xhrRequestData.i || {});
                            if (ajaxDataCntr[_ajaxDataId]) {
                                ajaxDataCntr[_ajaxDataId] = null;
                            }
                        }
                        catch (e) {
                            // May throw in environments that prevent extension or freeze xhr
                        }
                    }
                }, function (e) {
                    _reportXhrError(e, null);
                });
            }
            function _getAjaxCorrelationContext(xhr) {
                var _a;
                try {
                    var responseHeadersString = xhr[_DYN_GET_ALL_RESPONSE_HEA15 /* @min:%2egetAllResponseHeaders */]();
                    if (responseHeadersString !== null) {
                        var index = _indexOf(responseHeadersString[_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */](), RequestHeaders[8 /* eRequestHeaders.requestContextHeaderLowerCase */]);
                        if (index !== -1) {
                            var responseHeader = xhr.getResponseHeader(RequestHeaders[0 /* eRequestHeaders.requestContextHeader */]);
                            return correlationIdGetCorrelationContext(responseHeader);
                        }
                    }
                }
                catch (e) {
                    _throwInternalWarning(_self, 18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */, CORRELATION_HEADER_ERROR, (_a = {},
                        _a[_DYN_AJAX_DIAGNOSTICS_MES16 /* @min:ajaxDiagnosticsMessage */] = _getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId),
                        _a[_DYN_EXCEPTION /* @min:exception */] = dumpObj$2(e),
                        _a));
                }
            }
            function _createMarkId(type, ajaxData) {
                if (ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */] && _markPrefix && _enableAjaxPerfTracking) {
                    var performance_1 = getPerformance();
                    if (performance_1 && isFunction$2(performance_1.mark)) {
                        _markCount++;
                        var markId = _markPrefix + type + "#" + _markCount;
                        performance_1.mark(markId);
                        var entries = performance_1.getEntriesByName(markId);
                        if (entries && entries[_DYN_LENGTH$1 /* @min:%2elength */] === 1) {
                            ajaxData[_DYN_PERF_MARK /* @min:%2eperfMark */] = entries[0];
                        }
                    }
                }
            }
            function _findPerfResourceEntry(initiatorType, ajaxData, trackCallback, reportError) {
                var perfMark = ajaxData[_DYN_PERF_MARK /* @min:%2eperfMark */];
                var performance = getPerformance();
                var maxAttempts = _maxAjaxPerfLookupAttempts;
                var retryDelay = _ajaxPerfLookupDelay;
                var requestUrl = ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */];
                var attempt = 0;
                (function locateResourceTiming() {
                    try {
                        if (performance && perfMark) {
                            attempt++;
                            var perfTiming = null;
                            var entries = performance.getEntries();
                            for (var lp = entries[_DYN_LENGTH$1 /* @min:%2elength */] - 1; lp >= 0; lp--) {
                                var entry = entries[lp];
                                if (entry) {
                                    if (entry.entryType === "resource") {
                                        if (entry.initiatorType === initiatorType &&
                                            (_indexOf(entry[_DYN_NAME /* @min:%2ename */], requestUrl) !== -1 || _indexOf(requestUrl, entry[_DYN_NAME /* @min:%2ename */]) !== -1)) {
                                            perfTiming = entry;
                                        }
                                    }
                                    else if (entry.entryType === "mark" && entry[_DYN_NAME /* @min:%2ename */] === perfMark[_DYN_NAME /* @min:%2ename */]) {
                                        // We hit the start event
                                        ajaxData[_DYN_PERF_TIMING /* @min:%2eperfTiming */] = perfTiming;
                                        break;
                                    }
                                    if (entry[_DYN_START_TIME /* @min:%2estartTime */] < perfMark[_DYN_START_TIME /* @min:%2estartTime */] - 1000) {
                                        // Fallback to try and reduce the time spent looking for the perf entry
                                        break;
                                    }
                                }
                            }
                        }
                        if (!perfMark || // - we don't have a perfMark or
                            ajaxData[_DYN_PERF_TIMING /* @min:%2eperfTiming */] || // - we have not found the perf entry or
                            attempt >= maxAttempts || // - we have tried too many attempts or
                            ajaxData.async === false) { // - this is a sync request
                            if (perfMark && isFunction$2(performance.clearMarks)) {
                                // Remove the mark so we don't fill up the performance resources too much
                                performance.clearMarks(perfMark[_DYN_NAME /* @min:%2ename */]);
                            }
                            ajaxData.perfAttempts = attempt;
                            // just continue and report the track event
                            trackCallback();
                        }
                        else {
                            // We need to wait for the browser to populate the window.performance entry
                            // This needs to be at least 1ms as waiting <= 1 (on firefox) is not enough time for fetch or xhr,
                            // this is a scheduling issue for the browser implementation
                            scheduleTimeout$1(locateResourceTiming, retryDelay);
                        }
                    }
                    catch (e) {
                        reportError(e);
                    }
                })();
            }
            function _createFetchRecord(input, init) {
                var _a;
                var distributedTraceCtx = _getDistributedTraceCtx();
                var traceID = (distributedTraceCtx && distributedTraceCtx[_DYN_GET_TRACE_ID /* @min:%2egetTraceId */]()) || generateW3CId();
                var spanID = strSubstr(generateW3CId(), 0, 16);
                var ajaxData = new ajaxRecord(traceID, spanID, _self[strDiagLog](), (_a = _self.core) === null || _a === void 0 ? void 0 : _a.getTraceCtx());
                ajaxData[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = distributedTraceCtx && distributedTraceCtx[_DYN_GET_TRACE_FLAGS /* @min:%2egetTraceFlags */]();
                ajaxData[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */] = dateTimeUtilsNow();
                ajaxData[_DYN_ERROR_STATUS_TEXT /* @min:%2eerrorStatusText */] = _enableAjaxErrorStatusText;
                var requestUrl;
                if (input instanceof Request) {
                    requestUrl = (input || {}).url || "";
                }
                else {
                    requestUrl = input;
                }
                if (requestUrl === "") {
                    var location_1 = getLocation();
                    if (location_1 && location_1.href) {
                        requestUrl = strSplit(location_1.href, "#")[0];
                    }
                }
                ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */] = requestUrl;
                var method = "GET";
                if (init && init[_DYN_METHOD /* @min:%2emethod */]) {
                    method = init[_DYN_METHOD /* @min:%2emethod */];
                }
                else if (input && input instanceof Request) {
                    method = input[_DYN_METHOD /* @min:%2emethod */];
                }
                ajaxData[_DYN_METHOD /* @min:%2emethod */] = method;
                var requestHeaders = {};
                if (_enableRequestHeaderTracking) {
                    var headers = new Headers((init ? init[_DYN_HEADERS /* @min:%2eheaders */] : 0) || (input instanceof Request ? (input[_DYN_HEADERS /* @min:%2eheaders */] || {}) : {}));
                    headers.forEach(function (value, key) {
                        if (_canIncludeHeaders(key)) {
                            requestHeaders[key] = value;
                        }
                    });
                }
                ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */] = requestHeaders;
                _createMarkId(STR_FETCH, ajaxData);
                return ajaxData;
            }
            function _getFailedFetchDiagnosticsMessage(input) {
                var result = "";
                try {
                    if (!isNullOrUndefined$1(input)) {
                        if (typeof (input) === "string") {
                            result += "(url: '".concat(input, "')");
                        }
                        else {
                            result += "(url: '".concat(input.url, "')");
                        }
                    }
                }
                catch (e) {
                    _throwInternalCritical(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */, "Failed to grab failed fetch diagnostics message", { exception: dumpObj$2(e) });
                }
                return result;
            }
            function _reportFetchMetrics(callDetails, status, input, response, ajaxData, getResponse, properties) {
                if (!ajaxData) {
                    return;
                }
                function _reportFetchError(msgId, e, failedProps) {
                    var errorProps = failedProps || {};
                    errorProps["fetchDiagnosticsMessage"] = _getFailedFetchDiagnosticsMessage(input);
                    if (e) {
                        errorProps["exception"] = dumpObj$2(e);
                    }
                    _throwInternalWarning(_self, msgId, FAILED_TO_CALCULATE_DURATION_ERROR + "fetch call" + ERROR_NOT_SENT, errorProps);
                }
                ajaxData[_DYN_RESPONSE_FINISHED_TI14 /* @min:%2eresponseFinishedTime */] = dateTimeUtilsNow();
                ajaxData[_DYN_STATUS /* @min:%2estatus */] = status;
                _findPerfResourceEntry(STR_FETCH, ajaxData, function () {
                    var dependency = ajaxData[_DYN__CREATE_TRACK_ITEM /* @min:%2eCreateTrackItem */]("Fetch", _enableRequestHeaderTracking, getResponse);
                    var properties;
                    try {
                        if (!!_addRequestContext) {
                            properties = _addRequestContext({ status: status, request: input, response: response });
                        }
                    }
                    catch (e) {
                        _throwInternalWarning(_self, 104 /* _eInternalMessageId.FailedAddingCustomDefinedRequestContext */, CUSTOM_REQUEST_CONTEXT_ERROR);
                    }
                    if (dependency) {
                        if (properties !== undefined) {
                            dependency[STR_PROPERTIES /* @min:%2eproperties */] = __assignFn(__assignFn({}, dependency.properties), properties);
                        }
                        var sysProperties = ajaxData[_DYN_GET_PART_APROPS /* @min:%2egetPartAProps */]();
                        _reportDependencyInternal(_dependencyInitializers, _self[_DYN_CORE /* @min:%2ecore */], ajaxData, dependency, null, sysProperties);
                    }
                    else {
                        _reportFetchError(14 /* _eInternalMessageId.FailedMonitorAjaxDur */, null, {
                            requestSentTime: ajaxData[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */],
                            responseFinishedTime: ajaxData[_DYN_RESPONSE_FINISHED_TI14 /* @min:%2eresponseFinishedTime */]
                        });
                    }
                }, function (e) {
                    _reportFetchError(18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */, e, null);
                });
            }
            function _getFetchCorrelationContext(response) {
                var _a;
                if (response && response[_DYN_HEADERS /* @min:%2eheaders */]) {
                    try {
                        var responseHeader = response[_DYN_HEADERS /* @min:%2eheaders */].get(RequestHeaders[0 /* eRequestHeaders.requestContextHeader */]);
                        return correlationIdGetCorrelationContext(responseHeader);
                    }
                    catch (e) {
                        _throwInternalWarning(_self, 18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */, CORRELATION_HEADER_ERROR, (_a = {
                                fetchDiagnosticsMessage: _getFailedFetchDiagnosticsMessage(response)
                            },
                            _a[_DYN_EXCEPTION /* @min:exception */] = dumpObj$2(e),
                            _a));
                    }
                }
            }
            function _reportDependencyInternal(initializers, core, ajaxData, dependency, properties, systemProperties) {
                var _a;
                var result = true;
                var initializersCount = initializers[_DYN_LENGTH$1 /* @min:%2elength */];
                if (initializersCount > 0) {
                    var details = (_a = {
                            item: dependency
                        },
                        _a[STR_PROPERTIES /* @min:properties */] = properties,
                        _a.sysProperties = systemProperties,
                        _a.context = ajaxData ? ajaxData[_DYN_CONTEXT$1 /* @min:%2econtext */] : null,
                        _a.aborted = ajaxData ? !!ajaxData[_DYN_ABORTED /* @min:%2eaborted */] : false,
                        _a);
                    result = _processDependencyContainer(core, initializers, details, "initializer");
                }
                if (result) {
                    _self[_DYN_TRACK_DEPENDENCY_DAT3 /* @min:%2etrackDependencyDataInternal */](dependency, properties, systemProperties);
                }
            }
        });
        return _this;
    }
// Removed Stub for AjaxMonitor.prototype.initialize.
    AjaxMonitor.prototype.processTelemetry = function (item, itemCtx) {
        this.processNext(item, itemCtx);
    };
// Removed Stub for AjaxMonitor.prototype.trackDependencyData.
// Removed Stub for AjaxMonitor.prototype.includeCorrelationHeaders.
// Removed Stub for AjaxMonitor.prototype.addDependencyListener.
    /**
     * Add an dependency telemetry initializer callback function to allow populating additional properties or drop the request.
     * It is called after the dependency call has completed and any available performance details are available. A dependency
     * initializer is similar to the TelemetryInitializer function but it allows you to block the reporting of the dependency
     * request so that it doesn't count against the `maxAjaxCallsPerView`.
     * @param dependencyInitializer - The Dependency Telemetry Initializer function
     * @returns - A IDependencyInitializerHandler to enable the initializer to be removed
     */
    AjaxMonitor.prototype.addDependencyInitializer = function (dependencyInitializer) {
        return null;
    };
// Removed Stub for AjaxMonitor.prototype.trackDependencyDataInternal.
    AjaxMonitor.identifier = "AjaxDependencyPlugin";
    return AjaxMonitor;
}(BaseTelemetryPlugin));

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Application = /** @class */ (function () {
    function Application() {
    }
    return Application;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Device = /** @class */ (function () {
    /**
     * Constructs a new instance of the Device class
     */
    function Device() {
        // don't attempt to fingerprint browsers
        this.id = "browser";
        // Device type is a dimension in our data platform
        // Setting it to 'Browser' allows to separate client and server dependencies/exceptions
        this.deviceClass = "Browser";
    }
    return Device;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var Version = '3.1.2';
var Internal = /** @class */ (function () {
    /**
     * Constructs a new instance of the internal telemetry data class.
     */
    function Internal(config, unloadHookContainer) {
        var _this = this;
        var unloadHook = onConfigChange((config), function () {
            var prefix = config.sdkExtension;
            _this.sdkVersion = (prefix ? prefix + "_" : "") + "javascript:" + Version;
        });
        unloadHookContainer && unloadHookContainer.add(unloadHook);
    }
    return Internal;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Location = /** @class */ (function () {
    function Location() {
    }
    return Location;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_SESSION_MANAGER = "sessionManager"; // Count: 3
var _DYN_UPDATE = "update"; // Count: 4
var _DYN_IS_USER_COOKIE_SET = "isUserCookieSet"; // Count: 4
var _DYN_IS_NEW_USER = "isNewUser"; // Count: 4
var _DYN_GET_TRACE_CTX = "getTraceCtx"; // Count: 3
var _DYN_TELEMETRY_TRACE = "telemetryTrace"; // Count: 3
var _DYN_APPLY_SESSION_CONTEX0 = "applySessionContext"; // Count: 2
var _DYN_APPLY_APPLICATION_CO1 = "applyApplicationContext"; // Count: 2
var _DYN_APPLY_DEVICE_CONTEXT = "applyDeviceContext"; // Count: 2
var _DYN_APPLY_OPERATION_CONT2 = "applyOperationContext"; // Count: 2
var _DYN_APPLY_USER_CONTEXT = "applyUserContext"; // Count: 2
var _DYN_APPLY_OPERATING_SYST3 = "applyOperatingSystemContxt"; // Count: 2
var _DYN_APPLY_LOCATION_CONTE4 = "applyLocationContext"; // Count: 2
var _DYN_APPLY_INTERNAL_CONTE5 = "applyInternalContext"; // Count: 2
var _DYN_ACCOUNT_ID = "accountId"; // Count: 7
var _DYN_GET_SESSION_ID = "getSessionId"; // Count: 4
var _DYN_NAME_PREFIX = "namePrefix"; // Count: 3
var _DYN_SESSION_COOKIE_POSTF6 = "sessionCookiePostfix"; // Count: 2
var _DYN_USER_COOKIE_POSTFIX = "userCookiePostfix"; // Count: 2
var _DYN_ID_LENGTH = "idLength"; // Count: 4
var _DYN_GET_NEW_ID = "getNewId"; // Count: 3
var _DYN_LENGTH = "length"; // Count: 4
var _DYN_AUTOMATIC_SESSION = "automaticSession"; // Count: 5
var _DYN_AUTHENTICATED_ID = "authenticatedId"; // Count: 6
var _DYN_ACQUISITION_DATE = "acquisitionDate"; // Count: 5
var _DYN_RENEWAL_DATE = "renewalDate"; // Count: 4
var _DYN_JOIN = "join"; // Count: 5
var _DYN_COOKIE_SEPARATOR = "cookieSeparator"; // Count: 5
var _DYN_AUTH_USER_COOKIE_NAM7 = "authUserCookieName"; // Count: 3

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var SESSION_COOKIE_NAME = "ai_session";
var ACQUISITION_SPAN = 86400000; // 24 hours in ms
var RENEWAL_SPAN = 1800000; // 30 minutes in ms
var COOKIE_UPDATE_INTERVAL = 60000; // 1 minute in ms
var Session = /** @class */ (function () {
    function Session() {
    }
    return Session;
}());
var _SessionManager = /** @class */ (function () {
    function _SessionManager(config, core, unloadHookContainer) {
        var self = this;
        var _storageNamePrefix;
        var _cookieUpdatedTimestamp;
        var _logger = safeGetLogger(core);
        var _cookieManager = safeGetCookieMgr(core);
        var _sessionExpirationMs;
        var _sessionRenewalMs;
        dynamicProto(_SessionManager, self, function (_self) {
            if (!config) {
                config = {};
            }
            var unloadHook = onConfigChange(config, function (details) {
                _sessionExpirationMs = config.sessionExpirationMs || ACQUISITION_SPAN;
                _sessionRenewalMs = config.sessionRenewalMs || RENEWAL_SPAN;
                // sessionCookiePostfix takes the preference if it is configured, otherwise takes namePrefix if configured.
                var sessionCookiePostfix = config.sessionCookiePostfix || config[_DYN_NAME_PREFIX /* @min:%2enamePrefix */] || "";
                _storageNamePrefix = SESSION_COOKIE_NAME + sessionCookiePostfix;
            });
            unloadHookContainer && unloadHookContainer.add(unloadHook);
            _self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */] = new Session();
            _self[_DYN_UPDATE /* @min:%2eupdate */] = function () {
                // Always using Date getTime() as there is a bug in older IE instances that causes the performance timings to have the hi-bit set eg 0x800000000 causing
                // the number to be incorrect.
                var nowMs = utcNow();
                var isExpired = false;
                var session = _self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */];
                if (!session.id) {
                    isExpired = !_initializeAutomaticSession(session);
                }
                if (!isExpired && _sessionExpirationMs > 0) {
                    var timeSinceAcqMs = nowMs - session[_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */];
                    var timeSinceRenewalMs = nowMs - session[_DYN_RENEWAL_DATE /* @min:%2erenewalDate */];
                    isExpired = timeSinceAcqMs < 0 || timeSinceRenewalMs < 0; // expired if the acquisition or last renewal are in the future
                    isExpired = isExpired || timeSinceAcqMs > _sessionExpirationMs; // expired if the time since acquisition is more than session Expiration
                    isExpired = isExpired || timeSinceRenewalMs > _sessionRenewalMs; // expired if the time since last renewal is more than renewal period
                }
                // renew if acquisitionSpan or renewalSpan has elapsed
                if (isExpired) {
                    // update automaticSession so session state has correct id
                    _renew(nowMs);
                }
                else {
                    // do not update the cookie more often than cookieUpdateInterval
                    if (!_cookieUpdatedTimestamp || nowMs - _cookieUpdatedTimestamp > COOKIE_UPDATE_INTERVAL) {
                        _setCookie(session, nowMs);
                    }
                }
            };
            /**
             *  Record the current state of the automatic session and store it in our cookie string format
             *  into the browser's local storage. This is used to restore the session data when the cookie
             *  expires.
             */
            _self.backup = function () {
                var session = _self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */];
                _setStorage(session.id, session[_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */], session[_DYN_RENEWAL_DATE /* @min:%2erenewalDate */]);
            };
            /**
             * Use config.namePrefix + ai_session cookie data or local storage data (when the cookie is unavailable) to
             * initialize the automatic session.
             * @returns true if values set otherwise false
             */
            function _initializeAutomaticSession(session, now) {
                var isValid = false;
                var cookieValue = _cookieManager.get(_storageNamePrefix);
                if (cookieValue && isFunction$2(cookieValue.split)) {
                    isValid = _initializeAutomaticSessionWithData(session, cookieValue);
                }
                else {
                    // There's no cookie, but we might have session data in local storage
                    // This can happen if the session expired or the user actively deleted the cookie
                    // We only want to recover data if the cookie is missing from expiry. We should respect the user's wishes if the cookie was deleted actively.
                    // The User class handles this for us and deletes our local storage object if the persistent user cookie was removed.
                    var storageValue = utlGetLocalStorage(_logger, _storageNamePrefix);
                    if (storageValue) {
                        isValid = _initializeAutomaticSessionWithData(session, storageValue);
                    }
                }
                return isValid || !!session.id;
            }
            /**
             * Extract id, acquisitionDate, and renewalDate from an ai_session payload string and
             * use this data to initialize automaticSession.
             *
             * @param sessionData - The string stored in an ai_session cookie or local storage backup
             * @returns true if values set otherwise false
             */
            function _initializeAutomaticSessionWithData(session, sessionData) {
                var isValid = false;
                var sessionReset = ", session will be reset";
                var tokens = sessionData.split("|");
                if (tokens[_DYN_LENGTH /* @min:%2elength */] >= 2) {
                    try {
                        var acqMs = +tokens[1] || 0;
                        var renewalMs = +tokens[2] || 0;
                        if (isNaN(acqMs) || acqMs <= 0) {
                            _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 27 /* _eInternalMessageId.SessionRenewalDateIsZero */, "AI session acquisition date is 0" + sessionReset);
                        }
                        else if (isNaN(renewalMs) || renewalMs <= 0) {
                            _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 27 /* _eInternalMessageId.SessionRenewalDateIsZero */, "AI session renewal date is 0" + sessionReset);
                        }
                        else if (tokens[0]) {
                            // Everything looks valid so set the values
                            session.id = tokens[0];
                            session[_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */] = acqMs;
                            session[_DYN_RENEWAL_DATE /* @min:%2erenewalDate */] = renewalMs;
                            isValid = true;
                        }
                    }
                    catch (e) {
                        _throwInternal(_logger, 1 /* eLoggingSeverity.CRITICAL */, 9 /* _eInternalMessageId.ErrorParsingAISessionCookie */, "Error parsing ai_session value [" + (sessionData || "") + "]" + sessionReset + " - " + getExceptionName(e), { exception: dumpObj$2(e) });
                    }
                }
                return isValid;
            }
            function _renew(nowMs) {
                var getNewId = config[_DYN_GET_NEW_ID /* @min:%2egetNewId */] || newId;
                _self.automaticSession.id = getNewId(config[_DYN_ID_LENGTH /* @min:%2eidLength */] || 22);
                _self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */][_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */] = nowMs;
                _setCookie(_self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */], nowMs);
                // If this browser does not support local storage, fire an internal log to keep track of it at this point
                if (!utlCanUseLocalStorage()) {
                    _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 0 /* _eInternalMessageId.BrowserDoesNotSupportLocalStorage */, "Browser does not support local storage. Session durations will be inaccurate.");
                }
            }
            function _setCookie(session, nowMs) {
                var acq = session[_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */];
                session[_DYN_RENEWAL_DATE /* @min:%2erenewalDate */] = nowMs;
                var renewalPeriodMs = _sessionRenewalMs;
                // Set cookie to expire after the session expiry time passes or the session renewal deadline, whichever is sooner
                // Expiring the cookie will cause the session to expire even if the user isn't on the page
                var acqTimeLeftMs = (acq + _sessionExpirationMs) - nowMs;
                var cookie = [session.id, acq, nowMs];
                var maxAgeSec = 0;
                if (acqTimeLeftMs < renewalPeriodMs) {
                    maxAgeSec = acqTimeLeftMs / 1000;
                }
                else {
                    maxAgeSec = renewalPeriodMs / 1000;
                }
                var cookieDomain = config.cookieDomain || null;
                // if sessionExpirationMs is set to 0, it means the expiry is set to 0 for this session cookie
                // A cookie with 0 expiry in the session cookie will never expire for that browser session.  If the browser is closed the cookie expires.
                // Depending on the browser, another instance does not inherit this cookie, however, another tab will
                _cookieManager.set(_storageNamePrefix, cookie[_DYN_JOIN /* @min:%2ejoin */]("|"), _sessionExpirationMs > 0 ? maxAgeSec : null, cookieDomain);
                _cookieUpdatedTimestamp = nowMs;
            }
            function _setStorage(guid, acq, renewal) {
                // Keep data in local storage to retain the last session id, allowing us to cleanly end the session when it expires
                // Browsers that don't support local storage won't be able to end sessions cleanly from the client
                // The server will notice this and end the sessions itself, with loss of accurate session duration
                utlSetLocalStorage(_logger, _storageNamePrefix, [guid, acq, renewal][_DYN_JOIN /* @min:%2ejoin */]("|"));
            }
        });
    }
// Removed Stub for _SessionManager.prototype.update.
// Removed Stub for _SessionManager.prototype.backup.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    _SessionManager.__ieDyn=1;

    return _SessionManager;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var TelemetryTrace = /** @class */ (function () {
    function TelemetryTrace(id, parentId, name, logger) {
        var _self = this;
        _self.traceID = id || generateW3CId();
        _self.parentID = parentId;
        var location = getLocation();
        if (!name && location && location.pathname) {
            name = location.pathname;
        }
        _self.name = dataSanitizeString(logger, name);
    }
    return TelemetryTrace;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
function _validateUserInput(id) {
    // Validate:
    // 1. Id is a non-empty string.
    // 2. It does not contain special characters for cookies.
    if (typeof id !== "string" ||
        !id ||
        id.match(/,|;|=| |\|/)) {
        return false;
    }
    return true;
}
var User = /** @class */ (function () {
    function User(config, core, unloadHookContainer) {
        /**
         * A flag indicating whether this represents a new user
         */
        this.isNewUser = false;
        /**
         * A flag indicating whether the user cookie has been set
         */
        this.isUserCookieSet = false;
        var _logger = safeGetLogger(core);
        var _cookieManager = safeGetCookieMgr(core);
        var _storageNamePrefix;
        dynamicProto(User, this, function (_self) {
            // Define _self.config
            objDefine$1(_self, "config", {
                g: function () { return config; }
            });
            var unloadHook = onConfigChange(config, function () {
                var userCookiePostfix = config[_DYN_USER_COOKIE_POSTFIX /* @min:%2euserCookiePostfix */] || "";
                _storageNamePrefix = User.userCookieName + userCookiePostfix;
                // get userId or create new one if none exists
                var cookie = _cookieManager.get(_storageNamePrefix);
                if (cookie) {
                    _self[_DYN_IS_NEW_USER /* @min:%2eisNewUser */] = false;
                    var params = cookie.split(User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]);
                    if (params[_DYN_LENGTH /* @min:%2elength */] > 0) {
                        _self.id = params[0];
                        // we already have a cookie
                        _self[_DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */] = !!_self.id;
                    }
                }
                if (!_self.id) {
                    _self.id = _generateNewId();
                    var newCookie = _generateNewCookie(_self.id);
                    _setUserCookie(newCookie[_DYN_JOIN /* @min:%2ejoin */](User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]));
                    // If we have an config.namePrefix() + ai_session in local storage this means the user actively removed our cookies.
                    // We should respect their wishes and clear ourselves from local storage
                    var name_1 = (config[_DYN_NAME_PREFIX /* @min:%2enamePrefix */] || "") + "ai_session";
                    utlRemoveStorage(_logger, name_1);
                }
                // We still take the account id from the ctor param for backward compatibility.
                // But if the the customer set the accountId through the newer setAuthenticatedUserContext API, we will override it.
                _self[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] = config[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] || undefined;
                // Get the auth user id and account id from the cookie if exists
                // Cookie is in the pattern: <authenticatedId>|<accountId>
                var authCookie = _cookieManager.get(User[_DYN_AUTH_USER_COOKIE_NAM7 /* @min:%2eauthUserCookieName */]);
                if (authCookie) {
                    authCookie = decodeURI(authCookie);
                    var authCookieString = authCookie.split(User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]);
                    if (authCookieString[0]) {
                        _self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */] = authCookieString[0];
                    }
                    if (authCookieString[_DYN_LENGTH /* @min:%2elength */] > 1 && authCookieString[1]) {
                        _self[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] = authCookieString[1];
                    }
                }
            });
            unloadHookContainer && unloadHookContainer.add(unloadHook);
            function _generateNewId() {
                var theConfig = (config || {});
                var getNewId = theConfig[_DYN_GET_NEW_ID /* @min:%2egetNewId */] || newId;
                var id = getNewId(theConfig[_DYN_ID_LENGTH /* @min:%2eidLength */] ? config[_DYN_ID_LENGTH /* @min:%2eidLength */] : 22);
                return id;
            }
            function _generateNewCookie(userId) {
                var acqStr = toISOString(new Date());
                _self.accountAcquisitionDate = acqStr;
                _self[_DYN_IS_NEW_USER /* @min:%2eisNewUser */] = true;
                var newCookie = [userId, acqStr];
                return newCookie;
            }
            function _setUserCookie(cookie) {
                // without expiration, cookies expire at the end of the session
                // set it to 365 days from now
                // 365 * 24 * 60 * 60 = 31536000
                var oneYear = 31536000;
                _self[_DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */] = _cookieManager.set(_storageNamePrefix, cookie, oneYear);
            }
            _self.setAuthenticatedUserContext = function (authenticatedUserId, accountId, storeInCookie) {
                if (storeInCookie === void 0) { storeInCookie = false; }
                // Validate inputs to ensure no cookie control characters.
                var isInvalidInput = !_validateUserInput(authenticatedUserId) || (accountId && !_validateUserInput(accountId));
                if (isInvalidInput) {
                    _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 60 /* _eInternalMessageId.SetAuthContextFailedAccountName */, "Setting auth user context failed. " +
                        "User auth/account id should be of type string, and not contain commas, semi-colons, equal signs, spaces, or vertical-bars.", true);
                    return;
                }
                // Create cookie string.
                _self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */] = authenticatedUserId;
                var authCookie = _self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */];
                if (accountId) {
                    _self[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] = accountId;
                    authCookie = [_self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */], _self.accountId][_DYN_JOIN /* @min:%2ejoin */](User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]);
                }
                if (storeInCookie) {
                    // Set the cookie. No expiration date because this is a session cookie (expires when browser closed).
                    // Encoding the cookie to handle unexpected unicode characters.
                    _cookieManager.set(User[_DYN_AUTH_USER_COOKIE_NAM7 /* @min:%2eauthUserCookieName */], encodeURI(authCookie));
                }
            };
            /**
             * Clears the authenticated user id and the account id from the user context.
             * @returns {}
             */
            _self.clearAuthenticatedUserContext = function () {
                _self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */] = null;
                _self[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] = null;
                _cookieManager.del(User[_DYN_AUTH_USER_COOKIE_NAM7 /* @min:%2eauthUserCookieName */]);
            };
            _self[_DYN_UPDATE /* @min:%2eupdate */] = function (userId) {
                // Optimizations to avoid setting and processing the cookie when not needed
                if (_self.id !== userId || !_self[_DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */]) {
                    var user_id = userId ? userId : _generateNewId();
                    var user_cookie = _generateNewCookie(user_id);
                    _setUserCookie(user_cookie[_DYN_JOIN /* @min:%2ejoin */](User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]));
                }
            };
        });
    }
// Removed Stub for User.prototype.setAuthenticatedUserContext.
// Removed Stub for User.prototype.clearAuthenticatedUserContext.
// Removed Stub for User.prototype.update.
    User.cookieSeparator = "|";
    User.userCookieName = "ai_user";
    User.authUserCookieName = "ai_authUser";
    return User;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var strExt = "ext";
var strTags = "tags";
function _removeEmpty(target, name) {
    if (target && target[name] && objKeys(target[name])[_DYN_LENGTH /* @min:%2elength */] === 0) {
        delete target[name];
    }
}
function _nullResult() {
    return null;
}
var TelemetryContext = /** @class */ (function () {
    function TelemetryContext(core, defaultConfig, previousTraceCtx, unloadHookContainer) {
        var _this = this;
        var logger = core.logger;
        dynamicProto(TelemetryContext, this, function (_self) {
            _self.appId = _nullResult;
            _self[_DYN_GET_SESSION_ID /* @min:%2egetSessionId */] = _nullResult;
            _self.application = new Application();
            _self.internal = new Internal(defaultConfig, unloadHookContainer);
            if (hasWindow()) {
                _self[_DYN_SESSION_MANAGER /* @min:%2esessionManager */] = new _SessionManager(defaultConfig, core, unloadHookContainer);
                _self.device = new Device();
                _self.location = new Location();
                _self.user = new User(defaultConfig, core, unloadHookContainer);
                var traceId = void 0;
                var parentId = void 0;
                var name_1;
                if (previousTraceCtx) {
                    traceId = previousTraceCtx.getTraceId();
                    parentId = previousTraceCtx.getSpanId();
                    name_1 = previousTraceCtx.getName();
                }
                _self[_DYN_TELEMETRY_TRACE /* @min:%2etelemetryTrace */] = new TelemetryTrace(traceId, parentId, name_1, logger);
                _self.session = new Session();
            }
            _self[_DYN_GET_SESSION_ID /* @min:%2egetSessionId */] = function () {
                var session = _self.session;
                var sesId = null;
                // If customer set session info, apply their context; otherwise apply context automatically generated
                if (session && isString$2(session.id)) {
                    sesId = session.id;
                }
                else {
                    // Gets the automatic session if it exists or an empty object
                    var autoSession = (_self[_DYN_SESSION_MANAGER /* @min:%2esessionManager */] || {})[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */];
                    sesId = autoSession && isString$2(autoSession.id) ? autoSession.id : null;
                }
                return sesId;
            };
            _self[_DYN_APPLY_SESSION_CONTEX0 /* @min:%2eapplySessionContext */] = function (evt, itemCtx) {
                setValue(getSetValue(evt.ext, Extensions.AppExt), "sesId", _self[_DYN_GET_SESSION_ID /* @min:%2egetSessionId */](), isString$2);
            };
            _self[_DYN_APPLY_OPERATING_SYST3 /* @min:%2eapplyOperatingSystemContxt */] = function (evt, itemCtx) {
                setValue(evt.ext, Extensions.OSExt, _self.os);
            };
            _self[_DYN_APPLY_APPLICATION_CO1 /* @min:%2eapplyApplicationContext */] = function (evt, itemCtx) {
                var application = _self.application;
                if (application) {
                    // evt.ext.app
                    var tags = getSetValue(evt, strTags);
                    setValue(tags, CtxTagKeys.applicationVersion, application.ver, isString$2);
                    setValue(tags, CtxTagKeys.applicationBuild, application.build, isString$2);
                }
            };
            _self[_DYN_APPLY_DEVICE_CONTEXT /* @min:%2eapplyDeviceContext */] = function (evt, itemCtx) {
                var device = _self.device;
                if (device) {
                    // evt.ext.device
                    var extDevice = getSetValue(getSetValue(evt, strExt), Extensions.DeviceExt);
                    setValue(extDevice, "localId", device.id, isString$2);
                    setValue(extDevice, "ip", device.ip, isString$2);
                    setValue(extDevice, "model", device.model, isString$2);
                    setValue(extDevice, "deviceClass", device.deviceClass, isString$2);
                }
            };
            _self[_DYN_APPLY_INTERNAL_CONTE5 /* @min:%2eapplyInternalContext */] = function (evt, itemCtx) {
                var internal = _self.internal;
                if (internal) {
                    var tags = getSetValue(evt, strTags);
                    setValue(tags, CtxTagKeys.internalAgentVersion, internal.agentVersion, isString$2); // not mapped in CS 4.0
                    setValue(tags, CtxTagKeys.internalSdkVersion, dataSanitizeString(logger, internal.sdkVersion, 64), isString$2);
                    if (evt.baseType === _InternalLogMessage.dataType || evt.baseType === PageView.dataType) {
                        setValue(tags, CtxTagKeys.internalSnippet, internal.snippetVer, isString$2);
                        setValue(tags, CtxTagKeys.internalSdkSrc, internal.sdkSrc, isString$2);
                    }
                }
            };
            _self[_DYN_APPLY_LOCATION_CONTE4 /* @min:%2eapplyLocationContext */] = function (evt, itemCtx) {
                var location = _this.location;
                if (location) {
                    setValue(getSetValue(evt, strTags, []), CtxTagKeys.locationIp, location.ip, isString$2);
                }
            };
            _self[_DYN_APPLY_OPERATION_CONT2 /* @min:%2eapplyOperationContext */] = function (evt, itemCtx) {
                var telemetryTrace = _self[_DYN_TELEMETRY_TRACE /* @min:%2etelemetryTrace */];
                if (telemetryTrace) {
                    var extTrace = getSetValue(getSetValue(evt, strExt), Extensions.TraceExt, { traceID: undefined, parentID: undefined });
                    setValue(extTrace, "traceID", telemetryTrace.traceID, isString$2, isNullOrUndefined$1);
                    setValue(extTrace, "name", telemetryTrace.name, isString$2, isNullOrUndefined$1);
                    setValue(extTrace, "parentID", telemetryTrace.parentID, isString$2, isNullOrUndefined$1);
                }
            };
            _self.applyWebContext = function (evt, itemCtx) {
                var web = _this.web;
                if (web) {
                    setValue(getSetValue(evt, strExt), Extensions.WebExt, web);
                }
            };
            _self[_DYN_APPLY_USER_CONTEXT /* @min:%2eapplyUserContext */] = function (evt, itemCtx) {
                var user = _self.user;
                if (user) {
                    var tags = getSetValue(evt, strTags, []);
                    // stays in tags
                    setValue(tags, CtxTagKeys.userAccountId, user[_DYN_ACCOUNT_ID /* @min:%2eaccountId */], isString$2);
                    // CS 4.0
                    var extUser = getSetValue(getSetValue(evt, strExt), Extensions.UserExt);
                    setValue(extUser, "id", user.id, isString$2);
                    setValue(extUser, "authId", user[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */], isString$2);
                }
            };
            _self.cleanUp = function (evt, itemCtx) {
                var ext = evt.ext;
                if (ext) {
                    _removeEmpty(ext, Extensions.DeviceExt);
                    _removeEmpty(ext, Extensions.UserExt);
                    _removeEmpty(ext, Extensions.WebExt);
                    _removeEmpty(ext, Extensions.OSExt);
                    _removeEmpty(ext, Extensions.AppExt);
                    _removeEmpty(ext, Extensions.TraceExt);
                }
            };
        });
    }
// Removed Stub for TelemetryContext.prototype.applySessionContext.
// Removed Stub for TelemetryContext.prototype.applyOperatingSystemContxt.
// Removed Stub for TelemetryContext.prototype.applyApplicationContext.
// Removed Stub for TelemetryContext.prototype.applyDeviceContext.
// Removed Stub for TelemetryContext.prototype.applyInternalContext.
// Removed Stub for TelemetryContext.prototype.applyLocationContext.
// Removed Stub for TelemetryContext.prototype.applyOperationContext.
// Removed Stub for TelemetryContext.prototype.applyWebContext.
// Removed Stub for TelemetryContext.prototype.applyUserContext.
// Removed Stub for TelemetryContext.prototype.cleanUp.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    TelemetryContext.__ieDyn=1;

    return TelemetryContext;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* PropertiesPlugin.ts
* @copyright Microsoft 2018
*/
var _a$3;
var undefString;
var nullValue = null;
var _defaultConfig = objDeepFreeze$1((_a$3 = {},
    _a$3[_DYN_ACCOUNT_ID /* @min:accountId */] = nullValue,
    _a$3.sessionRenewalMs = 30 * 60 * 1000,
    _a$3.samplingPercentage = 100,
    _a$3.sessionExpirationMs = 24 * 60 * 60 * 1000,
    _a$3.cookieDomain = nullValue,
    _a$3.sdkExtension = nullValue,
    _a$3.isBrowserLinkTrackingEnabled = false,
    _a$3.appId = nullValue,
    _a$3[_DYN_GET_SESSION_ID /* @min:getSessionId */] = nullValue,
    _a$3[_DYN_NAME_PREFIX /* @min:namePrefix */] = undefString,
    _a$3[_DYN_SESSION_COOKIE_POSTF6 /* @min:sessionCookiePostfix */] = undefString,
    _a$3[_DYN_USER_COOKIE_POSTFIX /* @min:userCookiePostfix */] = undefString,
    _a$3[_DYN_ID_LENGTH /* @min:idLength */] = 22,
    _a$3[_DYN_GET_NEW_ID /* @min:getNewId */] = nullValue,
    _a$3));
var PropertiesPlugin = /** @class */ (function (_super) {
    __extendsFn(PropertiesPlugin, _super);
    function PropertiesPlugin() {
        var _this = _super.call(this) || this;
        _this.priority = 110;
        _this.identifier = PropertiesPluginIdentifier;
        var _extensionConfig;
        var _distributedTraceCtx;
        var _previousTraceCtx;
        var _context;
        var _disableUserInitMessage;
        dynamicProto(PropertiesPlugin, _this, function (_self, _base) {
            _initDefaults();
            objDefine$1(_self, "context", {
                g: function () {
                    return _context;
                }
            });
            _self.initialize = function (config, core, extensions, pluginChain) {
                _base.initialize(config, core, extensions, pluginChain);
                _populateDefaults(config);
            };
            /**
             * Add Part A fields to the event
             * @param event - The event that needs to be processed
             */
            _self.processTelemetry = function (event, itemCtx) {
                if (!isNullOrUndefined$1(event)) {
                    itemCtx = _self._getTelCtx(itemCtx);
                    // If the envelope is PageView, reset the internal message count so that we can send internal telemetry for the new page.
                    if (event.name === PageView.envelopeType) {
                        itemCtx.diagLog().resetInternalMessageCount();
                    }
                    var theContext = (_context || {});
                    if (theContext.session) {
                        // If customer did not provide custom session id update the session manager
                        if (typeof _context.session.id !== "string" && theContext[_DYN_SESSION_MANAGER /* @min:%2esessionManager */]) {
                            theContext[_DYN_SESSION_MANAGER /* @min:%2esessionManager */][_DYN_UPDATE /* @min:%2eupdate */]();
                        }
                    }
                    var userCtx = theContext.user;
                    if (userCtx && !userCtx[_DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */]) {
                        userCtx[_DYN_UPDATE /* @min:%2eupdate */](theContext.user.id);
                    }
                    _processTelemetryInternal(event, itemCtx);
                    if (userCtx && userCtx[_DYN_IS_NEW_USER /* @min:%2eisNewUser */]) {
                        userCtx[_DYN_IS_NEW_USER /* @min:%2eisNewUser */] = false;
                        if (!_disableUserInitMessage) {
                            var message = new _InternalLogMessage(72 /* _eInternalMessageId.SendBrowserInfoOnUserInit */, ((getNavigator() || {}).userAgent || ""));
                            _logInternalMessage(itemCtx.diagLog(), 1 /* eLoggingSeverity.CRITICAL */, message);
                        }
                    }
                    _self.processNext(event, itemCtx);
                }
            };
            _self._doTeardown = function (unloadCtx, unloadState) {
                var core = (unloadCtx || {}).core();
                if (core && core[_DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */]) {
                    var traceCtx = core[_DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */](false);
                    if (traceCtx === _distributedTraceCtx) {
                        core.setTraceCtx(_previousTraceCtx);
                    }
                }
                _initDefaults();
            };
            function _initDefaults() {
                _extensionConfig = null;
                _distributedTraceCtx = null;
                _previousTraceCtx = null;
                _context = null;
                _disableUserInitMessage = true;
            }
            function _populateDefaults(config) {
                var identifier = _self.identifier;
                var core = _self.core;
                // This function will be re-called whenever any referenced configuration is changed
                _self._addHook(onConfigChange(config, function () {
                    var ctx = createProcessTelemetryContext(null, config, core);
                    if (config.storagePrefix) {
                        utlSetStoragePrefix(config.storagePrefix);
                    }
                    _disableUserInitMessage = config.disableUserInitMessage === false ? false : true;
                    _extensionConfig = ctx.getExtCfg(identifier, _defaultConfig);
                    // Test hook to allow accessing the internal values -- explicitly not defined as an available property on the class
                    _self["_extConfig"] = _extensionConfig;
                }));
                // This is outside of the onConfigChange as we don't want to update (replace) these values whenever a referenced config item changes
                _previousTraceCtx = core[_DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */](false);
                _context = new TelemetryContext(core, _extensionConfig, _previousTraceCtx, _self._unloadHooks);
                _distributedTraceCtx = createDistributedTraceContextFromTrace(_self.context[_DYN_TELEMETRY_TRACE /* @min:%2etelemetryTrace */], _previousTraceCtx);
                core.setTraceCtx(_distributedTraceCtx);
                _self.context.appId = function () {
                    var breezeChannel = core.getPlugin(BreezeChannelIdentifier);
                    return breezeChannel ? breezeChannel.plugin["_appId"] : null;
                };
            }
            function _processTelemetryInternal(evt, itemCtx) {
                // Set Part A fields
                getSetValue(evt, "tags", []);
                getSetValue(evt, "ext", {});
                var ctx = _self.context;
                ctx[_DYN_APPLY_SESSION_CONTEX0 /* @min:%2eapplySessionContext */](evt, itemCtx);
                ctx[_DYN_APPLY_APPLICATION_CO1 /* @min:%2eapplyApplicationContext */](evt, itemCtx);
                ctx[_DYN_APPLY_DEVICE_CONTEXT /* @min:%2eapplyDeviceContext */](evt, itemCtx);
                ctx[_DYN_APPLY_OPERATION_CONT2 /* @min:%2eapplyOperationContext */](evt, itemCtx);
                ctx[_DYN_APPLY_USER_CONTEXT /* @min:%2eapplyUserContext */](evt, itemCtx);
                ctx[_DYN_APPLY_OPERATING_SYST3 /* @min:%2eapplyOperatingSystemContxt */](evt, itemCtx);
                ctx.applyWebContext(evt, itemCtx);
                ctx[_DYN_APPLY_LOCATION_CONTE4 /* @min:%2eapplyLocationContext */](evt, itemCtx); // legacy tags
                ctx[_DYN_APPLY_INTERNAL_CONTE5 /* @min:%2eapplyInternalContext */](evt, itemCtx); // legacy tags
                ctx.cleanUp(evt, itemCtx);
            }
        });
        return _this;
    }
// Removed Stub for PropertiesPlugin.prototype.initialize.
// Removed Stub for PropertiesPlugin.prototype.processTelemetry.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PropertiesPlugin.__ieDyn=1;

    return PropertiesPlugin;
}(BaseTelemetryPlugin));
const PropertiesPlugin$1 = PropertiesPlugin;

/*
 * Application Insights JavaScript SDK - Web, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var _AUTHENTICATED_USER_CONTEXT = "AuthenticatedUserContext";
var _TRACK = "track";
var STR_SNIPPET = "snippet";
var STR_GET_COOKIE_MGR = "getCookieMgr";
var STR_START_TRACK_PAGE = "startTrackPage";
var STR_STOP_TRACK_PAGE = "stopTrackPage";
var STR_FLUSH = "flush";
var STR_START_TRACK_EVENT = "startTrackEvent";
var STR_STOP_TRACK_EVENT = "stopTrackEvent";
var STR_ADD_TELEMETRY_INITIALIZER = "addTelemetryInitializer";
var STR_POLL_INTERNAL_LOGS = "pollInternalLogs";
var STR_GET_PLUGIN = "getPlugin";
var STR_EVT_NAMESPACE = "evtNamespace";
var STR_TRACK_EVENT = _TRACK + "Event";
var STR_TRACK_TRACE = _TRACK + "Trace";
var STR_TRACK_METRIC = _TRACK + "Metric";
var STR_TRACK_PAGE_VIEW = _TRACK + "PageView";
var STR_TRACK_EXCEPTION = _TRACK + "Exception";
var STR_TRACK_DEPENDENCY_DATA = _TRACK + "DependencyData";
var STR_SET_AUTHENTICATED_USER_CONTEXT = "set" + _AUTHENTICATED_USER_CONTEXT;
var STR_CLEAR_AUTHENTICATED_USER_CONTEXT = "clear" + _AUTHENTICATED_USER_CONTEXT;

/*
 * Application Insights JavaScript SDK - Web, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_VERSION = "version"; // Count: 6
var _DYN_QUEUE = "queue"; // Count: 6
var _DYN_CONNECTION_STRING = "connectionString"; // Count: 4
var _DYN_ENDPOINT_URL = "endpointUrl"; // Count: 4
var _DYN_USER_OVERRIDE_ENDPOI0 = "userOverrideEndpointUrl"; // Count: 5
var _DYN_INSTRUMENTATION_KEY = "instrumentationKey"; // Count: 3
var _DYN_ONUNLOAD_FLUSH = "onunloadFlush"; // Count: 6
var _DYN_CONTEXT = "context"; // Count: 5
var _DYN_ADD_HOUSEKEEPING_BEF1 = "addHousekeepingBeforeUnload"; // Count: 2
var _DYN_SEND_MESSAGE = "sendMessage"; // Count: 3
var _DYN_UPDATE_SNIPPET_DEFIN2 = "updateSnippetDefinitions"; // Count: 2

/*
 * Application Insights JavaScript SDK - Web, 3.1.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var _a$2, _b, _c;
var _internalSdkSrc;
// This is an exclude list of properties that should not be updated during initialization
// They include a combination of private and internal property names
var _ignoreUpdateSnippetProperties = [
    STR_SNIPPET, "dependencies", "properties", "_snippetVersion", "appInsightsNew", "getSKUDefaults"
];
var IKEY_USAGE = "iKeyUsage";
var CDN_USAGE = "CdnUsage";
var SDK_LOADER_VER = "SdkLoaderVer";
var UNDEFINED_VALUE = undefined;
var default_limit = {
    samplingRate: 100,
    maxSendNumber: 1
};
var default_interval = {
    monthInterval: 3,
    daysOfMonth: [28]
};
var default_throttle_config = {
    disabled: true,
    limit: cfgDfMerge(default_limit),
    interval: cfgDfMerge(default_interval)
};
// We need to include all properties that we only reference that we want to be dynamically updatable here
// So they are converted even when not specified in the passed configuration
var defaultConfigValues = (_a$2 = {},
    _a$2[_DYN_CONNECTION_STRING /* @min:connectionString */] = UNDEFINED_VALUE,
    _a$2[_DYN_ENDPOINT_URL /* @min:endpointUrl */] = UNDEFINED_VALUE,
    _a$2[_DYN_INSTRUMENTATION_KEY /* @min:instrumentationKey */] = UNDEFINED_VALUE,
    _a$2[_DYN_USER_OVERRIDE_ENDPOI0 /* @min:userOverrideEndpointUrl */] = UNDEFINED_VALUE,
    _a$2.diagnosticLogInterval = cfgDfValidate(_chkDiagLevel, 10000),
    _a$2.featureOptIn = (_b = {},
        _b[IKEY_USAGE] = { mode: 2 /* FeatureOptInMode.disable */ },
        _b[CDN_USAGE] = { mode: 2 /* FeatureOptInMode.disable */ },
        _b[SDK_LOADER_VER] = { mode: 2 /* FeatureOptInMode.disable */ },
        _b),
    _a$2.throttleMgrCfg = cfgDfMerge((_c = {},
        _c[109 /* _eInternalMessageId.DefaultThrottleMsgKey */] = cfgDfMerge(default_throttle_config),
        _c[106 /* _eInternalMessageId.InstrumentationKeyDeprecation */] = cfgDfMerge(default_throttle_config),
        _c[111 /* _eInternalMessageId.SdkLdrUpdate */] = cfgDfMerge(default_throttle_config),
        _c[110 /* _eInternalMessageId.CdnDeprecation */] = cfgDfMerge(default_throttle_config),
        _c)),
    _a$2);
function _chkDiagLevel(value) {
    // Make sure we have a value > 0
    return value && value > 0;
}
/**
 * Application Insights API
 * @group Entrypoint
 * @group Classes
 * @class Initialization
 * @implements {IApplicationInsights}
 */
var AppInsightsSku = /** @class */ (function () {
    function AppInsightsSku(snippet) {
        var _this = this;
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var dependencies;
        var properties;
        var _sender;
        var _snippetVersion;
        var _evtNamespace;
        var _houseKeepingNamespace;
        var _core;
        var _config;
        var _analyticsPlugin;
        var _cfgSyncPlugin;
        var _throttleMgr;
        var _iKeySentMessage;
        var _cdnSentMessage;
        var _sdkVerSentMessage;
        dynamicProto(AppInsightsSku, this, function (_self) {
            _initDefaults();
            objDefine$1(_self, "config", {
                g: function () {
                    return _config;
                }
            });
            arrForEach$1(["pluginVersionStringArr", "pluginVersionString"], function (key) {
                objDefine$1(_self, key, {
                    g: function () {
                        if (_core) {
                            return _core[key];
                        }
                        return null;
                    }
                });
            });
            // initialize the queue and config in case they are undefined
            _snippetVersion = "" + (snippet.sv || snippet[_DYN_VERSION /* @min:%2eversion */] || "");
            snippet[_DYN_QUEUE /* @min:%2equeue */] = snippet[_DYN_QUEUE /* @min:%2equeue */] || [];
            snippet[_DYN_VERSION /* @min:%2eversion */] = snippet[_DYN_VERSION /* @min:%2eversion */] || 2.0; // Default to new version
            var cfgHandler = createDynamicConfig(snippet.config || {}, defaultConfigValues);
            _config = cfgHandler.cfg;
            _analyticsPlugin = new AnalyticsPlugin();
            objDefine$1(_self, "appInsights", {
                g: function () {
                    return _analyticsPlugin;
                }
            });
            properties = new PropertiesPlugin$1();
            dependencies = new AjaxMonitor();
            _sender = new Sender();
            _core = new AppInsightsCore();
            objDefine$1(_self, "core", {
                g: function () {
                    return _core;
                }
            });
            // Will get recalled if any referenced values are changed
            _addUnloadHook(onConfigChange(cfgHandler, function () {
                if (_config[_DYN_CONNECTION_STRING /* @min:%2econnectionString */]) {
                    var cs = parseConnectionString(_config[_DYN_CONNECTION_STRING /* @min:%2econnectionString */]);
                    var ingest = cs.ingestionendpoint;
                    _config[_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */] = _config[_DYN_USER_OVERRIDE_ENDPOI0 /* @min:%2euserOverrideEndpointUrl */] ? _config[_DYN_USER_OVERRIDE_ENDPOI0 /* @min:%2euserOverrideEndpointUrl */] : ingest + DEFAULT_BREEZE_PATH; // add /v2/track
                    _config[_DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */] = cs.instrumentationkey || _config[_DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */];
                }
                // userOverrideEndpointUrl have the highest priority
                _config[_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */] = _config[_DYN_USER_OVERRIDE_ENDPOI0 /* @min:%2euserOverrideEndpointUrl */] ? _config[_DYN_USER_OVERRIDE_ENDPOI0 /* @min:%2euserOverrideEndpointUrl */] : _config[_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */];
            }));
            _self[STR_SNIPPET /* @min:%2esnippet */] = snippet;
            _self[STR_FLUSH /* @min:%2eflush */] = function (async, callBack) {
                if (async === void 0) { async = true; }
                var result;
                doPerf(_core, function () { return "AISKU.flush"; }, function () {
                    if (async && !callBack) {
                        result = createPromise(function (resolve) {
                            callBack = resolve;
                        });
                    }
                    var waiting = 1;
                    var flushDone = function () {
                        waiting--;
                        if (waiting === 0) {
                            callBack();
                        }
                    };
                    arrForEach$1(_core.getChannels(), function (channel) {
                        if (channel) {
                            waiting++;
                            channel[STR_FLUSH /* @min:%2eflush */](async, flushDone);
                        }
                    });
                    // decrement the initial "waiting"
                    flushDone();
                }, null, async);
                return result;
            };
            _self[_DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */] = function (async) {
                if (async === void 0) { async = true; }
                arrForEach$1(_core.getChannels(), function (channel) {
                    if (channel[_DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */]) {
                        channel[_DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */]();
                    }
                    else {
                        channel[STR_FLUSH /* @min:%2eflush */](async);
                    }
                });
            };
            _self.loadAppInsights = function (legacyMode, logger, notificationManager) {
                if (legacyMode === void 0) { legacyMode = false; }
                if (legacyMode) {
                    throwUnsupported("Legacy Mode is no longer supported");
                }
                function _updateSnippetProperties(snippet) {
                    if (snippet) {
                        var snippetVer = "";
                        if (!isNullOrUndefined$1(_snippetVersion)) {
                            snippetVer += _snippetVersion;
                        }
                        if (_self[_DYN_CONTEXT /* @min:%2econtext */] && _self[_DYN_CONTEXT /* @min:%2econtext */].internal) {
                            _self[_DYN_CONTEXT /* @min:%2econtext */].internal.snippetVer = snippetVer || "-";
                        }
                        // apply updated properties to the global instance (snippet)
                        objForEachKey$1(_self, function (field, value) {
                            if (isString$2(field) &&
                                !isFunction$2(value) &&
                                field && field[0] !== "_" && // Don't copy "internal" values
                                arrIndexOf(_ignoreUpdateSnippetProperties, field) === -1) {
                                if (snippet[field] !== value) {
                                    snippet[field] = value;
                                }
                            }
                        });
                    }
                }
                doPerf(_self.core, function () { return "AISKU.loadAppInsights"; }, function () {
                    // initialize core
                    _core.initialize(_config, [_sender, properties, dependencies, _analyticsPlugin, _cfgSyncPlugin], logger, notificationManager);
                    objDefine$1(_self, "context", {
                        g: function () { return properties[_DYN_CONTEXT /* @min:%2econtext */]; }
                    });
                    if (!_throttleMgr) {
                        _throttleMgr = new ThrottleMgr(_core);
                    }
                    var sdkSrc = _findSdkSourceFile();
                    if (sdkSrc && _self[_DYN_CONTEXT /* @min:%2econtext */]) {
                        _self[_DYN_CONTEXT /* @min:%2econtext */].internal.sdkSrc = sdkSrc;
                    }
                    _updateSnippetProperties(_self[STR_SNIPPET /* @min:%2esnippet */]);
                    // Empty queue of all api calls logged prior to sdk download
                    _self.emptyQueue();
                    _self[STR_POLL_INTERNAL_LOGS /* @min:%2epollInternalLogs */]();
                    _self[_DYN_ADD_HOUSEKEEPING_BEF1 /* @min:%2eaddHousekeepingBeforeUnload */](_self);
                    _addUnloadHook(onConfigChange(cfgHandler, function () {
                        var defaultEnable = false;
                        if (_config.throttleMgrCfg[109 /* _eInternalMessageId.DefaultThrottleMsgKey */]) {
                            defaultEnable = !_config.throttleMgrCfg[109 /* _eInternalMessageId.DefaultThrottleMsgKey */].disabled;
                        }
                        if (!_throttleMgr.isReady() && _config.extensionConfig && _config.extensionConfig[_cfgSyncPlugin.identifier] && defaultEnable) {
                            // set ready state to true will automatically trigger flush()
                            _throttleMgr.onReadyState(true);
                        }
                        if (!_iKeySentMessage && !_config[_DYN_CONNECTION_STRING /* @min:%2econnectionString */] && isFeatureEnabled(IKEY_USAGE, _config)) {
                            _throttleMgr[_DYN_SEND_MESSAGE /* @min:%2esendMessage */](106 /* _eInternalMessageId.InstrumentationKeyDeprecation */, "See Instrumentation key support at aka.ms/IkeyMigrate");
                            _iKeySentMessage = true;
                        }
                        if (!_cdnSentMessage && _self[_DYN_CONTEXT /* @min:%2econtext */].internal.sdkSrc && _self[_DYN_CONTEXT /* @min:%2econtext */].internal.sdkSrc.indexOf("az416426") != -1 && isFeatureEnabled(CDN_USAGE, _config)) {
                            _throttleMgr[_DYN_SEND_MESSAGE /* @min:%2esendMessage */](110 /* _eInternalMessageId.CdnDeprecation */, "See Cdn support notice at aka.ms/JsActiveCdn");
                            _cdnSentMessage = true;
                        }
                        if (!_sdkVerSentMessage && parseInt(_snippetVersion) < 6 && isFeatureEnabled(SDK_LOADER_VER, _config)) {
                            _throttleMgr[_DYN_SEND_MESSAGE /* @min:%2esendMessage */](111 /* _eInternalMessageId.SdkLdrUpdate */, "An updated Sdk Loader is available, see aka.ms/SnippetVer");
                            _sdkVerSentMessage = true;
                        }
                    }));
                });
                return _self;
            };
            _self[_DYN_UPDATE_SNIPPET_DEFIN2 /* @min:%2eupdateSnippetDefinitions */] = function (snippet) {
                // apply full appInsights to the global instance
                // Note: This must be called before loadAppInsights is called
                proxyAssign(snippet, _self, function (name) {
                    // Not excluding names prefixed with "_" as we need to proxy some functions like _onError
                    return name && arrIndexOf(_ignoreUpdateSnippetProperties, name) === -1;
                });
            };
            _self.emptyQueue = function () {
                // call functions that were queued before the main script was loaded
                try {
                    if (isArray$1(_self.snippet[_DYN_QUEUE /* @min:%2equeue */])) {
                        // note: do not check length in the for-loop conditional in case something goes wrong and the stub methods are not overridden.
                        var length_1 = _self.snippet[_DYN_QUEUE /* @min:%2equeue */].length;
                        for (var i = 0; i < length_1; i++) {
                            var call = _self.snippet[_DYN_QUEUE /* @min:%2equeue */][i];
                            call();
                        }
                        _self.snippet[_DYN_QUEUE /* @min:%2equeue */] = undefined;
                        delete _self.snippet[_DYN_QUEUE /* @min:%2equeue */];
                    }
                }
                catch (exception) {
                    var properties_1 = {};
                    if (exception && isFunction$2(exception.toString)) {
                        properties_1.exception = exception.toString();
                    }
                    // need from core
                    // Microsoft.ApplicationInsights._InternalLogging.throwInternal(
                    //     eLoggingSeverity.WARNING,
                    //     _eInternalMessageId.FailedToSendQueuedTelemetry,
                    //     "Failed to send queued telemetry",
                    //     properties);
                }
            };
            _self[_DYN_ADD_HOUSEKEEPING_BEF1 /* @min:%2eaddHousekeepingBeforeUnload */] = function (appInsightsInstance) {
                // Add callback to push events when the user navigates away
                if (hasWindow() || hasDocument()) {
                    var performHousekeeping_1 = function () {
                        // Adds the ability to flush all data before the page unloads.
                        // Note: This approach tries to push a sync request with all the pending events onbeforeunload.
                        // Firefox does not respect this.Other browsers DO push out the call with < 100% hit rate.
                        // Telemetry here will help us analyze how effective this approach is.
                        // Another approach would be to make this call sync with a acceptable timeout to reduce the
                        // impact on user experience.
                        // appInsightsInstance.context._sender.triggerSend();
                        appInsightsInstance[_DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */](false);
                        // Back up the current session to local storage
                        // This lets us close expired sessions after the cookies themselves expire
                        if (isFunction$2(_self.core[STR_GET_PLUGIN /* @min:%2egetPlugin */])) {
                            var loadedPlugin = _this.core[STR_GET_PLUGIN /* @min:%2egetPlugin */](PropertiesPluginIdentifier);
                            if (loadedPlugin) {
                                var propertiesPlugin = loadedPlugin.plugin;
                                if (propertiesPlugin && propertiesPlugin[_DYN_CONTEXT /* @min:%2econtext */] && propertiesPlugin[_DYN_CONTEXT /* @min:%2econtext */]._sessionManager) {
                                    propertiesPlugin[_DYN_CONTEXT /* @min:%2econtext */]._sessionManager.backup();
                                }
                            }
                        }
                    };
                    var added_1 = false;
                    if (!_houseKeepingNamespace) {
                        _houseKeepingNamespace = mergeEvtNamespace(_evtNamespace, _core[STR_EVT_NAMESPACE /* @min:%2eevtNamespace */] && _core[STR_EVT_NAMESPACE /* @min:%2eevtNamespace */]());
                    }
                    // Will be recalled if any referenced config properties change
                    _addUnloadHook(onConfigChange(_config, function (details) {
                        var coreConfig = details.cfg;
                        var analyticsPlugin = appInsightsInstance.appInsights;
                        var ctx = createProcessTelemetryContext(null, coreConfig, analyticsPlugin.core);
                        var extConfig = ctx.getExtCfg(analyticsPlugin.identifier || AnalyticsPluginIdentifier);
                        // As we could get recalled, remove any previously registered event handlers first
                        _removePageEventHandlers();
                        var excludePageUnloadEvents = coreConfig.disablePageUnloadEvents;
                        if (!extConfig.disableFlushOnBeforeUnload) {
                            // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
                            // As just hooking the window does not always fire (on chrome) for page navigation's.
                            if (addPageUnloadEventListener(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace)) {
                                added_1 = true;
                            }
                            // We also need to hook the pagehide and visibilitychange events as not all versions of Safari support load/unload events.
                            if (addPageHideEventListener(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace)) {
                                added_1 = true;
                            }
                            // A reactNative app may not have a window and therefore the beforeunload/pagehide events -- so don't
                            // log the failure in this case
                            if (!added_1 && !isReactNative()) {
                                _throwInternal(_core.logger, 1 /* eLoggingSeverity.CRITICAL */, 19 /* _eInternalMessageId.FailedToAddHandlerForOnBeforeUnload */, "Could not add handler for beforeunload and pagehide");
                            }
                        }
                        if (!added_1 && !extConfig.disableFlushOnUnload) {
                            // If we didn't add the normal set then attempt to add the pagehide and visibilitychange only
                            addPageHideEventListener(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace);
                        }
                    }));
                }
            };
            _self.getSender = function () {
                return _sender;
            };
            _self.unload = function (isAsync, unloadComplete, cbTimeout) {
                var unloadDone = false;
                var result;
                if (isAsync && !unloadComplete) {
                    result = createPromise(function (resolve) {
                        // Set the callback to the promise resolve callback
                        unloadComplete = resolve;
                    });
                }
                function _unloadCallback(unloadState) {
                    if (!unloadDone) {
                        unloadDone = true;
                        _initDefaults();
                        unloadComplete && unloadComplete(unloadState);
                    }
                }
                _self[_DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */](isAsync);
                _removePageEventHandlers();
                _core.unload && _core.unload(isAsync, _unloadCallback, cbTimeout);
                return result;
            };
            proxyFunctions(_self, _analyticsPlugin, [
                STR_GET_COOKIE_MGR,
                STR_TRACK_EVENT,
                STR_TRACK_PAGE_VIEW,
                "trackPageViewPerformance",
                STR_TRACK_EXCEPTION,
                "_onerror",
                STR_TRACK_TRACE,
                STR_TRACK_METRIC,
                STR_START_TRACK_PAGE,
                STR_STOP_TRACK_PAGE,
                STR_START_TRACK_EVENT,
                STR_STOP_TRACK_EVENT
            ]);
            proxyFunctions(_self, _getCurrentDependencies, [
                STR_TRACK_DEPENDENCY_DATA,
                "addDependencyListener",
                "addDependencyInitializer"
            ]);
            proxyFunctions(_self, _core, [
                STR_ADD_TELEMETRY_INITIALIZER,
                STR_POLL_INTERNAL_LOGS,
                "stopPollingInternalLogs",
                STR_GET_PLUGIN,
                "addPlugin",
                STR_EVT_NAMESPACE,
                "addUnloadCb",
                "getTraceCtx",
                "updateCfg",
                "onCfgChange"
            ]);
            proxyFunctions(_self, function () {
                var context = properties[_DYN_CONTEXT /* @min:%2econtext */];
                return context ? context.user : null;
            }, [
                STR_SET_AUTHENTICATED_USER_CONTEXT,
                STR_CLEAR_AUTHENTICATED_USER_CONTEXT
            ]);
            // Using a function to support the dynamic adding / removal of plugins, so this will always return the current value
            function _getCurrentDependencies() {
                return dependencies;
            }
            function _initDefaults() {
                _evtNamespace = createUniqueNamespace("AISKU");
                _houseKeepingNamespace = null;
                dependencies = null;
                properties = null;
                _sender = null;
                _snippetVersion = null;
                _throttleMgr = null;
                _iKeySentMessage = false;
                _cdnSentMessage = false;
                _sdkVerSentMessage = false;
                _cfgSyncPlugin = new CfgSyncPlugin();
            }
            function _removePageEventHandlers() {
                // Remove any registered event handlers
                if (_houseKeepingNamespace) {
                    removePageUnloadEventListener(null, _houseKeepingNamespace);
                    removePageHideEventListener(null, _houseKeepingNamespace);
                }
            }
            function _addUnloadHook(hooks) {
                _core.addUnloadHook(hooks);
            }
        });
    }
    // Analytics Plugin
// Removed Stub for AppInsightsSku.prototype.getCookieMgr.
// Removed Stub for AppInsightsSku.prototype.trackEvent.
// Removed Stub for AppInsightsSku.prototype.trackPageView.
// Removed Stub for AppInsightsSku.prototype.trackPageViewPerformance.
// Removed Stub for AppInsightsSku.prototype.trackException.
// Removed Stub for AppInsightsSku.prototype._onerror.
// Removed Stub for AppInsightsSku.prototype.trackTrace.
// Removed Stub for AppInsightsSku.prototype.trackMetric.
// Removed Stub for AppInsightsSku.prototype.startTrackPage.
// Removed Stub for AppInsightsSku.prototype.stopTrackPage.
// Removed Stub for AppInsightsSku.prototype.startTrackEvent.
// Removed Stub for AppInsightsSku.prototype.stopTrackEvent.
// Removed Stub for AppInsightsSku.prototype.addTelemetryInitializer.
    // Properties Plugin
// Removed Stub for AppInsightsSku.prototype.setAuthenticatedUserContext.
// Removed Stub for AppInsightsSku.prototype.clearAuthenticatedUserContext.
    // Dependencies Plugin
// Removed Stub for AppInsightsSku.prototype.trackDependencyData.
    // Misc
// Removed Stub for AppInsightsSku.prototype.flush.
// Removed Stub for AppInsightsSku.prototype.onunloadFlush.
// Removed Stub for AppInsightsSku.prototype.loadAppInsights.
// Removed Stub for AppInsightsSku.prototype.updateSnippetDefinitions.
// Removed Stub for AppInsightsSku.prototype.emptyQueue.
// Removed Stub for AppInsightsSku.prototype.pollInternalLogs.
// Removed Stub for AppInsightsSku.prototype.stopPollingInternalLogs.
// Removed Stub for AppInsightsSku.prototype.addHousekeepingBeforeUnload.
// Removed Stub for AppInsightsSku.prototype.getSender.
// Removed Stub for AppInsightsSku.prototype.unload.
// Removed Stub for AppInsightsSku.prototype.getPlugin.
// Removed Stub for AppInsightsSku.prototype.addPlugin.
// Removed Stub for AppInsightsSku.prototype.updateCfg.
// Removed Stub for AppInsightsSku.prototype.evtNamespace.
// Removed Stub for AppInsightsSku.prototype.addUnloadCb.
// Removed Stub for AppInsightsSku.prototype.addDependencyListener.
    /**
     * Add an dependency telemetry initializer callback function to allow populating additional properties or drop the request.
     * It is called after the dependency call has completed and any available performance details are available. A dependency
     * initializer is similar to the TelemetryInitializer function but it allows you to block the reporting of the dependency
     * request so that it doesn't count against the `maxAjaxCallsPerView`.
     * @param dependencyInitializer - The Dependency Telemetry Initializer function
     * @returns - A IDependencyInitializerHandler to enable the initializer to be removed
     */
    AppInsightsSku.prototype.addDependencyInitializer = function (dependencyInitializer) {
        return null;
    };
// Removed Stub for AppInsightsSku.prototype.getTraceCtx.
// Removed Stub for AppInsightsSku.prototype.onCfgChange.
    return AppInsightsSku;
}());
// tslint:disable-next-line
function _findSdkSourceFile() {
    if (_internalSdkSrc) {
        // Use the cached value
        return _internalSdkSrc;
    }
    var sdkSrc = null;
    var cdns = [
        "://js.monitor.azure.com/",
        "://az416426.vo.msecnd.net/"
    ];
    try {
        // Try and determine whether the sdk is being loaded from the CDN
        // currentScript is only valid during initial processing
        var scrpt = (document || {}).currentScript;
        if (scrpt) {
            sdkSrc = scrpt.src;
            // } else {
            //     // We need to update to at least typescript 2.9 for this to work :-(
            //     // Leaving as a stub for now so after we upgrade this breadcrumb is available
            //     let meta = import.meta;
            //     sdkSrc = (meta || {}).url;
            //     isModule = true;
        }
    }
    catch (e) {
        // eslint-disable-next-line no-empty
    }
    if (sdkSrc) {
        try {
            var url_1 = sdkSrc.toLowerCase();
            if (url_1) {
                var src_1 = "";
                arrForEach$1(cdns, function (value, idx) {
                    if (strIndexOf(url_1, value) !== -1) {
                        src_1 = "cdn" + (idx + 1);
                        if (strIndexOf(url_1, "/scripts/") === -1) {
                            if (strIndexOf(url_1, "/next/") !== -1) {
                                src_1 += "-next";
                            }
                            else if (strIndexOf(url_1, "/beta/") !== -1) {
                                src_1 += "-beta";
                            }
                        }
                        _internalSdkSrc = src_1 + ("");
                        return -1;
                    }
                });
            }
        }
        catch (e) {
            // eslint-disable-next-line no-empty
        }
        // Cache the found value so we don't have to look it up again
        _internalSdkSrc = sdkSrc;
    }
    return _internalSdkSrc;
}

var browser = function arch () {
  /**
   * User agent strings that indicate a 64-bit OS.
   * See: http://stackoverflow.com/a/13709431/292185
   */
  var userAgent = navigator.userAgent;
  if ([
    'x86_64',
    'x86-64',
    'Win64',
    'x64;',
    'amd64',
    'AMD64',
    'WOW64',
    'x64_64'
  ].some(function (str) {
    return userAgent.indexOf(str) > -1
  })) {
    return 'x64'
  }

  /**
   * Platform strings that indicate a 64-bit OS.
   * See: http://stackoverflow.com/a/19883965/292185
   */
  var platform = navigator.platform;
  if (platform === 'MacIntel' || platform === 'Linux x86_64') {
    return 'x64'
  }

  /**
   * CPU class strings that indicate a 64-bit OS.
   * See: http://stackoverflow.com/a/6267019/292185
   */
  if (navigator.cpuClass === 'x64') {
    return 'x64'
  }

  /**
   * If none of the above, assume the architecture is 32-bit.
   */
  return 'x86'
};

var uaParser = {exports: {}};

(function (module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.37
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License *//*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */
/////////////////////////////////////////////////////////////////////////////////

(function (window, undefined$1) {

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '1.0.37',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major',
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded',
        UA_MAX_LENGTH = 500;

    var AMAZON  = 'Amazon',
        APPLE   = 'Apple',
        ASUS    = 'ASUS',
        BLACKBERRY = 'BlackBerry',
        BROWSER = 'Browser',
        CHROME  = 'Chrome',
        EDGE    = 'Edge',
        FIREFOX = 'Firefox',
        GOOGLE  = 'Google',
        HUAWEI  = 'Huawei',
        LG      = 'LG',
        MICROSOFT = 'Microsoft',
        MOTOROLA  = 'Motorola',
        OPERA   = 'Opera',
        SAMSUNG = 'Samsung',
        SHARP   = 'Sharp',
        SONY    = 'Sony',
        XIAOMI  = 'Xiaomi',
        ZEBRA   = 'Zebra',
        FACEBOOK    = 'Facebook',
        CHROMIUM_OS = 'Chromium OS',
        MAC_OS  = 'Mac OS';

    ///////////
    // Helper
    //////////

    var extend = function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        enumerize = function (arr) {
            var enums = {};
            for (var i=0; i<arr.length; i++) {
                enums[arr[i].toUpperCase()] = arr[i];
            }
            return enums;
        },
        has = function (str1, str2) {
            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
        },
        lowerize = function (str) {
            return str.toLowerCase();
        },
        majorize = function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined$1;
        },
        trim = function (str, len) {
            if (typeof(str) === STR_TYPE) {
                str = str.replace(/^\s\s*/, EMPTY);
                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
            }
    };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    if (!regex[j]) { break; }
                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length === 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length === 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
                                    }
                                } else if (q.length === 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
                                }
                            } else {
                                this[q] = match ? match : undefined$1;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        strMapper = function (str, map) {

            for (var i in map) {
                // check if current value is array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined$1 : i;
                        }
                    }
                } else if (has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined$1 : i;
                }
            }
            return str;
    };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
            '1.0'   : '/8',
            '1.2'   : '/1',
            '1.3'   : '/3',
            '2.0'   : '/412',
            '2.0.2' : '/416',
            '2.0.3' : '/417',
            '2.0.4' : '/419',
            '?'     : '/'
        },
        windowsVersionMap = {
            'ME'        : '4.90',
            'NT 3.11'   : 'NT3.51',
            'NT 4.0'    : 'NT4.0',
            '2000'      : 'NT 5.0',
            'XP'        : ['NT 5.1', 'NT 5.2'],
            'Vista'     : 'NT 6.0',
            '7'         : 'NT 6.1',
            '8'         : 'NT 6.2',
            '8.1'       : 'NT 6.3',
            '10'        : ['NT 6.4', 'NT 10.0'],
            'RT'        : 'ARM'
    };

    //////////////
    // Regex map
    /////////////

    var regexes = {

        browser : [[

            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
            ], [VERSION, [NAME, 'Chrome']], [
            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
            ], [VERSION, [NAME, 'Edge']], [

            // Presto based
            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
            ], [NAME, VERSION], [
            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
            ], [VERSION, [NAME, OPERA+' Mini']], [
            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
            ], [VERSION, [NAME, OPERA]], [

            // Mixed
            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i            // Baidu
            ], [VERSION, [NAME, 'Baidu']], [
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
            // Trident based
            /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,             // Avant/IEMobile/SlimBrowser
            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer

            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
            /(heytap|ovi)browser\/([\d\.]+)/i,                                  // Heytap/Ovi
            /(weibo)__([\d\.]+)/i                                               // Weibo
            ], [NAME, VERSION], [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
            ], [VERSION, [NAME, 'UC'+BROWSER]], [
            /microm.+\bqbcore\/([\w\.]+)/i,                                     // WeChat Desktop for Windows Built-in Browser
            /\bqbcore\/([\w\.]+).+microm/i,
            /micromessenger\/([\w\.]+)/i                                        // WeChat
            ], [VERSION, [NAME, 'WeChat']], [
            /konqueror\/([\w\.]+)/i                                             // Konqueror
            ], [VERSION, [NAME, 'Konqueror']], [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
            ], [VERSION, [NAME, 'IE']], [
            /ya(?:search)?browser\/([\w\.]+)/i                                  // Yandex
            ], [VERSION, [NAME, 'Yandex']], [
            /slbrowser\/([\w\.]+)/i                                             // Smart Lenovo Browser
            ], [VERSION, [NAME, 'Smart Lenovo '+BROWSER]], [
            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
            ], [VERSION, [NAME, FIREFOX+' Focus']], [
            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
            ], [VERSION, [NAME, OPERA+' Touch']], [
            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
            ], [VERSION, [NAME, 'Coc Coc']], [
            /dolfin\/([\w\.]+)/i                                                // Dolphin
            ], [VERSION, [NAME, 'Dolphin']], [
            /coast\/([\w\.]+)/i                                                 // Opera Coast
            ], [VERSION, [NAME, OPERA+' Coast']], [
            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
            ], [VERSION, [NAME, 'MIUI '+BROWSER]], [
            /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, FIREFOX]], [
            /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
            ], [[NAME, '360 ' + BROWSER]], [
            /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
            ], [[NAME, /(.+)/, '$1 ' + BROWSER], VERSION], [                    // Oculus/Sailfish/HuaweiBrowser/VivoBrowser
            /samsungbrowser\/([\w\.]+)/i                                        // Samsung Internet
            ], [VERSION, [NAME, SAMSUNG + ' Internet']], [
            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [
            /metasr[\/ ]?([\d\.]+)/i                                            // Sogou Explorer
            ], [VERSION, [NAME, 'Sogou Explorer']], [
            /(sogou)mo\w+\/([\d\.]+)/i                                          // Sogou Mobile
            ], [[NAME, 'Sogou Mobile'], VERSION], [
            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
            /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i                        // QQBrowser/2345 Browser
            ], [NAME, VERSION], [
            /(lbbrowser)/i,                                                     // LieBao Browser
            /\[(linkedin)app\]/i                                                // LinkedIn App for iOS & Android
            ], [NAME], [

            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
            ], [[NAME, FACEBOOK], VERSION], [
            /(Klarna)\/([\w\.]+)/i,                                             // Klarna Shopping Browser for iOS & Android
            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,                             // Kakao App
            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,                                  // Naver InApp
            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
            /(alipay)client\/([\w\.]+)/i,                                       // Alipay
            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i                     // Chromium/Instagram/Snapchat
            ], [NAME, VERSION], [
            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
            ], [VERSION, [NAME, 'GSA']], [
            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i                        // TikTok
            ], [VERSION, [NAME, 'TikTok']], [

            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
            ], [VERSION, [NAME, CHROME+' Headless']], [

            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
            ], [[NAME, CHROME+' WebView'], VERSION], [

            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
            ], [VERSION, [NAME, 'Android '+BROWSER]], [

            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i                      // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [
            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i                // Safari & Safari Mobile
            ], [VERSION, NAME], [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
            ], [NAME, [VERSION, strMapper, oldSafariMap]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
            ], [VERSION, [NAME, FIREFOX+' Reality']], [
            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
            /(links) \(([\w\.]+)/i,                                             // Links
            /panasonic;(viera)/i                                                // Panasonic Viera
            ], [NAME, VERSION], [
            
            /(cobalt)\/([\w\.]+)/i                                              // Cobalt
            ], [NAME, [VERSION, /master.|lts./, ""]]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
            ], [[ARCHITECTURE, 'ia32']], [

            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
            ], [[ARCHITECTURE, 'arm64']], [

            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
            ], [[ARCHITECTURE, 'armhf']], [

            // PocketPC mistakenly identified as PowerPC
            /windows (ce|mobile); ppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, lowerize]]
        ],

        device : [[

            //////////////////////////
            // MOBILES & TABLETS
            /////////////////////////

            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
            /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
            /samsung[- ]([-\w]+)/i,
            /sec-(sgh\w+)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [

            // Apple
            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i                          // iPod/iPhone
            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [
            /(macintosh);/i
            ], [MODEL, [VENDOR, APPLE]], [

            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [

            // Huawei
            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
            /(?:huawei|honor)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [

            // Xiaomi
            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,                  // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,        // Xiaomi Redmi 'numeric' models
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
            /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,                     // Redmi Pad
            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [

            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [

            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

            // Realme
            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [

            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
            /\blg-?([\d\w]+) bui/i
            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [

            // Lenovo
            /(ideatab[-\w ]+)/i,
            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            // Nokia
            /(?:maemo|nokia).*(n900|lumia \d+)/i,
            /nokia[-_ ]?([-\w\.]*)/i
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

            // Google
            /(pixel c)\b/i                                                      // Google Pixel C
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [

            // Sony
            /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [

            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,                             // Kindle Fire without Silk / Echo Show
            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [

            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i                                                    // BlackBerry 10
            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [

            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [

            // HTC
            /(nexus 9)/i                                                        // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC

            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [
                
            // Ulefone
            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ], [MODEL, [VENDOR, 'Ulefone'], [TYPE, MOBILE]], [

            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
            /(asus)-?(\w+)/i,                                                   // Asus
            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
            /(jolla)/i,                                                         // Jolla
            /(oppo) ?([\w ]+) bui/i                                             // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /(kobo)\s(ereader|touch)/i,                                         // Kobo
            /(archos) (gamepad2?)/i,                                            // Archos
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(surface duo)/i                                                    // Surface Duo
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
            /(u304aa)/i                                                         // AT&T
            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
            /\bsie-(\w*)/i                                                      // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
            /\b(rct\w+) b/i                                                     // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
            /\b(tm\d{3}\w+) b/i
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
            /\b(k88) b/i                                                        // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
            /\b(ph-1) /i                                                        // Essential PH-1
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
            /\btu_(1491) b/i                                                    // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
            /(sprint) (\w+)/i                                                   // Sprint Phones
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [

            ///////////////////
            // SMARTTVS
            ///////////////////

            /smart-tv.+(samsung)/i                                              // Samsung
            ], [VENDOR, [TYPE, SMARTTV]], [
            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
            /(apple) ?tv/i                                                      // Apple TV
            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
            /droid.+aft(\w+)( bui|\))/i                                         // Fire TV
            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
            /\(dtv[\);].+(aquos)/i,
            /(aquos-tv[\w ]+)\)/i                                               // Sharp
            ], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],[
            /(bravia[\w ]+)( bui|\))/i                                              // Sony
            ], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [
            /(mitv-\w{5}) bui/i                                                 // Xiaomi
            ], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [
            /Hbbtv.*(technisat) (.*);/i                                         // TechniSAT
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i         // HbbTV devices
            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
            ], [[TYPE, SMARTTV]], [

            ///////////////////
            // CONSOLES
            ///////////////////

            /(ouya)/i,                                                          // Ouya
            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
            /droid.+; (shield) bui/i                                            // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
            /(playstation [345portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [

            ///////////////////
            // WEARABLES
            ///////////////////

            /((pebble))app/i                                                    // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i                              // Apple Watch
            ], [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]], [
            /droid.+; (glass) \d/i                                              // Google Glass
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
            /droid.+; (wt63?0{2,3})\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
            /(quest( 2| pro)?)/i                                                // Oculus Quest
            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [

            ///////////////////
            // EMBEDDED
            ///////////////////

            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
            ], [VENDOR, [TYPE, EMBEDDED]], [
            /(aeobc)\b/i                                                        // Echo Dot
            ], [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]], [

            ////////////////////
            // MIXED (GENERIC)
            ///////////////////

            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i    // Android Phones from Unidentified Vendors
            ], [MODEL, [TYPE, MOBILE]], [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
            ], [MODEL, [TYPE, TABLET]], [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
            ], [[TYPE, TABLET]], [
            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i    // Unidentifiable Mobile
            ], [[TYPE, MOBILE]], [
            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, EDGE+'HTML']], [

            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
            ], [VERSION, [NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i,                                      // iCab
            /\b(libweb)/i
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows
            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i             // Windows Phone
            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
            /windows nt 6\.2; (arm)/i,                                        // Windows RT
            /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ], [[VERSION, strMapper, windowsVersionMap], [NAME, 'Windows']], [

            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
            /cfnetwork\/.+darwin/i
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
            ], [[NAME, MAC_OS], [VERSION, /_/g, '.']], [

            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i                    // Android-x86/HarmonyOS
            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
            /\((series40);/i                                                    // Series 40
            ], [NAME, VERSION], [
            /\(bb(10);/i                                                        // BlackBerry 10
            ], [VERSION, [NAME, BLACKBERRY]], [
            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
            ], [VERSION, [NAME, 'Symbian']], [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ], [VERSION, [NAME, FIREFOX+' OS']], [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
            ], [VERSION, [NAME, 'webOS']], [
            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i                              // watchOS
            ], [VERSION, [NAME, 'watchOS']], [

            // Google Chromecast
            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
            ], [VERSION, [NAME, CHROME+'cast']], [
            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i                                  // Chromium OS
            ], [[NAME, CHROMIUM_OS], VERSION],[

            // Smart TVs
            /panasonic;(viera)/i,                                               // Panasonic Viera
            /(netrange)mmh/i,                                                   // Netrange
            /(nettv)\/(\d+\.[\w\.]+)/i,                                         // NetTV

            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)

            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,                                                // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i                                                    // Haiku
            ], [NAME, VERSION], [
            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
            ], [[NAME, 'Solaris'], VERSION], [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
            /(unix) ?([\w\.]*)/i                                                // UNIX
            ], [NAME, VERSION]
        ]
    };

    /////////////////
    // Constructor
    ////////////////

    var UAParser = function (ua, extensions) {

        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined$1;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(ua, extensions).getResult();
        }

        var _navigator = (typeof window !== UNDEF_TYPE && window.navigator) ? window.navigator : undefined$1;
        var _ua = ua || ((_navigator && _navigator.userAgent) ? _navigator.userAgent : EMPTY);
        var _uach = (_navigator && _navigator.userAgentData) ? _navigator.userAgentData : undefined$1;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;

        this.getBrowser = function () {
            var _browser = {};
            _browser[NAME] = undefined$1;
            _browser[VERSION] = undefined$1;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
                _browser[NAME] = 'Brave';
            }
            return _browser;
        };
        this.getCPU = function () {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined$1;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function () {
            var _device = {};
            _device[VENDOR] = undefined$1;
            _device[MODEL] = undefined$1;
            _device[TYPE] = undefined$1;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
                _device[TYPE] = MOBILE;
            }
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = 'iPad';
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function () {
            var _engine = {};
            _engine[NAME] = undefined$1;
            _engine[VERSION] = undefined$1;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function () {
            var _os = {};
            _os[NAME] = undefined$1;
            _os[VERSION] = undefined$1;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != 'Unknown') {
                _os[NAME] = _uach.platform  
                                    .replace(/chrome os/i, CHROMIUM_OS)
                                    .replace(/macos/i, MAC_OS);           // backward compatibility
            }
            return _os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return _ua;
        };
        this.setUA = function (ua) {
            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    {
        // nodejs env
        if (module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : commonjsGlobal);
}(uaParser, uaParser.exports));

const parser = uaParser.exports;

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0',
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsAstral = '[' + rsAstralRange + ']',
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
  rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
  rsUpper + '+' + rsOptUpperContr,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 'ss'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol$1 = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

var lodash_startcase = startCase;

function removeEmail(message) {
    if (typeof message !== 'string') {
        return message;
    }
    const regex = new RegExp(/[a-zA-Z0-9+._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,24}/, 'g');
    return message.replace(regex, 'xxxx');
}

const CIRCULAR = Symbol('circular');
const markCircularReferences = (val, refs) => {
    refs = refs !== null && refs !== void 0 ? refs : new WeakSet();
    if (!val || typeof val !== 'object' || Object.keys(val).length === 0) {
        return val;
    }
    if (refs.has(val)) {
        return CIRCULAR;
    }
    refs.add(val);
    const obj = (Array.isArray(val) ? [] : {});
    for (const idx in val) {
        obj[idx] = markCircularReferences(val[idx], refs);
    }
    refs.delete(val);
    return obj;
};

function updateRecursively(object, updateFn) {
    const markedObject = markCircularReferences(object);
    return traverseAndUpdate(markedObject, updateFn);
}
function traverseAndUpdate(object, updateFn) {
    if (typeof object !== 'object' && !Array.isArray(object)) {
        return updateFn(object);
    }
    if (Array.isArray(object)) {
        return object.map((value) => traverseAndUpdate(value, updateFn));
    }
    const updatedObject = {};
    for (const [key, value] of Object.entries(object)) {
        if (value === CIRCULAR) {
            continue;
        }
        updatedObject[key] = traverseAndUpdate(value, updateFn);
    }
    return updatedObject;
}

var WellKnownApplication;
(function (WellKnownApplication) {
    WellKnownApplication["AutomationHub"] = "UiPath.AutomationHub";
    WellKnownApplication["Orchestrator"] = "UiPath.Orchestrator";
    WellKnownApplication["AutomationStore"] = "UiPath.AutomationStore";
    WellKnownApplication["ProcessMining"] = "UiPath.ProcessMining";
    WellKnownApplication["AutomationOps"] = "UiPath.AutomationOps";
    WellKnownApplication["TaskCapture"] = "UiPath.TaskCapture";
    WellKnownApplication["Insights"] = "UiPath.Insights";
    WellKnownApplication["Solutions"] = "UiPath.Solutions";
    WellKnownApplication["AutomationCloud"] = "UiPath.AutomationCloud";
    WellKnownApplication["AutomationSuite"] = "UiPath.AutomationSuite";
    WellKnownApplication["PortalShell"] = "UiPath.PortalShell";
    WellKnownApplication["AutoPilot"] = "UiPath.AutoPilot";
})(WellKnownApplication || (WellKnownApplication = {}));

var WellKnownEvent;
(function (WellKnownEvent) {
    WellKnownEvent["Login"] = "Authenticate.LogIn";
    WellKnownEvent["Start"] = "Application.Start";
    WellKnownEvent["Navigate"] = "Application.Navigate";
    WellKnownEvent["Error"] = "Application.Error";
})(WellKnownEvent || (WellKnownEvent = {}));

var SeverityLevel;
(function (SeverityLevel) {
    SeverityLevel["Info"] = "Info";
    SeverityLevel["Normal"] = "Normal";
    SeverityLevel["Major"] = "Major";
    SeverityLevel["Critical"] = "Critical";
})(SeverityLevel || (SeverityLevel = {}));

var DeploymentType;
(function (DeploymentType) {
    /**
     * The application is deployed via MSI and hosted on-prem.
     */
    DeploymentType["Standalone"] = "Standalone";
    /**
     * The application is deployed onto a kubernetes cluster on-prem.
     */
    DeploymentType["AutomationSuite"] = "AutomationSuite";
    /**
     * The application is hosted in our Cloud.
     */
    DeploymentType["AutomationCloud"] = "AutomationCloud";
    /**
     * The application is hosted in an external cloud.
     */
    DeploymentType["External"] = "External";
})(DeploymentType || (DeploymentType = {}));

class ApplicationInsightDriver {
    constructor(instance, isInitialized = false) {
        this._instance = instance;
        this._isInitialized = isInitialized;
    }
    initialize() {
        if (this._isInitialized) {
            return;
        }
        this._instance.loadAppInsights();
        this._isInitialized = true;
    }
    track(name, properties) {
        properties = updateRecursively(properties, removeEmail);
        this._instance
            .trackEvent({
            name,
            properties,
        });
    }
    trackException(error, severityLevel, properties) {
        properties = updateRecursively(properties, removeEmail);
        this._instance
            .trackException({
            exception: error,
            severityLevel: appInsightsSeverityMap[severityLevel],
            properties,
        });
    }
    trackTrace(message, severityLevel, properties) {
        properties = updateRecursively(properties, removeEmail);
        this._instance
            .trackTrace({
            message,
            severityLevel: appInsightsSeverityMap[severityLevel],
            properties,
        });
    }
    trackMetric(metricTrackingOptions, properties) {
        properties = updateRecursively(properties, removeEmail);
        this._instance
            .trackMetric(Object.assign(Object.assign({}, metricTrackingOptions), { properties }));
    }
    trackPageView(pageViewTrackingOptions) {
        if (pageViewTrackingOptions && Object.keys(pageViewTrackingOptions).length) {
            pageViewTrackingOptions = updateRecursively(pageViewTrackingOptions, removeEmail);
        }
        this._instance.trackPageView(pageViewTrackingOptions);
    }
    trackPageViewPerformance(pageViewTrackingOptions) {
        if (pageViewTrackingOptions && Object.keys(pageViewTrackingOptions).length) {
            pageViewTrackingOptions = updateRecursively(pageViewTrackingOptions, removeEmail);
        }
        this._instance.trackPageViewPerformance(pageViewTrackingOptions);
    }
    addTelemetryInitializer(telemetryInitializer) {
        this._instance.addTelemetryInitializer(telemetryInitializer);
    }
    resetOperation(name) {
        this.resetOperationId();
        this._instance.context.telemetryTrace.name = name;
    }
    resetOperationId() {
        this._instance.context.telemetryTrace.traceID = generateW3CId();
    }
}
const appInsightsSeverityMap = {
    [SeverityLevel.Info]: 1,
    [SeverityLevel.Normal]: 2,
    [SeverityLevel.Major]: 3,
    [SeverityLevel.Critical]: 4,
};

class ApplicationInsightDriverBuilder {
    constructor() {
        this._isInitialized = false;
    }
    withConfig({ instrumentationKey, connectionString, disableFetchTracking, disableAjaxTracking, disableExceptionTracking, accountId, appId, }) {
        const isTelemetryDisabled = !!((instrumentationKey === null || instrumentationKey === void 0 ? void 0 : instrumentationKey.trim()) && (connectionString === null || connectionString === void 0 ? void 0 : connectionString.trim()));
        this._instance = new AppInsightsSku({
            config: {
                connectionString,
                instrumentationKey,
                disableExceptionTracking: !!disableExceptionTracking,
                disableTelemetry: isTelemetryDisabled,
                disableFetchTracking: !!disableFetchTracking,
                disableAjaxTracking: !!disableAjaxTracking,
                disableCookiesUsage: true,
                accountId,
                appId,
            },
        });
        return this;
    }
    withInstance(instance, isInitialized = false) {
        this._instance = instance;
        this._isInitialized = isInitialized;
        return this;
    }
    build() {
        if (this._instance) {
            return new ApplicationInsightDriver(this._instance, this._isInitialized);
        }
        throw new Error(`Not able to build AppInsights Driver.`);
    }
}
const AppInsightDriverBuilder = new ApplicationInsightDriverBuilder();

const browserInfo = () => {
    const touchCapable = 'ontouchstart' in window
        || window.DocumentTouch && document instanceof window.DocumentTouch
        || navigator.maxTouchPoints > 0
        || window.navigator.msMaxTouchPoints > 0;
    return {
        screenWidth: window.screen.width,
        screenHeight: window.screen.height,
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        orientation: window.screen.orientation.type.includes('landscape')
            ? 'landscape'
            : 'portrait',
        touchCapable,
    };
};

const DEVICE_TYPE = 'browser';
const sessionInfo = (store) => {
    var _a;
    const parsed = parser(navigator.userAgent);
    return {
        browserVersion: `${parsed.browser.name} ${parsed.browser.version}`,
        oSVersion: `${parsed.os.name} ${parsed.os.version}`,
        oSArchitecture: browser(),
        devicePixelRatio: window.devicePixelRatio,
        productLanguage: store.language,
        systemLanguage: navigator.language,
        deviceType: (_a = parsed.device.type) !== null && _a !== void 0 ? _a : DEVICE_TYPE,
    };
};

function extractPersona() {
    var _a;
    return (_a = localStorage.getItem('PORTAL_SHELL_PERSONA')) !== null && _a !== void 0 ? _a : 'UNKNOWN';
}

const platformInfo = (store, deploymentType) => {
    var _a, _b;
    switch (deploymentType) {
        case DeploymentType.Standalone:
            return {
                localUserId: store.localUserId,
                tenantId: store.tenantId,
                sessionId: store.sessionId,
                installationId: store.installationId,
                productVersion: store.productVersion,
                isHost: (_a = store.isHost) !== null && _a !== void 0 ? _a : false,
            };
        case DeploymentType.AutomationSuite:
            return {
                cloudUserId: store.cloudUserId,
                cloudOrganizationId: store.cloudOrganizationId,
                cloudTenantId: store.cloudTenantId,
                sessionId: store.sessionId,
                clusterId: store.clusterId,
                productVersion: store.productVersion,
                isHost: (_b = store.isHost) !== null && _b !== void 0 ? _b : false,
                persona: extractPersona(),
            };
        case DeploymentType.External:
            return {
                localUserId: store.localUserId,
                externalOrganizationId: store.externalOrganizationId,
                productVersion: store.productVersion,
            };
        default:
            return {
                cloudUserId: store.cloudUserId,
                cloudOrganizationId: store.cloudOrganizationId,
                cloudTenantId: store.cloudTenantId,
                sessionId: store.sessionId,
                productVersion: store.productVersion,
                serverRegion: store.serverRegion,
                subscriptionType: store.subscriptionType,
                persona: extractPersona(),
            };
    }
};

const assertDefined = (key, value) => {
    if (value == null) {
        throw new Error(`Property ${key} is not defined.`);
    }
    return value;
};

const pascalCase = (key) => lodash_startcase(key).replace(/ /g, '');

const pascalify = (obj, shouldMark = true) => {
    if (shouldMark) {
        obj = markCircularReferences(obj);
    }
    const result = {};
    if (!obj || typeof obj !== 'object') {
        return obj;
    }
    for (const key in obj) {
        const value = obj[key];
        if (Array.isArray(value)) {
            result[pascalCase(key)] = value.filter(item => item !== CIRCULAR).map(item => pascalify(item, false));
        }
        else if (typeof value === 'object' && Object.keys(value).length > 0) {
            result[pascalCase(key)] = pascalify(value, false);
        }
        else if (value !== CIRCULAR) {
            result[pascalCase(key)] = value;
        }
    }
    return result;
};

const eventToInvocationSource = (event) => {
    const ev = assertDefined('event', event);
    const detail = assertDefined('event.detail', ev.detail);
    return detail === 0 ? 'keyboard' : 'mouse';
};

const coerceInvocationSource = (source) => typeof source === 'string'
    ? source
    : eventToInvocationSource(source);

const TelemetryDataKey = {
    language: {
        key: `language`,
        requiredOnDeployment: [
            DeploymentType.AutomationCloud,
            DeploymentType.AutomationSuite,
            DeploymentType.Standalone,
        ],
    },
    cloudUserId: {
        key: `cloudUserId`,
        requiredOnDeployment: [
            DeploymentType.AutomationCloud,
            DeploymentType.AutomationSuite,
        ],
    },
    cloudOrganizationId: {
        key: `cloudOrganizationId`,
        requiredOnDeployment: [
            DeploymentType.AutomationCloud,
            DeploymentType.AutomationSuite,
        ],
    },
    cloudTenantId: {
        key: `cloudTenantId`,
        requiredOnDeployment: [
            DeploymentType.AutomationCloud,
            DeploymentType.AutomationSuite,
        ],
    },
    sessionId: {
        key: `sessionId`,
        requiredOnDeployment: [DeploymentType.AutomationCloud],
    },
    productVersion: {
        key: `productVersion`,
        requiredOnDeployment: [
            DeploymentType.AutomationSuite,
            DeploymentType.Standalone,
        ],
    },
    installationId: {
        key: `installationId`,
        requiredOnDeployment: [DeploymentType.Standalone],
    },
    clusterId: {
        key: `clusterId`,
        requiredOnDeployment: [DeploymentType.AutomationSuite],
    },
    localUserId: {
        key: `localUserId`,
        requiredOnDeployment: [DeploymentType.Standalone],
    },
    tenantId: {
        key: `tenantId`,
        requiredOnDeployment: [DeploymentType.Standalone],
    },
    externalOrganizationId: {
        key: `externalOrganizationId`,
        requiredOnDeployment: [],
    },
};
const ALL_STORE_PROPERTIES_NAMES = Object.freeze(Object.keys(TelemetryDataKey));
Object.freeze(ALL_STORE_PROPERTIES_NAMES.filter(property => TelemetryDataKey[property].requiredOnDeployment
    .includes(DeploymentType.AutomationCloud)));
Object.freeze(ALL_STORE_PROPERTIES_NAMES.filter(property => TelemetryDataKey[property].requiredOnDeployment
    .includes(DeploymentType.AutomationSuite)));
Object.freeze(ALL_STORE_PROPERTIES_NAMES.filter(property => TelemetryDataKey[property].requiredOnDeployment
    .includes(DeploymentType.Standalone)));
Object.freeze(ALL_STORE_PROPERTIES_NAMES.filter(property => TelemetryDataKey[property].requiredOnDeployment
    .includes(DeploymentType.External)));
class TelemetryStorage {
    constructor(deploymentType) {
        this._store = new Map();
        const properties = Object.keys(TelemetryDataKey);
        properties.forEach(property => {
            const { key, requiredOnDeployment: requiredOnEnvironment, } = TelemetryDataKey[property];
            Object.defineProperty(this, property, {
                set: (value) => this._store.set(key, value),
                get: () => {
                    if (!requiredOnEnvironment.includes(deploymentType)) {
                        return this._store.get(key);
                    }
                    return this._safeGet(key);
                },
            });
        });
    }
    clear() {
        this._store.clear();
    }
    _safeGet(key) {
        return assertDefined(key, this._store.get(key));
    }
}

class ObjectStorage {
    constructor() {
        this._store = new Map();
    }
    set(property, value) {
        if (['object', 'function'].includes(typeof value)) {
            throw new Error(`ObjectStorage can't store ${typeof value}.`);
        }
        this._store.set(property, value);
    }
    get(property) {
        return this._store.get(property);
    }
    delete(key) {
        this._store.delete(key);
    }
    clear() {
        this._store.clear();
    }
    object() {
        return Object.fromEntries(this._store.entries());
    }
}

function objectPropertyExtractor(o) {
    const extractor = function ({ object, references, }) {
        const properties = {};
        const keys = Object.keys(object);
        keys.forEach(key => {
            const isOwnProperty = Object.prototype.hasOwnProperty.call(object, key);
            if (!isOwnProperty) {
                return;
            }
            const value = object[key];
            if (value == null) {
                return;
            }
            if (typeof value === 'string' || typeof value === 'number') {
                properties[key] = value;
            }
            if (typeof value === 'object' && !references.has(value)) {
                references.add(value);
                const nestedProperties = extractor({
                    object: value,
                    references,
                });
                Object
                    .keys(nestedProperties)
                    .forEach(nestedKey => {
                    properties[`${key}_${nestedKey}`] = nestedProperties[nestedKey];
                });
            }
        });
        return properties;
    };
    return extractor({
        object: o,
        references: new WeakSet([o]),
    });
}

function removeQueryParams(url) {
    const urlObj = new URL(url);
    urlObj.search = '';
    return urlObj.toString();
}

/**
 * The Tracker class is responsible for tracking user events and sending them to the telemetry server.
 * @export
 * @class Tracker
 */
class Tracker {
    get _properties() {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this._metadata.object()), browserInfo()), platformInfo(this._store, this._deploymentType)), { currentRoute: window.location.pathname, applicationName: this._applicationName, deploymentType: this._deploymentType });
    }
    /**
     *
     * @param deploymentType The deployment type of the application.
     * @param _applicationName - The application name is used to identify the application in the telemetry server.
     * @param _driver - The driver used to send the telemetry data to the telemetry server.
     */
    constructor(_deploymentType, _applicationName, _driver) {
        this._deploymentType = _deploymentType;
        this._applicationName = _applicationName;
        this._driver = _driver;
        this._queue = [];
        this._isInitialized = false;
        this._preserveQueryParams = false;
        this._store = new TelemetryStorage(_deploymentType);
        this._metadata = new ObjectStorage();
    }
    /**
     * This method is used to initialize the telemetry client.
     * @param isDevelopment - specify to get more context on potential errors
     * @param isPageViewTrackingEnabled - on by default for AutomationCloud
     * @param isPageViewPerformanceTrackingEnabled - off by default
     * @param pageViewTrackingOptions - if passed, the options are added while tracking page view
     * @param initializer - use to mutate or filter out events
     */
    initialize({ isDevelopment = false, isPageViewTrackingEnabled = this._deploymentType === DeploymentType.AutomationCloud, isPageViewPerformanceTrackingEnabled = false, pageViewTrackingOptions, language, initializer, preserveQueryParams = false, }) {
        this._preserveQueryParams = preserveQueryParams;
        this._store.isDevelopment = isDevelopment;
        this._store.isPageViewTrackingEnabled = isPageViewTrackingEnabled;
        this._store.isPageViewPerformanceTrackingEnabled = isPageViewPerformanceTrackingEnabled;
        this._store.pageViewTrackingOptions = pageViewTrackingOptions;
        this._driver.initialize();
        this.setLanguage(language);
        if (initializer) {
            this._driver.addTelemetryInitializer(initializer);
        }
        this._isInitialized = true;
        this._dequeue();
    }
    /**
     * This will store the application language in the telemetry store.
     * @param language The language of the application.
     */
    setLanguage(language) {
        this._store.language = language;
    }
    /**
     * This will store the platform information in the telemetry store.
     * @param info - The platform information to send to the telemetry server.
     */
    setPlatformInfo(info) {
        const infoTyped = info;
        Object.keys(info)
            .forEach((key) => {
            const value = infoTyped[key];
            if (value == null) {
                return;
            }
            // FIXME: ugly cast because of https://github.com/microsoft/TypeScript/issues/38735
            this._store[key] = value;
        });
    }
    /**
     * This will set metadata attached to all telemetry events.
     *
     * @param properties - The properties to store in the global store.
     */
    setMetadata(properties) {
        Object.entries(properties)
            .forEach(([property, value]) => {
            if (value == null) {
                return;
            }
            this._metadata.set(property, value);
        });
    }
    /**
     * This method is used to track a user event.
     * All of the common properties are extracted automatically and attached to the provided details.
     * @param event - The event to track.
     * @param details - The details of the event.
     */
    trackEvent(event, ...[details]) {
        try {
            const invocationSource = details === null || details === void 0 ? void 0 : details.invocationSource;
            const invocationSourcePatch = invocationSource ?
                { invocationSource: coerceInvocationSource(invocationSource) }
                : {};
            const navigationTargetRoutePatch = event === WellKnownEvent.Navigate && details.targetRoute
                ? { targetRoute: details.targetRoute }
                : {};
            const navigationCurrentRoutePatch = event === WellKnownEvent.Navigate && details.currentRoute
                ? { currentRoute: details.currentRoute }
                : {};
            const getProperties = () => pascalify(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, this._properties), details), invocationSourcePatch), navigationTargetRoutePatch), navigationCurrentRoutePatch));
            this._enqueue(() => {
                this._driver.track(event.toString(), getProperties());
            });
        }
        catch (error) {
            if (!this._store.isDevelopment) {
                return;
            }
            // eslint-disable-next-line no-console
            console.error('Telemetry event failed was not sent:', {
                event,
                details,
                error,
            });
        }
    }
    /**
     * This method is used to track a navigate event.
     * @param details - The details of the navigate event.
     */
    trackNavigation(details) {
        this._driver.resetOperation(details.targetRoute);
        this.trackEvent(WellKnownEvent.Navigate, Object.assign({}, details));
        const uri = this._preserveQueryParams ? window.location.href : removeQueryParams(window.location.href);
        const trackingOptions = Object.assign({ uri, properties: { refUri: uri } }, this._store.pageViewTrackingOptions);
        if (this._store.isPageViewTrackingEnabled) {
            this._driver.trackPageView(trackingOptions);
        }
        if (this._store.isPageViewPerformanceTrackingEnabled) {
            this._driver.trackPageViewPerformance(trackingOptions);
        }
    }
    /**
     * This method is used to track a login event.
     * @param details - The details of the login event.
     */
    trackLogin(details) {
        this.trackEvent(WellKnownEvent.Login, Object.assign({}, details));
    }
    /**
     * This method is used to track when a new application load (bootstrap) occurs.
     * @param details - The details of the app start event.
     */
    trackApplicationStart(details = {}) {
        this._enqueue(() => this.trackEvent(WellKnownEvent.Start, Object.assign(Object.assign({}, details), sessionInfo(this._store))));
    }
    /**
     * This method is used to track when an application application error is thrown.
     * @param error - The error object thrown.
     * @param severityLevel - How severe the error is, how big of an impact it has on the application. Defaults to `Normal`
     */
    trackError(error, severityLevel = SeverityLevel.Normal, details = {}) {
        if (error instanceof Error) {
            try {
                const properties = pascalify(Object.assign(Object.assign(Object.assign({}, this._properties), details), objectPropertyExtractor(error)));
                this._enqueue(() => {
                    this._driver.trackException(error, severityLevel, properties);
                });
            }
            catch (e) {
                if (this._store.isDevelopment) {
                    // eslint-disable-next-line no-console
                    console.error('trackError failed', {
                        exceptionToTrack: error,
                        severityLevel,
                        error: e,
                        details,
                    });
                }
            }
            return;
        }
        if (this._store.isDevelopment) {
            // eslint-disable-next-line no-console
            console.error('trackError was called with a bad parameter', { error });
        }
    }
    /**
     * This method is used to track trace message.
     * @param message - The trace message.
     * @param severityLevel - How severe the error is, how big of an impact it has on the application. Defaults to `Normal`
     */
    trackTrace(message, severityLevel = SeverityLevel.Normal, details) {
        try {
            const properties = pascalify(Object.assign(Object.assign({}, this._properties), details));
            this._enqueue(() => {
                this._driver.trackTrace(message, severityLevel, properties);
            });
        }
        catch (e) {
            if (this._store.isDevelopment) {
                // eslint-disable-next-line no-console
                console.error('trackTrace failed', {
                    message,
                    severityLevel,
                    error: e,
                    details,
                });
            }
        }
    }
    /**
     * This method is used to track a metric.
     * @param metric - The metric object.
     */
    trackMetric(metric, details) {
        try {
            const properties = pascalify(Object.assign(Object.assign({}, this._properties), details));
            this._enqueue(() => {
                this._driver.trackMetric(metric, properties);
            });
        }
        catch (e) {
            if (this._store.isDevelopment) {
                // eslint-disable-next-line no-console
                console.error('trackMetric failed', {
                    metric,
                    error: e,
                    details,
                });
            }
        }
    }
    /**
     * This method is used to reset the operation id.
     * It is recommended to reset it per request, see:
     * https://learn.microsoft.com/en-us/azure/azure-monitor/app/data-model-complete
     */
    resetOperationId() {
        this._driver.resetOperationId();
    }
    _dequeue() {
        this._queue.forEach(trackingCallback => trackingCallback());
    }
    _enqueue(cb) {
        if (this._isInitialized) {
            cb();
        }
        else {
            this._queue.push(cb);
        }
    }
}

const Features = {
    /** Shows push notification */
    EnableNotification: {
        name: 'enableNotificationSettings',
        defaultValue: false,
    },
    /** Shows push notification preview tag */
    DisableNotificationPreview: {
        name: 'disableNotificationPreview',
        defaultValue: false,
    },
    /** Shows notification popout option */
    EnableNotificationsPopoutPage: {
        name: 'enableNotificationsPopoutPage',
        defaultValue: false,
    },
    EnableNotificationFilters: {
        name: 'apollo-enableNotificationFilters',
        defaultValue: false,
    },
    /** Routes notification api to portal */
    EnableNotificationProxy: {
        name: 'apollo-enableNotificationProxy',
        defaultValue: false,
    },
    NotificationPublishersRefetchThrottleMs: {
        name: 'apollo-notificationPublishersRefetchThrottleMs',
        defaultValue: 0,
    },
    /** Enable Local storage overrides for env config fields */
    EnablePortalShellLocalStorageOverrides: {
        name: 'enable-portal-shell-localstorage-overrides',
        defaultValue: false,
    },
    /** Enable using self auth in people picker */
    EnablePortalShellSelfAuthPeoplePicker: {
        name: 'enable-portal-shell-self-auth-people-picker',
        defaultValue: false,
    },
    /** Enable Global Focus */
    EnableGlobalFocus: {
        name: 'enable-global-focus',
        defaultValue: false,
    },
    /** Enable Keys language */
    EnableLocKeysLanguage: {
        name: 'enable-loc-keys-language',
        defaultValue: false,
    },
    EnablePeoplePickerIdentityBaseUrlOverride: {
        name: 'apollo-enablePeoplePickerIdentityBaseUrlOverride',
        defaultValue: false,
    },
    EnableEcommerceInJapan: {
        name: 'enableEcommerceInJapan',
        defaultValue: false,
    },
    EnableEcommercePlanSelectionRevampM0: {
        name: 'enableEcommercePlanSelectionRevampM0',
        defaultValue: false,
    },
    /** Enable debug logging to appInsights */
    EnableAppInsightsDebugLogging: {
        name: 'apollo-enable-app-insights-debug-logging',
        defaultValue: false,
    },
    /** Enable upgrade dialog in profile menu */
    EnableUpgradeDialogOffersRevamp: {
        name: 'EnableUpgradeDialogOffersRevamp',
        defaultValue: false,
    },
    AccountAndTenantsRefetchThrottleMs: {
        name: 'apollo-accountAndTenantsRefetchThrottleMs',
        defaultValue: 0,
    },
    FeatureFlagsRefetchThrottleMs: {
        name: 'apollo-featureFlagsRefetchThrottleMs',
        defaultValue: 0,
    },
    FavoritesRefetchThrottleMs: {
        name: 'apollo-favoritesRefetchThrottleMs',
        defaultValue: 0,
    },
    LanguageRefetchThrottleMs: {
        name: 'apollo-languageRefetchThrottleMs',
        defaultValue: 1000 * 60 * 5,
    },
    ThemeRefetchThrottleMs: {
        name: 'apollo-themeRefetchThrottleMs',
        defaultValue: 1000 * 60 * 5,
    },
    EnableAbTestingSupport: {
        name: 'enableAbTestingSupport',
        defaultValue: true,
    },
    EnableAbTestingLoggedEvents: {
        name: 'enableAbTestingLoggedEvents',
        defaultValue: [],
    },
    /** Checksession polling time */
    CheckSessionIntervalMs: {
        name: 'apollo-checkSessionIntervalMs',
        defaultValue: 30 * 1000,
    },
    /** Checksession inactive polling time */
    CheckSessionInactiveIntervalMs: {
        name: 'apollo-checkSessionInactiveIntervalMs',
        defaultValue: 5 * 60 * 1000,
    },
    EnableHighContrastLightTheme: {
        name: 'apollo-enableHighContrastLightTheme',
        defaultValue: true,
    },
    EnableHighContrastDarkTheme: {
        name: 'apollo-enableHighContrastDarkTheme',
        defaultValue: false,
    },
    ForceOrgLanguage: {
        name: 'apollo-forceOrgLanguage',
        defaultValue: false,
    },
    EnableTenantTrimming: {
        name: 'apollo-enableTenantTrimming',
        defaultValue: false,
    },
    EnableAccessibilityApi: {
        name: 'apollo-enableAccessibilityApi',
        defaultValue: false,
    },
    AccessibilityRefetchThrottleMs: {
        name: 'apollo-accessibilityRefetchThrottleMs',
        defaultValue: 0,
    },
    EnableAlertDuration: {
        name: 'apollo-enableAlertDuration',
        defaultValue: false,
    },
    AlertDurationRefetchThrottleMs: {
        name: 'apollo-alertDurationRefetchThrottleMs',
        defaultValue: 0,
    },
    EntitlementsRefetchThrottleMs: {
        name: 'apollo-entitlementsRefetchThrottleMs',
        defaultValue: 1000 * 60 * 60,
    },
    EnableSwitchingOrgDialog: {
        name: 'apollo-enableSwitchingOrgDialog',
        defaultValue: false,
    },
    EnableAccessTokenExpirationLogout: {
        name: 'apollo-enableAccessTokenExpirationLogout',
        defaultValue: true,
    },
    EnablePageLoadingProgressBar: {
        name: 'apollo-enablePageLoadingProgressBar',
        defaultValue: false,
    },
    EnableAppBarUnifiedAdminButton: {
        name: 'apollo-enableAppBarUnifiedAdminButton',
        defaultValue: false,
    },
    UnifiedSearchV2Routes: {
        name: 'apollo-unifiedSearchV2Routes',
        defaultValue: {},
    },
    EnableUnifiedSearchV2: {
        name: 'apollo-enableUnifiedSearchV2',
        defaultValue: false,
    },
    EnablePostEmailValidation: {
        name: 'apollo-enablePostEmailValidation',
        defaultValue: false,
    },
    EnableLogRocketIntegration: {
        name: 'apollo-enableLogRocketIntegration',
        defaultValue: false,
    },
    EnableCheckSessionToken: {
        name: 'apollo-enableCheckSessionToken',
        defaultValue: false,
    },
    EnableUnifiedSearchSRSEventCollect: {
        name: 'apollo-enableUnifiedSearchSRSEventCollect',
        defaultValue: false,
    },
    EnableLeftRailExperiment: {
        name: 'apollo-enableLeftRailExperiment',
        defaultValue: false,
    },
    EnableForceFocusModeOff: {
        name: 'apollo-enableForceFocusModeOff',
        defaultValue: false,
    },
    EnableHelpMenuFeedback: {
        name: 'apollo-enableHelpMenuFeedback',
        defaultValue: false,
    },
    EnableSAPEntitlements: {
        name: 'apollo-enableSAPEntitlements',
        defaultValue: false,
    },
    EnableFpsDocsUrl: {
        name: 'apollo-enableFpsDocsUrl',
        defaultValue: false,
    },
    EnableFpsAcademyUrl: {
        name: 'apollo-enableFpsAcademyUrl',
        defaultValue: false,
    },
    EnablePreferencesApi: {
        name: 'apollo-enablePreferencesApi',
        defaultValue: false,
    },
    EnableGlobalHeader: {
        name: 'apollo-enableGlobalHeader',
        defaultValue: false,
    },
    PreviewServices: {
        name: 'apollo-previewServices',
        defaultValue: [],
    },
    EnableSessionRemoveUserOnLoginRequired: {
        name: 'apollo-enableSessionRemoveUserOnLoginRequired',
        defaultValue: true,
    },
    EnableLeftRailRedesign: {
        name: 'apollo-enableLeftRailRedesign',
        defaultValue: false,
    },
    EnableComponentTracker: {
        name: 'apollo-enableComponentTracker',
        defaultValue: false,
    },
    FilteredServicesForSAP: {
        name: 'apollo-filteredServicesForSAP',
        defaultValue: [],
    },
    EnableIXP: {
        name: 'apollo-enableIXP',
        defaultValue: false,
    },
    EnableAutopilotChat: {
        name: 'apollo-enableAutopilotChat',
        defaultValue: false,
    },
    EnableMaestro: {
        name: 'apollo-enableMaestro',
        defaultValue: false,
    },
    EnableRoleUpsert: {
        name: 'apollo-enableRoleUpsert',
        defaultValue: false,
    },
};
const DefaultValuesMap = Object.values(Features).reduce((accumulator, current) => {
    accumulator[current.name] = current.defaultValue;
    return accumulator;
}, {});

function getSpaceName() {
    const services = Object.values(ServiceType).map(name => name.toLowerCase());
    const pathName = window.location.pathname.toLowerCase();
    for (let i = 0; i < services.length; i++) {
        const name = services[i];
        if (pathName.indexOf(`/${name}_/`) > -1 || pathName.endsWith(`/${name}_`)) {
            return name;
        }
    }
    return '';
}
function getAccountName() {
    if (!getSpaceName()) {
        return undefined;
    }
    const firstPart = window.location.pathname.split('/')[1];
    return !(firstPart === null || firstPart === void 0 ? void 0 : firstPart.endsWith('_')) ? firstPart : undefined;
}
function getTenantName() {
    if (!getSpaceName()) {
        return undefined;
    }
    const secondPart = window.location.pathname.split('/')[2];
    return !(secondPart === null || secondPart === void 0 ? void 0 : secondPart.endsWith('_')) ? secondPart : undefined;
}
function getRelativeServicePath() {
    const accountName = getAccountName();
    const spaceName = getSpaceName();
    const tenantName = getTenantName();
    if (!accountName || !spaceName) {
        return '';
    }
    return window.location.pathname.replace(`/${accountName}${tenantName ? `/${tenantName}` : ''}/${spaceName}_/`, '/');
}
function getBaseUrl() {
    var _a;
    return (_a = window.location.origin) !== null && _a !== void 0 ? _a : '';
}

/* eslint-disable no-console */
class Logger {
    // #endregion
    // #region Public Methods
    /**
     * Toggles debug mode for the logger so everything will be printed to console
     * @param debugMode the debug mode to set
     */
    static setDebugMode(debugMode) {
        this.isDebugMode = debugMode;
    }
    /**
     * Sets the app insights instance to Logger (since for now it's globally imported)
     * @param appInsights App insights instance to set
     */
    static setAppInsights(appInsights) {
        var _a;
        this.appInsights = appInsights;
        this.appInsights.initializeTracker('local' === getEnvironment(), (_a = getCachedLanguage()) !== null && _a !== void 0 ? _a : 'en');
    }
    /**
     * Sets the AppInsights log level to prevent logging too many traces for apollo
     * We are using the same severity level as AppInsights (0 = debug/verbose, 1 = info, 2 = warn, 3 = error, 4 = critical)
     * @param level the log level to set
     */
    static setAppInsightsMinimumSeverityLevel(severityLevel) {
        this.appInsightsMinimumSeverityLevel = severityLevel;
    }
    /**
     * Logs debug messages to the console if debug mode is enabled
     * Being as specific as possible helps a lot with debugging
     * @param scope the scope of the debug message (e.g. 'ap-nav', ['ap-nav', 'componentWillLoad'])
     * @param message the message of the debug message
     * @param context the context of the debug message (e.g. store state, object, includeStack, forcePrintToConsole, forcePushToAppInsights)
     */
    static debug(scope, message, context) {
        this.log(scope, message, SeverityLevel$1.Verbose, context);
    }
    /**
     * Logs info messages to the console if debug mode is enabled
     * Being as specific as possible helps a lot with debugging
     * @param scope the scope of the debug info (e.g. 'ap-nav', ['ap-nav', 'componentWillLoad'])
     * @param message the message of the debug info
     * @param context the context of the debug info (e.g. store state, object, includeStack, forcePrintToConsole, forcePushToAppInsights)
     */
    static info(scope, message, context) {
        this.log(scope, message, SeverityLevel$1.Information, context);
    }
    /**
     * Logs warning messages to the console if debug mode is enabled
     * Being as specific as possible helps a lot with debugging
     * @param scope the scope of the warning message (e.g. 'ap-nav', ['ap-nav', 'componentWillLoad'])
     * @param message the message of the warning message
     * @param context the context of the warning message (eg store state, object, includeStack, forcePrintToConsole, forcePushToAppInsights)
     */
    static warn(scope, message, context) {
        this.log(scope, message, SeverityLevel$1.Warning, context);
    }
    /**
     * Logs error messages to the console if debug mode is enabled
     * Being as specific as possible helps a lot with debugging
     * @param scope the scope of the error message (e.g. 'ap-nav', ['ap-nav', 'componentWillLoad'])
     * @param message the message of the error message
     * @param context the context of the error message (e.g. store state, object, includeStack, forcePrintToConsole, forcePushToAppInsights)
     */
    static error(scope, message, context) {
        this.log(scope, message, SeverityLevel$1.Error, context);
    }
    /**
     * Logs critical messages to the console if debug mode is enabled
     * Being as specific as possible helps a lot with debugging
     * @param scope the scope of the critical message (e.g. 'ap-nav', ['ap-nav', 'componentWillLoad'])
     * @param message the message of the critical message
     * @param context the context of critical message (e.g. store state, object, includeStack, forcePrintToConsole, forcePushToAppInsights)
     */
    static critical(scope, message, context) {
        this.log(scope, message, SeverityLevel$1.Critical, context);
    }
    /**
     * Logs messages to the console based on the severity level if debug mode is enabled
     * Being as specific as possible helps a lot with debugging
     * @param scope the scope of the message (e.g. 'ap-nav', ['ap-nav', 'componentWillLoad'])
     * @param message the message of the message
     * @param severityLevel the severity level of the message
     * @param context the context of the message (e.g. store state, object, includeStack, forcePrintToConsole, forcePushToAppInsights)
     */
    static log(scope, message, severityLevel, context) {
        var _a, _b;
        const contextWithStack = this.addStackToContext(context);
        this.printToConsole(severityLevelToLogLevel[severityLevel], scope, message, contextWithStack);
        if (contextWithStack === null || contextWithStack === void 0 ? void 0 : contextWithStack.printToConsoleOnly) {
            return;
        }
        const enableDebugLogging = (_b = (_a = window.PortalShell) === null || _a === void 0 ? void 0 : _a.FeatureFlags) === null || _b === void 0 ? void 0 : _b.getFeatureFlag(Features.EnableAppInsightsDebugLogging.name);
        if ((contextWithStack === null || contextWithStack === void 0 ? void 0 : contextWithStack.forcePushToAppInsights) || enableDebugLogging || this.appInsightsMinimumSeverityLevel <= severityLevel) {
            this.recordToAppInsights(scope, message, severityLevel, contextWithStack);
        }
    }
    /**
     * For business telemetry only, logs custom events to AppInsights.
     * Respects the new standardized format for logging
     * @param event event name to track
     * @param details details to track in custom dimension
     * @param severityLevel severity level to track in custom dimensions (defaults to Information)
     */
    static logCustomEvent(event, details, severityLevel = SeverityLevel$1.Verbose) {
        var _a, _b, _c, _d, _e;
        this.printToConsole(severityLevelToLogLevel[severityLevel], event, JSON.stringify(details !== null && details !== void 0 ? details : {}));
        (_b = (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackerMethods) === null || _b === void 0 ? void 0 : _b.trackEvent(event, details);
        if (severityLevel > SeverityLevel$1.Warning) {
            const message = this.getFormattedMessage(event, (_c = details === null || details === void 0 ? void 0 : details.errorMessage) !== null && _c !== void 0 ? _c : 'Unknown error');
            (_e = (_d = this.appInsights) === null || _d === void 0 ? void 0 : _d.trackerMethods) === null || _e === void 0 ? void 0 : _e.trackError(new Error(message), severityLevel === SeverityLevel$1.Error ? SeverityLevel.Major : SeverityLevel.Critical, details !== null && details !== void 0 ? details : {});
        }
    }
    /**
     * Logs a batch of custom events to AppInsights.
     * @param event the event name to track
     * @param batch the batch of events to track
     */
    static batchLogCustomEvent(event, batch) {
        batch.forEach(item => {
            var _a, _b;
            (_b = (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackerMethods) === null || _b === void 0 ? void 0 : _b.trackEvent(event, item);
        });
    }
    // #endregion
    // #region Private Methods
    static isDebugEnabled() {
        return this.isDebugMode;
    }
    static getTelemetryClientSeverityLevel(severityLevel) {
        return [
            SeverityLevel.Info, // Debug doesn't exist in TelemetryClientSeverity, so we map it to Info
            SeverityLevel.Info,
            SeverityLevel.Normal,
            SeverityLevel.Major,
            SeverityLevel.Critical,
        ][severityLevel];
    }
    static getFormattedMessage(scope, message) {
        return `[${Array.isArray(scope) ? scope.join('/') : scope}] - ${sanitizeEmail(message.substring(0, 250))}`;
    }
    static addStackToContext(context) {
        if ((context === null || context === void 0 ? void 0 : context.includeStack) && !context.stack) {
            return Object.assign(Object.assign({}, context), { stack: (new Error()).stack });
        }
        return context;
    }
    static printToConsole(logLevel, scope, message, context) {
        const { object, stack, forcePrintToConsole, } = context !== null && context !== void 0 ? context : {};
        if (forcePrintToConsole || this.isDebugEnabled()) {
            console[logLevel](`[ap-shell]${this.getFormattedMessage(scope, message)}`);
            if (object) {
                console[logLevel](JSON.stringify(object, undefined, 4));
            }
            if (stack) {
                console[logLevel](stack);
            }
        }
    }
    static recordToAppInsights(scope, message, severityLevel, context) {
        var _a, _b, _c, _d, _e, _f, _g;
        const { state, object, stack, } = context !== null && context !== void 0 ? context : {};
        const formattedMessage = this.getFormattedMessage(scope, message);
        const telemetryClientSeverity = this.getTelemetryClientSeverityLevel(severityLevel);
        let details = {
            message: formattedMessage,
            component: JSON.stringify(scope),
            scope: JSON.stringify(scope),
            object: JSON.stringify(object),
            stack,
            accountName: (_a = state === null || state === void 0 ? void 0 : state.accountName) !== null && _a !== void 0 ? _a : getAccountName(),
            tenantName: (_b = state === null || state === void 0 ? void 0 : state.currentTenant) !== null && _b !== void 0 ? _b : getTenantName(),
            orgId: state === null || state === void 0 ? void 0 : state.organizationId,
            space: (_c = state === null || state === void 0 ? void 0 : state.active) !== null && _c !== void 0 ? _c : getSpaceName(),
            locale: state === null || state === void 0 ? void 0 : state.locale,
            theme: state === null || state === void 0 ? void 0 : state.theme,
        };
        details = removeObjectUndefinedProperties(details);
        if (severityLevel > SeverityLevel$1.Warning) {
            (_e = (_d = this.appInsights) === null || _d === void 0 ? void 0 : _d.trackerMethods) === null || _e === void 0 ? void 0 : _e.trackError(new Error(formattedMessage), telemetryClientSeverity, details);
        }
        else {
            (_g = (_f = this.appInsights) === null || _f === void 0 ? void 0 : _f.trackerMethods) === null || _g === void 0 ? void 0 : _g.trackTrace(formattedMessage, telemetryClientSeverity, details);
        }
    }
}
// #region Static Fields
Logger.cacheKey = 'SHELL_DEBUG';
Logger.isDebugMode = localStorage.getItem(Logger.cacheKey) === 'true';
Logger.appInsightsMinimumSeverityLevel = SeverityLevel$1.Information;

// note all service ids are lowercase
const SERVICE_IDS = {
    home: 'home',
    academy: 'academy',
    customerportal: 'customerportal',
    automationhub: 'automationhub',
    automationstore: 'automationstore',
    actions: 'actions',
    apps: 'apps',
    chatbots: 'chatbots',
    entities: 'entities',
    orchestrator: 'orchestrator',
    processes: 'processes',
    insights: 'insights',
    marketplace: 'marketplace',
    testmanager: 'testmanager',
    integrations: 'connections', // Note: this is by design; integrations is using connections as their URL
    dataservice: 'dataservice',
    taskmining: 'taskmining',
    processmining: 'processmining',
    studio: 'studio',
    du: 'du',
    reinfer: 'reinfer',
    roboticsops: 'roboticsops',
    admin: 'admin',
    aifabric: 'aifabric',
    help: 'help',
    docs: 'docs',
    agents: 'agents',
    assistant: 'assistant',
    agenticorchestration: 'agenticorchestration',
};
const defaultServiceOrder = [
    SERVICE_IDS.home,
    SERVICE_IDS.orchestrator,
    SERVICE_IDS.studio,
    SERVICE_IDS.actions,
    SERVICE_IDS.academy,
    SERVICE_IDS.automationhub,
    SERVICE_IDS.apps,
    SERVICE_IDS.chatbots,
    SERVICE_IDS.processes,
    SERVICE_IDS.assistant,
    SERVICE_IDS.insights,
    SERVICE_IDS.marketplace,
    SERVICE_IDS.testmanager,
    SERVICE_IDS.integrations,
    SERVICE_IDS.dataservice,
    SERVICE_IDS.taskmining,
    SERVICE_IDS.processmining,
    SERVICE_IDS.aifabric,
    SERVICE_IDS.du,
    SERVICE_IDS.reinfer,
    SERVICE_IDS.customerportal,
    SERVICE_IDS.roboticsops,
    SERVICE_IDS.admin,
    SERVICE_IDS.automationstore,
    SERVICE_IDS.docs,
    SERVICE_IDS.agents,
    SERVICE_IDS.agenticorchestration,
    SERVICE_IDS.help,
];

var _a$1;
const defaultActiveItems = [SERVICE_IDS.home, SERVICE_IDS.help];
const defaultMenuItems = [
    {
        id: 'home',
        name: 'Home',
        scope: Scope.Global,
        serviceType: ServiceType.cloudRpa,
        svg: 'home',
        url: '//portal_/home',
    },
    {
        id: 'help',
        name: 'Help',
        scope: Scope.Global,
        serviceType: ServiceType.cloudRpa,
        svg: 'help',
        url: '//portal_/resourcecenter',
    },
];
const defaultStoreValues = {
    active: (_a$1 = getSpaceName()) !== null && _a$1 !== void 0 ? _a$1 : '',
    focusMode: false,
    mode: null,
    activePortalSubMenu: null,
    activeMenuSurface: null,
    activePortalToolbarSurface: null,
    activeDropdownMenuSurface: null,
    settingClickEmitter: null,
    handleItems: [],
    overrideAllNavItems: false,
};

function e(e){this.message=e;}e.prototype=new Error,e.prototype.name="InvalidCharacterError";var r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new e("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function t$1(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw "Illegal base64url string!"}try{return function(e){return decodeURIComponent(r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return r(t)}}function n(e){this.message=e;}function o(e,r){if("string"!=typeof e)throw new n("Invalid token specified");var o=!0===(r=r||{}).header?0:1;try{return JSON.parse(t$1(e.split(".")[o]))}catch(e){throw new n("Invalid token specified: "+e.message)}}n.prototype=new Error,n.prototype.name="InvalidTokenError";

const jwtDecode_esm = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': o,
    InvalidTokenError: n
});

class AccessibilityInstanceResolver {
    static Instantiate(accessibilityInstance) {
        if (!this._accessibilityInstance) {
            this._accessibilityInstance = accessibilityInstance;
        }
        return this._accessibilityInstance;
    }
    static get Instance() {
        return this._accessibilityInstance;
    }
}

class AccountAndTenantsInstanceResolver {
    static Instantiate(accountAndTenantsInstance) {
        if (!this._accountAndTenantsInstance) {
            this._accountAndTenantsInstance = accountAndTenantsInstance;
        }
        return this._accountAndTenantsInstance;
    }
    static get Instance() {
        return this._accountAndTenantsInstance;
    }
}

class AlertInstanceResolver {
    static Instantiate(alertInstance) {
        if (!this._alertInstance) {
            this._alertInstance = alertInstance;
        }
        return this._alertInstance;
    }
    static get Instance() {
        return this._alertInstance;
    }
}

// IoC pattern like a Service Locator of instantiating a singleton service with abstractization of the implementation
// benefits: very easy to mock in tests, by providing a mock implementation of the interface (IAppInsightsModel)
class AppInsightsInstanceResolver {
    static Instantiate(AppInsightsInstance) {
        if (!this._instance) {
            this._instance = AppInsightsInstance;
        }
        return this._instance;
    }
    static SetPlatformInfo(platformInfo) {
        var _a;
        (_a = this._instance) === null || _a === void 0 ? void 0 : _a.setPlatformInfo(platformInfo);
    }
    static SetPlatformMetadata(metadata) {
        var _a;
        (_a = this._instance) === null || _a === void 0 ? void 0 : _a.setPlatformMetadata(metadata);
    }
    static get Instance() {
        return this._instance;
    }
}

var utils$1 = {};

const Aacute = "Á";
const aacute = "á";
const Abreve = "Ă";
const abreve = "ă";
const ac = "∾";
const acd = "∿";
const acE = "∾̳";
const Acirc = "Â";
const acirc = "â";
const acute = "´";
const Acy = "А";
const acy = "а";
const AElig = "Æ";
const aelig = "æ";
const af = "⁡";
const Afr = "𝔄";
const afr = "𝔞";
const Agrave = "À";
const agrave = "à";
const alefsym = "ℵ";
const aleph = "ℵ";
const Alpha = "Α";
const alpha = "α";
const Amacr = "Ā";
const amacr = "ā";
const amalg = "⨿";
const amp = "&";
const AMP = "&";
const andand = "⩕";
const And = "⩓";
const and = "∧";
const andd = "⩜";
const andslope = "⩘";
const andv = "⩚";
const ang = "∠";
const ange = "⦤";
const angle = "∠";
const angmsdaa = "⦨";
const angmsdab = "⦩";
const angmsdac = "⦪";
const angmsdad = "⦫";
const angmsdae = "⦬";
const angmsdaf = "⦭";
const angmsdag = "⦮";
const angmsdah = "⦯";
const angmsd = "∡";
const angrt = "∟";
const angrtvb = "⊾";
const angrtvbd = "⦝";
const angsph = "∢";
const angst = "Å";
const angzarr = "⍼";
const Aogon = "Ą";
const aogon = "ą";
const Aopf = "𝔸";
const aopf = "𝕒";
const apacir = "⩯";
const ap = "≈";
const apE = "⩰";
const ape = "≊";
const apid = "≋";
const apos = "'";
const ApplyFunction = "⁡";
const approx = "≈";
const approxeq = "≊";
const Aring = "Å";
const aring = "å";
const Ascr = "𝒜";
const ascr = "𝒶";
const Assign = "≔";
const ast = "*";
const asymp = "≈";
const asympeq = "≍";
const Atilde = "Ã";
const atilde = "ã";
const Auml = "Ä";
const auml = "ä";
const awconint = "∳";
const awint = "⨑";
const backcong = "≌";
const backepsilon = "϶";
const backprime = "‵";
const backsim = "∽";
const backsimeq = "⋍";
const Backslash = "∖";
const Barv = "⫧";
const barvee = "⊽";
const barwed = "⌅";
const Barwed = "⌆";
const barwedge = "⌅";
const bbrk = "⎵";
const bbrktbrk = "⎶";
const bcong = "≌";
const Bcy = "Б";
const bcy = "б";
const bdquo = "„";
const becaus = "∵";
const because = "∵";
const Because = "∵";
const bemptyv = "⦰";
const bepsi = "϶";
const bernou = "ℬ";
const Bernoullis = "ℬ";
const Beta = "Β";
const beta = "β";
const beth = "ℶ";
const between = "≬";
const Bfr = "𝔅";
const bfr = "𝔟";
const bigcap = "⋂";
const bigcirc = "◯";
const bigcup = "⋃";
const bigodot = "⨀";
const bigoplus = "⨁";
const bigotimes = "⨂";
const bigsqcup = "⨆";
const bigstar = "★";
const bigtriangledown = "▽";
const bigtriangleup = "△";
const biguplus = "⨄";
const bigvee = "⋁";
const bigwedge = "⋀";
const bkarow = "⤍";
const blacklozenge = "⧫";
const blacksquare = "▪";
const blacktriangle = "▴";
const blacktriangledown = "▾";
const blacktriangleleft = "◂";
const blacktriangleright = "▸";
const blank = "␣";
const blk12 = "▒";
const blk14 = "░";
const blk34 = "▓";
const block$1 = "█";
const bne = "=⃥";
const bnequiv = "≡⃥";
const bNot = "⫭";
const bnot = "⌐";
const Bopf = "𝔹";
const bopf = "𝕓";
const bot = "⊥";
const bottom = "⊥";
const bowtie = "⋈";
const boxbox = "⧉";
const boxdl = "┐";
const boxdL = "╕";
const boxDl = "╖";
const boxDL = "╗";
const boxdr = "┌";
const boxdR = "╒";
const boxDr = "╓";
const boxDR = "╔";
const boxh = "─";
const boxH = "═";
const boxhd = "┬";
const boxHd = "╤";
const boxhD = "╥";
const boxHD = "╦";
const boxhu = "┴";
const boxHu = "╧";
const boxhU = "╨";
const boxHU = "╩";
const boxminus = "⊟";
const boxplus = "⊞";
const boxtimes = "⊠";
const boxul = "┘";
const boxuL = "╛";
const boxUl = "╜";
const boxUL = "╝";
const boxur = "└";
const boxuR = "╘";
const boxUr = "╙";
const boxUR = "╚";
const boxv = "│";
const boxV = "║";
const boxvh = "┼";
const boxvH = "╪";
const boxVh = "╫";
const boxVH = "╬";
const boxvl = "┤";
const boxvL = "╡";
const boxVl = "╢";
const boxVL = "╣";
const boxvr = "├";
const boxvR = "╞";
const boxVr = "╟";
const boxVR = "╠";
const bprime = "‵";
const breve = "˘";
const Breve = "˘";
const brvbar = "¦";
const bscr = "𝒷";
const Bscr = "ℬ";
const bsemi = "⁏";
const bsim = "∽";
const bsime = "⋍";
const bsolb = "⧅";
const bsol = "\\";
const bsolhsub = "⟈";
const bull = "•";
const bullet = "•";
const bump = "≎";
const bumpE = "⪮";
const bumpe = "≏";
const Bumpeq = "≎";
const bumpeq = "≏";
const Cacute = "Ć";
const cacute = "ć";
const capand = "⩄";
const capbrcup = "⩉";
const capcap = "⩋";
const cap = "∩";
const Cap = "⋒";
const capcup = "⩇";
const capdot = "⩀";
const CapitalDifferentialD = "ⅅ";
const caps = "∩︀";
const caret = "⁁";
const caron = "ˇ";
const Cayleys = "ℭ";
const ccaps = "⩍";
const Ccaron = "Č";
const ccaron = "č";
const Ccedil = "Ç";
const ccedil = "ç";
const Ccirc = "Ĉ";
const ccirc = "ĉ";
const Cconint = "∰";
const ccups = "⩌";
const ccupssm = "⩐";
const Cdot = "Ċ";
const cdot = "ċ";
const cedil = "¸";
const Cedilla = "¸";
const cemptyv = "⦲";
const cent = "¢";
const centerdot = "·";
const CenterDot = "·";
const cfr = "𝔠";
const Cfr = "ℭ";
const CHcy = "Ч";
const chcy = "ч";
const check = "✓";
const checkmark = "✓";
const Chi = "Χ";
const chi = "χ";
const circ = "ˆ";
const circeq = "≗";
const circlearrowleft = "↺";
const circlearrowright = "↻";
const circledast = "⊛";
const circledcirc = "⊚";
const circleddash = "⊝";
const CircleDot = "⊙";
const circledR = "®";
const circledS = "Ⓢ";
const CircleMinus = "⊖";
const CirclePlus = "⊕";
const CircleTimes = "⊗";
const cir = "○";
const cirE = "⧃";
const cire = "≗";
const cirfnint = "⨐";
const cirmid = "⫯";
const cirscir = "⧂";
const ClockwiseContourIntegral = "∲";
const CloseCurlyDoubleQuote = "”";
const CloseCurlyQuote = "’";
const clubs = "♣";
const clubsuit = "♣";
const colon = ":";
const Colon = "∷";
const Colone = "⩴";
const colone = "≔";
const coloneq = "≔";
const comma = ",";
const commat = "@";
const comp = "∁";
const compfn = "∘";
const complement = "∁";
const complexes = "ℂ";
const cong = "≅";
const congdot = "⩭";
const Congruent = "≡";
const conint = "∮";
const Conint = "∯";
const ContourIntegral = "∮";
const copf = "𝕔";
const Copf = "ℂ";
const coprod = "∐";
const Coproduct = "∐";
const copy = "©";
const COPY = "©";
const copysr = "℗";
const CounterClockwiseContourIntegral = "∳";
const crarr = "↵";
const cross = "✗";
const Cross = "⨯";
const Cscr = "𝒞";
const cscr = "𝒸";
const csub = "⫏";
const csube = "⫑";
const csup = "⫐";
const csupe = "⫒";
const ctdot = "⋯";
const cudarrl = "⤸";
const cudarrr = "⤵";
const cuepr = "⋞";
const cuesc = "⋟";
const cularr = "↶";
const cularrp = "⤽";
const cupbrcap = "⩈";
const cupcap = "⩆";
const CupCap = "≍";
const cup = "∪";
const Cup = "⋓";
const cupcup = "⩊";
const cupdot = "⊍";
const cupor = "⩅";
const cups = "∪︀";
const curarr = "↷";
const curarrm = "⤼";
const curlyeqprec = "⋞";
const curlyeqsucc = "⋟";
const curlyvee = "⋎";
const curlywedge = "⋏";
const curren = "¤";
const curvearrowleft = "↶";
const curvearrowright = "↷";
const cuvee = "⋎";
const cuwed = "⋏";
const cwconint = "∲";
const cwint = "∱";
const cylcty = "⌭";
const dagger = "†";
const Dagger = "‡";
const daleth = "ℸ";
const darr = "↓";
const Darr = "↡";
const dArr = "⇓";
const dash = "‐";
const Dashv = "⫤";
const dashv = "⊣";
const dbkarow = "⤏";
const dblac = "˝";
const Dcaron = "Ď";
const dcaron = "ď";
const Dcy = "Д";
const dcy = "д";
const ddagger = "‡";
const ddarr = "⇊";
const DD = "ⅅ";
const dd = "ⅆ";
const DDotrahd = "⤑";
const ddotseq = "⩷";
const deg = "°";
const Del = "∇";
const Delta = "Δ";
const delta = "δ";
const demptyv = "⦱";
const dfisht = "⥿";
const Dfr = "𝔇";
const dfr = "𝔡";
const dHar = "⥥";
const dharl = "⇃";
const dharr = "⇂";
const DiacriticalAcute = "´";
const DiacriticalDot = "˙";
const DiacriticalDoubleAcute = "˝";
const DiacriticalGrave = "`";
const DiacriticalTilde = "˜";
const diam = "⋄";
const diamond = "⋄";
const Diamond = "⋄";
const diamondsuit = "♦";
const diams = "♦";
const die = "¨";
const DifferentialD = "ⅆ";
const digamma = "ϝ";
const disin = "⋲";
const div = "÷";
const divide = "÷";
const divideontimes = "⋇";
const divonx = "⋇";
const DJcy = "Ђ";
const djcy = "ђ";
const dlcorn = "⌞";
const dlcrop = "⌍";
const dollar = "$";
const Dopf = "𝔻";
const dopf = "𝕕";
const Dot = "¨";
const dot = "˙";
const DotDot = "⃜";
const doteq = "≐";
const doteqdot = "≑";
const DotEqual = "≐";
const dotminus = "∸";
const dotplus = "∔";
const dotsquare = "⊡";
const doublebarwedge = "⌆";
const DoubleContourIntegral = "∯";
const DoubleDot = "¨";
const DoubleDownArrow = "⇓";
const DoubleLeftArrow = "⇐";
const DoubleLeftRightArrow = "⇔";
const DoubleLeftTee = "⫤";
const DoubleLongLeftArrow = "⟸";
const DoubleLongLeftRightArrow = "⟺";
const DoubleLongRightArrow = "⟹";
const DoubleRightArrow = "⇒";
const DoubleRightTee = "⊨";
const DoubleUpArrow = "⇑";
const DoubleUpDownArrow = "⇕";
const DoubleVerticalBar = "∥";
const DownArrowBar = "⤓";
const downarrow = "↓";
const DownArrow = "↓";
const Downarrow = "⇓";
const DownArrowUpArrow = "⇵";
const DownBreve = "̑";
const downdownarrows = "⇊";
const downharpoonleft = "⇃";
const downharpoonright = "⇂";
const DownLeftRightVector = "⥐";
const DownLeftTeeVector = "⥞";
const DownLeftVectorBar = "⥖";
const DownLeftVector = "↽";
const DownRightTeeVector = "⥟";
const DownRightVectorBar = "⥗";
const DownRightVector = "⇁";
const DownTeeArrow = "↧";
const DownTee = "⊤";
const drbkarow = "⤐";
const drcorn = "⌟";
const drcrop = "⌌";
const Dscr = "𝒟";
const dscr = "𝒹";
const DScy = "Ѕ";
const dscy = "ѕ";
const dsol = "⧶";
const Dstrok = "Đ";
const dstrok = "đ";
const dtdot = "⋱";
const dtri = "▿";
const dtrif = "▾";
const duarr = "⇵";
const duhar = "⥯";
const dwangle = "⦦";
const DZcy = "Џ";
const dzcy = "џ";
const dzigrarr = "⟿";
const Eacute = "É";
const eacute = "é";
const easter = "⩮";
const Ecaron = "Ě";
const ecaron = "ě";
const Ecirc = "Ê";
const ecirc = "ê";
const ecir = "≖";
const ecolon = "≕";
const Ecy = "Э";
const ecy = "э";
const eDDot = "⩷";
const Edot = "Ė";
const edot = "ė";
const eDot = "≑";
const ee = "ⅇ";
const efDot = "≒";
const Efr = "𝔈";
const efr = "𝔢";
const eg = "⪚";
const Egrave = "È";
const egrave = "è";
const egs = "⪖";
const egsdot = "⪘";
const el = "⪙";
const Element = "∈";
const elinters = "⏧";
const ell = "ℓ";
const els = "⪕";
const elsdot = "⪗";
const Emacr = "Ē";
const emacr = "ē";
const empty = "∅";
const emptyset = "∅";
const EmptySmallSquare = "◻";
const emptyv = "∅";
const EmptyVerySmallSquare = "▫";
const emsp13 = " ";
const emsp14 = " ";
const emsp = " ";
const ENG = "Ŋ";
const eng = "ŋ";
const ensp = " ";
const Eogon = "Ę";
const eogon = "ę";
const Eopf = "𝔼";
const eopf = "𝕖";
const epar = "⋕";
const eparsl = "⧣";
const eplus = "⩱";
const epsi = "ε";
const Epsilon = "Ε";
const epsilon = "ε";
const epsiv = "ϵ";
const eqcirc = "≖";
const eqcolon = "≕";
const eqsim = "≂";
const eqslantgtr = "⪖";
const eqslantless = "⪕";
const Equal = "⩵";
const equals = "=";
const EqualTilde = "≂";
const equest = "≟";
const Equilibrium = "⇌";
const equiv = "≡";
const equivDD = "⩸";
const eqvparsl = "⧥";
const erarr = "⥱";
const erDot = "≓";
const escr = "ℯ";
const Escr = "ℰ";
const esdot = "≐";
const Esim = "⩳";
const esim = "≂";
const Eta = "Η";
const eta = "η";
const ETH = "Ð";
const eth = "ð";
const Euml = "Ë";
const euml = "ë";
const euro = "€";
const excl = "!";
const exist = "∃";
const Exists = "∃";
const expectation = "ℰ";
const exponentiale = "ⅇ";
const ExponentialE = "ⅇ";
const fallingdotseq = "≒";
const Fcy = "Ф";
const fcy = "ф";
const female = "♀";
const ffilig = "ﬃ";
const fflig = "ﬀ";
const ffllig = "ﬄ";
const Ffr = "𝔉";
const ffr = "𝔣";
const filig = "ﬁ";
const FilledSmallSquare = "◼";
const FilledVerySmallSquare = "▪";
const fjlig = "fj";
const flat = "♭";
const fllig = "ﬂ";
const fltns = "▱";
const fnof = "ƒ";
const Fopf = "𝔽";
const fopf = "𝕗";
const forall = "∀";
const ForAll = "∀";
const fork = "⋔";
const forkv = "⫙";
const Fouriertrf = "ℱ";
const fpartint = "⨍";
const frac12 = "½";
const frac13 = "⅓";
const frac14 = "¼";
const frac15 = "⅕";
const frac16 = "⅙";
const frac18 = "⅛";
const frac23 = "⅔";
const frac25 = "⅖";
const frac34 = "¾";
const frac35 = "⅗";
const frac38 = "⅜";
const frac45 = "⅘";
const frac56 = "⅚";
const frac58 = "⅝";
const frac78 = "⅞";
const frasl = "⁄";
const frown = "⌢";
const fscr = "𝒻";
const Fscr = "ℱ";
const gacute = "ǵ";
const Gamma = "Γ";
const gamma = "γ";
const Gammad = "Ϝ";
const gammad = "ϝ";
const gap = "⪆";
const Gbreve = "Ğ";
const gbreve = "ğ";
const Gcedil = "Ģ";
const Gcirc = "Ĝ";
const gcirc = "ĝ";
const Gcy = "Г";
const gcy = "г";
const Gdot = "Ġ";
const gdot = "ġ";
const ge = "≥";
const gE = "≧";
const gEl = "⪌";
const gel = "⋛";
const geq = "≥";
const geqq = "≧";
const geqslant = "⩾";
const gescc = "⪩";
const ges = "⩾";
const gesdot = "⪀";
const gesdoto = "⪂";
const gesdotol = "⪄";
const gesl = "⋛︀";
const gesles = "⪔";
const Gfr = "𝔊";
const gfr = "𝔤";
const gg = "≫";
const Gg = "⋙";
const ggg = "⋙";
const gimel = "ℷ";
const GJcy = "Ѓ";
const gjcy = "ѓ";
const gla = "⪥";
const gl = "≷";
const glE = "⪒";
const glj = "⪤";
const gnap = "⪊";
const gnapprox = "⪊";
const gne = "⪈";
const gnE = "≩";
const gneq = "⪈";
const gneqq = "≩";
const gnsim = "⋧";
const Gopf = "𝔾";
const gopf = "𝕘";
const grave = "`";
const GreaterEqual = "≥";
const GreaterEqualLess = "⋛";
const GreaterFullEqual = "≧";
const GreaterGreater = "⪢";
const GreaterLess = "≷";
const GreaterSlantEqual = "⩾";
const GreaterTilde = "≳";
const Gscr = "𝒢";
const gscr = "ℊ";
const gsim = "≳";
const gsime = "⪎";
const gsiml = "⪐";
const gtcc = "⪧";
const gtcir = "⩺";
const gt = ">";
const GT = ">";
const Gt = "≫";
const gtdot = "⋗";
const gtlPar = "⦕";
const gtquest = "⩼";
const gtrapprox = "⪆";
const gtrarr = "⥸";
const gtrdot = "⋗";
const gtreqless = "⋛";
const gtreqqless = "⪌";
const gtrless = "≷";
const gtrsim = "≳";
const gvertneqq = "≩︀";
const gvnE = "≩︀";
const Hacek = "ˇ";
const hairsp = " ";
const half = "½";
const hamilt = "ℋ";
const HARDcy = "Ъ";
const hardcy = "ъ";
const harrcir = "⥈";
const harr = "↔";
const hArr = "⇔";
const harrw = "↭";
const Hat = "^";
const hbar = "ℏ";
const Hcirc = "Ĥ";
const hcirc = "ĥ";
const hearts = "♥";
const heartsuit = "♥";
const hellip = "…";
const hercon = "⊹";
const hfr = "𝔥";
const Hfr = "ℌ";
const HilbertSpace = "ℋ";
const hksearow = "⤥";
const hkswarow = "⤦";
const hoarr = "⇿";
const homtht = "∻";
const hookleftarrow = "↩";
const hookrightarrow = "↪";
const hopf = "𝕙";
const Hopf = "ℍ";
const horbar = "―";
const HorizontalLine = "─";
const hscr = "𝒽";
const Hscr = "ℋ";
const hslash = "ℏ";
const Hstrok = "Ħ";
const hstrok = "ħ";
const HumpDownHump = "≎";
const HumpEqual = "≏";
const hybull = "⁃";
const hyphen = "‐";
const Iacute = "Í";
const iacute = "í";
const ic = "⁣";
const Icirc = "Î";
const icirc = "î";
const Icy = "И";
const icy = "и";
const Idot = "İ";
const IEcy = "Е";
const iecy = "е";
const iexcl = "¡";
const iff = "⇔";
const ifr = "𝔦";
const Ifr = "ℑ";
const Igrave = "Ì";
const igrave = "ì";
const ii = "ⅈ";
const iiiint = "⨌";
const iiint = "∭";
const iinfin = "⧜";
const iiota = "℩";
const IJlig = "Ĳ";
const ijlig = "ĳ";
const Imacr = "Ī";
const imacr = "ī";
const image$1 = "ℑ";
const ImaginaryI = "ⅈ";
const imagline = "ℐ";
const imagpart = "ℑ";
const imath = "ı";
const Im = "ℑ";
const imof = "⊷";
const imped = "Ƶ";
const Implies = "⇒";
const incare = "℅";
const infin = "∞";
const infintie = "⧝";
const inodot = "ı";
const intcal = "⊺";
const int = "∫";
const Int = "∬";
const integers = "ℤ";
const Integral = "∫";
const intercal = "⊺";
const Intersection = "⋂";
const intlarhk = "⨗";
const intprod = "⨼";
const InvisibleComma = "⁣";
const InvisibleTimes = "⁢";
const IOcy = "Ё";
const iocy = "ё";
const Iogon = "Į";
const iogon = "į";
const Iopf = "𝕀";
const iopf = "𝕚";
const Iota = "Ι";
const iota = "ι";
const iprod = "⨼";
const iquest = "¿";
const iscr = "𝒾";
const Iscr = "ℐ";
const isin = "∈";
const isindot = "⋵";
const isinE = "⋹";
const isins = "⋴";
const isinsv = "⋳";
const isinv = "∈";
const it = "⁢";
const Itilde = "Ĩ";
const itilde = "ĩ";
const Iukcy = "І";
const iukcy = "і";
const Iuml = "Ï";
const iuml = "ï";
const Jcirc = "Ĵ";
const jcirc = "ĵ";
const Jcy = "Й";
const jcy = "й";
const Jfr = "𝔍";
const jfr = "𝔧";
const jmath = "ȷ";
const Jopf = "𝕁";
const jopf = "𝕛";
const Jscr = "𝒥";
const jscr = "𝒿";
const Jsercy = "Ј";
const jsercy = "ј";
const Jukcy = "Є";
const jukcy = "є";
const Kappa = "Κ";
const kappa = "κ";
const kappav = "ϰ";
const Kcedil = "Ķ";
const kcedil = "ķ";
const Kcy = "К";
const kcy = "к";
const Kfr = "𝔎";
const kfr = "𝔨";
const kgreen = "ĸ";
const KHcy = "Х";
const khcy = "х";
const KJcy = "Ќ";
const kjcy = "ќ";
const Kopf = "𝕂";
const kopf = "𝕜";
const Kscr = "𝒦";
const kscr = "𝓀";
const lAarr = "⇚";
const Lacute = "Ĺ";
const lacute = "ĺ";
const laemptyv = "⦴";
const lagran = "ℒ";
const Lambda = "Λ";
const lambda = "λ";
const lang = "⟨";
const Lang = "⟪";
const langd = "⦑";
const langle = "⟨";
const lap = "⪅";
const Laplacetrf = "ℒ";
const laquo = "«";
const larrb = "⇤";
const larrbfs = "⤟";
const larr = "←";
const Larr = "↞";
const lArr = "⇐";
const larrfs = "⤝";
const larrhk = "↩";
const larrlp = "↫";
const larrpl = "⤹";
const larrsim = "⥳";
const larrtl = "↢";
const latail = "⤙";
const lAtail = "⤛";
const lat = "⪫";
const late = "⪭";
const lates = "⪭︀";
const lbarr = "⤌";
const lBarr = "⤎";
const lbbrk = "❲";
const lbrace = "{";
const lbrack = "[";
const lbrke = "⦋";
const lbrksld = "⦏";
const lbrkslu = "⦍";
const Lcaron = "Ľ";
const lcaron = "ľ";
const Lcedil = "Ļ";
const lcedil = "ļ";
const lceil = "⌈";
const lcub = "{";
const Lcy = "Л";
const lcy = "л";
const ldca = "⤶";
const ldquo = "“";
const ldquor = "„";
const ldrdhar = "⥧";
const ldrushar = "⥋";
const ldsh = "↲";
const le = "≤";
const lE = "≦";
const LeftAngleBracket = "⟨";
const LeftArrowBar = "⇤";
const leftarrow = "←";
const LeftArrow = "←";
const Leftarrow = "⇐";
const LeftArrowRightArrow = "⇆";
const leftarrowtail = "↢";
const LeftCeiling = "⌈";
const LeftDoubleBracket = "⟦";
const LeftDownTeeVector = "⥡";
const LeftDownVectorBar = "⥙";
const LeftDownVector = "⇃";
const LeftFloor = "⌊";
const leftharpoondown = "↽";
const leftharpoonup = "↼";
const leftleftarrows = "⇇";
const leftrightarrow = "↔";
const LeftRightArrow = "↔";
const Leftrightarrow = "⇔";
const leftrightarrows = "⇆";
const leftrightharpoons = "⇋";
const leftrightsquigarrow = "↭";
const LeftRightVector = "⥎";
const LeftTeeArrow = "↤";
const LeftTee = "⊣";
const LeftTeeVector = "⥚";
const leftthreetimes = "⋋";
const LeftTriangleBar = "⧏";
const LeftTriangle = "⊲";
const LeftTriangleEqual = "⊴";
const LeftUpDownVector = "⥑";
const LeftUpTeeVector = "⥠";
const LeftUpVectorBar = "⥘";
const LeftUpVector = "↿";
const LeftVectorBar = "⥒";
const LeftVector = "↼";
const lEg = "⪋";
const leg = "⋚";
const leq = "≤";
const leqq = "≦";
const leqslant = "⩽";
const lescc = "⪨";
const les = "⩽";
const lesdot = "⩿";
const lesdoto = "⪁";
const lesdotor = "⪃";
const lesg = "⋚︀";
const lesges = "⪓";
const lessapprox = "⪅";
const lessdot = "⋖";
const lesseqgtr = "⋚";
const lesseqqgtr = "⪋";
const LessEqualGreater = "⋚";
const LessFullEqual = "≦";
const LessGreater = "≶";
const lessgtr = "≶";
const LessLess = "⪡";
const lesssim = "≲";
const LessSlantEqual = "⩽";
const LessTilde = "≲";
const lfisht = "⥼";
const lfloor = "⌊";
const Lfr = "𝔏";
const lfr = "𝔩";
const lg = "≶";
const lgE = "⪑";
const lHar = "⥢";
const lhard = "↽";
const lharu = "↼";
const lharul = "⥪";
const lhblk = "▄";
const LJcy = "Љ";
const ljcy = "љ";
const llarr = "⇇";
const ll = "≪";
const Ll = "⋘";
const llcorner = "⌞";
const Lleftarrow = "⇚";
const llhard = "⥫";
const lltri = "◺";
const Lmidot = "Ŀ";
const lmidot = "ŀ";
const lmoustache = "⎰";
const lmoust = "⎰";
const lnap = "⪉";
const lnapprox = "⪉";
const lne = "⪇";
const lnE = "≨";
const lneq = "⪇";
const lneqq = "≨";
const lnsim = "⋦";
const loang = "⟬";
const loarr = "⇽";
const lobrk = "⟦";
const longleftarrow = "⟵";
const LongLeftArrow = "⟵";
const Longleftarrow = "⟸";
const longleftrightarrow = "⟷";
const LongLeftRightArrow = "⟷";
const Longleftrightarrow = "⟺";
const longmapsto = "⟼";
const longrightarrow = "⟶";
const LongRightArrow = "⟶";
const Longrightarrow = "⟹";
const looparrowleft = "↫";
const looparrowright = "↬";
const lopar = "⦅";
const Lopf = "𝕃";
const lopf = "𝕝";
const loplus = "⨭";
const lotimes = "⨴";
const lowast = "∗";
const lowbar = "_";
const LowerLeftArrow = "↙";
const LowerRightArrow = "↘";
const loz = "◊";
const lozenge = "◊";
const lozf = "⧫";
const lpar = "(";
const lparlt = "⦓";
const lrarr = "⇆";
const lrcorner = "⌟";
const lrhar = "⇋";
const lrhard = "⥭";
const lrm = "‎";
const lrtri = "⊿";
const lsaquo = "‹";
const lscr = "𝓁";
const Lscr = "ℒ";
const lsh = "↰";
const Lsh = "↰";
const lsim = "≲";
const lsime = "⪍";
const lsimg = "⪏";
const lsqb = "[";
const lsquo = "‘";
const lsquor = "‚";
const Lstrok = "Ł";
const lstrok = "ł";
const ltcc = "⪦";
const ltcir = "⩹";
const lt = "<";
const LT = "<";
const Lt = "≪";
const ltdot = "⋖";
const lthree = "⋋";
const ltimes = "⋉";
const ltlarr = "⥶";
const ltquest = "⩻";
const ltri = "◃";
const ltrie = "⊴";
const ltrif = "◂";
const ltrPar = "⦖";
const lurdshar = "⥊";
const luruhar = "⥦";
const lvertneqq = "≨︀";
const lvnE = "≨︀";
const macr = "¯";
const male = "♂";
const malt = "✠";
const maltese = "✠";
const map$1 = "↦";
const mapsto = "↦";
const mapstodown = "↧";
const mapstoleft = "↤";
const mapstoup = "↥";
const marker = "▮";
const mcomma = "⨩";
const Mcy = "М";
const mcy = "м";
const mdash = "—";
const mDDot = "∺";
const measuredangle = "∡";
const MediumSpace = " ";
const Mellintrf = "ℳ";
const Mfr = "𝔐";
const mfr = "𝔪";
const mho = "℧";
const micro = "µ";
const midast = "*";
const midcir = "⫰";
const mid = "∣";
const middot = "·";
const minusb = "⊟";
const minus = "−";
const minusd = "∸";
const minusdu = "⨪";
const MinusPlus = "∓";
const mlcp = "⫛";
const mldr = "…";
const mnplus = "∓";
const models = "⊧";
const Mopf = "𝕄";
const mopf = "𝕞";
const mp = "∓";
const mscr = "𝓂";
const Mscr = "ℳ";
const mstpos = "∾";
const Mu = "Μ";
const mu = "μ";
const multimap = "⊸";
const mumap = "⊸";
const nabla = "∇";
const Nacute = "Ń";
const nacute = "ń";
const nang = "∠⃒";
const nap = "≉";
const napE = "⩰̸";
const napid = "≋̸";
const napos = "ŉ";
const napprox = "≉";
const natural = "♮";
const naturals = "ℕ";
const natur = "♮";
const nbsp = " ";
const nbump = "≎̸";
const nbumpe = "≏̸";
const ncap = "⩃";
const Ncaron = "Ň";
const ncaron = "ň";
const Ncedil = "Ņ";
const ncedil = "ņ";
const ncong = "≇";
const ncongdot = "⩭̸";
const ncup = "⩂";
const Ncy = "Н";
const ncy = "н";
const ndash = "–";
const nearhk = "⤤";
const nearr = "↗";
const neArr = "⇗";
const nearrow = "↗";
const ne = "≠";
const nedot = "≐̸";
const NegativeMediumSpace = "​";
const NegativeThickSpace = "​";
const NegativeThinSpace = "​";
const NegativeVeryThinSpace = "​";
const nequiv = "≢";
const nesear = "⤨";
const nesim = "≂̸";
const NestedGreaterGreater = "≫";
const NestedLessLess = "≪";
const NewLine = "\n";
const nexist = "∄";
const nexists = "∄";
const Nfr = "𝔑";
const nfr = "𝔫";
const ngE = "≧̸";
const nge = "≱";
const ngeq = "≱";
const ngeqq = "≧̸";
const ngeqslant = "⩾̸";
const nges = "⩾̸";
const nGg = "⋙̸";
const ngsim = "≵";
const nGt = "≫⃒";
const ngt = "≯";
const ngtr = "≯";
const nGtv = "≫̸";
const nharr = "↮";
const nhArr = "⇎";
const nhpar = "⫲";
const ni = "∋";
const nis = "⋼";
const nisd = "⋺";
const niv = "∋";
const NJcy = "Њ";
const njcy = "њ";
const nlarr = "↚";
const nlArr = "⇍";
const nldr = "‥";
const nlE = "≦̸";
const nle = "≰";
const nleftarrow = "↚";
const nLeftarrow = "⇍";
const nleftrightarrow = "↮";
const nLeftrightarrow = "⇎";
const nleq = "≰";
const nleqq = "≦̸";
const nleqslant = "⩽̸";
const nles = "⩽̸";
const nless = "≮";
const nLl = "⋘̸";
const nlsim = "≴";
const nLt = "≪⃒";
const nlt = "≮";
const nltri = "⋪";
const nltrie = "⋬";
const nLtv = "≪̸";
const nmid = "∤";
const NoBreak = "⁠";
const NonBreakingSpace = " ";
const nopf = "𝕟";
const Nopf = "ℕ";
const Not = "⫬";
const not = "¬";
const NotCongruent = "≢";
const NotCupCap = "≭";
const NotDoubleVerticalBar = "∦";
const NotElement = "∉";
const NotEqual = "≠";
const NotEqualTilde = "≂̸";
const NotExists = "∄";
const NotGreater = "≯";
const NotGreaterEqual = "≱";
const NotGreaterFullEqual = "≧̸";
const NotGreaterGreater = "≫̸";
const NotGreaterLess = "≹";
const NotGreaterSlantEqual = "⩾̸";
const NotGreaterTilde = "≵";
const NotHumpDownHump = "≎̸";
const NotHumpEqual = "≏̸";
const notin = "∉";
const notindot = "⋵̸";
const notinE = "⋹̸";
const notinva = "∉";
const notinvb = "⋷";
const notinvc = "⋶";
const NotLeftTriangleBar = "⧏̸";
const NotLeftTriangle = "⋪";
const NotLeftTriangleEqual = "⋬";
const NotLess = "≮";
const NotLessEqual = "≰";
const NotLessGreater = "≸";
const NotLessLess = "≪̸";
const NotLessSlantEqual = "⩽̸";
const NotLessTilde = "≴";
const NotNestedGreaterGreater = "⪢̸";
const NotNestedLessLess = "⪡̸";
const notni = "∌";
const notniva = "∌";
const notnivb = "⋾";
const notnivc = "⋽";
const NotPrecedes = "⊀";
const NotPrecedesEqual = "⪯̸";
const NotPrecedesSlantEqual = "⋠";
const NotReverseElement = "∌";
const NotRightTriangleBar = "⧐̸";
const NotRightTriangle = "⋫";
const NotRightTriangleEqual = "⋭";
const NotSquareSubset = "⊏̸";
const NotSquareSubsetEqual = "⋢";
const NotSquareSuperset = "⊐̸";
const NotSquareSupersetEqual = "⋣";
const NotSubset = "⊂⃒";
const NotSubsetEqual = "⊈";
const NotSucceeds = "⊁";
const NotSucceedsEqual = "⪰̸";
const NotSucceedsSlantEqual = "⋡";
const NotSucceedsTilde = "≿̸";
const NotSuperset = "⊃⃒";
const NotSupersetEqual = "⊉";
const NotTilde = "≁";
const NotTildeEqual = "≄";
const NotTildeFullEqual = "≇";
const NotTildeTilde = "≉";
const NotVerticalBar = "∤";
const nparallel = "∦";
const npar = "∦";
const nparsl = "⫽⃥";
const npart = "∂̸";
const npolint = "⨔";
const npr = "⊀";
const nprcue = "⋠";
const nprec = "⊀";
const npreceq = "⪯̸";
const npre = "⪯̸";
const nrarrc = "⤳̸";
const nrarr = "↛";
const nrArr = "⇏";
const nrarrw = "↝̸";
const nrightarrow = "↛";
const nRightarrow = "⇏";
const nrtri = "⋫";
const nrtrie = "⋭";
const nsc = "⊁";
const nsccue = "⋡";
const nsce = "⪰̸";
const Nscr = "𝒩";
const nscr = "𝓃";
const nshortmid = "∤";
const nshortparallel = "∦";
const nsim = "≁";
const nsime = "≄";
const nsimeq = "≄";
const nsmid = "∤";
const nspar = "∦";
const nsqsube = "⋢";
const nsqsupe = "⋣";
const nsub = "⊄";
const nsubE = "⫅̸";
const nsube = "⊈";
const nsubset = "⊂⃒";
const nsubseteq = "⊈";
const nsubseteqq = "⫅̸";
const nsucc = "⊁";
const nsucceq = "⪰̸";
const nsup = "⊅";
const nsupE = "⫆̸";
const nsupe = "⊉";
const nsupset = "⊃⃒";
const nsupseteq = "⊉";
const nsupseteqq = "⫆̸";
const ntgl = "≹";
const Ntilde = "Ñ";
const ntilde = "ñ";
const ntlg = "≸";
const ntriangleleft = "⋪";
const ntrianglelefteq = "⋬";
const ntriangleright = "⋫";
const ntrianglerighteq = "⋭";
const Nu = "Ν";
const nu = "ν";
const num = "#";
const numero = "№";
const numsp = " ";
const nvap = "≍⃒";
const nvdash = "⊬";
const nvDash = "⊭";
const nVdash = "⊮";
const nVDash = "⊯";
const nvge = "≥⃒";
const nvgt = ">⃒";
const nvHarr = "⤄";
const nvinfin = "⧞";
const nvlArr = "⤂";
const nvle = "≤⃒";
const nvlt = "<⃒";
const nvltrie = "⊴⃒";
const nvrArr = "⤃";
const nvrtrie = "⊵⃒";
const nvsim = "∼⃒";
const nwarhk = "⤣";
const nwarr = "↖";
const nwArr = "⇖";
const nwarrow = "↖";
const nwnear = "⤧";
const Oacute = "Ó";
const oacute = "ó";
const oast = "⊛";
const Ocirc = "Ô";
const ocirc = "ô";
const ocir = "⊚";
const Ocy = "О";
const ocy = "о";
const odash = "⊝";
const Odblac = "Ő";
const odblac = "ő";
const odiv = "⨸";
const odot = "⊙";
const odsold = "⦼";
const OElig = "Œ";
const oelig = "œ";
const ofcir = "⦿";
const Ofr = "𝔒";
const ofr = "𝔬";
const ogon = "˛";
const Ograve = "Ò";
const ograve = "ò";
const ogt = "⧁";
const ohbar = "⦵";
const ohm = "Ω";
const oint = "∮";
const olarr = "↺";
const olcir = "⦾";
const olcross = "⦻";
const oline = "‾";
const olt = "⧀";
const Omacr = "Ō";
const omacr = "ō";
const Omega = "Ω";
const omega = "ω";
const Omicron = "Ο";
const omicron = "ο";
const omid = "⦶";
const ominus = "⊖";
const Oopf = "𝕆";
const oopf = "𝕠";
const opar = "⦷";
const OpenCurlyDoubleQuote = "“";
const OpenCurlyQuote = "‘";
const operp = "⦹";
const oplus = "⊕";
const orarr = "↻";
const Or = "⩔";
const or = "∨";
const ord = "⩝";
const order = "ℴ";
const orderof = "ℴ";
const ordf = "ª";
const ordm = "º";
const origof = "⊶";
const oror = "⩖";
const orslope = "⩗";
const orv = "⩛";
const oS = "Ⓢ";
const Oscr = "𝒪";
const oscr = "ℴ";
const Oslash = "Ø";
const oslash = "ø";
const osol = "⊘";
const Otilde = "Õ";
const otilde = "õ";
const otimesas = "⨶";
const Otimes = "⨷";
const otimes = "⊗";
const Ouml = "Ö";
const ouml = "ö";
const ovbar = "⌽";
const OverBar = "‾";
const OverBrace = "⏞";
const OverBracket = "⎴";
const OverParenthesis = "⏜";
const para = "¶";
const parallel = "∥";
const par = "∥";
const parsim = "⫳";
const parsl = "⫽";
const part = "∂";
const PartialD = "∂";
const Pcy = "П";
const pcy = "п";
const percnt = "%";
const period = ".";
const permil = "‰";
const perp = "⊥";
const pertenk = "‱";
const Pfr = "𝔓";
const pfr = "𝔭";
const Phi = "Φ";
const phi = "φ";
const phiv = "ϕ";
const phmmat = "ℳ";
const phone = "☎";
const Pi = "Π";
const pi = "π";
const pitchfork = "⋔";
const piv = "ϖ";
const planck = "ℏ";
const planckh = "ℎ";
const plankv = "ℏ";
const plusacir = "⨣";
const plusb = "⊞";
const pluscir = "⨢";
const plus = "+";
const plusdo = "∔";
const plusdu = "⨥";
const pluse = "⩲";
const PlusMinus = "±";
const plusmn = "±";
const plussim = "⨦";
const plustwo = "⨧";
const pm = "±";
const Poincareplane = "ℌ";
const pointint = "⨕";
const popf = "𝕡";
const Popf = "ℙ";
const pound = "£";
const prap = "⪷";
const Pr = "⪻";
const pr = "≺";
const prcue = "≼";
const precapprox = "⪷";
const prec = "≺";
const preccurlyeq = "≼";
const Precedes = "≺";
const PrecedesEqual = "⪯";
const PrecedesSlantEqual = "≼";
const PrecedesTilde = "≾";
const preceq = "⪯";
const precnapprox = "⪹";
const precneqq = "⪵";
const precnsim = "⋨";
const pre = "⪯";
const prE = "⪳";
const precsim = "≾";
const prime = "′";
const Prime = "″";
const primes = "ℙ";
const prnap = "⪹";
const prnE = "⪵";
const prnsim = "⋨";
const prod = "∏";
const Product = "∏";
const profalar = "⌮";
const profline = "⌒";
const profsurf = "⌓";
const prop = "∝";
const Proportional = "∝";
const Proportion = "∷";
const propto = "∝";
const prsim = "≾";
const prurel = "⊰";
const Pscr = "𝒫";
const pscr = "𝓅";
const Psi = "Ψ";
const psi = "ψ";
const puncsp = " ";
const Qfr = "𝔔";
const qfr = "𝔮";
const qint = "⨌";
const qopf = "𝕢";
const Qopf = "ℚ";
const qprime = "⁗";
const Qscr = "𝒬";
const qscr = "𝓆";
const quaternions = "ℍ";
const quatint = "⨖";
const quest = "?";
const questeq = "≟";
const quot = "\"";
const QUOT = "\"";
const rAarr = "⇛";
const race = "∽̱";
const Racute = "Ŕ";
const racute = "ŕ";
const radic = "√";
const raemptyv = "⦳";
const rang = "⟩";
const Rang = "⟫";
const rangd = "⦒";
const range = "⦥";
const rangle = "⟩";
const raquo = "»";
const rarrap = "⥵";
const rarrb = "⇥";
const rarrbfs = "⤠";
const rarrc = "⤳";
const rarr = "→";
const Rarr = "↠";
const rArr = "⇒";
const rarrfs = "⤞";
const rarrhk = "↪";
const rarrlp = "↬";
const rarrpl = "⥅";
const rarrsim = "⥴";
const Rarrtl = "⤖";
const rarrtl = "↣";
const rarrw = "↝";
const ratail = "⤚";
const rAtail = "⤜";
const ratio = "∶";
const rationals = "ℚ";
const rbarr = "⤍";
const rBarr = "⤏";
const RBarr = "⤐";
const rbbrk = "❳";
const rbrace = "}";
const rbrack = "]";
const rbrke = "⦌";
const rbrksld = "⦎";
const rbrkslu = "⦐";
const Rcaron = "Ř";
const rcaron = "ř";
const Rcedil = "Ŗ";
const rcedil = "ŗ";
const rceil = "⌉";
const rcub = "}";
const Rcy = "Р";
const rcy = "р";
const rdca = "⤷";
const rdldhar = "⥩";
const rdquo = "”";
const rdquor = "”";
const rdsh = "↳";
const real = "ℜ";
const realine = "ℛ";
const realpart = "ℜ";
const reals = "ℝ";
const Re = "ℜ";
const rect = "▭";
const reg = "®";
const REG = "®";
const ReverseElement = "∋";
const ReverseEquilibrium = "⇋";
const ReverseUpEquilibrium = "⥯";
const rfisht = "⥽";
const rfloor = "⌋";
const rfr = "𝔯";
const Rfr = "ℜ";
const rHar = "⥤";
const rhard = "⇁";
const rharu = "⇀";
const rharul = "⥬";
const Rho = "Ρ";
const rho = "ρ";
const rhov = "ϱ";
const RightAngleBracket = "⟩";
const RightArrowBar = "⇥";
const rightarrow = "→";
const RightArrow = "→";
const Rightarrow = "⇒";
const RightArrowLeftArrow = "⇄";
const rightarrowtail = "↣";
const RightCeiling = "⌉";
const RightDoubleBracket = "⟧";
const RightDownTeeVector = "⥝";
const RightDownVectorBar = "⥕";
const RightDownVector = "⇂";
const RightFloor = "⌋";
const rightharpoondown = "⇁";
const rightharpoonup = "⇀";
const rightleftarrows = "⇄";
const rightleftharpoons = "⇌";
const rightrightarrows = "⇉";
const rightsquigarrow = "↝";
const RightTeeArrow = "↦";
const RightTee = "⊢";
const RightTeeVector = "⥛";
const rightthreetimes = "⋌";
const RightTriangleBar = "⧐";
const RightTriangle = "⊳";
const RightTriangleEqual = "⊵";
const RightUpDownVector = "⥏";
const RightUpTeeVector = "⥜";
const RightUpVectorBar = "⥔";
const RightUpVector = "↾";
const RightVectorBar = "⥓";
const RightVector = "⇀";
const ring = "˚";
const risingdotseq = "≓";
const rlarr = "⇄";
const rlhar = "⇌";
const rlm = "‏";
const rmoustache = "⎱";
const rmoust = "⎱";
const rnmid = "⫮";
const roang = "⟭";
const roarr = "⇾";
const robrk = "⟧";
const ropar = "⦆";
const ropf = "𝕣";
const Ropf = "ℝ";
const roplus = "⨮";
const rotimes = "⨵";
const RoundImplies = "⥰";
const rpar = ")";
const rpargt = "⦔";
const rppolint = "⨒";
const rrarr = "⇉";
const Rrightarrow = "⇛";
const rsaquo = "›";
const rscr = "𝓇";
const Rscr = "ℛ";
const rsh = "↱";
const Rsh = "↱";
const rsqb = "]";
const rsquo = "’";
const rsquor = "’";
const rthree = "⋌";
const rtimes = "⋊";
const rtri = "▹";
const rtrie = "⊵";
const rtrif = "▸";
const rtriltri = "⧎";
const RuleDelayed = "⧴";
const ruluhar = "⥨";
const rx = "℞";
const Sacute = "Ś";
const sacute = "ś";
const sbquo = "‚";
const scap = "⪸";
const Scaron = "Š";
const scaron = "š";
const Sc = "⪼";
const sc = "≻";
const sccue = "≽";
const sce = "⪰";
const scE = "⪴";
const Scedil = "Ş";
const scedil = "ş";
const Scirc = "Ŝ";
const scirc = "ŝ";
const scnap = "⪺";
const scnE = "⪶";
const scnsim = "⋩";
const scpolint = "⨓";
const scsim = "≿";
const Scy = "С";
const scy = "с";
const sdotb = "⊡";
const sdot = "⋅";
const sdote = "⩦";
const searhk = "⤥";
const searr = "↘";
const seArr = "⇘";
const searrow = "↘";
const sect = "§";
const semi = ";";
const seswar = "⤩";
const setminus = "∖";
const setmn = "∖";
const sext = "✶";
const Sfr = "𝔖";
const sfr = "𝔰";
const sfrown = "⌢";
const sharp = "♯";
const SHCHcy = "Щ";
const shchcy = "щ";
const SHcy = "Ш";
const shcy = "ш";
const ShortDownArrow = "↓";
const ShortLeftArrow = "←";
const shortmid = "∣";
const shortparallel = "∥";
const ShortRightArrow = "→";
const ShortUpArrow = "↑";
const shy = "­";
const Sigma = "Σ";
const sigma = "σ";
const sigmaf = "ς";
const sigmav = "ς";
const sim = "∼";
const simdot = "⩪";
const sime = "≃";
const simeq = "≃";
const simg = "⪞";
const simgE = "⪠";
const siml = "⪝";
const simlE = "⪟";
const simne = "≆";
const simplus = "⨤";
const simrarr = "⥲";
const slarr = "←";
const SmallCircle = "∘";
const smallsetminus = "∖";
const smashp = "⨳";
const smeparsl = "⧤";
const smid = "∣";
const smile = "⌣";
const smt = "⪪";
const smte = "⪬";
const smtes = "⪬︀";
const SOFTcy = "Ь";
const softcy = "ь";
const solbar = "⌿";
const solb = "⧄";
const sol = "/";
const Sopf = "𝕊";
const sopf = "𝕤";
const spades = "♠";
const spadesuit = "♠";
const spar = "∥";
const sqcap = "⊓";
const sqcaps = "⊓︀";
const sqcup = "⊔";
const sqcups = "⊔︀";
const Sqrt = "√";
const sqsub = "⊏";
const sqsube = "⊑";
const sqsubset = "⊏";
const sqsubseteq = "⊑";
const sqsup = "⊐";
const sqsupe = "⊒";
const sqsupset = "⊐";
const sqsupseteq = "⊒";
const square = "□";
const Square = "□";
const SquareIntersection = "⊓";
const SquareSubset = "⊏";
const SquareSubsetEqual = "⊑";
const SquareSuperset = "⊐";
const SquareSupersetEqual = "⊒";
const SquareUnion = "⊔";
const squarf = "▪";
const squ = "□";
const squf = "▪";
const srarr = "→";
const Sscr = "𝒮";
const sscr = "𝓈";
const ssetmn = "∖";
const ssmile = "⌣";
const sstarf = "⋆";
const Star = "⋆";
const star = "☆";
const starf = "★";
const straightepsilon = "ϵ";
const straightphi = "ϕ";
const strns = "¯";
const sub = "⊂";
const Sub = "⋐";
const subdot = "⪽";
const subE = "⫅";
const sube = "⊆";
const subedot = "⫃";
const submult = "⫁";
const subnE = "⫋";
const subne = "⊊";
const subplus = "⪿";
const subrarr = "⥹";
const subset = "⊂";
const Subset = "⋐";
const subseteq = "⊆";
const subseteqq = "⫅";
const SubsetEqual = "⊆";
const subsetneq = "⊊";
const subsetneqq = "⫋";
const subsim = "⫇";
const subsub = "⫕";
const subsup = "⫓";
const succapprox = "⪸";
const succ = "≻";
const succcurlyeq = "≽";
const Succeeds = "≻";
const SucceedsEqual = "⪰";
const SucceedsSlantEqual = "≽";
const SucceedsTilde = "≿";
const succeq = "⪰";
const succnapprox = "⪺";
const succneqq = "⪶";
const succnsim = "⋩";
const succsim = "≿";
const SuchThat = "∋";
const sum = "∑";
const Sum = "∑";
const sung = "♪";
const sup1 = "¹";
const sup2 = "²";
const sup3 = "³";
const sup = "⊃";
const Sup = "⋑";
const supdot = "⪾";
const supdsub = "⫘";
const supE = "⫆";
const supe = "⊇";
const supedot = "⫄";
const Superset = "⊃";
const SupersetEqual = "⊇";
const suphsol = "⟉";
const suphsub = "⫗";
const suplarr = "⥻";
const supmult = "⫂";
const supnE = "⫌";
const supne = "⊋";
const supplus = "⫀";
const supset = "⊃";
const Supset = "⋑";
const supseteq = "⊇";
const supseteqq = "⫆";
const supsetneq = "⊋";
const supsetneqq = "⫌";
const supsim = "⫈";
const supsub = "⫔";
const supsup = "⫖";
const swarhk = "⤦";
const swarr = "↙";
const swArr = "⇙";
const swarrow = "↙";
const swnwar = "⤪";
const szlig = "ß";
const Tab = "\t";
const target = "⌖";
const Tau = "Τ";
const tau = "τ";
const tbrk = "⎴";
const Tcaron = "Ť";
const tcaron = "ť";
const Tcedil = "Ţ";
const tcedil = "ţ";
const Tcy = "Т";
const tcy = "т";
const tdot = "⃛";
const telrec = "⌕";
const Tfr = "𝔗";
const tfr = "𝔱";
const there4 = "∴";
const therefore = "∴";
const Therefore = "∴";
const Theta = "Θ";
const theta = "θ";
const thetasym = "ϑ";
const thetav = "ϑ";
const thickapprox = "≈";
const thicksim = "∼";
const ThickSpace = "  ";
const ThinSpace = " ";
const thinsp = " ";
const thkap = "≈";
const thksim = "∼";
const THORN = "Þ";
const thorn = "þ";
const tilde = "˜";
const Tilde = "∼";
const TildeEqual = "≃";
const TildeFullEqual = "≅";
const TildeTilde = "≈";
const timesbar = "⨱";
const timesb = "⊠";
const times = "×";
const timesd = "⨰";
const tint = "∭";
const toea = "⤨";
const topbot = "⌶";
const topcir = "⫱";
const top = "⊤";
const Topf = "𝕋";
const topf = "𝕥";
const topfork = "⫚";
const tosa = "⤩";
const tprime = "‴";
const trade = "™";
const TRADE = "™";
const triangle = "▵";
const triangledown = "▿";
const triangleleft = "◃";
const trianglelefteq = "⊴";
const triangleq = "≜";
const triangleright = "▹";
const trianglerighteq = "⊵";
const tridot = "◬";
const trie = "≜";
const triminus = "⨺";
const TripleDot = "⃛";
const triplus = "⨹";
const trisb = "⧍";
const tritime = "⨻";
const trpezium = "⏢";
const Tscr = "𝒯";
const tscr = "𝓉";
const TScy = "Ц";
const tscy = "ц";
const TSHcy = "Ћ";
const tshcy = "ћ";
const Tstrok = "Ŧ";
const tstrok = "ŧ";
const twixt = "≬";
const twoheadleftarrow = "↞";
const twoheadrightarrow = "↠";
const Uacute = "Ú";
const uacute = "ú";
const uarr = "↑";
const Uarr = "↟";
const uArr = "⇑";
const Uarrocir = "⥉";
const Ubrcy = "Ў";
const ubrcy = "ў";
const Ubreve = "Ŭ";
const ubreve = "ŭ";
const Ucirc = "Û";
const ucirc = "û";
const Ucy = "У";
const ucy = "у";
const udarr = "⇅";
const Udblac = "Ű";
const udblac = "ű";
const udhar = "⥮";
const ufisht = "⥾";
const Ufr = "𝔘";
const ufr = "𝔲";
const Ugrave = "Ù";
const ugrave = "ù";
const uHar = "⥣";
const uharl = "↿";
const uharr = "↾";
const uhblk = "▀";
const ulcorn = "⌜";
const ulcorner = "⌜";
const ulcrop = "⌏";
const ultri = "◸";
const Umacr = "Ū";
const umacr = "ū";
const uml = "¨";
const UnderBar = "_";
const UnderBrace = "⏟";
const UnderBracket = "⎵";
const UnderParenthesis = "⏝";
const Union = "⋃";
const UnionPlus = "⊎";
const Uogon = "Ų";
const uogon = "ų";
const Uopf = "𝕌";
const uopf = "𝕦";
const UpArrowBar = "⤒";
const uparrow = "↑";
const UpArrow = "↑";
const Uparrow = "⇑";
const UpArrowDownArrow = "⇅";
const updownarrow = "↕";
const UpDownArrow = "↕";
const Updownarrow = "⇕";
const UpEquilibrium = "⥮";
const upharpoonleft = "↿";
const upharpoonright = "↾";
const uplus = "⊎";
const UpperLeftArrow = "↖";
const UpperRightArrow = "↗";
const upsi = "υ";
const Upsi = "ϒ";
const upsih = "ϒ";
const Upsilon = "Υ";
const upsilon = "υ";
const UpTeeArrow = "↥";
const UpTee = "⊥";
const upuparrows = "⇈";
const urcorn = "⌝";
const urcorner = "⌝";
const urcrop = "⌎";
const Uring = "Ů";
const uring = "ů";
const urtri = "◹";
const Uscr = "𝒰";
const uscr = "𝓊";
const utdot = "⋰";
const Utilde = "Ũ";
const utilde = "ũ";
const utri = "▵";
const utrif = "▴";
const uuarr = "⇈";
const Uuml = "Ü";
const uuml = "ü";
const uwangle = "⦧";
const vangrt = "⦜";
const varepsilon = "ϵ";
const varkappa = "ϰ";
const varnothing = "∅";
const varphi = "ϕ";
const varpi = "ϖ";
const varpropto = "∝";
const varr = "↕";
const vArr = "⇕";
const varrho = "ϱ";
const varsigma = "ς";
const varsubsetneq = "⊊︀";
const varsubsetneqq = "⫋︀";
const varsupsetneq = "⊋︀";
const varsupsetneqq = "⫌︀";
const vartheta = "ϑ";
const vartriangleleft = "⊲";
const vartriangleright = "⊳";
const vBar = "⫨";
const Vbar = "⫫";
const vBarv = "⫩";
const Vcy = "В";
const vcy = "в";
const vdash = "⊢";
const vDash = "⊨";
const Vdash = "⊩";
const VDash = "⊫";
const Vdashl = "⫦";
const veebar = "⊻";
const vee = "∨";
const Vee = "⋁";
const veeeq = "≚";
const vellip = "⋮";
const verbar = "|";
const Verbar = "‖";
const vert = "|";
const Vert = "‖";
const VerticalBar = "∣";
const VerticalLine = "|";
const VerticalSeparator = "❘";
const VerticalTilde = "≀";
const VeryThinSpace = " ";
const Vfr = "𝔙";
const vfr = "𝔳";
const vltri = "⊲";
const vnsub = "⊂⃒";
const vnsup = "⊃⃒";
const Vopf = "𝕍";
const vopf = "𝕧";
const vprop = "∝";
const vrtri = "⊳";
const Vscr = "𝒱";
const vscr = "𝓋";
const vsubnE = "⫋︀";
const vsubne = "⊊︀";
const vsupnE = "⫌︀";
const vsupne = "⊋︀";
const Vvdash = "⊪";
const vzigzag = "⦚";
const Wcirc = "Ŵ";
const wcirc = "ŵ";
const wedbar = "⩟";
const wedge = "∧";
const Wedge = "⋀";
const wedgeq = "≙";
const weierp = "℘";
const Wfr = "𝔚";
const wfr = "𝔴";
const Wopf = "𝕎";
const wopf = "𝕨";
const wp = "℘";
const wr = "≀";
const wreath = "≀";
const Wscr = "𝒲";
const wscr = "𝓌";
const xcap = "⋂";
const xcirc = "◯";
const xcup = "⋃";
const xdtri = "▽";
const Xfr = "𝔛";
const xfr = "𝔵";
const xharr = "⟷";
const xhArr = "⟺";
const Xi = "Ξ";
const xi = "ξ";
const xlarr = "⟵";
const xlArr = "⟸";
const xmap = "⟼";
const xnis = "⋻";
const xodot = "⨀";
const Xopf = "𝕏";
const xopf = "𝕩";
const xoplus = "⨁";
const xotime = "⨂";
const xrarr = "⟶";
const xrArr = "⟹";
const Xscr = "𝒳";
const xscr = "𝓍";
const xsqcup = "⨆";
const xuplus = "⨄";
const xutri = "△";
const xvee = "⋁";
const xwedge = "⋀";
const Yacute = "Ý";
const yacute = "ý";
const YAcy = "Я";
const yacy = "я";
const Ycirc = "Ŷ";
const ycirc = "ŷ";
const Ycy = "Ы";
const ycy = "ы";
const yen = "¥";
const Yfr = "𝔜";
const yfr = "𝔶";
const YIcy = "Ї";
const yicy = "ї";
const Yopf = "𝕐";
const yopf = "𝕪";
const Yscr = "𝒴";
const yscr = "𝓎";
const YUcy = "Ю";
const yucy = "ю";
const yuml = "ÿ";
const Yuml = "Ÿ";
const Zacute = "Ź";
const zacute = "ź";
const Zcaron = "Ž";
const zcaron = "ž";
const Zcy = "З";
const zcy = "з";
const Zdot = "Ż";
const zdot = "ż";
const zeetrf = "ℨ";
const ZeroWidthSpace = "​";
const Zeta = "Ζ";
const zeta = "ζ";
const zfr = "𝔷";
const Zfr = "ℨ";
const ZHcy = "Ж";
const zhcy = "ж";
const zigrarr = "⇝";
const zopf = "𝕫";
const Zopf = "ℤ";
const Zscr = "𝒵";
const zscr = "𝓏";
const zwj = "‍";
const zwnj = "‌";
const require$$0 = {
	Aacute: Aacute,
	aacute: aacute,
	Abreve: Abreve,
	abreve: abreve,
	ac: ac,
	acd: acd,
	acE: acE,
	Acirc: Acirc,
	acirc: acirc,
	acute: acute,
	Acy: Acy,
	acy: acy,
	AElig: AElig,
	aelig: aelig,
	af: af,
	Afr: Afr,
	afr: afr,
	Agrave: Agrave,
	agrave: agrave,
	alefsym: alefsym,
	aleph: aleph,
	Alpha: Alpha,
	alpha: alpha,
	Amacr: Amacr,
	amacr: amacr,
	amalg: amalg,
	amp: amp,
	AMP: AMP,
	andand: andand,
	And: And,
	and: and,
	andd: andd,
	andslope: andslope,
	andv: andv,
	ang: ang,
	ange: ange,
	angle: angle,
	angmsdaa: angmsdaa,
	angmsdab: angmsdab,
	angmsdac: angmsdac,
	angmsdad: angmsdad,
	angmsdae: angmsdae,
	angmsdaf: angmsdaf,
	angmsdag: angmsdag,
	angmsdah: angmsdah,
	angmsd: angmsd,
	angrt: angrt,
	angrtvb: angrtvb,
	angrtvbd: angrtvbd,
	angsph: angsph,
	angst: angst,
	angzarr: angzarr,
	Aogon: Aogon,
	aogon: aogon,
	Aopf: Aopf,
	aopf: aopf,
	apacir: apacir,
	ap: ap,
	apE: apE,
	ape: ape,
	apid: apid,
	apos: apos,
	ApplyFunction: ApplyFunction,
	approx: approx,
	approxeq: approxeq,
	Aring: Aring,
	aring: aring,
	Ascr: Ascr,
	ascr: ascr,
	Assign: Assign,
	ast: ast,
	asymp: asymp,
	asympeq: asympeq,
	Atilde: Atilde,
	atilde: atilde,
	Auml: Auml,
	auml: auml,
	awconint: awconint,
	awint: awint,
	backcong: backcong,
	backepsilon: backepsilon,
	backprime: backprime,
	backsim: backsim,
	backsimeq: backsimeq,
	Backslash: Backslash,
	Barv: Barv,
	barvee: barvee,
	barwed: barwed,
	Barwed: Barwed,
	barwedge: barwedge,
	bbrk: bbrk,
	bbrktbrk: bbrktbrk,
	bcong: bcong,
	Bcy: Bcy,
	bcy: bcy,
	bdquo: bdquo,
	becaus: becaus,
	because: because,
	Because: Because,
	bemptyv: bemptyv,
	bepsi: bepsi,
	bernou: bernou,
	Bernoullis: Bernoullis,
	Beta: Beta,
	beta: beta,
	beth: beth,
	between: between,
	Bfr: Bfr,
	bfr: bfr,
	bigcap: bigcap,
	bigcirc: bigcirc,
	bigcup: bigcup,
	bigodot: bigodot,
	bigoplus: bigoplus,
	bigotimes: bigotimes,
	bigsqcup: bigsqcup,
	bigstar: bigstar,
	bigtriangledown: bigtriangledown,
	bigtriangleup: bigtriangleup,
	biguplus: biguplus,
	bigvee: bigvee,
	bigwedge: bigwedge,
	bkarow: bkarow,
	blacklozenge: blacklozenge,
	blacksquare: blacksquare,
	blacktriangle: blacktriangle,
	blacktriangledown: blacktriangledown,
	blacktriangleleft: blacktriangleleft,
	blacktriangleright: blacktriangleright,
	blank: blank,
	blk12: blk12,
	blk14: blk14,
	blk34: blk34,
	block: block$1,
	bne: bne,
	bnequiv: bnequiv,
	bNot: bNot,
	bnot: bnot,
	Bopf: Bopf,
	bopf: bopf,
	bot: bot,
	bottom: bottom,
	bowtie: bowtie,
	boxbox: boxbox,
	boxdl: boxdl,
	boxdL: boxdL,
	boxDl: boxDl,
	boxDL: boxDL,
	boxdr: boxdr,
	boxdR: boxdR,
	boxDr: boxDr,
	boxDR: boxDR,
	boxh: boxh,
	boxH: boxH,
	boxhd: boxhd,
	boxHd: boxHd,
	boxhD: boxhD,
	boxHD: boxHD,
	boxhu: boxhu,
	boxHu: boxHu,
	boxhU: boxhU,
	boxHU: boxHU,
	boxminus: boxminus,
	boxplus: boxplus,
	boxtimes: boxtimes,
	boxul: boxul,
	boxuL: boxuL,
	boxUl: boxUl,
	boxUL: boxUL,
	boxur: boxur,
	boxuR: boxuR,
	boxUr: boxUr,
	boxUR: boxUR,
	boxv: boxv,
	boxV: boxV,
	boxvh: boxvh,
	boxvH: boxvH,
	boxVh: boxVh,
	boxVH: boxVH,
	boxvl: boxvl,
	boxvL: boxvL,
	boxVl: boxVl,
	boxVL: boxVL,
	boxvr: boxvr,
	boxvR: boxvR,
	boxVr: boxVr,
	boxVR: boxVR,
	bprime: bprime,
	breve: breve,
	Breve: Breve,
	brvbar: brvbar,
	bscr: bscr,
	Bscr: Bscr,
	bsemi: bsemi,
	bsim: bsim,
	bsime: bsime,
	bsolb: bsolb,
	bsol: bsol,
	bsolhsub: bsolhsub,
	bull: bull,
	bullet: bullet,
	bump: bump,
	bumpE: bumpE,
	bumpe: bumpe,
	Bumpeq: Bumpeq,
	bumpeq: bumpeq,
	Cacute: Cacute,
	cacute: cacute,
	capand: capand,
	capbrcup: capbrcup,
	capcap: capcap,
	cap: cap,
	Cap: Cap,
	capcup: capcup,
	capdot: capdot,
	CapitalDifferentialD: CapitalDifferentialD,
	caps: caps,
	caret: caret,
	caron: caron,
	Cayleys: Cayleys,
	ccaps: ccaps,
	Ccaron: Ccaron,
	ccaron: ccaron,
	Ccedil: Ccedil,
	ccedil: ccedil,
	Ccirc: Ccirc,
	ccirc: ccirc,
	Cconint: Cconint,
	ccups: ccups,
	ccupssm: ccupssm,
	Cdot: Cdot,
	cdot: cdot,
	cedil: cedil,
	Cedilla: Cedilla,
	cemptyv: cemptyv,
	cent: cent,
	centerdot: centerdot,
	CenterDot: CenterDot,
	cfr: cfr,
	Cfr: Cfr,
	CHcy: CHcy,
	chcy: chcy,
	check: check,
	checkmark: checkmark,
	Chi: Chi,
	chi: chi,
	circ: circ,
	circeq: circeq,
	circlearrowleft: circlearrowleft,
	circlearrowright: circlearrowright,
	circledast: circledast,
	circledcirc: circledcirc,
	circleddash: circleddash,
	CircleDot: CircleDot,
	circledR: circledR,
	circledS: circledS,
	CircleMinus: CircleMinus,
	CirclePlus: CirclePlus,
	CircleTimes: CircleTimes,
	cir: cir,
	cirE: cirE,
	cire: cire,
	cirfnint: cirfnint,
	cirmid: cirmid,
	cirscir: cirscir,
	ClockwiseContourIntegral: ClockwiseContourIntegral,
	CloseCurlyDoubleQuote: CloseCurlyDoubleQuote,
	CloseCurlyQuote: CloseCurlyQuote,
	clubs: clubs,
	clubsuit: clubsuit,
	colon: colon,
	Colon: Colon,
	Colone: Colone,
	colone: colone,
	coloneq: coloneq,
	comma: comma,
	commat: commat,
	comp: comp,
	compfn: compfn,
	complement: complement,
	complexes: complexes,
	cong: cong,
	congdot: congdot,
	Congruent: Congruent,
	conint: conint,
	Conint: Conint,
	ContourIntegral: ContourIntegral,
	copf: copf,
	Copf: Copf,
	coprod: coprod,
	Coproduct: Coproduct,
	copy: copy,
	COPY: COPY,
	copysr: copysr,
	CounterClockwiseContourIntegral: CounterClockwiseContourIntegral,
	crarr: crarr,
	cross: cross,
	Cross: Cross,
	Cscr: Cscr,
	cscr: cscr,
	csub: csub,
	csube: csube,
	csup: csup,
	csupe: csupe,
	ctdot: ctdot,
	cudarrl: cudarrl,
	cudarrr: cudarrr,
	cuepr: cuepr,
	cuesc: cuesc,
	cularr: cularr,
	cularrp: cularrp,
	cupbrcap: cupbrcap,
	cupcap: cupcap,
	CupCap: CupCap,
	cup: cup,
	Cup: Cup,
	cupcup: cupcup,
	cupdot: cupdot,
	cupor: cupor,
	cups: cups,
	curarr: curarr,
	curarrm: curarrm,
	curlyeqprec: curlyeqprec,
	curlyeqsucc: curlyeqsucc,
	curlyvee: curlyvee,
	curlywedge: curlywedge,
	curren: curren,
	curvearrowleft: curvearrowleft,
	curvearrowright: curvearrowright,
	cuvee: cuvee,
	cuwed: cuwed,
	cwconint: cwconint,
	cwint: cwint,
	cylcty: cylcty,
	dagger: dagger,
	Dagger: Dagger,
	daleth: daleth,
	darr: darr,
	Darr: Darr,
	dArr: dArr,
	dash: dash,
	Dashv: Dashv,
	dashv: dashv,
	dbkarow: dbkarow,
	dblac: dblac,
	Dcaron: Dcaron,
	dcaron: dcaron,
	Dcy: Dcy,
	dcy: dcy,
	ddagger: ddagger,
	ddarr: ddarr,
	DD: DD,
	dd: dd,
	DDotrahd: DDotrahd,
	ddotseq: ddotseq,
	deg: deg,
	Del: Del,
	Delta: Delta,
	delta: delta,
	demptyv: demptyv,
	dfisht: dfisht,
	Dfr: Dfr,
	dfr: dfr,
	dHar: dHar,
	dharl: dharl,
	dharr: dharr,
	DiacriticalAcute: DiacriticalAcute,
	DiacriticalDot: DiacriticalDot,
	DiacriticalDoubleAcute: DiacriticalDoubleAcute,
	DiacriticalGrave: DiacriticalGrave,
	DiacriticalTilde: DiacriticalTilde,
	diam: diam,
	diamond: diamond,
	Diamond: Diamond,
	diamondsuit: diamondsuit,
	diams: diams,
	die: die,
	DifferentialD: DifferentialD,
	digamma: digamma,
	disin: disin,
	div: div,
	divide: divide,
	divideontimes: divideontimes,
	divonx: divonx,
	DJcy: DJcy,
	djcy: djcy,
	dlcorn: dlcorn,
	dlcrop: dlcrop,
	dollar: dollar,
	Dopf: Dopf,
	dopf: dopf,
	Dot: Dot,
	dot: dot,
	DotDot: DotDot,
	doteq: doteq,
	doteqdot: doteqdot,
	DotEqual: DotEqual,
	dotminus: dotminus,
	dotplus: dotplus,
	dotsquare: dotsquare,
	doublebarwedge: doublebarwedge,
	DoubleContourIntegral: DoubleContourIntegral,
	DoubleDot: DoubleDot,
	DoubleDownArrow: DoubleDownArrow,
	DoubleLeftArrow: DoubleLeftArrow,
	DoubleLeftRightArrow: DoubleLeftRightArrow,
	DoubleLeftTee: DoubleLeftTee,
	DoubleLongLeftArrow: DoubleLongLeftArrow,
	DoubleLongLeftRightArrow: DoubleLongLeftRightArrow,
	DoubleLongRightArrow: DoubleLongRightArrow,
	DoubleRightArrow: DoubleRightArrow,
	DoubleRightTee: DoubleRightTee,
	DoubleUpArrow: DoubleUpArrow,
	DoubleUpDownArrow: DoubleUpDownArrow,
	DoubleVerticalBar: DoubleVerticalBar,
	DownArrowBar: DownArrowBar,
	downarrow: downarrow,
	DownArrow: DownArrow,
	Downarrow: Downarrow,
	DownArrowUpArrow: DownArrowUpArrow,
	DownBreve: DownBreve,
	downdownarrows: downdownarrows,
	downharpoonleft: downharpoonleft,
	downharpoonright: downharpoonright,
	DownLeftRightVector: DownLeftRightVector,
	DownLeftTeeVector: DownLeftTeeVector,
	DownLeftVectorBar: DownLeftVectorBar,
	DownLeftVector: DownLeftVector,
	DownRightTeeVector: DownRightTeeVector,
	DownRightVectorBar: DownRightVectorBar,
	DownRightVector: DownRightVector,
	DownTeeArrow: DownTeeArrow,
	DownTee: DownTee,
	drbkarow: drbkarow,
	drcorn: drcorn,
	drcrop: drcrop,
	Dscr: Dscr,
	dscr: dscr,
	DScy: DScy,
	dscy: dscy,
	dsol: dsol,
	Dstrok: Dstrok,
	dstrok: dstrok,
	dtdot: dtdot,
	dtri: dtri,
	dtrif: dtrif,
	duarr: duarr,
	duhar: duhar,
	dwangle: dwangle,
	DZcy: DZcy,
	dzcy: dzcy,
	dzigrarr: dzigrarr,
	Eacute: Eacute,
	eacute: eacute,
	easter: easter,
	Ecaron: Ecaron,
	ecaron: ecaron,
	Ecirc: Ecirc,
	ecirc: ecirc,
	ecir: ecir,
	ecolon: ecolon,
	Ecy: Ecy,
	ecy: ecy,
	eDDot: eDDot,
	Edot: Edot,
	edot: edot,
	eDot: eDot,
	ee: ee,
	efDot: efDot,
	Efr: Efr,
	efr: efr,
	eg: eg,
	Egrave: Egrave,
	egrave: egrave,
	egs: egs,
	egsdot: egsdot,
	el: el,
	Element: Element,
	elinters: elinters,
	ell: ell,
	els: els,
	elsdot: elsdot,
	Emacr: Emacr,
	emacr: emacr,
	empty: empty,
	emptyset: emptyset,
	EmptySmallSquare: EmptySmallSquare,
	emptyv: emptyv,
	EmptyVerySmallSquare: EmptyVerySmallSquare,
	emsp13: emsp13,
	emsp14: emsp14,
	emsp: emsp,
	ENG: ENG,
	eng: eng,
	ensp: ensp,
	Eogon: Eogon,
	eogon: eogon,
	Eopf: Eopf,
	eopf: eopf,
	epar: epar,
	eparsl: eparsl,
	eplus: eplus,
	epsi: epsi,
	Epsilon: Epsilon,
	epsilon: epsilon,
	epsiv: epsiv,
	eqcirc: eqcirc,
	eqcolon: eqcolon,
	eqsim: eqsim,
	eqslantgtr: eqslantgtr,
	eqslantless: eqslantless,
	Equal: Equal,
	equals: equals,
	EqualTilde: EqualTilde,
	equest: equest,
	Equilibrium: Equilibrium,
	equiv: equiv,
	equivDD: equivDD,
	eqvparsl: eqvparsl,
	erarr: erarr,
	erDot: erDot,
	escr: escr,
	Escr: Escr,
	esdot: esdot,
	Esim: Esim,
	esim: esim,
	Eta: Eta,
	eta: eta,
	ETH: ETH,
	eth: eth,
	Euml: Euml,
	euml: euml,
	euro: euro,
	excl: excl,
	exist: exist,
	Exists: Exists,
	expectation: expectation,
	exponentiale: exponentiale,
	ExponentialE: ExponentialE,
	fallingdotseq: fallingdotseq,
	Fcy: Fcy,
	fcy: fcy,
	female: female,
	ffilig: ffilig,
	fflig: fflig,
	ffllig: ffllig,
	Ffr: Ffr,
	ffr: ffr,
	filig: filig,
	FilledSmallSquare: FilledSmallSquare,
	FilledVerySmallSquare: FilledVerySmallSquare,
	fjlig: fjlig,
	flat: flat,
	fllig: fllig,
	fltns: fltns,
	fnof: fnof,
	Fopf: Fopf,
	fopf: fopf,
	forall: forall,
	ForAll: ForAll,
	fork: fork,
	forkv: forkv,
	Fouriertrf: Fouriertrf,
	fpartint: fpartint,
	frac12: frac12,
	frac13: frac13,
	frac14: frac14,
	frac15: frac15,
	frac16: frac16,
	frac18: frac18,
	frac23: frac23,
	frac25: frac25,
	frac34: frac34,
	frac35: frac35,
	frac38: frac38,
	frac45: frac45,
	frac56: frac56,
	frac58: frac58,
	frac78: frac78,
	frasl: frasl,
	frown: frown,
	fscr: fscr,
	Fscr: Fscr,
	gacute: gacute,
	Gamma: Gamma,
	gamma: gamma,
	Gammad: Gammad,
	gammad: gammad,
	gap: gap,
	Gbreve: Gbreve,
	gbreve: gbreve,
	Gcedil: Gcedil,
	Gcirc: Gcirc,
	gcirc: gcirc,
	Gcy: Gcy,
	gcy: gcy,
	Gdot: Gdot,
	gdot: gdot,
	ge: ge,
	gE: gE,
	gEl: gEl,
	gel: gel,
	geq: geq,
	geqq: geqq,
	geqslant: geqslant,
	gescc: gescc,
	ges: ges,
	gesdot: gesdot,
	gesdoto: gesdoto,
	gesdotol: gesdotol,
	gesl: gesl,
	gesles: gesles,
	Gfr: Gfr,
	gfr: gfr,
	gg: gg,
	Gg: Gg,
	ggg: ggg,
	gimel: gimel,
	GJcy: GJcy,
	gjcy: gjcy,
	gla: gla,
	gl: gl,
	glE: glE,
	glj: glj,
	gnap: gnap,
	gnapprox: gnapprox,
	gne: gne,
	gnE: gnE,
	gneq: gneq,
	gneqq: gneqq,
	gnsim: gnsim,
	Gopf: Gopf,
	gopf: gopf,
	grave: grave,
	GreaterEqual: GreaterEqual,
	GreaterEqualLess: GreaterEqualLess,
	GreaterFullEqual: GreaterFullEqual,
	GreaterGreater: GreaterGreater,
	GreaterLess: GreaterLess,
	GreaterSlantEqual: GreaterSlantEqual,
	GreaterTilde: GreaterTilde,
	Gscr: Gscr,
	gscr: gscr,
	gsim: gsim,
	gsime: gsime,
	gsiml: gsiml,
	gtcc: gtcc,
	gtcir: gtcir,
	gt: gt,
	GT: GT,
	Gt: Gt,
	gtdot: gtdot,
	gtlPar: gtlPar,
	gtquest: gtquest,
	gtrapprox: gtrapprox,
	gtrarr: gtrarr,
	gtrdot: gtrdot,
	gtreqless: gtreqless,
	gtreqqless: gtreqqless,
	gtrless: gtrless,
	gtrsim: gtrsim,
	gvertneqq: gvertneqq,
	gvnE: gvnE,
	Hacek: Hacek,
	hairsp: hairsp,
	half: half,
	hamilt: hamilt,
	HARDcy: HARDcy,
	hardcy: hardcy,
	harrcir: harrcir,
	harr: harr,
	hArr: hArr,
	harrw: harrw,
	Hat: Hat,
	hbar: hbar,
	Hcirc: Hcirc,
	hcirc: hcirc,
	hearts: hearts,
	heartsuit: heartsuit,
	hellip: hellip,
	hercon: hercon,
	hfr: hfr,
	Hfr: Hfr,
	HilbertSpace: HilbertSpace,
	hksearow: hksearow,
	hkswarow: hkswarow,
	hoarr: hoarr,
	homtht: homtht,
	hookleftarrow: hookleftarrow,
	hookrightarrow: hookrightarrow,
	hopf: hopf,
	Hopf: Hopf,
	horbar: horbar,
	HorizontalLine: HorizontalLine,
	hscr: hscr,
	Hscr: Hscr,
	hslash: hslash,
	Hstrok: Hstrok,
	hstrok: hstrok,
	HumpDownHump: HumpDownHump,
	HumpEqual: HumpEqual,
	hybull: hybull,
	hyphen: hyphen,
	Iacute: Iacute,
	iacute: iacute,
	ic: ic,
	Icirc: Icirc,
	icirc: icirc,
	Icy: Icy,
	icy: icy,
	Idot: Idot,
	IEcy: IEcy,
	iecy: iecy,
	iexcl: iexcl,
	iff: iff,
	ifr: ifr,
	Ifr: Ifr,
	Igrave: Igrave,
	igrave: igrave,
	ii: ii,
	iiiint: iiiint,
	iiint: iiint,
	iinfin: iinfin,
	iiota: iiota,
	IJlig: IJlig,
	ijlig: ijlig,
	Imacr: Imacr,
	imacr: imacr,
	image: image$1,
	ImaginaryI: ImaginaryI,
	imagline: imagline,
	imagpart: imagpart,
	imath: imath,
	Im: Im,
	imof: imof,
	imped: imped,
	Implies: Implies,
	incare: incare,
	"in": "∈",
	infin: infin,
	infintie: infintie,
	inodot: inodot,
	intcal: intcal,
	int: int,
	Int: Int,
	integers: integers,
	Integral: Integral,
	intercal: intercal,
	Intersection: Intersection,
	intlarhk: intlarhk,
	intprod: intprod,
	InvisibleComma: InvisibleComma,
	InvisibleTimes: InvisibleTimes,
	IOcy: IOcy,
	iocy: iocy,
	Iogon: Iogon,
	iogon: iogon,
	Iopf: Iopf,
	iopf: iopf,
	Iota: Iota,
	iota: iota,
	iprod: iprod,
	iquest: iquest,
	iscr: iscr,
	Iscr: Iscr,
	isin: isin,
	isindot: isindot,
	isinE: isinE,
	isins: isins,
	isinsv: isinsv,
	isinv: isinv,
	it: it,
	Itilde: Itilde,
	itilde: itilde,
	Iukcy: Iukcy,
	iukcy: iukcy,
	Iuml: Iuml,
	iuml: iuml,
	Jcirc: Jcirc,
	jcirc: jcirc,
	Jcy: Jcy,
	jcy: jcy,
	Jfr: Jfr,
	jfr: jfr,
	jmath: jmath,
	Jopf: Jopf,
	jopf: jopf,
	Jscr: Jscr,
	jscr: jscr,
	Jsercy: Jsercy,
	jsercy: jsercy,
	Jukcy: Jukcy,
	jukcy: jukcy,
	Kappa: Kappa,
	kappa: kappa,
	kappav: kappav,
	Kcedil: Kcedil,
	kcedil: kcedil,
	Kcy: Kcy,
	kcy: kcy,
	Kfr: Kfr,
	kfr: kfr,
	kgreen: kgreen,
	KHcy: KHcy,
	khcy: khcy,
	KJcy: KJcy,
	kjcy: kjcy,
	Kopf: Kopf,
	kopf: kopf,
	Kscr: Kscr,
	kscr: kscr,
	lAarr: lAarr,
	Lacute: Lacute,
	lacute: lacute,
	laemptyv: laemptyv,
	lagran: lagran,
	Lambda: Lambda,
	lambda: lambda,
	lang: lang,
	Lang: Lang,
	langd: langd,
	langle: langle,
	lap: lap,
	Laplacetrf: Laplacetrf,
	laquo: laquo,
	larrb: larrb,
	larrbfs: larrbfs,
	larr: larr,
	Larr: Larr,
	lArr: lArr,
	larrfs: larrfs,
	larrhk: larrhk,
	larrlp: larrlp,
	larrpl: larrpl,
	larrsim: larrsim,
	larrtl: larrtl,
	latail: latail,
	lAtail: lAtail,
	lat: lat,
	late: late,
	lates: lates,
	lbarr: lbarr,
	lBarr: lBarr,
	lbbrk: lbbrk,
	lbrace: lbrace,
	lbrack: lbrack,
	lbrke: lbrke,
	lbrksld: lbrksld,
	lbrkslu: lbrkslu,
	Lcaron: Lcaron,
	lcaron: lcaron,
	Lcedil: Lcedil,
	lcedil: lcedil,
	lceil: lceil,
	lcub: lcub,
	Lcy: Lcy,
	lcy: lcy,
	ldca: ldca,
	ldquo: ldquo,
	ldquor: ldquor,
	ldrdhar: ldrdhar,
	ldrushar: ldrushar,
	ldsh: ldsh,
	le: le,
	lE: lE,
	LeftAngleBracket: LeftAngleBracket,
	LeftArrowBar: LeftArrowBar,
	leftarrow: leftarrow,
	LeftArrow: LeftArrow,
	Leftarrow: Leftarrow,
	LeftArrowRightArrow: LeftArrowRightArrow,
	leftarrowtail: leftarrowtail,
	LeftCeiling: LeftCeiling,
	LeftDoubleBracket: LeftDoubleBracket,
	LeftDownTeeVector: LeftDownTeeVector,
	LeftDownVectorBar: LeftDownVectorBar,
	LeftDownVector: LeftDownVector,
	LeftFloor: LeftFloor,
	leftharpoondown: leftharpoondown,
	leftharpoonup: leftharpoonup,
	leftleftarrows: leftleftarrows,
	leftrightarrow: leftrightarrow,
	LeftRightArrow: LeftRightArrow,
	Leftrightarrow: Leftrightarrow,
	leftrightarrows: leftrightarrows,
	leftrightharpoons: leftrightharpoons,
	leftrightsquigarrow: leftrightsquigarrow,
	LeftRightVector: LeftRightVector,
	LeftTeeArrow: LeftTeeArrow,
	LeftTee: LeftTee,
	LeftTeeVector: LeftTeeVector,
	leftthreetimes: leftthreetimes,
	LeftTriangleBar: LeftTriangleBar,
	LeftTriangle: LeftTriangle,
	LeftTriangleEqual: LeftTriangleEqual,
	LeftUpDownVector: LeftUpDownVector,
	LeftUpTeeVector: LeftUpTeeVector,
	LeftUpVectorBar: LeftUpVectorBar,
	LeftUpVector: LeftUpVector,
	LeftVectorBar: LeftVectorBar,
	LeftVector: LeftVector,
	lEg: lEg,
	leg: leg,
	leq: leq,
	leqq: leqq,
	leqslant: leqslant,
	lescc: lescc,
	les: les,
	lesdot: lesdot,
	lesdoto: lesdoto,
	lesdotor: lesdotor,
	lesg: lesg,
	lesges: lesges,
	lessapprox: lessapprox,
	lessdot: lessdot,
	lesseqgtr: lesseqgtr,
	lesseqqgtr: lesseqqgtr,
	LessEqualGreater: LessEqualGreater,
	LessFullEqual: LessFullEqual,
	LessGreater: LessGreater,
	lessgtr: lessgtr,
	LessLess: LessLess,
	lesssim: lesssim,
	LessSlantEqual: LessSlantEqual,
	LessTilde: LessTilde,
	lfisht: lfisht,
	lfloor: lfloor,
	Lfr: Lfr,
	lfr: lfr,
	lg: lg,
	lgE: lgE,
	lHar: lHar,
	lhard: lhard,
	lharu: lharu,
	lharul: lharul,
	lhblk: lhblk,
	LJcy: LJcy,
	ljcy: ljcy,
	llarr: llarr,
	ll: ll,
	Ll: Ll,
	llcorner: llcorner,
	Lleftarrow: Lleftarrow,
	llhard: llhard,
	lltri: lltri,
	Lmidot: Lmidot,
	lmidot: lmidot,
	lmoustache: lmoustache,
	lmoust: lmoust,
	lnap: lnap,
	lnapprox: lnapprox,
	lne: lne,
	lnE: lnE,
	lneq: lneq,
	lneqq: lneqq,
	lnsim: lnsim,
	loang: loang,
	loarr: loarr,
	lobrk: lobrk,
	longleftarrow: longleftarrow,
	LongLeftArrow: LongLeftArrow,
	Longleftarrow: Longleftarrow,
	longleftrightarrow: longleftrightarrow,
	LongLeftRightArrow: LongLeftRightArrow,
	Longleftrightarrow: Longleftrightarrow,
	longmapsto: longmapsto,
	longrightarrow: longrightarrow,
	LongRightArrow: LongRightArrow,
	Longrightarrow: Longrightarrow,
	looparrowleft: looparrowleft,
	looparrowright: looparrowright,
	lopar: lopar,
	Lopf: Lopf,
	lopf: lopf,
	loplus: loplus,
	lotimes: lotimes,
	lowast: lowast,
	lowbar: lowbar,
	LowerLeftArrow: LowerLeftArrow,
	LowerRightArrow: LowerRightArrow,
	loz: loz,
	lozenge: lozenge,
	lozf: lozf,
	lpar: lpar,
	lparlt: lparlt,
	lrarr: lrarr,
	lrcorner: lrcorner,
	lrhar: lrhar,
	lrhard: lrhard,
	lrm: lrm,
	lrtri: lrtri,
	lsaquo: lsaquo,
	lscr: lscr,
	Lscr: Lscr,
	lsh: lsh,
	Lsh: Lsh,
	lsim: lsim,
	lsime: lsime,
	lsimg: lsimg,
	lsqb: lsqb,
	lsquo: lsquo,
	lsquor: lsquor,
	Lstrok: Lstrok,
	lstrok: lstrok,
	ltcc: ltcc,
	ltcir: ltcir,
	lt: lt,
	LT: LT,
	Lt: Lt,
	ltdot: ltdot,
	lthree: lthree,
	ltimes: ltimes,
	ltlarr: ltlarr,
	ltquest: ltquest,
	ltri: ltri,
	ltrie: ltrie,
	ltrif: ltrif,
	ltrPar: ltrPar,
	lurdshar: lurdshar,
	luruhar: luruhar,
	lvertneqq: lvertneqq,
	lvnE: lvnE,
	macr: macr,
	male: male,
	malt: malt,
	maltese: maltese,
	"Map": "⤅",
	map: map$1,
	mapsto: mapsto,
	mapstodown: mapstodown,
	mapstoleft: mapstoleft,
	mapstoup: mapstoup,
	marker: marker,
	mcomma: mcomma,
	Mcy: Mcy,
	mcy: mcy,
	mdash: mdash,
	mDDot: mDDot,
	measuredangle: measuredangle,
	MediumSpace: MediumSpace,
	Mellintrf: Mellintrf,
	Mfr: Mfr,
	mfr: mfr,
	mho: mho,
	micro: micro,
	midast: midast,
	midcir: midcir,
	mid: mid,
	middot: middot,
	minusb: minusb,
	minus: minus,
	minusd: minusd,
	minusdu: minusdu,
	MinusPlus: MinusPlus,
	mlcp: mlcp,
	mldr: mldr,
	mnplus: mnplus,
	models: models,
	Mopf: Mopf,
	mopf: mopf,
	mp: mp,
	mscr: mscr,
	Mscr: Mscr,
	mstpos: mstpos,
	Mu: Mu,
	mu: mu,
	multimap: multimap,
	mumap: mumap,
	nabla: nabla,
	Nacute: Nacute,
	nacute: nacute,
	nang: nang,
	nap: nap,
	napE: napE,
	napid: napid,
	napos: napos,
	napprox: napprox,
	natural: natural,
	naturals: naturals,
	natur: natur,
	nbsp: nbsp,
	nbump: nbump,
	nbumpe: nbumpe,
	ncap: ncap,
	Ncaron: Ncaron,
	ncaron: ncaron,
	Ncedil: Ncedil,
	ncedil: ncedil,
	ncong: ncong,
	ncongdot: ncongdot,
	ncup: ncup,
	Ncy: Ncy,
	ncy: ncy,
	ndash: ndash,
	nearhk: nearhk,
	nearr: nearr,
	neArr: neArr,
	nearrow: nearrow,
	ne: ne,
	nedot: nedot,
	NegativeMediumSpace: NegativeMediumSpace,
	NegativeThickSpace: NegativeThickSpace,
	NegativeThinSpace: NegativeThinSpace,
	NegativeVeryThinSpace: NegativeVeryThinSpace,
	nequiv: nequiv,
	nesear: nesear,
	nesim: nesim,
	NestedGreaterGreater: NestedGreaterGreater,
	NestedLessLess: NestedLessLess,
	NewLine: NewLine,
	nexist: nexist,
	nexists: nexists,
	Nfr: Nfr,
	nfr: nfr,
	ngE: ngE,
	nge: nge,
	ngeq: ngeq,
	ngeqq: ngeqq,
	ngeqslant: ngeqslant,
	nges: nges,
	nGg: nGg,
	ngsim: ngsim,
	nGt: nGt,
	ngt: ngt,
	ngtr: ngtr,
	nGtv: nGtv,
	nharr: nharr,
	nhArr: nhArr,
	nhpar: nhpar,
	ni: ni,
	nis: nis,
	nisd: nisd,
	niv: niv,
	NJcy: NJcy,
	njcy: njcy,
	nlarr: nlarr,
	nlArr: nlArr,
	nldr: nldr,
	nlE: nlE,
	nle: nle,
	nleftarrow: nleftarrow,
	nLeftarrow: nLeftarrow,
	nleftrightarrow: nleftrightarrow,
	nLeftrightarrow: nLeftrightarrow,
	nleq: nleq,
	nleqq: nleqq,
	nleqslant: nleqslant,
	nles: nles,
	nless: nless,
	nLl: nLl,
	nlsim: nlsim,
	nLt: nLt,
	nlt: nlt,
	nltri: nltri,
	nltrie: nltrie,
	nLtv: nLtv,
	nmid: nmid,
	NoBreak: NoBreak,
	NonBreakingSpace: NonBreakingSpace,
	nopf: nopf,
	Nopf: Nopf,
	Not: Not,
	not: not,
	NotCongruent: NotCongruent,
	NotCupCap: NotCupCap,
	NotDoubleVerticalBar: NotDoubleVerticalBar,
	NotElement: NotElement,
	NotEqual: NotEqual,
	NotEqualTilde: NotEqualTilde,
	NotExists: NotExists,
	NotGreater: NotGreater,
	NotGreaterEqual: NotGreaterEqual,
	NotGreaterFullEqual: NotGreaterFullEqual,
	NotGreaterGreater: NotGreaterGreater,
	NotGreaterLess: NotGreaterLess,
	NotGreaterSlantEqual: NotGreaterSlantEqual,
	NotGreaterTilde: NotGreaterTilde,
	NotHumpDownHump: NotHumpDownHump,
	NotHumpEqual: NotHumpEqual,
	notin: notin,
	notindot: notindot,
	notinE: notinE,
	notinva: notinva,
	notinvb: notinvb,
	notinvc: notinvc,
	NotLeftTriangleBar: NotLeftTriangleBar,
	NotLeftTriangle: NotLeftTriangle,
	NotLeftTriangleEqual: NotLeftTriangleEqual,
	NotLess: NotLess,
	NotLessEqual: NotLessEqual,
	NotLessGreater: NotLessGreater,
	NotLessLess: NotLessLess,
	NotLessSlantEqual: NotLessSlantEqual,
	NotLessTilde: NotLessTilde,
	NotNestedGreaterGreater: NotNestedGreaterGreater,
	NotNestedLessLess: NotNestedLessLess,
	notni: notni,
	notniva: notniva,
	notnivb: notnivb,
	notnivc: notnivc,
	NotPrecedes: NotPrecedes,
	NotPrecedesEqual: NotPrecedesEqual,
	NotPrecedesSlantEqual: NotPrecedesSlantEqual,
	NotReverseElement: NotReverseElement,
	NotRightTriangleBar: NotRightTriangleBar,
	NotRightTriangle: NotRightTriangle,
	NotRightTriangleEqual: NotRightTriangleEqual,
	NotSquareSubset: NotSquareSubset,
	NotSquareSubsetEqual: NotSquareSubsetEqual,
	NotSquareSuperset: NotSquareSuperset,
	NotSquareSupersetEqual: NotSquareSupersetEqual,
	NotSubset: NotSubset,
	NotSubsetEqual: NotSubsetEqual,
	NotSucceeds: NotSucceeds,
	NotSucceedsEqual: NotSucceedsEqual,
	NotSucceedsSlantEqual: NotSucceedsSlantEqual,
	NotSucceedsTilde: NotSucceedsTilde,
	NotSuperset: NotSuperset,
	NotSupersetEqual: NotSupersetEqual,
	NotTilde: NotTilde,
	NotTildeEqual: NotTildeEqual,
	NotTildeFullEqual: NotTildeFullEqual,
	NotTildeTilde: NotTildeTilde,
	NotVerticalBar: NotVerticalBar,
	nparallel: nparallel,
	npar: npar,
	nparsl: nparsl,
	npart: npart,
	npolint: npolint,
	npr: npr,
	nprcue: nprcue,
	nprec: nprec,
	npreceq: npreceq,
	npre: npre,
	nrarrc: nrarrc,
	nrarr: nrarr,
	nrArr: nrArr,
	nrarrw: nrarrw,
	nrightarrow: nrightarrow,
	nRightarrow: nRightarrow,
	nrtri: nrtri,
	nrtrie: nrtrie,
	nsc: nsc,
	nsccue: nsccue,
	nsce: nsce,
	Nscr: Nscr,
	nscr: nscr,
	nshortmid: nshortmid,
	nshortparallel: nshortparallel,
	nsim: nsim,
	nsime: nsime,
	nsimeq: nsimeq,
	nsmid: nsmid,
	nspar: nspar,
	nsqsube: nsqsube,
	nsqsupe: nsqsupe,
	nsub: nsub,
	nsubE: nsubE,
	nsube: nsube,
	nsubset: nsubset,
	nsubseteq: nsubseteq,
	nsubseteqq: nsubseteqq,
	nsucc: nsucc,
	nsucceq: nsucceq,
	nsup: nsup,
	nsupE: nsupE,
	nsupe: nsupe,
	nsupset: nsupset,
	nsupseteq: nsupseteq,
	nsupseteqq: nsupseteqq,
	ntgl: ntgl,
	Ntilde: Ntilde,
	ntilde: ntilde,
	ntlg: ntlg,
	ntriangleleft: ntriangleleft,
	ntrianglelefteq: ntrianglelefteq,
	ntriangleright: ntriangleright,
	ntrianglerighteq: ntrianglerighteq,
	Nu: Nu,
	nu: nu,
	num: num,
	numero: numero,
	numsp: numsp,
	nvap: nvap,
	nvdash: nvdash,
	nvDash: nvDash,
	nVdash: nVdash,
	nVDash: nVDash,
	nvge: nvge,
	nvgt: nvgt,
	nvHarr: nvHarr,
	nvinfin: nvinfin,
	nvlArr: nvlArr,
	nvle: nvle,
	nvlt: nvlt,
	nvltrie: nvltrie,
	nvrArr: nvrArr,
	nvrtrie: nvrtrie,
	nvsim: nvsim,
	nwarhk: nwarhk,
	nwarr: nwarr,
	nwArr: nwArr,
	nwarrow: nwarrow,
	nwnear: nwnear,
	Oacute: Oacute,
	oacute: oacute,
	oast: oast,
	Ocirc: Ocirc,
	ocirc: ocirc,
	ocir: ocir,
	Ocy: Ocy,
	ocy: ocy,
	odash: odash,
	Odblac: Odblac,
	odblac: odblac,
	odiv: odiv,
	odot: odot,
	odsold: odsold,
	OElig: OElig,
	oelig: oelig,
	ofcir: ofcir,
	Ofr: Ofr,
	ofr: ofr,
	ogon: ogon,
	Ograve: Ograve,
	ograve: ograve,
	ogt: ogt,
	ohbar: ohbar,
	ohm: ohm,
	oint: oint,
	olarr: olarr,
	olcir: olcir,
	olcross: olcross,
	oline: oline,
	olt: olt,
	Omacr: Omacr,
	omacr: omacr,
	Omega: Omega,
	omega: omega,
	Omicron: Omicron,
	omicron: omicron,
	omid: omid,
	ominus: ominus,
	Oopf: Oopf,
	oopf: oopf,
	opar: opar,
	OpenCurlyDoubleQuote: OpenCurlyDoubleQuote,
	OpenCurlyQuote: OpenCurlyQuote,
	operp: operp,
	oplus: oplus,
	orarr: orarr,
	Or: Or,
	or: or,
	ord: ord,
	order: order,
	orderof: orderof,
	ordf: ordf,
	ordm: ordm,
	origof: origof,
	oror: oror,
	orslope: orslope,
	orv: orv,
	oS: oS,
	Oscr: Oscr,
	oscr: oscr,
	Oslash: Oslash,
	oslash: oslash,
	osol: osol,
	Otilde: Otilde,
	otilde: otilde,
	otimesas: otimesas,
	Otimes: Otimes,
	otimes: otimes,
	Ouml: Ouml,
	ouml: ouml,
	ovbar: ovbar,
	OverBar: OverBar,
	OverBrace: OverBrace,
	OverBracket: OverBracket,
	OverParenthesis: OverParenthesis,
	para: para,
	parallel: parallel,
	par: par,
	parsim: parsim,
	parsl: parsl,
	part: part,
	PartialD: PartialD,
	Pcy: Pcy,
	pcy: pcy,
	percnt: percnt,
	period: period,
	permil: permil,
	perp: perp,
	pertenk: pertenk,
	Pfr: Pfr,
	pfr: pfr,
	Phi: Phi,
	phi: phi,
	phiv: phiv,
	phmmat: phmmat,
	phone: phone,
	Pi: Pi,
	pi: pi,
	pitchfork: pitchfork,
	piv: piv,
	planck: planck,
	planckh: planckh,
	plankv: plankv,
	plusacir: plusacir,
	plusb: plusb,
	pluscir: pluscir,
	plus: plus,
	plusdo: plusdo,
	plusdu: plusdu,
	pluse: pluse,
	PlusMinus: PlusMinus,
	plusmn: plusmn,
	plussim: plussim,
	plustwo: plustwo,
	pm: pm,
	Poincareplane: Poincareplane,
	pointint: pointint,
	popf: popf,
	Popf: Popf,
	pound: pound,
	prap: prap,
	Pr: Pr,
	pr: pr,
	prcue: prcue,
	precapprox: precapprox,
	prec: prec,
	preccurlyeq: preccurlyeq,
	Precedes: Precedes,
	PrecedesEqual: PrecedesEqual,
	PrecedesSlantEqual: PrecedesSlantEqual,
	PrecedesTilde: PrecedesTilde,
	preceq: preceq,
	precnapprox: precnapprox,
	precneqq: precneqq,
	precnsim: precnsim,
	pre: pre,
	prE: prE,
	precsim: precsim,
	prime: prime,
	Prime: Prime,
	primes: primes,
	prnap: prnap,
	prnE: prnE,
	prnsim: prnsim,
	prod: prod,
	Product: Product,
	profalar: profalar,
	profline: profline,
	profsurf: profsurf,
	prop: prop,
	Proportional: Proportional,
	Proportion: Proportion,
	propto: propto,
	prsim: prsim,
	prurel: prurel,
	Pscr: Pscr,
	pscr: pscr,
	Psi: Psi,
	psi: psi,
	puncsp: puncsp,
	Qfr: Qfr,
	qfr: qfr,
	qint: qint,
	qopf: qopf,
	Qopf: Qopf,
	qprime: qprime,
	Qscr: Qscr,
	qscr: qscr,
	quaternions: quaternions,
	quatint: quatint,
	quest: quest,
	questeq: questeq,
	quot: quot,
	QUOT: QUOT,
	rAarr: rAarr,
	race: race,
	Racute: Racute,
	racute: racute,
	radic: radic,
	raemptyv: raemptyv,
	rang: rang,
	Rang: Rang,
	rangd: rangd,
	range: range,
	rangle: rangle,
	raquo: raquo,
	rarrap: rarrap,
	rarrb: rarrb,
	rarrbfs: rarrbfs,
	rarrc: rarrc,
	rarr: rarr,
	Rarr: Rarr,
	rArr: rArr,
	rarrfs: rarrfs,
	rarrhk: rarrhk,
	rarrlp: rarrlp,
	rarrpl: rarrpl,
	rarrsim: rarrsim,
	Rarrtl: Rarrtl,
	rarrtl: rarrtl,
	rarrw: rarrw,
	ratail: ratail,
	rAtail: rAtail,
	ratio: ratio,
	rationals: rationals,
	rbarr: rbarr,
	rBarr: rBarr,
	RBarr: RBarr,
	rbbrk: rbbrk,
	rbrace: rbrace,
	rbrack: rbrack,
	rbrke: rbrke,
	rbrksld: rbrksld,
	rbrkslu: rbrkslu,
	Rcaron: Rcaron,
	rcaron: rcaron,
	Rcedil: Rcedil,
	rcedil: rcedil,
	rceil: rceil,
	rcub: rcub,
	Rcy: Rcy,
	rcy: rcy,
	rdca: rdca,
	rdldhar: rdldhar,
	rdquo: rdquo,
	rdquor: rdquor,
	rdsh: rdsh,
	real: real,
	realine: realine,
	realpart: realpart,
	reals: reals,
	Re: Re,
	rect: rect,
	reg: reg,
	REG: REG,
	ReverseElement: ReverseElement,
	ReverseEquilibrium: ReverseEquilibrium,
	ReverseUpEquilibrium: ReverseUpEquilibrium,
	rfisht: rfisht,
	rfloor: rfloor,
	rfr: rfr,
	Rfr: Rfr,
	rHar: rHar,
	rhard: rhard,
	rharu: rharu,
	rharul: rharul,
	Rho: Rho,
	rho: rho,
	rhov: rhov,
	RightAngleBracket: RightAngleBracket,
	RightArrowBar: RightArrowBar,
	rightarrow: rightarrow,
	RightArrow: RightArrow,
	Rightarrow: Rightarrow,
	RightArrowLeftArrow: RightArrowLeftArrow,
	rightarrowtail: rightarrowtail,
	RightCeiling: RightCeiling,
	RightDoubleBracket: RightDoubleBracket,
	RightDownTeeVector: RightDownTeeVector,
	RightDownVectorBar: RightDownVectorBar,
	RightDownVector: RightDownVector,
	RightFloor: RightFloor,
	rightharpoondown: rightharpoondown,
	rightharpoonup: rightharpoonup,
	rightleftarrows: rightleftarrows,
	rightleftharpoons: rightleftharpoons,
	rightrightarrows: rightrightarrows,
	rightsquigarrow: rightsquigarrow,
	RightTeeArrow: RightTeeArrow,
	RightTee: RightTee,
	RightTeeVector: RightTeeVector,
	rightthreetimes: rightthreetimes,
	RightTriangleBar: RightTriangleBar,
	RightTriangle: RightTriangle,
	RightTriangleEqual: RightTriangleEqual,
	RightUpDownVector: RightUpDownVector,
	RightUpTeeVector: RightUpTeeVector,
	RightUpVectorBar: RightUpVectorBar,
	RightUpVector: RightUpVector,
	RightVectorBar: RightVectorBar,
	RightVector: RightVector,
	ring: ring,
	risingdotseq: risingdotseq,
	rlarr: rlarr,
	rlhar: rlhar,
	rlm: rlm,
	rmoustache: rmoustache,
	rmoust: rmoust,
	rnmid: rnmid,
	roang: roang,
	roarr: roarr,
	robrk: robrk,
	ropar: ropar,
	ropf: ropf,
	Ropf: Ropf,
	roplus: roplus,
	rotimes: rotimes,
	RoundImplies: RoundImplies,
	rpar: rpar,
	rpargt: rpargt,
	rppolint: rppolint,
	rrarr: rrarr,
	Rrightarrow: Rrightarrow,
	rsaquo: rsaquo,
	rscr: rscr,
	Rscr: Rscr,
	rsh: rsh,
	Rsh: Rsh,
	rsqb: rsqb,
	rsquo: rsquo,
	rsquor: rsquor,
	rthree: rthree,
	rtimes: rtimes,
	rtri: rtri,
	rtrie: rtrie,
	rtrif: rtrif,
	rtriltri: rtriltri,
	RuleDelayed: RuleDelayed,
	ruluhar: ruluhar,
	rx: rx,
	Sacute: Sacute,
	sacute: sacute,
	sbquo: sbquo,
	scap: scap,
	Scaron: Scaron,
	scaron: scaron,
	Sc: Sc,
	sc: sc,
	sccue: sccue,
	sce: sce,
	scE: scE,
	Scedil: Scedil,
	scedil: scedil,
	Scirc: Scirc,
	scirc: scirc,
	scnap: scnap,
	scnE: scnE,
	scnsim: scnsim,
	scpolint: scpolint,
	scsim: scsim,
	Scy: Scy,
	scy: scy,
	sdotb: sdotb,
	sdot: sdot,
	sdote: sdote,
	searhk: searhk,
	searr: searr,
	seArr: seArr,
	searrow: searrow,
	sect: sect,
	semi: semi,
	seswar: seswar,
	setminus: setminus,
	setmn: setmn,
	sext: sext,
	Sfr: Sfr,
	sfr: sfr,
	sfrown: sfrown,
	sharp: sharp,
	SHCHcy: SHCHcy,
	shchcy: shchcy,
	SHcy: SHcy,
	shcy: shcy,
	ShortDownArrow: ShortDownArrow,
	ShortLeftArrow: ShortLeftArrow,
	shortmid: shortmid,
	shortparallel: shortparallel,
	ShortRightArrow: ShortRightArrow,
	ShortUpArrow: ShortUpArrow,
	shy: shy,
	Sigma: Sigma,
	sigma: sigma,
	sigmaf: sigmaf,
	sigmav: sigmav,
	sim: sim,
	simdot: simdot,
	sime: sime,
	simeq: simeq,
	simg: simg,
	simgE: simgE,
	siml: siml,
	simlE: simlE,
	simne: simne,
	simplus: simplus,
	simrarr: simrarr,
	slarr: slarr,
	SmallCircle: SmallCircle,
	smallsetminus: smallsetminus,
	smashp: smashp,
	smeparsl: smeparsl,
	smid: smid,
	smile: smile,
	smt: smt,
	smte: smte,
	smtes: smtes,
	SOFTcy: SOFTcy,
	softcy: softcy,
	solbar: solbar,
	solb: solb,
	sol: sol,
	Sopf: Sopf,
	sopf: sopf,
	spades: spades,
	spadesuit: spadesuit,
	spar: spar,
	sqcap: sqcap,
	sqcaps: sqcaps,
	sqcup: sqcup,
	sqcups: sqcups,
	Sqrt: Sqrt,
	sqsub: sqsub,
	sqsube: sqsube,
	sqsubset: sqsubset,
	sqsubseteq: sqsubseteq,
	sqsup: sqsup,
	sqsupe: sqsupe,
	sqsupset: sqsupset,
	sqsupseteq: sqsupseteq,
	square: square,
	Square: Square,
	SquareIntersection: SquareIntersection,
	SquareSubset: SquareSubset,
	SquareSubsetEqual: SquareSubsetEqual,
	SquareSuperset: SquareSuperset,
	SquareSupersetEqual: SquareSupersetEqual,
	SquareUnion: SquareUnion,
	squarf: squarf,
	squ: squ,
	squf: squf,
	srarr: srarr,
	Sscr: Sscr,
	sscr: sscr,
	ssetmn: ssetmn,
	ssmile: ssmile,
	sstarf: sstarf,
	Star: Star,
	star: star,
	starf: starf,
	straightepsilon: straightepsilon,
	straightphi: straightphi,
	strns: strns,
	sub: sub,
	Sub: Sub,
	subdot: subdot,
	subE: subE,
	sube: sube,
	subedot: subedot,
	submult: submult,
	subnE: subnE,
	subne: subne,
	subplus: subplus,
	subrarr: subrarr,
	subset: subset,
	Subset: Subset,
	subseteq: subseteq,
	subseteqq: subseteqq,
	SubsetEqual: SubsetEqual,
	subsetneq: subsetneq,
	subsetneqq: subsetneqq,
	subsim: subsim,
	subsub: subsub,
	subsup: subsup,
	succapprox: succapprox,
	succ: succ,
	succcurlyeq: succcurlyeq,
	Succeeds: Succeeds,
	SucceedsEqual: SucceedsEqual,
	SucceedsSlantEqual: SucceedsSlantEqual,
	SucceedsTilde: SucceedsTilde,
	succeq: succeq,
	succnapprox: succnapprox,
	succneqq: succneqq,
	succnsim: succnsim,
	succsim: succsim,
	SuchThat: SuchThat,
	sum: sum,
	Sum: Sum,
	sung: sung,
	sup1: sup1,
	sup2: sup2,
	sup3: sup3,
	sup: sup,
	Sup: Sup,
	supdot: supdot,
	supdsub: supdsub,
	supE: supE,
	supe: supe,
	supedot: supedot,
	Superset: Superset,
	SupersetEqual: SupersetEqual,
	suphsol: suphsol,
	suphsub: suphsub,
	suplarr: suplarr,
	supmult: supmult,
	supnE: supnE,
	supne: supne,
	supplus: supplus,
	supset: supset,
	Supset: Supset,
	supseteq: supseteq,
	supseteqq: supseteqq,
	supsetneq: supsetneq,
	supsetneqq: supsetneqq,
	supsim: supsim,
	supsub: supsub,
	supsup: supsup,
	swarhk: swarhk,
	swarr: swarr,
	swArr: swArr,
	swarrow: swarrow,
	swnwar: swnwar,
	szlig: szlig,
	Tab: Tab,
	target: target,
	Tau: Tau,
	tau: tau,
	tbrk: tbrk,
	Tcaron: Tcaron,
	tcaron: tcaron,
	Tcedil: Tcedil,
	tcedil: tcedil,
	Tcy: Tcy,
	tcy: tcy,
	tdot: tdot,
	telrec: telrec,
	Tfr: Tfr,
	tfr: tfr,
	there4: there4,
	therefore: therefore,
	Therefore: Therefore,
	Theta: Theta,
	theta: theta,
	thetasym: thetasym,
	thetav: thetav,
	thickapprox: thickapprox,
	thicksim: thicksim,
	ThickSpace: ThickSpace,
	ThinSpace: ThinSpace,
	thinsp: thinsp,
	thkap: thkap,
	thksim: thksim,
	THORN: THORN,
	thorn: thorn,
	tilde: tilde,
	Tilde: Tilde,
	TildeEqual: TildeEqual,
	TildeFullEqual: TildeFullEqual,
	TildeTilde: TildeTilde,
	timesbar: timesbar,
	timesb: timesb,
	times: times,
	timesd: timesd,
	tint: tint,
	toea: toea,
	topbot: topbot,
	topcir: topcir,
	top: top,
	Topf: Topf,
	topf: topf,
	topfork: topfork,
	tosa: tosa,
	tprime: tprime,
	trade: trade,
	TRADE: TRADE,
	triangle: triangle,
	triangledown: triangledown,
	triangleleft: triangleleft,
	trianglelefteq: trianglelefteq,
	triangleq: triangleq,
	triangleright: triangleright,
	trianglerighteq: trianglerighteq,
	tridot: tridot,
	trie: trie,
	triminus: triminus,
	TripleDot: TripleDot,
	triplus: triplus,
	trisb: trisb,
	tritime: tritime,
	trpezium: trpezium,
	Tscr: Tscr,
	tscr: tscr,
	TScy: TScy,
	tscy: tscy,
	TSHcy: TSHcy,
	tshcy: tshcy,
	Tstrok: Tstrok,
	tstrok: tstrok,
	twixt: twixt,
	twoheadleftarrow: twoheadleftarrow,
	twoheadrightarrow: twoheadrightarrow,
	Uacute: Uacute,
	uacute: uacute,
	uarr: uarr,
	Uarr: Uarr,
	uArr: uArr,
	Uarrocir: Uarrocir,
	Ubrcy: Ubrcy,
	ubrcy: ubrcy,
	Ubreve: Ubreve,
	ubreve: ubreve,
	Ucirc: Ucirc,
	ucirc: ucirc,
	Ucy: Ucy,
	ucy: ucy,
	udarr: udarr,
	Udblac: Udblac,
	udblac: udblac,
	udhar: udhar,
	ufisht: ufisht,
	Ufr: Ufr,
	ufr: ufr,
	Ugrave: Ugrave,
	ugrave: ugrave,
	uHar: uHar,
	uharl: uharl,
	uharr: uharr,
	uhblk: uhblk,
	ulcorn: ulcorn,
	ulcorner: ulcorner,
	ulcrop: ulcrop,
	ultri: ultri,
	Umacr: Umacr,
	umacr: umacr,
	uml: uml,
	UnderBar: UnderBar,
	UnderBrace: UnderBrace,
	UnderBracket: UnderBracket,
	UnderParenthesis: UnderParenthesis,
	Union: Union,
	UnionPlus: UnionPlus,
	Uogon: Uogon,
	uogon: uogon,
	Uopf: Uopf,
	uopf: uopf,
	UpArrowBar: UpArrowBar,
	uparrow: uparrow,
	UpArrow: UpArrow,
	Uparrow: Uparrow,
	UpArrowDownArrow: UpArrowDownArrow,
	updownarrow: updownarrow,
	UpDownArrow: UpDownArrow,
	Updownarrow: Updownarrow,
	UpEquilibrium: UpEquilibrium,
	upharpoonleft: upharpoonleft,
	upharpoonright: upharpoonright,
	uplus: uplus,
	UpperLeftArrow: UpperLeftArrow,
	UpperRightArrow: UpperRightArrow,
	upsi: upsi,
	Upsi: Upsi,
	upsih: upsih,
	Upsilon: Upsilon,
	upsilon: upsilon,
	UpTeeArrow: UpTeeArrow,
	UpTee: UpTee,
	upuparrows: upuparrows,
	urcorn: urcorn,
	urcorner: urcorner,
	urcrop: urcrop,
	Uring: Uring,
	uring: uring,
	urtri: urtri,
	Uscr: Uscr,
	uscr: uscr,
	utdot: utdot,
	Utilde: Utilde,
	utilde: utilde,
	utri: utri,
	utrif: utrif,
	uuarr: uuarr,
	Uuml: Uuml,
	uuml: uuml,
	uwangle: uwangle,
	vangrt: vangrt,
	varepsilon: varepsilon,
	varkappa: varkappa,
	varnothing: varnothing,
	varphi: varphi,
	varpi: varpi,
	varpropto: varpropto,
	varr: varr,
	vArr: vArr,
	varrho: varrho,
	varsigma: varsigma,
	varsubsetneq: varsubsetneq,
	varsubsetneqq: varsubsetneqq,
	varsupsetneq: varsupsetneq,
	varsupsetneqq: varsupsetneqq,
	vartheta: vartheta,
	vartriangleleft: vartriangleleft,
	vartriangleright: vartriangleright,
	vBar: vBar,
	Vbar: Vbar,
	vBarv: vBarv,
	Vcy: Vcy,
	vcy: vcy,
	vdash: vdash,
	vDash: vDash,
	Vdash: Vdash,
	VDash: VDash,
	Vdashl: Vdashl,
	veebar: veebar,
	vee: vee,
	Vee: Vee,
	veeeq: veeeq,
	vellip: vellip,
	verbar: verbar,
	Verbar: Verbar,
	vert: vert,
	Vert: Vert,
	VerticalBar: VerticalBar,
	VerticalLine: VerticalLine,
	VerticalSeparator: VerticalSeparator,
	VerticalTilde: VerticalTilde,
	VeryThinSpace: VeryThinSpace,
	Vfr: Vfr,
	vfr: vfr,
	vltri: vltri,
	vnsub: vnsub,
	vnsup: vnsup,
	Vopf: Vopf,
	vopf: vopf,
	vprop: vprop,
	vrtri: vrtri,
	Vscr: Vscr,
	vscr: vscr,
	vsubnE: vsubnE,
	vsubne: vsubne,
	vsupnE: vsupnE,
	vsupne: vsupne,
	Vvdash: Vvdash,
	vzigzag: vzigzag,
	Wcirc: Wcirc,
	wcirc: wcirc,
	wedbar: wedbar,
	wedge: wedge,
	Wedge: Wedge,
	wedgeq: wedgeq,
	weierp: weierp,
	Wfr: Wfr,
	wfr: wfr,
	Wopf: Wopf,
	wopf: wopf,
	wp: wp,
	wr: wr,
	wreath: wreath,
	Wscr: Wscr,
	wscr: wscr,
	xcap: xcap,
	xcirc: xcirc,
	xcup: xcup,
	xdtri: xdtri,
	Xfr: Xfr,
	xfr: xfr,
	xharr: xharr,
	xhArr: xhArr,
	Xi: Xi,
	xi: xi,
	xlarr: xlarr,
	xlArr: xlArr,
	xmap: xmap,
	xnis: xnis,
	xodot: xodot,
	Xopf: Xopf,
	xopf: xopf,
	xoplus: xoplus,
	xotime: xotime,
	xrarr: xrarr,
	xrArr: xrArr,
	Xscr: Xscr,
	xscr: xscr,
	xsqcup: xsqcup,
	xuplus: xuplus,
	xutri: xutri,
	xvee: xvee,
	xwedge: xwedge,
	Yacute: Yacute,
	yacute: yacute,
	YAcy: YAcy,
	yacy: yacy,
	Ycirc: Ycirc,
	ycirc: ycirc,
	Ycy: Ycy,
	ycy: ycy,
	yen: yen,
	Yfr: Yfr,
	yfr: yfr,
	YIcy: YIcy,
	yicy: yicy,
	Yopf: Yopf,
	yopf: yopf,
	Yscr: Yscr,
	yscr: yscr,
	YUcy: YUcy,
	yucy: yucy,
	yuml: yuml,
	Yuml: Yuml,
	Zacute: Zacute,
	zacute: zacute,
	Zcaron: Zcaron,
	zcaron: zcaron,
	Zcy: Zcy,
	zcy: zcy,
	Zdot: Zdot,
	zdot: zdot,
	zeetrf: zeetrf,
	ZeroWidthSpace: ZeroWidthSpace,
	Zeta: Zeta,
	zeta: zeta,
	zfr: zfr,
	Zfr: Zfr,
	ZHcy: ZHcy,
	zhcy: zhcy,
	zigrarr: zigrarr,
	zopf: zopf,
	Zopf: Zopf,
	Zscr: Zscr,
	zscr: zscr,
	zwj: zwj,
	zwnj: zwnj
};

/*eslint quotes:0*/
var entities$1 = require$$0;

var regex$4=/[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

var mdurl$1 = {};

var encodeCache = {};


// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function getEncodeCache(exclude) {
  var i, ch, cache = encodeCache[exclude];
  if (cache) { return cache; }

  cache = encodeCache[exclude] = [];

  for (i = 0; i < 128; i++) {
    ch = String.fromCharCode(i);

    if (/^[0-9a-z]$/i.test(ch)) {
      // always allow unencoded alphanumeric characters
      cache.push(ch);
    } else {
      cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
  }

  for (i = 0; i < exclude.length; i++) {
    cache[exclude.charCodeAt(i)] = exclude[i];
  }

  return cache;
}


// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function encode$1(string, exclude, keepEscaped) {
  var i, l, code, nextCode, cache,
      result = '';

  if (typeof exclude !== 'string') {
    // encode(string, keepEscaped)
    keepEscaped  = exclude;
    exclude = encode$1.defaultChars;
  }

  if (typeof keepEscaped === 'undefined') {
    keepEscaped = true;
  }

  cache = getEncodeCache(exclude);

  for (i = 0, l = string.length; i < l; i++) {
    code = string.charCodeAt(i);

    if (keepEscaped && code === 0x25 /* % */ && i + 2 < l) {
      if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
        result += string.slice(i, i + 3);
        i += 2;
        continue;
      }
    }

    if (code < 128) {
      result += cache[code];
      continue;
    }

    if (code >= 0xD800 && code <= 0xDFFF) {
      if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
        nextCode = string.charCodeAt(i + 1);
        if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
          result += encodeURIComponent(string[i] + string[i + 1]);
          i++;
          continue;
        }
      }
      result += '%EF%BF%BD';
      continue;
    }

    result += encodeURIComponent(string[i]);
  }

  return result;
}

encode$1.defaultChars   = ";/?:@&=+$,-_.!~*'()#";
encode$1.componentChars = "-_.!~*'()";


var encode_1 = encode$1;

/* eslint-disable no-bitwise */

var decodeCache = {};

function getDecodeCache(exclude) {
  var i, ch, cache = decodeCache[exclude];
  if (cache) { return cache; }

  cache = decodeCache[exclude] = [];

  for (i = 0; i < 128; i++) {
    ch = String.fromCharCode(i);
    cache.push(ch);
  }

  for (i = 0; i < exclude.length; i++) {
    ch = exclude.charCodeAt(i);
    cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
  }

  return cache;
}


// Decode percent-encoded string.
//
function decode$1(string, exclude) {
  var cache;

  if (typeof exclude !== 'string') {
    exclude = decode$1.defaultChars;
  }

  cache = getDecodeCache(exclude);

  return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
    var i, l, b1, b2, b3, b4, chr,
        result = '';

    for (i = 0, l = seq.length; i < l; i += 3) {
      b1 = parseInt(seq.slice(i + 1, i + 3), 16);

      if (b1 < 0x80) {
        result += cache[b1];
        continue;
      }

      if ((b1 & 0xE0) === 0xC0 && (i + 3 < l)) {
        // 110xxxxx 10xxxxxx
        b2 = parseInt(seq.slice(i + 4, i + 6), 16);

        if ((b2 & 0xC0) === 0x80) {
          chr = ((b1 << 6) & 0x7C0) | (b2 & 0x3F);

          if (chr < 0x80) {
            result += '\ufffd\ufffd';
          } else {
            result += String.fromCharCode(chr);
          }

          i += 3;
          continue;
        }
      }

      if ((b1 & 0xF0) === 0xE0 && (i + 6 < l)) {
        // 1110xxxx 10xxxxxx 10xxxxxx
        b2 = parseInt(seq.slice(i + 4, i + 6), 16);
        b3 = parseInt(seq.slice(i + 7, i + 9), 16);

        if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
          chr = ((b1 << 12) & 0xF000) | ((b2 << 6) & 0xFC0) | (b3 & 0x3F);

          if (chr < 0x800 || (chr >= 0xD800 && chr <= 0xDFFF)) {
            result += '\ufffd\ufffd\ufffd';
          } else {
            result += String.fromCharCode(chr);
          }

          i += 6;
          continue;
        }
      }

      if ((b1 & 0xF8) === 0xF0 && (i + 9 < l)) {
        // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
        b2 = parseInt(seq.slice(i + 4, i + 6), 16);
        b3 = parseInt(seq.slice(i + 7, i + 9), 16);
        b4 = parseInt(seq.slice(i + 10, i + 12), 16);

        if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
          chr = ((b1 << 18) & 0x1C0000) | ((b2 << 12) & 0x3F000) | ((b3 << 6) & 0xFC0) | (b4 & 0x3F);

          if (chr < 0x10000 || chr > 0x10FFFF) {
            result += '\ufffd\ufffd\ufffd\ufffd';
          } else {
            chr -= 0x10000;
            result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
          }

          i += 9;
          continue;
        }
      }

      result += '\ufffd';
    }

    return result;
  });
}


decode$1.defaultChars   = ';/?:@&=+$,#';
decode$1.componentChars = '';


var decode_1 = decode$1;

var format = function format(url) {
  var result = '';

  result += url.protocol || '';
  result += url.slashes ? '//' : '';
  result += url.auth ? url.auth + '@' : '';

  if (url.hostname && url.hostname.indexOf(':') !== -1) {
    // ipv6 address
    result += '[' + url.hostname + ']';
  } else {
    result += url.hostname || '';
  }

  result += url.port ? ':' + url.port : '';
  result += url.pathname || '';
  result += url.search || '';
  result += url.hash || '';

  return result;
};

//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//


function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.pathname = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = [ '<', '>', '"', '`', ' ', '\r', '\n', '\t' ],

    // RFC 2396: characters not allowed for various reasons.
    unwise = [ '{', '}', '|', '\\', '^', '`' ].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = [ '\'' ].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = [ '%', '/', '?', ';', '#' ].concat(autoEscape),
    hostEndingChars = [ '/', '?', '#' ],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    /* eslint-disable no-script-url */
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    };
    /* eslint-enable no-script-url */

function urlParse(url, slashesDenoteHost) {
  if (url && url instanceof Url) { return url; }

  var u = new Url();
  u.parse(url, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, slashesDenoteHost) {
  var i, l, lowerProto, hec, slashes,
      rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    lowerProto = proto.toLowerCase();
    this.protocol = proto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (i = 0; i < hostEndingChars.length; i++) {
      hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) {
        hostEnd = hec;
      }
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = auth;
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (i = 0; i < nonHostChars.length; i++) {
      hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) {
        hostEnd = hec;
      }
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) {
      hostEnd = rest.length;
    }

    if (rest[hostEnd - 1] === ':') { hostEnd--; }
    var host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost(host);

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) { continue; }
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    }

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    rest = rest.slice(0, qm);
  }
  if (rest) { this.pathname = rest; }
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '';
  }

  return this;
};

Url.prototype.parseHost = function(host) {
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) { this.hostname = host; }
};

var parse = urlParse;

mdurl$1.encode = encode_1;
mdurl$1.decode = decode_1;
mdurl$1.format = format;
mdurl$1.parse  = parse;

var uc_micro = {};

var regex$3=/[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

var regex$2=/[\0-\x1F\x7F-\x9F]/;

var regex$1=/[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

var regex=/[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

uc_micro.Any = regex$3;
uc_micro.Cc  = regex$2;
uc_micro.Cf  = regex$1;
uc_micro.P   = regex$4;
uc_micro.Z   = regex;

(function (exports) {


function _class(obj) { return Object.prototype.toString.call(obj); }

function isString(obj) { return _class(obj) === '[object String]'; }

var _hasOwnProperty = Object.prototype.hasOwnProperty;

function has(object, key) {
  return _hasOwnProperty.call(object, key);
}

// Merge objects
//
function assign(obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);

  sources.forEach(function (source) {
    if (!source) { return; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be object');
    }

    Object.keys(source).forEach(function (key) {
      obj[key] = source[key];
    });
  });

  return obj;
}

// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function arrayReplaceAt(src, pos, newElements) {
  return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}

////////////////////////////////////////////////////////////////////////////////

function isValidEntityCode(c) {
  /*eslint no-bitwise:0*/
  // broken sequence
  if (c >= 0xD800 && c <= 0xDFFF) { return false; }
  // never used
  if (c >= 0xFDD0 && c <= 0xFDEF) { return false; }
  if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) { return false; }
  // control codes
  if (c >= 0x00 && c <= 0x08) { return false; }
  if (c === 0x0B) { return false; }
  if (c >= 0x0E && c <= 0x1F) { return false; }
  if (c >= 0x7F && c <= 0x9F) { return false; }
  // out of range
  if (c > 0x10FFFF) { return false; }
  return true;
}

function fromCodePoint(c) {
  /*eslint no-bitwise:0*/
  if (c > 0xffff) {
    c -= 0x10000;
    var surrogate1 = 0xd800 + (c >> 10),
        surrogate2 = 0xdc00 + (c & 0x3ff);

    return String.fromCharCode(surrogate1, surrogate2);
  }
  return String.fromCharCode(c);
}


var UNESCAPE_MD_RE  = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var ENTITY_RE       = /&([a-z#][a-z0-9]{1,31});/gi;
var UNESCAPE_ALL_RE = new RegExp(UNESCAPE_MD_RE.source + '|' + ENTITY_RE.source, 'gi');

var DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;

var entities = entities$1;

function replaceEntityPattern(match, name) {
  var code;

  if (has(entities, name)) {
    return entities[name];
  }

  if (name.charCodeAt(0) === 0x23/* # */ && DIGITAL_ENTITY_TEST_RE.test(name)) {
    code = name[1].toLowerCase() === 'x' ?
      parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);

    if (isValidEntityCode(code)) {
      return fromCodePoint(code);
    }
  }

  return match;
}

/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/

function unescapeMd(str) {
  if (str.indexOf('\\') < 0) { return str; }
  return str.replace(UNESCAPE_MD_RE, '$1');
}

function unescapeAll(str) {
  if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) { return str; }

  return str.replace(UNESCAPE_ALL_RE, function (match, escaped, entity) {
    if (escaped) { return escaped; }
    return replaceEntityPattern(match, entity);
  });
}

////////////////////////////////////////////////////////////////////////////////

var HTML_ESCAPE_TEST_RE = /[&<>"]/;
var HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var HTML_REPLACEMENTS = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;'
};

function replaceUnsafeChar(ch) {
  return HTML_REPLACEMENTS[ch];
}

function escapeHtml(str) {
  if (HTML_ESCAPE_TEST_RE.test(str)) {
    return str.replace(HTML_ESCAPE_REPLACE_RE, replaceUnsafeChar);
  }
  return str;
}

////////////////////////////////////////////////////////////////////////////////

var REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;

function escapeRE(str) {
  return str.replace(REGEXP_ESCAPE_RE, '\\$&');
}

////////////////////////////////////////////////////////////////////////////////

function isSpace(code) {
  switch (code) {
    case 0x09:
    case 0x20:
      return true;
  }
  return false;
}

// Zs (unicode class) || [\t\f\v\r\n]
function isWhiteSpace(code) {
  if (code >= 0x2000 && code <= 0x200A) { return true; }
  switch (code) {
    case 0x09: // \t
    case 0x0A: // \n
    case 0x0B: // \v
    case 0x0C: // \f
    case 0x0D: // \r
    case 0x20:
    case 0xA0:
    case 0x1680:
    case 0x202F:
    case 0x205F:
    case 0x3000:
      return true;
  }
  return false;
}

////////////////////////////////////////////////////////////////////////////////

/*eslint-disable max-len*/
var UNICODE_PUNCT_RE = regex$4;

// Currently without astral characters support.
function isPunctChar(ch) {
  return UNICODE_PUNCT_RE.test(ch);
}


// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function isMdAsciiPunct(ch) {
  switch (ch) {
    case 0x21/* ! */:
    case 0x22/* " */:
    case 0x23/* # */:
    case 0x24/* $ */:
    case 0x25/* % */:
    case 0x26/* & */:
    case 0x27/* ' */:
    case 0x28/* ( */:
    case 0x29/* ) */:
    case 0x2A/* * */:
    case 0x2B/* + */:
    case 0x2C/* , */:
    case 0x2D/* - */:
    case 0x2E/* . */:
    case 0x2F/* / */:
    case 0x3A/* : */:
    case 0x3B/* ; */:
    case 0x3C/* < */:
    case 0x3D/* = */:
    case 0x3E/* > */:
    case 0x3F/* ? */:
    case 0x40/* @ */:
    case 0x5B/* [ */:
    case 0x5C/* \ */:
    case 0x5D/* ] */:
    case 0x5E/* ^ */:
    case 0x5F/* _ */:
    case 0x60/* ` */:
    case 0x7B/* { */:
    case 0x7C/* | */:
    case 0x7D/* } */:
    case 0x7E/* ~ */:
      return true;
    default:
      return false;
  }
}

// Hepler to unify [reference labels].
//
function normalizeReference(str) {
  // Trim and collapse whitespace
  //
  str = str.trim().replace(/\s+/g, ' ');

  // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
  // fixed in v12 (couldn't find any details).
  //
  // So treat this one as a special case
  // (remove this when node v10 is no longer supported).
  //
  if ('ẞ'.toLowerCase() === 'Ṿ') {
    str = str.replace(/ẞ/g, 'ß');
  }

  // .toLowerCase().toUpperCase() should get rid of all differences
  // between letter variants.
  //
  // Simple .toLowerCase() doesn't normalize 125 code points correctly,
  // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
  // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
  // uppercased versions).
  //
  // Here's an example showing how it happens. Lets take greek letter omega:
  // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
  //
  // Unicode entries:
  // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
  // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
  // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
  // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
  //
  // Case-insensitive comparison should treat all of them as equivalent.
  //
  // But .toLowerCase() doesn't change ϑ (it's already lowercase),
  // and .toUpperCase() doesn't change ϴ (already uppercase).
  //
  // Applying first lower then upper case normalizes any character:
  // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
  //
  // Note: this is equivalent to unicode case folding; unicode normalization
  // is a different step that is not required here.
  //
  // Final result should be uppercased, because it's later stored in an object
  // (this avoid a conflict with Object.prototype members,
  // most notably, `__proto__`)
  //
  return str.toLowerCase().toUpperCase();
}

////////////////////////////////////////////////////////////////////////////////

// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
exports.lib                 = {};
exports.lib.mdurl           = mdurl$1;
exports.lib.ucmicro         = uc_micro;

exports.assign              = assign;
exports.isString            = isString;
exports.has                 = has;
exports.unescapeMd          = unescapeMd;
exports.unescapeAll         = unescapeAll;
exports.isValidEntityCode   = isValidEntityCode;
exports.fromCodePoint       = fromCodePoint;
// exports.replaceEntities     = replaceEntities;
exports.escapeHtml          = escapeHtml;
exports.arrayReplaceAt      = arrayReplaceAt;
exports.isSpace             = isSpace;
exports.isWhiteSpace        = isWhiteSpace;
exports.isMdAsciiPunct      = isMdAsciiPunct;
exports.isPunctChar         = isPunctChar;
exports.escapeRE            = escapeRE;
exports.normalizeReference  = normalizeReference;
}(utils$1));

var helpers$1 = {};

var parse_link_label = function parseLinkLabel(state, start, disableNested) {
  var level, found, marker, prevPos,
      labelEnd = -1,
      max = state.posMax,
      oldPos = state.pos;

  state.pos = start + 1;
  level = 1;

  while (state.pos < max) {
    marker = state.src.charCodeAt(state.pos);
    if (marker === 0x5D /* ] */) {
      level--;
      if (level === 0) {
        found = true;
        break;
      }
    }

    prevPos = state.pos;
    state.md.inline.skipToken(state);
    if (marker === 0x5B /* [ */) {
      if (prevPos === state.pos - 1) {
        // increase level if we find text `[`, which is not a part of any token
        level++;
      } else if (disableNested) {
        state.pos = oldPos;
        return -1;
      }
    }
  }

  if (found) {
    labelEnd = state.pos;
  }

  // restore old state
  state.pos = oldPos;

  return labelEnd;
};

var unescapeAll$2 = utils$1.unescapeAll;


var parse_link_destination = function parseLinkDestination(str, start, max) {
  var code, level,
      pos = start,
      result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
      };

  if (str.charCodeAt(pos) === 0x3C /* < */) {
    pos++;
    while (pos < max) {
      code = str.charCodeAt(pos);
      if (code === 0x0A /* \n */) { return result; }
      if (code === 0x3C /* < */) { return result; }
      if (code === 0x3E /* > */) {
        result.pos = pos + 1;
        result.str = unescapeAll$2(str.slice(start + 1, pos));
        result.ok = true;
        return result;
      }
      if (code === 0x5C /* \ */ && pos + 1 < max) {
        pos += 2;
        continue;
      }

      pos++;
    }

    // no closing '>'
    return result;
  }

  // this should be ... } else { ... branch

  level = 0;
  while (pos < max) {
    code = str.charCodeAt(pos);

    if (code === 0x20) { break; }

    // ascii control characters
    if (code < 0x20 || code === 0x7F) { break; }

    if (code === 0x5C /* \ */ && pos + 1 < max) {
      if (str.charCodeAt(pos + 1) === 0x20) { break; }
      pos += 2;
      continue;
    }

    if (code === 0x28 /* ( */) {
      level++;
      if (level > 32) { return result; }
    }

    if (code === 0x29 /* ) */) {
      if (level === 0) { break; }
      level--;
    }

    pos++;
  }

  if (start === pos) { return result; }
  if (level !== 0) { return result; }

  result.str = unescapeAll$2(str.slice(start, pos));
  result.pos = pos;
  result.ok = true;
  return result;
};

var unescapeAll$1 = utils$1.unescapeAll;


var parse_link_title = function parseLinkTitle(str, start, max) {
  var code,
      marker,
      lines = 0,
      pos = start,
      result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
      };

  if (pos >= max) { return result; }

  marker = str.charCodeAt(pos);

  if (marker !== 0x22 /* " */ && marker !== 0x27 /* ' */ && marker !== 0x28 /* ( */) { return result; }

  pos++;

  // if opening marker is "(", switch it to closing marker ")"
  if (marker === 0x28) { marker = 0x29; }

  while (pos < max) {
    code = str.charCodeAt(pos);
    if (code === marker) {
      result.pos = pos + 1;
      result.lines = lines;
      result.str = unescapeAll$1(str.slice(start + 1, pos));
      result.ok = true;
      return result;
    } else if (code === 0x28 /* ( */ && marker === 0x29 /* ) */) {
      return result;
    } else if (code === 0x0A) {
      lines++;
    } else if (code === 0x5C /* \ */ && pos + 1 < max) {
      pos++;
      if (str.charCodeAt(pos) === 0x0A) {
        lines++;
      }
    }

    pos++;
  }

  return result;
};

helpers$1.parseLinkLabel       = parse_link_label;
helpers$1.parseLinkDestination = parse_link_destination;
helpers$1.parseLinkTitle       = parse_link_title;

/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/


var assign$1          = utils$1.assign;
var unescapeAll     = utils$1.unescapeAll;
var escapeHtml      = utils$1.escapeHtml;


////////////////////////////////////////////////////////////////////////////////

var default_rules = {};


default_rules.code_inline = function (tokens, idx, options, env, slf) {
  var token = tokens[idx];

  return  '<code' + slf.renderAttrs(token) + '>' +
          escapeHtml(token.content) +
          '</code>';
};


default_rules.code_block = function (tokens, idx, options, env, slf) {
  var token = tokens[idx];

  return  '<pre' + slf.renderAttrs(token) + '><code>' +
          escapeHtml(tokens[idx].content) +
          '</code></pre>\n';
};


default_rules.fence = function (tokens, idx, options, env, slf) {
  var token = tokens[idx],
      info = token.info ? unescapeAll(token.info).trim() : '',
      langName = '',
      langAttrs = '',
      highlighted, i, arr, tmpAttrs, tmpToken;

  if (info) {
    arr = info.split(/(\s+)/g);
    langName = arr[0];
    langAttrs = arr.slice(2).join('');
  }

  if (options.highlight) {
    highlighted = options.highlight(token.content, langName, langAttrs) || escapeHtml(token.content);
  } else {
    highlighted = escapeHtml(token.content);
  }

  if (highlighted.indexOf('<pre') === 0) {
    return highlighted + '\n';
  }

  // If language exists, inject class gently, without modifying original token.
  // May be, one day we will add .deepClone() for token and simplify this part, but
  // now we prefer to keep things local.
  if (info) {
    i        = token.attrIndex('class');
    tmpAttrs = token.attrs ? token.attrs.slice() : [];

    if (i < 0) {
      tmpAttrs.push([ 'class', options.langPrefix + langName ]);
    } else {
      tmpAttrs[i] = tmpAttrs[i].slice();
      tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
    }

    // Fake token just to render attributes
    tmpToken = {
      attrs: tmpAttrs
    };

    return  '<pre><code' + slf.renderAttrs(tmpToken) + '>'
          + highlighted
          + '</code></pre>\n';
  }


  return  '<pre><code' + slf.renderAttrs(token) + '>'
        + highlighted
        + '</code></pre>\n';
};


default_rules.image = function (tokens, idx, options, env, slf) {
  var token = tokens[idx];

  // "alt" attr MUST be set, even if empty. Because it's mandatory and
  // should be placed on proper position for tests.
  //
  // Replace content with actual value

  token.attrs[token.attrIndex('alt')][1] =
    slf.renderInlineAsText(token.children, options, env);

  return slf.renderToken(tokens, idx, options);
};


default_rules.hardbreak = function (tokens, idx, options /*, env */) {
  return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
default_rules.softbreak = function (tokens, idx, options /*, env */) {
  return options.breaks ? (options.xhtmlOut ? '<br />\n' : '<br>\n') : '\n';
};


default_rules.text = function (tokens, idx /*, options, env */) {
  return escapeHtml(tokens[idx].content);
};


default_rules.html_block = function (tokens, idx /*, options, env */) {
  return tokens[idx].content;
};
default_rules.html_inline = function (tokens, idx /*, options, env */) {
  return tokens[idx].content;
};


/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/
function Renderer$1() {

  /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/
  this.rules = assign$1({}, default_rules);
}


/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/
Renderer$1.prototype.renderAttrs = function renderAttrs(token) {
  var i, l, result;

  if (!token.attrs) { return ''; }

  result = '';

  for (i = 0, l = token.attrs.length; i < l; i++) {
    result += ' ' + escapeHtml(token.attrs[i][0]) + '="' + escapeHtml(token.attrs[i][1]) + '"';
  }

  return result;
};


/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/
Renderer$1.prototype.renderToken = function renderToken(tokens, idx, options) {
  var nextToken,
      result = '',
      needLf = false,
      token = tokens[idx];

  // Tight list paragraphs
  if (token.hidden) {
    return '';
  }

  // Insert a newline between hidden paragraph and subsequent opening
  // block-level tag.
  //
  // For example, here we should insert a newline before blockquote:
  //  - a
  //    >
  //
  if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) {
    result += '\n';
  }

  // Add token name, e.g. `<img`
  result += (token.nesting === -1 ? '</' : '<') + token.tag;

  // Encode attributes, e.g. `<img src="foo"`
  result += this.renderAttrs(token);

  // Add a slash for self-closing tags, e.g. `<img src="foo" /`
  if (token.nesting === 0 && options.xhtmlOut) {
    result += ' /';
  }

  // Check if we need to add a newline after this tag
  if (token.block) {
    needLf = true;

    if (token.nesting === 1) {
      if (idx + 1 < tokens.length) {
        nextToken = tokens[idx + 1];

        if (nextToken.type === 'inline' || nextToken.hidden) {
          // Block-level tag containing an inline tag.
          //
          needLf = false;

        } else if (nextToken.nesting === -1 && nextToken.tag === token.tag) {
          // Opening tag + closing tag of the same type. E.g. `<li></li>`.
          //
          needLf = false;
        }
      }
    }
  }

  result += needLf ? '>\n' : '>';

  return result;
};


/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/
Renderer$1.prototype.renderInline = function (tokens, options, env) {
  var type,
      result = '',
      rules = this.rules;

  for (var i = 0, len = tokens.length; i < len; i++) {
    type = tokens[i].type;

    if (typeof rules[type] !== 'undefined') {
      result += rules[type](tokens, i, options, env, this);
    } else {
      result += this.renderToken(tokens, i, options);
    }
  }

  return result;
};


/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/
Renderer$1.prototype.renderInlineAsText = function (tokens, options, env) {
  var result = '';

  for (var i = 0, len = tokens.length; i < len; i++) {
    if (tokens[i].type === 'text') {
      result += tokens[i].content;
    } else if (tokens[i].type === 'image') {
      result += this.renderInlineAsText(tokens[i].children, options, env);
    } else if (tokens[i].type === 'softbreak') {
      result += '\n';
    }
  }

  return result;
};


/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/
Renderer$1.prototype.render = function (tokens, options, env) {
  var i, len, type,
      result = '',
      rules = this.rules;

  for (i = 0, len = tokens.length; i < len; i++) {
    type = tokens[i].type;

    if (type === 'inline') {
      result += this.renderInline(tokens[i].children, options, env);
    } else if (typeof rules[type] !== 'undefined') {
      result += rules[type](tokens, i, options, env, this);
    } else {
      result += this.renderToken(tokens, i, options, env);
    }
  }

  return result;
};

var renderer = Renderer$1;

/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/


/**
 * new Ruler()
 **/
function Ruler$3() {
  // List of added rules. Each element is:
  //
  // {
  //   name: XXX,
  //   enabled: Boolean,
  //   fn: Function(),
  //   alt: [ name2, name3 ]
  // }
  //
  this.__rules__ = [];

  // Cached rule chains.
  //
  // First level - chain name, '' for default.
  // Second level - diginal anchor for fast filtering by charcodes.
  //
  this.__cache__ = null;
}

////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly


// Find rule index by name
//
Ruler$3.prototype.__find__ = function (name) {
  for (var i = 0; i < this.__rules__.length; i++) {
    if (this.__rules__[i].name === name) {
      return i;
    }
  }
  return -1;
};


// Build rules lookup cache
//
Ruler$3.prototype.__compile__ = function () {
  var self = this;
  var chains = [ '' ];

  // collect unique names
  self.__rules__.forEach(function (rule) {
    if (!rule.enabled) { return; }

    rule.alt.forEach(function (altName) {
      if (chains.indexOf(altName) < 0) {
        chains.push(altName);
      }
    });
  });

  self.__cache__ = {};

  chains.forEach(function (chain) {
    self.__cache__[chain] = [];
    self.__rules__.forEach(function (rule) {
      if (!rule.enabled) { return; }

      if (chain && rule.alt.indexOf(chain) < 0) { return; }

      self.__cache__[chain].push(rule.fn);
    });
  });
};


/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler$3.prototype.at = function (name, fn, options) {
  var index = this.__find__(name);
  var opt = options || {};

  if (index === -1) { throw new Error('Parser rule not found: ' + name); }

  this.__rules__[index].fn = fn;
  this.__rules__[index].alt = opt.alt || [];
  this.__cache__ = null;
};


/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler$3.prototype.before = function (beforeName, ruleName, fn, options) {
  var index = this.__find__(beforeName);
  var opt = options || {};

  if (index === -1) { throw new Error('Parser rule not found: ' + beforeName); }

  this.__rules__.splice(index, 0, {
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};


/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler$3.prototype.after = function (afterName, ruleName, fn, options) {
  var index = this.__find__(afterName);
  var opt = options || {};

  if (index === -1) { throw new Error('Parser rule not found: ' + afterName); }

  this.__rules__.splice(index + 1, 0, {
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};

/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler$3.prototype.push = function (ruleName, fn, options) {
  var opt = options || {};

  this.__rules__.push({
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};


/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/
Ruler$3.prototype.enable = function (list, ignoreInvalid) {
  if (!Array.isArray(list)) { list = [ list ]; }

  var result = [];

  // Search by name and enable
  list.forEach(function (name) {
    var idx = this.__find__(name);

    if (idx < 0) {
      if (ignoreInvalid) { return; }
      throw new Error('Rules manager: invalid rule name ' + name);
    }
    this.__rules__[idx].enabled = true;
    result.push(name);
  }, this);

  this.__cache__ = null;
  return result;
};


/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/
Ruler$3.prototype.enableOnly = function (list, ignoreInvalid) {
  if (!Array.isArray(list)) { list = [ list ]; }

  this.__rules__.forEach(function (rule) { rule.enabled = false; });

  this.enable(list, ignoreInvalid);
};


/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/
Ruler$3.prototype.disable = function (list, ignoreInvalid) {
  if (!Array.isArray(list)) { list = [ list ]; }

  var result = [];

  // Search by name and disable
  list.forEach(function (name) {
    var idx = this.__find__(name);

    if (idx < 0) {
      if (ignoreInvalid) { return; }
      throw new Error('Rules manager: invalid rule name ' + name);
    }
    this.__rules__[idx].enabled = false;
    result.push(name);
  }, this);

  this.__cache__ = null;
  return result;
};


/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/
Ruler$3.prototype.getRules = function (chainName) {
  if (this.__cache__ === null) {
    this.__compile__();
  }

  // Chain can be empty, if rules disabled. But we still have to return Array.
  return this.__cache__[chainName] || [];
};

var ruler = Ruler$3;

// https://spec.commonmark.org/0.29/#line-ending
var NEWLINES_RE  = /\r\n?|\n/g;
var NULL_RE      = /\0/g;


var normalize = function normalize(state) {
  var str;

  // Normalize newlines
  str = state.src.replace(NEWLINES_RE, '\n');

  // Replace NULL characters
  str = str.replace(NULL_RE, '\uFFFD');

  state.src = str;
};

var block = function block(state) {
  var token;

  if (state.inlineMode) {
    token          = new state.Token('inline', '', 0);
    token.content  = state.src;
    token.map      = [ 0, 1 ];
    token.children = [];
    state.tokens.push(token);
  } else {
    state.md.block.parse(state.src, state.md, state.env, state.tokens);
  }
};

var inline = function inline(state) {
  var tokens = state.tokens, tok, i, l;

  // Parse inlines
  for (i = 0, l = tokens.length; i < l; i++) {
    tok = tokens[i];
    if (tok.type === 'inline') {
      state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
  }
};

var arrayReplaceAt = utils$1.arrayReplaceAt;


function isLinkOpen$1(str) {
  return /^<a[>\s]/i.test(str);
}
function isLinkClose$1(str) {
  return /^<\/a\s*>/i.test(str);
}


var linkify$1 = function linkify(state) {
  var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos,
      level, htmlLinkLevel, url, fullUrl, urlText,
      blockTokens = state.tokens,
      links;

  if (!state.md.options.linkify) { return; }

  for (j = 0, l = blockTokens.length; j < l; j++) {
    if (blockTokens[j].type !== 'inline' ||
        !state.md.linkify.pretest(blockTokens[j].content)) {
      continue;
    }

    tokens = blockTokens[j].children;

    htmlLinkLevel = 0;

    // We scan from the end, to keep position when new tags added.
    // Use reversed logic in links start/end match
    for (i = tokens.length - 1; i >= 0; i--) {
      currentToken = tokens[i];

      // Skip content of markdown links
      if (currentToken.type === 'link_close') {
        i--;
        while (tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open') {
          i--;
        }
        continue;
      }

      // Skip content of html tag links
      if (currentToken.type === 'html_inline') {
        if (isLinkOpen$1(currentToken.content) && htmlLinkLevel > 0) {
          htmlLinkLevel--;
        }
        if (isLinkClose$1(currentToken.content)) {
          htmlLinkLevel++;
        }
      }
      if (htmlLinkLevel > 0) { continue; }

      if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {

        text = currentToken.content;
        links = state.md.linkify.match(text);

        // Now split string to nodes
        nodes = [];
        level = currentToken.level;
        lastPos = 0;

        // forbid escape sequence at the start of the string,
        // this avoids http\://example.com/ from being linkified as
        // http:<a href="//example.com/">//example.com/</a>
        if (links.length > 0 &&
            links[0].index === 0 &&
            i > 0 &&
            tokens[i - 1].type === 'text_special') {
          links = links.slice(1);
        }

        for (ln = 0; ln < links.length; ln++) {
          url = links[ln].url;
          fullUrl = state.md.normalizeLink(url);
          if (!state.md.validateLink(fullUrl)) { continue; }

          urlText = links[ln].text;

          // Linkifier might send raw hostnames like "example.com", where url
          // starts with domain name. So we prepend http:// in those cases,
          // and remove it afterwards.
          //
          if (!links[ln].schema) {
            urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
          } else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) {
            urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
          } else {
            urlText = state.md.normalizeLinkText(urlText);
          }

          pos = links[ln].index;

          if (pos > lastPos) {
            token         = new state.Token('text', '', 0);
            token.content = text.slice(lastPos, pos);
            token.level   = level;
            nodes.push(token);
          }

          token         = new state.Token('link_open', 'a', 1);
          token.attrs   = [ [ 'href', fullUrl ] ];
          token.level   = level++;
          token.markup  = 'linkify';
          token.info    = 'auto';
          nodes.push(token);

          token         = new state.Token('text', '', 0);
          token.content = urlText;
          token.level   = level;
          nodes.push(token);

          token         = new state.Token('link_close', 'a', -1);
          token.level   = --level;
          token.markup  = 'linkify';
          token.info    = 'auto';
          nodes.push(token);

          lastPos = links[ln].lastIndex;
        }
        if (lastPos < text.length) {
          token         = new state.Token('text', '', 0);
          token.content = text.slice(lastPos);
          token.level   = level;
          nodes.push(token);
        }

        // replace current node
        blockTokens[j].children = tokens = arrayReplaceAt(tokens, i, nodes);
      }
    }
  }
};

// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4

var RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;

// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;

var SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
var SCOPED_ABBR = {
  c: '©',
  r: '®',
  tm: '™'
};

function replaceFn(match, name) {
  return SCOPED_ABBR[name.toLowerCase()];
}

function replace_scoped(inlineTokens) {
  var i, token, inside_autolink = 0;

  for (i = inlineTokens.length - 1; i >= 0; i--) {
    token = inlineTokens[i];

    if (token.type === 'text' && !inside_autolink) {
      token.content = token.content.replace(SCOPED_ABBR_RE, replaceFn);
    }

    if (token.type === 'link_open' && token.info === 'auto') {
      inside_autolink--;
    }

    if (token.type === 'link_close' && token.info === 'auto') {
      inside_autolink++;
    }
  }
}

function replace_rare(inlineTokens) {
  var i, token, inside_autolink = 0;

  for (i = inlineTokens.length - 1; i >= 0; i--) {
    token = inlineTokens[i];

    if (token.type === 'text' && !inside_autolink) {
      if (RARE_RE.test(token.content)) {
        token.content = token.content
          .replace(/\+-/g, '±')
          // .., ..., ....... -> …
          // but ?..... & !..... -> ?.. & !..
          .replace(/\.{2,}/g, '…').replace(/([?!])…/g, '$1..')
          .replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')
          // em-dash
          .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')
          // en-dash
          .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013')
          .replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
      }
    }

    if (token.type === 'link_open' && token.info === 'auto') {
      inside_autolink--;
    }

    if (token.type === 'link_close' && token.info === 'auto') {
      inside_autolink++;
    }
  }
}


var replacements = function replace(state) {
  var blkIdx;

  if (!state.md.options.typographer) { return; }

  for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {

    if (state.tokens[blkIdx].type !== 'inline') { continue; }

    if (SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) {
      replace_scoped(state.tokens[blkIdx].children);
    }

    if (RARE_RE.test(state.tokens[blkIdx].content)) {
      replace_rare(state.tokens[blkIdx].children);
    }

  }
};

var isWhiteSpace$1   = utils$1.isWhiteSpace;
var isPunctChar$1    = utils$1.isPunctChar;
var isMdAsciiPunct$1 = utils$1.isMdAsciiPunct;

var QUOTE_TEST_RE = /['"]/;
var QUOTE_RE = /['"]/g;
var APOSTROPHE = '\u2019'; /* ’ */


function replaceAt(str, index, ch) {
  return str.slice(0, index) + ch + str.slice(index + 1);
}

function process_inlines(tokens, state) {
  var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar,
      isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace,
      canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;

  stack = [];

  for (i = 0; i < tokens.length; i++) {
    token = tokens[i];

    thisLevel = tokens[i].level;

    for (j = stack.length - 1; j >= 0; j--) {
      if (stack[j].level <= thisLevel) { break; }
    }
    stack.length = j + 1;

    if (token.type !== 'text') { continue; }

    text = token.content;
    pos = 0;
    max = text.length;

    /*eslint no-labels:0,block-scoped-var:0*/
    OUTER:
    while (pos < max) {
      QUOTE_RE.lastIndex = pos;
      t = QUOTE_RE.exec(text);
      if (!t) { break; }

      canOpen = canClose = true;
      pos = t.index + 1;
      isSingle = (t[0] === "'");

      // Find previous character,
      // default to space if it's the beginning of the line
      //
      lastChar = 0x20;

      if (t.index - 1 >= 0) {
        lastChar = text.charCodeAt(t.index - 1);
      } else {
        for (j = i - 1; j >= 0; j--) {
          if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
          if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'

          lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
          break;
        }
      }

      // Find next character,
      // default to space if it's the end of the line
      //
      nextChar = 0x20;

      if (pos < max) {
        nextChar = text.charCodeAt(pos);
      } else {
        for (j = i + 1; j < tokens.length; j++) {
          if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
          if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'

          nextChar = tokens[j].content.charCodeAt(0);
          break;
        }
      }

      isLastPunctChar = isMdAsciiPunct$1(lastChar) || isPunctChar$1(String.fromCharCode(lastChar));
      isNextPunctChar = isMdAsciiPunct$1(nextChar) || isPunctChar$1(String.fromCharCode(nextChar));

      isLastWhiteSpace = isWhiteSpace$1(lastChar);
      isNextWhiteSpace = isWhiteSpace$1(nextChar);

      if (isNextWhiteSpace) {
        canOpen = false;
      } else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) {
          canOpen = false;
        }
      }

      if (isLastWhiteSpace) {
        canClose = false;
      } else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) {
          canClose = false;
        }
      }

      if (nextChar === 0x22 /* " */ && t[0] === '"') {
        if (lastChar >= 0x30 /* 0 */ && lastChar <= 0x39 /* 9 */) {
          // special case: 1"" - count first quote as an inch
          canClose = canOpen = false;
        }
      }

      if (canOpen && canClose) {
        // Replace quotes in the middle of punctuation sequence, but not
        // in the middle of the words, i.e.:
        //
        // 1. foo " bar " baz - not replaced
        // 2. foo-"-bar-"-baz - replaced
        // 3. foo"bar"baz     - not replaced
        //
        canOpen = isLastPunctChar;
        canClose = isNextPunctChar;
      }

      if (!canOpen && !canClose) {
        // middle of word
        if (isSingle) {
          token.content = replaceAt(token.content, t.index, APOSTROPHE);
        }
        continue;
      }

      if (canClose) {
        // this could be a closing quote, rewind the stack to get a match
        for (j = stack.length - 1; j >= 0; j--) {
          item = stack[j];
          if (stack[j].level < thisLevel) { break; }
          if (item.single === isSingle && stack[j].level === thisLevel) {
            item = stack[j];

            if (isSingle) {
              openQuote = state.md.options.quotes[2];
              closeQuote = state.md.options.quotes[3];
            } else {
              openQuote = state.md.options.quotes[0];
              closeQuote = state.md.options.quotes[1];
            }

            // replace token.content *before* tokens[item.token].content,
            // because, if they are pointing at the same token, replaceAt
            // could mess up indices when quote length != 1
            token.content = replaceAt(token.content, t.index, closeQuote);
            tokens[item.token].content = replaceAt(
              tokens[item.token].content, item.pos, openQuote);

            pos += closeQuote.length - 1;
            if (item.token === i) { pos += openQuote.length - 1; }

            text = token.content;
            max = text.length;

            stack.length = j;
            continue OUTER;
          }
        }
      }

      if (canOpen) {
        stack.push({
          token: i,
          pos: t.index,
          single: isSingle,
          level: thisLevel
        });
      } else if (canClose && isSingle) {
        token.content = replaceAt(token.content, t.index, APOSTROPHE);
      }
    }
  }
}


var smartquotes = function smartquotes(state) {
  /*eslint max-depth:0*/
  var blkIdx;

  if (!state.md.options.typographer) { return; }

  for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {

    if (state.tokens[blkIdx].type !== 'inline' ||
        !QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) {
      continue;
    }

    process_inlines(state.tokens[blkIdx].children, state);
  }
};

var text_join = function text_join(state) {
  var j, l, tokens, curr, max, last,
      blockTokens = state.tokens;

  for (j = 0, l = blockTokens.length; j < l; j++) {
    if (blockTokens[j].type !== 'inline') continue;

    tokens = blockTokens[j].children;
    max = tokens.length;

    for (curr = 0; curr < max; curr++) {
      if (tokens[curr].type === 'text_special') {
        tokens[curr].type = 'text';
      }
    }

    for (curr = last = 0; curr < max; curr++) {
      if (tokens[curr].type === 'text' &&
          curr + 1 < max &&
          tokens[curr + 1].type === 'text') {

        // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
      } else {
        if (curr !== last) { tokens[last] = tokens[curr]; }

        last++;
      }
    }

    if (curr !== last) {
      tokens.length = last;
    }
  }
};

/**
 * class Token
 **/

/**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/
function Token$3(type, tag, nesting) {
  /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/
  this.type     = type;

  /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/
  this.tag      = tag;

  /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/
  this.attrs    = null;

  /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/
  this.map      = null;

  /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/
  this.nesting  = nesting;

  /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/
  this.level    = 0;

  /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/
  this.children = null;

  /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/
  this.content  = '';

  /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/
  this.markup   = '';

  /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/
  this.info     = '';

  /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/
  this.meta     = null;

  /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/
  this.block    = false;

  /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/
  this.hidden   = false;
}


/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/
Token$3.prototype.attrIndex = function attrIndex(name) {
  var attrs, i, len;

  if (!this.attrs) { return -1; }

  attrs = this.attrs;

  for (i = 0, len = attrs.length; i < len; i++) {
    if (attrs[i][0] === name) { return i; }
  }
  return -1;
};


/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/
Token$3.prototype.attrPush = function attrPush(attrData) {
  if (this.attrs) {
    this.attrs.push(attrData);
  } else {
    this.attrs = [ attrData ];
  }
};


/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/
Token$3.prototype.attrSet = function attrSet(name, value) {
  var idx = this.attrIndex(name),
      attrData = [ name, value ];

  if (idx < 0) {
    this.attrPush(attrData);
  } else {
    this.attrs[idx] = attrData;
  }
};


/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/
Token$3.prototype.attrGet = function attrGet(name) {
  var idx = this.attrIndex(name), value = null;
  if (idx >= 0) {
    value = this.attrs[idx][1];
  }
  return value;
};


/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/
Token$3.prototype.attrJoin = function attrJoin(name, value) {
  var idx = this.attrIndex(name);

  if (idx < 0) {
    this.attrPush([ name, value ]);
  } else {
    this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
  }
};


var token = Token$3;

var Token$2 = token;


function StateCore(src, md, env) {
  this.src = src;
  this.env = env;
  this.tokens = [];
  this.inlineMode = false;
  this.md = md; // link to parser instance
}

// re-export Token class to use in core rules
StateCore.prototype.Token = Token$2;


var state_core = StateCore;

/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/


var Ruler$2  = ruler;


var _rules$2 = [
  [ 'normalize',      normalize      ],
  [ 'block',          block          ],
  [ 'inline',         inline         ],
  [ 'linkify',        linkify$1        ],
  [ 'replacements',   replacements   ],
  [ 'smartquotes',    smartquotes    ],
  // `text_join` finds `text_special` tokens (for escape sequences)
  // and joins them with the rest of the text
  [ 'text_join',      text_join      ]
];


/**
 * new Core()
 **/
function Core() {
  /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/
  this.ruler = new Ruler$2();

  for (var i = 0; i < _rules$2.length; i++) {
    this.ruler.push(_rules$2[i][0], _rules$2[i][1]);
  }
}


/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/
Core.prototype.process = function (state) {
  var i, l, rules;

  rules = this.ruler.getRules('');

  for (i = 0, l = rules.length; i < l; i++) {
    rules[i](state);
  }
};

Core.prototype.State = state_core;


var parser_core = Core;

var isSpace$a = utils$1.isSpace;


function getLine(state, line) {
  var pos = state.bMarks[line] + state.tShift[line],
      max = state.eMarks[line];

  return state.src.slice(pos, max);
}

function escapedSplit(str) {
  var result = [],
      pos = 0,
      max = str.length,
      ch,
      isEscaped = false,
      lastPos = 0,
      current = '';

  ch  = str.charCodeAt(pos);

  while (pos < max) {
    if (ch === 0x7c/* | */) {
      if (!isEscaped) {
        // pipe separating cells, '|'
        result.push(current + str.substring(lastPos, pos));
        current = '';
        lastPos = pos + 1;
      } else {
        // escaped pipe, '\|'
        current += str.substring(lastPos, pos - 1);
        lastPos = pos;
      }
    }

    isEscaped = (ch === 0x5c/* \ */);
    pos++;

    ch = str.charCodeAt(pos);
  }

  result.push(current + str.substring(lastPos));

  return result;
}


var table = function table(state, startLine, endLine, silent) {
  var ch, lineText, pos, i, l, nextLine, columns, columnCount, token,
      aligns, t, tableLines, tbodyLines, oldParentType, terminate,
      terminatorRules, firstCh, secondCh;

  // should have at least two lines
  if (startLine + 2 > endLine) { return false; }

  nextLine = startLine + 1;

  if (state.sCount[nextLine] < state.blkIndent) { return false; }

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[nextLine] - state.blkIndent >= 4) { return false; }

  // first character of the second line should be '|', '-', ':',
  // and no other characters are allowed but spaces;
  // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp

  pos = state.bMarks[nextLine] + state.tShift[nextLine];
  if (pos >= state.eMarks[nextLine]) { return false; }

  firstCh = state.src.charCodeAt(pos++);
  if (firstCh !== 0x7C/* | */ && firstCh !== 0x2D/* - */ && firstCh !== 0x3A/* : */) { return false; }

  if (pos >= state.eMarks[nextLine]) { return false; }

  secondCh = state.src.charCodeAt(pos++);
  if (secondCh !== 0x7C/* | */ && secondCh !== 0x2D/* - */ && secondCh !== 0x3A/* : */ && !isSpace$a(secondCh)) {
    return false;
  }

  // if first character is '-', then second character must not be a space
  // (due to parsing ambiguity with list)
  if (firstCh === 0x2D/* - */ && isSpace$a(secondCh)) { return false; }

  while (pos < state.eMarks[nextLine]) {
    ch = state.src.charCodeAt(pos);

    if (ch !== 0x7C/* | */ && ch !== 0x2D/* - */ && ch !== 0x3A/* : */ && !isSpace$a(ch)) { return false; }

    pos++;
  }

  lineText = getLine(state, startLine + 1);

  columns = lineText.split('|');
  aligns = [];
  for (i = 0; i < columns.length; i++) {
    t = columns[i].trim();
    if (!t) {
      // allow empty columns before and after table, but not in between columns;
      // e.g. allow ` |---| `, disallow ` ---||--- `
      if (i === 0 || i === columns.length - 1) {
        continue;
      } else {
        return false;
      }
    }

    if (!/^:?-+:?$/.test(t)) { return false; }
    if (t.charCodeAt(t.length - 1) === 0x3A/* : */) {
      aligns.push(t.charCodeAt(0) === 0x3A/* : */ ? 'center' : 'right');
    } else if (t.charCodeAt(0) === 0x3A/* : */) {
      aligns.push('left');
    } else {
      aligns.push('');
    }
  }

  lineText = getLine(state, startLine).trim();
  if (lineText.indexOf('|') === -1) { return false; }
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }
  columns = escapedSplit(lineText);
  if (columns.length && columns[0] === '') columns.shift();
  if (columns.length && columns[columns.length - 1] === '') columns.pop();

  // header row will define an amount of columns in the entire table,
  // and align row should be exactly the same (the rest of the rows can differ)
  columnCount = columns.length;
  if (columnCount === 0 || columnCount !== aligns.length) { return false; }

  if (silent) { return true; }

  oldParentType = state.parentType;
  state.parentType = 'table';

  // use 'blockquote' lists for termination because it's
  // the most similar to tables
  terminatorRules = state.md.block.ruler.getRules('blockquote');

  token     = state.push('table_open', 'table', 1);
  token.map = tableLines = [ startLine, 0 ];

  token     = state.push('thead_open', 'thead', 1);
  token.map = [ startLine, startLine + 1 ];

  token     = state.push('tr_open', 'tr', 1);
  token.map = [ startLine, startLine + 1 ];

  for (i = 0; i < columns.length; i++) {
    token          = state.push('th_open', 'th', 1);
    if (aligns[i]) {
      token.attrs  = [ [ 'style', 'text-align:' + aligns[i] ] ];
    }

    token          = state.push('inline', '', 0);
    token.content  = columns[i].trim();
    token.children = [];

    token          = state.push('th_close', 'th', -1);
  }

  token     = state.push('tr_close', 'tr', -1);
  token     = state.push('thead_close', 'thead', -1);

  for (nextLine = startLine + 2; nextLine < endLine; nextLine++) {
    if (state.sCount[nextLine] < state.blkIndent) { break; }

    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }

    if (terminate) { break; }
    lineText = getLine(state, nextLine).trim();
    if (!lineText) { break; }
    if (state.sCount[nextLine] - state.blkIndent >= 4) { break; }
    columns = escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();

    if (nextLine === startLine + 2) {
      token     = state.push('tbody_open', 'tbody', 1);
      token.map = tbodyLines = [ startLine + 2, 0 ];
    }

    token     = state.push('tr_open', 'tr', 1);
    token.map = [ nextLine, nextLine + 1 ];

    for (i = 0; i < columnCount; i++) {
      token          = state.push('td_open', 'td', 1);
      if (aligns[i]) {
        token.attrs  = [ [ 'style', 'text-align:' + aligns[i] ] ];
      }

      token          = state.push('inline', '', 0);
      token.content  = columns[i] ? columns[i].trim() : '';
      token.children = [];

      token          = state.push('td_close', 'td', -1);
    }
    token = state.push('tr_close', 'tr', -1);
  }

  if (tbodyLines) {
    token = state.push('tbody_close', 'tbody', -1);
    tbodyLines[1] = nextLine;
  }

  token = state.push('table_close', 'table', -1);
  tableLines[1] = nextLine;

  state.parentType = oldParentType;
  state.line = nextLine;
  return true;
};

var code = function code(state, startLine, endLine/*, silent*/) {
  var nextLine, last, token;

  if (state.sCount[startLine] - state.blkIndent < 4) { return false; }

  last = nextLine = startLine + 1;

  while (nextLine < endLine) {
    if (state.isEmpty(nextLine)) {
      nextLine++;
      continue;
    }

    if (state.sCount[nextLine] - state.blkIndent >= 4) {
      nextLine++;
      last = nextLine;
      continue;
    }
    break;
  }

  state.line = last;

  token         = state.push('code_block', 'code', 0);
  token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
  token.map     = [ startLine, state.line ];

  return true;
};

var fence = function fence(state, startLine, endLine, silent) {
  var marker, len, params, nextLine, mem, token, markup,
      haveEndMarker = false,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  if (pos + 3 > max) { return false; }

  marker = state.src.charCodeAt(pos);

  if (marker !== 0x7E/* ~ */ && marker !== 0x60 /* ` */) {
    return false;
  }

  // scan marker length
  mem = pos;
  pos = state.skipChars(pos, marker);

  len = pos - mem;

  if (len < 3) { return false; }

  markup = state.src.slice(mem, pos);
  params = state.src.slice(pos, max);

  if (marker === 0x60 /* ` */) {
    if (params.indexOf(String.fromCharCode(marker)) >= 0) {
      return false;
    }
  }

  // Since start is found, we can report success here in validation mode
  if (silent) { return true; }

  // search end of block
  nextLine = startLine;

  for (;;) {
    nextLine++;
    if (nextLine >= endLine) {
      // unclosed block should be autoclosed by end of document.
      // also block seems to be autoclosed by end of parent
      break;
    }

    pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
    max = state.eMarks[nextLine];

    if (pos < max && state.sCount[nextLine] < state.blkIndent) {
      // non-empty line with negative indent should stop the list:
      // - ```
      //  test
      break;
    }

    if (state.src.charCodeAt(pos) !== marker) { continue; }

    if (state.sCount[nextLine] - state.blkIndent >= 4) {
      // closing fence should be indented less than 4 spaces
      continue;
    }

    pos = state.skipChars(pos, marker);

    // closing code fence must be at least as long as the opening one
    if (pos - mem < len) { continue; }

    // make sure tail has spaces only
    pos = state.skipSpaces(pos);

    if (pos < max) { continue; }

    haveEndMarker = true;
    // found!
    break;
  }

  // If a fence has heading spaces, they should be removed from its inner block
  len = state.sCount[startLine];

  state.line = nextLine + (haveEndMarker ? 1 : 0);

  token         = state.push('fence', 'code', 0);
  token.info    = params;
  token.content = state.getLines(startLine + 1, nextLine, len, true);
  token.markup  = markup;
  token.map     = [ startLine, state.line ];

  return true;
};

var isSpace$9 = utils$1.isSpace;


var blockquote = function blockquote(state, startLine, endLine, silent) {
  var adjustTab,
      ch,
      i,
      initial,
      l,
      lastLineEmpty,
      lines,
      nextLine,
      offset,
      oldBMarks,
      oldBSCount,
      oldIndent,
      oldParentType,
      oldSCount,
      oldTShift,
      spaceAfterMarker,
      terminate,
      terminatorRules,
      token,
      isOutdented,
      oldLineMax = state.lineMax,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  // check the block quote marker
  if (state.src.charCodeAt(pos) !== 0x3E/* > */) { return false; }

  // we know that it's going to be a valid blockquote,
  // so no point trying to find the end of it in silent mode
  if (silent) { return true; }

  oldBMarks  = [];
  oldBSCount = [];
  oldSCount  = [];
  oldTShift  = [];

  terminatorRules = state.md.block.ruler.getRules('blockquote');

  oldParentType = state.parentType;
  state.parentType = 'blockquote';

  // Search the end of the block
  //
  // Block ends with either:
  //  1. an empty line outside:
  //     ```
  //     > test
  //
  //     ```
  //  2. an empty line inside:
  //     ```
  //     >
  //     test
  //     ```
  //  3. another tag:
  //     ```
  //     > test
  //      - - -
  //     ```
  for (nextLine = startLine; nextLine < endLine; nextLine++) {
    // check if it's outdented, i.e. it's inside list item and indented
    // less than said list item:
    //
    // ```
    // 1. anything
    //    > current blockquote
    // 2. checking this line
    // ```
    isOutdented = state.sCount[nextLine] < state.blkIndent;

    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    max = state.eMarks[nextLine];

    if (pos >= max) {
      // Case 1: line is not inside the blockquote, and this line is empty.
      break;
    }

    if (state.src.charCodeAt(pos++) === 0x3E/* > */ && !isOutdented) {
      // This line is inside the blockquote.

      // set offset past spaces and ">"
      initial = state.sCount[nextLine] + 1;

      // skip one optional space after '>'
      if (state.src.charCodeAt(pos) === 0x20 /* space */) {
        // ' >   test '
        //     ^ -- position start of line here:
        pos++;
        initial++;
        adjustTab = false;
        spaceAfterMarker = true;
      } else if (state.src.charCodeAt(pos) === 0x09 /* tab */) {
        spaceAfterMarker = true;

        if ((state.bsCount[nextLine] + initial) % 4 === 3) {
          // '  >\t  test '
          //       ^ -- position start of line here (tab has width===1)
          pos++;
          initial++;
          adjustTab = false;
        } else {
          // ' >\t  test '
          //    ^ -- position start of line here + shift bsCount slightly
          //         to make extra space appear
          adjustTab = true;
        }
      } else {
        spaceAfterMarker = false;
      }

      offset = initial;
      oldBMarks.push(state.bMarks[nextLine]);
      state.bMarks[nextLine] = pos;

      while (pos < max) {
        ch = state.src.charCodeAt(pos);

        if (isSpace$9(ch)) {
          if (ch === 0x09) {
            offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
          } else {
            offset++;
          }
        } else {
          break;
        }

        pos++;
      }

      lastLineEmpty = pos >= max;

      oldBSCount.push(state.bsCount[nextLine]);
      state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);

      oldSCount.push(state.sCount[nextLine]);
      state.sCount[nextLine] = offset - initial;

      oldTShift.push(state.tShift[nextLine]);
      state.tShift[nextLine] = pos - state.bMarks[nextLine];
      continue;
    }

    // Case 2: line is not inside the blockquote, and the last line was empty.
    if (lastLineEmpty) { break; }

    // Case 3: another tag found.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }

    if (terminate) {
      // Quirk to enforce "hard termination mode" for paragraphs;
      // normally if you call `tokenize(state, startLine, nextLine)`,
      // paragraphs will look below nextLine for paragraph continuation,
      // but if blockquote is terminated by another tag, they shouldn't
      state.lineMax = nextLine;

      if (state.blkIndent !== 0) {
        // state.blkIndent was non-zero, we now set it to zero,
        // so we need to re-calculate all offsets to appear as
        // if indent wasn't changed
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        state.sCount[nextLine] -= state.blkIndent;
      }

      break;
    }

    oldBMarks.push(state.bMarks[nextLine]);
    oldBSCount.push(state.bsCount[nextLine]);
    oldTShift.push(state.tShift[nextLine]);
    oldSCount.push(state.sCount[nextLine]);

    // A negative indentation means that this is a paragraph continuation
    //
    state.sCount[nextLine] = -1;
  }

  oldIndent = state.blkIndent;
  state.blkIndent = 0;

  token        = state.push('blockquote_open', 'blockquote', 1);
  token.markup = '>';
  token.map    = lines = [ startLine, 0 ];

  state.md.block.tokenize(state, startLine, nextLine);

  token        = state.push('blockquote_close', 'blockquote', -1);
  token.markup = '>';

  state.lineMax = oldLineMax;
  state.parentType = oldParentType;
  lines[1] = state.line;

  // Restore original tShift; this might not be necessary since the parser
  // has already been here, but just to make sure we can do that.
  for (i = 0; i < oldTShift.length; i++) {
    state.bMarks[i + startLine] = oldBMarks[i];
    state.tShift[i + startLine] = oldTShift[i];
    state.sCount[i + startLine] = oldSCount[i];
    state.bsCount[i + startLine] = oldBSCount[i];
  }
  state.blkIndent = oldIndent;

  return true;
};

var isSpace$8 = utils$1.isSpace;


var hr = function hr(state, startLine, endLine, silent) {
  var marker, cnt, ch, token,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  marker = state.src.charCodeAt(pos++);

  // Check hr marker
  if (marker !== 0x2A/* * */ &&
      marker !== 0x2D/* - */ &&
      marker !== 0x5F/* _ */) {
    return false;
  }

  // markers can be mixed with spaces, but there should be at least 3 of them

  cnt = 1;
  while (pos < max) {
    ch = state.src.charCodeAt(pos++);
    if (ch !== marker && !isSpace$8(ch)) { return false; }
    if (ch === marker) { cnt++; }
  }

  if (cnt < 3) { return false; }

  if (silent) { return true; }

  state.line = startLine + 1;

  token        = state.push('hr', 'hr', 0);
  token.map    = [ startLine, state.line ];
  token.markup = Array(cnt + 1).join(String.fromCharCode(marker));

  return true;
};

var isSpace$7 = utils$1.isSpace;


// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function skipBulletListMarker(state, startLine) {
  var marker, pos, max, ch;

  pos = state.bMarks[startLine] + state.tShift[startLine];
  max = state.eMarks[startLine];

  marker = state.src.charCodeAt(pos++);
  // Check bullet
  if (marker !== 0x2A/* * */ &&
      marker !== 0x2D/* - */ &&
      marker !== 0x2B/* + */) {
    return -1;
  }

  if (pos < max) {
    ch = state.src.charCodeAt(pos);

    if (!isSpace$7(ch)) {
      // " -test " - is not a list item
      return -1;
    }
  }

  return pos;
}

// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function skipOrderedListMarker(state, startLine) {
  var ch,
      start = state.bMarks[startLine] + state.tShift[startLine],
      pos = start,
      max = state.eMarks[startLine];

  // List marker should have at least 2 chars (digit + dot)
  if (pos + 1 >= max) { return -1; }

  ch = state.src.charCodeAt(pos++);

  if (ch < 0x30/* 0 */ || ch > 0x39/* 9 */) { return -1; }

  for (;;) {
    // EOL -> fail
    if (pos >= max) { return -1; }

    ch = state.src.charCodeAt(pos++);

    if (ch >= 0x30/* 0 */ && ch <= 0x39/* 9 */) {

      // List marker should have no more than 9 digits
      // (prevents integer overflow in browsers)
      if (pos - start >= 10) { return -1; }

      continue;
    }

    // found valid marker
    if (ch === 0x29/* ) */ || ch === 0x2e/* . */) {
      break;
    }

    return -1;
  }


  if (pos < max) {
    ch = state.src.charCodeAt(pos);

    if (!isSpace$7(ch)) {
      // " 1.test " - is not a list item
      return -1;
    }
  }
  return pos;
}

function markTightParagraphs(state, idx) {
  var i, l,
      level = state.level + 2;

  for (i = idx + 2, l = state.tokens.length - 2; i < l; i++) {
    if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
      state.tokens[i + 2].hidden = true;
      state.tokens[i].hidden = true;
      i += 2;
    }
  }
}


var list = function list(state, startLine, endLine, silent) {
  var ch,
      contentStart,
      i,
      indent,
      indentAfterMarker,
      initial,
      isOrdered,
      itemLines,
      l,
      listLines,
      listTokIdx,
      markerCharCode,
      markerValue,
      max,
      offset,
      oldListIndent,
      oldParentType,
      oldSCount,
      oldTShift,
      oldTight,
      pos,
      posAfterMarker,
      prevEmptyEnd,
      start,
      terminate,
      terminatorRules,
      token,
      nextLine = startLine,
      isTerminatingParagraph = false,
      tight = true;

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[nextLine] - state.blkIndent >= 4) { return false; }

  // Special case:
  //  - item 1
  //   - item 2
  //    - item 3
  //     - item 4
  //      - this one is a paragraph continuation
  if (state.listIndent >= 0 &&
      state.sCount[nextLine] - state.listIndent >= 4 &&
      state.sCount[nextLine] < state.blkIndent) {
    return false;
  }

  // limit conditions when list can interrupt
  // a paragraph (validation mode only)
  if (silent && state.parentType === 'paragraph') {
    // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    if (state.sCount[nextLine] >= state.blkIndent) {
      isTerminatingParagraph = true;
    }
  }

  // Detect list type and position after marker
  if ((posAfterMarker = skipOrderedListMarker(state, nextLine)) >= 0) {
    isOrdered = true;
    start = state.bMarks[nextLine] + state.tShift[nextLine];
    markerValue = Number(state.src.slice(start, posAfterMarker - 1));

    // If we're starting a new ordered list right after
    // a paragraph, it should start with 1.
    if (isTerminatingParagraph && markerValue !== 1) return false;

  } else if ((posAfterMarker = skipBulletListMarker(state, nextLine)) >= 0) {
    isOrdered = false;

  } else {
    return false;
  }

  // If we're starting a new unordered list right after
  // a paragraph, first line should not be empty.
  if (isTerminatingParagraph) {
    if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
  }

  // For validation mode we can terminate immediately
  if (silent) { return true; }

  // We should terminate list on style change. Remember first one to compare.
  markerCharCode = state.src.charCodeAt(posAfterMarker - 1);

  // Start list
  listTokIdx = state.tokens.length;

  if (isOrdered) {
    token       = state.push('ordered_list_open', 'ol', 1);
    if (markerValue !== 1) {
      token.attrs = [ [ 'start', markerValue ] ];
    }

  } else {
    token       = state.push('bullet_list_open', 'ul', 1);
  }

  token.map    = listLines = [ nextLine, 0 ];
  token.markup = String.fromCharCode(markerCharCode);

  //
  // Iterate list items
  //

  prevEmptyEnd = false;
  terminatorRules = state.md.block.ruler.getRules('list');

  oldParentType = state.parentType;
  state.parentType = 'list';

  while (nextLine < endLine) {
    pos = posAfterMarker;
    max = state.eMarks[nextLine];

    initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);

    while (pos < max) {
      ch = state.src.charCodeAt(pos);

      if (ch === 0x09) {
        offset += 4 - (offset + state.bsCount[nextLine]) % 4;
      } else if (ch === 0x20) {
        offset++;
      } else {
        break;
      }

      pos++;
    }

    contentStart = pos;

    if (contentStart >= max) {
      // trimming space in "-    \n  3" case, indent is 1 here
      indentAfterMarker = 1;
    } else {
      indentAfterMarker = offset - initial;
    }

    // If we have more than 4 spaces, the indent is 1
    // (the rest is just indented code block)
    if (indentAfterMarker > 4) { indentAfterMarker = 1; }

    // "  -  test"
    //  ^^^^^ - calculating total length of this thing
    indent = initial + indentAfterMarker;

    // Run subparser & write tokens
    token        = state.push('list_item_open', 'li', 1);
    token.markup = String.fromCharCode(markerCharCode);
    token.map    = itemLines = [ nextLine, 0 ];
    if (isOrdered) {
      token.info = state.src.slice(start, posAfterMarker - 1);
    }

    // change current state, then restore it after parser subcall
    oldTight = state.tight;
    oldTShift = state.tShift[nextLine];
    oldSCount = state.sCount[nextLine];

    //  - example list
    // ^ listIndent position will be here
    //   ^ blkIndent position will be here
    //
    oldListIndent = state.listIndent;
    state.listIndent = state.blkIndent;
    state.blkIndent = indent;

    state.tight = true;
    state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
    state.sCount[nextLine] = offset;

    if (contentStart >= max && state.isEmpty(nextLine + 1)) {
      // workaround for this case
      // (list item is empty, list terminates before "foo"):
      // ~~~~~~~~
      //   -
      //
      //     foo
      // ~~~~~~~~
      state.line = Math.min(state.line + 2, endLine);
    } else {
      state.md.block.tokenize(state, nextLine, endLine, true);
    }

    // If any of list item is tight, mark list as tight
    if (!state.tight || prevEmptyEnd) {
      tight = false;
    }
    // Item become loose if finish with empty line,
    // but we should filter last element, because it means list finish
    prevEmptyEnd = (state.line - nextLine) > 1 && state.isEmpty(state.line - 1);

    state.blkIndent = state.listIndent;
    state.listIndent = oldListIndent;
    state.tShift[nextLine] = oldTShift;
    state.sCount[nextLine] = oldSCount;
    state.tight = oldTight;

    token        = state.push('list_item_close', 'li', -1);
    token.markup = String.fromCharCode(markerCharCode);

    nextLine = state.line;
    itemLines[1] = nextLine;

    if (nextLine >= endLine) { break; }

    //
    // Try to check if list is terminated or continued.
    //
    if (state.sCount[nextLine] < state.blkIndent) { break; }

    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) { break; }

    // fail if terminating block found
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }

    // fail if list has another type
    if (isOrdered) {
      posAfterMarker = skipOrderedListMarker(state, nextLine);
      if (posAfterMarker < 0) { break; }
      start = state.bMarks[nextLine] + state.tShift[nextLine];
    } else {
      posAfterMarker = skipBulletListMarker(state, nextLine);
      if (posAfterMarker < 0) { break; }
    }

    if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) { break; }
  }

  // Finalize list
  if (isOrdered) {
    token = state.push('ordered_list_close', 'ol', -1);
  } else {
    token = state.push('bullet_list_close', 'ul', -1);
  }
  token.markup = String.fromCharCode(markerCharCode);

  listLines[1] = nextLine;
  state.line = nextLine;

  state.parentType = oldParentType;

  // mark paragraphs tight if needed
  if (tight) {
    markTightParagraphs(state, listTokIdx);
  }

  return true;
};

var normalizeReference$2   = utils$1.normalizeReference;
var isSpace$6              = utils$1.isSpace;


var reference = function reference(state, startLine, _endLine, silent) {
  var ch,
      destEndPos,
      destEndLineNo,
      endLine,
      href,
      i,
      l,
      label,
      labelEnd,
      oldParentType,
      res,
      start,
      str,
      terminate,
      terminatorRules,
      title,
      lines = 0,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine],
      nextLine = startLine + 1;

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  if (state.src.charCodeAt(pos) !== 0x5B/* [ */) { return false; }

  // Simple check to quickly interrupt scan on [link](url) at the start of line.
  // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
  while (++pos < max) {
    if (state.src.charCodeAt(pos) === 0x5D /* ] */ &&
        state.src.charCodeAt(pos - 1) !== 0x5C/* \ */) {
      if (pos + 1 === max) { return false; }
      if (state.src.charCodeAt(pos + 1) !== 0x3A/* : */) { return false; }
      break;
    }
  }

  endLine = state.lineMax;

  // jump line-by-line until empty one or EOF
  terminatorRules = state.md.block.ruler.getRules('reference');

  oldParentType = state.parentType;
  state.parentType = 'reference';

  for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
    // this would be a code block normally, but after paragraph
    // it's considered a lazy continuation regardless of what's there
    if (state.sCount[nextLine] - state.blkIndent > 3) { continue; }

    // quirk for blockquotes, this line should already be checked by that rule
    if (state.sCount[nextLine] < 0) { continue; }

    // Some tags can terminate paragraph without empty line.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }
  }

  str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
  max = str.length;

  for (pos = 1; pos < max; pos++) {
    ch = str.charCodeAt(pos);
    if (ch === 0x5B /* [ */) {
      return false;
    } else if (ch === 0x5D /* ] */) {
      labelEnd = pos;
      break;
    } else if (ch === 0x0A /* \n */) {
      lines++;
    } else if (ch === 0x5C /* \ */) {
      pos++;
      if (pos < max && str.charCodeAt(pos) === 0x0A) {
        lines++;
      }
    }
  }

  if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A/* : */) { return false; }

  // [label]:   destination   'title'
  //         ^^^ skip optional whitespace here
  for (pos = labelEnd + 2; pos < max; pos++) {
    ch = str.charCodeAt(pos);
    if (ch === 0x0A) {
      lines++;
    } else if (isSpace$6(ch)) ; else {
      break;
    }
  }

  // [label]:   destination   'title'
  //            ^^^^^^^^^^^ parse this
  res = state.md.helpers.parseLinkDestination(str, pos, max);
  if (!res.ok) { return false; }

  href = state.md.normalizeLink(res.str);
  if (!state.md.validateLink(href)) { return false; }

  pos = res.pos;
  lines += res.lines;

  // save cursor state, we could require to rollback later
  destEndPos = pos;
  destEndLineNo = lines;

  // [label]:   destination   'title'
  //                       ^^^ skipping those spaces
  start = pos;
  for (; pos < max; pos++) {
    ch = str.charCodeAt(pos);
    if (ch === 0x0A) {
      lines++;
    } else if (isSpace$6(ch)) ; else {
      break;
    }
  }

  // [label]:   destination   'title'
  //                          ^^^^^^^ parse this
  res = state.md.helpers.parseLinkTitle(str, pos, max);
  if (pos < max && start !== pos && res.ok) {
    title = res.str;
    pos = res.pos;
    lines += res.lines;
  } else {
    title = '';
    pos = destEndPos;
    lines = destEndLineNo;
  }

  // skip trailing spaces until the rest of the line
  while (pos < max) {
    ch = str.charCodeAt(pos);
    if (!isSpace$6(ch)) { break; }
    pos++;
  }

  if (pos < max && str.charCodeAt(pos) !== 0x0A) {
    if (title) {
      // garbage at the end of the line after title,
      // but it could still be a valid reference if we roll back
      title = '';
      pos = destEndPos;
      lines = destEndLineNo;
      while (pos < max) {
        ch = str.charCodeAt(pos);
        if (!isSpace$6(ch)) { break; }
        pos++;
      }
    }
  }

  if (pos < max && str.charCodeAt(pos) !== 0x0A) {
    // garbage at the end of the line
    return false;
  }

  label = normalizeReference$2(str.slice(1, labelEnd));
  if (!label) {
    // CommonMark 0.20 disallows empty labels
    return false;
  }

  // Reference can not terminate anything. This check is for safety only.
  /*istanbul ignore if*/
  if (silent) { return true; }

  if (typeof state.env.references === 'undefined') {
    state.env.references = {};
  }
  if (typeof state.env.references[label] === 'undefined') {
    state.env.references[label] = { title: title, href: href };
  }

  state.parentType = oldParentType;

  state.line = startLine + lines + 1;
  return true;
};

var html_blocks = [
  'address',
  'article',
  'aside',
  'base',
  'basefont',
  'blockquote',
  'body',
  'caption',
  'center',
  'col',
  'colgroup',
  'dd',
  'details',
  'dialog',
  'dir',
  'div',
  'dl',
  'dt',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'frame',
  'frameset',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hr',
  'html',
  'iframe',
  'legend',
  'li',
  'link',
  'main',
  'menu',
  'menuitem',
  'nav',
  'noframes',
  'ol',
  'optgroup',
  'option',
  'p',
  'param',
  'section',
  'source',
  'summary',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'title',
  'tr',
  'track',
  'ul'
];

var html_re = {};

var attr_name     = '[a-zA-Z_:][a-zA-Z0-9:._-]*';

var unquoted      = '[^"\'=<>`\\x00-\\x20]+';
var single_quoted = "'[^']*'";
var double_quoted = '"[^"]*"';

var attr_value  = '(?:' + unquoted + '|' + single_quoted + '|' + double_quoted + ')';

var attribute   = '(?:\\s+' + attr_name + '(?:\\s*=\\s*' + attr_value + ')?)';

var open_tag    = '<[A-Za-z][A-Za-z0-9\\-]*' + attribute + '*\\s*\\/?>';

var close_tag   = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
var comment     = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
var processing  = '<[?][\\s\\S]*?[?]>';
var declaration = '<![A-Z]+\\s+[^>]*>';
var cdata       = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';

var HTML_TAG_RE$1 = new RegExp('^(?:' + open_tag + '|' + close_tag + '|' + comment +
                        '|' + processing + '|' + declaration + '|' + cdata + ')');
var HTML_OPEN_CLOSE_TAG_RE$1 = new RegExp('^(?:' + open_tag + '|' + close_tag + ')');

html_re.HTML_TAG_RE = HTML_TAG_RE$1;
html_re.HTML_OPEN_CLOSE_TAG_RE = HTML_OPEN_CLOSE_TAG_RE$1;

var block_names = html_blocks;
var HTML_OPEN_CLOSE_TAG_RE = html_re.HTML_OPEN_CLOSE_TAG_RE;

// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var HTML_SEQUENCES = [
  [ /^<(script|pre|style|textarea)(?=(\s|>|$))/i, /<\/(script|pre|style|textarea)>/i, true ],
  [ /^<!--/,        /-->/,   true ],
  [ /^<\?/,         /\?>/,   true ],
  [ /^<![A-Z]/,     />/,     true ],
  [ /^<!\[CDATA\[/, /\]\]>/, true ],
  [ new RegExp('^</?(' + block_names.join('|') + ')(?=(\\s|/?>|$))', 'i'), /^$/, true ],
  [ new RegExp(HTML_OPEN_CLOSE_TAG_RE.source + '\\s*$'),  /^$/, false ]
];


var html_block = function html_block(state, startLine, endLine, silent) {
  var i, nextLine, token, lineText,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  if (!state.md.options.html) { return false; }

  if (state.src.charCodeAt(pos) !== 0x3C/* < */) { return false; }

  lineText = state.src.slice(pos, max);

  for (i = 0; i < HTML_SEQUENCES.length; i++) {
    if (HTML_SEQUENCES[i][0].test(lineText)) { break; }
  }

  if (i === HTML_SEQUENCES.length) { return false; }

  if (silent) {
    // true if this sequence can be a terminator, false otherwise
    return HTML_SEQUENCES[i][2];
  }

  nextLine = startLine + 1;

  // If we are here - we detected HTML block.
  // Let's roll down till block end.
  if (!HTML_SEQUENCES[i][1].test(lineText)) {
    for (; nextLine < endLine; nextLine++) {
      if (state.sCount[nextLine] < state.blkIndent) { break; }

      pos = state.bMarks[nextLine] + state.tShift[nextLine];
      max = state.eMarks[nextLine];
      lineText = state.src.slice(pos, max);

      if (HTML_SEQUENCES[i][1].test(lineText)) {
        if (lineText.length !== 0) { nextLine++; }
        break;
      }
    }
  }

  state.line = nextLine;

  token         = state.push('html_block', '', 0);
  token.map     = [ startLine, nextLine ];
  token.content = state.getLines(startLine, nextLine, state.blkIndent, true);

  return true;
};

var isSpace$5 = utils$1.isSpace;


var heading = function heading(state, startLine, endLine, silent) {
  var ch, level, tmp, token,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  ch  = state.src.charCodeAt(pos);

  if (ch !== 0x23/* # */ || pos >= max) { return false; }

  // count heading level
  level = 1;
  ch = state.src.charCodeAt(++pos);
  while (ch === 0x23/* # */ && pos < max && level <= 6) {
    level++;
    ch = state.src.charCodeAt(++pos);
  }

  if (level > 6 || (pos < max && !isSpace$5(ch))) { return false; }

  if (silent) { return true; }

  // Let's cut tails like '    ###  ' from the end of string

  max = state.skipSpacesBack(max, pos);
  tmp = state.skipCharsBack(max, 0x23, pos); // #
  if (tmp > pos && isSpace$5(state.src.charCodeAt(tmp - 1))) {
    max = tmp;
  }

  state.line = startLine + 1;

  token        = state.push('heading_open', 'h' + String(level), 1);
  token.markup = '########'.slice(0, level);
  token.map    = [ startLine, state.line ];

  token          = state.push('inline', '', 0);
  token.content  = state.src.slice(pos, max).trim();
  token.map      = [ startLine, state.line ];
  token.children = [];

  token        = state.push('heading_close', 'h' + String(level), -1);
  token.markup = '########'.slice(0, level);

  return true;
};

var lheading = function lheading(state, startLine, endLine/*, silent*/) {
  var content, terminate, i, l, token, pos, max, level, marker,
      nextLine = startLine + 1, oldParentType,
      terminatorRules = state.md.block.ruler.getRules('paragraph');

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  oldParentType = state.parentType;
  state.parentType = 'paragraph'; // use paragraph to match terminatorRules

  // jump line-by-line until empty one or EOF
  for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
    // this would be a code block normally, but after paragraph
    // it's considered a lazy continuation regardless of what's there
    if (state.sCount[nextLine] - state.blkIndent > 3) { continue; }

    //
    // Check for underline in setext header
    //
    if (state.sCount[nextLine] >= state.blkIndent) {
      pos = state.bMarks[nextLine] + state.tShift[nextLine];
      max = state.eMarks[nextLine];

      if (pos < max) {
        marker = state.src.charCodeAt(pos);

        if (marker === 0x2D/* - */ || marker === 0x3D/* = */) {
          pos = state.skipChars(pos, marker);
          pos = state.skipSpaces(pos);

          if (pos >= max) {
            level = (marker === 0x3D/* = */ ? 1 : 2);
            break;
          }
        }
      }
    }

    // quirk for blockquotes, this line should already be checked by that rule
    if (state.sCount[nextLine] < 0) { continue; }

    // Some tags can terminate paragraph without empty line.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }
  }

  if (!level) {
    // Didn't find valid underline
    return false;
  }

  content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();

  state.line = nextLine + 1;

  token          = state.push('heading_open', 'h' + String(level), 1);
  token.markup   = String.fromCharCode(marker);
  token.map      = [ startLine, state.line ];

  token          = state.push('inline', '', 0);
  token.content  = content;
  token.map      = [ startLine, state.line - 1 ];
  token.children = [];

  token          = state.push('heading_close', 'h' + String(level), -1);
  token.markup   = String.fromCharCode(marker);

  state.parentType = oldParentType;

  return true;
};

var paragraph = function paragraph(state, startLine, endLine) {
  var content, terminate, i, l, token, oldParentType,
      nextLine = startLine + 1,
      terminatorRules = state.md.block.ruler.getRules('paragraph');

  oldParentType = state.parentType;
  state.parentType = 'paragraph';

  // jump line-by-line until empty one or EOF
  for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
    // this would be a code block normally, but after paragraph
    // it's considered a lazy continuation regardless of what's there
    if (state.sCount[nextLine] - state.blkIndent > 3) { continue; }

    // quirk for blockquotes, this line should already be checked by that rule
    if (state.sCount[nextLine] < 0) { continue; }

    // Some tags can terminate paragraph without empty line.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }
  }

  content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();

  state.line = nextLine;

  token          = state.push('paragraph_open', 'p', 1);
  token.map      = [ startLine, state.line ];

  token          = state.push('inline', '', 0);
  token.content  = content;
  token.map      = [ startLine, state.line ];
  token.children = [];

  token          = state.push('paragraph_close', 'p', -1);

  state.parentType = oldParentType;

  return true;
};

var Token$1 = token;
var isSpace$4 = utils$1.isSpace;


function StateBlock(src, md, env, tokens) {
  var ch, s, start, pos, len, indent, offset, indent_found;

  this.src = src;

  // link to parser instance
  this.md     = md;

  this.env = env;

  //
  // Internal state vartiables
  //

  this.tokens = tokens;

  this.bMarks = [];  // line begin offsets for fast jumps
  this.eMarks = [];  // line end offsets for fast jumps
  this.tShift = [];  // offsets of the first non-space characters (tabs not expanded)
  this.sCount = [];  // indents for each line (tabs expanded)

  // An amount of virtual spaces (tabs expanded) between beginning
  // of each line (bMarks) and real beginning of that line.
  //
  // It exists only as a hack because blockquotes override bMarks
  // losing information in the process.
  //
  // It's used only when expanding tabs, you can think about it as
  // an initial tab length, e.g. bsCount=21 applied to string `\t123`
  // means first tab should be expanded to 4-21%4 === 3 spaces.
  //
  this.bsCount = [];

  // block parser variables
  this.blkIndent  = 0; // required block content indent (for example, if we are
                       // inside a list, it would be positioned after list marker)
  this.line       = 0; // line index in src
  this.lineMax    = 0; // lines count
  this.tight      = false;  // loose/tight mode for lists
  this.ddIndent   = -1; // indent of the current dd block (-1 if there isn't any)
  this.listIndent = -1; // indent of the current list block (-1 if there isn't any)

  // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
  // used in lists to determine if they interrupt a paragraph
  this.parentType = 'root';

  this.level = 0;

  // renderer
  this.result = '';

  // Create caches
  // Generate markers.
  s = this.src;
  indent_found = false;

  for (start = pos = indent = offset = 0, len = s.length; pos < len; pos++) {
    ch = s.charCodeAt(pos);

    if (!indent_found) {
      if (isSpace$4(ch)) {
        indent++;

        if (ch === 0x09) {
          offset += 4 - offset % 4;
        } else {
          offset++;
        }
        continue;
      } else {
        indent_found = true;
      }
    }

    if (ch === 0x0A || pos === len - 1) {
      if (ch !== 0x0A) { pos++; }
      this.bMarks.push(start);
      this.eMarks.push(pos);
      this.tShift.push(indent);
      this.sCount.push(offset);
      this.bsCount.push(0);

      indent_found = false;
      indent = 0;
      offset = 0;
      start = pos + 1;
    }
  }

  // Push fake entry to simplify cache bounds checks
  this.bMarks.push(s.length);
  this.eMarks.push(s.length);
  this.tShift.push(0);
  this.sCount.push(0);
  this.bsCount.push(0);

  this.lineMax = this.bMarks.length - 1; // don't count last fake line
}

// Push new token to "stream".
//
StateBlock.prototype.push = function (type, tag, nesting) {
  var token = new Token$1(type, tag, nesting);
  token.block = true;

  if (nesting < 0) this.level--; // closing tag
  token.level = this.level;
  if (nesting > 0) this.level++; // opening tag

  this.tokens.push(token);
  return token;
};

StateBlock.prototype.isEmpty = function isEmpty(line) {
  return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};

StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
  for (var max = this.lineMax; from < max; from++) {
    if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) {
      break;
    }
  }
  return from;
};

// Skip spaces from given position.
StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
  var ch;

  for (var max = this.src.length; pos < max; pos++) {
    ch = this.src.charCodeAt(pos);
    if (!isSpace$4(ch)) { break; }
  }
  return pos;
};

// Skip spaces from given position in reverse.
StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
  if (pos <= min) { return pos; }

  while (pos > min) {
    if (!isSpace$4(this.src.charCodeAt(--pos))) { return pos + 1; }
  }
  return pos;
};

// Skip char codes from given position
StateBlock.prototype.skipChars = function skipChars(pos, code) {
  for (var max = this.src.length; pos < max; pos++) {
    if (this.src.charCodeAt(pos) !== code) { break; }
  }
  return pos;
};

// Skip char codes reverse from given position - 1
StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
  if (pos <= min) { return pos; }

  while (pos > min) {
    if (code !== this.src.charCodeAt(--pos)) { return pos + 1; }
  }
  return pos;
};

// cut lines range from source.
StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
  var i, lineIndent, ch, first, last, queue, lineStart,
      line = begin;

  if (begin >= end) {
    return '';
  }

  queue = new Array(end - begin);

  for (i = 0; line < end; line++, i++) {
    lineIndent = 0;
    lineStart = first = this.bMarks[line];

    if (line + 1 < end || keepLastLF) {
      // No need for bounds check because we have fake entry on tail.
      last = this.eMarks[line] + 1;
    } else {
      last = this.eMarks[line];
    }

    while (first < last && lineIndent < indent) {
      ch = this.src.charCodeAt(first);

      if (isSpace$4(ch)) {
        if (ch === 0x09) {
          lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
        } else {
          lineIndent++;
        }
      } else if (first - lineStart < this.tShift[line]) {
        // patched tShift masked characters to look like spaces (blockquotes, list markers)
        lineIndent++;
      } else {
        break;
      }

      first++;
    }

    if (lineIndent > indent) {
      // partially expanding tabs in code blocks, e.g '\t\tfoobar'
      // with indent=2 becomes '  \tfoobar'
      queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
    } else {
      queue[i] = this.src.slice(first, last);
    }
  }

  return queue.join('');
};

// re-export Token class to use in block rules
StateBlock.prototype.Token = Token$1;


var state_block = StateBlock;

/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/


var Ruler$1           = ruler;


var _rules$1 = [
  // First 2 params - rule name & source. Secondary array - list of rules,
  // which can be terminated by this one.
  [ 'table',      table,      [ 'paragraph', 'reference' ] ],
  [ 'code',       code ],
  [ 'fence',      fence,      [ 'paragraph', 'reference', 'blockquote', 'list' ] ],
  [ 'blockquote', blockquote, [ 'paragraph', 'reference', 'blockquote', 'list' ] ],
  [ 'hr',         hr,         [ 'paragraph', 'reference', 'blockquote', 'list' ] ],
  [ 'list',       list,       [ 'paragraph', 'reference', 'blockquote' ] ],
  [ 'reference',  reference ],
  [ 'html_block', html_block, [ 'paragraph', 'reference', 'blockquote' ] ],
  [ 'heading',    heading,    [ 'paragraph', 'reference', 'blockquote' ] ],
  [ 'lheading',   lheading ],
  [ 'paragraph',  paragraph ]
];


/**
 * new ParserBlock()
 **/
function ParserBlock$1() {
  /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/
  this.ruler = new Ruler$1();

  for (var i = 0; i < _rules$1.length; i++) {
    this.ruler.push(_rules$1[i][0], _rules$1[i][1], { alt: (_rules$1[i][2] || []).slice() });
  }
}


// Generate tokens for input range
//
ParserBlock$1.prototype.tokenize = function (state, startLine, endLine) {
  var ok, i, prevLine,
      rules = this.ruler.getRules(''),
      len = rules.length,
      line = startLine,
      hasEmptyLines = false,
      maxNesting = state.md.options.maxNesting;

  while (line < endLine) {
    state.line = line = state.skipEmptyLines(line);
    if (line >= endLine) { break; }

    // Termination condition for nested calls.
    // Nested calls currently used for blockquotes & lists
    if (state.sCount[line] < state.blkIndent) { break; }

    // If nesting level exceeded - skip tail to the end. That's not ordinary
    // situation and we should not care about content.
    if (state.level >= maxNesting) {
      state.line = endLine;
      break;
    }

    // Try all possible rules.
    // On success, rule should:
    //
    // - update `state.line`
    // - update `state.tokens`
    // - return true
    prevLine = state.line;

    for (i = 0; i < len; i++) {
      ok = rules[i](state, line, endLine, false);
      if (ok) {
        if (prevLine >= state.line) {
          throw new Error("block rule didn't increment state.line");
        }
        break;
      }
    }

    // this can only happen if user disables paragraph rule
    if (!ok) throw new Error('none of the block rules matched');

    // set state.tight if we had an empty line before current tag
    // i.e. latest empty line should not count
    state.tight = !hasEmptyLines;

    // paragraph might "eat" one newline after it in nested lists
    if (state.isEmpty(state.line - 1)) {
      hasEmptyLines = true;
    }

    line = state.line;

    if (line < endLine && state.isEmpty(line)) {
      hasEmptyLines = true;
      line++;
      state.line = line;
    }
  }
};


/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/
ParserBlock$1.prototype.parse = function (src, md, env, outTokens) {
  var state;

  if (!src) { return; }

  state = new this.State(src, md, env, outTokens);

  this.tokenize(state, state.line, state.lineMax);
};


ParserBlock$1.prototype.State = state_block;


var parser_block = ParserBlock$1;

// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions

// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~

// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function isTerminatorChar(ch) {
  switch (ch) {
    case 0x0A/* \n */:
    case 0x21/* ! */:
    case 0x23/* # */:
    case 0x24/* $ */:
    case 0x25/* % */:
    case 0x26/* & */:
    case 0x2A/* * */:
    case 0x2B/* + */:
    case 0x2D/* - */:
    case 0x3A/* : */:
    case 0x3C/* < */:
    case 0x3D/* = */:
    case 0x3E/* > */:
    case 0x40/* @ */:
    case 0x5B/* [ */:
    case 0x5C/* \ */:
    case 0x5D/* ] */:
    case 0x5E/* ^ */:
    case 0x5F/* _ */:
    case 0x60/* ` */:
    case 0x7B/* { */:
    case 0x7D/* } */:
    case 0x7E/* ~ */:
      return true;
    default:
      return false;
  }
}

var text = function text(state, silent) {
  var pos = state.pos;

  while (pos < state.posMax && !isTerminatorChar(state.src.charCodeAt(pos))) {
    pos++;
  }

  if (pos === state.pos) { return false; }

  if (!silent) { state.pending += state.src.slice(state.pos, pos); }

  state.pos = pos;

  return true;
};

// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
var SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;


var linkify = function linkify(state, silent) {
  var pos, max, match, proto, link, url, fullUrl, token;

  if (!state.md.options.linkify) return false;
  if (state.linkLevel > 0) return false;

  pos = state.pos;
  max = state.posMax;

  if (pos + 3 > max) return false;
  if (state.src.charCodeAt(pos) !== 0x3A/* : */) return false;
  if (state.src.charCodeAt(pos + 1) !== 0x2F/* / */) return false;
  if (state.src.charCodeAt(pos + 2) !== 0x2F/* / */) return false;

  match = state.pending.match(SCHEME_RE);
  if (!match) return false;

  proto = match[1];

  link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
  if (!link) return false;

  url = link.url;

  // invalid link, but still detected by linkify somehow;
  // need to check to prevent infinite loop below
  if (url.length <= proto.length) return false;

  // disallow '*' at the end of the link (conflicts with emphasis)
  url = url.replace(/\*+$/, '');

  fullUrl = state.md.normalizeLink(url);
  if (!state.md.validateLink(fullUrl)) return false;

  if (!silent) {
    state.pending = state.pending.slice(0, -proto.length);

    token         = state.push('link_open', 'a', 1);
    token.attrs   = [ [ 'href', fullUrl ] ];
    token.markup  = 'linkify';
    token.info    = 'auto';

    token         = state.push('text', '', 0);
    token.content = state.md.normalizeLinkText(url);

    token         = state.push('link_close', 'a', -1);
    token.markup  = 'linkify';
    token.info    = 'auto';
  }

  state.pos += url.length - proto.length;
  return true;
};

var isSpace$3 = utils$1.isSpace;


var newline = function newline(state, silent) {
  var pmax, max, ws, pos = state.pos;

  if (state.src.charCodeAt(pos) !== 0x0A/* \n */) { return false; }

  pmax = state.pending.length - 1;
  max = state.posMax;

  // '  \n' -> hardbreak
  // Lookup in pending chars is bad practice! Don't copy to other rules!
  // Pending string is stored in concat mode, indexed lookups will cause
  // convertion to flat mode.
  if (!silent) {
    if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
      if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
        // Find whitespaces tail of pending chars.
        ws = pmax - 1;
        while (ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20) ws--;

        state.pending = state.pending.slice(0, ws);
        state.push('hardbreak', 'br', 0);
      } else {
        state.pending = state.pending.slice(0, -1);
        state.push('softbreak', 'br', 0);
      }

    } else {
      state.push('softbreak', 'br', 0);
    }
  }

  pos++;

  // skip heading spaces for next line
  while (pos < max && isSpace$3(state.src.charCodeAt(pos))) { pos++; }

  state.pos = pos;
  return true;
};

var isSpace$2 = utils$1.isSpace;

var ESCAPED = [];

for (var i = 0; i < 256; i++) { ESCAPED.push(0); }

'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'
  .split('').forEach(function (ch) { ESCAPED[ch.charCodeAt(0)] = 1; });


var _escape = function escape(state, silent) {
  var ch1, ch2, origStr, escapedStr, token, pos = state.pos, max = state.posMax;

  if (state.src.charCodeAt(pos) !== 0x5C/* \ */) return false;
  pos++;

  // '\' at the end of the inline block
  if (pos >= max) return false;

  ch1 = state.src.charCodeAt(pos);

  if (ch1 === 0x0A) {
    if (!silent) {
      state.push('hardbreak', 'br', 0);
    }

    pos++;
    // skip leading whitespaces from next line
    while (pos < max) {
      ch1 = state.src.charCodeAt(pos);
      if (!isSpace$2(ch1)) break;
      pos++;
    }

    state.pos = pos;
    return true;
  }

  escapedStr = state.src[pos];

  if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
    ch2 = state.src.charCodeAt(pos + 1);

    if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
      escapedStr += state.src[pos + 1];
      pos++;
    }
  }

  origStr = '\\' + escapedStr;

  if (!silent) {
    token = state.push('text_special', '', 0);

    if (ch1 < 256 && ESCAPED[ch1] !== 0) {
      token.content = escapedStr;
    } else {
      token.content = origStr;
    }

    token.markup = origStr;
    token.info   = 'escape';
  }

  state.pos = pos + 1;
  return true;
};

var backticks = function backtick(state, silent) {
  var start, max, marker, token, matchStart, matchEnd, openerLength, closerLength,
      pos = state.pos,
      ch = state.src.charCodeAt(pos);

  if (ch !== 0x60/* ` */) { return false; }

  start = pos;
  pos++;
  max = state.posMax;

  // scan marker length
  while (pos < max && state.src.charCodeAt(pos) === 0x60/* ` */) { pos++; }

  marker = state.src.slice(start, pos);
  openerLength = marker.length;

  if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
  }

  matchEnd = pos;

  // Nothing found in the cache, scan until the end of the line (or until marker is found)
  while ((matchStart = state.src.indexOf('`', matchEnd)) !== -1) {
    matchEnd = matchStart + 1;

    // scan marker length
    while (matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60/* ` */) { matchEnd++; }

    closerLength = matchEnd - matchStart;

    if (closerLength === openerLength) {
      // Found matching closer length.
      if (!silent) {
        token     = state.push('code_inline', 'code', 0);
        token.markup  = marker;
        token.content = state.src.slice(pos, matchStart)
          .replace(/\n/g, ' ')
          .replace(/^ (.+) $/, '$1');
      }
      state.pos = matchEnd;
      return true;
    }

    // Some different length found, put it in cache as upper limit of where closer can be found
    state.backticks[closerLength] = matchStart;
  }

  // Scanned through the end, didn't find anything
  state.backticksScanned = true;

  if (!silent) state.pending += marker;
  state.pos += openerLength;
  return true;
};

var strikethrough = {};

// Insert each marker as a separate text token, and add it to delimiter list
//
strikethrough.tokenize = function strikethrough(state, silent) {
  var i, scanned, token, len, ch,
      start = state.pos,
      marker = state.src.charCodeAt(start);

  if (silent) { return false; }

  if (marker !== 0x7E/* ~ */) { return false; }

  scanned = state.scanDelims(state.pos, true);
  len = scanned.length;
  ch = String.fromCharCode(marker);

  if (len < 2) { return false; }

  if (len % 2) {
    token         = state.push('text', '', 0);
    token.content = ch;
    len--;
  }

  for (i = 0; i < len; i += 2) {
    token         = state.push('text', '', 0);
    token.content = ch + ch;

    state.delimiters.push({
      marker: marker,
      length: 0,     // disable "rule of 3" length checks meant for emphasis
      token:  state.tokens.length - 1,
      end:    -1,
      open:   scanned.can_open,
      close:  scanned.can_close
    });
  }

  state.pos += scanned.length;

  return true;
};


function postProcess$1(state, delimiters) {
  var i, j,
      startDelim,
      endDelim,
      token,
      loneMarkers = [],
      max = delimiters.length;

  for (i = 0; i < max; i++) {
    startDelim = delimiters[i];

    if (startDelim.marker !== 0x7E/* ~ */) {
      continue;
    }

    if (startDelim.end === -1) {
      continue;
    }

    endDelim = delimiters[startDelim.end];

    token         = state.tokens[startDelim.token];
    token.type    = 's_open';
    token.tag     = 's';
    token.nesting = 1;
    token.markup  = '~~';
    token.content = '';

    token         = state.tokens[endDelim.token];
    token.type    = 's_close';
    token.tag     = 's';
    token.nesting = -1;
    token.markup  = '~~';
    token.content = '';

    if (state.tokens[endDelim.token - 1].type === 'text' &&
        state.tokens[endDelim.token - 1].content === '~') {

      loneMarkers.push(endDelim.token - 1);
    }
  }

  // If a marker sequence has an odd number of characters, it's splitted
  // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
  // start of the sequence.
  //
  // So, we have to move all those markers after subsequent s_close tags.
  //
  while (loneMarkers.length) {
    i = loneMarkers.pop();
    j = i + 1;

    while (j < state.tokens.length && state.tokens[j].type === 's_close') {
      j++;
    }

    j--;

    if (i !== j) {
      token = state.tokens[j];
      state.tokens[j] = state.tokens[i];
      state.tokens[i] = token;
    }
  }
}


// Walk through delimiter list and replace text tokens with tags
//
strikethrough.postProcess = function strikethrough(state) {
  var curr,
      tokens_meta = state.tokens_meta,
      max = state.tokens_meta.length;

  postProcess$1(state, state.delimiters);

  for (curr = 0; curr < max; curr++) {
    if (tokens_meta[curr] && tokens_meta[curr].delimiters) {
      postProcess$1(state, tokens_meta[curr].delimiters);
    }
  }
};

var emphasis = {};

// Insert each marker as a separate text token, and add it to delimiter list
//
emphasis.tokenize = function emphasis(state, silent) {
  var i, scanned, token,
      start = state.pos,
      marker = state.src.charCodeAt(start);

  if (silent) { return false; }

  if (marker !== 0x5F /* _ */ && marker !== 0x2A /* * */) { return false; }

  scanned = state.scanDelims(state.pos, marker === 0x2A);

  for (i = 0; i < scanned.length; i++) {
    token         = state.push('text', '', 0);
    token.content = String.fromCharCode(marker);

    state.delimiters.push({
      // Char code of the starting marker (number).
      //
      marker: marker,

      // Total length of these series of delimiters.
      //
      length: scanned.length,

      // A position of the token this delimiter corresponds to.
      //
      token:  state.tokens.length - 1,

      // If this delimiter is matched as a valid opener, `end` will be
      // equal to its position, otherwise it's `-1`.
      //
      end:    -1,

      // Boolean flags that determine if this delimiter could open or close
      // an emphasis.
      //
      open:   scanned.can_open,
      close:  scanned.can_close
    });
  }

  state.pos += scanned.length;

  return true;
};


function postProcess(state, delimiters) {
  var i,
      startDelim,
      endDelim,
      token,
      ch,
      isStrong,
      max = delimiters.length;

  for (i = max - 1; i >= 0; i--) {
    startDelim = delimiters[i];

    if (startDelim.marker !== 0x5F/* _ */ && startDelim.marker !== 0x2A/* * */) {
      continue;
    }

    // Process only opening markers
    if (startDelim.end === -1) {
      continue;
    }

    endDelim = delimiters[startDelim.end];

    // If the previous delimiter has the same marker and is adjacent to this one,
    // merge those into one strong delimiter.
    //
    // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
    //
    isStrong = i > 0 &&
               delimiters[i - 1].end === startDelim.end + 1 &&
               // check that first two markers match and adjacent
               delimiters[i - 1].marker === startDelim.marker &&
               delimiters[i - 1].token === startDelim.token - 1 &&
               // check that last two markers are adjacent (we can safely assume they match)
               delimiters[startDelim.end + 1].token === endDelim.token + 1;

    ch = String.fromCharCode(startDelim.marker);

    token         = state.tokens[startDelim.token];
    token.type    = isStrong ? 'strong_open' : 'em_open';
    token.tag     = isStrong ? 'strong' : 'em';
    token.nesting = 1;
    token.markup  = isStrong ? ch + ch : ch;
    token.content = '';

    token         = state.tokens[endDelim.token];
    token.type    = isStrong ? 'strong_close' : 'em_close';
    token.tag     = isStrong ? 'strong' : 'em';
    token.nesting = -1;
    token.markup  = isStrong ? ch + ch : ch;
    token.content = '';

    if (isStrong) {
      state.tokens[delimiters[i - 1].token].content = '';
      state.tokens[delimiters[startDelim.end + 1].token].content = '';
      i--;
    }
  }
}


// Walk through delimiter list and replace text tokens with tags
//
emphasis.postProcess = function emphasis(state) {
  var curr,
      tokens_meta = state.tokens_meta,
      max = state.tokens_meta.length;

  postProcess(state, state.delimiters);

  for (curr = 0; curr < max; curr++) {
    if (tokens_meta[curr] && tokens_meta[curr].delimiters) {
      postProcess(state, tokens_meta[curr].delimiters);
    }
  }
};

var normalizeReference$1   = utils$1.normalizeReference;
var isSpace$1              = utils$1.isSpace;


var link = function link(state, silent) {
  var attrs,
      code,
      label,
      labelEnd,
      labelStart,
      pos,
      res,
      ref,
      token,
      href = '',
      title = '',
      oldPos = state.pos,
      max = state.posMax,
      start = state.pos,
      parseReference = true;

  if (state.src.charCodeAt(state.pos) !== 0x5B/* [ */) { return false; }

  labelStart = state.pos + 1;
  labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);

  // parser failed to find ']', so it's not a valid link
  if (labelEnd < 0) { return false; }

  pos = labelEnd + 1;
  if (pos < max && state.src.charCodeAt(pos) === 0x28/* ( */) {
    //
    // Inline link
    //

    // might have found a valid shortcut link, disable reference parsing
    parseReference = false;

    // [link](  <href>  "title"  )
    //        ^^ skipping these spaces
    pos++;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (!isSpace$1(code) && code !== 0x0A) { break; }
    }
    if (pos >= max) { return false; }

    // [link](  <href>  "title"  )
    //          ^^^^^^ parsing link destination
    start = pos;
    res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
    if (res.ok) {
      href = state.md.normalizeLink(res.str);
      if (state.md.validateLink(href)) {
        pos = res.pos;
      } else {
        href = '';
      }

      // [link](  <href>  "title"  )
      //                ^^ skipping these spaces
      start = pos;
      for (; pos < max; pos++) {
        code = state.src.charCodeAt(pos);
        if (!isSpace$1(code) && code !== 0x0A) { break; }
      }

      // [link](  <href>  "title"  )
      //                  ^^^^^^^ parsing link title
      res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
      if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;

        // [link](  <href>  "title"  )
        //                         ^^ skipping these spaces
        for (; pos < max; pos++) {
          code = state.src.charCodeAt(pos);
          if (!isSpace$1(code) && code !== 0x0A) { break; }
        }
      }
    }

    if (pos >= max || state.src.charCodeAt(pos) !== 0x29/* ) */) {
      // parsing a valid shortcut link failed, fallback to reference
      parseReference = true;
    }
    pos++;
  }

  if (parseReference) {
    //
    // Link reference
    //
    if (typeof state.env.references === 'undefined') { return false; }

    if (pos < max && state.src.charCodeAt(pos) === 0x5B/* [ */) {
      start = pos + 1;
      pos = state.md.helpers.parseLinkLabel(state, pos);
      if (pos >= 0) {
        label = state.src.slice(start, pos++);
      } else {
        pos = labelEnd + 1;
      }
    } else {
      pos = labelEnd + 1;
    }

    // covers label === '' and label === undefined
    // (collapsed reference link and shortcut reference link respectively)
    if (!label) { label = state.src.slice(labelStart, labelEnd); }

    ref = state.env.references[normalizeReference$1(label)];
    if (!ref) {
      state.pos = oldPos;
      return false;
    }
    href = ref.href;
    title = ref.title;
  }

  //
  // We found the end of the link, and know for a fact it's a valid link;
  // so all that's left to do is to call tokenizer.
  //
  if (!silent) {
    state.pos = labelStart;
    state.posMax = labelEnd;

    token        = state.push('link_open', 'a', 1);
    token.attrs  = attrs = [ [ 'href', href ] ];
    if (title) {
      attrs.push([ 'title', title ]);
    }

    state.linkLevel++;
    state.md.inline.tokenize(state);
    state.linkLevel--;

    token        = state.push('link_close', 'a', -1);
  }

  state.pos = pos;
  state.posMax = max;
  return true;
};

var normalizeReference   = utils$1.normalizeReference;
var isSpace              = utils$1.isSpace;


var image = function image(state, silent) {
  var attrs,
      code,
      content,
      label,
      labelEnd,
      labelStart,
      pos,
      ref,
      res,
      title,
      token,
      tokens,
      start,
      href = '',
      oldPos = state.pos,
      max = state.posMax;

  if (state.src.charCodeAt(state.pos) !== 0x21/* ! */) { return false; }
  if (state.src.charCodeAt(state.pos + 1) !== 0x5B/* [ */) { return false; }

  labelStart = state.pos + 2;
  labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);

  // parser failed to find ']', so it's not a valid link
  if (labelEnd < 0) { return false; }

  pos = labelEnd + 1;
  if (pos < max && state.src.charCodeAt(pos) === 0x28/* ( */) {
    //
    // Inline link
    //

    // [link](  <href>  "title"  )
    //        ^^ skipping these spaces
    pos++;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (!isSpace(code) && code !== 0x0A) { break; }
    }
    if (pos >= max) { return false; }

    // [link](  <href>  "title"  )
    //          ^^^^^^ parsing link destination
    start = pos;
    res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
    if (res.ok) {
      href = state.md.normalizeLink(res.str);
      if (state.md.validateLink(href)) {
        pos = res.pos;
      } else {
        href = '';
      }
    }

    // [link](  <href>  "title"  )
    //                ^^ skipping these spaces
    start = pos;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (!isSpace(code) && code !== 0x0A) { break; }
    }

    // [link](  <href>  "title"  )
    //                  ^^^^^^^ parsing link title
    res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
    if (pos < max && start !== pos && res.ok) {
      title = res.str;
      pos = res.pos;

      // [link](  <href>  "title"  )
      //                         ^^ skipping these spaces
      for (; pos < max; pos++) {
        code = state.src.charCodeAt(pos);
        if (!isSpace(code) && code !== 0x0A) { break; }
      }
    } else {
      title = '';
    }

    if (pos >= max || state.src.charCodeAt(pos) !== 0x29/* ) */) {
      state.pos = oldPos;
      return false;
    }
    pos++;
  } else {
    //
    // Link reference
    //
    if (typeof state.env.references === 'undefined') { return false; }

    if (pos < max && state.src.charCodeAt(pos) === 0x5B/* [ */) {
      start = pos + 1;
      pos = state.md.helpers.parseLinkLabel(state, pos);
      if (pos >= 0) {
        label = state.src.slice(start, pos++);
      } else {
        pos = labelEnd + 1;
      }
    } else {
      pos = labelEnd + 1;
    }

    // covers label === '' and label === undefined
    // (collapsed reference link and shortcut reference link respectively)
    if (!label) { label = state.src.slice(labelStart, labelEnd); }

    ref = state.env.references[normalizeReference(label)];
    if (!ref) {
      state.pos = oldPos;
      return false;
    }
    href = ref.href;
    title = ref.title;
  }

  //
  // We found the end of the link, and know for a fact it's a valid link;
  // so all that's left to do is to call tokenizer.
  //
  if (!silent) {
    content = state.src.slice(labelStart, labelEnd);

    state.md.inline.parse(
      content,
      state.md,
      state.env,
      tokens = []
    );

    token          = state.push('image', 'img', 0);
    token.attrs    = attrs = [ [ 'src', href ], [ 'alt', '' ] ];
    token.children = tokens;
    token.content  = content;

    if (title) {
      attrs.push([ 'title', title ]);
    }
  }

  state.pos = pos;
  state.posMax = max;
  return true;
};

/*eslint max-len:0*/
var EMAIL_RE    = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
var AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;


var autolink = function autolink(state, silent) {
  var url, fullUrl, token, ch, start, max,
      pos = state.pos;

  if (state.src.charCodeAt(pos) !== 0x3C/* < */) { return false; }

  start = state.pos;
  max = state.posMax;

  for (;;) {
    if (++pos >= max) return false;

    ch = state.src.charCodeAt(pos);

    if (ch === 0x3C /* < */) return false;
    if (ch === 0x3E /* > */) break;
  }

  url = state.src.slice(start + 1, pos);

  if (AUTOLINK_RE.test(url)) {
    fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) { return false; }

    if (!silent) {
      token         = state.push('link_open', 'a', 1);
      token.attrs   = [ [ 'href', fullUrl ] ];
      token.markup  = 'autolink';
      token.info    = 'auto';

      token         = state.push('text', '', 0);
      token.content = state.md.normalizeLinkText(url);

      token         = state.push('link_close', 'a', -1);
      token.markup  = 'autolink';
      token.info    = 'auto';
    }

    state.pos += url.length + 2;
    return true;
  }

  if (EMAIL_RE.test(url)) {
    fullUrl = state.md.normalizeLink('mailto:' + url);
    if (!state.md.validateLink(fullUrl)) { return false; }

    if (!silent) {
      token         = state.push('link_open', 'a', 1);
      token.attrs   = [ [ 'href', fullUrl ] ];
      token.markup  = 'autolink';
      token.info    = 'auto';

      token         = state.push('text', '', 0);
      token.content = state.md.normalizeLinkText(url);

      token         = state.push('link_close', 'a', -1);
      token.markup  = 'autolink';
      token.info    = 'auto';
    }

    state.pos += url.length + 2;
    return true;
  }

  return false;
};

var HTML_TAG_RE = html_re.HTML_TAG_RE;


function isLinkOpen(str) {
  return /^<a[>\s]/i.test(str);
}
function isLinkClose(str) {
  return /^<\/a\s*>/i.test(str);
}


function isLetter(ch) {
  /*eslint no-bitwise:0*/
  var lc = ch | 0x20; // to lower case
  return (lc >= 0x61/* a */) && (lc <= 0x7a/* z */);
}


var html_inline = function html_inline(state, silent) {
  var ch, match, max, token,
      pos = state.pos;

  if (!state.md.options.html) { return false; }

  // Check start
  max = state.posMax;
  if (state.src.charCodeAt(pos) !== 0x3C/* < */ ||
      pos + 2 >= max) {
    return false;
  }

  // Quick fail on second char
  ch = state.src.charCodeAt(pos + 1);
  if (ch !== 0x21/* ! */ &&
      ch !== 0x3F/* ? */ &&
      ch !== 0x2F/* / */ &&
      !isLetter(ch)) {
    return false;
  }

  match = state.src.slice(pos).match(HTML_TAG_RE);
  if (!match) { return false; }

  if (!silent) {
    token         = state.push('html_inline', '', 0);
    token.content = match[0];

    if (isLinkOpen(token.content))  state.linkLevel++;
    if (isLinkClose(token.content)) state.linkLevel--;
  }
  state.pos += match[0].length;
  return true;
};

var entities          = entities$1;
var has               = utils$1.has;
var isValidEntityCode = utils$1.isValidEntityCode;
var fromCodePoint     = utils$1.fromCodePoint;


var DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var NAMED_RE   = /^&([a-z][a-z0-9]{1,31});/i;


var entity = function entity(state, silent) {
  var ch, code, match, token, pos = state.pos, max = state.posMax;

  if (state.src.charCodeAt(pos) !== 0x26/* & */) return false;

  if (pos + 1 >= max) return false;

  ch = state.src.charCodeAt(pos + 1);

  if (ch === 0x23 /* # */) {
    match = state.src.slice(pos).match(DIGITAL_RE);
    if (match) {
      if (!silent) {
        code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);

        token         = state.push('text_special', '', 0);
        token.content = isValidEntityCode(code) ? fromCodePoint(code) : fromCodePoint(0xFFFD);
        token.markup  = match[0];
        token.info    = 'entity';
      }
      state.pos += match[0].length;
      return true;
    }
  } else {
    match = state.src.slice(pos).match(NAMED_RE);
    if (match) {
      if (has(entities, match[1])) {
        if (!silent) {
          token         = state.push('text_special', '', 0);
          token.content = entities[match[1]];
          token.markup  = match[0];
          token.info    = 'entity';
        }
        state.pos += match[0].length;
        return true;
      }
    }
  }

  return false;
};

function processDelimiters(delimiters) {
  var closerIdx, openerIdx, closer, opener, minOpenerIdx, newMinOpenerIdx,
      isOddMatch, lastJump,
      openersBottom = {},
      max = delimiters.length;

  if (!max) return;

  // headerIdx is the first delimiter of the current (where closer is) delimiter run
  var headerIdx = 0;
  var lastTokenIdx = -2; // needs any value lower than -1
  var jumps = [];

  for (closerIdx = 0; closerIdx < max; closerIdx++) {
    closer = delimiters[closerIdx];

    jumps.push(0);

    // markers belong to same delimiter run if:
    //  - they have adjacent tokens
    //  - AND markers are the same
    //
    if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) {
      headerIdx = closerIdx;
    }

    lastTokenIdx = closer.token;

    // Length is only used for emphasis-specific "rule of 3",
    // if it's not defined (in strikethrough or 3rd party plugins),
    // we can default it to 0 to disable those checks.
    //
    closer.length = closer.length || 0;

    if (!closer.close) continue;

    // Previously calculated lower bounds (previous fails)
    // for each marker, each delimiter length modulo 3,
    // and for whether this closer can be an opener;
    // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
    if (!openersBottom.hasOwnProperty(closer.marker)) {
      openersBottom[closer.marker] = [ -1, -1, -1, -1, -1, -1 ];
    }

    minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length % 3)];

    openerIdx = headerIdx - jumps[headerIdx] - 1;

    newMinOpenerIdx = openerIdx;

    for (; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1) {
      opener = delimiters[openerIdx];

      if (opener.marker !== closer.marker) continue;

      if (opener.open && opener.end < 0) {

        isOddMatch = false;

        // from spec:
        //
        // If one of the delimiters can both open and close emphasis, then the
        // sum of the lengths of the delimiter runs containing the opening and
        // closing delimiters must not be a multiple of 3 unless both lengths
        // are multiples of 3.
        //
        if (opener.close || closer.open) {
          if ((opener.length + closer.length) % 3 === 0) {
            if (opener.length % 3 !== 0 || closer.length % 3 !== 0) {
              isOddMatch = true;
            }
          }
        }

        if (!isOddMatch) {
          // If previous delimiter cannot be an opener, we can safely skip
          // the entire sequence in future checks. This is required to make
          // sure algorithm has linear complexity (see *_*_*_*_*_... case).
          //
          lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ?
            jumps[openerIdx - 1] + 1 :
            0;

          jumps[closerIdx] = closerIdx - openerIdx + lastJump;
          jumps[openerIdx] = lastJump;

          closer.open  = false;
          opener.end   = closerIdx;
          opener.close = false;
          newMinOpenerIdx = -1;
          // treat next token as start of run,
          // it optimizes skips in **<...>**a**<...>** pathological case
          lastTokenIdx = -2;
          break;
        }
      }
    }

    if (newMinOpenerIdx !== -1) {
      // If match for this delimiter run failed, we want to set lower bound for
      // future lookups. This is required to make sure algorithm has linear
      // complexity.
      //
      // See details here:
      // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
      //
      openersBottom[closer.marker][(closer.open ? 3 : 0) + ((closer.length || 0) % 3)] = newMinOpenerIdx;
    }
  }
}


var balance_pairs = function link_pairs(state) {
  var curr,
      tokens_meta = state.tokens_meta,
      max = state.tokens_meta.length;

  processDelimiters(state.delimiters);

  for (curr = 0; curr < max; curr++) {
    if (tokens_meta[curr] && tokens_meta[curr].delimiters) {
      processDelimiters(tokens_meta[curr].delimiters);
    }
  }
};

var fragments_join = function fragments_join(state) {
  var curr, last,
      level = 0,
      tokens = state.tokens,
      max = state.tokens.length;

  for (curr = last = 0; curr < max; curr++) {
    // re-calculate levels after emphasis/strikethrough turns some text nodes
    // into opening/closing tags
    if (tokens[curr].nesting < 0) level--; // closing tag
    tokens[curr].level = level;
    if (tokens[curr].nesting > 0) level++; // opening tag

    if (tokens[curr].type === 'text' &&
        curr + 1 < max &&
        tokens[curr + 1].type === 'text') {

      // collapse two adjacent text nodes
      tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
    } else {
      if (curr !== last) { tokens[last] = tokens[curr]; }

      last++;
    }
  }

  if (curr !== last) {
    tokens.length = last;
  }
};

var Token          = token;
var isWhiteSpace   = utils$1.isWhiteSpace;
var isPunctChar    = utils$1.isPunctChar;
var isMdAsciiPunct = utils$1.isMdAsciiPunct;


function StateInline(src, md, env, outTokens) {
  this.src = src;
  this.env = env;
  this.md = md;
  this.tokens = outTokens;
  this.tokens_meta = Array(outTokens.length);

  this.pos = 0;
  this.posMax = this.src.length;
  this.level = 0;
  this.pending = '';
  this.pendingLevel = 0;

  // Stores { start: end } pairs. Useful for backtrack
  // optimization of pairs parse (emphasis, strikes).
  this.cache = {};

  // List of emphasis-like delimiters for current tag
  this.delimiters = [];

  // Stack of delimiter lists for upper level tags
  this._prev_delimiters = [];

  // backtick length => last seen position
  this.backticks = {};
  this.backticksScanned = false;

  // Counter used to disable inline linkify-it execution
  // inside <a> and markdown links
  this.linkLevel = 0;
}


// Flush pending text
//
StateInline.prototype.pushPending = function () {
  var token = new Token('text', '', 0);
  token.content = this.pending;
  token.level = this.pendingLevel;
  this.tokens.push(token);
  this.pending = '';
  return token;
};


// Push new token to "stream".
// If pending text exists - flush it as text token
//
StateInline.prototype.push = function (type, tag, nesting) {
  if (this.pending) {
    this.pushPending();
  }

  var token = new Token(type, tag, nesting);
  var token_meta = null;

  if (nesting < 0) {
    // closing tag
    this.level--;
    this.delimiters = this._prev_delimiters.pop();
  }

  token.level = this.level;

  if (nesting > 0) {
    // opening tag
    this.level++;
    this._prev_delimiters.push(this.delimiters);
    this.delimiters = [];
    token_meta = { delimiters: this.delimiters };
  }

  this.pendingLevel = this.level;
  this.tokens.push(token);
  this.tokens_meta.push(token_meta);
  return token;
};


// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
StateInline.prototype.scanDelims = function (start, canSplitWord) {
  var pos = start, lastChar, nextChar, count, can_open, can_close,
      isLastWhiteSpace, isLastPunctChar,
      isNextWhiteSpace, isNextPunctChar,
      left_flanking = true,
      right_flanking = true,
      max = this.posMax,
      marker = this.src.charCodeAt(start);

  // treat beginning of the line as a whitespace
  lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;

  while (pos < max && this.src.charCodeAt(pos) === marker) { pos++; }

  count = pos - start;

  // treat end of the line as a whitespace
  nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;

  isLastPunctChar = isMdAsciiPunct(lastChar) || isPunctChar(String.fromCharCode(lastChar));
  isNextPunctChar = isMdAsciiPunct(nextChar) || isPunctChar(String.fromCharCode(nextChar));

  isLastWhiteSpace = isWhiteSpace(lastChar);
  isNextWhiteSpace = isWhiteSpace(nextChar);

  if (isNextWhiteSpace) {
    left_flanking = false;
  } else if (isNextPunctChar) {
    if (!(isLastWhiteSpace || isLastPunctChar)) {
      left_flanking = false;
    }
  }

  if (isLastWhiteSpace) {
    right_flanking = false;
  } else if (isLastPunctChar) {
    if (!(isNextWhiteSpace || isNextPunctChar)) {
      right_flanking = false;
    }
  }

  if (!canSplitWord) {
    can_open  = left_flanking  && (!right_flanking || isLastPunctChar);
    can_close = right_flanking && (!left_flanking  || isNextPunctChar);
  } else {
    can_open  = left_flanking;
    can_close = right_flanking;
  }

  return {
    can_open:  can_open,
    can_close: can_close,
    length:    count
  };
};


// re-export Token class to use in block rules
StateInline.prototype.Token = Token;


var state_inline = StateInline;

/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/


var Ruler           = ruler;


////////////////////////////////////////////////////////////////////////////////
// Parser rules

var _rules = [
  [ 'text',            text ],
  [ 'linkify',         linkify ],
  [ 'newline',         newline ],
  [ 'escape',          _escape ],
  [ 'backticks',       backticks ],
  [ 'strikethrough',   strikethrough.tokenize ],
  [ 'emphasis',        emphasis.tokenize ],
  [ 'link',            link ],
  [ 'image',           image ],
  [ 'autolink',        autolink ],
  [ 'html_inline',     html_inline ],
  [ 'entity',          entity ]
];

// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
var _rules2 = [
  [ 'balance_pairs',   balance_pairs ],
  [ 'strikethrough',   strikethrough.postProcess ],
  [ 'emphasis',        emphasis.postProcess ],
  // rules for pairs separate '**' into its own text tokens, which may be left unused,
  // rule below merges unused segments back with the rest of the text
  [ 'fragments_join',  fragments_join ]
];


/**
 * new ParserInline()
 **/
function ParserInline$1() {
  var i;

  /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/
  this.ruler = new Ruler();

  for (i = 0; i < _rules.length; i++) {
    this.ruler.push(_rules[i][0], _rules[i][1]);
  }

  /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/
  this.ruler2 = new Ruler();

  for (i = 0; i < _rules2.length; i++) {
    this.ruler2.push(_rules2[i][0], _rules2[i][1]);
  }
}


// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
ParserInline$1.prototype.skipToken = function (state) {
  var ok, i, pos = state.pos,
      rules = this.ruler.getRules(''),
      len = rules.length,
      maxNesting = state.md.options.maxNesting,
      cache = state.cache;


  if (typeof cache[pos] !== 'undefined') {
    state.pos = cache[pos];
    return;
  }

  if (state.level < maxNesting) {
    for (i = 0; i < len; i++) {
      // Increment state.level and decrement it later to limit recursion.
      // It's harmless to do here, because no tokens are created. But ideally,
      // we'd need a separate private state variable for this purpose.
      //
      state.level++;
      ok = rules[i](state, true);
      state.level--;

      if (ok) {
        if (pos >= state.pos) { throw new Error("inline rule didn't increment state.pos"); }
        break;
      }
    }
  } else {
    // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
  }

  if (!ok) { state.pos++; }
  cache[pos] = state.pos;
};


// Generate tokens for input range
//
ParserInline$1.prototype.tokenize = function (state) {
  var ok, i, prevPos,
      rules = this.ruler.getRules(''),
      len = rules.length,
      end = state.posMax,
      maxNesting = state.md.options.maxNesting;

  while (state.pos < end) {
    // Try all possible rules.
    // On success, rule should:
    //
    // - update `state.pos`
    // - update `state.tokens`
    // - return true
    prevPos = state.pos;

    if (state.level < maxNesting) {
      for (i = 0; i < len; i++) {
        ok = rules[i](state, false);
        if (ok) {
          if (prevPos >= state.pos) { throw new Error("inline rule didn't increment state.pos"); }
          break;
        }
      }
    }

    if (ok) {
      if (state.pos >= end) { break; }
      continue;
    }

    state.pending += state.src[state.pos++];
  }

  if (state.pending) {
    state.pushPending();
  }
};


/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/
ParserInline$1.prototype.parse = function (str, md, env, outTokens) {
  var i, rules, len;
  var state = new this.State(str, md, env, outTokens);

  this.tokenize(state);

  rules = this.ruler2.getRules('');
  len = rules.length;

  for (i = 0; i < len; i++) {
    rules[i](state);
  }
};


ParserInline$1.prototype.State = state_inline;


var parser_inline = ParserInline$1;

var re = function (opts) {
  var re = {};
  opts = opts || {};

  // Use direct extract instead of `regenerate` to reduse browserified size
  re.src_Any = regex$3.source;
  re.src_Cc  = regex$2.source;
  re.src_Z   = regex.source;
  re.src_P   = regex$4.source;

  // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
  re.src_ZPCc = [ re.src_Z, re.src_P, re.src_Cc ].join('|');

  // \p{\Z\Cc} (white spaces + control)
  re.src_ZCc = [ re.src_Z, re.src_Cc ].join('|');

  // Experimental. List of chars, completely prohibited in links
  // because can separate it from other part of text
  var text_separators = '[><\uff5c]';

  // All possible word characters (everything without punctuation, spaces & controls)
  // Defined via punctuation & spaces to save space
  // Should be something like \p{\L\N\S\M} (\w but without `_`)
  re.src_pseudo_letter       = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
  // The same as abothe but without [0-9]
  // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';

  ////////////////////////////////////////////////////////////////////////////////

  re.src_ip4 =

    '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';

  // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
  re.src_auth    = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';

  re.src_port =

    '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';

  re.src_host_terminator =

    '(?=$|' + text_separators + '|' + re.src_ZPCc + ')' +
    '(?!' + (opts['---'] ? '-(?!--)|' : '-|') + '_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';

  re.src_path =

    '(?:' +
      '[/?#]' +
        '(?:' +
          '(?!' + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' +
          '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' +
          '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' +
          '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' +
          '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' +
          "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" +
          "\\'(?=" + re.src_pseudo_letter + '|[-])|' +  // allow `I'm_king` if no pair found
          '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
                                     // github has ... in commit range links,
                                     // Restrict to
                                     // - english
                                     // - percent-encoded
                                     // - parts of file path
                                     // - params separator
                                     // until more examples found.
          '\\.(?!' + re.src_ZCc + '|[.]|$)|' +
          (opts['---'] ?
            '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
            :
            '\\-+|'
          ) +
          ',(?!' + re.src_ZCc + '|$)|' +       // allow `,,,` in paths
          ';(?!' + re.src_ZCc + '|$)|' +       // allow `;` if not followed by space-like char
          '\\!+(?!' + re.src_ZCc + '|[!]|$)|' +  // allow `!!!` in paths, but not at the end
          '\\?(?!' + re.src_ZCc + '|[?]|$)' +
        ')+' +
      '|\\/' +
    ')?';

  // Allow anything in markdown spec, forbid quote (") at the first position
  // because emails enclosed in quotes are far more common
  re.src_email_name =

    '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';

  re.src_xn =

    'xn--[a-z0-9\\-]{1,59}';

  // More to read about domain names
  // http://serverfault.com/questions/638260/

  re.src_domain_root =

    // Allow letters & digits (http://test1)
    '(?:' +
      re.src_xn +
      '|' +
      re.src_pseudo_letter + '{1,63}' +
    ')';

  re.src_domain =

    '(?:' +
      re.src_xn +
      '|' +
      '(?:' + re.src_pseudo_letter + ')' +
      '|' +
      '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' +
    ')';

  re.src_host =

    '(?:' +
    // Don't need IP check, because digits are already allowed in normal domain names
    //   src_ip4 +
    // '|' +
      '(?:(?:(?:' + re.src_domain + ')\\.)*' + re.src_domain/*_root*/ + ')' +
    ')';

  re.tpl_host_fuzzy =

    '(?:' +
      re.src_ip4 +
    '|' +
      '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' +
    ')';

  re.tpl_host_no_ip_fuzzy =

    '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';

  re.src_host_strict =

    re.src_host + re.src_host_terminator;

  re.tpl_host_fuzzy_strict =

    re.tpl_host_fuzzy + re.src_host_terminator;

  re.src_host_port_strict =

    re.src_host + re.src_port + re.src_host_terminator;

  re.tpl_host_port_fuzzy_strict =

    re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;

  re.tpl_host_port_no_ip_fuzzy_strict =

    re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;


  ////////////////////////////////////////////////////////////////////////////////
  // Main rules

  // Rude test fuzzy links by host, for quick deny
  re.tpl_host_fuzzy_test =

    'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';

  re.tpl_email_fuzzy =

      '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' +
      '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';

  re.tpl_link_fuzzy =
      // Fuzzy link can't be prepended with .:/\- and non punctuation.
      // but can start with > (markdown blockquote)
      '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' +
      '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';

  re.tpl_link_no_ip_fuzzy =
      // Fuzzy link can't be prepended with .:/\- and non punctuation.
      // but can start with > (markdown blockquote)
      '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' +
      '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';

  return re;
};

////////////////////////////////////////////////////////////////////////////////
// Helpers

// Merge objects
//
function assign(obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);

  sources.forEach(function (source) {
    if (!source) { return; }

    Object.keys(source).forEach(function (key) {
      obj[key] = source[key];
    });
  });

  return obj;
}

function _class(obj) { return Object.prototype.toString.call(obj); }
function isString$1(obj) { return _class(obj) === '[object String]'; }
function isObject(obj) { return _class(obj) === '[object Object]'; }
function isRegExp(obj) { return _class(obj) === '[object RegExp]'; }
function isFunction(obj) { return _class(obj) === '[object Function]'; }


function escapeRE(str) { return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&'); }

////////////////////////////////////////////////////////////////////////////////


var defaultOptions = {
  fuzzyLink: true,
  fuzzyEmail: true,
  fuzzyIP: false
};


function isOptionsObj(obj) {
  return Object.keys(obj || {}).reduce(function (acc, k) {
    return acc || defaultOptions.hasOwnProperty(k);
  }, false);
}


var defaultSchemas = {
  'http:': {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.http) {
        // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.http =  new RegExp(
          '^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i'
        );
      }
      if (self.re.http.test(tail)) {
        return tail.match(self.re.http)[0].length;
      }
      return 0;
    }
  },
  'https:':  'http:',
  'ftp:':    'http:',
  '//':      {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.no_http) {
      // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.no_http =  new RegExp(
          '^' +
          self.re.src_auth +
          // Don't allow single-level domains, because of false positives like '//test'
          // with code comments
          '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' +
          self.re.src_port +
          self.re.src_host_terminator +
          self.re.src_path,

          'i'
        );
      }

      if (self.re.no_http.test(tail)) {
        // should not be `://` & `///`, that protects from errors in protocol name
        if (pos >= 3 && text[pos - 3] === ':') { return 0; }
        if (pos >= 3 && text[pos - 3] === '/') { return 0; }
        return tail.match(self.re.no_http)[0].length;
      }
      return 0;
    }
  },
  'mailto:': {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.mailto) {
        self.re.mailto =  new RegExp(
          '^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i'
        );
      }
      if (self.re.mailto.test(tail)) {
        return tail.match(self.re.mailto)[0].length;
      }
      return 0;
    }
  }
};

/*eslint-disable max-len*/

// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';

// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var tlds_default = 'biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф'.split('|');

/*eslint-enable max-len*/

////////////////////////////////////////////////////////////////////////////////

function resetScanCache(self) {
  self.__index__ = -1;
  self.__text_cache__   = '';
}

function createValidator(re) {
  return function (text, pos) {
    var tail = text.slice(pos);

    if (re.test(tail)) {
      return tail.match(re)[0].length;
    }
    return 0;
  };
}

function createNormalizer() {
  return function (match, self) {
    self.normalize(match);
  };
}

// Schemas compiler. Build regexps.
//
function compile(self) {

  // Load & clone RE patterns.
  var re$1 = self.re = re(self.__opts__);

  // Define dynamic patterns
  var tlds = self.__tlds__.slice();

  self.onCompile();

  if (!self.__tlds_replaced__) {
    tlds.push(tlds_2ch_src_re);
  }
  tlds.push(re$1.src_xn);

  re$1.src_tlds = tlds.join('|');

  function untpl(tpl) { return tpl.replace('%TLDS%', re$1.src_tlds); }

  re$1.email_fuzzy      = RegExp(untpl(re$1.tpl_email_fuzzy), 'i');
  re$1.link_fuzzy       = RegExp(untpl(re$1.tpl_link_fuzzy), 'i');
  re$1.link_no_ip_fuzzy = RegExp(untpl(re$1.tpl_link_no_ip_fuzzy), 'i');
  re$1.host_fuzzy_test  = RegExp(untpl(re$1.tpl_host_fuzzy_test), 'i');

  //
  // Compile each schema
  //

  var aliases = [];

  self.__compiled__ = {}; // Reset compiled data

  function schemaError(name, val) {
    throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
  }

  Object.keys(self.__schemas__).forEach(function (name) {
    var val = self.__schemas__[name];

    // skip disabled methods
    if (val === null) { return; }

    var compiled = { validate: null, link: null };

    self.__compiled__[name] = compiled;

    if (isObject(val)) {
      if (isRegExp(val.validate)) {
        compiled.validate = createValidator(val.validate);
      } else if (isFunction(val.validate)) {
        compiled.validate = val.validate;
      } else {
        schemaError(name, val);
      }

      if (isFunction(val.normalize)) {
        compiled.normalize = val.normalize;
      } else if (!val.normalize) {
        compiled.normalize = createNormalizer();
      } else {
        schemaError(name, val);
      }

      return;
    }

    if (isString$1(val)) {
      aliases.push(name);
      return;
    }

    schemaError(name, val);
  });

  //
  // Compile postponed aliases
  //

  aliases.forEach(function (alias) {
    if (!self.__compiled__[self.__schemas__[alias]]) {
      // Silently fail on missed schemas to avoid errons on disable.
      // schemaError(alias, self.__schemas__[alias]);
      return;
    }

    self.__compiled__[alias].validate =
      self.__compiled__[self.__schemas__[alias]].validate;
    self.__compiled__[alias].normalize =
      self.__compiled__[self.__schemas__[alias]].normalize;
  });

  //
  // Fake record for guessed links
  //
  self.__compiled__[''] = { validate: null, normalize: createNormalizer() };

  //
  // Build schema condition
  //
  var slist = Object.keys(self.__compiled__)
                      .filter(function (name) {
                        // Filter disabled & fake schemas
                        return name.length > 0 && self.__compiled__[name];
                      })
                      .map(escapeRE)
                      .join('|');
  // (?!_) cause 1.5x slowdown
  self.re.schema_test     = RegExp('(^|(?!_)(?:[><\uff5c]|' + re$1.src_ZPCc + '))(' + slist + ')', 'i');
  self.re.schema_search   = RegExp('(^|(?!_)(?:[><\uff5c]|' + re$1.src_ZPCc + '))(' + slist + ')', 'ig');
  self.re.schema_at_start = RegExp('^' + self.re.schema_search.source, 'i');

  self.re.pretest = RegExp(
    '(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@',
    'i'
  );

  //
  // Cleanup
  //

  resetScanCache(self);
}

/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/
function Match(self, shift) {
  var start = self.__index__,
      end   = self.__last_index__,
      text  = self.__text_cache__.slice(start, end);

  /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/
  this.schema    = self.__schema__.toLowerCase();
  /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/
  this.index     = start + shift;
  /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/
  this.lastIndex = end + shift;
  /**
   * Match#raw -> String
   *
   * Matched string.
   **/
  this.raw       = text;
  /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/
  this.text      = text;
  /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/
  this.url       = text;
}

function createMatch(self, shift) {
  var match = new Match(self, shift);

  self.__compiled__[match.schema].normalize(match, self);

  return match;
}


/**
 * class LinkifyIt
 **/

/**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/
function LinkifyIt$1(schemas, options) {
  if (!(this instanceof LinkifyIt$1)) {
    return new LinkifyIt$1(schemas, options);
  }

  if (!options) {
    if (isOptionsObj(schemas)) {
      options = schemas;
      schemas = {};
    }
  }

  this.__opts__           = assign({}, defaultOptions, options);

  // Cache last tested result. Used to skip repeating steps on next `match` call.
  this.__index__          = -1;
  this.__last_index__     = -1; // Next scan position
  this.__schema__         = '';
  this.__text_cache__     = '';

  this.__schemas__        = assign({}, defaultSchemas, schemas);
  this.__compiled__       = {};

  this.__tlds__           = tlds_default;
  this.__tlds_replaced__  = false;

  this.re = {};

  compile(this);
}


/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/
LinkifyIt$1.prototype.add = function add(schema, definition) {
  this.__schemas__[schema] = definition;
  compile(this);
  return this;
};


/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/
LinkifyIt$1.prototype.set = function set(options) {
  this.__opts__ = assign(this.__opts__, options);
  return this;
};


/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/
LinkifyIt$1.prototype.test = function test(text) {
  // Reset scan cache
  this.__text_cache__ = text;
  this.__index__      = -1;

  if (!text.length) { return false; }

  var m, ml, me, len, shift, next, re, tld_pos, at_pos;

  // try to scan for link with schema - that's the most simple rule
  if (this.re.schema_test.test(text)) {
    re = this.re.schema_search;
    re.lastIndex = 0;
    while ((m = re.exec(text)) !== null) {
      len = this.testSchemaAt(text, m[2], re.lastIndex);
      if (len) {
        this.__schema__     = m[2];
        this.__index__      = m.index + m[1].length;
        this.__last_index__ = m.index + m[0].length + len;
        break;
      }
    }
  }

  if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
    // guess schemaless links
    tld_pos = text.search(this.re.host_fuzzy_test);
    if (tld_pos >= 0) {
      // if tld is located after found link - no need to check fuzzy pattern
      if (this.__index__ < 0 || tld_pos < this.__index__) {
        if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {

          shift = ml.index + ml[1].length;

          if (this.__index__ < 0 || shift < this.__index__) {
            this.__schema__     = '';
            this.__index__      = shift;
            this.__last_index__ = ml.index + ml[0].length;
          }
        }
      }
    }
  }

  if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
    // guess schemaless emails
    at_pos = text.indexOf('@');
    if (at_pos >= 0) {
      // We can't skip this check, because this cases are possible:
      // 192.168.1.1@gmail.com, my.in@example.com
      if ((me = text.match(this.re.email_fuzzy)) !== null) {

        shift = me.index + me[1].length;
        next  = me.index + me[0].length;

        if (this.__index__ < 0 || shift < this.__index__ ||
            (shift === this.__index__ && next > this.__last_index__)) {
          this.__schema__     = 'mailto:';
          this.__index__      = shift;
          this.__last_index__ = next;
        }
      }
    }
  }

  return this.__index__ >= 0;
};


/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/
LinkifyIt$1.prototype.pretest = function pretest(text) {
  return this.re.pretest.test(text);
};


/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/
LinkifyIt$1.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
  // If not supported schema check requested - terminate
  if (!this.__compiled__[schema.toLowerCase()]) {
    return 0;
  }
  return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};


/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/
LinkifyIt$1.prototype.match = function match(text) {
  var shift = 0, result = [];

  // Try to take previous element from cache, if .test() called before
  if (this.__index__ >= 0 && this.__text_cache__ === text) {
    result.push(createMatch(this, shift));
    shift = this.__last_index__;
  }

  // Cut head if cache was used
  var tail = shift ? text.slice(shift) : text;

  // Scan string until end reached
  while (this.test(tail)) {
    result.push(createMatch(this, shift));

    tail = tail.slice(this.__last_index__);
    shift += this.__last_index__;
  }

  if (result.length) {
    return result;
  }

  return null;
};


/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/
LinkifyIt$1.prototype.matchAtStart = function matchAtStart(text) {
  // Reset scan cache
  this.__text_cache__ = text;
  this.__index__      = -1;

  if (!text.length) return null;

  var m = this.re.schema_at_start.exec(text);
  if (!m) return null;

  var len = this.testSchemaAt(text, m[2], m[0].length);
  if (!len) return null;

  this.__schema__     = m[2];
  this.__index__      = m.index + m[1].length;
  this.__last_index__ = m.index + m[0].length + len;

  return createMatch(this, 0);
};


/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/
LinkifyIt$1.prototype.tlds = function tlds(list, keepOld) {
  list = Array.isArray(list) ? list : [ list ];

  if (!keepOld) {
    this.__tlds__ = list.slice();
    this.__tlds_replaced__ = true;
    compile(this);
    return this;
  }

  this.__tlds__ = this.__tlds__.concat(list)
                                  .sort()
                                  .filter(function (el, idx, arr) {
                                    return el !== arr[idx - 1];
                                  })
                                  .reverse();

  compile(this);
  return this;
};

/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/
LinkifyIt$1.prototype.normalize = function normalize(match) {

  // Do minimal possible changes by default. Need to collect feedback prior
  // to move forward https://github.com/markdown-it/linkify-it/issues/1

  if (!match.schema) { match.url = 'http://' + match.url; }

  if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) {
    match.url = 'mailto:' + match.url;
  }
};


/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/
LinkifyIt$1.prototype.onCompile = function onCompile() {
};


var linkifyIt = LinkifyIt$1;

/** Highest positive signed 32-bit float value */
const maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1

/** Bootstring parameters */
const base = 36;
const tMin = 1;
const tMax = 26;
const skew = 38;
const damp = 700;
const initialBias = 72;
const initialN = 128; // 0x80
const delimiter = '-'; // '\x2D'

/** Regular expressions */
const regexPunycode = /^xn--/;
const regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators

/** Error messages */
const errors = {
	'overflow': 'Overflow: input needs wider integers to process',
	'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
	'invalid-input': 'Invalid input'
};

/** Convenience shortcuts */
const baseMinusTMin = base - tMin;
const floor = Math.floor;
const stringFromCharCode = String.fromCharCode;

/*--------------------------------------------------------------------------*/

/**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */
function error$c(type) {
	throw new RangeError(errors[type]);
}

/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */
function map(array, callback) {
	const result = [];
	let length = array.length;
	while (length--) {
		result[length] = callback(array[length]);
	}
	return result;
}

/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */
function mapDomain(domain, callback) {
	const parts = domain.split('@');
	let result = '';
	if (parts.length > 1) {
		// In email addresses, only the domain name should be punycoded. Leave
		// the local part (i.e. everything up to `@`) intact.
		result = parts[0] + '@';
		domain = parts[1];
	}
	// Avoid `split(regex)` for IE8 compatibility. See #17.
	domain = domain.replace(regexSeparators, '\x2E');
	const labels = domain.split('.');
	const encoded = map(labels, callback).join('.');
	return result + encoded;
}

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */
function ucs2decode(string) {
	const output = [];
	let counter = 0;
	const length = string.length;
	while (counter < length) {
		const value = string.charCodeAt(counter++);
		if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
			// It's a high surrogate, and there is a next character.
			const extra = string.charCodeAt(counter++);
			if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
				output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
			} else {
				// It's an unmatched surrogate; only append this code unit, in case the
				// next code unit is the high surrogate of a surrogate pair.
				output.push(value);
				counter--;
			}
		} else {
			output.push(value);
		}
	}
	return output;
}

/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */
const ucs2encode = codePoints => String.fromCodePoint(...codePoints);

/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */
const basicToDigit = function(codePoint) {
	if (codePoint >= 0x30 && codePoint < 0x3A) {
		return 26 + (codePoint - 0x30);
	}
	if (codePoint >= 0x41 && codePoint < 0x5B) {
		return codePoint - 0x41;
	}
	if (codePoint >= 0x61 && codePoint < 0x7B) {
		return codePoint - 0x61;
	}
	return base;
};

/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */
const digitToBasic = function(digit, flag) {
	//  0..25 map to ASCII a..z or A..Z
	// 26..35 map to ASCII 0..9
	return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */
const adapt = function(delta, numPoints, firstTime) {
	let k = 0;
	delta = firstTime ? floor(delta / damp) : delta >> 1;
	delta += floor(delta / numPoints);
	for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
		delta = floor(delta / baseMinusTMin);
	}
	return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */
const decode = function(input) {
	// Don't use UCS-2.
	const output = [];
	const inputLength = input.length;
	let i = 0;
	let n = initialN;
	let bias = initialBias;

	// Handle the basic code points: let `basic` be the number of input code
	// points before the last delimiter, or `0` if there is none, then copy
	// the first basic code points to the output.

	let basic = input.lastIndexOf(delimiter);
	if (basic < 0) {
		basic = 0;
	}

	for (let j = 0; j < basic; ++j) {
		// if it's not a basic code point
		if (input.charCodeAt(j) >= 0x80) {
			error$c('not-basic');
		}
		output.push(input.charCodeAt(j));
	}

	// Main decoding loop: start just after the last delimiter if any basic code
	// points were copied; start at the beginning otherwise.

	for (let index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

		// `index` is the index of the next character to be consumed.
		// Decode a generalized variable-length integer into `delta`,
		// which gets added to `i`. The overflow checking is easier
		// if we increase `i` as we go, then subtract off its starting
		// value at the end to obtain `delta`.
		const oldi = i;
		for (let w = 1, k = base; /* no condition */; k += base) {

			if (index >= inputLength) {
				error$c('invalid-input');
			}

			const digit = basicToDigit(input.charCodeAt(index++));

			if (digit >= base) {
				error$c('invalid-input');
			}
			if (digit > floor((maxInt - i) / w)) {
				error$c('overflow');
			}

			i += digit * w;
			const t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

			if (digit < t) {
				break;
			}

			const baseMinusT = base - t;
			if (w > floor(maxInt / baseMinusT)) {
				error$c('overflow');
			}

			w *= baseMinusT;

		}

		const out = output.length + 1;
		bias = adapt(i - oldi, out, oldi == 0);

		// `i` was supposed to wrap around from `out` to `0`,
		// incrementing `n` each time, so we'll fix that now:
		if (floor(i / out) > maxInt - n) {
			error$c('overflow');
		}

		n += floor(i / out);
		i %= out;

		// Insert `n` at position `i` of the output.
		output.splice(i++, 0, n);

	}

	return String.fromCodePoint(...output);
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */
const encode = function(input) {
	const output = [];

	// Convert the input in UCS-2 to an array of Unicode code points.
	input = ucs2decode(input);

	// Cache the length.
	const inputLength = input.length;

	// Initialize the state.
	let n = initialN;
	let delta = 0;
	let bias = initialBias;

	// Handle the basic code points.
	for (const currentValue of input) {
		if (currentValue < 0x80) {
			output.push(stringFromCharCode(currentValue));
		}
	}

	const basicLength = output.length;
	let handledCPCount = basicLength;

	// `handledCPCount` is the number of code points that have been handled;
	// `basicLength` is the number of basic code points.

	// Finish the basic string with a delimiter unless it's empty.
	if (basicLength) {
		output.push(delimiter);
	}

	// Main encoding loop:
	while (handledCPCount < inputLength) {

		// All non-basic code points < n have been handled already. Find the next
		// larger one:
		let m = maxInt;
		for (const currentValue of input) {
			if (currentValue >= n && currentValue < m) {
				m = currentValue;
			}
		}

		// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
		// but guard against overflow.
		const handledCPCountPlusOne = handledCPCount + 1;
		if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
			error$c('overflow');
		}

		delta += (m - n) * handledCPCountPlusOne;
		n = m;

		for (const currentValue of input) {
			if (currentValue < n && ++delta > maxInt) {
				error$c('overflow');
			}
			if (currentValue === n) {
				// Represent delta as a generalized variable-length integer.
				let q = delta;
				for (let k = base; /* no condition */; k += base) {
					const t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
					if (q < t) {
						break;
					}
					const qMinusT = q - t;
					const baseMinusT = base - t;
					output.push(
						stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
					);
					q = floor(qMinusT / baseMinusT);
				}

				output.push(stringFromCharCode(digitToBasic(q, 0)));
				bias = adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
				delta = 0;
				++handledCPCount;
			}
		}

		++delta;
		++n;

	}
	return output.join('');
};

/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */
const toUnicode = function(input) {
	return mapDomain(input, function(string) {
		return regexPunycode.test(string)
			? decode(string.slice(4).toLowerCase())
			: string;
	});
};

/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */
const toASCII = function(input) {
	return mapDomain(input, function(string) {
		return regexNonASCII.test(string)
			? 'xn--' + encode(string)
			: string;
	});
};

/*--------------------------------------------------------------------------*/

/** Define the public API */
const punycode$1 = {
	/**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */
	'version': '2.3.1',
	/**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */
	'ucs2': {
		'decode': ucs2decode,
		'encode': ucs2encode
	},
	'decode': decode,
	'encode': encode,
	'toASCII': toASCII,
	'toUnicode': toUnicode
};

var punycode_1 = punycode$1;

var _default = {
  options: {
    html:         false,        // Enable HTML tags in source
    xhtmlOut:     false,        // Use '/' to close single tags (<br />)
    breaks:       false,        // Convert '\n' in paragraphs into <br>
    langPrefix:   'language-',  // CSS language prefix for fenced blocks
    linkify:      false,        // autoconvert URL-like texts to links

    // Enable some language-neutral replacements + quotes beautification
    typographer:  false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: '\u201c\u201d\u2018\u2019', /* “”‘’ */

    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,

    maxNesting:   100            // Internal protection, recursion limit
  },

  components: {

    core: {},
    block: {},
    inline: {}
  }
};

var zero = {
  options: {
    html:         false,        // Enable HTML tags in source
    xhtmlOut:     false,        // Use '/' to close single tags (<br />)
    breaks:       false,        // Convert '\n' in paragraphs into <br>
    langPrefix:   'language-',  // CSS language prefix for fenced blocks
    linkify:      false,        // autoconvert URL-like texts to links

    // Enable some language-neutral replacements + quotes beautification
    typographer:  false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: '\u201c\u201d\u2018\u2019', /* “”‘’ */

    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,

    maxNesting:   20            // Internal protection, recursion limit
  },

  components: {

    core: {
      rules: [
        'normalize',
        'block',
        'inline',
        'text_join'
      ]
    },

    block: {
      rules: [
        'paragraph'
      ]
    },

    inline: {
      rules: [
        'text'
      ],
      rules2: [
        'balance_pairs',
        'fragments_join'
      ]
    }
  }
};

var commonmark = {
  options: {
    html:         true,         // Enable HTML tags in source
    xhtmlOut:     true,         // Use '/' to close single tags (<br />)
    breaks:       false,        // Convert '\n' in paragraphs into <br>
    langPrefix:   'language-',  // CSS language prefix for fenced blocks
    linkify:      false,        // autoconvert URL-like texts to links

    // Enable some language-neutral replacements + quotes beautification
    typographer:  false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: '\u201c\u201d\u2018\u2019', /* “”‘’ */

    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,

    maxNesting:   20            // Internal protection, recursion limit
  },

  components: {

    core: {
      rules: [
        'normalize',
        'block',
        'inline',
        'text_join'
      ]
    },

    block: {
      rules: [
        'blockquote',
        'code',
        'fence',
        'heading',
        'hr',
        'html_block',
        'lheading',
        'list',
        'reference',
        'paragraph'
      ]
    },

    inline: {
      rules: [
        'autolink',
        'backticks',
        'emphasis',
        'entity',
        'escape',
        'html_inline',
        'image',
        'link',
        'newline',
        'text'
      ],
      rules2: [
        'balance_pairs',
        'emphasis',
        'fragments_join'
      ]
    }
  }
};

var utils        = utils$1;
var helpers      = helpers$1;
var Renderer     = renderer;
var ParserCore   = parser_core;
var ParserBlock  = parser_block;
var ParserInline = parser_inline;
var LinkifyIt    = linkifyIt;
var mdurl        = mdurl$1;
var punycode     = punycode_1;


var config = {
  default: _default,
  zero: zero,
  commonmark: commonmark
};

////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//

var BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;

function validateLink(url) {
  // url should be normalized at this point, and existing entities are decoded
  var str = url.trim().toLowerCase();

  return BAD_PROTO_RE.test(str) ? (GOOD_DATA_RE.test(str) ? true : false) : true;
}

////////////////////////////////////////////////////////////////////////////////


var RECODE_HOSTNAME_FOR = [ 'http:', 'https:', 'mailto:' ];

function normalizeLink(url) {
  var parsed = mdurl.parse(url, true);

  if (parsed.hostname) {
    // Encode hostnames in urls like:
    // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
    //
    // We don't encode unknown schemas, because it's likely that we encode
    // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
    //
    if (!parsed.protocol || RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) {
      try {
        parsed.hostname = punycode.toASCII(parsed.hostname);
      } catch (er) { /**/ }
    }
  }

  return mdurl.encode(mdurl.format(parsed));
}

function normalizeLinkText(url) {
  var parsed = mdurl.parse(url, true);

  if (parsed.hostname) {
    // Encode hostnames in urls like:
    // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
    //
    // We don't encode unknown schemas, because it's likely that we encode
    // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
    //
    if (!parsed.protocol || RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) {
      try {
        parsed.hostname = punycode.toUnicode(parsed.hostname);
      } catch (er) { /**/ }
    }
  }

  // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
  return mdurl.decode(mdurl.format(parsed), mdurl.decode.defaultChars + '%');
}


/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/

/**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/
function MarkdownIt(presetName, options) {
  if (!(this instanceof MarkdownIt)) {
    return new MarkdownIt(presetName, options);
  }

  if (!options) {
    if (!utils.isString(presetName)) {
      options = presetName || {};
      presetName = 'default';
    }
  }

  /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/
  this.inline = new ParserInline();

  /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/
  this.block = new ParserBlock();

  /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/
  this.core = new ParserCore();

  /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/
  this.renderer = new Renderer();

  /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/
  this.linkify = new LinkifyIt();

  /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/
  this.validateLink = validateLink;

  /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/
  this.normalizeLink = normalizeLink;

  /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/
  this.normalizeLinkText = normalizeLinkText;


  // Expose utils & helpers for easy acces from plugins

  /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/
  this.utils = utils;

  /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/
  this.helpers = utils.assign({}, helpers);


  this.options = {};
  this.configure(presetName);

  if (options) { this.set(options); }
}


/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/
MarkdownIt.prototype.set = function (options) {
  utils.assign(this.options, options);
  return this;
};


/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/
MarkdownIt.prototype.configure = function (presets) {
  var self = this, presetName;

  if (utils.isString(presets)) {
    presetName = presets;
    presets = config[presetName];
    if (!presets) { throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name'); }
  }

  if (!presets) { throw new Error('Wrong `markdown-it` preset, can\'t be empty'); }

  if (presets.options) { self.set(presets.options); }

  if (presets.components) {
    Object.keys(presets.components).forEach(function (name) {
      if (presets.components[name].rules) {
        self[name].ruler.enableOnly(presets.components[name].rules);
      }
      if (presets.components[name].rules2) {
        self[name].ruler2.enableOnly(presets.components[name].rules2);
      }
    });
  }
  return this;
};


/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/
MarkdownIt.prototype.enable = function (list, ignoreInvalid) {
  var result = [];

  if (!Array.isArray(list)) { list = [ list ]; }

  [ 'core', 'block', 'inline' ].forEach(function (chain) {
    result = result.concat(this[chain].ruler.enable(list, true));
  }, this);

  result = result.concat(this.inline.ruler2.enable(list, true));

  var missed = list.filter(function (name) { return result.indexOf(name) < 0; });

  if (missed.length && !ignoreInvalid) {
    throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
  }

  return this;
};


/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/
MarkdownIt.prototype.disable = function (list, ignoreInvalid) {
  var result = [];

  if (!Array.isArray(list)) { list = [ list ]; }

  [ 'core', 'block', 'inline' ].forEach(function (chain) {
    result = result.concat(this[chain].ruler.disable(list, true));
  }, this);

  result = result.concat(this.inline.ruler2.disable(list, true));

  var missed = list.filter(function (name) { return result.indexOf(name) < 0; });

  if (missed.length && !ignoreInvalid) {
    throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
  }
  return this;
};


/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/
MarkdownIt.prototype.use = function (plugin /*, params, ... */) {
  var args = [ this ].concat(Array.prototype.slice.call(arguments, 1));
  plugin.apply(plugin, args);
  return this;
};


/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/
MarkdownIt.prototype.parse = function (src, env) {
  if (typeof src !== 'string') {
    throw new Error('Input data should be a String');
  }

  var state = new this.core.State(src, this, env);

  this.core.process(state);

  return state.tokens;
};


/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/
MarkdownIt.prototype.render = function (src, env) {
  env = env || {};

  return this.renderer.render(this.parse(src, env), this.options, env);
};


/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/
MarkdownIt.prototype.parseInline = function (src, env) {
  var state = new this.core.State(src, this, env);

  state.inlineMode = true;
  this.core.process(state);

  return state.tokens;
};


/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/
MarkdownIt.prototype.renderInline = function (src, env) {
  env = env || {};

  return this.renderer.render(this.parseInline(src, env), this.options, env);
};


var lib = MarkdownIt;

var markdownIt = lib;

var MessageSource;
(function (MessageSource) {
    MessageSource["USER"] = "user";
    MessageSource["SERVICE"] = "service";
    MessageSource["AI"] = "ai";
})(MessageSource || (MessageSource = {}));

var NotificationSeverity;
(function (NotificationSeverity) {
    NotificationSeverity["Info"] = "Info";
    NotificationSeverity["Success"] = "Success";
    NotificationSeverity["Warn"] = "Warn";
    NotificationSeverity["Error"] = "Error";
    NotificationSeverity["Fatal"] = "Fatal";
})(NotificationSeverity || (NotificationSeverity = {}));
var NotificationMode;
(function (NotificationMode) {
    NotificationMode["InApp"] = "InApp";
    NotificationMode["Email"] = "Email";
})(NotificationMode || (NotificationMode = {}));
var NotificationEvents;
(function (NotificationEvents) {
    NotificationEvents["localNotificationNavigation"] = "localNotificationNavigation";
    NotificationEvents["receivedNotification"] = "receivedNotification";
})(NotificationEvents || (NotificationEvents = {}));

class GlobalEventEmitter {
    static emitPortalShellLoaded() {
        this.emitEvent(GlobalEventNames.portalShellLoaded);
    }
    static emitAccessTokenChanged(config) {
        this.emitEvent(GlobalEventNames.accessTokenChanged, config);
    }
    static emitTenantsNotAvailable() {
        this.emitEvent(GlobalEventNames.tenantsNotAvailable);
    }
    static emitTenantChanged(tenant) {
        this.emitEvent(GlobalEventNames.tenantChanged, tenant);
    }
    static emitTenantLoaded(tenant) {
        this.emitEvent(GlobalEventNames.tenantLoaded, tenant);
    }
    static emitThemeChanged(theme) {
        this.emitEvent(GlobalEventNames.themeChanged, theme);
    }
    static emitThemeSelectChanged(theme) {
        this.emitEvent(GlobalEventNames.themeSelectChanged, theme);
    }
    static emitThemeLoaded(theme) {
        this.emitEvent(GlobalEventNames.themeLoaded, theme);
    }
    static emitLanguageChanged(language) {
        this.emitEvent(GlobalEventNames.languageChanged, language);
    }
    static emitLanguageLoaded(language) {
        this.emitEvent(GlobalEventNames.languageLoaded, language);
    }
    static emitPendoInitialized(pendo) {
        this.emitEvent(GlobalEventNames.pendoInitialized, pendo);
    }
    static emitLogout() {
        this.emitEvent(GlobalEventNames.logout);
    }
    static emitSessionTimedOut() {
        this.emitEvent(GlobalEventNames.sessionTimedOut);
    }
    static emitAccessiblityModeChanged(mode) {
        this.emitEvent(GlobalEventNames.accessiblityModeChanged, { isAccessibleMode: mode });
    }
    static emitAlertDurationChanged(duration) {
        this.emitEvent(GlobalEventNames.alertDurationChanged, duration);
    }
    static emitSwitchOrganization(orgNames) {
        this.emitEvent(GlobalEventNames.switchingOrganizations, orgNames);
    }
    static emitChatMessageReceived(source, content, hidden = false, postMessage) {
        this.emitEvent(GlobalEventNames.chatMessageReceived, {
            source,
            content,
            hidden,
            postMessage,
        });
    }
    static emitChatMessagePosted(source, content) {
        this.emitEvent(GlobalEventNames.chatMessagePosted, {
            source,
            content,
        });
    }
    static emitChatCreated() {
        this.emitEvent(GlobalEventNames.chatCreated);
    }
    static emitChatConnected() {
        this.emitEvent(GlobalEventNames.chatConnected);
    }
    static emitChatEnded() {
        this.emitEvent(GlobalEventNames.chatEnded);
    }
    static emitNotificationNavigateToTarget(redirectUrl) {
        this.emitEvent(NotificationEvents.localNotificationNavigation, { redirectUrl });
    }
    static emitNotificationReceived(notificationDetail) {
        this.emitEvent(NotificationEvents.receivedNotification, notificationDetail);
    }
    static emitPlatformInfoChanged(platformInfo) {
        this.emitEvent(GlobalEventNames.platformInfo, platformInfo);
    }
    static emitOpenUpgradeTrialDialog(isBusinessEmail = false) {
        this.emitEvent(GlobalEventNames.openApDialog, {
            eventName: isBusinessEmail
                ? DialogEventNames.UpgradeToTrialDialogBusinessEmail
                : DialogEventNames.UpgradeToTrialDialogPersonalEmail,
        });
    }
    static emitOpenServicesNav() {
        this.emitEvent(GlobalEventNames.openServicesNav);
    }
    static emitCloseServicesNav() {
        this.emitEvent(GlobalEventNames.closeServicesNav);
    }
    static emitIsNewNavSelected(isNewNavSelected) {
        this.emitEvent(GlobalEventNames.isNewNavSelected, isNewNavSelected.toString());
    }
    static emitToggleServiceNav() {
        this.emitEvent(GlobalEventNames.toggleServiceNav);
    }
    static emitEvent(eventName, data, options = {
        composed: true,
        cancelable: true,
        bubbles: true,
    }) {
        const dataString = eventName === 'accessTokenChanged' ? Object.assign(Object.assign({}, data), { accessToken: sanitizeToken(data.accessToken) }) : JSON.stringify(data);
        Logger.debug('GlobalEventEmitter', `${eventName} triggered: ${dataString}`);
        const event = new CustomEvent(eventName, data ? Object.assign(Object.assign({}, options), { detail: data }) : undefined);
        window.document.dispatchEvent(event);
    }
}

class Chat {
    constructor(chatStore) {
        this.sessionId = '';
        this.connected = false;
        this.chatStore = chatStore;
        const sessionId = this.getSessionIdFromSessionStorage();
        if (sessionId) {
            this.sessionId = sessionId;
        }
        this.markdownParser = new markdownIt();
    }
    initialize({ context, serviceAvatarUrl, serviceId, brainId, token, tenantId, } = {}) {
        this.chatStore.set('context', context !== null && context !== void 0 ? context : '');
        this.chatStore.set('brainId', brainId !== null && brainId !== void 0 ? brainId : 'defaultAlphaBrain');
        this.chatStore.set('serviceAvatarUrl', serviceAvatarUrl !== null && serviceAvatarUrl !== void 0 ? serviceAvatarUrl : '');
        this.chatStore.set('serviceId', serviceId !== null && serviceId !== void 0 ? serviceId : (getSpaceName() || ServiceType.cloudRpa));
        this.chatStore.set('token', token !== null && token !== void 0 ? token : '');
        this.chatStore.set('tenantId', tenantId);
        this.chatStore.set('isInitialized', true);
    }
    async createNewChat() {
        const accessToken = this.getChatAccessToken();
        if (!accessToken || !this.chatStore.get('isInitialized')) {
            Logger.error('chat', `No access token ${accessToken}, or is not initialized ${this.chatStore.get('isInitialized')}, not creating chat`);
            return;
        }
        const id = await post(`https://${Chat.serverHost}/api/chat/session`, {
            token: accessToken,
            body: {
                context: this.chatStore.get('context'),
                brainId: this.chatStore.get('brainId'),
            },
        });
        this.sessionId = id;
        this.setSessionIdInSessionStorage(this.sessionId);
        GlobalEventEmitter.emitChatCreated();
        this.connected = true;
    }
    async closeCurrentChat() {
        const token = this.getChatAccessToken();
        if (!this.sessionId || !token) {
            Logger.error('chat', `No session id ${this.sessionId} or access token ${token}, not closing chat`);
            return;
        }
        await safeFetch('DELETE', `https://${Chat.serverHost}/api/chat/session/${this.sessionId}`, { token });
        this.chatStore.set('messages', []);
        this.setSessionIdInSessionStorage('');
        this.sessionId = '';
        this.connected = false;
    }
    async connectChat(accessToken = this.getChatAccessToken(), sessionId = this.sessionId) {
        var _a, _b;
        if (!sessionId) {
            sessionId = (_a = this.getSessionIdFromSessionStorage()) !== null && _a !== void 0 ? _a : '';
            this.sessionId = sessionId;
        }
        if (!this.chatStore.get('isInitialized') || !accessToken || !sessionId || this.connected) {
            Logger.error('chat', `Failing to connect ---> initialized: ${this.chatStore.get('isInitialized')}, token: ${!!accessToken}, session id: ${!!sessionId}, connected: ${this.connected}`, { printToConsoleOnly: true });
            return;
        }
        const userSessionsResponse = await get(`https://${Chat.serverHost}/api/user`, { token: accessToken });
        if (!(userSessionsResponse === null || userSessionsResponse === void 0 ? void 0 : userSessionsResponse.sessions.includes(sessionId))) {
            Logger.error('chat', `user does not have session ${sessionId}`);
            this.connected = false;
            return;
        }
        const response = await get(`https://${Chat.serverHost}/api/chat/session/${sessionId}`, { token: accessToken });
        const messages = ((_b = response === null || response === void 0 ? void 0 : response.messages) !== null && _b !== void 0 ? _b : []).map((message) => (Object.assign(Object.assign({}, message), { source: message.source === Chat.BACKEND_AI ? MessageSource.AI : message.source })));
        this.chatStore.set('messages', messages);
        this.connected = true;
    }
    async postServiceMessage(content, hidden) {
        await this.postUserOrServiceMessage(MessageSource.SERVICE, content, hidden);
    }
    async postUserMessage(content) {
        await this.postUserOrServiceMessage(MessageSource.USER, content);
    }
    async postUserOrServiceMessage(source, content, hidden) {
        const sessionId = this.sessionId || this.getSessionIdFromSessionStorage();
        if (!sessionId) {
            await this.createNewChat();
        }
        else if (!this.connected) {
            await this.connectChat();
        }
        GlobalEventEmitter.emitChatMessageReceived(source, content, hidden);
        await Chat.postChatMessage({
            delegate: this,
            source,
            content,
            timestamp: Date.now(),
            sendMessage: true,
            hidden,
        });
    }
    static async postChatMessage({ delegate, source, content, timestamp, sendMessage = false, hidden = false, }) {
        if (!delegate.chatStore.get('isInitialized')) {
            return;
        }
        const messages = delegate.chatStore.get('messages');
        const newMessage = {
            id: `chat-message-${messages.length}`,
            source,
            content,
            timestamp: timestamp !== null && timestamp !== void 0 ? timestamp : Date.now(),
            hidden,
        };
        Logger.debug('chat', `posting message: ${JSON.stringify(newMessage)}, ${messages}`);
        delegate.chatStore.set('messages', [...messages, newMessage]);
        if (sendMessage) {
            await delegate.sendMessage(newMessage);
        }
        if (!hidden) {
            GlobalEventEmitter.emitChatMessagePosted(source, content);
        }
    }
    async sendMessage(message) {
        var _a, _b, _c;
        const token = this.getChatAccessToken();
        if (!token || !message.content) {
            Logger.error('chat', 'No access token, not sending message');
            return;
        }
        const response = await post(`https://${Chat.serverHost}/api/chat/completion`, {
            token,
            body: {
                sessionId: this.sessionId,
                serviceId: this.chatStore.get('serviceId'),
                brainId: this.chatStore.get('brainId'),
                tenantId: (_a = this.chatStore.get('tenantId')) !== null && _a !== void 0 ? _a : (_c = (_b = AccountAndTenantsInstanceResolver.Instance) === null || _b === void 0 ? void 0 : _b.getTenant()) === null || _c === void 0 ? void 0 : _c.id,
                message,
            },
        });
        if (response === null || response === void 0 ? void 0 : response.content) {
            GlobalEventEmitter.emitChatMessageReceived(MessageSource.AI, response.content, response.hidden, (messageSource, messageContent) => Chat.postChatMessage({
                delegate: this,
                source: messageSource,
                content: messageContent,
                timestamp: response === null || response === void 0 ? void 0 : response.timestamp,
                sendMessage: false,
                hidden: response.hidden,
            }));
        }
    }
    getChatAccessToken() {
        // The token can be empty string so we need to use the || operator
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        return this.chatStore.get('token') || getAccessToken();
    }
    getChatUserId() {
        const userId = sessionStore.get('userId');
        if (userId) {
            return userId;
        }
        const token = this.getChatAccessToken();
        if (token) {
            return o(token).sub;
        }
        return '';
    }
    getSessionIdFromSessionStorage() {
        const userId = this.getChatUserId();
        const sessionStorageId = sessionStorage.getItem(`${Chat.sessionStorageKeyPrefix}_${userId}_${getSpaceName() || 'local'}`);
        Logger.debug('chat', `getting sessionStorageId: ${userId},  ${sessionStorageId}`);
        return sessionStorageId;
    }
    setSessionIdInSessionStorage(sessionId) {
        Logger.debug('chat', `setting sessionStorageId: ${sessionId}`);
        const userId = this.getChatUserId();
        sessionStorage.setItem(`${Chat.sessionStorageKeyPrefix}_${userId}_${getSpaceName() || 'local'}`, sessionId);
    }
}
Chat.sessionStorageKeyPrefix = 'chatSessionId';
Chat.serverHost = 'jarvis-alpha.uipath.co';
Chat.BACKEND_AI = 'assistant';
const chatStore = createStore({
    isInitialized: false,
    context: '',
    messages: [],
    serviceAvatarUrl: '',
    serviceId: getSpaceName() || ServiceType.cloudRpa,
    token: '',
});

class ChatInstanceResolver {
    static Instantiate(chatStore) {
        if (!this._chatInstance) {
            this._chatInstance = new Chat(chatStore);
        }
        if (!this._chatStore) {
            this._chatStore = chatStore;
        }
        return this._chatInstance;
    }
    static get Instance() {
        return this._chatInstance;
    }
    static get Store() {
        return this._chatStore;
    }
}

function backfillEntitlements() {
    var _a;
    const currentEntitlement = localStorage.getItem(`${STORAGE_KEYS.PORTAL_SHELL_ENTITLEMENTS}_${getAccountName()}`);
    if (currentEntitlement === 'true' || currentEntitlement === 'false') {
        (_a = AccountAndTenantsInstanceResolver.Instance) === null || _a === void 0 ? void 0 : _a.fetchEntitlements(getAccessToken(), true);
    }
}

// Checks if should refetch based on the throttle flag and the last refetched key
// Returns a function that sets the last refetched key in local storage, which
// should be called after the refetch is complete.
// If the URL account name is different than the one in the cache we should always refetch
const shouldRefetch = (throttleFlag, lastRefetchedKey) => {
    var _a;
    // Check the throttle
    const refetchThrottleMs = +getFeatureFlag(throttleFlag);
    const currentTime = new Date().getTime();
    const lastRefetch = +((_a = localStorage.getItem(lastRefetchedKey)) !== null && _a !== void 0 ? _a : 0);
    const isThrottlePassed = lastRefetch + refetchThrottleMs < currentTime;
    // Check the account name
    const isAccountNameSame = isUrlAccountSameAsCached();
    // Calculate the refetch condition
    const refetchCondition = isThrottlePassed || !isAccountNameSame;
    // Return the function that sets the last refetched key
    const setLocalStorageLastRefetched = () => localStorage.setItem(lastRefetchedKey, currentTime.toString());
    return {
        refetchCondition,
        setLocalStorageLastRefetched,
    };
};
const isUrlAccountSameAsCached = () => {
    var _a, _b, _c, _d, _e, _f;
    try {
        const currentAccountCache = (_a = localStorage.getItem(STORAGE_KEYS.PORTAL_ACCOUNT)) !== null && _a !== void 0 ? _a : '';
        const currentAccount = JSON.parse(currentAccountCache);
        const cachedAccountName = (_c = (_b = currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.organization) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : '';
        const cachedAccountId = (_e = (_d = currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.organization) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : '';
        const existsCachedNameOrId = cachedAccountName || cachedAccountId;
        const urlAccountNameOrId = (_f = getAccountName()) !== null && _f !== void 0 ? _f : '';
        return existsCachedNameOrId
            && urlAccountNameOrId
            && (caseInsensitiveCompare(cachedAccountName, urlAccountNameOrId) || caseInsensitiveCompare(cachedAccountId, urlAccountNameOrId));
    }
    catch (e) {
        return false;
    }
};

function getOrganizationStandardUrl({ shouldUseDefaultBaseUrl = false, shouldAlwaysExcludeAccountName = false, isForServiceUrl = false, } = {}) {
    var _a, _b, _c, _d, _e, _f;
    const devProperties = (_a = GlobalPropsInstanceResolver.Instance) === null || _a === void 0 ? void 0 : _a.devProperties;
    const organizationName = (_b = devProperties === null || devProperties === void 0 ? void 0 : devProperties.organizationName) !== null && _b !== void 0 ? _b : '';
    const isMFERoot = devProperties === null || devProperties === void 0 ? void 0 : devProperties.isMFERoot;
    let organizationStandardUrl = (_c = devProperties === null || devProperties === void 0 ? void 0 : devProperties.organizationStandardUrl) !== null && _c !== void 0 ? _c : '';
    if (isMFERoot && isForServiceUrl) {
        return shouldAlwaysExcludeAccountName
            ? window.location.origin
            : `${window.location.origin}/${organizationName}`;
    }
    if (isMFERoot && organizationStandardUrl) {
        return shouldAlwaysExcludeAccountName
            ? organizationStandardUrl
            : `${organizationStandardUrl}/${organizationName}`;
    }
    if (!organizationStandardUrl && ((_e = (_d = GlobalPropsInstanceResolver.Instance) === null || _d === void 0 ? void 0 : _d.devProperties) === null || _e === void 0 ? void 0 : _e.mode) !== 'dev-cloud') {
        organizationStandardUrl = getBaseUrl();
        if (isLocal() && isMSI()) {
            Logger.debug('orgStandardUrl', 'base url local, missing service in url: ' + organizationStandardUrl);
            return organizationStandardUrl;
        }
        const isLocalOrgStandardUrl = (organizationStandardUrl === null || organizationStandardUrl === void 0 ? void 0 : organizationStandardUrl.includes('localhost:')) || (organizationStandardUrl === null || organizationStandardUrl === void 0 ? void 0 : organizationStandardUrl.includes('127.0.0.1:'));
        if (shouldUseDefaultBaseUrl && isLocalOrgStandardUrl) {
            organizationStandardUrl = (_f = getEnvConfigField('DEFAULT_BASE_URL')) !== null && _f !== void 0 ? _f : '';
        }
        const accountName = getAccountName();
        if (organizationStandardUrl
            && accountName
            && !shouldAlwaysExcludeAccountName) {
            organizationStandardUrl += `/${accountName}`;
        }
        else if (!accountName && !shouldAlwaysExcludeAccountName) {
            Logger.error('orgStandardUrl', 'accountName is empty', { printToConsoleOnly: true });
            return '';
        }
    }
    Logger.debug('orgStandardUrl', organizationStandardUrl, {
        object: {
            shouldUseDefaultBaseUrl,
            shouldAlwaysExcludeAccountName,
        },
    });
    return organizationStandardUrl;
}
function parseOrganizationStandardUrl(organizationStandardUrl) {
    const url = organizationStandardUrl ? new URL(organizationStandardUrl) : {
        origin: '',
        pathname: '',
    };
    return {
        baseUrl: url.origin || getBaseUrl(),
        accountName: url.pathname.split('/')[1] || getAccountName(),
    };
}

class FeatureFlags {
    constructor(flagStore) {
        this.flagStore = flagStore;
        Object
            .entries(FeatureFlags.getCachedFeatureFlags())
            .forEach(([key, value]) => {
            this.flagStore.set(key, value);
        });
    }
    static getDefaultFeatureFlags() {
        var _a, _b;
        return Object.assign(Object.assign(Object.assign({}, DefaultValuesMap), ((getEnvConfigField === null || getEnvConfigField === void 0 ? void 0 : getEnvConfigField('FeatureFlags')) || {})), ((_b = (_a = GlobalPropsInstanceResolver === null || GlobalPropsInstanceResolver === void 0 ? void 0 : GlobalPropsInstanceResolver.Instance) === null || _a === void 0 ? void 0 : _a.featureFlagOverrides) !== null && _b !== void 0 ? _b : {}));
    }
    async fetchFeatureFlags(sessionStorage, token = '') {
        var _a, _b, _c, _d, _e;
        if (isStandalone()) {
            Logger.debug('featureFlags', 'standalone, skipping fetching feature flags, removing old cache');
            localStorage.removeItem(FeatureFlags.getFeatureFlagsCacheKey());
            localStorage.removeItem(FeatureFlags.cacheKeyPrefix);
            return;
        }
        const organizationStandardUrl = getOrganizationStandardUrl();
        const { refetchCondition, setLocalStorageLastRefetched, } = shouldRefetch(Features.FeatureFlagsRefetchThrottleMs.name, `${FeatureFlags.featureFlagsLastRefetchedKeyPrefix}_${getSpaceName()}_${organizationStandardUrl}`);
        if (!organizationStandardUrl
            || !token
            || (!refetchCondition && FeatureFlags.getCachedFeatureFlags())) {
            Logger.debug('featureFlags', `skipping fetch due to throttle, missing token or missing org standard URL: ${organizationStandardUrl}`);
            return;
        }
        Logger.debug('featureFlags', `fetch: token='${sanitizeToken(token)}'`);
        const fetchedFlags = await get(`${organizationStandardUrl}/portal_/api/featureFlags?filter=portal_shell&spaceName=${getSpaceName()}`, {
            token,
            credentials: 'omit',
            headers: {
                'X-UiPath-Internal-AccountName': (_a = getAccountName()) !== null && _a !== void 0 ? _a : '',
                'X-UiPath-Internal-AccountId': sessionStorage.get('organizationId'),
            },
        }, (e) => {
            Logger.warn(['featureFlags', 'api'], `unexpected error: ${e}`, { stack: e.stack });
            return {};
        });
        setLocalStorageLastRefetched();
        const processedFlags = fetchedFlags ? Object.entries(fetchedFlags).reduce((accumulator, [key, value]) => {
            accumulator[key] = value === null || value === void 0 ? void 0 : value.value;
            return accumulator;
        }, {}) : {};
        const localStorageOverride = (_b = fetchedFlags === null || fetchedFlags === void 0 ? void 0 : fetchedFlags[Features.EnablePortalShellLocalStorageOverrides.name]) === null || _b === void 0 ? void 0 : _b.value;
        const localStorageFlags = (_c = getEnvConfigField('FeatureFlags', getEnvironment(), localStorageOverride)) !== null && _c !== void 0 ? _c : {};
        const flags = Object.assign(Object.assign(Object.assign(Object.assign({}, this.flagStore.state), processedFlags), localStorageFlags), ((_e = (_d = GlobalPropsInstanceResolver === null || GlobalPropsInstanceResolver === void 0 ? void 0 : GlobalPropsInstanceResolver.Instance) === null || _d === void 0 ? void 0 : _d.featureFlagOverrides) !== null && _e !== void 0 ? _e : {}));
        FeatureFlags.setFeatureFlagsCache(flags);
        Object.entries(flags).forEach(([key, value]) => {
            this.flagStore.set(key, value);
        });
    }
    /**
     * USE THE EXPORTED GET_FEATURE_FLAG(S) FUNCTIONS INSTEAD (getFeatureFlag(key), getFeatureFlags(keys)) for components
     * This function does not trigger rerender in components, but it does return the correct flag value at the time it is called.
     * Use this in all other cases (such as in side effects)
     * @param key string
     * @returns boolean
     */
    getFeatureFlag(key) {
        return this.flagStore.get(key);
    }
    /**
     * Set the override flags
     * To be used by the GlobalEventEmitter after passing in the feature flags overrides
     */
    setOverrideFlags(overrideFlags) {
        Object.entries(overrideFlags).forEach(([key, value]) => {
            if (this.flagStore.get(key) == null) {
                return;
            }
            this.flagStore.set(key, value);
        });
    }
    static getCachedFeatureFlags() {
        var _a, _b;
        const featureFlag = isStandalone() ? '{}' : localStorage.getItem(FeatureFlags.getFeatureFlagsCacheKey());
        const defaultValues = FeatureFlags.getDefaultFeatureFlags();
        if (!featureFlag) {
            return defaultValues;
        }
        let cachedFeatureFlags = {};
        try {
            cachedFeatureFlags = JSON.parse(featureFlag);
        }
        catch (_c) {
            cachedFeatureFlags = {};
        }
        // Required feature flags (ones found in FeatureFlagConstants) must be in the cache
        const currentFlags = Object.entries(defaultValues).reduce((accumulator, current) => {
            const cachedFlagValue = accumulator[current[0]];
            if (cachedFlagValue == null) {
                accumulator[current[0]] = current[1];
            }
            return accumulator;
        }, cachedFeatureFlags);
        Logger.debug('featureFlags', `loaded cached: ${JSON.stringify(currentFlags, null, 2)}`);
        return Object.assign(Object.assign({}, currentFlags), ((_b = (_a = GlobalPropsInstanceResolver === null || GlobalPropsInstanceResolver === void 0 ? void 0 : GlobalPropsInstanceResolver.Instance) === null || _a === void 0 ? void 0 : _a.featureFlagOverrides) !== null && _b !== void 0 ? _b : {}));
    }
    static setFeatureFlagsCache(featureFlags) {
        localStorage.setItem(FeatureFlags.getFeatureFlagsCacheKey(), JSON.stringify(featureFlags));
    }
    static getFeatureFlagsCacheKey() {
        const accountName = getAccountName();
        if (!accountName) {
            return FeatureFlags.cacheKeyPrefix;
        }
        return `${FeatureFlags.cacheKeyPrefix}_${accountName}`;
    }
}
FeatureFlags.cacheKeyPrefix = STORAGE_KEYS.PORTAL_FEATURE_FLAGS;
FeatureFlags.featureFlagsLastRefetchedKeyPrefix = STORAGE_KEYS.PORTAL_SHELL_FLAGS_LAST_REFETCHED;
let _getFeatureFlagsStore;
const getFeatureFlagsStore = () => {
    if (!_getFeatureFlagsStore) {
        _getFeatureFlagsStore = createStore(FeatureFlags.getDefaultFeatureFlags());
    }
    return _getFeatureFlagsStore;
};
const getFeatureFlag = (key) => getFeatureFlagsStore().get(key);
const getFeatureFlags = (keys) => keys.map(key => getFeatureFlag(key));

class LocaleInstanceResolver {
    static Instantiate(localeInstance) {
        if (!this._localeInstance) {
            this._localeInstance = localeInstance;
        }
        return this._localeInstance;
    }
    static get Instance() {
        return this._localeInstance;
    }
}

function registerLogRocket() {
    if (window.LogRocket) {
        return;
    }
    const script = document.createElement('script');
    script.src = 'https://cdn.logr-ingest.com/LogRocket.min.js';
    script.type = 'text/javascript';
    script.crossOrigin = 'anonymous';
    document.getElementsByTagName('head')[0].appendChild(script);
    script.onload = function () {
        var _a;
        (_a = window.LogRocket) === null || _a === void 0 ? void 0 : _a.init('p9wbp4/uipath-user-research');
    };
}

class ThemeInstanceResolver {
    static Instantiate(themeInstance) {
        if (!this._themeInstance) {
            this._themeInstance = themeInstance;
        }
        return this._themeInstance;
    }
    static get Instance() {
        return this._themeInstance;
    }
}

function applyCustomSettings() {
    const queries = new URLSearchParams(window.location.search);
    const apTheme = queries.get('ap-theme');
    const apLocale = queries.get('ap-locale');
    const themeNeedsUpdate = !!(apTheme && apTheme !== ThemeInstanceResolver.Instance.theme && validateThemeCode(apTheme));
    const localeNeedsUpdate = !!(apLocale && apLocale !== LocaleInstanceResolver.Instance.locale && validateLanguageCode(apLocale));
    if (themeNeedsUpdate) {
        ThemeInstanceResolver.Instance.putThemeSettings(apTheme);
        ThemeInstanceResolver.Instance.overrideTheme = apTheme;
    }
    if (localeNeedsUpdate) {
        LocaleInstanceResolver.Instance.putLocaleSettings(apLocale);
        LocaleInstanceResolver.Instance.overrideLocale = apLocale;
    }
    if (themeNeedsUpdate || localeNeedsUpdate) {
        const url = new URL(window.location.href);
        url.searchParams.delete('ap-theme');
        url.searchParams.delete('ap-locale');
        window.history.replaceState({}, '', url.toString());
    }
}

var _a;
const currentGravatarStorageKey = STORAGE_KEYS.PORTAL_GRAVATAR;
const sessionStore = createStore({
    isSignInInitialized: false,
    isSignInSuccessful: false,
    selfAuthAccessToken: '',
    fullName: '',
    userId: '',
    email: '',
    avatarUrl: (_a = localStorage.getItem(currentGravatarStorageKey)) !== null && _a !== void 0 ? _a : '',
    organizationId: '',
    isHost: false,
    connectionType: '',
});
sessionStore.on('set', (key, newValue, oldValue) => {
    if (key === 'selfAuthAccessToken') {
        Logger.debug('store', `key: ${key}\noldValue: ${sanitizeToken(oldValue)} \nnewValue: ${sanitizeToken(newValue)} \n`, { state: store$1.state });
        return;
    }
    if (key === 'email' || key === 'fullName') {
        Logger.debug('store', `key: ${key}\noldValue: ${sanitizePii(oldValue)} \nnewValue: ${sanitizePii(newValue)} \n`, { state: store$1.state });
        return;
    }
    // Used to check hydration
    Logger.debug('store', `key: ${key}\noldValue: ${JSON.stringify(oldValue)} \nnewValue: ${JSON.stringify(newValue)} \n`, { state: store$1.state });
});
sessionStore.onChange('selfAuthAccessToken', async (accessToken) => {
    await handleAccessTokenChange(accessToken, { isSelfAuth: true });
});
sessionStore.onChange('userId', (userId) => {
    localStorage.setItem(STORAGE_KEYS.PORTAL_CURRENT_USER_ID, userId);
});
async function handleAccessTokenChange(accessToken, { isSelfAuth = false } = {}) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (isFalsyOrWhitespace(accessToken)) {
        return;
    }
    const success = decodeAccessToken(accessToken);
    if (!success) {
        return;
    }
    const prevUserId = (_a = AppInsightsInstanceResolver.Instance.getPlatformInfoField('cloudUserId')) !== null && _a !== void 0 ? _a : AppInsightsInstanceResolver.Instance.getPlatformInfoField('localUserId');
    const newUserId = sessionStore.get('userId');
    /**
    * This will help us debugging user issues via app insights easier (ask them to give us this information from the console)
    *
    * TODO: Make it even a better experience (like a button to copy to clipboard)
    */
    if (prevUserId !== newUserId) {
        Logger.info(['AppInsights Debug', 'Access Token Changed'], `New User Id / UserId: ${newUserId}`, { forcePrintToConsole: true });
    }
    // Set partial data of app insights based off access token info
    AppInsightsInstanceResolver.SetPlatformInfo({
        cloudUserId: newUserId,
        localUserId: newUserId,
        cloudOrganizationId: sessionStore.get('organizationId'),
        isHost: sessionStore.get('isHost'),
    });
    const tokenType = isSelfAuth ? 'session self auth' : 'passed-in';
    Logger.debug(['api', 'token'], `using ${tokenType} access token`, { state: store$1.state });
    const effectiveToken = getAccessToken(accessToken);
    Logger.debug(['account', 'api', 'featureFlags'], 'account and tenants, feature flags calls');
    await Promise.all([
        (_b = AccountAndTenantsInstanceResolver.Instance) === null || _b === void 0 ? void 0 : _b.fetchAccountAndTenants(false, effectiveToken, sessionStore.get('isHost')),
        window.PortalShell.FeatureFlags.fetchFeatureFlags(sessionStore, effectiveToken),
        (_c = ChatInstanceResolver.Instance) === null || _c === void 0 ? void 0 : _c.connectChat(accessToken),
    ]);
    // Requests that are dependent on the above other API requests
    Logger.debug(['language', 'theme', 'notifications'], 'language, theme, notifications calls');
    await Promise.all([
        ...(!isStandalone() ? [(_d = LocaleInstanceResolver.Instance) === null || _d === void 0 ? void 0 : _d.fetchLocaleSettings()] : []),
        ...(!isStandalone() ? [(_e = ThemeInstanceResolver.Instance) === null || _e === void 0 ? void 0 : _e.fetchThemeSettings()] : []),
        ...(!isStandalone() && getFeatureFlag(Features.EnableAccessibilityApi.name)
            ? [(_f = AccessibilityInstanceResolver.Instance) === null || _f === void 0 ? void 0 : _f.fetchAccessibilitySettings()]
            : []),
        ...(!isStandalone() && getFeatureFlag(Features.EnableAlertDuration.name)
            ? [(_g = AlertInstanceResolver.Instance) === null || _g === void 0 ? void 0 : _g.fetchAlertDurationSettings()]
            : []),
        ...(getFeatureFlag(Features.EnableNotification.name) ? [window.PortalShell.SignalRService.updateConnection()] : []),
        ...(getFeatureFlag(Features.EnableLeftRailExperiment.name) ? [(_h = AccountAndTenantsInstanceResolver.Instance) === null || _h === void 0 ? void 0 : _h.fetchFavorites()] : []),
        ...(getFeatureFlag(Features.EnableSAPEntitlements.name) ? [backfillEntitlements()] : []),
        applyCustomSettings(),
    ]);
    if (getFeatureFlag(Features.EnableLogRocketIntegration.name)) {
        registerLogRocket();
    }
}
function decodeAccessToken(accessToken) {
    var _a, _b, _c;
    let decodedToken = null;
    try {
        decodedToken = o(accessToken);
    }
    catch (e) {
        Logger.error(['store', 'token'], 'access token was invalid, Details : ' + e.toString());
    }
    if (decodedToken == null) {
        return false;
    }
    if (!decodedToken.scope) {
        Logger.warn('token', `Warning: The ID Token should not be passed. Please pass an access token to the token prop.`, { forcePrintToConsole: true });
    }
    const hasName = decodedToken.first_name || decodedToken.last_name;
    const fullName = hasName ? `${decodedToken.first_name} ${decodedToken.last_name}` : decodedToken.name;
    sessionStore.set('fullName', fullName);
    sessionStore.set('email', decodedToken.email);
    sessionStore.set('avatarUrl', decodedToken.picture);
    sessionStore.set('organizationId', decodedToken.prt_id);
    sessionStore.set('isHost', ((_a = decodedToken.host) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true');
    sessionStore.set('userId', decodedToken.sub);
    sessionStore.set('connectionType', (_c = (_b = decodedToken.ext_idp_disp_name) === null || _b === void 0 ? void 0 : _b.toLowerCase()) !== null && _c !== void 0 ? _c : '');
    GlobalEventEmitter.emitAccessTokenChanged({
        accessToken,
        organizationId: decodedToken.prt_id,
    });
    if (decodedToken.picture) {
        localStorage.setItem(currentGravatarStorageKey, decodedToken.picture);
    }
    return true;
}
// Internal use only
function getAccessToken(defaultToken) {
    const selfAuthAccessToken = sessionStore.get('selfAuthAccessToken');
    Logger.debug('session', `returning self auth access token, selfAuthAccessToken=${sanitizeToken(selfAuthAccessToken)} or defaultToken=${sanitizeToken(defaultToken)}`, { state: sessionStore.state });
    return selfAuthAccessToken || defaultToken || '';
}

function setModeSideEffect(store) {
    store.onChange('mode', async () => {
        var _a, _b;
        Logger.debug('featureFlags', 'mode changed, refreshing feature flags');
        await window.PortalShell.FeatureFlags.fetchFeatureFlags(sessionStore, getAccessToken());
        const local = isLocal();
        const standalone = isStandalone();
        // We only want to attempt sign in when there is an account name or we are passing in an organization standard url
        const hasAccountName = local
            || ((_b = (_a = GlobalPropsInstanceResolver.Instance) === null || _a === void 0 ? void 0 : _a.devProperties) === null || _b === void 0 ? void 0 : _b.organizationStandardUrl)
            || getAccountName();
        const session = window.PortalShell.Session;
        Logger.debug(['session', 'idle timeout'], `Session from mode side effect: hasAccountName=${hasAccountName}, isSignInInitialized: ${sessionStore.get('isSignInInitialized')}, isLocal: ${local}, isStandalone: ${standalone}`);
        if (!sessionStore.get('isSignInInitialized') && !standalone && hasAccountName) {
            Logger.debug('session', 'starting initialize');
            const success = await session.signInSilent();
            Logger.debug('session', `initialize complete, success: ${success}`);
        }
    });
}

// store is based on : https://stenciljs.com/docs/stencil-store
const store = createStore(defaultStoreValues);
store.on('set', (key, newValue, oldValue) => {
    // Used to check hydration
    Logger.debug('store', `key: ${key}\noldValue: ${JSON.stringify(oldValue)} \nnewValue: ${JSON.stringify(newValue)} \n`, { state: store.state });
});
setModeSideEffect(store);
const store$1 = store;

class GlobalPropsInstanceResolver {
    static Instantiate(globalPropsInstance) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        Logger.debug('GlobalPropsInstanceResolver', 'Instantiate', { object: globalPropsInstance });
        if (this._isCloudOrK8s() && !((_a = globalPropsInstance.devProperties) === null || _a === void 0 ? void 0 : _a.isMFERoot)) {
            (_b = globalPropsInstance.devProperties) === null || _b === void 0 ? true : delete _b.organizationStandardUrl;
            (_c = globalPropsInstance.devProperties) === null || _c === void 0 ? true : delete _c.tenant;
        }
        window.PortalShell.GlobalProperties.devProperties = globalPropsInstance.devProperties;
        window.PortalShell.GlobalProperties.featureFlagOverrides = globalPropsInstance.featureFlagOverrides;
        this._globalPropsInstance = globalPropsInstance;
        if (globalPropsInstance.featureFlagOverrides) {
            (_d = window.PortalShell.FeatureFlags) === null || _d === void 0 ? void 0 : _d.setOverrideFlags(globalPropsInstance.featureFlagOverrides);
        }
        if (((_e = globalPropsInstance.devProperties) === null || _e === void 0 ? void 0 : _e.debugMode) != null) {
            Logger.setDebugMode(!!((_f = globalPropsInstance.devProperties) === null || _f === void 0 ? void 0 : _f.debugMode));
        }
        if ((_g = globalPropsInstance.devProperties) === null || _g === void 0 ? void 0 : _g.organizationStandardUrl) {
            (_h = AccountAndTenantsInstanceResolver.Instance) === null || _h === void 0 ? void 0 : _h.fetchAccountAndTenants();
        }
        if (((_j = globalPropsInstance.devProperties) === null || _j === void 0 ? void 0 : _j.tenant) && !((_k = globalPropsInstance.devProperties) === null || _k === void 0 ? void 0 : _k.organizationStandardUrl)) {
            (_l = AccountAndTenantsInstanceResolver.Instance) === null || _l === void 0 ? void 0 : _l.updateCurrentTenant(globalPropsInstance.devProperties.tenant);
        }
        let mode = (_o = (_m = globalPropsInstance.devProperties) === null || _m === void 0 ? void 0 : _m.mode) !== null && _o !== void 0 ? _o : 'auto';
        if (mode.includes('msi')) {
            // eslint-disable-next-line no-console
            console.warn('MSI mode is no longer supported and will be converted to standalone');
            mode = 'standalone';
            this._globalPropsInstance.devProperties = Object.assign(Object.assign({}, this._globalPropsInstance.devProperties), { mode });
            window.PortalShell.GlobalProperties.devProperties = this._globalPropsInstance.devProperties;
        }
        store$1.set('mode', mode);
        return this._globalPropsInstance;
    }
    static get Instance() {
        return this._globalPropsInstance;
    }
    static updateDevProperties(devProperties) {
        var _a, _b;
        Logger.debug('GlobalPropsInstanceResolver', 'updateDevProperties', { object: devProperties });
        this._globalPropsInstance.devProperties = Object.assign(Object.assign({}, this._globalPropsInstance.devProperties), devProperties);
        window.PortalShell.GlobalProperties.devProperties = this._globalPropsInstance.devProperties;
        if (devProperties.organizationStandardUrl) {
            (_a = AccountAndTenantsInstanceResolver.Instance) === null || _a === void 0 ? void 0 : _a.fetchAccountAndTenants();
        }
        if (devProperties.tenant && !devProperties.organizationStandardUrl) {
            (_b = AccountAndTenantsInstanceResolver.Instance) === null || _b === void 0 ? void 0 : _b.updateCurrentTenant(devProperties.tenant);
        }
        let mode = devProperties.mode;
        if (mode) {
            if (mode.includes('msi')) {
                // eslint-disable-next-line no-console
                console.log('MSI mode is no longer supported and will be converted to standalone');
                mode = 'standalone';
                this._globalPropsInstance.devProperties.mode = mode;
                window.PortalShell.GlobalProperties.devProperties = this._globalPropsInstance.devProperties;
            }
            store$1.set('mode', mode);
        }
        if (devProperties.debugMode != null) {
            Logger.setDebugMode(!!devProperties.debugMode);
        }
    }
    static _isCloudOrK8s() {
        const environment = getEnvironment();
        return ['alp', 'stg', 'prd', 'agov', 'sgov', 'pgov', 'k8s'].includes(environment);
    }
}
GlobalPropsInstanceResolver._globalPropsInstance = {
    devProperties: { mode: 'auto' },
    featureFlagOverrides: {},
};

const isNonCloud = (env = getEnvironment()) => env === 'local'
    || env === 'k8s'
    || isStandalone();
const isLocal = (env = getEnvironment()) => {
    var _a, _b;
    return env === 'local'
        || (isNonCloud(env) && ((_b = (_a = GlobalPropsInstanceResolver.Instance) === null || _a === void 0 ? void 0 : _a.devProperties) === null || _b === void 0 ? void 0 : _b.mode) === 'dev-cloud');
};
const isStandalone = () => {
    var _a, _b;
    return ((_b = (_a = GlobalPropsInstanceResolver.Instance) === null || _a === void 0 ? void 0 : _a.devProperties) === null || _b === void 0 ? void 0 : _b.mode) === 'standalone';
};
function getEnvConfig(env = getEnvironment()) {
    return envConfigs[env] || {};
}
function getEnvConfigField(fieldName, env = getEnvironment(), enableLocalStorageOverrides = false) {
    var _a;
    let localStorageValue;
    try {
        localStorageValue = enableLocalStorageOverrides ? JSON.parse((_a = localStorage.getItem(`PORTAL_OVERRIDE_${fieldName}`)) !== null && _a !== void 0 ? _a : '') : undefined;
    }
    catch (error) {
        localStorageValue = undefined;
    }
    const config = getEnvConfig(env);
    return localStorageValue || config[fieldName] || undefined;
}

function getScopedUrl(organizationStandardUrl, tenantName, serviceType, scope, isStandAlone) {
    return isStandAlone
        ? `${organizationStandardUrl}/${serviceType}`
        : scope === Scope.Global
            ? `${organizationStandardUrl}/${serviceType}_`
            : `${organizationStandardUrl}/${tenantName}/${serviceType}_`;
}
function getMenuConfig({ tenantName, isHost, locale, }) {
    const isStandAlone = !!isStandalone();
    const organizationStandardUrl = getOrganizationStandardUrl({ isForServiceUrl: true });
    const { baseUrl, accountName, } = parseOrganizationStandardUrl(organizationStandardUrl);
    const standardUrl = isStandAlone ? baseUrl : organizationStandardUrl;
    Logger.debug('menu', `StandardUrl:${standardUrl}, Base Url: ${baseUrl}, accountName: ${accountName}, tenantName: ${tenantName}, locale: ${locale}, isStandAlone: ${isStandAlone}, isHost: ${isHost}`);
    return {
        services: [
            {
                id: SERVICE_IDS.home,
                name: t('home', { locale }),
                svg: 'home',
                scope: Scope.Global,
                serviceType: ServiceType.cloudRpa,
                url: `${getScopedUrl(standardUrl, tenantName, ServiceType.cloudRpa, Scope.Global, isStandAlone)}/home`,
                isPersistent: true,
            },
            {
                id: SERVICE_IDS.academy,
                name: 'Academy',
                svg: 'academy',
                scope: Scope.Global,
                serviceType: ServiceType.academy,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.academy, Scope.Global, isStandAlone),
                docId: 'academy',
            },
            {
                id: SERVICE_IDS.automationhub,
                name: 'Automation Hub',
                svg: 'automationhub',
                scope: Scope.Tenant,
                serviceType: ServiceType.automationHub,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.automationHub, Scope.Tenant, isStandAlone),
                docId: 'automation-hub',
            },
            {
                id: SERVICE_IDS.actions,
                name: 'Actions',
                svg: 'actions',
                scope: Scope.Tenant,
                serviceType: ServiceType.actions,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.actions, Scope.Tenant, isStandAlone),
                docId: 'action-center',
            },
            {
                id: SERVICE_IDS.apps,
                name: 'Apps',
                svg: 'apps',
                scope: Scope.Global,
                serviceType: ServiceType.apps,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.apps, Scope.Global, isStandAlone),
                docId: 'apps',
            },
            {
                id: SERVICE_IDS.chatbots,
                name: 'Chatbots',
                svg: 'chatbots',
                scope: Scope.Tenant,
                serviceType: ServiceType.chatBots,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.chatBots, Scope.Tenant, isStandAlone),
                docId: 'chatbots',
            },
            {
                id: SERVICE_IDS.customerportal,
                name: 'Customer Portal',
                svg: 'customerportal',
                scope: Scope.Global,
                serviceType: ServiceType.customerPortal,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.customerPortal, Scope.Global, isStandAlone),
                docId: 'customer-portal',
            },
            {
                id: SERVICE_IDS.entities,
                name: 'Entities',
                svg: 'entities',
                scope: Scope.Tenant,
                serviceType: ServiceType.entities,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.entities, Scope.Tenant, isStandAlone),
            },
            {
                id: SERVICE_IDS.orchestrator,
                name: 'Orchestrator',
                svg: 'orchestrator',
                scope: Scope.Tenant,
                serviceType: ServiceType.orchestrator,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.orchestrator, isHost ? Scope.Global : Scope.Tenant, // When host mode do not add tenant name to URL
                isStandAlone),
                showInHostAccount: true,
                docId: 'orchestrator',
            },
            {
                id: SERVICE_IDS.processes,
                name: 'Processes',
                svg: 'processes',
                scope: Scope.Tenant,
                serviceType: ServiceType.processes,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.processes, Scope.Tenant, isStandAlone),
            },
            {
                id: SERVICE_IDS.insights,
                name: 'Insights',
                svg: 'insights',
                scope: Scope.Tenant,
                serviceType: ServiceType.insights,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.insights, Scope.Tenant, isStandAlone),
                docId: 'insights',
            },
            {
                id: SERVICE_IDS.marketplace,
                name: 'Marketplace',
                svg: 'marketplace',
                scope: Scope.Global,
                serviceType: ServiceType.marketplace,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.marketplace, Scope.Global, isStandAlone),
                docId: 'marketplace',
            },
            {
                id: SERVICE_IDS.reinfer,
                name: getFeatureFlag(Features.EnableIXP.name) ? 'IXP' : 'Communications Mining',
                svg: 'reinfer',
                scope: Scope.Tenant,
                serviceType: ServiceType.reinfer,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.reinfer, Scope.Tenant, isStandAlone),
                docId: 'reinfer',
            },
            {
                id: SERVICE_IDS.testmanager,
                name: 'Test Manager',
                svg: 'testmanager',
                scope: Scope.Tenant,
                serviceType: ServiceType.testManager,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.testManager, Scope.Tenant, isStandAlone),
                docId: 'test-suite',
            },
            {
                id: SERVICE_IDS.integrations,
                name: 'Integration Service',
                svg: 'integrations',
                scope: Scope.Tenant,
                serviceType: ServiceType.integrations,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.integrations, Scope.Tenant, isStandAlone),
                docId: 'integrations',
            },
            {
                id: SERVICE_IDS.dataservice,
                name: 'Data Service',
                svg: 'dataservice',
                scope: Scope.Tenant,
                serviceType: ServiceType.dataservice,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.dataservice, Scope.Tenant, isStandAlone),
                docId: 'data-service',
            },
            {
                id: SERVICE_IDS.taskmining,
                name: 'Task Mining',
                svg: 'taskmining',
                scope: Scope.Tenant,
                serviceType: ServiceType.taskMining,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.taskMining, Scope.Tenant, isStandAlone),
                docId: 'task-mining',
            },
            {
                id: SERVICE_IDS.processmining,
                name: 'Process Mining',
                svg: 'processmining',
                scope: Scope.Tenant,
                serviceType: ServiceType.processMining,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.processMining, Scope.Tenant, isStandAlone),
                docId: 'process-mining',
            },
            {
                id: SERVICE_IDS.studio,
                name: 'Studio',
                svg: 'studio',
                scope: Scope.Global,
                serviceType: ServiceType.studio,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.studio, Scope.Global, isStandAlone),
                docId: 'studio',
            },
            {
                id: SERVICE_IDS.roboticsops,
                name: 'Automation Ops',
                svg: 'roboticsops',
                scope: Scope.Global,
                serviceType: ServiceType.roboticsOps,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.roboticsOps, Scope.Global, isStandAlone),
                docId: 'automation-ops',
            },
            {
                id: SERVICE_IDS.du,
                name: 'Document Understanding',
                svg: 'du',
                scope: Scope.Tenant,
                serviceType: ServiceType.du,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.du, Scope.Tenant, isStandAlone),
                docId: 'document-understanding',
            },
            {
                id: SERVICE_IDS.aifabric,
                name: 'AI Center',
                svg: 'aifabric',
                scope: Scope.Tenant,
                serviceType: ServiceType.aifabric,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.aifabric, Scope.Tenant, isStandAlone),
                docId: 'ai-fabric',
            },
            {
                id: SERVICE_IDS.admin,
                name: t('admin', { locale }),
                svg: 'admin',
                scope: Scope.Global,
                serviceType: ServiceType.cloudRpa,
                url: `${getScopedUrl(standardUrl, tenantName, ServiceType.cloudRpa, Scope.Global, isStandAlone)}/${isHost ? 'organizations' : 'admin'}`,
                showInHostAccount: true,
                isPersistent: true,
            },
            {
                id: SERVICE_IDS.automationstore,
                name: 'Automation Store',
                svg: 'automationstore',
                scope: Scope.Tenant,
                serviceType: ServiceType.automationStore,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.automationStore, Scope.Tenant, isStandAlone),
            },
            {
                id: SERVICE_IDS.docs,
                name: 'Documentation',
                svg: 'docs',
                scope: Scope.Global,
                serviceType: ServiceType.docs,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.docs, Scope.Global, isStandAlone),
            },
            {
                id: SERVICE_IDS.agents,
                name: 'Agents',
                svg: 'agents',
                scope: Scope.Global,
                serviceType: ServiceType.agents,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.agents, Scope.Global, isStandAlone),
            },
            {
                id: SERVICE_IDS.assistant,
                name: 'Assistant',
                svg: 'assistant',
                scope: Scope.Global,
                serviceType: ServiceType.assistant,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.assistant, Scope.Global, isStandAlone),
            },
            {
                id: SERVICE_IDS.agenticorchestration,
                name: getFeatureFlag(Features.EnableMaestro.name) ? 'Maestro' : 'Agentic Orchestration',
                svg: getFeatureFlag(Features.EnableMaestro.name) ? 'maestro' : 'agenticorchestration',
                scope: Scope.Tenant,
                serviceType: ServiceType.agenticorchestration,
                url: getScopedUrl(standardUrl, tenantName, ServiceType.agenticorchestration, Scope.Tenant, isStandAlone),
            },
        ],
    };
}
const getMoreTileProps = (locale) => ({
    id: 'more',
    name: t('more_products', { locale }),
    svg: 'more',
    scope: Scope.Global,
    serviceType: ServiceType.cloudRpa,
    url: '',
});

function isFalsyOrWhitespace(str = '') {
    return !(str === null || str === void 0 ? void 0 : str.trim());
}
function parseArrayProps(prop) {
    var _a, _b;
    return (_b = (_a = prop === null || prop === void 0 ? void 0 : prop.split) === null || _a === void 0 ? void 0 : _a.call(prop, ',').map(s => s.toLowerCase().trim())) !== null && _b !== void 0 ? _b : [];
}
function caseInsensitiveCompare(str1, str2) {
    return str1.toLowerCase() === str2.toLowerCase();
}
function isDefined(value) {
    return typeof value !== 'undefined' && value != null;
}
const isString = (value) => typeof value === 'string';
const isNonEmptyString = (value) => isString(value) && value.length > 0;
const getCircularReplacer = () => {
    const seen = new WeakSet();
    return (_, value) => {
        if (typeof value === 'object' && value != null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    };
};
const getScopedUrlFromDevProps = (serviceType, scope, tenant) => {
    var _a, _b, _c, _d;
    const isStandAlone = !!isStandalone();
    const organizationStandardUrl = getOrganizationStandardUrl();
    const tenantName = (_d = (_c = tenant !== null && tenant !== void 0 ? tenant : (_b = (_a = GlobalPropsInstanceResolver.Instance) === null || _a === void 0 ? void 0 : _a.devProperties) === null || _b === void 0 ? void 0 : _b.tenant) !== null && _c !== void 0 ? _c : getTenantName()) !== null && _d !== void 0 ? _d : '';
    const { baseUrl } = parseOrganizationStandardUrl(organizationStandardUrl !== null && organizationStandardUrl !== void 0 ? organizationStandardUrl : '');
    const standardUrl = isStandAlone ? baseUrl : organizationStandardUrl;
    return getScopedUrl(standardUrl, tenantName, serviceType, scope, isStandAlone);
};
/**
 * `parseOrReturn(item, fallback)` helps in the case where `item` could be a valid object _or_ a string that should be parsed.
 * This is a common case with the Stencil property API.
 *
 * - If `item` is not a string, `item` will be returned
 * - If `item` is a string, and it is successfully parsed, the parsed object will be returned
 * - If `item` is a string, and parse fails, the `fallback` item will be returned.
 */
const parseOrReturn = (item, fallback) => {
    if (typeof item === 'string') {
        try {
            return JSON.parse(item);
        }
        catch (err) {
            Logger.error('utils', `Error parsing ${item}: ${err}`, { printToConsoleOnly: true });
            return fallback;
        }
    }
    return item;
};
/**
 * Helper function to sanitize a token for logs
 */
const sanitizeToken = (token) => {
    if (!!token && !isString(token)) {
        return '<invalid>';
    }
    return isFalsyOrWhitespace(token) ? '<empty>' : '<token>';
};
const sanitizePii = (pii) => isFalsyOrWhitespace(pii) ? '<empty>' : '<pii>';
const sanitizeEmail = (message) => {
    if (!message || !isString(message)) {
        return '<invalid>';
    }
    // eslint-disable-next-line spaced-comment
    const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/g; //NOSONAR email is from error message
    return message.replace(emailRegex, '<email-pii>');
};
const removeObjectUndefinedProperties = (obj) => {
    const tempObj = Object.assign({}, obj);
    Object.entries(tempObj).forEach(([key, value]) => {
        if (value == null) {
            delete tempObj[key];
        }
    });
    return tempObj;
};
const translatedContactSalesUrl = (locale) => {
    switch (locale.toLowerCase()) {
        case LanguageCodes.zhCn:
            return 'https://www.uipath.com.cn/company/contact-us/';
        case LanguageCodes.ja:
        case LanguageCodes.de:
        case LanguageCodes.fr:
        case LanguageCodes.ko:
        case LanguageCodes.ru:
        case LanguageCodes.tr:
            return 'https://www.uipath.com/' + locale + '/company/contact-us';
        case LanguageCodes.es:
        case LanguageCodes.esMx:
            return 'https://www.uipath.com/es/company/contact-us';
        case LanguageCodes.pt:
        case LanguageCodes.ptBr:
            return 'https://www.uipath.com/pt/company/contact-us';
        default:
            return 'https://www.uipath.com/company/contact-us';
    }
};
const capitalizeFirstLetter = (key) => {
    var _a, _b;
    return ((_a = key === null || key === void 0 ? void 0 : key.charAt(0)) === null || _a === void 0 ? void 0 : _a.toUpperCase()) + ((_b = key === null || key === void 0 ? void 0 : key.slice(1)) === null || _b === void 0 ? void 0 : _b.toLowerCase());
};

const home$b = "Start";
const help$b = "Hilfe";
const languages$b = "Sprachen";
const language$b = "Sprache";
const edit$b = "Bearbeiten";
const enter$b = "Eingabe";
const theme$b = "Design";
const logout$b = "Abmelden";
const tenants$b = "Mandanten";
const more$b = "Mehr";
const admin$b = "Admin";
const autoTheme$b = "Design autom. auswählen";
const dark$b = "Dunkles Design";
const light$b = "Helles Design";
const dismiss$b = "Verwerfen (Dismiss)";
const warning$b = "Warnung";
const info$b = "Info";
const success$b = "Erfolg";
const error$b = "Fehler";
const more_items$b = "Weitere Elemente";
const notifications$b = "Benachrichtigungen";
const preview$b = "Vorschau";
const more_products$b = "Weitere Optionen";
const current_plan_upgrade$b = "Sie nutzen einen {{ license }}-Plan.";
const free_license$b = "Kostenlos";
const community_license$b = "Community";
const pro_trial_license$b = "Pro-Testversion";
const unlicensed$b = "Nicht lizenziert";
const back$b = "Zurück";
const trademark$b = "TM";
const basic_auth_user$b = "Lokaler Benutzer";
const local_group$b = "Lokale Gruppe";
const robot$b = "Roboter";
const directory_group$b = "Verzeichnisgruppe";
const directory_user$b = "Verzeichnisbenutzer";
const directory_app$b = "Verzeichnis-App";
const build$b = "Erstellen";
const discover$b = "Discover";
const operate$b = "Bedienen";
const feedback$b = "Feedback";
const cancel$b = "Abbrechen";
const confirm$b = "Bestätigen";
const favorites$b = "Favoriten";
const apply$a = "Anwenden";
const date$a = "Datum";
const time$a = "Uhrzeit";
const de = {
	home: home$b,
	help: help$b,
	languages: languages$b,
	language: language$b,
	edit: edit$b,
	"edit-subject": "{{ subject }} bearbeiten",
	enter: enter$b,
	theme: theme$b,
	logout: logout$b,
	tenants: tenants$b,
	more: more$b,
	admin: admin$b,
	autoTheme: autoTheme$b,
	dark: dark$b,
	light: light$b,
	"light-hc": "Design mit hohem Kontrast",
	"dark-hc": "Design mit hohem Kontrast",
	"close-button": "Schaltfläche „Schließen“",
	"client-days": "{{ differenceInDays }} verbleibende Tage",
	"client-hours": "{{ differenceInHours }} verbleibende Stunden",
	"dropdown-placeholder": "Wählen Sie eine Option aus.",
	"empty-tenant-list-placeholder": "Kein gültiger Mandant",
	"tenant-picker-label": "Mandant:",
	"tenant-picker-list": "Mandant",
	"error-page-401-header": "Nicht autorisiert",
	"error-page-403-header": "Sie stehen nicht auf der Liste.",
	"error-page-403-description": "Sie haben keine Berechtigung zum Anzeigen von {{ pageTitle }}. Wenden Sie sich an Ihren Administrator, um die erforderlichen Berechtigungen zu erhalten.",
	"error-page-404-header": "Kann leider nicht gefunden werden.",
	"error-page-404-description": "Die Seite, die Sie suchen, wurde möglicherweise entfernt, ihr Name wurde geändert, oder sie ist vorübergehend nicht verfügbar.",
	"error-page-503-header": "Der Zugriff ist in Kürze wieder möglich.",
	"error-page-503-description": "Das System wird gewartet. Updates werden in diesem Bereich angezeigt.",
	"error-page-browser-header": "Dieser Browser wird nicht unterstützt.",
	"error-page-endie-header": "Internet Explorer eingestellt",
	"error-page-endie-description": "Die Unterstützung für Internet Explorer endete am 31. Mai 2021. Für UiPath empfehlen wir die aktuelle Version von Chrome, Firefox, Safari oder Edge.",
	"error-page-ip-restricted-header": "Zugriff eingeschränkt",
	"error-page-ip-restricted-description": "Aufgrund von Organisationsrichtlinien können Sie von diesem Netzwerkspeicherort aus nicht auf {{ pageTitle }} zugreifen. Wenden Sie sich an Ihren Administrator.",
	"error-page-learn-more": "Weitere Informationen",
	"error-page-learn-why": "Ursache",
	"error-page-loader-header": "Bitte warten Sie, während wir alles für Sie vorbereiten.",
	"error-page-loader-description": "Dieser Vorgang kann einige Minuten dauern. Die Seite wird aktualisiert, wenn die Plattform einsatzbereit ist.",
	"error-page-goto-home": "Zum Start",
	"error-page-goto-uipath-website": "Zur UiPath-Website",
	"error-page-check-service": "Dienststatus überprüfen",
	"error-page-know-why": "Fehlerursache",
	"aria-label-logo": "Das offizielle Logo von UiPath. Beim Anklicken wird die {{ serviceName }}-Startseite geöffnet.",
	"aria-label-logo-v2": "UiPath Automation Cloud-Logo, das Anklicken führt zur {serviceName}-Startseite.",
	"language-na": "Sprache wird für diesen Dienst nicht unterstützt.",
	dismiss: dismiss$b,
	warning: warning$b,
	info: info$b,
	success: success$b,
	error: error$b,
	"client-days-per-service": "Ihre Testversion ist noch {{ differenceInDays }} Tage verfügbar.",
	"client-days-per-service-with-name": "Sie können Ihre kostenlose Testversion von {{ serviceName }} noch {{ differenceInDays }} Tage nutzen.",
	"client-hours-per-service": "Ihre Testversion ist noch {{ differenceInHours }} Stunden verfügbar.",
	"client-hours-per-service-with-name": "Sie können Ihre kostenlose Testversion von {{ serviceName }} noch {{ differenceInHours }} Stunden nutzen.",
	"waffle-label": "App-Startprogramm",
	"generic-error-message": "Ein unerwarteter Fehler ist aufgetreten. Versuchen Sie es später noch einmal.",
	"help-menu-documentation": "Dokumentation",
	"help-menu-product-documentation": "{{ product }}-Dokumentation",
	"help-menu-downloads": "Downloads",
	"help-menu-forum": "Community-Forum",
	"help-menu-training-tutorials": "Schulungen und Tutorials",
	"help-menu-uipath-academy": "UiPath Academy",
	"help-menu-youtube-tutorials": "YouTube-Tutorials",
	"help-menu-release-notes": "Versionshinweise",
	"help-menu-resources": "Ressourcen",
	"help-menu-support": "Support",
	more_items: more_items$b,
	notifications: notifications$b,
	"notifications-empty": "Keine Benachrichtigungen gefunden",
	"notifications-all-read": "Alle als gelesen markieren",
	"notifications-unread": "Als ungelesen markieren",
	"notifications-read": "Als gelesen markieren",
	"notifications-delete": "Löschen",
	"notifications-mute": "{{ topicOrTenant }} abbestellen",
	"notifications-muted": "Erfolg: Sie haben {{ topicOrTenant }}-Benachrichtigungen abbestellt.",
	"notifications-unread-only": "Nur ungelesen",
	"notifications-settings": "Benachrichtigungseinstellungen",
	"notifications-page": "Seite „Benachrichtigungen“",
	"notifications-clear-all": "Alle löschen",
	"notifications-end-list": "Ende der Liste",
	"notifications-expandCollapse": "Erweitern/Reduzieren",
	"notifications-fetch-failure": "Benachrichtigungen konnten nicht abgerufen werden. Versuchen Sie es später noch einmal.",
	preview: preview$b,
	"unread-notifications-count": "{{ count }} ungelesene Benachrichtigungen",
	"people-picker-default-placeholder": "Anhand des Namens oder der E-Mail-Adresse suchen",
	"people-picker-groups-placeholder": "Anhand des Gruppennamens suchen",
	"people-picker-single-mode-placeholder": "Anhand des Namens oder der E-Mail-Adresse suchen",
	"people-picker-single-mode-ad-helper-text": "Anhand von Name, E-Mail-Adresse oder Domäne\\SAMKontoname suchen",
	"people-picker-single-mode-aad-helper-text": "Anhand von Name oder E-Mail-Adresse, Gruppenname oder App-Name suchen",
	"people-picker-default-helper-text": "Suchen Sie anhand des Namens, oder geben Sie durch Komma oder Semikolon getrennte E-Mail-Adressen ein. Sie können \\ als Escape-Zeichen für Sonderzeichen verwenden.",
	"people-picker-aad-helper-text": "Suchen Sie anhand des Namens, oder geben Sie durch Komma oder Semikolon getrennte E-Mail-Adressen ein. Sie können \\ als Escape-Zeichen für Sonderzeichen verwenden.",
	"people-picker-ad-ldap-helper-text": "Suchen Sie anhand des Namens, oder geben Sie durch Komma oder Semikolon getrennte E-Mail-Adressen oder Namen im Format „Domäne\\SAMKontoname“ ein. Sie können \\ als Escape-Zeichen für Sonderzeichen verwenden.",
	"people-picker-invalid-error-helper": "Verwenden Sie eine gültige E-Mail-Adresse.",
	"people-picker-resolve-error-helper": "Einige Einträge konnten nicht aufgelöst werden. Entfernen Sie sie, oder versuchen Sie es später noch einmal.",
	"people-picker-resolve-error-tooltip": "Eintrag konnte nicht aufgelöst werden. Entfernen Sie ihn, oder versuchen Sie es später erneut.",
	"people-picker-domain-picker-helper": "Domäne auswählen",
	"people-picker-too-many-entities": "Sie können jeweils nur {{ maxValue }} Entitäten hinzufügen.",
	"people-picker-more-info": "Weitere Informationen",
	"autocomplete-no-results": "Keine übereinstimmenden Ergebnisse für „{{ query }}“",
	"autocomplete-limit-exceeded": "Grenzwert von {limit} überschritten",
	"autocomplete-search-text": "Zum Suchen eingeben …",
	"autocomplete-no-results-people-picker": "Keine übereinstimmenden Ergebnisse für „{ query }“",
	"autocomplete-loading": "Wird geladen ...",
	"people-picker-add-users": "Namen",
	"people-picker-add-groups": "Gruppen",
	"people-picker-add-apps": "Apps",
	"people-picker-add-names": "Namen",
	"tenant-picker-aria-label": "Wählen Sie den Mandanten aus. Aktuell: ",
	"people-picker-duplicate-chip": "Es gibt einige doppelte Einträge. Entfernen Sie eines der Duplikate, und versuchen Sie es erneut.",
	"profile-navigation": "Einstellungen",
	"remove-chip": "„{{ value }}“ entfernen",
	"default-cobranding-logo-alt-text": "Cobranding-Logo",
	"canary-tenant": "Canary",
	more_products: more_products$b,
	current_plan_upgrade: current_plan_upgrade$b,
	free_license: free_license$b,
	community_license: community_license$b,
	pro_trial_license: pro_trial_license$b,
	"notification-action-menu-text": "Aktion bei Benachrichtigung",
	"notification-allaction-menu-text": "Weitere Aktionen für alle Benachrichtigungen",
	"buy-now": "Jetzt kaufen",
	"contact-sales": "Vertrieb kontaktieren",
	"skip-content": "Zu Hauptinhalten springen",
	"object-picker-add-entry": "„{{ entry }}“ hinzufügen",
	"start-free-trial-header": "Starten Sie Ihre",
	"sixty-days-trial": "60-tägige Testversion",
	"with-uipath-cloud": "mit UiPath Automation Cloud",
	"take-advantage-capabilities": "Profitieren Sie von unseren umfassenden Automation Cloud-Funktionen.",
	"upgrade-to-enterprise": "Müssen Sie Ihr Automatisierungsprogramm mit unternehmensgerechter Governance, Sicherheit und mehr skalieren?",
	"trial-benefit-one": "Roboter zur Aktivierung der Remote-Ausführung nach Bedarf",
	"trial-benefit-two": "Rund-um-die-Uhr-Support von UiPath",
	"trial-benefit-three": "Betriebszeitgarantie",
	"trial-benefit-four": "Mehrere Mandanten, die jeweils in einer beliebigen unserer Regionen gehostet werden",
	"view-pricing": "Preise anzeigen",
	"upgrade-trial-role": "Berufsbezeichnung",
	"upgrade-trial-company-name": "Name des Unternehmens/der Organisation",
	"upgrade-trial-business-email": "E-Mail-Adresse (geschäftlich)",
	"notifications-clear-message": "Benachrichtigungselement wurde gelöscht",
	"session-expiring": "Sitzung läuft ab",
	"session-expiring-description-inactive-hours": "Sie waren {{hours}} Stunden und {{minutes}} Minuten inaktiv.",
	"session-expiring-description-inactive": "Sie waren {{minutes}} Minuten lang inaktiv.",
	"session-expiring-description-logged-out": "Sie werden in {{n}} Sekunden abgemeldet.",
	"extend-session": "Sitzung verlängern",
	"dropdown-position": "{{index}} von {{total}}",
	unlicensed: unlicensed$b,
	"copy-clipboard": "In die Zwischenablage kopieren",
	"people-picker-search-entries": "{{count}} Suchergebnisse für „{{query}}“ gefunden",
	"app-bar-aria-label": "App-Leiste",
	"nav-aria-label": "Linke Navigation",
	"chat-no-messages": "Geben Sie unten eine Nachricht ein, um den Chat zu starten.",
	"chat-type-a-message": "Nachricht eingeben",
	"filter-service": "Dienst:",
	"filter-severity": "Schweregrad:",
	"priority-low": "Niedrig",
	"priority-medium": "Mittel",
	"priority-high": "Hoch",
	"priority-critical": "Kritisch",
	"filter-option-all": "Alle",
	"severity-info": "Info",
	"severity-success": "Erfolg",
	"severity-warn": "Warnen",
	"severity-error": "Fehler",
	"severity-fatal": "Schwerwiegend",
	"breadcrumb-aria-label-default": "Breadcrumb",
	back: back$b,
	"switching-orgs": "Organisation wechseln",
	"switching-orgs-description": "Sie versuchen, für die Organisation von {{ oldOrg }} zu {{ newOrg }}zu wechseln. Melden Sie sich zunächst ab, um fortfahren zu können.",
	"business-email-required": "Für das Upgrade auf Pro Trial ist eine geschäftliche E-Mail-Adresse erforderlich.",
	"check-inbox-for-invite-link": "Suchen Sie in Ihrem Posteingang nach einem Einladungslink und akzeptieren Sie diesen, um das Upgrade abzuschließen.",
	"invite-business-email-help": "Wenn Sie bereits mit dieser E-Mail-Adresse Mitglied der Organisation sind, melden Sie sich einfach bei Ihrem Konto an, um fortzufahren.",
	"check-email-for-invite": "Überprüfen Sie in Ihren Posteingang auf eine Einladung.",
	"check-email-for-invite-description": "Wenn Sie die Einladung nicht finden können, überprüfen Sie Ihren Spam-Ordner. Nachdem Sie die Einladung angenommen haben, können Sie ein Upgrade auf Pro Trial durchführen.",
	"no-minimum-purchase": "Keine Mindestabnahme.",
	"view-details-trial-plan": "Details zu allen in einer 60-tägigen Testversion des Pro-Plans enthaltenen Komponenten anzeigen",
	"get-more-cloud": "UiPath Automation Cloud besser nutzen",
	"start-free-trial": "Kostenlose Testversion starten",
	trademark: trademark$b,
	"send-invite": "Einladung senden",
	"support-id": "Support-ID",
	basic_auth_user: basic_auth_user$b,
	local_group: local_group$b,
	robot: robot$b,
	directory_group: directory_group$b,
	directory_user: directory_user$b,
	directory_app: directory_app$b,
	"unified-admin-button-label": "Zugriff verwalten",
	"unified-search-placeholder": "UiPath Marketplace und Dokumentation durchsuchen",
	"unified-search-placeholder-v2": "Suchen Sie nach Komponenten, Seiten und mehr",
	"unified-search-recent-searches": "Letzte Suchvorgänge",
	"unified-search-recent-pages-visited": "Besuchte Seiten",
	"unified-search-recent-resources-visited": "Besuchte Ressourcen",
	"unified-search-no-recent-searches": "Keine aktuellen Suchvorgänge, geben Sie mindestens 3 Zeichen ein, um Ergebnisse abzurufen.",
	"unified-search-no-recent-searches-logographic-locales": "Keine aktuellen Suchvorgänge, geben Sie mindestens 1 Zeichen ein, um Ergebnisse abzurufen.",
	"unified-search-marketplace": "UiPath-Marktplatz",
	"unified-search-documentation": "Dokumentation",
	"unified-search-open-product": "Wird in {product} geöffnet",
	"unified-search-change-search-terms": "Versuchen Sie, Ihre Suchbegriffe zu ändern.",
	"unified-search-no-results-found": "Es wurden keine Ergebnisse für „{term}“ gefunden.",
	"unified-search-footer": "Nicht die von Ihnen erwarteten Ergebnisse? {feedbackLink} oder {learnMoreLink}",
	"unified-search-footer-no-feedback": "Nicht die von Ihnen erwarteten Ergebnisse? {learnMoreLink}",
	"unified-search-footer-give-feedback": "Nicht die von Ihnen erwarteten Ergebnisse? {feedbackLink}",
	"unified-search-documentation-link": "Suchen Sie in der Dokumentation nach „{query}“",
	"unified-search-downloads": "{count} Downloads",
	"unified-search-runs": "{count} Ausführungen",
	"unified-search-all": "Alle",
	"unified-search-see-all": "Alle anzeigen",
	"unified-search-clear-button": "Löschen",
	"unified-search-filter": "Filter",
	"unified-search-all-count": "Alle ({count})",
	"unified-search-components-count": "Komponenten ({count})",
	"unified-search-pages-count": "Seiten ({count})",
	"unified-search-tags": "Tags: {tagList}",
	"learn-more": "Weitere Informationen",
	"my-workspace": "Mein Arbeitsbereich",
	"give-feedback": "Feedback geben",
	"ap-autocomplete-input-no-results": "Keine übereinstimmenden Ergebnisse für „{query}“",
	"ap-dropdown-placeholder": "Auswählen…",
	"ap-date-picker-placeholder": "Datum auswählen",
	"ap-time-picker-placeholder": "Zeit auswählen",
	"ap-date-picker-selected-day-label": "{day} ausgewählt",
	"ap-breadcrumb-overflow-label": "Breadcrumb – ausgeblendete Links",
	"unified-search-Studio": "Studio",
	"unified-search-AiCenter": "AI Center",
	"unified-search-Assistant": "Assistant",
	"unified-search-ProcessMining": "Process Mining",
	"unified-search-BusinessSolutions": "Partnerlösungen",
	"unified-search-UiPathApps": "Apps",
	"unified-search-IntegrationServices": "Integration Service",
	"unified-search-StudioX": "StudioX",
	"unified-search-ProfessionalServices": "Professionelle Services",
	"unified-search-Accelerator": "Beschleuniger",
	"unified-search-StudioWeb": "Studio Web",
	"unified-search-AutomationOps": "Automation Ops",
	"unified-search-DocumentUnderstanding": "Document Understanding",
	"unified-search-Insights": "Insights",
	"unified-search-Other": "Sonstige",
	"unified-search-Activity": "Aktivitäten",
	"unified-search-CustomActivity": "Aktivitäten",
	"unified-search-Snippet": "Snippets",
	"unified-search-WorkflowTemplate": "Vorlagen",
	"unified-search-Connector": "Connectors",
	"unified-search-Tool": "Tools",
	"unified-search-MLModel": "ML-Modelle",
	"unified-search-Solution": "Lösungen",
	"unified-search-Process": "Sofort einsatzbereite Automatisierungen",
	"unified-search-Widget": "Widget",
	"unified-search-BusinessSolution": "Partnerlösungen",
	"unified-search-App": "Apps",
	"unified-search-UiPathAppSolution": "App-Lösungen",
	"unified-search-UiPathAppTemplate": "App-Vorlagen",
	"unified-search-IntegrationServiceConnector": "Integration Service-Connector",
	"unified-search-StudioXWorkflowTemplate": "Vorlagen",
	"unified-search-ProfessionalService": "Professioneller Service",
	"unified-search-StudioWebTemplate": "Studio Web-Vorlage",
	"unified-search-AutomationOpsPipeline": "Pipelines",
	"unified-search-AutomationOpsPipelineTemplate": "Pipeline-Vorlagen",
	"unified-search-ExtractionModel": "Extraktionsmodelle",
	"unified-search-marketplace-studio-activity": "Studio-Aktivität",
	"unified-search-marketplace-studio-snippet": "Studio-Snippet",
	"unified-search-marketplace-studio-workflowtemplate": "Studio-Vorlage",
	"unified-search-marketplace-studio-connector": "Connectors (Legacy)",
	"unified-search-marketplace-studio-tool": "Studio-Tool",
	"unified-search-marketplace-studio-solution": "Studio-Lösung",
	"unified-search-marketplace-studioweb-studiowebtemplate": "Studio Web-Vorlage",
	"unified-search-marketplace-studiox-studioxworkflowtemplate": "Studio X-Vorlage",
	"unified-search-marketplace-assistant-process": "Sofort einsatzbereite Automatisierung",
	"unified-search-marketplace-aicenter-mlmodel": "ML-Modell",
	"unified-search-marketplace-processmining-app": "Process Mining-App-Vorlage",
	"unified-search-marketplace-uipathapps-uipathappsolution": "App-Lösung",
	"unified-search-marketplace-uipathapps-uipathapptemplate": "App-Vorlage",
	"unified-search-marketplace-integrationservices-integrationserviceconnector": "Connectors",
	"unified-search-marketplace-accelerator-accelerator": "Beschleuniger",
	"unified-search-marketplace-businesssolutions-businesssolution": "Partnerlösung",
	"unified-search-marketplace-professionalservices-professionalservice": "Professionelle Services",
	"unified-search-orchestrator-asset": "Asset",
	"unified-search-orchestrator-process": "Prozess",
	"unified-search-orchestrator-trigger": "Trigger",
	"unified-search-orchestrator-queue": "Warteschlange",
	"unified-search-orchestrator-bucket": "Bucket",
	"unified-search-orchestrator-actioncatalog": "Aktionskatalog",
	"unified-search-orchestrator-machine": "Maschine",
	"unified-search-orchestrator-webhook": "Webhook",
	"unified-search-integrationservice-connection": "Verbindung",
	"unified-search-integrationservice-trigger": "Trigger",
	"unified-search-dataservice-entity": "Entität",
	"unified-search-dataservice-choiceset": "Auswahlsatz",
	"unified-search-apps-app": "Apps",
	"unified-search-loading-search-results": "Suchergebnisse werden geladen…",
	"rich-text-editor-format-bold": "Fett formatieren",
	"rich-text-editor-bold": "Fett",
	"rich-text-editor-format-italic": "Formatierung: kursiv",
	"rich-text-editor-italic": "Kursiv",
	"rich-text-editor-format-underline": "Formatierung: unterstrichen",
	"rich-text-editor-underline": "Unterstrichen",
	"rich-text-editor-format-strikethrough": "Format – durchgestrichen",
	"rich-text-editor-strikethrough": "Durchgestrichen",
	"rich-text-editor-format-ordered-list": "Formatierung: sortierte Liste",
	"rich-text-editor-ordered-list": "Sortierte Liste",
	"rich-text-editor-format-unordered-list": "Formatierung: unsortierte Liste",
	"rich-text-editor-unordered-list": "Unsortierte Liste",
	"rich-text-editor-insert-link": "Link einfügen",
	"rich-text-editor-link": "Link",
	"rich-text-editor-format-code": "Formatierung: Code",
	"rich-text-editor-code": "Code",
	"ap-text-field-placeholder": "Wert eingeben",
	"notification-message-template": "{{ topic }} in {{ tenantName }}",
	build: build$b,
	discover: discover$b,
	operate: operate$b,
	feedback: feedback$b,
	"give-us-feedback": "Feedback geben",
	cancel: cancel$b,
	confirm: confirm$b,
	favorites: favorites$b,
	"favorites-limit-reached": "Grenzwert erreicht: Sie können höchstens 3 Elemente hinzufügen.",
	"favorites-description": "Ihre bevorzugten Produkte werden hier angezeigt. Sie können maximal 3 Elemente hinzufügen.",
	"default-toggle": "Schalter umschalten",
	"default-progress-spinner": "Laden des Inhalts",
	"default-icon-button": "Symbolschaltfläche",
	"default-radio-group": "Radiogruppe",
	"default-checkbox": "Kontrollkästchen",
	"default-stepper-clickable": "mit anklickbaren Schritten",
	"default-stepper-disabled": "mit deaktivierten Schritten",
	"new-navigation": "Neue Navigation",
	"product-launcher-tooltip": "Produktstartprogramm",
	"autopilot-tooltip": "Autopilot",
	"notifications-tooltip": "Benachrichtigungen",
	"search-tooltip": "Suchen",
	"help-tooltip": "Hilfe",
	"profile-tooltip": "Profil",
	apply: apply$a,
	date: date$a,
	time: time$a,
	"date-range": "Datumsbereich:",
	"date-range-label": "Datumsbereich",
	"date-time-label": "DateTime",
	"date-time-picker-label": "Datums-/Zeitauswahl",
	"date-range-start": "Starten",
	"date-range-end": "Ende",
	"date-range-presets": "Voreinstellungen",
	"date-range-picker-last-hour": "Letzte Stunde",
	"date-range-picker-today": "Heute",
	"date-range-picker-last-seven-days": "Vergangene 7 Tage",
	"date-range-picker-last-two-weeks": "Letzte 2 Wochen",
	"date-range-picker-last-month": "Letzter Monat",
	"date-range-picker-last-six-months": "Letzte 6 Monate",
	"date-range-picker-custom": "Benutzerdefiniert",
	"date-range-picker-start-tooltip": "Startdatum darf nicht nach Enddatum liegen",
	"date-range-picker-label": "Selektor für Datumsbereich",
	"time-selector": "Selektor für Uhrzeit",
	"date-range-picker-options": "Optionen für den Datumsbereich",
	"no-options": "Keine Optionen",
	"type-to-search": "Zum Suchen eingeben …",
	"autopilot-chat-header": "Autopilot",
	"autopilot-chat-input-placeholder": "Was soll ich tun?",
	"autopilot-chat-footer": "Autopilot kann Fehler machen. Überprüfen Sie die Antworten sorgfältig.",
	"autopilot-chat-new-chat": "Neuer Chat",
	"autopilot-chat-close": "Schließen",
	"autopilot-chat-attach-file": "Datei(en) anhängen",
	"autopilot-chat-send": "Senden",
	"autopilot-chat-stop": "Anhalten",
	"autopilot-chat-remove-file": "Entfernen",
	"autopilot-chat-prompt-library": "Aufforderungsbibliothek",
	"autopilot-chat-dropzone-overlay-title": "Legen Sie Ihre Dateien hier ab, um sie Ihrer Aufforderung hinzuzufügen.",
	"autopilot-chat-dropzone-overlay-description": "Unterstützte Dateitypen: {{ fileTypes }}",
	"autopilot-chat-dropzone-overlay-error": "Nicht unterstützte Datei(en): {{ fileTypes }}.",
	"autopilot-chat-code-block-language": "Text",
	"autopilot-chat-code-block-copy": "Kopieren",
	"autopilot-chat-expand": "Erweitern",
	"autopilot-chat-collapse": "Reduzieren",
	"autopilot-chat-remove-file-name": "{{ name }} entfernen",
	"autopilot-chat-selected-files": "Ausgewählte Dateien ({{ count }})",
	"autopilot-chat-files-preview": "{{ files }} und {{ count }} weitere",
	"autopilot-chat-thinking": "Denken",
	"autopilot-chat-analyzing": "Analysieren Ihrer Anforderung",
	"autopilot-chat-thinking-more": "Denken Sie noch ein wenig nach.",
	"autopilot-chat-suggestions": "Vorschläge"
};

const home$a = "Inicio";
const help$a = "Ayuda";
const languages$a = "Lenguajes";
const language$a = "Idioma";
const edit$a = "Editar";
const enter$a = "Intro";
const theme$a = "Tema";
const logout$a = "Cerrar sesión";
const tenants$a = "Tenants";
const more$a = "Más";
const admin$a = "Admin";
const autoTheme$a = "Tema automático";
const dark$a = "Tema oscuro";
const light$a = "Tema claro";
const dismiss$a = "Descartar";
const warning$a = "Advertencia";
const info$a = "Info";
const success$a = "correcto";
const error$a = "error";
const more_items$a = "Mas elementos";
const notifications$a = "Notificaciones";
const preview$a = "Preliminar";
const more_products$a = "Más opciones";
const current_plan_upgrade$a = "Tienes un plan {{ license }}";
const free_license$a = "gratuito";
const community_license$a = "comunidad";
const pro_trial_license$a = "prueba profesional";
const unlicensed$a = "Sin licencia";
const back$a = "Volver";
const trademark$a = "TM";
const basic_auth_user$a = "Usuario local";
const local_group$a = "Grupo Local";
const robot$a = "Robot";
const directory_group$a = "Grupo del directorio";
const directory_user$a = "Usuario del directorio";
const directory_app$a = "Aplicación de directorio";
const build$a = "Crear";
const discover$a = "Discover";
const operate$a = "Operar";
const feedback$a = "Comentarios";
const cancel$a = "Cancelar";
const confirm$a = "Confirmar";
const favorites$a = "Favoritos";
const apply$9 = "Aplicar";
const date$9 = "Fecha";
const time$9 = "Hora";
const es = {
	home: home$a,
	help: help$a,
	languages: languages$a,
	language: language$a,
	edit: edit$a,
	"edit-subject": "Editar {{ subject }}",
	enter: enter$a,
	theme: theme$a,
	logout: logout$a,
	tenants: tenants$a,
	more: more$a,
	admin: admin$a,
	autoTheme: autoTheme$a,
	dark: dark$a,
	light: light$a,
	"light-hc": "Tema de alto contraste",
	"dark-hc": "Tema de alto contraste",
	"close-button": "Botón de cerrar",
	"client-days": "Faltan {{ differenceInDays }} días",
	"client-hours": "Faltan {{ differenceInHours }} horas",
	"dropdown-placeholder": "Seleccione una opción",
	"empty-tenant-list-placeholder": "Ningún tenant válido",
	"tenant-picker-label": "Tenant:",
	"tenant-picker-list": "Tenant",
	"error-page-401-header": "Sin autorización",
	"error-page-403-header": "¡Vaya! No está en la lista",
	"error-page-403-description": "No tiene permiso para ver {{ pageTitle }}. Póngase en contacto con su administrador para obtener los permisos necesarios.",
	"error-page-404-header": "¡Oh, no! No puedo encontrarlo",
	"error-page-404-description": "Es posible que la página que está buscando haya sido eliminada, haya cambiado de nombre o no esté disponible temporalmente.",
	"error-page-503-header": "Volveremos pronto",
	"error-page-503-description": "El sistema está en mantenimiento. Consulte este espacio para ver las actualizaciones.",
	"error-page-browser-header": "No se admite este navegador",
	"error-page-endie-header": "Eliminación progresiva de Internet Explorer",
	"error-page-endie-description": "El soporte para Internet Explorer finalizó el 31 de mayo de 2021. Para usar UiPath, recomendamos la última versión de Chrome, Firefox, Safari o Edge.",
	"error-page-ip-restricted-header": "Acceso restringido",
	"error-page-ip-restricted-description": "Debido a las políticas de la organización, no puede acceder a {{ pageTitle }} desde esta ubicación de red. Póngase en contacto con su administrador.",
	"error-page-learn-more": "Más información",
	"error-page-learn-why": "Sepa por qué",
	"error-page-loader-header": "Espere mientras configuramos todo lo que necesita",
	"error-page-loader-description": "Esto podría tardar unos minutos. La página se actualizará cuando la plataforma esté lista para usarse.",
	"error-page-goto-home": "Ir al inicio",
	"error-page-goto-uipath-website": "Ir al sitio web de UiPath",
	"error-page-check-service": "Marcar estado de servicio",
	"error-page-know-why": "Conozca el por qué",
	"aria-label-logo": "El logotipo oficial de UiPath. Al hacer clic aquí se accede a la página inicial de {{ serviceName }}",
	"aria-label-logo-v2": "Logotipo de UiPath Automation Cloud, al hacer clic aquí se accede a la página de inicio de {serviceName}",
	"language-na": "Idioma no admitido para este servicio.",
	dismiss: dismiss$a,
	warning: warning$a,
	info: info$a,
	success: success$a,
	error: error$a,
	"client-days-per-service": "Le quedan {{ differenceInDays }} días de prueba",
	"client-days-per-service-with-name": "Le quedan {{ differenceInDays }} días para su prueba gratuita de {{ serviceName }}",
	"client-hours-per-service": "Le quedan {{ differenceInHours }} horas de prueba",
	"client-hours-per-service-with-name": "Le quedan {{ differenceInHours }} horas para su prueba gratuita de {{ serviceName }}",
	"waffle-label": "lanzador de aplicaciones",
	"generic-error-message": "Error inesperado. Inténtelo de nuevo más tarde.",
	"help-menu-documentation": "Documentación",
	"help-menu-product-documentation": "Documentación de {{ product }}",
	"help-menu-downloads": "Descargas",
	"help-menu-forum": "Foro de la comunidad",
	"help-menu-training-tutorials": "Formación y tutoriales",
	"help-menu-uipath-academy": "UiPath Academy",
	"help-menu-youtube-tutorials": "Tutoriales de YouTube",
	"help-menu-release-notes": "Notas relacionadas",
	"help-menu-resources": "Recursos",
	"help-menu-support": "Soporte",
	more_items: more_items$a,
	notifications: notifications$a,
	"notifications-empty": "No se encontraron notificaciones",
	"notifications-all-read": "Marcar todo como leído",
	"notifications-unread": "marcar como no leído",
	"notifications-read": "Marcar como leído",
	"notifications-delete": "Eliminar",
	"notifications-mute": "Darse de baja de {{ topicOrTenant }}",
	"notifications-muted": "Correcto: canceló la suscripción a {{ topicOrTenant }} notificaciones.",
	"notifications-unread-only": "Solo no leídos",
	"notifications-settings": "Configuración de notificaciones",
	"notifications-page": "Página de notificaciones",
	"notifications-clear-all": "Borrar todo",
	"notifications-end-list": "fin de lista",
	"notifications-expandCollapse": "Expandir/Contraer",
	"notifications-fetch-failure": "Error al obtener las notificaciones. Inténtelo de nuevo más tarde",
	preview: preview$a,
	"unread-notifications-count": "{{ count }} notificaciones no leídas",
	"people-picker-default-placeholder": "Buscar por nombre o correo electrónico",
	"people-picker-groups-placeholder": "Buscar por nombre de grupo",
	"people-picker-single-mode-placeholder": "Buscar por nombre o correo electrónico",
	"people-picker-single-mode-ad-helper-text": "Buscar por nombre, correo electrónico o dominio\\NombreDeCuentaSAM",
	"people-picker-single-mode-aad-helper-text": "Buscar por nombre o correo electrónico, nombre de grupo o nombre de la aplicación",
	"people-picker-default-helper-text": "Busque por nombre o introduzca correos electrónicos separados por comas o punto y coma. Puede escapar de los caracteres especiales utilizando \\.",
	"people-picker-aad-helper-text": "Busque por nombre o introduzca correos electrónicos separados por comas o punto y coma. Puede escapar de los caracteres especiales utilizando \\.",
	"people-picker-ad-ldap-helper-text": "Busque por nombre o introduzca correos electrónicos o dominio\\NombresDeCuentaSAM separados por comas o punto y coma. Puede escapar de los caracteres especiales utilizando \\.",
	"people-picker-invalid-error-helper": "Utilice un correo electrónico válido",
	"people-picker-resolve-error-helper": "Hubo algunas entradas que no se pudieron resolver. Elimínelas o inténtelo de nuevo más tarde.",
	"people-picker-resolve-error-tooltip": "No se pudo resolver la entrada. Elimínela o inténtelo de nuevo más tarde.",
	"people-picker-domain-picker-helper": "Seleccione un dominio",
	"people-picker-too-many-entities": "Solo puede agregar {{ maxValue }} entidades a la vez",
	"people-picker-more-info": "Más información",
	"autocomplete-no-results": "No hay resultados que coincidan con \"{{ query }}\"",
	"autocomplete-limit-exceeded": "Se ha superado el límite de {limit}.",
	"autocomplete-search-text": "Escribir para buscar...",
	"autocomplete-no-results-people-picker": "No hay resultados que coincidan con \"{ query }\"",
	"autocomplete-loading": "Cargando...",
	"people-picker-add-users": "Nombres",
	"people-picker-add-groups": "Grupos",
	"people-picker-add-apps": "Apps",
	"people-picker-add-names": "Nombres",
	"tenant-picker-aria-label": "Seleccionar tenant. Tenant actual: ",
	"people-picker-duplicate-chip": "Hay algunas entradas duplicadas. Elimine uno de los duplicados y vuelva a intentarlo.",
	"profile-navigation": "Preferencias",
	"remove-chip": "Eliminar a \"{{ value }}\"",
	"default-cobranding-logo-alt-text": "Logotipo de marca compartida",
	"canary-tenant": "Valor controlado",
	more_products: more_products$a,
	current_plan_upgrade: current_plan_upgrade$a,
	free_license: free_license$a,
	community_license: community_license$a,
	pro_trial_license: pro_trial_license$a,
	"notification-action-menu-text": "Acción sobre la notificación",
	"notification-allaction-menu-text": "Más acción sobre todas las notificaciones",
	"buy-now": "Comprar ahora",
	"contact-sales": "Ponerse en contacto con el departamento de ventas",
	"skip-content": "Ir al contenido principal",
	"object-picker-add-entry": "Añadir \"{{ entry }}\"",
	"start-free-trial-header": "Comience su",
	"sixty-days-trial": "60 días de prueba",
	"with-uipath-cloud": "con UiPath Automation Cloud",
	"take-advantage-capabilities": "Aprovechar nuestras capacidades completas de Automation Cloud.",
	"upgrade-to-enterprise": "¿Necesita escalar su programa de automatización con control de nivel empresarial, seguridad y mucho más?",
	"trial-benefit-one": "Robots que permiten la ejecución remota bajo demanda",
	"trial-benefit-two": "Soporte ininterrumpido de UiPath",
	"trial-benefit-three": "Garantía de tiempo de actividad",
	"trial-benefit-four": "Múltiples tenants, cada uno alojado en cualquiera de nuestras regiones",
	"view-pricing": "Ver precios",
	"upgrade-trial-role": "Puesto de trabajo",
	"upgrade-trial-company-name": "Nombre de la empresa/organización",
	"upgrade-trial-business-email": "Correo electrónico de trabajo",
	"notifications-clear-message": "Se ha eliminado un elemento de notificación",
	"session-expiring": "Sesión caducando",
	"session-expiring-description-inactive-hours": "Ha estado inactivo durante {{hours}} horas y {{minutes}} minutos.",
	"session-expiring-description-inactive": "Ha estado inactivo durante {{minutes}} minutos.",
	"session-expiring-description-logged-out": "Se cerrará la sesión en {{n}} segundos.",
	"extend-session": "Ampliar sesión",
	"dropdown-position": "{{index}} de {{total}}",
	unlicensed: unlicensed$a,
	"copy-clipboard": "Copiar en el portapapeles",
	"people-picker-search-entries": "Se han encontrado {{count}} resultados de búsqueda que coincidan con \"{{query}}\"",
	"app-bar-aria-label": "Barra de aplicaciones",
	"nav-aria-label": "Navegación izquierda",
	"chat-no-messages": "Teclee un mensaje a continuación para iniciar el chat",
	"chat-type-a-message": "Escriba un mensaje",
	"filter-service": "Servicio:",
	"filter-severity": "Gravedad:",
	"priority-low": "Bajo",
	"priority-medium": "Medio",
	"priority-high": "Alto",
	"priority-critical": "Crucial",
	"filter-option-all": "Todos",
	"severity-info": "Info",
	"severity-success": "Correcto",
	"severity-warn": "Advertencia",
	"severity-error": "Error",
	"severity-fatal": "Fatal",
	"breadcrumb-aria-label-default": "Ruta de navegación",
	back: back$a,
	"switching-orgs": "Cambio de organizaciones",
	"switching-orgs-description": "Está intentando cambiar las organizaciones de {{ oldOrg }} a {{ newOrg }}. Para continuar, primero cierre sesión.",
	"business-email-required": "Se requiere un correo electrónico de empresa para actualizar a la versión Pro Trial",
	"check-inbox-for-invite-link": "Busque en su bandeja de entrada un enlace de invitación y acéptelo para completar la actualización",
	"invite-business-email-help": "Si ya es miembro de la organización que utiliza esa dirección de correo electrónico, solo tiene que iniciar sesión en su cuenta para continuar.",
	"check-email-for-invite": "Busque la invitación en su bandeja de entrada de correo electrónico",
	"check-email-for-invite-description": "Si no encuentra la invitación, compruebe la carpeta de correo no deseado. Después de aceptar la invitación, puede actualizar a la versión Pro Trial.",
	"no-minimum-purchase": "Sin mínimo de compra.",
	"view-details-trial-plan": "Ver los detalles de todo lo incluido en una prueba de 60 días del plan Pro",
	"get-more-cloud": "Aproveche más su UiPath Automation Cloud",
	"start-free-trial": "Iniciar prueba gratuita",
	trademark: trademark$a,
	"send-invite": "Enviar invitado",
	"support-id": "ID de soporte",
	basic_auth_user: basic_auth_user$a,
	local_group: local_group$a,
	robot: robot$a,
	directory_group: directory_group$a,
	directory_user: directory_user$a,
	directory_app: directory_app$a,
	"unified-admin-button-label": "Administrar acceso",
	"unified-search-placeholder": "Buscar Marketplace y documentación",
	"unified-search-placeholder-v2": "Buscar componentes, páginas y más",
	"unified-search-recent-searches": "Búsquedas recientes",
	"unified-search-recent-pages-visited": "Páginas visitadas",
	"unified-search-recent-resources-visited": "Recursos visitados",
	"unified-search-no-recent-searches": "No hay búsquedas recientes, escriba 3 o más caracteres para obtener resultados",
	"unified-search-no-recent-searches-logographic-locales": "No hay búsquedas recientes, escriba 1 o más caracteres para obtener resultados",
	"unified-search-marketplace": "MercadoMercado de UiPath",
	"unified-search-documentation": "Documentación",
	"unified-search-open-product": "Se abre en {product}",
	"unified-search-change-search-terms": "Intente cambiar los términos de búsqueda",
	"unified-search-no-results-found": "No se encontraron resultados que coincidan con \"{term}\"",
	"unified-search-footer": "¿No son los resultados que esperaba? {feedbackLink} o {learnMoreLink}",
	"unified-search-footer-no-feedback": "¿No son los resultados que esperaba? {learnMoreLink}",
	"unified-search-footer-give-feedback": "¿No son los resultados que esperaba? {feedbackLink}",
	"unified-search-documentation-link": "Buscar \"{query}\" en la documentación",
	"unified-search-downloads": "{count} descargas",
	"unified-search-runs": "{count} ejecuciones",
	"unified-search-all": "Todos",
	"unified-search-see-all": "Ver todo",
	"unified-search-clear-button": "Borrar",
	"unified-search-filter": "Filtro",
	"unified-search-all-count": "Todos ({count})",
	"unified-search-components-count": "Componentes ({count})",
	"unified-search-pages-count": "Páginas ({count})",
	"unified-search-tags": "Etiquetas: {tagList}",
	"learn-more": "Más información",
	"my-workspace": "Mi espacio de trabajo",
	"give-feedback": "Comentar",
	"ap-autocomplete-input-no-results": "No hay resultados que coincidan con \"{query}\"",
	"ap-dropdown-placeholder": "Seleccionar...",
	"ap-date-picker-placeholder": "Seleccionar fecha",
	"ap-time-picker-placeholder": "Seleccionar hora",
	"ap-date-picker-selected-day-label": "{day} seleccionados",
	"ap-breadcrumb-overflow-label": "Enlaces ocultos de la ruta de navegación",
	"unified-search-Studio": "Studio",
	"unified-search-AiCenter": "Centro de IA",
	"unified-search-Assistant": "Asistente",
	"unified-search-ProcessMining": "Process Mining",
	"unified-search-BusinessSolutions": "Soluciones de socios",
	"unified-search-UiPathApps": "Aplicaciones",
	"unified-search-IntegrationServices": "Integration Service",
	"unified-search-StudioX": "StudioX",
	"unified-search-ProfessionalServices": "Servicios profesionales",
	"unified-search-Accelerator": "Accelerators",
	"unified-search-StudioWeb": "Studio Web",
	"unified-search-AutomationOps": "Operaciones de automatización",
	"unified-search-DocumentUnderstanding": "Document Understanding",
	"unified-search-Insights": "Insights",
	"unified-search-Other": "Otro",
	"unified-search-Activity": "Actividades",
	"unified-search-CustomActivity": "Actividades",
	"unified-search-Snippet": "Fragmentos",
	"unified-search-WorkflowTemplate": "Plantillas",
	"unified-search-Connector": "Conectores",
	"unified-search-Tool": "Herramientas",
	"unified-search-MLModel": "Modelos ML",
	"unified-search-Solution": "Soluciones",
	"unified-search-Process": "Automatizaciones listas para usar",
	"unified-search-Widget": "Widget",
	"unified-search-BusinessSolution": "Soluciones de socios",
	"unified-search-App": "Aplicaciones",
	"unified-search-UiPathAppSolution": "Soluciones de aplicaciones",
	"unified-search-UiPathAppTemplate": "Plantillas de la aplicación",
	"unified-search-IntegrationServiceConnector": "Conector de Integration Service",
	"unified-search-StudioXWorkflowTemplate": "Plantillas",
	"unified-search-ProfessionalService": "Servicio profesional",
	"unified-search-StudioWebTemplate": "Plantilla Studio Web",
	"unified-search-AutomationOpsPipeline": "Procesos",
	"unified-search-AutomationOpsPipelineTemplate": "Plantillas de proceso",
	"unified-search-ExtractionModel": "Modelos de extracción",
	"unified-search-marketplace-studio-activity": "Actividad de Studio",
	"unified-search-marketplace-studio-snippet": "Fragmento de Studio",
	"unified-search-marketplace-studio-workflowtemplate": "Plantilla de Studio",
	"unified-search-marketplace-studio-connector": "Conectores (heredado)",
	"unified-search-marketplace-studio-tool": "Herramientas de Studio",
	"unified-search-marketplace-studio-solution": "Solución de Studio",
	"unified-search-marketplace-studioweb-studiowebtemplate": "Plantilla Studio Web",
	"unified-search-marketplace-studiox-studioxworkflowtemplate": "Plantilla de Studio X",
	"unified-search-marketplace-assistant-process": "Automatización lista para usar",
	"unified-search-marketplace-aicenter-mlmodel": "Modelo de ML",
	"unified-search-marketplace-processmining-app": "Plantilla de la aplicación de Process Mining",
	"unified-search-marketplace-uipathapps-uipathappsolution": "Solución de aplicación",
	"unified-search-marketplace-uipathapps-uipathapptemplate": "Plantilla de aplicación",
	"unified-search-marketplace-integrationservices-integrationserviceconnector": "Conectores",
	"unified-search-marketplace-accelerator-accelerator": "Accelerator",
	"unified-search-marketplace-businesssolutions-businesssolution": "Solución de socio",
	"unified-search-marketplace-professionalservices-professionalservice": "Servicios profesionales",
	"unified-search-orchestrator-asset": "Activo",
	"unified-search-orchestrator-process": "Proceso",
	"unified-search-orchestrator-trigger": "Desencadenador",
	"unified-search-orchestrator-queue": "Cola",
	"unified-search-orchestrator-bucket": "Depósito",
	"unified-search-orchestrator-actioncatalog": "Catálogo de acciones",
	"unified-search-orchestrator-machine": "Máquina",
	"unified-search-orchestrator-webhook": "Webhook",
	"unified-search-integrationservice-connection": "Conexión",
	"unified-search-integrationservice-trigger": "Desencadenador",
	"unified-search-dataservice-entity": "Entidad",
	"unified-search-dataservice-choiceset": "Conjunto de opciones",
	"unified-search-apps-app": "Aplicaciones",
	"unified-search-loading-search-results": "Cargando resultados de búsqueda",
	"rich-text-editor-format-bold": "Formato negrita",
	"rich-text-editor-bold": "Negrita",
	"rich-text-editor-format-italic": "Formato cursiva",
	"rich-text-editor-italic": "Cursiva",
	"rich-text-editor-format-underline": "Formato subrayado",
	"rich-text-editor-underline": "Subrayar",
	"rich-text-editor-format-strikethrough": "Formato Tachado",
	"rich-text-editor-strikethrough": "Tachado",
	"rich-text-editor-format-ordered-list": "Formato de lista ordenada",
	"rich-text-editor-ordered-list": "Lista ordenada",
	"rich-text-editor-format-unordered-list": "Formato de lista desordenada",
	"rich-text-editor-unordered-list": "Lista desordenada",
	"rich-text-editor-insert-link": "Insertar enlace",
	"rich-text-editor-link": "Vincular",
	"rich-text-editor-format-code": "Código de formato",
	"rich-text-editor-code": "Código",
	"ap-text-field-placeholder": "Escribir un valor",
	"notification-message-template": "{{ topic }} en {{ tenantName }}",
	build: build$a,
	discover: discover$a,
	operate: operate$a,
	feedback: feedback$a,
	"give-us-feedback": "Comentar",
	cancel: cancel$a,
	confirm: confirm$a,
	favorites: favorites$a,
	"favorites-limit-reached": "Límite alcanzado: solo puedes añadir un máximo de 3 elementos.",
	"favorites-description": "Tus productos favoritos se mostrarán aquí. Puedes añadir un máximo de 3 elementos.",
	"default-toggle": "Interruptor de alternancia",
	"default-progress-spinner": "Cargando contenido",
	"default-icon-button": "Botón de icono",
	"default-radio-group": "Grupo de opción",
	"default-checkbox": "Casilla de verificación",
	"default-stepper-clickable": "con pasos en los que se puede hacer clic",
	"default-stepper-disabled": "con pasos deshabilitados",
	"new-navigation": "Nueva navegación",
	"product-launcher-tooltip": "Lanzador de productos",
	"autopilot-tooltip": "Autopilot",
	"notifications-tooltip": "Notificaciones",
	"search-tooltip": "Buscar",
	"help-tooltip": "Ayuda",
	"profile-tooltip": "Perfil",
	apply: apply$9,
	date: date$9,
	time: time$9,
	"date-range": "Intervalo de fechas:",
	"date-range-label": "Intervalo de fechas",
	"date-time-label": "Fecha y hora",
	"date-time-picker-label": "Selector de fecha y hora",
	"date-range-start": "Iniciar",
	"date-range-end": "Finalizar",
	"date-range-presets": "Preajustes",
	"date-range-picker-last-hour": "Última hora",
	"date-range-picker-today": "Hoy",
	"date-range-picker-last-seven-days": "Últimos 7 días",
	"date-range-picker-last-two-weeks": "Últimas 2 semanas",
	"date-range-picker-last-month": "Último mes",
	"date-range-picker-last-six-months": "Últimos 6 meses",
	"date-range-picker-custom": "Personalizar",
	"date-range-picker-start-tooltip": "La fecha de inicio no puede ser posterior a la fecha de finalización",
	"date-range-picker-label": "Selector de intervalo de fechas",
	"time-selector": "Selector de tiempo",
	"date-range-picker-options": "Opciones de intervalo de fechas",
	"no-options": "Sin opciones",
	"type-to-search": "Escribir para buscar...",
	"autopilot-chat-header": "Autopilot",
	"autopilot-chat-input-placeholder": "¿Que le gustaría que hiciera?",
	"autopilot-chat-footer": "Autopilot puede cometer errores. Vuelva a comprobar las respuestas.",
	"autopilot-chat-new-chat": "Nuevo chat",
	"autopilot-chat-close": "Cerrar",
	"autopilot-chat-attach-file": "Adjuntar archivo(s)",
	"autopilot-chat-send": "Enviar",
	"autopilot-chat-stop": "Detener",
	"autopilot-chat-remove-file": "Quitar",
	"autopilot-chat-prompt-library": "Biblioteca de solicitudes",
	"autopilot-chat-dropzone-overlay-title": "Suelte sus archivos aquí para añadirlos a su solicitud",
	"autopilot-chat-dropzone-overlay-description": "Tipos de archivo compatibles: {{ fileTypes }}",
	"autopilot-chat-dropzone-overlay-error": "Archivo(s) no compatible(s): {{ fileTypes }}.",
	"autopilot-chat-code-block-language": "Texto",
	"autopilot-chat-code-block-copy": "Copiar",
	"autopilot-chat-expand": "Expandir",
	"autopilot-chat-collapse": "Contraer",
	"autopilot-chat-remove-file-name": "Eliminar {{ name }}",
	"autopilot-chat-selected-files": "Archivos seleccionados ({{ count }})",
	"autopilot-chat-files-preview": "{{ files }} y {{ count }} más",
	"autopilot-chat-thinking": "Pensando",
	"autopilot-chat-analyzing": "Analizando su solicitud",
	"autopilot-chat-thinking-more": "Pensando un poco más",
	"autopilot-chat-suggestions": "Sugerencias"
};

const home$9 = "Inicio";
const help$9 = "Ayuda";
const languages$9 = "Lenguajes";
const language$9 = "Idioma";
const edit$9 = "Editar";
const enter$9 = "Intro";
const theme$9 = "Tema";
const logout$9 = "Cerrar sesión";
const tenants$9 = "Inquilinos";
const more$9 = "Más";
const admin$9 = "Admin";
const autoTheme$9 = "Tema automático";
const dark$9 = "Tema oscuro";
const light$9 = "Tema claro";
const dismiss$9 = "Descartar";
const warning$9 = "Advertencia";
const info$9 = "Información";
const success$9 = "correcto";
const error$9 = "error";
const more_items$9 = "Más elementos";
const notifications$9 = "Notificaciones";
const preview$9 = "Vista previa";
const more_products$9 = "Más opciones";
const current_plan_upgrade$9 = "Tiene un plan {{ license }}";
const free_license$9 = "gratuito";
const community_license$9 = "Community";
const pro_trial_license$9 = "de prueba profesional";
const unlicensed$9 = "Sin licencia";
const back$9 = "Volver";
const trademark$9 = "TM";
const basic_auth_user$9 = "Usuario local";
const local_group$9 = "Grupo Local";
const robot$9 = "Robot";
const directory_group$9 = "Grupo de directorio";
const directory_user$9 = "Usuario de directorio";
const directory_app$9 = "Aplicación de directorio";
const build$9 = "Crear";
const discover$9 = "Discover";
const operate$9 = "Operador";
const feedback$9 = "Comentarios";
const cancel$9 = "Cancelar";
const confirm$9 = "Confirmar";
const favorites$9 = "Favoritos";
const apply$8 = "Aplicar";
const date$8 = "Fecha";
const time$8 = "Hora";
const esMX = {
	home: home$9,
	help: help$9,
	languages: languages$9,
	language: language$9,
	edit: edit$9,
	"edit-subject": "Editar {{ subject }}",
	enter: enter$9,
	theme: theme$9,
	logout: logout$9,
	tenants: tenants$9,
	more: more$9,
	admin: admin$9,
	autoTheme: autoTheme$9,
	dark: dark$9,
	light: light$9,
	"light-hc": "Tema claro de alto contraste",
	"dark-hc": "Tema oscuro de alto contraste",
	"close-button": "Botón cerrar",
	"client-days": "{{ differenceInDays }} días restantes",
	"client-hours": "{{ differenceInHours }} horas restantes",
	"dropdown-placeholder": "Seleccione una opción",
	"empty-tenant-list-placeholder": "No hay un inquilino válido",
	"tenant-picker-label": "Inquilino:",
	"tenant-picker-list": "Inquilino",
	"error-page-401-header": "Sin autorizar",
	"error-page-403-header": "¡Vaya! No estás en la lista",
	"error-page-403-description": "No tiene permiso para ver {{ pageTitle }}. Comuníquese con el administrador para obtener los permisos necesarios.",
	"error-page-404-header": "¡Vaya! No puedo encontrarlo.",
	"error-page-404-description": "Es posible que la página que está buscando haya sido eliminada, haya cambiado de nombre o no esté disponible temporalmente.",
	"error-page-503-header": "Volveremos pronto.",
	"error-page-503-description": "El sistema está en mantenimiento. Vea este espacio para obtener actualizaciones.",
	"error-page-browser-header": "No se admite el navegador.",
	"error-page-endie-header": "Eliminación gradual de Internet Explorer",
	"error-page-endie-description": "El soporte técnico para Internet<br />Explorer finalizó el 31 de mayo de 2021. Para utilizar UiPath, recomendamos tener instalada la última versión de Chrome, Firefox, Safari o Edge.",
	"error-page-ip-restricted-header": "Acceso restringido",
	"error-page-ip-restricted-description": "Debido a las políticas de la organización, no puede acceder a {{ pageTitle }} desde esta ubicación de red.Póngase en contacto con su administrador.",
	"error-page-learn-more": "Más información",
	"error-page-learn-why": "Saber porqué",
	"error-page-loader-header": "Espere mientras configuramos todo lo que necesita.",
	"error-page-loader-description": "Esto podría tardar unos minutos. La página se actualizará cuando la plataforma esté lista para usarse.",
	"error-page-goto-home": "Ir al inicio",
	"error-page-goto-uipath-website": "Ir al sitio web de UiPath",
	"error-page-check-service": "Comprobar el estado del servicio",
	"error-page-know-why": "Sepa por qué",
	"aria-label-logo": "El logotipo oficial de UiPath. Si hace clic aquí, irá al inicio de {{ serviceName }}.",
	"aria-label-logo-v2": "Logotipo de UiPath Automation Cloud; al hacerle clic se accede a la página de inicio de {serviceName}",
	"language-na": "Idioma no compatible con este servicio.",
	dismiss: dismiss$9,
	warning: warning$9,
	info: info$9,
	success: success$9,
	error: error$9,
	"client-days-per-service": "Le quedan {{ differenceInDays }} días de prueba",
	"client-days-per-service-with-name": "Le quedan {{ differenceInDays }} días para su prueba gratuita de {{ serviceName }}.",
	"client-hours-per-service": "Le quedan {{ differenceInHours }} horas en su prueba",
	"client-hours-per-service-with-name": "Le quedan {{ differenceInHours }} horas para su prueba gratuita de {{ serviceName }}.",
	"waffle-label": "Iniciador de aplicaciones",
	"generic-error-message": "Error inesperado. Inténtelo nuevamente más tarde",
	"help-menu-documentation": "Documentación",
	"help-menu-product-documentation": "documentación de {{ product }}",
	"help-menu-downloads": "Descargas",
	"help-menu-forum": "Foro de la comunidad",
	"help-menu-training-tutorials": "Capacitación y tutoriales",
	"help-menu-uipath-academy": "UiPath Academy",
	"help-menu-youtube-tutorials": "Tutoriales de YouTube",
	"help-menu-release-notes": "Notas relacionadas",
	"help-menu-resources": "Recursos",
	"help-menu-support": "Soporte",
	more_items: more_items$9,
	notifications: notifications$9,
	"notifications-empty": "No se encontraron notificaciones",
	"notifications-all-read": "Marcar todo como leído",
	"notifications-unread": "Marcar como no leído",
	"notifications-read": "Marcar como leído",
	"notifications-delete": "Eliminar",
	"notifications-mute": "Darse de baja de {{ topicOrTenant }}",
	"notifications-muted": "Correcto: se ha dado de baja de las notificaciones de {{ topicOrTenant }}.",
	"notifications-unread-only": "Solo lo no leído",
	"notifications-settings": "Configuración de notificaciones",
	"notifications-page": "Página de notificaciones",
	"notifications-clear-all": "Borrar todo",
	"notifications-end-list": "Fin de la lista",
	"notifications-expandCollapse": "Ampliar/contraer",
	"notifications-fetch-failure": "No se pudieron obtener las notificaciones. Inténtelo de nuevo más tarde",
	preview: preview$9,
	"unread-notifications-count": "{{ count }} notificaciones no leídas",
	"people-picker-default-placeholder": "Buscar por nombre o correo electrónico",
	"people-picker-groups-placeholder": "Buscar por nombre de grupo",
	"people-picker-single-mode-placeholder": "Buscar por nombre o correo electrónico",
	"people-picker-single-mode-ad-helper-text": "Busque por nombre, correo electrónico o dominio\\samAccountName",
	"people-picker-single-mode-aad-helper-text": "Busque por nombre, correo electrónico, nombre de grupo o nombre de la aplicación",
	"people-picker-default-helper-text": "Busque por nombre o ingrese correos electrónicos separados por comas o punto y coma. Puede prescindir de los caracteres especiales utilizando \\.",
	"people-picker-aad-helper-text": "Busque por nombre de usuario o ingrese correos electrónicos separados por comas o punto y coma. Puede prescindir de los caracteres especiales utilizando \\.",
	"people-picker-ad-ldap-helper-text": "Busque por nombre de usuario o introduzca correos electrónicos o dominio\\samAccountNames separados por comas o punto y coma. Puede prescindir de los caracteres especiales utilizando \\.",
	"people-picker-invalid-error-helper": "Utilice un correo electrónico válido",
	"people-picker-resolve-error-helper": "Algunas entradas no se resolvieron. Elimínelas o inténtelo de nuevo más tarde",
	"people-picker-resolve-error-tooltip": "No se pudo resolver la entrada. Elimine o inténtelo de nuevo más tarde",
	"people-picker-domain-picker-helper": "Seleccionar un dominio",
	"people-picker-too-many-entities": "Solo puede agregar {{ maxValue }} entidades a la vez",
	"people-picker-more-info": "Más información",
	"autocomplete-no-results": "No hay resultados que coincidan con \"{{ query }}\"",
	"autocomplete-limit-exceeded": "Límite de {limit} excedido",
	"autocomplete-search-text": "Escribir para buscar...",
	"autocomplete-no-results-people-picker": "No hay resultados que coincidan con \"{ query }\"",
	"autocomplete-loading": "Cargando...",
	"people-picker-add-users": "Nombres",
	"people-picker-add-groups": "Grupos",
	"people-picker-add-apps": "Aplicaciones",
	"people-picker-add-names": "Nombres",
	"tenant-picker-aria-label": "Seleccionar inquilino Actual: ",
	"people-picker-duplicate-chip": "Hay algunas entradas duplicadas. Elimine una de los duplicadas e inténtelo de nuevo.",
	"profile-navigation": "Preferencias",
	"remove-chip": "Quitar \"{{ value }}\"",
	"default-cobranding-logo-alt-text": "Logotipo de marca compartida",
	"canary-tenant": "Canario",
	more_products: more_products$9,
	current_plan_upgrade: current_plan_upgrade$9,
	free_license: free_license$9,
	community_license: community_license$9,
	pro_trial_license: pro_trial_license$9,
	"notification-action-menu-text": "Acción sobre la notificación",
	"notification-allaction-menu-text": "Más acción en todas las notificaciones",
	"buy-now": "Comprar ahora",
	"contact-sales": "Ponerse en contacto con el departamento de Ventas",
	"skip-content": "Ir al contenido principal",
	"object-picker-add-entry": "Agregar \"{{ entry }}\"",
	"start-free-trial-header": "Comience su",
	"sixty-days-trial": "prueba de 60 días",
	"with-uipath-cloud": "con UiPath Automation Cloud",
	"take-advantage-capabilities": "Aproveche nuestras capacidades completas de Automation Cloud.",
	"upgrade-to-enterprise": "¿Necesita escalar su programa de automatización con gobernanza, seguridad y más de nivel empresarial?",
	"trial-benefit-one": "Robots para permitir la ejecución remota bajo demanda",
	"trial-benefit-two": "Soporte de UiPath 24x7",
	"trial-benefit-three": "Garantía de tiempo de actividad",
	"trial-benefit-four": "Múltiples inquilinos, cada uno alojado en cualquiera de nuestras regiones",
	"view-pricing": "Ver precios",
	"upgrade-trial-role": "Puesto de trabajo",
	"upgrade-trial-company-name": "Nombre de la empresa/organización",
	"upgrade-trial-business-email": "Correo electrónico de trabajo",
	"notifications-clear-message": "Se eliminó el elemento de notificación",
	"session-expiring": "La sesión caducará pronto",
	"session-expiring-description-inactive-hours": "Ha estado inactivo durante {{hours}} horas y {{minutes}} minutos.",
	"session-expiring-description-inactive": "Ha estado inactivo durante {{minutes}} minutos.",
	"session-expiring-description-logged-out": "Se cerrará la sesión en {{n}} segundos.",
	"extend-session": "Extender sesión",
	"dropdown-position": "{{index}} de {{total}}",
	unlicensed: unlicensed$9,
	"copy-clipboard": "Copiar en el portapapeles",
	"people-picker-search-entries": "Se encontraron {{count}} resultados de búsqueda que coincidan con \"{{query}}\"",
	"app-bar-aria-label": "Barra Aplicaciones",
	"nav-aria-label": "Navegación izquierda",
	"chat-no-messages": "Escriba un mensaje a continuación para iniciar el chat",
	"chat-type-a-message": "Escriba un mensaje",
	"filter-service": "Servicio:",
	"filter-severity": "Gravedad:",
	"priority-low": "Bajo",
	"priority-medium": "Medio",
	"priority-high": "Alto",
	"priority-critical": "Crítica",
	"filter-option-all": "Todos",
	"severity-info": "Info",
	"severity-success": "Correcto",
	"severity-warn": "Aviso",
	"severity-error": "Error",
	"severity-fatal": "Fatal",
	"breadcrumb-aria-label-default": "Sendero de navegación",
	back: back$9,
	"switching-orgs": "Cambio de organizaciones",
	"switching-orgs-description": "Está intentando cambiar las organizaciones de {{ oldOrg }} a {{ newOrg }}. Para continuar, primero cierre sesión.",
	"business-email-required": "Se requiere un correo electrónico de empresa para actualizar a Pro Trial",
	"check-inbox-for-invite-link": "Busque en su bandeja de entrada un enlace de invitación y acéptela para completar la actualización",
	"invite-business-email-help": "Si ya es miembro de la organización que utiliza esa dirección de correo electrónico, simplemente inicie sesión en su cuenta para continuar.",
	"check-email-for-invite": "Revise su correo electrónico para ver la invitación",
	"check-email-for-invite-description": "Si no la encuentra, revise su carpeta de correo no deseado. Después de aceptar la invitación, puede actualizar a Pro Trial.",
	"no-minimum-purchase": "Sin mínimo de compra.",
	"view-details-trial-plan": "Ver los detalles de todo lo incluido en una prueba de 60 días del plan Pro",
	"get-more-cloud": "Obtenga más de UiPath Automation Cloud",
	"start-free-trial": "Iniciar prueba gratuita",
	trademark: trademark$9,
	"send-invite": "Enviar invitación",
	"support-id": "ID de soporte",
	basic_auth_user: basic_auth_user$9,
	local_group: local_group$9,
	robot: robot$9,
	directory_group: directory_group$9,
	directory_user: directory_user$9,
	directory_app: directory_app$9,
	"unified-admin-button-label": "Administrar el acceso",
	"unified-search-placeholder": "Buscar en Marketplace y documentación",
	"unified-search-placeholder-v2": "Buscar componentes, páginas y más",
	"unified-search-recent-searches": "Búsquedas recientes",
	"unified-search-recent-pages-visited": "Páginas visitadas",
	"unified-search-recent-resources-visited": "Recursos visitados",
	"unified-search-no-recent-searches": "No hay búsquedas recientes, escriba 3 o más caracteres para obtener resultados",
	"unified-search-no-recent-searches-logographic-locales": "No hay búsquedas recientes, escriba 1 o más caracteres para obtener resultados",
	"unified-search-marketplace": "Mercado de Uipath",
	"unified-search-documentation": "Documentación",
	"unified-search-open-product": "Se abre en {product}",
	"unified-search-change-search-terms": "Pruebe cambiar los términos de búsqueda.",
	"unified-search-no-results-found": "No hay resultados que coincidan con \"{term}\"",
	"unified-search-footer": "¿No son los resultados que esperaba? {feedbackLink} o {learnMoreLink}",
	"unified-search-footer-no-feedback": "¿No son los resultados que esperaba? {learnMoreLink}",
	"unified-search-footer-give-feedback": "¿No son los resultados que esperaba? {feedbackLink}",
	"unified-search-documentation-link": "Buscar \"{query}\" en la documentación",
	"unified-search-downloads": "{count} Descargas",
	"unified-search-runs": "{count} ejecuciones",
	"unified-search-all": "Todos",
	"unified-search-see-all": "Ver todo",
	"unified-search-clear-button": "Borrar",
	"unified-search-filter": "Filtro",
	"unified-search-all-count": "Todo ({count})",
	"unified-search-components-count": "Componentes ({count})",
	"unified-search-pages-count": "Páginas ({count})",
	"unified-search-tags": "Etiquetas: {tagList}",
	"learn-more": "Más información",
	"my-workspace": "Mi espacio de trabajo",
	"give-feedback": "Proporcionar comentarios",
	"ap-autocomplete-input-no-results": "No hay resultados que coincidan con \"{query}\"",
	"ap-dropdown-placeholder": "Seleccionar...",
	"ap-date-picker-placeholder": "Seleccionar fecha",
	"ap-time-picker-placeholder": "Seleccionar hora",
	"ap-date-picker-selected-day-label": "{day} seleccionados",
	"ap-breadcrumb-overflow-label": "Enlaces ocultos de la ruta de navegación",
	"unified-search-Studio": "Studio",
	"unified-search-AiCenter": "AI Center",
	"unified-search-Assistant": "Asistente",
	"unified-search-ProcessMining": "Process Mining",
	"unified-search-BusinessSolutions": "Soluciones de socios",
	"unified-search-UiPathApps": "Apps",
	"unified-search-IntegrationServices": "Integration Service",
	"unified-search-StudioX": "StudioX",
	"unified-search-ProfessionalServices": "Servicios profesionales",
	"unified-search-Accelerator": "Aceleradores",
	"unified-search-StudioWeb": "StudioWeb",
	"unified-search-AutomationOps": "Automation Ops",
	"unified-search-DocumentUnderstanding": "Document Understanding",
	"unified-search-Insights": "Insights",
	"unified-search-Other": "Otro",
	"unified-search-Activity": "Actividades",
	"unified-search-CustomActivity": "Actividades",
	"unified-search-Snippet": "Fragmentos",
	"unified-search-WorkflowTemplate": "Plantillas",
	"unified-search-Connector": "Conectores",
	"unified-search-Tool": "Herramientas",
	"unified-search-MLModel": "Modelo de ML",
	"unified-search-Solution": "Soluciones",
	"unified-search-Process": "Automatizaciones listas para usar",
	"unified-search-Widget": "Widget",
	"unified-search-BusinessSolution": "Soluciones de socios",
	"unified-search-App": "Apps",
	"unified-search-UiPathAppSolution": "Soluciones de aplicaciones",
	"unified-search-UiPathAppTemplate": "Plantillas de aplicaciones",
	"unified-search-IntegrationServiceConnector": "Conector Integration Service",
	"unified-search-StudioXWorkflowTemplate": "Plantillas",
	"unified-search-ProfessionalService": "Servicio profesional",
	"unified-search-StudioWebTemplate": "Plantilla de Studio Web",
	"unified-search-AutomationOpsPipeline": "Procesos",
	"unified-search-AutomationOpsPipelineTemplate": "Plantillas de proceso",
	"unified-search-ExtractionModel": "Modelos de extracción",
	"unified-search-marketplace-studio-activity": "Actividad de Studio",
	"unified-search-marketplace-studio-snippet": "Fragmento de Studio",
	"unified-search-marketplace-studio-workflowtemplate": "Plantilla de Studio",
	"unified-search-marketplace-studio-connector": "Conectores (heredado)",
	"unified-search-marketplace-studio-tool": "Herramienta de Studio",
	"unified-search-marketplace-studio-solution": "Solución de Studio",
	"unified-search-marketplace-studioweb-studiowebtemplate": "Plantilla de Studio Web",
	"unified-search-marketplace-studiox-studioxworkflowtemplate": "Plantilla de Studio X",
	"unified-search-marketplace-assistant-process": "Automatización lista para usar",
	"unified-search-marketplace-aicenter-mlmodel": "Modelo de ML",
	"unified-search-marketplace-processmining-app": "Plantilla de aplicación de Process Mining",
	"unified-search-marketplace-uipathapps-uipathappsolution": "Soluciones de aplicaciones",
	"unified-search-marketplace-uipathapps-uipathapptemplate": "Agregar plantilla",
	"unified-search-marketplace-integrationservices-integrationserviceconnector": "Conectores",
	"unified-search-marketplace-accelerator-accelerator": "Acelerador",
	"unified-search-marketplace-businesssolutions-businesssolution": "Solución de socios",
	"unified-search-marketplace-professionalservices-professionalservice": "Servicios profesionales",
	"unified-search-orchestrator-asset": "Recurso",
	"unified-search-orchestrator-process": "Proceso",
	"unified-search-orchestrator-trigger": "Desencadenante",
	"unified-search-orchestrator-queue": "Cola",
	"unified-search-orchestrator-bucket": "Bucket",
	"unified-search-orchestrator-actioncatalog": "Catálogo de acciones",
	"unified-search-orchestrator-machine": "Máquina",
	"unified-search-orchestrator-webhook": "Webhook",
	"unified-search-integrationservice-connection": "Conexión",
	"unified-search-integrationservice-trigger": "Desencadenante",
	"unified-search-dataservice-entity": "Entidad",
	"unified-search-dataservice-choiceset": "Conjunto de opciones",
	"unified-search-apps-app": "Apps",
	"unified-search-loading-search-results": "Cargando resultados de la búsqueda",
	"rich-text-editor-format-bold": "Formato negrita",
	"rich-text-editor-bold": "Negrita",
	"rich-text-editor-format-italic": "Formato cursiva",
	"rich-text-editor-italic": "Cursiva",
	"rich-text-editor-format-underline": "Formato subrayado",
	"rich-text-editor-underline": "Subrayar",
	"rich-text-editor-format-strikethrough": "Formato Tachado",
	"rich-text-editor-strikethrough": "Tachado",
	"rich-text-editor-format-ordered-list": "Formato de lista ordenada",
	"rich-text-editor-ordered-list": "Lista ordenada",
	"rich-text-editor-format-unordered-list": "Formato de lista desordenada",
	"rich-text-editor-unordered-list": "Lista desordenada",
	"rich-text-editor-insert-link": "Insertar enlace",
	"rich-text-editor-link": "Enlace",
	"rich-text-editor-format-code": "Código de formato",
	"rich-text-editor-code": "Código",
	"ap-text-field-placeholder": "Ingresar un valor",
	"notification-message-template": "{{ topic }} en {{ tenantName }}",
	build: build$9,
	discover: discover$9,
	operate: operate$9,
	feedback: feedback$9,
	"give-us-feedback": "Envíenos comentarios",
	cancel: cancel$9,
	confirm: confirm$9,
	favorites: favorites$9,
	"favorites-limit-reached": "Límite alcanzado: solo puede agregar un máximo de 3 elementos.",
	"favorites-description": "Sus productos favoritos aparecerán aquí. Puede agregar un máximo de 3 elementos.",
	"default-toggle": "Alternar conmutador",
	"default-progress-spinner": "Cargando el contenido",
	"default-icon-button": "Botón de icono",
	"default-radio-group": "Grupo de botón de opción",
	"default-checkbox": "Casilla de verificación",
	"default-stepper-clickable": "con pasos en los que se puede hacer clic",
	"default-stepper-disabled": "con pasos deshabilitados",
	"new-navigation": "Nueva navegación",
	"product-launcher-tooltip": "Iniciador de productos",
	"autopilot-tooltip": "Autopilot",
	"notifications-tooltip": "Notificaciones",
	"search-tooltip": "Buscar",
	"help-tooltip": "Ayuda",
	"profile-tooltip": "Perfil",
	apply: apply$8,
	date: date$8,
	time: time$8,
	"date-range": "Intervalo de fechas:",
	"date-range-label": "Intervalo de fechas",
	"date-time-label": "FechaHora",
	"date-time-picker-label": "Selector de fecha y hora",
	"date-range-start": "Iniciar",
	"date-range-end": "Final",
	"date-range-presets": "Preestablecidos",
	"date-range-picker-last-hour": "Última hora",
	"date-range-picker-today": "Hoy",
	"date-range-picker-last-seven-days": "Últimos 7 días",
	"date-range-picker-last-two-weeks": "Las últimas 2 semanas",
	"date-range-picker-last-month": "Último mes",
	"date-range-picker-last-six-months": "Últimos 6 meses",
	"date-range-picker-custom": "Personalizar",
	"date-range-picker-start-tooltip": "La fecha de inicio no puede ser posterior a la fecha de finalización",
	"date-range-picker-label": "Selector de intervalo de fechas",
	"time-selector": "Selector de hora",
	"date-range-picker-options": "Opciones de intervalo de fechas",
	"no-options": "Sin opciones",
	"type-to-search": "Escribir para buscar...",
	"autopilot-chat-header": "Autopilot",
	"autopilot-chat-input-placeholder": "¿Qué le gustaría que hiciera?",
	"autopilot-chat-footer": "Autopilot puede cometer errores. Compruebe las respuestas.",
	"autopilot-chat-new-chat": "Nuevo chat",
	"autopilot-chat-close": "Cerrar",
	"autopilot-chat-attach-file": "Adjuntar archivo(s)",
	"autopilot-chat-send": "Enviar",
	"autopilot-chat-stop": "Detener",
	"autopilot-chat-remove-file": "Eliminar",
	"autopilot-chat-prompt-library": "Biblioteca de solicitudes",
	"autopilot-chat-dropzone-overlay-title": "Suelte los archivos aquí para agregarlos a la solicitud",
	"autopilot-chat-dropzone-overlay-description": "Tipos de archivo compatibles: {{ fileTypes }}",
	"autopilot-chat-dropzone-overlay-error": "Archivo(s) {{ fileTypes }} no admitido(s).",
	"autopilot-chat-code-block-language": "Texto",
	"autopilot-chat-code-block-copy": "Copiar",
	"autopilot-chat-expand": "Expandir",
	"autopilot-chat-collapse": "Contraer",
	"autopilot-chat-remove-file-name": "Eliminar {{ name }}",
	"autopilot-chat-selected-files": "Archivos seleccionados ({{ count }})",
	"autopilot-chat-files-preview": "{{ files }} y {{ count }} más",
	"autopilot-chat-thinking": "Pensando",
	"autopilot-chat-analyzing": "Analizando tu solicitud",
	"autopilot-chat-thinking-more": "Pensando un poco más",
	"autopilot-chat-suggestions": "Sugerencias"
};

const home$8 = "Accueil";
const help$8 = "Aide";
const languages$8 = "Langues";
const language$8 = "Langue";
const edit$8 = "Modifier";
const enter$8 = "Entrée";
const theme$8 = "Thème";
const logout$8 = "Se déconnecter";
const tenants$8 = "Locataires";
const more$8 = "Plus";
const admin$8 = "Admin";
const autoTheme$8 = "Sélectionner un thème auto";
const dark$8 = "Thème foncé";
const light$8 = "Thème clair";
const dismiss$8 = "Ignorer";
const warning$8 = "Avertissement";
const info$8 = "Info";
const success$8 = "Réussite";
const error$8 = "Erreur";
const more_items$8 = "Plus d’éléments";
const notifications$8 = "Notifications";
const preview$8 = "Aperçu";
const more_products$8 = "Options supplémentaires";
const current_plan_upgrade$8 = "Vous disposez d'une version {{ license }}";
const free_license$8 = "gratuite";
const community_license$8 = "community";
const pro_trial_license$8 = "pro-essai";
const unlicensed$8 = "Sans licence";
const back$8 = "Précédent";
const trademark$8 = "TM";
const basic_auth_user$8 = "Utilisateur local";
const local_group$8 = "Groupe local";
const robot$8 = "Robot";
const directory_group$8 = "Groupe de répertoires";
const directory_user$8 = "Utilisateur du répertoire";
const directory_app$8 = "Application d’annuaire";
const build$8 = "Construire";
const discover$8 = "Découvrir";
const operate$8 = "Opérer";
const feedback$8 = "Commentaires";
const cancel$8 = "Annuler";
const confirm$8 = "Confirmer";
const favorites$8 = "Favoris";
const apply$7 = "Appliquer";
const date$7 = "Date";
const time$7 = "Heure";
const fr = {
	home: home$8,
	help: help$8,
	languages: languages$8,
	language: language$8,
	edit: edit$8,
	"edit-subject": "Modifier {{ subject }}",
	enter: enter$8,
	theme: theme$8,
	logout: logout$8,
	tenants: tenants$8,
	more: more$8,
	admin: admin$8,
	autoTheme: autoTheme$8,
	dark: dark$8,
	light: light$8,
	"light-hc": "Thème clair à contraste élevé",
	"dark-hc": "Thème sombre à contraste élevé",
	"close-button": "Bouton Fermer",
	"client-days": "{{ differenceInDays }} jours restants",
	"client-hours": "{{ differenceInHours }} heures restantes",
	"dropdown-placeholder": "Sélectionnez une option",
	"empty-tenant-list-placeholder": "Aucun locataire valide",
	"tenant-picker-label": "Locataire :",
	"tenant-picker-list": "Locataire",
	"error-page-401-header": "Non autorisé",
	"error-page-403-header": "Oups ! Vous n’êtes pas dans la liste",
	"error-page-403-description": "Vous ne disposez pas des autorisations requises pour consulter {{ pageTitle }}. Contactez votre administrateur afin d’obtenir les autorisations requises.",
	"error-page-404-header": "Oh oh… Votre recherche n’a pas abouti",
	"error-page-404-description": "La page que vous recherchez a peut-être été supprimée, a changé de nom ou est temporairement indisponible.",
	"error-page-503-header": "Nous serons bientôt à nouveau disponibles",
	"error-page-503-description": "Le système est en maintenance. Consultez cet espace pour vous tenir informé.",
	"error-page-browser-header": "Ce navigateur n’est pas pris en charge",
	"error-page-endie-header": "Suppression progressive d’Internet Explorer",
	"error-page-endie-description": "La prise en charge d’Internet Explorer a pris fin le 31 mai 2021. Pour utiliser UiPath, nous vous recommandons la dernière version de Chrome, Firefox, Safari ou Edge.",
	"error-page-ip-restricted-header": "Accès restreint",
	"error-page-ip-restricted-description": "En raison des règles de l'organisation, vous ne pouvez pas accéder à {{ pageTitle }} à partir de cet emplacement réseau. Veuillez contacter votre administrateur.",
	"error-page-learn-more": "En savoir plus",
	"error-page-learn-why": "Découvrir pourquoi",
	"error-page-loader-header": "Veuillez patienter pendant que nous configurons le tout",
	"error-page-loader-description": "Cela ne devrait prendre que quelques minutes. La page s’actualisera dès que la plate-forme sera prête à l’emploi.",
	"error-page-goto-home": "Aller à l’accueil",
	"error-page-goto-uipath-website": "Aller sur le site Web UiPath",
	"error-page-check-service": "Vérifier le statut du service",
	"error-page-know-why": "En savoir plus",
	"aria-label-logo": "Le logo officiel d’UiPath. Cliquez ici pour accéder à la page d’accueil {{ serviceName }}",
	"aria-label-logo-v2": "Logo UiPath Automation Cloud, redirige vers la page d’accueil de {serviceName}",
	"language-na": "Langue non prise en charge pour ce service.",
	dismiss: dismiss$8,
	warning: warning$8,
	info: info$8,
	success: success$8,
	error: error$8,
	"client-days-per-service": "Il vous reste {{ differenceInDays }} jours pour votre version d'essai",
	"client-days-per-service-with-name": "Il vous reste {{ differenceInDays }} jours pour profiter de votre essai gratuit de {{ serviceName }}",
	"client-hours-per-service": "Il vous reste {{ differenceInHours }} heures pour votre version d'essai",
	"client-hours-per-service-with-name": "Il vous reste {{ differenceInHours }} heures pour profiter de votre essai gratuit de {{ serviceName }}",
	"waffle-label": "Lanceur de l'application",
	"generic-error-message": "Une erreur inattendue s’est produite. Veuillez réessayer ultérieurement",
	"help-menu-documentation": "Documentation",
	"help-menu-product-documentation": "Documentation {{ product }}",
	"help-menu-downloads": "Téléchargements",
	"help-menu-forum": "Forum de la communauté",
	"help-menu-training-tutorials": "Formations et tutoriels",
	"help-menu-uipath-academy": "UiPath Academy",
	"help-menu-youtube-tutorials": "Tutoriels YouTube",
	"help-menu-release-notes": "Notes de publication",
	"help-menu-resources": "Ressources",
	"help-menu-support": "Assistance",
	more_items: more_items$8,
	notifications: notifications$8,
	"notifications-empty": "Aucune notification trouvée",
	"notifications-all-read": "Tout marquer comme lu",
	"notifications-unread": "Marquer comme non lu",
	"notifications-read": "Marquer comme lu",
	"notifications-delete": "Supprimer",
	"notifications-mute": "Se désinscrire de {{ topicOrTenant }}",
	"notifications-muted": "Vous avez été désinscrit des notifications de {{ topicOrTenant }} avec succès.",
	"notifications-unread-only": "Non lus uniquement",
	"notifications-settings": "Paramètres de notification",
	"notifications-page": "Page Notifications",
	"notifications-clear-all": "Tout effacer",
	"notifications-end-list": "Fin de la liste",
	"notifications-expandCollapse": "Développer/Réduire",
	"notifications-fetch-failure": "Échec de la récupération des notifications. Veuillez réessayer ultérieurement",
	preview: preview$8,
	"unread-notifications-count": "{{ count }} notifications non lues",
	"people-picker-default-placeholder": "Rechercher par nom ou par e-mail",
	"people-picker-groups-placeholder": "Rechercher par nom de groupe",
	"people-picker-single-mode-placeholder": "Rechercher par nom ou par e-mail",
	"people-picker-single-mode-ad-helper-text": "Rechercher par nom, adresse e-mail ou domaine\\NomCompteSAM",
	"people-picker-single-mode-aad-helper-text": "Rechercher par nom, adresse e-mail, nom de groupe ou nom d'application",
	"people-picker-default-helper-text": "Effectuez une recherche par nom ou saisissez des adresses e-mail séparées par des virgules ou des points-virgules. Vous pouvez échapper les caractères spéciaux à l'aide de \\.",
	"people-picker-aad-helper-text": "Effectuez une recherche par nom ou saisissez des adresses e-mail séparées par des virgules ou des points-virgules. Vous pouvez échapper les caractères spéciaux à l'aide de \\.",
	"people-picker-ad-ldap-helper-text": "Effectuez une recherche par nom ou saisissez des adresses e-mail ou domaine\\NomComptesSAM (domain\\samAccountNames) séparés par des virgules ou des points-virgules. Vous pouvez échapper les caractères spéciaux à l'aide de \\.",
	"people-picker-invalid-error-helper": "Utilisez une adresse e-mail valide",
	"people-picker-resolve-error-helper": "Certaines entrées n'ont pas été résolues. Veuillez les supprimer ou réessayer ultérieurement",
	"people-picker-resolve-error-tooltip": "Impossible de résoudre l'entrée. Veuillez les supprimer ou réessayer ultérieurement",
	"people-picker-domain-picker-helper": "Sélectionner un domaine",
	"people-picker-too-many-entities": "Vous ne pouvez ajouter que {{ maxValue }} entités à la fois",
	"people-picker-more-info": "Plus d’informations",
	"autocomplete-no-results": "Aucun résultat correspondant à « {{ query }} »",
	"autocomplete-limit-exceeded": "Limite de {limit} dépassée",
	"autocomplete-search-text": "Taper pour rechercher...",
	"autocomplete-no-results-people-picker": "Aucun résultat correspondant à « { query } »",
	"autocomplete-loading": "Chargement en cours ...",
	"people-picker-add-users": "Noms",
	"people-picker-add-groups": "Groupes",
	"people-picker-add-apps": "Apps",
	"people-picker-add-names": "Noms",
	"tenant-picker-aria-label": "Sélectionnez un locataire. Locataire actuel : ",
	"people-picker-duplicate-chip": "Certaines entrées existent en double. Veuillez supprimer l’un des doublons, puis réessayez.",
	"profile-navigation": "Préférences",
	"remove-chip": "Supprimer « {{ value }} »",
	"default-cobranding-logo-alt-text": "Logo de co-marquage",
	"canary-tenant": "Canari",
	more_products: more_products$8,
	current_plan_upgrade: current_plan_upgrade$8,
	free_license: free_license$8,
	community_license: community_license$8,
	pro_trial_license: pro_trial_license$8,
	"notification-action-menu-text": "Action sur notification",
	"notification-allaction-menu-text": "Plus d'actions sur toutes les notifications",
	"buy-now": "Acheter maintenant",
	"contact-sales": "Contacter le service commercial",
	"skip-content": "Passer au contenu principal",
	"object-picker-add-entry": "Ajouter « {{ entry }} »",
	"start-free-trial-header": "Démarrez votre",
	"sixty-days-trial": "période d'essai de 60 jours",
	"with-uipath-cloud": "avec UiPath Automation Cloud",
	"take-advantage-capabilities": "Tirez parti de toutes nos capacités Automation Cloud.",
	"upgrade-to-enterprise": "Besoin de faire évoluer votre programme d’automatisation avec une gouvernance, une sécurité, et bien plus, de niveau entreprise ?",
	"trial-benefit-one": "Des robots pour permettre une exécution à distance et à la demande",
	"trial-benefit-two": "Assistant UiPath 24 h/24 et 7 j/7",
	"trial-benefit-three": "Une garantie de disponibilité",
	"trial-benefit-four": "Locataires multiples, chacun hébergé dans l’une de nos régions",
	"view-pricing": "Afficher les prix",
	"upgrade-trial-role": "Intitulé de poste",
	"upgrade-trial-company-name": "Nom de l’entreprise/organisation",
	"upgrade-trial-business-email": "E-mail professionnel",
	"notifications-clear-message": "L'élément de notification a été supprimé",
	"session-expiring": "Expiration de la session",
	"session-expiring-description-inactive-hours": "Vous êtes inactif depuis {{hours}} heures et {{minutes}} minutes.",
	"session-expiring-description-inactive": "Vous êtes inactif depuis {{minutes}} minutes.",
	"session-expiring-description-logged-out": "Vous serez déconnecté dans {{n}} secondes.",
	"extend-session": "Étendre la session",
	"dropdown-position": "{{index}} sur {{total}}",
	unlicensed: unlicensed$8,
	"copy-clipboard": "Copier dans le presse-papiers",
	"people-picker-search-entries": "{{count}} résultats de recherche trouvés correspondant à « {{query}} »",
	"app-bar-aria-label": "Barre d’applications",
	"nav-aria-label": "Navigation de gauche",
	"chat-no-messages": "Saisissez un message ci-dessous pour démarrer le chat",
	"chat-type-a-message": "Saisir un message",
	"filter-service": "Service :",
	"filter-severity": "Gravité :",
	"priority-low": "Basse",
	"priority-medium": "Moyen",
	"priority-high": "Haute",
	"priority-critical": "Critique",
	"filter-option-all": "Tout",
	"severity-info": "Info",
	"severity-success": "Réussite",
	"severity-warn": "Avertir",
	"severity-error": "Erreur",
	"severity-fatal": "Fatal",
	"breadcrumb-aria-label-default": "Barre de navigation",
	back: back$8,
	"switching-orgs": "Basculement d’organisations",
	"switching-orgs-description": "Vous essayez de faire basculer des organisations depuis {{ oldOrg }} vers {{ newOrg }}. Pour continuer, déconnectez-vous d’abord.",
	"business-email-required": "Une adresse e-mail professionnelle est requise pour la mise à niveau vers la version Pro Trial",
	"check-inbox-for-invite-link": "Dans votre boîte de réception, cliquez sur le lien d’invitation et acceptez-le pour réaliser la mise à niveau",
	"invite-business-email-help": "Si vous êtes déjà membre de l’organisation qui utilise cette adresse e-mail, connectez-vous simplement à votre compte pour continuer.",
	"check-email-for-invite": "Consultez votre boîte de réception pour voir si vous avez reçu l’invitation",
	"check-email-for-invite-description": "Si vous ne trouvez pas l'invitation, vérifiez dans votre dossier de courrier indésirable. Vous pourrez passer à la version Pro Trial après avoir accepté l'invitation.",
	"no-minimum-purchase": "Pas de minimum d'achat.",
	"view-details-trial-plan": "Découvrez dans le détail tous les éléments inclus dans la version d'essai de 60 jours du plan Pro",
	"get-more-cloud": "Obtenez plus d'UiPath Automation Cloud",
	"start-free-trial": "Commencer l’essai gratuit",
	trademark: trademark$8,
	"send-invite": "Envoyer une invitation",
	"support-id": "ID de support",
	basic_auth_user: basic_auth_user$8,
	local_group: local_group$8,
	robot: robot$8,
	directory_group: directory_group$8,
	directory_user: directory_user$8,
	directory_app: directory_app$8,
	"unified-admin-button-label": "Gérer l’accès",
	"unified-search-placeholder": "Recherchez Marketplace et la documentation",
	"unified-search-placeholder-v2": "Rechercher des composants, des pages et plus",
	"unified-search-recent-searches": "Recherches récentes",
	"unified-search-recent-pages-visited": "Pages consultées",
	"unified-search-recent-resources-visited": "Ressources consultées",
	"unified-search-no-recent-searches": "Aucune recherche récente, saisissez 3 caractères ou plus pour récupérer les résultats",
	"unified-search-no-recent-searches-logographic-locales": "Aucune recherche récente, saisissez 1 caractère ou plus pour récupérer les résultats",
	"unified-search-marketplace": "Place de marché UiPath",
	"unified-search-documentation": "Documentation",
	"unified-search-open-product": "S’ouvre dans {product}",
	"unified-search-change-search-terms": "Essayez de modifier les termes de recherche",
	"unified-search-no-results-found": "Aucun résultat correspondant à « {term} »",
	"unified-search-footer": "Ce ne sont pas les résultats que vous cherchiez ? {feedbackLink} ou {learnMoreLink}",
	"unified-search-footer-no-feedback": "Ce ne sont pas les résultats que vous cherchiez ? {learnMoreLink}",
	"unified-search-footer-give-feedback": "Ce ne sont pas les résultats que vous cherchiez ? {feedbackLink}",
	"unified-search-documentation-link": "Rechercher « {query} » dans la documentation",
	"unified-search-downloads": "{count} Téléchargements",
	"unified-search-runs": "{count} exécutions",
	"unified-search-all": "Tout",
	"unified-search-see-all": "Voir tous",
	"unified-search-clear-button": "Effacer",
	"unified-search-filter": "Filtre",
	"unified-search-all-count": "Tout ({count})",
	"unified-search-components-count": "Composants ({count})",
	"unified-search-pages-count": "Pages ({count})",
	"unified-search-tags": "Balises : {tagList}",
	"learn-more": "En savoir plus",
	"my-workspace": "Mon espace de travail",
	"give-feedback": "Envoyer un commentaire",
	"ap-autocomplete-input-no-results": "Aucun résultat correspondant à « {query} »",
	"ap-dropdown-placeholder": "Sélectionner...",
	"ap-date-picker-placeholder": "Sélectionner la date",
	"ap-time-picker-placeholder": "Sélectionner l'heure",
	"ap-date-picker-selected-day-label": "{day} sélectionné",
	"ap-breadcrumb-overflow-label": "Liens masqués dans la barre de navigation",
	"unified-search-Studio": "Studio",
	"unified-search-AiCenter": "AI Center",
	"unified-search-Assistant": "Assistant",
	"unified-search-ProcessMining": "Process Mining",
	"unified-search-BusinessSolutions": "Solutions partenaires",
	"unified-search-UiPathApps": "Apps",
	"unified-search-IntegrationServices": "Integration Service",
	"unified-search-StudioX": "StudioX",
	"unified-search-ProfessionalServices": "Services professionnels",
	"unified-search-Accelerator": "Accélérateurs",
	"unified-search-StudioWeb": "Studio Web",
	"unified-search-AutomationOps": "Automation Ops",
	"unified-search-DocumentUnderstanding": "Document Understanding",
	"unified-search-Insights": "Insights",
	"unified-search-Other": "Autre",
	"unified-search-Activity": "Activités",
	"unified-search-CustomActivity": "Activités",
	"unified-search-Snippet": "Extraits",
	"unified-search-WorkflowTemplate": "Modèles",
	"unified-search-Connector": "Connecteurs",
	"unified-search-Tool": "Outils",
	"unified-search-MLModel": "Modèles ML",
	"unified-search-Solution": "Solutions",
	"unified-search-Process": "Automatisations prêtes à l'emploi",
	"unified-search-Widget": "Widget",
	"unified-search-BusinessSolution": "Solutions partenaires",
	"unified-search-App": "Apps",
	"unified-search-UiPathAppSolution": "Solutions d'applications",
	"unified-search-UiPathAppTemplate": "Modèles d'applications",
	"unified-search-IntegrationServiceConnector": "Connecteur Integration Service",
	"unified-search-StudioXWorkflowTemplate": "Modèles",
	"unified-search-ProfessionalService": "Service professionnel",
	"unified-search-StudioWebTemplate": "Modèle Studio Web",
	"unified-search-AutomationOpsPipeline": "Pipelines",
	"unified-search-AutomationOpsPipelineTemplate": "Modèles de pipeline",
	"unified-search-ExtractionModel": "Modèles d'extraction",
	"unified-search-marketplace-studio-activity": "Activité Studio",
	"unified-search-marketplace-studio-snippet": "Extrait Studio",
	"unified-search-marketplace-studio-workflowtemplate": "Modèle Studio",
	"unified-search-marketplace-studio-connector": "Connecteurs (Héritage)",
	"unified-search-marketplace-studio-tool": "Outil Studio",
	"unified-search-marketplace-studio-solution": "Solution Studio",
	"unified-search-marketplace-studioweb-studiowebtemplate": "Modèle Studio Web",
	"unified-search-marketplace-studiox-studioxworkflowtemplate": "Modèle StudioX",
	"unified-search-marketplace-assistant-process": "Automatisation prête à l'emploi",
	"unified-search-marketplace-aicenter-mlmodel": "Modèle ML",
	"unified-search-marketplace-processmining-app": "Modèle d’application Process Mining",
	"unified-search-marketplace-uipathapps-uipathappsolution": "Solution d'application",
	"unified-search-marketplace-uipathapps-uipathapptemplate": "Modèle d'applications",
	"unified-search-marketplace-integrationservices-integrationserviceconnector": "Connecteurs",
	"unified-search-marketplace-accelerator-accelerator": "Accélérateur",
	"unified-search-marketplace-businesssolutions-businesssolution": "Solution partenaire",
	"unified-search-marketplace-professionalservices-professionalservice": "Services professionnels",
	"unified-search-orchestrator-asset": "Ressource",
	"unified-search-orchestrator-process": "Processus",
	"unified-search-orchestrator-trigger": "Déclencheur",
	"unified-search-orchestrator-queue": "File dʹattente",
	"unified-search-orchestrator-bucket": "Compartiment",
	"unified-search-orchestrator-actioncatalog": "Catalogue d’actions",
	"unified-search-orchestrator-machine": "Machine",
	"unified-search-orchestrator-webhook": "Webhook",
	"unified-search-integrationservice-connection": "Connexion",
	"unified-search-integrationservice-trigger": "Déclencheur",
	"unified-search-dataservice-entity": "Entité",
	"unified-search-dataservice-choiceset": "Ensemble de choix",
	"unified-search-apps-app": "Apps",
	"unified-search-loading-search-results": "Chargement des résultats de recherche",
	"rich-text-editor-format-bold": "Format Gras",
	"rich-text-editor-bold": "Gras",
	"rich-text-editor-format-italic": "Format italique",
	"rich-text-editor-italic": "Italique",
	"rich-text-editor-format-underline": "Format de soulignement",
	"rich-text-editor-underline": "Souligner",
	"rich-text-editor-format-strikethrough": "Format Barré",
	"rich-text-editor-strikethrough": "Biffer",
	"rich-text-editor-format-ordered-list": "Format liste ordonnée",
	"rich-text-editor-ordered-list": "Liste ordonnée",
	"rich-text-editor-format-unordered-list": "Format de liste non ordonnée",
	"rich-text-editor-unordered-list": "Liste non ordonnée",
	"rich-text-editor-insert-link": "Insérer lien",
	"rich-text-editor-link": "Lier",
	"rich-text-editor-format-code": "Format de code",
	"rich-text-editor-code": "Code",
	"ap-text-field-placeholder": "Entrer une valeur",
	"notification-message-template": "{{ topic }} dans {{ tenantName }}",
	build: build$8,
	discover: discover$8,
	operate: operate$8,
	feedback: feedback$8,
	"give-us-feedback": "Nous envoyer un commentaire",
	cancel: cancel$8,
	confirm: confirm$8,
	favorites: favorites$8,
	"favorites-limit-reached": "Limite atteinte : vous pouvez ajouter au maximum 3 éléments.",
	"favorites-description": "Vos produits favoris s’afficheront ici. Vous pouvez ajouter au maximum 3 éléments.",
	"default-toggle": "Bouton bascule",
	"default-progress-spinner": "Chargement du contenu en cours",
	"default-icon-button": "Bouton d’icône",
	"default-radio-group": "Groupe Radio",
	"default-checkbox": "Case à cocher",
	"default-stepper-clickable": "avec des étapes cliquables",
	"default-stepper-disabled": "avec des étapes désactivées",
	"new-navigation": "Nouvelle navigation",
	"product-launcher-tooltip": "Lanceur du produit",
	"autopilot-tooltip": "Autopilot",
	"notifications-tooltip": "Notifications",
	"search-tooltip": "Rechercher",
	"help-tooltip": "Aide",
	"profile-tooltip": "Profil",
	apply: apply$7,
	date: date$7,
	time: time$7,
	"date-range": "Plage de dates :",
	"date-range-label": "Plage de dates",
	"date-time-label": "DateTime",
	"date-time-picker-label": "Sélecteur de date et d’heure",
	"date-range-start": "Démarrer",
	"date-range-end": "Terminer",
	"date-range-presets": "Préréglages",
	"date-range-picker-last-hour": "Dernière heure",
	"date-range-picker-today": "Aujourd'hui",
	"date-range-picker-last-seven-days": "7 derniers jours",
	"date-range-picker-last-two-weeks": "2 dernières semaines",
	"date-range-picker-last-month": "Le mois dernier",
	"date-range-picker-last-six-months": "6 derniers mois",
	"date-range-picker-custom": "Personnalisé",
	"date-range-picker-start-tooltip": "La date de début ne peut pas être ultérieure à la date de fin",
	"date-range-picker-label": "Sélecteur de plage de dates",
	"time-selector": "Sélecteur d’heure",
	"date-range-picker-options": "Options de plage de dates",
	"no-options": "Aucune option",
	"type-to-search": "Taper pour rechercher...",
	"autopilot-chat-header": "Autopilot",
	"autopilot-chat-input-placeholder": "Que souhaitez-vous que je fasse ?",
	"autopilot-chat-footer": "Autopilot peut commettre des erreurs. Veuillez vérifier soigneusement les réponses.",
	"autopilot-chat-new-chat": "Nouveau chat",
	"autopilot-chat-close": "Fermer",
	"autopilot-chat-attach-file": "Joindre le(s) fichier(s)",
	"autopilot-chat-send": "Envoyer",
	"autopilot-chat-stop": "Arrêter",
	"autopilot-chat-remove-file": "Supprimer",
	"autopilot-chat-prompt-library": "Bibliothèque d’invite",
	"autopilot-chat-dropzone-overlay-title": "Déposez vos fichiers ici pour les ajouter à votre invite",
	"autopilot-chat-dropzone-overlay-description": "Types de fichiers pris en charge : {{ fileTypes }}",
	"autopilot-chat-dropzone-overlay-error": "Fichier(s) non pris en charge : {{ fileTypes }}.",
	"autopilot-chat-code-block-language": "Texte",
	"autopilot-chat-code-block-copy": "Copier",
	"autopilot-chat-expand": "Développer",
	"autopilot-chat-collapse": "Réduire",
	"autopilot-chat-remove-file-name": "Supprimer {{ name }}",
	"autopilot-chat-selected-files": "Fichiers sélectionnés ({{ count }})",
	"autopilot-chat-files-preview": "{{ files }} et {{ count }} autres",
	"autopilot-chat-thinking": "Réflexion",
	"autopilot-chat-analyzing": "Analyse de votre demande",
	"autopilot-chat-thinking-more": "Réfléchir un peu plus",
	"autopilot-chat-suggestions": "Suggestions"
};

const home$7 = "ホーム";
const help$7 = "ヘルプ";
const languages$7 = "言語";
const language$7 = "言語";
const edit$7 = "編集";
const enter$7 = "入力";
const theme$7 = "テーマ";
const logout$7 = "サインアウト";
const tenants$7 = "テナント";
const more$7 = "その他";
const admin$7 = "管理";
const autoTheme$7 = "テーマを自動選択";
const dark$7 = "ダーク テーマ";
const light$7 = "ライト テーマ";
const dismiss$7 = "無視";
const warning$7 = "Warning";
const info$7 = "Info";
const success$7 = "Success";
const error$7 = "Error";
const more_items$7 = "その他の項目";
const notifications$7 = "通知";
const preview$7 = "プレビュー";
const more_products$7 = "その他のオプション";
const current_plan_upgrade$7 = "{{ license }} プランを利用しています。";
const free_license$7 = "Free";
const community_license$7 = "Community";
const pro_trial_license$7 = "Pro の無料トライアル";
const unlicensed$7 = "ライセンスなし";
const back$7 = "戻る";
const trademark$7 = "TM";
const basic_auth_user$7 = "ローカル ユーザー";
const local_group$7 = "ローカル グループ";
const robot$7 = "ロボット";
const directory_group$7 = "ディレクトリ グループ";
const directory_user$7 = "ディレクトリ ユーザー";
const directory_app$7 = "ディレクトリ アプリ";
const build$7 = "開発";
const discover$7 = "発見";
const operate$7 = "運用";
const feedback$7 = "フィードバック";
const cancel$7 = "キャンセル";
const confirm$7 = "確認";
const favorites$7 = "お気に入り";
const apply$6 = "適用";
const date$6 = "日付";
const time$6 = "時刻";
const ja = {
	home: home$7,
	help: help$7,
	languages: languages$7,
	language: language$7,
	edit: edit$7,
	"edit-subject": "{{ subject }} を編集",
	enter: enter$7,
	theme: theme$7,
	logout: logout$7,
	tenants: tenants$7,
	more: more$7,
	admin: admin$7,
	autoTheme: autoTheme$7,
	dark: dark$7,
	light: light$7,
	"light-hc": "ハイコントラストのライト テーマ",
	"dark-hc": "ハイコントラストのダーク テーマ",
	"close-button": "[閉じる] ボタン",
	"client-days": "残り {{ differenceInDays }} 日",
	"client-hours": "残り {{ differenceInHours }} 時間",
	"dropdown-placeholder": "オプションを選択してください。",
	"empty-tenant-list-placeholder": "有効なテナントなし",
	"tenant-picker-label": "テナント:",
	"tenant-picker-list": "テナント",
	"error-page-401-header": "未承認",
	"error-page-403-header": "リストに載っていません。",
	"error-page-403-description": "「{{ pageTitle }}」を表示する権限がありません。必要な権限について管理者にお問い合わせください。",
	"error-page-404-header": "ページが見つかりません。",
	"error-page-404-description": "お探しのページは削除されたか、名前が変更されたか、一時的に利用できなくなっています。",
	"error-page-503-header": "しばらくお待ちください。",
	"error-page-503-description": "システムは現在メンテナンス中です。ご迷惑をおかけしますが、こちらで最新の状況をご確認ください。",
	"error-page-browser-header": "このブラウザーはサポートされていません。",
	"error-page-endie-header": "Internet Explorer のサポートを段階的に終了しています。",
	"error-page-endie-description": "2021 年 5 月 31 日に Internet Explorer のサポートを終了しました。UiPath 製品を使用するには、最新バージョンの Chrome、Firefox、Safari または Edge を使用することをお勧めします。",
	"error-page-ip-restricted-header": "アクセスが制限されました。",
	"error-page-ip-restricted-description": "組織のポリシーにより、このネットワークの場所からは「{{ pageTitle }}」にアクセスできません。管理者にお問い合わせください。",
	"error-page-learn-more": "詳細",
	"error-page-learn-why": "詳細を確認",
	"error-page-loader-header": "設定しています。しばらくお待ちください。",
	"error-page-loader-description": "これには数分かかる場合があります。プラットフォームを使用する準備ができたら、ページは更新されます。",
	"error-page-goto-home": "ホームに移動",
	"error-page-goto-uipath-website": "UiPath の Web サイトに移動",
	"error-page-check-service": "サービスのステータスを確認",
	"error-page-know-why": "エラーの原因を確認",
	"aria-label-logo": "UiPath の公式ロゴです。ここをクリックすると、{{ serviceName }} のホームに移動します。",
	"aria-label-logo-v2": "UiPath Automation Cloud のロゴです。ここをクリックすると {serviceName} のホームに移動します。",
	"language-na": "このサービスではサポートされていない言語です。",
	dismiss: dismiss$7,
	warning: warning$7,
	info: info$7,
	success: success$7,
	error: error$7,
	"client-days-per-service": "無料トライアルの終了まで残り {{ differenceInDays }} 日です。",
	"client-days-per-service-with-name": "{{ serviceName }} の無料トライアルの終了まで残り {{ differenceInDays }} 日です。",
	"client-hours-per-service": "無料トライアルの終了まで残り {{ differenceInHours }} 時間です。",
	"client-hours-per-service-with-name": "{{ serviceName }} の無料トライアルの終了まで残り {{ differenceInHours }} 時間です。",
	"waffle-label": "アプリ起動ツール",
	"generic-error-message": "予期しないエラーが発生しました。しばらくしてからもう一度お試しください。",
	"help-menu-documentation": "製品ドキュメント",
	"help-menu-product-documentation": "{{ product }} ドキュメント",
	"help-menu-downloads": "ダウンロード",
	"help-menu-forum": "コミュニティ フォーラム",
	"help-menu-training-tutorials": "トレーニングとチュートリアル",
	"help-menu-uipath-academy": "UiPath アカデミー",
	"help-menu-youtube-tutorials": "YouTube のチュートリアル",
	"help-menu-release-notes": "リリース ノート",
	"help-menu-resources": "リソース",
	"help-menu-support": "サポート",
	more_items: more_items$7,
	notifications: notifications$7,
	"notifications-empty": "通知はありません。",
	"notifications-all-read": "すべて既読にする",
	"notifications-unread": "未読にする",
	"notifications-read": "既読にする",
	"notifications-delete": "削除",
	"notifications-mute": "{{ topicOrTenant }} の通知を停止",
	"notifications-muted": "成功: {{ topicOrTenant }} の通知を停止しました。",
	"notifications-unread-only": "未読のみ",
	"notifications-settings": "通知設定",
	"notifications-page": "通知ページ",
	"notifications-clear-all": "すべてクリア",
	"notifications-end-list": "リストの最後",
	"notifications-expandCollapse": "展開/折りたたみ",
	"notifications-fetch-failure": "通知の取得に失敗しました。しばらくしてからもう一度お試しください。",
	preview: preview$7,
	"unread-notifications-count": "{{ count }} 件の未読の通知",
	"people-picker-default-placeholder": "名前またはメール アドレスで検索",
	"people-picker-groups-placeholder": "グループ名で検索します。",
	"people-picker-single-mode-placeholder": "名前またはメール アドレスで検索",
	"people-picker-single-mode-ad-helper-text": "名前、メール アドレスまたは domain\\samAccountName で検索",
	"people-picker-single-mode-aad-helper-text": "名前、メール アドレス、グループ名、またはアプリ名で検索",
	"people-picker-default-helper-text": "名前で検索するか、メール アドレスをコンマまたはセミコロンで区切って入力します。\\ を使用して特殊文字をエスケープできます。",
	"people-picker-aad-helper-text": "名前で検索するか、メール アドレスをコンマまたはセミコロンで区切って入力します。\\ を使用して特殊文字をエスケープできます。",
	"people-picker-ad-ldap-helper-text": "名前で検索するか、メール アドレスまたは domain\\samAccountNames をコンマまたはセミコロンで区切って入力します。\\ を使用して特殊文字をエスケープできます。",
	"people-picker-invalid-error-helper": "有効なメール アドレスを使用してください。",
	"people-picker-resolve-error-helper": "一部のエントリを解決できませんでした。それらのエントリを削除するか、後でもう一度お試しください。",
	"people-picker-resolve-error-tooltip": "エントリを解決できませんでした。エントリを削除するか、後でもう一度お試しください。",
	"people-picker-domain-picker-helper": "ドメインを選択します。",
	"people-picker-too-many-entities": "一度に追加できるエンティティは {{ maxValue }} 個までです。",
	"people-picker-more-info": "詳細情報",
	"autocomplete-no-results": "\"{{ query }}\" と一致する結果がありません。",
	"autocomplete-limit-exceeded": "{limit} の制限を超えました。",
	"autocomplete-search-text": "入力して検索...",
	"autocomplete-no-results-people-picker": "「{ query }」に一致する結果がありません。",
	"autocomplete-loading": "読み込んでいます...",
	"people-picker-add-users": "名前",
	"people-picker-add-groups": "グループ",
	"people-picker-add-apps": "アプリ",
	"people-picker-add-names": "名前",
	"tenant-picker-aria-label": "テナントを選択します。現在のテナント: ",
	"people-picker-duplicate-chip": "一部のエントリが重複しています。重複するエントリのうちのいずれかを削除してから、もう一度お試しください。",
	"profile-navigation": "設定",
	"remove-chip": "「{{ value }}」を削除",
	"default-cobranding-logo-alt-text": "コブランディング ロゴ",
	"canary-tenant": "カナリア",
	more_products: more_products$7,
	current_plan_upgrade: current_plan_upgrade$7,
	free_license: free_license$7,
	community_license: community_license$7,
	pro_trial_license: pro_trial_license$7,
	"notification-action-menu-text": "通知に対するアクション",
	"notification-allaction-menu-text": "すべての通知に対するその他のアクション",
	"buy-now": "今すぐ購入",
	"contact-sales": "セールスに問い合わせ",
	"skip-content": "メイン コンテンツにスキップ",
	"object-picker-add-entry": "「{{ entry }}」を追加",
	"start-free-trial-header": "はじめましょう。",
	"sixty-days-trial": "60 日間の無料トライアルを",
	"with-uipath-cloud": "UiPath Automation Cloud で",
	"take-advantage-capabilities": "Automation Cloud の充実した機能を活用しましょう。",
	"upgrade-to-enterprise": "エンタープライズ レベルのガバナンスやセキュリティを活用し、オートメーション プログラムの規模を拡大する必要がありますか?",
	"trial-benefit-one": "リモートでのオンデマンドな実行を可能にするロボット",
	"trial-benefit-two": "UiPath による 24 時間 365 日のサポート",
	"trial-benefit-three": "稼働時間保証",
	"trial-benefit-four": "複数のテナントをそれぞれ任意のリージョンでホスト",
	"view-pricing": "価格を表示",
	"upgrade-trial-role": "役職",
	"upgrade-trial-company-name": "企業/組織名",
	"upgrade-trial-business-email": "勤務先のメール アドレス",
	"notifications-clear-message": "通知項目が削除されました。",
	"session-expiring": "セッションの有効期限が切れました。",
	"session-expiring-description-inactive-hours": "{{hours}} 時間 {{minutes}} 分の間、非アクティブ状態です。",
	"session-expiring-description-inactive": "{{minutes}} 分間、非アクティブ状態です。",
	"session-expiring-description-logged-out": "{{n}} 秒後にログアウトされます。",
	"extend-session": "セッションを延長",
	"dropdown-position": "{{index}} / {{total}}",
	unlicensed: unlicensed$7,
	"copy-clipboard": "クリップボードにコピー",
	"people-picker-search-entries": "「{{query}}」に一致する結果が {{count}} 件見つかりました。",
	"app-bar-aria-label": "アプリ バー",
	"nav-aria-label": "左側ナビゲーション",
	"chat-no-messages": "以下にメッセージを入力してチャットを開始します。",
	"chat-type-a-message": "メッセージを入力",
	"filter-service": "サービス:",
	"filter-severity": "重要度:",
	"priority-low": "低",
	"priority-medium": "中",
	"priority-high": "高",
	"priority-critical": "緊急",
	"filter-option-all": "すべて",
	"severity-info": "Info",
	"severity-success": "Success",
	"severity-warn": "Warn",
	"severity-error": "Error",
	"severity-fatal": "Fatal",
	"breadcrumb-aria-label-default": "階層リンク",
	back: back$7,
	"switching-orgs": "組織を切り替える",
	"switching-orgs-description": "組織を {{ oldOrg }} から {{ newOrg }} に切り替えようとしています。続行するには、最初にサインアウトしてください。",
	"business-email-required": "Pro Trial にアップグレードするには勤務先のメール アドレスが必要です。",
	"check-inbox-for-invite-link": "招待リンクが記載されたメールを確認し、承諾してアップグレードを完了します。",
	"invite-business-email-help": "すでにこのメール アドレスを使用する組織のメンバーである場合は、アカウントにログインして続行してください。",
	"check-email-for-invite": "招待メールを確認します。",
	"check-email-for-invite-description": "招待メールが見つからない場合は、迷惑メール フォルダーをご確認ください。招待を承諾すると、Pro Trial にアップグレードできます。",
	"no-minimum-purchase": "最低購入額はありません。",
	"view-details-trial-plan": "Pro プランの 60 日間の無料トライアルに含まれる、すべての詳細情報を表示",
	"get-more-cloud": "UiPath Automation Cloud が提供する、より幅広い機能を利用できます。",
	"start-free-trial": "無料トライアルを開始",
	trademark: trademark$7,
	"send-invite": "招待を送信",
	"support-id": "サポート ID",
	basic_auth_user: basic_auth_user$7,
	local_group: local_group$7,
	robot: robot$7,
	directory_group: directory_group$7,
	directory_user: directory_user$7,
	directory_app: directory_app$7,
	"unified-admin-button-label": "アクセス権を管理",
	"unified-search-placeholder": "Marketplace と製品ドキュメントを検索",
	"unified-search-placeholder-v2": "コンポーネントやページなどを検索",
	"unified-search-recent-searches": "最近の検索",
	"unified-search-recent-pages-visited": "最近表示したページ",
	"unified-search-recent-resources-visited": "最近使用したリソース",
	"unified-search-no-recent-searches": "最近の検索履歴がありません。3 文字以上入力して結果を取得してください。",
	"unified-search-no-recent-searches-logographic-locales": "最近の検索履歴がありません。結果を取得するには 1 文字以上入力します。",
	"unified-search-marketplace": "Marketplace",
	"unified-search-documentation": "製品ドキュメント",
	"unified-search-open-product": "{product} で開く",
	"unified-search-change-search-terms": "検索語句を変更してみてください。",
	"unified-search-no-results-found": "「{term}」に一致する結果がありませんでした。",
	"unified-search-footer": "期待した結果が得られませんでしたか?{feedbackLink} または {learnMoreLink}",
	"unified-search-footer-no-feedback": "期待した結果が得られませんでしたか?{learnMoreLink}",
	"unified-search-footer-give-feedback": "期待した結果が得られませんでしたか? {feedbackLink}",
	"unified-search-documentation-link": "ドキュメントで「{query}」を検索",
	"unified-search-downloads": "{count} 件のダウンロード",
	"unified-search-runs": "{count} 件の実行",
	"unified-search-all": "すべて",
	"unified-search-see-all": "すべて表示",
	"unified-search-clear-button": "クリア",
	"unified-search-filter": "フィルター",
	"unified-search-all-count": "すべて ({count})",
	"unified-search-components-count": "コンポーネント ({count})",
	"unified-search-pages-count": "ページ ({count})",
	"unified-search-tags": "タグ: {tagList}",
	"learn-more": "詳細",
	"my-workspace": "マイ ワークスペース",
	"give-feedback": "フィードバックを送る",
	"ap-autocomplete-input-no-results": "「{query}」に一致する結果がありません。",
	"ap-dropdown-placeholder": "選択...",
	"ap-date-picker-placeholder": "日付を選択",
	"ap-time-picker-placeholder": "時間を選択",
	"ap-date-picker-selected-day-label": "{day} を選択中",
	"ap-breadcrumb-overflow-label": "階層リンクの非表示リンク",
	"unified-search-Studio": "Studio",
	"unified-search-AiCenter": "AI Center",
	"unified-search-Assistant": "Assistant",
	"unified-search-ProcessMining": "Process Mining",
	"unified-search-BusinessSolutions": "パートナー ソリューション",
	"unified-search-UiPathApps": "Apps",
	"unified-search-IntegrationServices": "Integration Service",
	"unified-search-StudioX": "StudioX",
	"unified-search-ProfessionalServices": "プロフェッショナル サービス",
	"unified-search-Accelerator": "アクセラレータ",
	"unified-search-StudioWeb": "Studio Web",
	"unified-search-AutomationOps": "Automation Ops",
	"unified-search-DocumentUnderstanding": "Document Understanding",
	"unified-search-Insights": "Insights",
	"unified-search-Other": "その他",
	"unified-search-Activity": "アクティビティ",
	"unified-search-CustomActivity": "アクティビティ",
	"unified-search-Snippet": "スニペット",
	"unified-search-WorkflowTemplate": "テンプレート",
	"unified-search-Connector": "コネクタ",
	"unified-search-Tool": "ツール",
	"unified-search-MLModel": "ML モデル",
	"unified-search-Solution": "ソリューション",
	"unified-search-Process": "すぐに使えるオートメーション",
	"unified-search-Widget": "ウィジェット",
	"unified-search-BusinessSolution": "パートナー ソリューション",
	"unified-search-App": "Apps",
	"unified-search-UiPathAppSolution": "アプリ ソリューション",
	"unified-search-UiPathAppTemplate": "アプリ テンプレート",
	"unified-search-IntegrationServiceConnector": "Integration Service のコネクタ",
	"unified-search-StudioXWorkflowTemplate": "テンプレート",
	"unified-search-ProfessionalService": "プロフェッショナル サービス",
	"unified-search-StudioWebTemplate": "Studio Web テンプレート",
	"unified-search-AutomationOpsPipeline": "パイプライン",
	"unified-search-AutomationOpsPipelineTemplate": "パイプライン テンプレート",
	"unified-search-ExtractionModel": "抽出モデル",
	"unified-search-marketplace-studio-activity": "Studio アクティビティ",
	"unified-search-marketplace-studio-snippet": "Studio スニペット",
	"unified-search-marketplace-studio-workflowtemplate": "Studio テンプレート",
	"unified-search-marketplace-studio-connector": "コネクタ (レガシ)",
	"unified-search-marketplace-studio-tool": "Studio ツール",
	"unified-search-marketplace-studio-solution": "Studio ソリューション",
	"unified-search-marketplace-studioweb-studiowebtemplate": "Studio Web テンプレート",
	"unified-search-marketplace-studiox-studioxworkflowtemplate": "StudioX テンプレート",
	"unified-search-marketplace-assistant-process": "すぐに使えるオートメーション",
	"unified-search-marketplace-aicenter-mlmodel": "ML モデル",
	"unified-search-marketplace-processmining-app": "Process Mining アプリ テンプレート",
	"unified-search-marketplace-uipathapps-uipathappsolution": "アプリ ソリューション",
	"unified-search-marketplace-uipathapps-uipathapptemplate": "アプリ テンプレート",
	"unified-search-marketplace-integrationservices-integrationserviceconnector": "コネクタ",
	"unified-search-marketplace-accelerator-accelerator": "アクセラレータ",
	"unified-search-marketplace-businesssolutions-businesssolution": "パートナー ソリューション",
	"unified-search-marketplace-professionalservices-professionalservice": "プロフェッショナル サービス",
	"unified-search-orchestrator-asset": "アセット",
	"unified-search-orchestrator-process": "プロセス",
	"unified-search-orchestrator-trigger": "トリガー",
	"unified-search-orchestrator-queue": "キュー",
	"unified-search-orchestrator-bucket": "バケット",
	"unified-search-orchestrator-actioncatalog": "アクション カタログ",
	"unified-search-orchestrator-machine": "マシン",
	"unified-search-orchestrator-webhook": "Webhook",
	"unified-search-integrationservice-connection": "コネクション",
	"unified-search-integrationservice-trigger": "トリガー",
	"unified-search-dataservice-entity": "エンティティ",
	"unified-search-dataservice-choiceset": "チョイス セット",
	"unified-search-apps-app": "Apps",
	"unified-search-loading-search-results": "検索結果を読み込んでいます。",
	"rich-text-editor-format-bold": "書式設定 (太字)",
	"rich-text-editor-bold": "太字",
	"rich-text-editor-format-italic": "書式設定 (斜体)",
	"rich-text-editor-italic": "斜体",
	"rich-text-editor-format-underline": "書式設定 (下線)",
	"rich-text-editor-underline": "下線",
	"rich-text-editor-format-strikethrough": "書式設定 (取り消し線)",
	"rich-text-editor-strikethrough": "取り消し線",
	"rich-text-editor-format-ordered-list": "書式設定 (番号付きリスト)",
	"rich-text-editor-ordered-list": "番号付きリスト",
	"rich-text-editor-format-unordered-list": "書式設定 (記号付きリスト)",
	"rich-text-editor-unordered-list": "記号付きリスト",
	"rich-text-editor-insert-link": "リンクを挿入",
	"rich-text-editor-link": "リンク",
	"rich-text-editor-format-code": "書式設定 (コード)",
	"rich-text-editor-code": "コード",
	"ap-text-field-placeholder": "値を入力",
	"notification-message-template": "{{ tenantName }} の {{ topic }}",
	build: build$7,
	discover: discover$7,
	operate: operate$7,
	feedback: feedback$7,
	"give-us-feedback": "フィードバックを送信",
	cancel: cancel$7,
	confirm: confirm$7,
	favorites: favorites$7,
	"favorites-limit-reached": "上限に達しました。追加できる項目は最大 3 つです。",
	"favorites-description": "お気に入りの製品がここに表示されます。追加できる項目は最大 3 つです。",
	"default-toggle": "切り替えスイッチ",
	"default-progress-spinner": "内容を読み込んでいます。",
	"default-icon-button": "アイコン ボタン",
	"default-radio-group": "ラジオ グループ",
	"default-checkbox": "チェックボックス",
	"default-stepper-clickable": "クリック可能な手順あり",
	"default-stepper-disabled": "無効化された手順あり",
	"new-navigation": "新しいナビゲーション",
	"product-launcher-tooltip": "製品起動ツール",
	"autopilot-tooltip": "Autopilot",
	"notifications-tooltip": "通知",
	"search-tooltip": "検索",
	"help-tooltip": "ヘルプ",
	"profile-tooltip": "プロフィール",
	apply: apply$6,
	date: date$6,
	time: time$6,
	"date-range": "日付範囲:",
	"date-range-label": "データ範囲",
	"date-time-label": "日付と時刻",
	"date-time-picker-label": "日付/時刻の選択",
	"date-range-start": "開始",
	"date-range-end": "終了",
	"date-range-presets": "プリセット",
	"date-range-picker-last-hour": "過去 1 時間",
	"date-range-picker-today": "今日",
	"date-range-picker-last-seven-days": "過去 7 日間",
	"date-range-picker-last-two-weeks": "過去 2 週間",
	"date-range-picker-last-month": "先月",
	"date-range-picker-last-six-months": "過去半年間",
	"date-range-picker-custom": "カスタム",
	"date-range-picker-start-tooltip": "開始日は終了日より未来の日付にはできません。",
	"date-range-picker-label": "日付範囲セレクター",
	"time-selector": "時刻セレクター",
	"date-range-picker-options": "日付範囲のオプション",
	"no-options": "オプションなし",
	"type-to-search": "入力して検索...",
	"autopilot-chat-header": "Autopilot",
	"autopilot-chat-input-placeholder": "どのようなサポートが必要ですか?",
	"autopilot-chat-footer": "Autopilot は間違うことがあります。必ず回答を確認してください。",
	"autopilot-chat-new-chat": "新しいチャット",
	"autopilot-chat-close": "閉じる",
	"autopilot-chat-attach-file": "ファイルを添付",
	"autopilot-chat-send": "送信",
	"autopilot-chat-stop": "停止",
	"autopilot-chat-remove-file": "削除",
	"autopilot-chat-prompt-library": "プロンプト ライブラリ",
	"autopilot-chat-dropzone-overlay-title": "ここにファイルをドロップして、プロンプトに追加します。",
	"autopilot-chat-dropzone-overlay-description": "サポートされているファイルの種類: {{ fileTypes }}",
	"autopilot-chat-dropzone-overlay-error": "サポートされていないファイル: {{ fileTypes }}",
	"autopilot-chat-code-block-language": "テキスト",
	"autopilot-chat-code-block-copy": "コピー",
	"autopilot-chat-expand": "展開",
	"autopilot-chat-collapse": "折りたたみ",
	"autopilot-chat-remove-file-name": "{{ name }} を削除",
	"autopilot-chat-selected-files": "選択中のファイル ({{ count }})",
	"autopilot-chat-files-preview": "{{ files }}、他 {{ count }} 個",
	"autopilot-chat-thinking": "考えています。",
	"autopilot-chat-analyzing": "リクエストを分析しています。",
	"autopilot-chat-thinking-more": "まだ考えています。",
	"autopilot-chat-suggestions": "提案"
};

const home$6 = "홈";
const help$6 = "도움말";
const languages$6 = "언어";
const language$6 = "언어";
const edit$6 = "편집";
const enter$6 = "입력";
const theme$6 = "테마";
const logout$6 = "로그아웃";
const tenants$6 = "테넌트";
const more$6 = "자세히";
const admin$6 = "관리자";
const autoTheme$6 = "테마 자동 선택";
const dark$6 = "어두운 테마";
const light$6 = "밝은 테마";
const dismiss$6 = "해제";
const warning$6 = "경고";
const info$6 = "정보";
const success$6 = "성공";
const error$6 = "오류";
const more_items$6 = "추가 항목";
const notifications$6 = "알림";
const preview$6 = "미리 보기";
const more_products$6 = "추가 옵션";
const current_plan_upgrade$6 = "{{ license }} 요금제를 사용 중입니다.";
const free_license$6 = "무료";
const community_license$6 = "커뮤니티";
const pro_trial_license$6 = "프로 체험판";
const unlicensed$6 = "라이선스 없음";
const back$6 = "뒤로";
const trademark$6 = "TM";
const basic_auth_user$6 = "로컬 사용자";
const local_group$6 = "로컬 그룹";
const robot$6 = "Robot";
const directory_group$6 = "디렉터리 그룹";
const directory_user$6 = "디렉터리 사용자";
const directory_app$6 = "디렉터리 앱";
const build$6 = "빌드";
const discover$6 = "Discover";
const operate$6 = "작동";
const feedback$6 = "피드백";
const cancel$6 = "취소";
const confirm$6 = "확인";
const favorites$6 = "즐겨찾기";
const apply$5 = "적용";
const date$5 = "날짜";
const time$5 = "시간";
const ko = {
	home: home$6,
	help: help$6,
	languages: languages$6,
	language: language$6,
	edit: edit$6,
	"edit-subject": "{{ subject }} 편집",
	enter: enter$6,
	theme: theme$6,
	logout: logout$6,
	tenants: tenants$6,
	more: more$6,
	admin: admin$6,
	autoTheme: autoTheme$6,
	dark: dark$6,
	light: light$6,
	"light-hc": "고대비 밝은 테마",
	"dark-hc": "고대비 어두운 테마",
	"close-button": "CloseButton",
	"client-days": "{{ differenceInDays }}일 남음",
	"client-hours": "{{ differenceInHours }}시간 남음",
	"dropdown-placeholder": "어떤 옵션이든 선택하십시오.",
	"empty-tenant-list-placeholder": "유효한 테넌트가 없습니다.",
	"tenant-picker-label": "테넌트:",
	"tenant-picker-list": "테넌트",
	"error-page-401-header": "권한이 없음",
	"error-page-403-header": "죄송합니다. 목록에 없는 사용자입니다.",
	"error-page-403-description": "{{ pageTitle }}을(를) 볼 수 있는 권한이 없습니다. 관리자에게 필요한 권한을 요청하십시오.",
	"error-page-404-header": "찾을 수 없습니다.",
	"error-page-404-description": "찾고 있는 페이지가 제거되었거나 이름이 변경되었거나 일시적으로 사용할 수 없습니다.",
	"error-page-503-header": "곧 백업됩니다.",
	"error-page-503-description": "시스템 유지보수 중입니다. 이 공간에 업데이트가 표시됩니다.",
	"error-page-browser-header": "이 브라우저는 지원되지 않습니다.",
	"error-page-endie-header": "Internet Explorer의 단계적 중단",
	"error-page-endie-description": "Internet Explorer에 대한 지원이 2021년 5월 31일에 종료되었습니다. UiPath를 사용하려면 최신 버전의 Chrome, Firefox, Safari 또는 Edge를 사용하십시오.",
	"error-page-ip-restricted-header": "액세스 제한됨",
	"error-page-ip-restricted-description": "조직 정책으로 인해 이 네트워크 위치에서 {{ pageTitle }}에 액세스할 수 없습니다. 관리자에게 문의하십시오.",
	"error-page-learn-more": "자세히 알아보기",
	"error-page-learn-why": "이유 알아보기",
	"error-page-loader-header": "설정하는 동안 잠시 기다려 주십시오.",
	"error-page-loader-description": "이 작업에는 몇 분 정도 걸릴 수 있습니다. 플랫폼을 사용할 수 있게 되면 페이지가 새로 고침됩니다.",
	"error-page-goto-home": "홈으로 이동",
	"error-page-goto-uipath-website": "UiPath 웹사이트로 이동",
	"error-page-check-service": "서비스 상태 확인",
	"error-page-know-why": "이유 알아보기",
	"aria-label-logo": "UiPath의 공식 로고입니다. 여기를 클릭하여 {{ serviceName }} 홈으로 이동",
	"aria-label-logo-v2": "UiPath Automation Cloud 로고, 여기를 클릭하면 {serviceName} 홈으로 이동합니다",
	"language-na": "이 서비스에서 지원되지 않는 언어입니다.",
	dismiss: dismiss$6,
	warning: warning$6,
	info: info$6,
	success: success$6,
	error: error$6,
	"client-days-per-service": "체험판 기간이 {{ differenceInDays }}일 남았습니다.",
	"client-days-per-service-with-name": "{{ serviceName }}의 무료 평가판이 {{ differenceInDays }}일 남았습니다",
	"client-hours-per-service": "체험판 기간이 {{ differenceInHours }}시간 남았습니다.",
	"client-hours-per-service-with-name": "{{ serviceName }}의 무료 평가판이 {{ differenceInHours }}시간 남았습니다",
	"waffle-label": "앱 실행기",
	"generic-error-message": "예기치 않은 오류가 발생했습니다. 나중에 다시 시도하십시오.",
	"help-menu-documentation": "문서",
	"help-menu-product-documentation": "{{ product }} 문서",
	"help-menu-downloads": "다운로드",
	"help-menu-forum": "커뮤니티 포럼",
	"help-menu-training-tutorials": "교육 및 튜토리얼",
	"help-menu-uipath-academy": "UiPath Academy",
	"help-menu-youtube-tutorials": "YouTube 튜토리얼",
	"help-menu-release-notes": "릴리스 정보",
	"help-menu-resources": "리소스",
	"help-menu-support": "지원",
	more_items: more_items$6,
	notifications: notifications$6,
	"notifications-empty": "알림이 없음",
	"notifications-all-read": "모두 읽음으로 표시",
	"notifications-unread": "읽지 않음으로 표시",
	"notifications-read": "읽음으로 표시",
	"notifications-delete": "삭제",
	"notifications-mute": "{{ topicOrTenant }} 구독 취소",
	"notifications-muted": "성공: {{ topicOrTenant }} 알림을 구독 취소했습니다.",
	"notifications-unread-only": "읽지 않음만",
	"notifications-settings": "알림 설정",
	"notifications-page": "알림 페이지",
	"notifications-clear-all": "모두 지우기",
	"notifications-end-list": "목록의 끝",
	"notifications-expandCollapse": "확장/축소",
	"notifications-fetch-failure": "알림을 가져오지 못했습니다. 나중에 다시 시도하십시오.",
	preview: preview$6,
	"unread-notifications-count": "읽지 않은 알림이 {{ count }}개 있음",
	"people-picker-default-placeholder": "이름 또는 이메일로 검색",
	"people-picker-groups-placeholder": "그룹 이름으로 검색",
	"people-picker-single-mode-placeholder": "이름 또는 이메일로 검색",
	"people-picker-single-mode-ad-helper-text": "이름, 이메일 또는 domain\\samAccountName으로 검색",
	"people-picker-single-mode-aad-helper-text": "이름 또는 이메일, 그룹 이름 또는 앱 이름으로 검색",
	"people-picker-default-helper-text": "이름으로 검색하거나 쉼표 또는 세미콜론으로 구분된 이메일을 입력하십시오. \\를 사용하여 특수 문자를 이스케이프할 수 있습니다.",
	"people-picker-aad-helper-text": "이름으로 검색하거나 쉼표 또는 세미콜론으로 구분된 이메일을 입력하십시오. \\를 사용하여 특수 문자를 이스케이프할 수 있습니다.",
	"people-picker-ad-ldap-helper-text": "이름으로 검색하거나 쉼표 또는 세미콜론으로 구분된 이메일 또는 domain\\samAccountNames를 입력하십시오. \\를 사용하여 특수 문자를 이스케이프할 수 있습니다.",
	"people-picker-invalid-error-helper": "유효한 이메일 사용",
	"people-picker-resolve-error-helper": "확인할 수 없는 항목이 있습니다. 해당 항목을 제거하거나 나중에 다시 시도하십시오.",
	"people-picker-resolve-error-tooltip": "항목을 확인할 수 없습니다. 해당 항목을 제거하거나 나중에 다시 시도하십시오.",
	"people-picker-domain-picker-helper": "도메인 선택",
	"people-picker-too-many-entities": "한 번에 {{ maxValue }}개의 엔터티만 추가 할 수 있습니다.",
	"people-picker-more-info": "추가 정보",
	"autocomplete-no-results": "\"{{ query }}\"과(와) 일치하는 결과 없음",
	"autocomplete-limit-exceeded": "한도 {limit} 초과",
	"autocomplete-search-text": "검색하려면 입력...",
	"autocomplete-no-results-people-picker": "\"{ query }\"과(와) 일치하는 결과 없음",
	"autocomplete-loading": "로드하는 중...",
	"people-picker-add-users": "이름",
	"people-picker-add-groups": "그룹",
	"people-picker-add-apps": "Apps",
	"people-picker-add-names": "이름",
	"tenant-picker-aria-label": "테넌트를 선택하십시오. 현재: ",
	"people-picker-duplicate-chip": "일부 항목이 중복됩니다. 중복 항목 중 하나를 제거하고 다시 시도하십시오.",
	"profile-navigation": "환경 설정",
	"remove-chip": "\"{{ value }}\" 제거",
	"default-cobranding-logo-alt-text": "공동 브랜딩 로고",
	"canary-tenant": "카나리아",
	more_products: more_products$6,
	current_plan_upgrade: current_plan_upgrade$6,
	free_license: free_license$6,
	community_license: community_license$6,
	pro_trial_license: pro_trial_license$6,
	"notification-action-menu-text": "알림에 대한 액션",
	"notification-allaction-menu-text": "모든 알림에 대한 추가 액션",
	"buy-now": "지금 구입하기",
	"contact-sales": "영업 팀에 문의하기",
	"skip-content": "기본 콘텐츠로 건너뛰기",
	"object-picker-add-entry": "'{{ entry }}' 추가",
	"start-free-trial-header": "UiPath Automation Cloud로",
	"sixty-days-trial": "60일 체험판",
	"with-uipath-cloud": "시작하기",
	"take-advantage-capabilities": "전체 Automation Cloud 기능을 활용하십시오.",
	"upgrade-to-enterprise": "엔터프라이즈급 거버넌스, 보안 등으로 자동화 프로그램을 확장해야 합니까?",
	"trial-benefit-one": "원격 온디맨드 실행을 지원하는 로봇",
	"trial-benefit-two": "UiPath의 연중무휴 24시간 지원",
	"trial-benefit-three": "가동 시간 보장",
	"trial-benefit-four": "다중 테넌트, 각각 UiPath 서비스 지역 중 한 곳에서 호스팅됨",
	"view-pricing": "가격 보기",
	"upgrade-trial-role": "직책",
	"upgrade-trial-company-name": "비즈니스/조직 이름",
	"upgrade-trial-business-email": "작업 이메일",
	"notifications-clear-message": "알림 항목이 삭제되었습니다",
	"session-expiring": "세션 만료",
	"session-expiring-description-inactive-hours": "{{hours}}시간 {{minutes}}분 동안 비활성 상태로 유지되었습니다.",
	"session-expiring-description-inactive": "{{minutes}}분 동안 비활성 상태로 유지되었습니다.",
	"session-expiring-description-logged-out": "{{n}}초 후에 로그아웃됩니다.",
	"extend-session": "세션 연장",
	"dropdown-position": "{{index}}/{{total}}",
	unlicensed: unlicensed$6,
	"copy-clipboard": "클립보드에 복사",
	"people-picker-search-entries": "\"{{query}}\"과(와) 일치하는 {{count}}개의 검색 결과를 찾았습니다.",
	"app-bar-aria-label": "앱 바",
	"nav-aria-label": "왼쪽 탐색",
	"chat-no-messages": "채팅을 시작하려면 아래에 메시지를 입력하십시오",
	"chat-type-a-message": "메시지 입력",
	"filter-service": "서비스:",
	"filter-severity": "심각도:",
	"priority-low": "낮음",
	"priority-medium": "중간",
	"priority-high": "높음",
	"priority-critical": "위험",
	"filter-option-all": "모두",
	"severity-info": "정보",
	"severity-success": "성공",
	"severity-warn": "경고",
	"severity-error": "오류",
	"severity-fatal": "Fatal",
	"breadcrumb-aria-label-default": "이동 경로",
	back: back$6,
	"switching-orgs": "조직 전환",
	"switching-orgs-description": "조직을 {{ oldOrg }}에서 {{ newOrg }}(으)로 전환하려고 합니다. 계속하려면 먼저 로그아웃하세요.",
	"business-email-required": "Pro Trial로 업그레이드하려면 비즈니스 이메일이 필요합니다.",
	"check-inbox-for-invite-link": "받은 편지함에서 초대 링크를 확인하고 수락하여 업그레이드를 완료하십시오.",
	"invite-business-email-help": "이미 해당 이메일 주소를 사용하는 조직의 회원인 경우 계정에 로그인하여 계속 진행하면 됩니다.",
	"check-email-for-invite": "초대 이메일 확인",
	"check-email-for-invite-description": "초대장을 찾을 수 없는 경우 스팸 폴더를 확인하십시오. 초대를 수락한 후 Pro Trial로 업그레이드할 수 있습니다.",
	"no-minimum-purchase": "최소 구매가 없습니다.",
	"view-details-trial-plan": "Pro 플랜의 60일 체험판에 포함된 모든 항목의 세부 정보 보기",
	"get-more-cloud": "UiPath Automation Cloud에서 더 많은 것을 얻으십시오.",
	"start-free-trial": "무료 체험판 시작",
	trademark: trademark$6,
	"send-invite": "초대 보내기",
	"support-id": "지원 ID",
	basic_auth_user: basic_auth_user$6,
	local_group: local_group$6,
	robot: robot$6,
	directory_group: directory_group$6,
	directory_user: directory_user$6,
	directory_app: directory_app$6,
	"unified-admin-button-label": "액세스 관리",
	"unified-search-placeholder": "Marketplace 및 문서 검색",
	"unified-search-placeholder-v2": "구성 요소, 페이지 등 검색",
	"unified-search-recent-searches": "최근 검색",
	"unified-search-recent-pages-visited": "방문한 페이지",
	"unified-search-recent-resources-visited": "방문한 리소스",
	"unified-search-no-recent-searches": "최근 검색어가 없습니다. 결과를 가져오려면 3자 이상 입력하십시오.",
	"unified-search-no-recent-searches-logographic-locales": "최근 검색 내역이 없습니다. 결과를 가져오려면 1자 이상 입력하십시오",
	"unified-search-marketplace": "UiPath 마켓플레이스",
	"unified-search-documentation": "문서",
	"unified-search-open-product": "{product}에서 열기",
	"unified-search-change-search-terms": "검색어를 변경해 보십시오",
	"unified-search-no-results-found": "\"{term}\"과(와) 일치하는 결과가 없습니다",
	"unified-search-footer": "기대했던 결과가 아닙니까? {feedbackLink} 또는 {learnMoreLink}",
	"unified-search-footer-no-feedback": "기대했던 결과가 아닙니까? {learnMoreLink}",
	"unified-search-footer-give-feedback": "기대했던 결과가 아닙니까? {feedbackLink}",
	"unified-search-documentation-link": "문서에서 \"{query}\" 검색",
	"unified-search-downloads": "{count} 다운로드",
	"unified-search-runs": "{count}회 실행",
	"unified-search-all": "모두",
	"unified-search-see-all": "모두 보기",
	"unified-search-clear-button": "지우기",
	"unified-search-filter": "필터",
	"unified-search-all-count": "모두({count}개)",
	"unified-search-components-count": "컴포넌트({count})",
	"unified-search-pages-count": "페이지({count})",
	"unified-search-tags": "태그: {tagList}",
	"learn-more": "자세히 알아보기",
	"my-workspace": "내 작업 영역",
	"give-feedback": "피드백 제공",
	"ap-autocomplete-input-no-results": "\"{query}\"과(와) 일치하는 결과 없음",
	"ap-dropdown-placeholder": "선택...",
	"ap-date-picker-placeholder": "날짜 선택",
	"ap-time-picker-placeholder": "시간 선택",
	"ap-date-picker-selected-day-label": "{day}개 선택됨",
	"ap-breadcrumb-overflow-label": "이동 경로 숨겨진 링크",
	"unified-search-Studio": "Studio",
	"unified-search-AiCenter": "AI Center",
	"unified-search-Assistant": "어시스턴트",
	"unified-search-ProcessMining": "Process Mining",
	"unified-search-BusinessSolutions": "파트너 솔루션",
	"unified-search-UiPathApps": "앱",
	"unified-search-IntegrationServices": "Integration Service",
	"unified-search-StudioX": "StudioX",
	"unified-search-ProfessionalServices": "전문 서비스",
	"unified-search-Accelerator": "가속기",
	"unified-search-StudioWeb": "Studio 웹",
	"unified-search-AutomationOps": "Automation Ops",
	"unified-search-DocumentUnderstanding": "Document Understanding",
	"unified-search-Insights": "Insights",
	"unified-search-Other": "기타",
	"unified-search-Activity": "액티비티",
	"unified-search-CustomActivity": "액티비티",
	"unified-search-Snippet": "스니펫",
	"unified-search-WorkflowTemplate": "템플릿",
	"unified-search-Connector": "커넥터",
	"unified-search-Tool": "도구",
	"unified-search-MLModel": "ML 모델",
	"unified-search-Solution": "솔루션",
	"unified-search-Process": "자동화 준비 완료",
	"unified-search-Widget": "위젯",
	"unified-search-BusinessSolution": "파트너 솔루션",
	"unified-search-App": "앱",
	"unified-search-UiPathAppSolution": "앱 솔루션",
	"unified-search-UiPathAppTemplate": "앱 템플릿",
	"unified-search-IntegrationServiceConnector": "Integration Service 커넥터",
	"unified-search-StudioXWorkflowTemplate": "템플릿",
	"unified-search-ProfessionalService": "전문 서비스",
	"unified-search-StudioWebTemplate": "Studio Web 템플릿",
	"unified-search-AutomationOpsPipeline": "파이프라인",
	"unified-search-AutomationOpsPipelineTemplate": "파이프라인 템플릿",
	"unified-search-ExtractionModel": "추출 모델",
	"unified-search-marketplace-studio-activity": "Studio 액티비티",
	"unified-search-marketplace-studio-snippet": "Studio 스니펫",
	"unified-search-marketplace-studio-workflowtemplate": "Studio 템플릿",
	"unified-search-marketplace-studio-connector": "커넥터(레거시)",
	"unified-search-marketplace-studio-tool": "Studio 도구",
	"unified-search-marketplace-studio-solution": "Studio 솔루션",
	"unified-search-marketplace-studioweb-studiowebtemplate": "Studio Web 템플릿",
	"unified-search-marketplace-studiox-studioxworkflowtemplate": "Studio X 템플릿",
	"unified-search-marketplace-assistant-process": "바로 사용할 수 있는 자동화",
	"unified-search-marketplace-aicenter-mlmodel": "ML 모델",
	"unified-search-marketplace-processmining-app": "Process Mining 앱 템플릿",
	"unified-search-marketplace-uipathapps-uipathappsolution": "앱 솔루션",
	"unified-search-marketplace-uipathapps-uipathapptemplate": "앱 템플릿",
	"unified-search-marketplace-integrationservices-integrationserviceconnector": "커넥터",
	"unified-search-marketplace-accelerator-accelerator": "가속기",
	"unified-search-marketplace-businesssolutions-businesssolution": "파트너 솔루션",
	"unified-search-marketplace-professionalservices-professionalservice": "전문 서비스",
	"unified-search-orchestrator-asset": "자산",
	"unified-search-orchestrator-process": "프로세스",
	"unified-search-orchestrator-trigger": "트리거",
	"unified-search-orchestrator-queue": "큐",
	"unified-search-orchestrator-bucket": "버킷",
	"unified-search-orchestrator-actioncatalog": "액션 카탈로그",
	"unified-search-orchestrator-machine": "머신",
	"unified-search-orchestrator-webhook": "웹후크",
	"unified-search-integrationservice-connection": "연결",
	"unified-search-integrationservice-trigger": "트리거",
	"unified-search-dataservice-entity": "엔터티",
	"unified-search-dataservice-choiceset": "선택 집합",
	"unified-search-apps-app": "앱",
	"unified-search-loading-search-results": "검색 결과 로드 중",
	"rich-text-editor-format-bold": "서식 굵게",
	"rich-text-editor-bold": "굵게",
	"rich-text-editor-format-italic": "기울임꼴 서식",
	"rich-text-editor-italic": "기울임꼴",
	"rich-text-editor-format-underline": "밑줄 서식",
	"rich-text-editor-underline": "밑줄",
	"rich-text-editor-format-strikethrough": "서식 취소선",
	"rich-text-editor-strikethrough": "취소선",
	"rich-text-editor-format-ordered-list": "순서 목록 서식",
	"rich-text-editor-ordered-list": "순서 목록",
	"rich-text-editor-format-unordered-list": "정렬되지 않은 목록 서식",
	"rich-text-editor-unordered-list": "정렬되지 않은 목록",
	"rich-text-editor-insert-link": "링크 삽입",
	"rich-text-editor-link": "링크",
	"rich-text-editor-format-code": "코드 서식",
	"rich-text-editor-code": "코드",
	"ap-text-field-placeholder": "값 입력",
	"notification-message-template": "{{ tenantName }}의 {{ topic }}",
	build: build$6,
	discover: discover$6,
	operate: operate$6,
	feedback: feedback$6,
	"give-us-feedback": "피드백 제공",
	cancel: cancel$6,
	confirm: confirm$6,
	favorites: favorites$6,
	"favorites-limit-reached": "제한에 도달했습니다. 최대 3개의 항목만 추가할 수 있습니다.",
	"favorites-description": "즐겨찾는 제품이 여기에 표시됩니다. 최대 3개의 항목을 추가할 수 있습니다.",
	"default-toggle": "토글 스위치",
	"default-progress-spinner": "콘텐츠 로드 중",
	"default-icon-button": "아이콘 버튼",
	"default-radio-group": "라디오 그룹",
	"default-checkbox": "체크박스",
	"default-stepper-clickable": "클릭 가능한 단계 포함",
	"default-stepper-disabled": "비활성화된 단계 포함",
	"new-navigation": "새로운 탐색",
	"product-launcher-tooltip": "제품 시작 관리자",
	"autopilot-tooltip": "Autopilot",
	"notifications-tooltip": "알림",
	"search-tooltip": "검색",
	"help-tooltip": "도움말",
	"profile-tooltip": "프로필",
	apply: apply$5,
	date: date$5,
	time: time$5,
	"date-range": "날짜 범위:",
	"date-range-label": "날짜 범위",
	"date-time-label": "날짜 시간",
	"date-time-picker-label": "날짜 시간 선택기",
	"date-range-start": "시작",
	"date-range-end": "종료",
	"date-range-presets": "사전 설정",
	"date-range-picker-last-hour": "지난 시간",
	"date-range-picker-today": "오늘",
	"date-range-picker-last-seven-days": "지난 7일",
	"date-range-picker-last-two-weeks": "지난 2주",
	"date-range-picker-last-month": "지난 달",
	"date-range-picker-last-six-months": "지난 6개월",
	"date-range-picker-custom": "사용자 지정",
	"date-range-picker-start-tooltip": "시작 날짜는 종료 날짜보다 이후일 수 없습니다",
	"date-range-picker-label": "날짜 범위 선택기",
	"time-selector": "시간 선택기",
	"date-range-picker-options": "날짜 범위 옵션",
	"no-options": "옵션 없음",
	"type-to-search": "검색하려면 입력...",
	"autopilot-chat-header": "Autopilot",
	"autopilot-chat-input-placeholder": "뭘 해드리면 될까요?",
	"autopilot-chat-footer": "Autopilot은 실수를 할 수 있습니다. 응답을 다시 확인하십시오.",
	"autopilot-chat-new-chat": "새 채팅",
	"autopilot-chat-close": "닫기",
	"autopilot-chat-attach-file": "파일 첨부",
	"autopilot-chat-send": "보내기",
	"autopilot-chat-stop": "중지",
	"autopilot-chat-remove-file": "제거",
	"autopilot-chat-prompt-library": "프롬프트 라이브러리",
	"autopilot-chat-dropzone-overlay-title": "파일을 여기에 끌어다 놓아 프롬프트에 추가하십시오",
	"autopilot-chat-dropzone-overlay-description": "지원되는 파일 형식: {{ fileTypes }}",
	"autopilot-chat-dropzone-overlay-error": "지원되지 않는 파일: {{ fileTypes }}.",
	"autopilot-chat-code-block-language": "텍스트",
	"autopilot-chat-code-block-copy": "복사",
	"autopilot-chat-expand": "펼치기",
	"autopilot-chat-collapse": "축소",
	"autopilot-chat-remove-file-name": "{{ name }} 제거",
	"autopilot-chat-selected-files": "선택한 파일 ({{ count }})개",
	"autopilot-chat-files-preview": "{{ files }} 및 {{ count }}개 더",
	"autopilot-chat-thinking": "생각하는 중",
	"autopilot-chat-analyzing": "요청을 분석하는 중",
	"autopilot-chat-thinking-more": "조금 더 생각하기",
	"autopilot-chat-suggestions": "제안"
};

const home$5 = "Página Inicial";
const help$5 = "Ajuda";
const languages$5 = "Idiomas";
const language$5 = "Idioma";
const edit$5 = "Editar";
const enter$5 = "Introduzir";
const theme$5 = "Tema";
const logout$5 = "Terminar Sessão";
const tenants$5 = "Inquilinos";
const more$5 = "Mais";
const admin$5 = "Admin";
const autoTheme$5 = "Tema automático";
const dark$5 = "Tema escuro";
const light$5 = "Tema claro";
const dismiss$5 = "dispensar";
const warning$5 = "aviso";
const info$5 = "info";
const success$5 = "sucesso";
const error$5 = "erro";
const more_items$5 = "Mais Itens";
const notifications$5 = "Notificações";
const preview$5 = "Pré-visualizar";
const more_products$5 = "Mais opções";
const current_plan_upgrade$5 = "Está num plano {{ license }}";
const free_license$5 = "gratuito";
const community_license$5 = "Community";
const pro_trial_license$5 = "de versão de avaliação Pro";
const unlicensed$5 = "Não licenciado";
const back$5 = "Anterior";
const trademark$5 = "TM";
const basic_auth_user$5 = "Utilizador local";
const local_group$5 = "Grupo local";
const robot$5 = "Robot";
const directory_group$5 = "Grupo de diretório";
const directory_user$5 = "Utilizador de diretório";
const directory_app$5 = "Aplicação do Diretório";
const build$5 = "Criar";
const discover$5 = "Discover";
const operate$5 = "Operar";
const feedback$5 = "Feedback";
const cancel$5 = "Cancelar";
const confirm$5 = "Confirmar";
const favorites$5 = "Favoritos";
const apply$4 = "Aplicar";
const date$4 = "Data";
const time$4 = "Hora";
const pt = {
	home: home$5,
	help: help$5,
	languages: languages$5,
	language: language$5,
	edit: edit$5,
	"edit-subject": "Editar {{ subject }}",
	enter: enter$5,
	theme: theme$5,
	logout: logout$5,
	tenants: tenants$5,
	more: more$5,
	admin: admin$5,
	autoTheme: autoTheme$5,
	dark: dark$5,
	light: light$5,
	"light-hc": "Tema de alto contraste claro",
	"dark-hc": "Tema de alto contraste escuro",
	"close-button": "Botão Fechar",
	"client-days": "Faltam {{ differenceInDays }} dias",
	"client-hours": "Faltam {{ differenceInHours }} horas",
	"dropdown-placeholder": "Selecione qualquer opção",
	"empty-tenant-list-placeholder": "Nenhum inquilino válido",
	"tenant-picker-label": "Inquilino:",
	"tenant-picker-list": "Inquilino",
	"error-page-401-header": "Não autorizado",
	"error-page-403-header": "Ups! Não está na lista",
	"error-page-403-description": "Não tem autorização para ver {{ pageTitle }}. Contacte o seu administrador para obter as autorizações necessárias.",
	"error-page-404-header": "Ups! Não foi possível encontrar",
	"error-page-404-description": "A página que procura pode ter sido removida, o nome pode ter sido alterado ou pode estar temporariamente indisponível.",
	"error-page-503-header": "Estaremos de volta em breve",
	"error-page-503-description": "O sistema está em manutenção. Fique atento a este passo para obter atualizações.",
	"error-page-browser-header": "Este browser não é suportado",
	"error-page-endie-header": "Descontinuação do Internet Explorer",
	"error-page-endie-description": "O suporte do Internet Explorer terminou a 31 de maio de 2021. Para utilizar o UiPath, recomendamos a versão mais recente do Chrome, Firefox, Safari ou Edge.",
	"error-page-ip-restricted-header": "Acesso restrito",
	"error-page-ip-restricted-description": "Devido a políticas organizacionais, não pode aceder a {{ pageTitle }} a partir desta localização de rede. Contacte o seu administrador.",
	"error-page-learn-more": "Saiba mais",
	"error-page-learn-why": "Saiba porquê",
	"error-page-loader-header": "Aguarde enquanto preparamos as coisas",
	"error-page-loader-description": "Isto pode demorar alguns minutos. A página será atualizada quando a plataforma estiver pronta a utilizar.",
	"error-page-goto-home": "Ir para a página inicial",
	"error-page-goto-uipath-website": "Aceder ao Web site da UiPath",
	"error-page-check-service": "Verificar estado do serviço",
	"error-page-know-why": "Saiba porquê",
	"aria-label-logo": "O logótipo oficial da UiPath. Se clicar aqui, será redirecionado para a página inicial do {{ serviceName }}",
	"aria-label-logo-v2": "Logótipo UiPath Automation Cloud. Se clicar aqui, será redirecionado para a página inicial de {serviceName}",
	"language-na": "Idioma não suportado para este serviço.",
	dismiss: dismiss$5,
	warning: warning$5,
	info: info$5,
	success: success$5,
	error: error$5,
	"client-days-per-service": "Ainda lhe restam {{ differenceInDays }} dias de avaliação",
	"client-days-per-service-with-name": "Restam-lhe {{ differenceInDays }} dias da sua avaliação gratuita do {{ serviceName }}",
	"client-hours-per-service": "Ainda lhe restam {{ differenceInHours }} horas da versão de avaliação",
	"client-hours-per-service-with-name": "Restam-lhe {{ differenceInHours }} horas da sua avaliação gratuita do {{ serviceName }}",
	"waffle-label": "Iniciador de aplicações",
	"generic-error-message": "Ocorreu um erro inesperado. Tente novamente mais tarde",
	"help-menu-documentation": "Documentação",
	"help-menu-product-documentation": "Documentação do {{ product }}",
	"help-menu-downloads": "Transferências",
	"help-menu-forum": "Fórum Community",
	"help-menu-training-tutorials": "Formação e Tutoriais",
	"help-menu-uipath-academy": "UiPath Academy",
	"help-menu-youtube-tutorials": "Tutoriais do YouTube",
	"help-menu-release-notes": "Notas de versão",
	"help-menu-resources": "Recursos",
	"help-menu-support": "Suporte",
	more_items: more_items$5,
	notifications: notifications$5,
	"notifications-empty": "Não foram encontradas notificações",
	"notifications-all-read": "Marcar todas como lidas",
	"notifications-unread": "Marcar como não lida",
	"notifications-read": "Marcar como lida",
	"notifications-delete": "Eliminar",
	"notifications-mute": "Cancelar a subscrição de {{ topicOrTenant }}",
	"notifications-muted": "Êxito: cancelou a subscrição das notificações de {{ topicOrTenant }}.",
	"notifications-unread-only": "Apenas não lidas",
	"notifications-settings": "Definições de notificação",
	"notifications-page": "Página de notificações",
	"notifications-clear-all": "Limpar tudo",
	"notifications-end-list": "Fim da lista",
	"notifications-expandCollapse": "Expandir/Fechar",
	"notifications-fetch-failure": "Falha ao obter notificações. Tente novamente mais tarde",
	preview: preview$5,
	"unread-notifications-count": "{{ count }} notificações não lidas",
	"people-picker-default-placeholder": "Pesquisar por nome ou e-mail",
	"people-picker-groups-placeholder": "Pesquisar por nome de grupo",
	"people-picker-single-mode-placeholder": "Pesquisar por nome ou e-mail",
	"people-picker-single-mode-ad-helper-text": "Pesquisar por nome, e-mail ou domínio\\NomeContaSam",
	"people-picker-single-mode-aad-helper-text": "Pesquisar por nome, e-mail, nome do grupo ou nome da aplicação",
	"people-picker-default-helper-text": "Pesquise por nome ou introduza e-mails separados por vírgulas ou ponto e vírgula. Pode executar carateres especiais com carateres de escape através de \\.",
	"people-picker-aad-helper-text": "Pesquise por nome ou introduza e-mails separados por vírgulas ou ponto e vírgula. Pode executar carateres especiais com carateres de escape através de \\.",
	"people-picker-ad-ldap-helper-text": "Pesquise por nome de utilizador ou introduza e-mails ou domínio\\nomesContaSam separados por vírgulas ou ponto e vírgula. Pode executar carateres especiais com carateres de escape através de \\.",
	"people-picker-invalid-error-helper": "Utilize um e-mail válido",
	"people-picker-resolve-error-helper": "Não foi possível resolver algumas entradas. Remova-as ou tente novamente mais tarde",
	"people-picker-resolve-error-tooltip": "Não foi possível resolver a entrada. Remova ou tente novamente mais tarde",
	"people-picker-domain-picker-helper": "Selecionar um domínio",
	"people-picker-too-many-entities": "Só pode adicionar {{ maxValue }} entidades de cada vez",
	"people-picker-more-info": "Mais informações",
	"autocomplete-no-results": "Não existem resultados correspondentes a \"{{ query }}\"",
	"autocomplete-limit-exceeded": "Limite de {limit} excedido",
	"autocomplete-search-text": "Escreva para procurar...",
	"autocomplete-no-results-people-picker": "Não existem resultados correspondentes a \"{ query }\"",
	"autocomplete-loading": "A carregar...",
	"people-picker-add-users": "Nomes",
	"people-picker-add-groups": "Grupos",
	"people-picker-add-apps": "Apps",
	"people-picker-add-names": "Nomes",
	"tenant-picker-aria-label": "Selecione um inquilino. Atual: ",
	"people-picker-duplicate-chip": "Existem entradas duplicadas. Remova um dos duplicados e tente novamente.",
	"profile-navigation": "Preferências",
	"remove-chip": "Remover \"{{ value }}\"",
	"default-cobranding-logo-alt-text": "Logótipo de cobranding",
	"canary-tenant": "Canário",
	more_products: more_products$5,
	current_plan_upgrade: current_plan_upgrade$5,
	free_license: free_license$5,
	community_license: community_license$5,
	pro_trial_license: pro_trial_license$5,
	"notification-action-menu-text": "Ação em Notificação",
	"notification-allaction-menu-text": "Mais Ações em Todas as Notificações",
	"buy-now": "Comprar Agora",
	"contact-sales": "Contactar o departamento de vendas",
	"skip-content": "Avançar para o conteúdo principal",
	"object-picker-add-entry": "Adicionar \"{{ entry }}\"",
	"start-free-trial-header": "Inicie os seus",
	"sixty-days-trial": "60 dias de avaliação gratuita",
	"with-uipath-cloud": "com o UiPath Automation Cloud",
	"take-advantage-capabilities": "Aproveite as nossas capacidades completas do Cloud Automation.",
	"upgrade-to-enterprise": "Precisa de dimensionar o seu programa de automatização com governação de nível empresarial, segurança, entre outros?",
	"trial-benefit-one": "Robots para ativar a execução remota e a pedido",
	"trial-benefit-two": "Suporte 24 horas por dia, 7 dias por semana, da UiPath",
	"trial-benefit-three": "Garantia de tempo de atividade",
	"trial-benefit-four": "Vários inquilinos, cada um alojado em qualquer uma das nossas regiões",
	"view-pricing": "Ver preços",
	"upgrade-trial-role": "Cargo",
	"upgrade-trial-company-name": "Nome da Empresa/Organização",
	"upgrade-trial-business-email": "E-mail profissional",
	"notifications-clear-message": "O item de notificação foi eliminado",
	"session-expiring": "Sessão expirada",
	"session-expiring-description-inactive-hours": "Esteve inativo durante {{hours}} horas e {{minutes}} minutos.",
	"session-expiring-description-inactive": "Esteve inativo durante {{minutes}} minutos.",
	"session-expiring-description-logged-out": "A sua sessão terminará dentro de {{n}} segundos.",
	"extend-session": "Alargar sessão",
	"dropdown-position": "{{index}} de {{total}}",
	unlicensed: unlicensed$5,
	"copy-clipboard": "Copiar para a Área de Transferência",
	"people-picker-search-entries": "Foram encontrados {{count}} resultados de pesquisa correspondentes a \"{{query}}\"",
	"app-bar-aria-label": "Barra de aplicações",
	"nav-aria-label": "Navegação à esquerda",
	"chat-no-messages": "Escreva uma mensagem abaixo para iniciar o chat",
	"chat-type-a-message": "Escreva uma mensagem",
	"filter-service": "Serviço:",
	"filter-severity": "Gravidade:",
	"priority-low": "Baixa",
	"priority-medium": "Média",
	"priority-high": "Alta",
	"priority-critical": "Crítica",
	"filter-option-all": "Tudo",
	"severity-info": "Inf.",
	"severity-success": "Sucesso",
	"severity-warn": "Warn",
	"severity-error": "Erro",
	"severity-fatal": "Fatal",
	"breadcrumb-aria-label-default": "Trilho",
	back: back$5,
	"switching-orgs": "Mudar de Organização",
	"switching-orgs-description": "Está a tentar mudar da organização {{ oldOrg }} para {{ newOrg }}. Para continuar, primeiro termine sessão.",
	"business-email-required": "É necessário um e-mail empresarial para atualizar para a Pro Trial",
	"check-inbox-for-invite-link": "Consulte uma ligação de convite na sua caixa de entrada e aceite-a para concluir a atualização",
	"invite-business-email-help": "Se já for membro da organização com esse endereço de e-mail, basta iniciar sessão na sua conta para continuar.",
	"check-email-for-invite": "Verifique o convite no seu e-mail",
	"check-email-for-invite-description": "Se não encontrar o convite, verifique a pasta de spam. Depois de aceitar o convite, pode atualizar para a Pro Trial.",
	"no-minimum-purchase": "Sem compra mínima.",
	"view-details-trial-plan": "Ver os detalhes de tudo o que está incluído numa avaliação gratuita de 60 dias do plano Pro",
	"get-more-cloud": "Obter mais a partir do UiPath Automation Cloud",
	"start-free-trial": "Iniciar avaliação gratuita",
	trademark: trademark$5,
	"send-invite": "Enviar Convite",
	"support-id": "ID de Suporte",
	basic_auth_user: basic_auth_user$5,
	local_group: local_group$5,
	robot: robot$5,
	directory_group: directory_group$5,
	directory_user: directory_user$5,
	directory_app: directory_app$5,
	"unified-admin-button-label": "Gerir acesso",
	"unified-search-placeholder": "Pesquisar no Marketplace e em Documentação",
	"unified-search-placeholder-v2": "Pesquisar componentes, páginas e mais",
	"unified-search-recent-searches": "Pesquisas recentes",
	"unified-search-recent-pages-visited": "Páginas visitadas",
	"unified-search-recent-resources-visited": "Recursos visitados",
	"unified-search-no-recent-searches": "Nenhuma pesquisa recente, escreva 3 ou mais carateres para obter resultados",
	"unified-search-no-recent-searches-logographic-locales": "Nenhuma pesquisa recente, escreva 1 ou mais carateres para obter resultados",
	"unified-search-marketplace": "Mercado UiPath",
	"unified-search-documentation": "Documentação",
	"unified-search-open-product": "Abre em {product}",
	"unified-search-change-search-terms": "Tente alterar os termos de pesquisa",
	"unified-search-no-results-found": "Não existem resultados correspondentes a \"{term}\"",
	"unified-search-footer": "Não são os resultados esperados? {feedbackLink} ou {learnMoreLink}",
	"unified-search-footer-no-feedback": "Não são os resultados esperados? {learnMoreLink}",
	"unified-search-footer-give-feedback": "Não são os resultados esperados? {feedbackLink}",
	"unified-search-documentation-link": "Pesquise \"{query}\" na Documentação",
	"unified-search-downloads": "{count} Transferências",
	"unified-search-runs": "{count} execuções",
	"unified-search-all": "Tudo",
	"unified-search-see-all": "Ver tudo",
	"unified-search-clear-button": "Limpar",
	"unified-search-filter": "Filtro",
	"unified-search-all-count": "Todos ({count})",
	"unified-search-components-count": "Componentes ({count})",
	"unified-search-pages-count": "Páginas ({count})",
	"unified-search-tags": "Tags: {tagList}",
	"learn-more": "Saiba mais",
	"my-workspace": "A Minha Área de Trabalho",
	"give-feedback": "Enviar feedback",
	"ap-autocomplete-input-no-results": "Não existem resultados correspondentes a \"{query}\"",
	"ap-dropdown-placeholder": "Selecionar...",
	"ap-date-picker-placeholder": "Selecionar data",
	"ap-time-picker-placeholder": "Selecionar Hora",
	"ap-date-picker-selected-day-label": "{day} selecionado(s)",
	"ap-breadcrumb-overflow-label": "Ligações ocultas de trilho",
	"unified-search-Studio": "Studio",
	"unified-search-AiCenter": "AI Center",
	"unified-search-Assistant": "Assistente",
	"unified-search-ProcessMining": "Process Mining",
	"unified-search-BusinessSolutions": "Soluções de Parceiros",
	"unified-search-UiPathApps": "Apps",
	"unified-search-IntegrationServices": "Integration Service",
	"unified-search-StudioX": "StudioX",
	"unified-search-ProfessionalServices": "Serviços Profissionais",
	"unified-search-Accelerator": "Aceleradores",
	"unified-search-StudioWeb": "Studio Web",
	"unified-search-AutomationOps": "Automation Ops",
	"unified-search-DocumentUnderstanding": "Document Understanding",
	"unified-search-Insights": "Insights",
	"unified-search-Other": "Outro",
	"unified-search-Activity": "Atividades",
	"unified-search-CustomActivity": "Atividades",
	"unified-search-Snippet": "Fragmentos",
	"unified-search-WorkflowTemplate": "Modelos",
	"unified-search-Connector": "Conetores",
	"unified-search-Tool": "Ferramentas",
	"unified-search-MLModel": "Modelos de ML",
	"unified-search-Solution": "Soluções",
	"unified-search-Process": "Automatizações Prontas",
	"unified-search-Widget": "Widget",
	"unified-search-BusinessSolution": "Soluções de Parceiros",
	"unified-search-App": "Apps",
	"unified-search-UiPathAppSolution": "Soluções de Aplicações",
	"unified-search-UiPathAppTemplate": "Modelos de Aplicações",
	"unified-search-IntegrationServiceConnector": "Conetor do Integration Service",
	"unified-search-StudioXWorkflowTemplate": "Modelos",
	"unified-search-ProfessionalService": "Serviço Profissional",
	"unified-search-StudioWebTemplate": "Modelo Studio Web",
	"unified-search-AutomationOpsPipeline": "Pipelines",
	"unified-search-AutomationOpsPipelineTemplate": "Modelos de Pipeline",
	"unified-search-ExtractionModel": "Modelos de extração",
	"unified-search-marketplace-studio-activity": "Atividade do Studio",
	"unified-search-marketplace-studio-snippet": "Fragmento do Studio",
	"unified-search-marketplace-studio-workflowtemplate": "Modelo do Studio",
	"unified-search-marketplace-studio-connector": "Conetores (Legado)",
	"unified-search-marketplace-studio-tool": "Ferramenta do Studio",
	"unified-search-marketplace-studio-solution": "Solução do Studio",
	"unified-search-marketplace-studioweb-studiowebtemplate": "Modelo Studio Web",
	"unified-search-marketplace-studiox-studioxworkflowtemplate": "Modelo do Studio X",
	"unified-search-marketplace-assistant-process": "Automatização Pronta",
	"unified-search-marketplace-aicenter-mlmodel": "Modelo de ML",
	"unified-search-marketplace-processmining-app": "Modelo de Aplicação do Process Mining",
	"unified-search-marketplace-uipathapps-uipathappsolution": "Solução de Aplicação",
	"unified-search-marketplace-uipathapps-uipathapptemplate": "Modelo de Aplicação",
	"unified-search-marketplace-integrationservices-integrationserviceconnector": "Conetores",
	"unified-search-marketplace-accelerator-accelerator": "Acelerador",
	"unified-search-marketplace-businesssolutions-businesssolution": "Solução de Parceiros",
	"unified-search-marketplace-professionalservices-professionalservice": "Serviços Profissionais",
	"unified-search-orchestrator-asset": "Recurso",
	"unified-search-orchestrator-process": "Processo",
	"unified-search-orchestrator-trigger": "Acionador",
	"unified-search-orchestrator-queue": "Fila",
	"unified-search-orchestrator-bucket": "Bucket",
	"unified-search-orchestrator-actioncatalog": "Catálogo de Ações",
	"unified-search-orchestrator-machine": "Máquina",
	"unified-search-orchestrator-webhook": "Webhook",
	"unified-search-integrationservice-connection": "Ligação",
	"unified-search-integrationservice-trigger": "Acionador",
	"unified-search-dataservice-entity": "Entidade",
	"unified-search-dataservice-choiceset": "Conjunto de Opções",
	"unified-search-apps-app": "Apps",
	"unified-search-loading-search-results": "A carregar os resultados da pesquisa",
	"rich-text-editor-format-bold": "Formatar Negrito",
	"rich-text-editor-bold": "Negrito",
	"rich-text-editor-format-italic": "Formatar itálico",
	"rich-text-editor-italic": "Itálico",
	"rich-text-editor-format-underline": "Formatar sublinhado",
	"rich-text-editor-underline": "Sublinhado",
	"rich-text-editor-format-strikethrough": "Formatar Rasurado",
	"rich-text-editor-strikethrough": "Rasurado",
	"rich-text-editor-format-ordered-list": "Formatar lista ordenada",
	"rich-text-editor-ordered-list": "Lista ordenada",
	"rich-text-editor-format-unordered-list": "Formatar lista não ordenada",
	"rich-text-editor-unordered-list": "Lista não ordenada",
	"rich-text-editor-insert-link": "Inserir Ligação",
	"rich-text-editor-link": "Ligar",
	"rich-text-editor-format-code": "Formatar código",
	"rich-text-editor-code": "Código",
	"ap-text-field-placeholder": "Introduzir um valor",
	"notification-message-template": "{{ topic }} em {{ tenantName }}",
	build: build$5,
	discover: discover$5,
	operate: operate$5,
	feedback: feedback$5,
	"give-us-feedback": "Envie-nos feedback",
	cancel: cancel$5,
	confirm: confirm$5,
	favorites: favorites$5,
	"favorites-limit-reached": "Limite alcançado: só pode adicionar um máximo de 3 itens.",
	"favorites-description": "Os seus produtos favoritos serão apresentados aqui. Pode adicionar um máximo de 3 itens.",
	"default-toggle": "Botão de alternar",
	"default-progress-spinner": "A carregar conteúdo",
	"default-icon-button": "Botão de ícone",
	"default-radio-group": "Grupo de Opção",
	"default-checkbox": "Caixa de Verificação",
	"default-stepper-clickable": "com passos clicáveis",
	"default-stepper-disabled": "com passos desativados",
	"new-navigation": "Nova navegação",
	"product-launcher-tooltip": "Iniciador de produtos",
	"autopilot-tooltip": "Autopilot",
	"notifications-tooltip": "Notificações",
	"search-tooltip": "Pesquisar",
	"help-tooltip": "Ajuda",
	"profile-tooltip": "Perfil",
	apply: apply$4,
	date: date$4,
	time: time$4,
	"date-range": "Intervalo de Datas:",
	"date-range-label": "Intervalo de Datas",
	"date-time-label": "DateTime",
	"date-time-picker-label": "Seletor de data/hora",
	"date-range-start": "Iniciar",
	"date-range-end": "Terminar",
	"date-range-presets": "Predefinições",
	"date-range-picker-last-hour": "Última hora",
	"date-range-picker-today": "Hoje",
	"date-range-picker-last-seven-days": "Últimos 7 dias",
	"date-range-picker-last-two-weeks": "Últimas 2 Semanas",
	"date-range-picker-last-month": "Último mês",
	"date-range-picker-last-six-months": "Últimos 6 meses",
	"date-range-picker-custom": "Personalizado",
	"date-range-picker-start-tooltip": "A data de início não pode ser superior à data de fim",
	"date-range-picker-label": "Seletor de intervalo de datas",
	"time-selector": "Seletor de hora",
	"date-range-picker-options": "Opções de intervalos de datas",
	"no-options": "Sem opções",
	"type-to-search": "Escreva para procurar...",
	"autopilot-chat-header": "Autopilot",
	"autopilot-chat-input-placeholder": "O que pretende fazer?",
	"autopilot-chat-footer": "O Autopilot pode cometer erros. Confirme atentamente as respostas.",
	"autopilot-chat-new-chat": "Novo Chat",
	"autopilot-chat-close": "Fechar",
	"autopilot-chat-attach-file": "Anexar ficheiro(s)",
	"autopilot-chat-send": "Enviar",
	"autopilot-chat-stop": "Parar",
	"autopilot-chat-remove-file": "Remover",
	"autopilot-chat-prompt-library": "Biblioteca de pedidos",
	"autopilot-chat-dropzone-overlay-title": "Solte os seus ficheiros aqui para os adicionar ao pedido",
	"autopilot-chat-dropzone-overlay-description": "Tipos de ficheiro suportados: {{ fileTypes }}",
	"autopilot-chat-dropzone-overlay-error": "Ficheiro(s) não suportado(s): {{ fileTypes }}.",
	"autopilot-chat-code-block-language": "Texto",
	"autopilot-chat-code-block-copy": "Copiar",
	"autopilot-chat-expand": "Expandir",
	"autopilot-chat-collapse": "Fechar",
	"autopilot-chat-remove-file-name": "Remover {{ name }}",
	"autopilot-chat-selected-files": "Ficheiros Selecionados ({{ count }})",
	"autopilot-chat-files-preview": "{{ files }} e mais {{ count }}",
	"autopilot-chat-thinking": "A pensar",
	"autopilot-chat-analyzing": "A analisar o seu pedido",
	"autopilot-chat-thinking-more": "A pensar mais um pouco",
	"autopilot-chat-suggestions": "Sugestões"
};

const home$4 = "Início";
const help$4 = "Ajuda";
const languages$4 = "Idiomas";
const language$4 = "Idioma";
const edit$4 = "Editar";
const enter$4 = "Inserir";
const theme$4 = "Tema";
const logout$4 = "Sair";
const tenants$4 = "Tenants";
const more$4 = "Mais";
const admin$4 = "Admin";
const autoTheme$4 = "Tema automático";
const dark$4 = "Tema escuro";
const light$4 = "Tema claro";
const dismiss$4 = "ignorar";
const warning$4 = "aviso";
const info$4 = "informações";
const success$4 = "sucesso";
const error$4 = "erro";
const more_items$4 = "Mais itens";
const notifications$4 = "Notificações";
const preview$4 = "Visualizar";
const more_products$4 = "Mais opções";
const current_plan_upgrade$4 = "Seu plano é: {{ license }}";
const free_license$4 = "gratuito";
const community_license$4 = "Community";
const pro_trial_license$4 = "avaliação profissional";
const unlicensed$4 = "Não licenciado";
const back$4 = "Voltar";
const trademark$4 = "TM";
const basic_auth_user$4 = "Usuário local";
const local_group$4 = "Grupo local";
const robot$4 = "Robô";
const directory_group$4 = "Diretório grupo";
const directory_user$4 = "Diretório usuário";
const directory_app$4 = "Aplicativo de diretório";
const build$4 = "Criar";
const discover$4 = "Discover";
const operate$4 = "Opere";
const feedback$4 = "Feedback";
const cancel$4 = "Cancelar";
const confirm$4 = "Confirmar";
const favorites$4 = "Favoritos";
const apply$3 = "Aplicar";
const date$3 = "Data";
const time$3 = "Hora";
const ptBR = {
	home: home$4,
	help: help$4,
	languages: languages$4,
	language: language$4,
	edit: edit$4,
	"edit-subject": "Editar {{ subject }}",
	enter: enter$4,
	theme: theme$4,
	logout: logout$4,
	tenants: tenants$4,
	more: more$4,
	admin: admin$4,
	autoTheme: autoTheme$4,
	dark: dark$4,
	light: light$4,
	"light-hc": "Tema claro de alto contraste",
	"dark-hc": "Tema escuro de alto contraste",
	"close-button": "CloseButton",
	"client-days": "{{ differenceInDays }} dias restantes",
	"client-hours": "{{ differenceInHours }} horas restantes",
	"dropdown-placeholder": "Selecione uma opção",
	"empty-tenant-list-placeholder": "Nenhum tenant válido",
	"tenant-picker-label": "Tenant:",
	"tenant-picker-list": "Tenant",
	"error-page-401-header": "Não autorizado",
	"error-page-403-header": "Opa! Você não está na lista",
	"error-page-403-description": "Você não tem permissão para exibir {{ pageTitle }}. Entre em contato com o administrador para obter as permissões necessárias.",
	"error-page-404-header": "Opa! Não encontrado",
	"error-page-404-description": "A página que você está procurando pode ter sido removida, ter o nome alterado ou está temporariamente indisponível.",
	"error-page-503-header": "Voltaremos em breve",
	"error-page-503-description": "O sistema está em manutenção. Fique de olho neste espaço para saber das atualizações.",
	"error-page-browser-header": "Não há suporte para este navegador",
	"error-page-endie-header": "Desativação do Internet Explorer",
	"error-page-endie-description": "O suporte para o Internet Explorer terminou em 31 de maio de 2021. Para usar o UiPath, recomendamos a versão mais recente do Chrome, Firefox, Safari ou Edge.",
	"error-page-ip-restricted-header": "Acesso restrito",
	"error-page-ip-restricted-description": "Devido às políticas organizacionais, você não pode acessar {{ pageTitle }} deste local de rede.Entre em contato com seu administrador.",
	"error-page-learn-more": "Saiba mais",
	"error-page-learn-why": "Saiba por quê",
	"error-page-loader-header": "Aguarde enquanto configuramos tudo para você",
	"error-page-loader-description": "Isso pode levar alguns minutos. A página será atualizada quando a plataforma estiver pronta para uso.",
	"error-page-goto-home": "Ir para a Página Inicial",
	"error-page-goto-uipath-website": "Acessar o site da UiPath",
	"error-page-check-service": "Verificar status do serviço",
	"error-page-know-why": "Saiba por quê",
	"aria-label-logo": "Este é o logotipo oficial do UiPath. Clicar aqui leva à página inicial do {{ serviceName }}",
	"aria-label-logo-v2": "Logotipo do UiPath Automation Cloud, ao clicar aqui, você vai para a página de início do {serviceName}",
	"language-na": "Linguagem incompatível com este serviço.",
	dismiss: dismiss$4,
	warning: warning$4,
	info: info$4,
	success: success$4,
	error: error$4,
	"client-days-per-service": "Você tem {{ differenceInDays }} dias restantes em sua avaliação",
	"client-days-per-service-with-name": "Restam {{ differenceInDays }} dias na sua avaliação gratuita de {{ serviceName }}",
	"client-hours-per-service": "Você tem {{ differenceInHours }} horas restantes na sua avaliação",
	"client-hours-per-service-with-name": "Restam {{ differenceInHours }} horas na sua avaliação gratuita de {{ serviceName }}",
	"waffle-label": "Inicializador de aplicativos",
	"generic-error-message": "Ocorreu um erro inesperado. Tente novamente mais tarde",
	"help-menu-documentation": "Documentação",
	"help-menu-product-documentation": "Documentação do {{ product }}",
	"help-menu-downloads": "Downloads",
	"help-menu-forum": "Fórum Community",
	"help-menu-training-tutorials": "Treinamento e tutoriais",
	"help-menu-uipath-academy": "UiPath Academy",
	"help-menu-youtube-tutorials": "Tutoriais do YouTube",
	"help-menu-release-notes": "Notas de versão",
	"help-menu-resources": "Recursos",
	"help-menu-support": "Suporte",
	more_items: more_items$4,
	notifications: notifications$4,
	"notifications-empty": "Nenhuma notificação encontrada",
	"notifications-all-read": "Marcar tudo como lido",
	"notifications-unread": "Marcar não lida",
	"notifications-read": "Marcar como lida",
	"notifications-delete": "Excluir",
	"notifications-mute": "Cancelar assinatura de {{ topicOrTenant }}",
	"notifications-muted": "Sucesso: você cancelou a assinatura das notificações de {{ topicOrTenant }}.",
	"notifications-unread-only": "Somente não lidas",
	"notifications-settings": "Configurações de notificação",
	"notifications-page": "Página de notificações",
	"notifications-clear-all": "Limpar tudo",
	"notifications-end-list": "Fim da lista",
	"notifications-expandCollapse": "Expandir/Recolher",
	"notifications-fetch-failure": "Falha ao buscar notificações. Tente novamente mais tarde",
	preview: preview$4,
	"unread-notifications-count": "{{ count }} notificações não lidas",
	"people-picker-default-placeholder": "Pesquisar por nome ou e-mail",
	"people-picker-groups-placeholder": "Pesquisar pelo nome do grupo",
	"people-picker-single-mode-placeholder": "Pesquisar por nome ou e-mail",
	"people-picker-single-mode-ad-helper-text": "Pesquise por nome, email ou domínio\\NomeDaContaSAM",
	"people-picker-single-mode-aad-helper-text": "Pesquise por nome, email ou nome do grupo ou do aplicativo",
	"people-picker-default-helper-text": "Pesquise por nome ou insira e-mails separados por vírgula ou ponto e vírgula. Para usar caracteres especiais, use \\.",
	"people-picker-aad-helper-text": "Pesquise por nome ou insira e-mails separados por vírgula ou ponto e vírgula. Para usar caracteres especiais, use \\.",
	"people-picker-ad-ldap-helper-text": "Pesquise por nome ou insira e-mails ou domain\\samAccountNames separados por vírgula ou ponto e vírgula. Para usar caracteres especiais, use \\.",
	"people-picker-invalid-error-helper": "Use um email válido",
	"people-picker-resolve-error-helper": "Algumas entradas não foram resolvidas. Remova-as ou tente novamente mais tarde.",
	"people-picker-resolve-error-tooltip": "Não foi possível resolver a entrada. Remova-a ou tente novamente mais tarde.",
	"people-picker-domain-picker-helper": "Selecionar um domínio",
	"people-picker-too-many-entities": "Você só pode adicionar {{ maxValue }} entidades por vez",
	"people-picker-more-info": "Mais Informações",
	"autocomplete-no-results": "Nenhum resultado correspondente a \"{{ query }}\"",
	"autocomplete-limit-exceeded": "Limite de {limit} excedido",
	"autocomplete-search-text": "Digitar para pesquisar...",
	"autocomplete-no-results-people-picker": "Nenhum resultado correspondente a \"{ query }\"",
	"autocomplete-loading": "Carregando...",
	"people-picker-add-users": "Nomes",
	"people-picker-add-groups": "Grupos",
	"people-picker-add-apps": "Apps",
	"people-picker-add-names": "Nomes",
	"tenant-picker-aria-label": "Selecionar tenant. Atual: ",
	"people-picker-duplicate-chip": "Existem entradas duplicadas. Exclua uma e tente novamente.",
	"profile-navigation": "Preferências",
	"remove-chip": "Remover \"{{ value }}\"",
	"default-cobranding-logo-alt-text": "Logotipo de co-branding",
	"canary-tenant": "Canário",
	more_products: more_products$4,
	current_plan_upgrade: current_plan_upgrade$4,
	free_license: free_license$4,
	community_license: community_license$4,
	pro_trial_license: pro_trial_license$4,
	"notification-action-menu-text": "Ação sobre a notificação",
	"notification-allaction-menu-text": "Outras ações em todas as notificações",
	"buy-now": "Adquira já",
	"contact-sales": "Fale com a equipe de vendas",
	"skip-content": "Ir para o conteúdo principal",
	"object-picker-add-entry": "Adicionar \"{{ entry }}\"",
	"start-free-trial-header": "Inicie sua",
	"sixty-days-trial": "avaliação de 60 dias",
	"with-uipath-cloud": "com UiPath Automation Cloud",
	"take-advantage-capabilities": "Aproveite nossos recursos avançados do Automation Cloud.",
	"upgrade-to-enterprise": "Precisa escalar seu programa de automação com governança, segurança e muito mais em nível empresarial?",
	"trial-benefit-one": "Robots que possibilitam a execução remota sob demanda",
	"trial-benefit-two": "Suporte 24 horas da UiPath",
	"trial-benefit-three": "Garantia de tempo de operação",
	"trial-benefit-four": "Vários tenants, cada um hospedado em qualquer uma de nossas regiões",
	"view-pricing": "Exibir preços",
	"upgrade-trial-role": "Cargo",
	"upgrade-trial-company-name": "Nome da empresa/organização",
	"upgrade-trial-business-email": "Email profissional",
	"notifications-clear-message": "O item de notificação foi excluído",
	"session-expiring": "Sessão expirando",
	"session-expiring-description-inactive-hours": "Sua inatividade já dura {{hours}} horas e {{minutes}} minutos.",
	"session-expiring-description-inactive": "Você está inativo(a) há {{minutes}} minutos.",
	"session-expiring-description-logged-out": "Você será desconectado(a) em {{n}} segundos.",
	"extend-session": "Estender sessão",
	"dropdown-position": "{{index}} de {{total}}",
	unlicensed: unlicensed$4,
	"copy-clipboard": "Copiar para Área de Transferência",
	"people-picker-search-entries": "{{count}} resultados de pesquisa encontrados correspondentes a \"{{query}}\"",
	"app-bar-aria-label": "Barra de aplicativos",
	"nav-aria-label": "Navegação à esquerda",
	"chat-no-messages": "Digite uma mensagem abaixo para iniciar o chat",
	"chat-type-a-message": "Digite uma mensagem",
	"filter-service": "Serviço:",
	"filter-severity": "Gravidade:",
	"priority-low": "Baixa",
	"priority-medium": "Médio",
	"priority-high": "Alta",
	"priority-critical": "Crítico",
	"filter-option-all": "Todos",
	"severity-info": "Informações",
	"severity-success": "Sucesso",
	"severity-warn": "Aviso",
	"severity-error": "Erro",
	"severity-fatal": "Fatal",
	"breadcrumb-aria-label-default": "Trilha",
	back: back$4,
	"switching-orgs": "Mudança de Organizações",
	"switching-orgs-description": "Você está tentando mudar as organizações de {{ oldOrg }} para {{ newOrg }}. Para continuar, desconecte primeiro.",
	"business-email-required": "É necessário ter um email comercial para atualizar para a versão Pro Trial",
	"check-inbox-for-invite-link": "Procure e aceite um link de convite em sua caixa de entrada para concluir a atualização",
	"invite-business-email-help": "Se você já for um membro da organização usando esse endereço de email, faça login na sua conta para prosseguir.",
	"check-email-for-invite": "Procure o convite no seu email",
	"check-email-for-invite-description": "Se não encontrar o convite, verifique sua pasta de spam. Depois de aceitar o convite, você pode fazer a atualização para o Pro Trial.",
	"no-minimum-purchase": "Sem compra mínima.",
	"view-details-trial-plan": "Confira os detalhes de tudo o que está incluído nos 60 dias de avaliação do plano Pro",
	"get-more-cloud": "Aproveite mais o UiPath Automation Cloud",
	"start-free-trial": "Iniciar avaliação gratuita",
	trademark: trademark$4,
	"send-invite": "Enviar convite",
	"support-id": "ID de Suporte",
	basic_auth_user: basic_auth_user$4,
	local_group: local_group$4,
	robot: robot$4,
	directory_group: directory_group$4,
	directory_user: directory_user$4,
	directory_app: directory_app$4,
	"unified-admin-button-label": "Gerenciar acesso",
	"unified-search-placeholder": "Pesquisar no Marketplace e na Documentação",
	"unified-search-placeholder-v2": "Pesquisar componentes, páginas e muito mais",
	"unified-search-recent-searches": "Pesquisas recentes",
	"unified-search-recent-pages-visited": "Páginas visitadas",
	"unified-search-recent-resources-visited": "Recursos visitados",
	"unified-search-no-recent-searches": "Nenhuma pesquisa recente, digite três ou mais caracteres para obter resultados",
	"unified-search-no-recent-searches-logographic-locales": "Nenhuma pesquisa recente, digite um ou mais caracteres para obter resultados",
	"unified-search-marketplace": "UiPath Marketplace",
	"unified-search-documentation": "Documentação",
	"unified-search-open-product": "Abrir em {product}",
	"unified-search-change-search-terms": "Tente alterar os termos de pesquisa",
	"unified-search-no-results-found": "Nenhum resultado correspondente a \"{term}\" encontrado",
	"unified-search-footer": "Não eram os resultados que você esperava? {feedbackLink} ou {learnMoreLink}",
	"unified-search-footer-no-feedback": "Não eram os resultados que você esperava? {learnMoreLink}",
	"unified-search-footer-give-feedback": "Não eram os resultados que você esperava? {feedbackLink}",
	"unified-search-documentation-link": "Pesquisar \"{query}\" na Documentação",
	"unified-search-downloads": "{count} downloads",
	"unified-search-runs": "{count} execuções",
	"unified-search-all": "Todos",
	"unified-search-see-all": "Exibir tudo",
	"unified-search-clear-button": "Limpar",
	"unified-search-filter": "Filtro",
	"unified-search-all-count": "Todos ({count})",
	"unified-search-components-count": "Componentes ({count})",
	"unified-search-pages-count": "Páginas ({count})",
	"unified-search-tags": "Tags: {tagList}",
	"learn-more": "Saiba mais",
	"my-workspace": "Meu Espaço de Trabalho",
	"give-feedback": "Enviar feedback",
	"ap-autocomplete-input-no-results": "Nenhum resultado correspondente a \"{query}\"",
	"ap-dropdown-placeholder": "Selecionar...",
	"ap-date-picker-placeholder": "Selecionar data",
	"ap-time-picker-placeholder": "Selecionar Horário",
	"ap-date-picker-selected-day-label": "{day} selecionada(s)",
	"ap-breadcrumb-overflow-label": "Links ocultos de trilha de navegação",
	"unified-search-Studio": "Studio",
	"unified-search-AiCenter": "Centro de IA",
	"unified-search-Assistant": "Assistente",
	"unified-search-ProcessMining": "Process Mining",
	"unified-search-BusinessSolutions": "Soluções de parceiros",
	"unified-search-UiPathApps": "Aplicativos",
	"unified-search-IntegrationServices": "Integration Service",
	"unified-search-StudioX": "StudioX",
	"unified-search-ProfessionalServices": "Serviços profissionais",
	"unified-search-Accelerator": "Aceleradores",
	"unified-search-StudioWeb": "Studio Web",
	"unified-search-AutomationOps": "Automation Ops",
	"unified-search-DocumentUnderstanding": "Document Understanding",
	"unified-search-Insights": "Insights",
	"unified-search-Other": "Outro",
	"unified-search-Activity": "Atividades",
	"unified-search-CustomActivity": "Atividades",
	"unified-search-Snippet": "Fragmentos",
	"unified-search-WorkflowTemplate": "Modelos",
	"unified-search-Connector": "Conectores",
	"unified-search-Tool": "Ferramentas",
	"unified-search-MLModel": "Modelos de ML",
	"unified-search-Solution": "Soluções",
	"unified-search-Process": "Automações prontas para execução",
	"unified-search-Widget": "Widget",
	"unified-search-BusinessSolution": "Soluções de parceiros",
	"unified-search-App": "Aplicativos",
	"unified-search-UiPathAppSolution": "Soluções de app",
	"unified-search-UiPathAppTemplate": "Modelos de app",
	"unified-search-IntegrationServiceConnector": "Conector do Integration Service",
	"unified-search-StudioXWorkflowTemplate": "Modelos",
	"unified-search-ProfessionalService": "Serviço profissional",
	"unified-search-StudioWebTemplate": "Modelo do Studio Web",
	"unified-search-AutomationOpsPipeline": "Pipelines",
	"unified-search-AutomationOpsPipelineTemplate": "Modelos de pipeline",
	"unified-search-ExtractionModel": "Modelos de extração",
	"unified-search-marketplace-studio-activity": "Atividade do Studio",
	"unified-search-marketplace-studio-snippet": "Fragmento do Studio",
	"unified-search-marketplace-studio-workflowtemplate": "Modelo do Studio",
	"unified-search-marketplace-studio-connector": "Conectores (legado)",
	"unified-search-marketplace-studio-tool": "Ferramenta do Studio",
	"unified-search-marketplace-studio-solution": "Solução do Studio",
	"unified-search-marketplace-studioweb-studiowebtemplate": "Modelo do Studio Web",
	"unified-search-marketplace-studiox-studioxworkflowtemplate": "Modelo do Studio X",
	"unified-search-marketplace-assistant-process": "Automação disponível",
	"unified-search-marketplace-aicenter-mlmodel": "Modelo de ML",
	"unified-search-marketplace-processmining-app": "Modelo de app do Process Mining",
	"unified-search-marketplace-uipathapps-uipathappsolution": "Solução de app",
	"unified-search-marketplace-uipathapps-uipathapptemplate": "Modelo de aplicativo",
	"unified-search-marketplace-integrationservices-integrationserviceconnector": "Conectores",
	"unified-search-marketplace-accelerator-accelerator": "Acelerador",
	"unified-search-marketplace-businesssolutions-businesssolution": "Solução de parceiros",
	"unified-search-marketplace-professionalservices-professionalservice": "Serviços profissionais",
	"unified-search-orchestrator-asset": "Ativo",
	"unified-search-orchestrator-process": "Processo",
	"unified-search-orchestrator-trigger": "Gatilho",
	"unified-search-orchestrator-queue": "Fila",
	"unified-search-orchestrator-bucket": "Bucket",
	"unified-search-orchestrator-actioncatalog": "Catálogo de Ações",
	"unified-search-orchestrator-machine": "Máquina",
	"unified-search-orchestrator-webhook": "Webhook",
	"unified-search-integrationservice-connection": "Conexão",
	"unified-search-integrationservice-trigger": "Gatilho",
	"unified-search-dataservice-entity": "Entidade",
	"unified-search-dataservice-choiceset": "Conjunto de Escolhas",
	"unified-search-apps-app": "Aplicativos",
	"unified-search-loading-search-results": "Carregando resultados da pesquisa",
	"rich-text-editor-format-bold": "Formatação em negrito",
	"rich-text-editor-bold": "Negrito",
	"rich-text-editor-format-italic": "Formatação em itálico",
	"rich-text-editor-italic": "Itálico",
	"rich-text-editor-format-underline": "Formatação sublinhada",
	"rich-text-editor-underline": "Sublinhado",
	"rich-text-editor-format-strikethrough": "Formatação tachada",
	"rich-text-editor-strikethrough": "Tachado",
	"rich-text-editor-format-ordered-list": "Formatação de lista ordenada",
	"rich-text-editor-ordered-list": "Lista ordenada",
	"rich-text-editor-format-unordered-list": "Formatação de lista não ordenada",
	"rich-text-editor-unordered-list": "Lista não ordenada",
	"rich-text-editor-insert-link": "Inserir link",
	"rich-text-editor-link": "Vincular",
	"rich-text-editor-format-code": "Formatação de código",
	"rich-text-editor-code": "Código",
	"ap-text-field-placeholder": "Insira um valor",
	"notification-message-template": "{{ topic }} em {{ tenantName }}",
	build: build$4,
	discover: discover$4,
	operate: operate$4,
	feedback: feedback$4,
	"give-us-feedback": "Enviar feedback",
	cancel: cancel$4,
	confirm: confirm$4,
	favorites: favorites$4,
	"favorites-limit-reached": "Limite atingido: é possível adicionar no máximo três itens.",
	"favorites-description": "Seus produtos favoritos serão exibidos aqui. É possível adicionar no máximo três itens.",
	"default-toggle": "Botão de alternância",
	"default-progress-spinner": "Carregando o conteúdo",
	"default-icon-button": "Botão de ícone",
	"default-radio-group": "Grupo de rádio",
	"default-checkbox": "Caixa de seleção",
	"default-stepper-clickable": "com etapas clicáveis",
	"default-stepper-disabled": "com etapas desabilitadas",
	"new-navigation": "Nova navegação",
	"product-launcher-tooltip": "Inicializador de produtos",
	"autopilot-tooltip": "Autopilot",
	"notifications-tooltip": "Notificações",
	"search-tooltip": "Pesquisar",
	"help-tooltip": "Ajuda",
	"profile-tooltip": "Perfil",
	apply: apply$3,
	date: date$3,
	time: time$3,
	"date-range": "Intervalo de datas:",
	"date-range-label": "Intervalo de data",
	"date-time-label": "DateTime",
	"date-time-picker-label": "Seletor de data e hora",
	"date-range-start": "Iniciar",
	"date-range-end": "Encerrar",
	"date-range-presets": "Predefinição",
	"date-range-picker-last-hour": "Última hora",
	"date-range-picker-today": "Hoje",
	"date-range-picker-last-seven-days": "Últimos 7 dias",
	"date-range-picker-last-two-weeks": "Últimas 2 semanas",
	"date-range-picker-last-month": "Último mês",
	"date-range-picker-last-six-months": "Últimos 6 meses",
	"date-range-picker-custom": "Personalizado",
	"date-range-picker-start-tooltip": "A data de início não pode exceder a de término",
	"date-range-picker-label": "Seletor de intervalo de datas",
	"time-selector": "Seletor de hora",
	"date-range-picker-options": "Opções de intervalo de datas",
	"no-options": "Sem Opções",
	"type-to-search": "Digitar para pesquisar...",
	"autopilot-chat-header": "Autopilot",
	"autopilot-chat-input-placeholder": "O que você quer que eu faça?",
	"autopilot-chat-footer": "O Autopilot pode cometer erros. Verifique as respostas novamente.",
	"autopilot-chat-new-chat": "Novo chat",
	"autopilot-chat-close": "Fechar",
	"autopilot-chat-attach-file": "Anexar arquivo(s)",
	"autopilot-chat-send": "Enviar",
	"autopilot-chat-stop": "Parar",
	"autopilot-chat-remove-file": "Remover",
	"autopilot-chat-prompt-library": "Biblioteca de prompt",
	"autopilot-chat-dropzone-overlay-title": "Solte seus arquivos aqui para adicioná-los ao seu prompt",
	"autopilot-chat-dropzone-overlay-description": "Tipos de arquivo compatíveis: {{ fileTypes }}",
	"autopilot-chat-dropzone-overlay-error": "Arquivos incompatíveis: {{ fileTypes }}.",
	"autopilot-chat-code-block-language": "Texto",
	"autopilot-chat-code-block-copy": "Copiar",
	"autopilot-chat-expand": "Expandir",
	"autopilot-chat-collapse": "Recolher",
	"autopilot-chat-remove-file-name": "Remover {{ name }}",
	"autopilot-chat-selected-files": "Arquivos Selecionados ({{ count }})",
	"autopilot-chat-files-preview": "{{ files }} e mais {{ count }}",
	"autopilot-chat-thinking": "Pensando",
	"autopilot-chat-analyzing": "Analisando sua solicitação",
	"autopilot-chat-thinking-more": "Pensando um pouco mais",
	"autopilot-chat-suggestions": "Sugestões"
};

const home$3 = "Начальная страница";
const help$3 = "Справка";
const languages$3 = "Языки";
const language$3 = "Язык";
const edit$3 = "";
const enter$3 = "";
const theme$3 = "Тема";
const logout$3 = "Выход";
const tenants$3 = "Тенант";
const more$3 = "Подробнее";
const admin$3 = "Админ";
const autoTheme$3 = "Автоматическая тема";
const dark$3 = "Темная тема";
const light$3 = "Светлая тема";
const dismiss$3 = "отклонить";
const warning$3 = "предупреждение";
const info$3 = "сведения";
const success$3 = "успех";
const error$3 = "ошибка";
const more_items$3 = "Еще элементы";
const notifications$3 = "Уведомления";
const preview$3 = "Предварительный просмотр";
const more_products$3 = "";
const current_plan_upgrade$3 = "";
const free_license$3 = "";
const community_license$3 = "";
const pro_trial_license$3 = "";
const unlicensed$3 = "";
const back$3 = "Назад";
const trademark$3 = "";
const basic_auth_user$3 = "";
const local_group$3 = "";
const robot$3 = "";
const directory_group$3 = "";
const directory_user$3 = "";
const directory_app$3 = "";
const build$3 = "";
const discover$3 = "";
const operate$3 = "";
const feedback$3 = "";
const cancel$3 = "";
const confirm$3 = "";
const favorites$3 = "";
const ru = {
	home: home$3,
	help: help$3,
	languages: languages$3,
	language: language$3,
	edit: edit$3,
	"edit-subject": "",
	enter: enter$3,
	theme: theme$3,
	logout: logout$3,
	tenants: tenants$3,
	more: more$3,
	admin: admin$3,
	autoTheme: autoTheme$3,
	dark: dark$3,
	light: light$3,
	"light-hc": "",
	"dark-hc": "",
	"close-button": "",
	"client-days": "Осталось дней: {{ differenceInDays }}",
	"client-hours": "Осталось часов: {{ differenceInHours }}",
	"dropdown-placeholder": "Выберите любой вариант",
	"empty-tenant-list-placeholder": "Нет действительного тенанта",
	"tenant-picker-label": "",
	"tenant-picker-list": "",
	"error-page-401-header": "Нет разрешения",
	"error-page-403-header": "Ой! Вас нет в списке",
	"error-page-403-description": "У вас нет разрешения на просмотр {{ pageTitle }}. Обратитесь к администратору, чтобы получить необходимые разрешения.",
	"error-page-404-header": "Ой! Не удается найти",
	"error-page-404-description": "Возможно, искомая страница была удалена, ее имя изменилось или она временно недоступна.",
	"error-page-503-header": "Скоро работа возобновится",
	"error-page-503-description": "Проводится техническое обслуживание системы. Следите за обновлениями на этой странице.",
	"error-page-browser-header": "Этот браузер не поддерживается",
	"error-page-endie-header": "Прекращение использования Internet Explorer",
	"error-page-endie-description": "Поддержка Internet Explorer прекращена 31 мая 2021 года. Чтобы использовать UiPath, рекомендуем установить последнюю версию Chrome, Firefox, Safari или Edge.",
	"error-page-ip-restricted-header": "Доступ ограничен",
	"error-page-ip-restricted-description": "Из-за политики организации вы не можете получить доступ к {{ pageTitle }} из этого сетевого расположения. Обратитесь к администратору.",
	"error-page-learn-more": "Подробнее",
	"error-page-learn-why": "Узнать причину",
	"error-page-loader-header": "Подождите, пока мы все настроим для вас",
	"error-page-loader-description": "Это может занять несколько минут. Страница обновится, когда платформа будет готова к использованию.",
	"error-page-goto-home": "Перейти на главную страницу",
	"error-page-goto-uipath-website": "Перейти на веб-сайт UiPath",
	"error-page-check-service": "Проверить статус сервиса",
	"error-page-know-why": "Узнать причину",
	"aria-label-logo": "Официальный логотип UiPath. Если нажать здесь, будет выполнен переход на главную страницу {{ serviceName }}",
	"language-na": "Язык не поддерживается для этого сервиса",
	dismiss: dismiss$3,
	warning: warning$3,
	info: info$3,
	success: success$3,
	error: error$3,
	"client-days-per-service": "До окончания пробной версии осталось {{ differenceInDays }} дн.",
	"client-days-per-service-with-name": "",
	"client-hours-per-service": "До окончания пробной версии осталось {{ differenceInHours }} ч.",
	"client-hours-per-service-with-name": "",
	"waffle-label": "Средство запуска приложений",
	"generic-error-message": "Произошла непредвиденная ошибка. Повторите попытку позже",
	"help-menu-documentation": "Документация",
	"help-menu-product-documentation": "Документация {{ product }}",
	"help-menu-downloads": "Загрузки",
	"help-menu-forum": "Форум сообщества",
	"help-menu-training-tutorials": "Обучающие материалы и руководства",
	"help-menu-uipath-academy": "UiPath Academy",
	"help-menu-youtube-tutorials": "Руководства на YouTube",
	"help-menu-release-notes": "Примечания к выпуску",
	"help-menu-resources": "Ресурсы",
	"help-menu-support": "Поддержка",
	more_items: more_items$3,
	notifications: notifications$3,
	"notifications-empty": "Уведомления не найдены",
	"notifications-all-read": "Пометить все как прочитанное",
	"notifications-unread": "Пометить как непрочитанное",
	"notifications-read": "Пометить как прочитанное",
	"notifications-delete": "Удалить",
	"notifications-mute": "Отписаться от {{ topicOrTenant }}",
	"notifications-muted": "Успешно. Вы отписались от уведомлений {{ topicOrTenant }}.",
	"notifications-unread-only": "Только непрочитанные‑",
	"notifications-settings": "Настройки уведомлений",
	"notifications-page": "",
	"notifications-clear-all": "Очистить все",
	"notifications-end-list": "Конец списка",
	"notifications-expandCollapse": "",
	"notifications-fetch-failure": "",
	preview: preview$3,
	"unread-notifications-count": "Непрочитанных уведомлений: {{ count }}",
	"people-picker-default-placeholder": "",
	"people-picker-groups-placeholder": "",
	"people-picker-single-mode-placeholder": "Поиск по имени или адресу электронной почты",
	"people-picker-single-mode-ad-helper-text": "",
	"people-picker-single-mode-aad-helper-text": "",
	"people-picker-default-helper-text": "",
	"people-picker-aad-helper-text": "",
	"people-picker-ad-ldap-helper-text": "",
	"people-picker-invalid-error-helper": "",
	"people-picker-resolve-error-helper": "Не удалось разрешить некоторые записи. Удалите их или повторите попытку",
	"people-picker-resolve-error-tooltip": "Не удалось разрешить запись. Удалите ее или повторите попытку",
	"people-picker-domain-picker-helper": "Выбрать домен",
	"people-picker-too-many-entities": "Можно добавить не более {{ maxValue }} объектов за раз",
	"people-picker-more-info": "",
	"autocomplete-no-results": "Нет результатов, соответствующих \"{{ query }}\"",
	"autocomplete-limit-exceeded": "",
	"autocomplete-search-text": "",
	"autocomplete-no-results-people-picker": "",
	"autocomplete-loading": "",
	"people-picker-add-users": "",
	"people-picker-add-groups": "",
	"people-picker-add-apps": "",
	"people-picker-add-names": "",
	"tenant-picker-aria-label": "Выберите тенанта. Текущий: ",
	"people-picker-duplicate-chip": "Есть несколько повторяющихся записей. Удалите одну и повторите попытку.",
	"profile-navigation": "Настройки",
	"remove-chip": "",
	"default-cobranding-logo-alt-text": "Логотип кобрендинга",
	"canary-tenant": "",
	more_products: more_products$3,
	current_plan_upgrade: current_plan_upgrade$3,
	free_license: free_license$3,
	community_license: community_license$3,
	pro_trial_license: pro_trial_license$3,
	"notification-action-menu-text": "",
	"notification-allaction-menu-text": "",
	"buy-now": "",
	"contact-sales": "",
	"skip-content": "",
	"object-picker-add-entry": "",
	"start-free-trial-header": "",
	"sixty-days-trial": "",
	"with-uipath-cloud": "",
	"take-advantage-capabilities": "",
	"upgrade-to-enterprise": "",
	"trial-benefit-one": "",
	"trial-benefit-two": "",
	"trial-benefit-three": "",
	"trial-benefit-four": "",
	"view-pricing": "",
	"upgrade-trial-role": "",
	"upgrade-trial-company-name": "",
	"upgrade-trial-business-email": "",
	"notifications-clear-message": "",
	"session-expiring": "",
	"session-expiring-description-inactive-hours": "",
	"session-expiring-description-inactive": "",
	"session-expiring-description-logged-out": "",
	"extend-session": "",
	"dropdown-position": "",
	unlicensed: unlicensed$3,
	"copy-clipboard": "",
	"people-picker-search-entries": "",
	"app-bar-aria-label": "",
	"nav-aria-label": "",
	"chat-no-messages": "",
	"chat-type-a-message": "",
	"filter-service": "",
	"filter-severity": "",
	"priority-low": "",
	"priority-medium": "",
	"priority-high": "",
	"priority-critical": "",
	"filter-option-all": "",
	"severity-info": "",
	"severity-success": "",
	"severity-warn": "",
	"severity-error": "",
	"severity-fatal": "",
	"breadcrumb-aria-label-default": "",
	back: back$3,
	"switching-orgs": "",
	"switching-orgs-description": "",
	"business-email-required": "",
	"check-inbox-for-invite-link": "",
	"invite-business-email-help": "",
	"check-email-for-invite": "",
	"check-email-for-invite-description": "",
	"no-minimum-purchase": "",
	"view-details-trial-plan": "",
	"get-more-cloud": "",
	"start-free-trial": "",
	trademark: trademark$3,
	"send-invite": "",
	"support-id": "",
	basic_auth_user: basic_auth_user$3,
	local_group: local_group$3,
	robot: robot$3,
	directory_group: directory_group$3,
	directory_user: directory_user$3,
	directory_app: directory_app$3,
	"unified-admin-button-label": "",
	"unified-search-placeholder": "",
	"unified-search-placeholder-v2": "",
	"unified-search-recent-searches": "",
	"unified-search-recent-pages-visited": "",
	"unified-search-recent-resources-visited": "",
	"unified-search-no-recent-searches": "",
	"unified-search-marketplace": "",
	"unified-search-documentation": "",
	"unified-search-open-product": "",
	"unified-search-change-search-terms": "",
	"unified-search-no-results-found": "",
	"unified-search-footer": "",
	"unified-search-footer-no-feedback": "",
	"unified-search-footer-give-feedback": "",
	"unified-search-documentation-link": "",
	"unified-search-downloads": "",
	"unified-search-runs": "",
	"unified-search-all": "",
	"unified-search-see-all": "",
	"unified-search-clear-button": "",
	"unified-search-filter": "",
	"unified-search-all-count": "",
	"unified-search-components-count": "",
	"unified-search-pages-count": "",
	"unified-search-tags": "",
	"learn-more": "",
	"my-workspace": "",
	"give-feedback": "",
	"ap-autocomplete-input-no-results": "",
	"ap-dropdown-placeholder": "",
	"ap-date-picker-placeholder": "",
	"ap-date-picker-selected-day-label": "",
	"ap-breadcrumb-overflow-label": "",
	"unified-search-Studio": "",
	"unified-search-AiCenter": "",
	"unified-search-Assistant": "",
	"unified-search-ProcessMining": "",
	"unified-search-BusinessSolutions": "",
	"unified-search-UiPathApps": "",
	"unified-search-IntegrationServices": "",
	"unified-search-StudioX": "",
	"unified-search-ProfessionalServices": "",
	"unified-search-Accelerator": "",
	"unified-search-StudioWeb": "",
	"unified-search-AutomationOps": "",
	"unified-search-DocumentUnderstanding": "",
	"unified-search-Insights": "",
	"unified-search-Other": "",
	"unified-search-Activity": "",
	"unified-search-CustomActivity": "",
	"unified-search-Snippet": "",
	"unified-search-WorkflowTemplate": "",
	"unified-search-Connector": "",
	"unified-search-Tool": "",
	"unified-search-MLModel": "",
	"unified-search-Solution": "",
	"unified-search-Process": "",
	"unified-search-Widget": "",
	"unified-search-BusinessSolution": "",
	"unified-search-App": "",
	"unified-search-UiPathAppSolution": "",
	"unified-search-UiPathAppTemplate": "",
	"unified-search-IntegrationServiceConnector": "",
	"unified-search-StudioXWorkflowTemplate": "",
	"unified-search-ProfessionalService": "",
	"unified-search-StudioWebTemplate": "",
	"unified-search-AutomationOpsPipeline": "",
	"unified-search-AutomationOpsPipelineTemplate": "",
	"unified-search-ExtractionModel": "",
	"unified-search-marketplace-studio-activity": "",
	"unified-search-marketplace-studio-snippet": "",
	"unified-search-marketplace-studio-workflowtemplate": "",
	"unified-search-marketplace-studio-connector": "",
	"unified-search-marketplace-studio-tool": "",
	"unified-search-marketplace-studio-solution": "",
	"unified-search-marketplace-studioweb-studiowebtemplate": "",
	"unified-search-marketplace-studiox-studioxworkflowtemplate": "",
	"unified-search-marketplace-assistant-process": "",
	"unified-search-marketplace-aicenter-mlmodel": "",
	"unified-search-marketplace-processmining-app": "",
	"unified-search-marketplace-uipathapps-uipathappsolution": "",
	"unified-search-marketplace-uipathapps-uipathapptemplate": "",
	"unified-search-marketplace-integrationservices-integrationserviceconnector": "",
	"unified-search-marketplace-accelerator-accelerator": "",
	"unified-search-marketplace-businesssolutions-businesssolution": "",
	"unified-search-marketplace-professionalservices-professionalservice": "",
	"rich-text-editor-format-bold": "",
	"rich-text-editor-bold": "",
	"rich-text-editor-format-italic": "",
	"rich-text-editor-italic": "",
	"rich-text-editor-format-underline": "",
	"rich-text-editor-underline": "",
	"rich-text-editor-format-strikethrough": "",
	"rich-text-editor-strikethrough": "",
	"rich-text-editor-format-ordered-list": "",
	"rich-text-editor-ordered-list": "",
	"rich-text-editor-format-unordered-list": "",
	"rich-text-editor-unordered-list": "",
	"rich-text-editor-insert-link": "",
	"rich-text-editor-link": "",
	"rich-text-editor-format-code": "",
	"rich-text-editor-code": "",
	"ap-text-field-placeholder": "",
	"notification-message-template": "",
	build: build$3,
	discover: discover$3,
	operate: operate$3,
	feedback: feedback$3,
	"give-us-feedback": "",
	cancel: cancel$3,
	confirm: confirm$3,
	favorites: favorites$3,
	"favorites-limit-reached": "",
	"favorites-description": "",
	"default-toggle": "",
	"default-progress-spinner": "",
	"default-icon-button": "",
	"default-radio-group": "",
	"default-checkbox": "",
	"default-stepper-clickable": "",
	"default-stepper-disabled": "",
	"new-navigation": ""
};

const home$2 = "Ana Sayfa";
const help$2 = "Yardım";
const languages$2 = "Diller";
const language$2 = "Dil";
const edit$2 = "Düzenle";
const enter$2 = "Giriş";
const theme$2 = "Tema";
const logout$2 = "Oturumu Kapat";
const tenants$2 = "Kiracılar";
const more$2 = "Daha Fazla";
const admin$2 = "Yönetici";
const autoTheme$2 = "Temayı otomatik seç";
const dark$2 = "Koyu tema";
const light$2 = "Açık tema";
const dismiss$2 = "kapat";
const warning$2 = "uyarı";
const info$2 = "bilgi";
const success$2 = "başarılı";
const error$2 = "hata";
const more_items$2 = "Daha Fazla Öğe";
const notifications$2 = "Bildirimler";
const preview$2 = "Önizleme";
const more_products$2 = "Diğer seçenekler";
const current_plan_upgrade$2 = "{{ license }} planındasınız";
const free_license$2 = "ücretsiz";
const community_license$2 = "topluluk";
const pro_trial_license$2 = "pro deneme sürümü";
const unlicensed$2 = "Lisanssız";
const back$2 = "Geri";
const trademark$2 = "TM";
const basic_auth_user$2 = "Yerel kullanıcı";
const local_group$2 = "Yerel grup";
const robot$2 = "Robot";
const directory_group$2 = "Dizin grubu";
const directory_user$2 = "Dizin kullanıcısı";
const directory_app$2 = "Dizin uygulaması";
const build$2 = "Oluşturma";
const discover$2 = "Discover";
const operate$2 = "Çalıştır";
const feedback$2 = "Geri Bildirim";
const cancel$2 = "İptal";
const confirm$2 = "Onayla";
const favorites$2 = "Favoriler";
const apply$2 = "Uygula";
const date$2 = "Tarih";
const time$2 = "Zaman";
const tr = {
	home: home$2,
	help: help$2,
	languages: languages$2,
	language: language$2,
	edit: edit$2,
	"edit-subject": "{{ subject }} öğesini düzenle",
	enter: enter$2,
	theme: theme$2,
	logout: logout$2,
	tenants: tenants$2,
	more: more$2,
	admin: admin$2,
	autoTheme: autoTheme$2,
	dark: dark$2,
	light: light$2,
	"light-hc": "Yüksek karşıtlık açık teması",
	"dark-hc": "Yüksek karşıtlık koyu teması",
	"close-button": "Kapat düğmesi",
	"client-days": "{{ differenceInDays }} gün kaldı",
	"client-hours": "{{ differenceInHours }} saat kaldı",
	"dropdown-placeholder": "Lütfen bir seçenek belirleyin",
	"empty-tenant-list-placeholder": "Geçerli kiracı yok",
	"tenant-picker-label": "Kiracı:",
	"tenant-picker-list": "Kiracı",
	"error-page-401-header": "Yetkilendirilmemiş",
	"error-page-403-header": "Hata! Listede değilsiniz",
	"error-page-403-description": "{{ pageTitle }} sayfasını görüntüleme izniniz yok. Gerekli izinler için lütfen yöneticinize başvurun.",
	"error-page-404-header": "Maalesef bulunamıyor",
	"error-page-404-description": "Aradığınız sayfa kaldırılmış, adı değiştirilmiş veya geçici olarak kullanılamıyor olabilir.",
	"error-page-503-header": "Yakında döneceğiz",
	"error-page-503-description": "Sistem bakımda. Güncel bilgiler için bu alanı takip edin.",
	"error-page-browser-header": "Bu tarayıcı desteklenmiyor",
	"error-page-endie-header": "Internet Explorer aşamalı olarak durduruluyor",
	"error-page-endie-description": "Internet Explorer desteği 31 Mayıs 2021'de sona erdi. UiPath'i kullanmak için Chrome, Firefox, Safari veya Edge'in en son sürümünü öneririz.",
	"error-page-ip-restricted-header": "Erişim kısıtlandı",
	"error-page-ip-restricted-description": "Kuruluş politikaları nedeniyle, bu ağ konumundan {{ pageTitle }} erişemezsiniz. Lütfen yöneticinizle iletişime geçin.",
	"error-page-learn-more": "Daha fazla bilgi edinin",
	"error-page-learn-why": "Nedenini öğrenin",
	"error-page-loader-header": "Biz her şeyi hazırlarken lütfen biraz bekleyin",
	"error-page-loader-description": "Bu işlem birkaç dakika sürebilir. Platform kullanıma hazır olduğunda sayfa yenilenir.",
	"error-page-goto-home": "Ana sayfaya git",
	"error-page-goto-uipath-website": "UiPath web sitesine git",
	"error-page-check-service": "Hizmet durumunu kontrol et",
	"error-page-know-why": "Nedenini öğren",
	"aria-label-logo": "UiPath'in resmi logosu. Burayı tıklatırsanız {{ serviceName }} ana sayfasına gider",
	"aria-label-logo-v2": "UiPath Automation Cloud logosu, burayı tıklattığınızda {serviceName} ana sayfasına gider",
	"language-na": "Bu hizmet için dil desteklenmiyor.",
	dismiss: dismiss$2,
	warning: warning$2,
	info: info$2,
	success: success$2,
	error: error$2,
	"client-days-per-service": "Deneme sürenizin bitmesine {{ differenceInDays }} gün kaldı",
	"client-days-per-service-with-name": "Ücretsiz {{ serviceName }} denemenizin bitmesine {{ differenceInDays }} gün kaldı",
	"client-hours-per-service": "Deneme sürenizde {{ differenceInHours }} saatiniz kaldı",
	"client-hours-per-service-with-name": "Ücretsiz {{ serviceName }} denemenizin bitmesine {{ differenceInHours }} saat kaldı",
	"waffle-label": "Uygulama başlatıcı",
	"generic-error-message": "Beklenmedik bir hata oluştu. Lütfen daha sonra tekrar deneyin",
	"help-menu-documentation": "Belgeler",
	"help-menu-product-documentation": "{{ product }} belgeleri",
	"help-menu-downloads": "İndirmeler",
	"help-menu-forum": "Topluluk forumu",
	"help-menu-training-tutorials": "Eğitim ve öğreticiler",
	"help-menu-uipath-academy": "UiPath Akademisi",
	"help-menu-youtube-tutorials": "YouTube öğreticileri",
	"help-menu-release-notes": "Sürüm notları",
	"help-menu-resources": "Kaynaklar",
	"help-menu-support": "Destek",
	more_items: more_items$2,
	notifications: notifications$2,
	"notifications-empty": "Bildirim bulunamadı",
	"notifications-all-read": "Tümünü okundu olarak işaretle",
	"notifications-unread": "Okunmadı olarak işaretle",
	"notifications-read": "Okundu olarak işaretle",
	"notifications-delete": "Sil",
	"notifications-mute": "{{ topicOrTenant }} aboneliğini iptal et",
	"notifications-muted": "Başarılı: {{ topicOrTenant }} bildirimleri aboneliğini iptal ettiniz.",
	"notifications-unread-only": "Sadece okunmayanlar",
	"notifications-settings": "Bildirim ayarları",
	"notifications-page": "Bildirimler sayfası",
	"notifications-clear-all": "Tümünü temizle",
	"notifications-end-list": "Liste sonu",
	"notifications-expandCollapse": "Genişlet/Daralt",
	"notifications-fetch-failure": "Bildirimler getirilemedi. Lütfen daha sonra tekrar deneyin",
	preview: preview$2,
	"unread-notifications-count": "{{ count }} okunmamış bildirim",
	"people-picker-default-placeholder": "Ada veya e-postaya göre ara",
	"people-picker-groups-placeholder": "Grup adına göre ara",
	"people-picker-single-mode-placeholder": "Ada veya e-postaya göre ara",
	"people-picker-single-mode-ad-helper-text": "Kullanıcı adına veya e-postaya veya alanadı\\sAmHesabıAdı'na göre ara",
	"people-picker-single-mode-aad-helper-text": "Kullanıcı adı veya e-posta, grup adı veya uygulama adına göre ara",
	"people-picker-default-helper-text": "Kullanıcı adına göre arama yapın veya virgülle ya da noktalı virgülle ayırarak e-postaları girin. \\ tuşunu kullanarak özel karakterleri atlayabilirsiniz.",
	"people-picker-aad-helper-text": "Kullanıcı adına göre arama yapın veya virgülle ya da noktalı virgülle ayırarak e-postaları girin. \\ tuşunu kullanarak özel karakterleri atlayabilirsiniz.",
	"people-picker-ad-ldap-helper-text": "Kullanıcı adına göre arama yapın veya virgülle ya da noktalı virgülle ayırarak e-postaları veya etki alanı\\ samHesabıAdları'nı girin. \\ tuşunu kullanarak özel karakterleri atlayabilirsiniz.",
	"people-picker-invalid-error-helper": "Geçerli bir e-posta kullanın",
	"people-picker-resolve-error-helper": "Çözümlenemeyen bazı girişler vardı. Lütfen bunları kaldırın veya daha sonra tekrar deneyin",
	"people-picker-resolve-error-tooltip": "Giriş çözümlenemedi. Lütfen kaldırın veya daha sonra yeniden deneyin",
	"people-picker-domain-picker-helper": "Bir etki alanı seç",
	"people-picker-too-many-entities": "Bir seferde sadece {{ maxValue }} varlık ekleyebilirsiniz",
	"people-picker-more-info": "Daha Fazla Bilgi",
	"autocomplete-no-results": "\"{{ query }}\" ile eşleşen sonuç yok",
	"autocomplete-limit-exceeded": "{limit} sınırı aşıldı",
	"autocomplete-search-text": "Aramak için yazın...",
	"autocomplete-no-results-people-picker": "\"{ query }\" ile eşleşen sonuç yok",
	"autocomplete-loading": "Yükleniyor...",
	"people-picker-add-users": "Adlar",
	"people-picker-add-groups": "Gruplar",
	"people-picker-add-apps": "Apps",
	"people-picker-add-names": "Adlar",
	"tenant-picker-aria-label": "Kiracı seçin. Geçerli: ",
	"people-picker-duplicate-chip": "Bazı yinelenen girişler var. Lütfen kopyalardan birini kaldırın ve tekrar deneyin.",
	"profile-navigation": "Tercihler",
	"remove-chip": "\"{{ value }}\" adlı üyeyi kaldır",
	"default-cobranding-logo-alt-text": "Marka Ortaklığı Logosu",
	"canary-tenant": "Test",
	more_products: more_products$2,
	current_plan_upgrade: current_plan_upgrade$2,
	free_license: free_license$2,
	community_license: community_license$2,
	pro_trial_license: pro_trial_license$2,
	"notification-action-menu-text": "Bildirimde Eylem",
	"notification-allaction-menu-text": "Tüm Bildirimlerde Daha Fazla Eylem",
	"buy-now": "Hemen Satın Al",
	"contact-sales": "Satış ekibiyle iletişime geçin",
	"skip-content": "Ana içeriğe atla",
	"object-picker-add-entry": "\"{{ entry }}\" ekle",
	"start-free-trial-header": "60 günlük",
	"sixty-days-trial": "UiPath Automation Cloud",
	"with-uipath-cloud": "denemesini başlatın",
	"take-advantage-capabilities": "Tam gelişmiş Automation Cloud yeteneklerimizden yararlanın.",
	"upgrade-to-enterprise": "Otomasyon programınızı kurumsal düzeyde yönetişim, güvenlik ve daha fazlasıyla ölçeklendirmeniz mi gerekiyor?",
	"trial-benefit-one": "Uzaktan, isteğe bağlı yürütmeyi etkinleştirmek için robotlar",
	"trial-benefit-two": "UiPath'tan 7x24 destek",
	"trial-benefit-three": "Çalışma süresi garantisi",
	"trial-benefit-four": "Her biri bölgelerimizde barındırılan birden fazla kiracı",
	"view-pricing": "Fiyatlandırmayı görüntüle",
	"upgrade-trial-role": "İş Unvanı",
	"upgrade-trial-company-name": "İşletme/Organizasyon adı",
	"upgrade-trial-business-email": "İş e-postası",
	"notifications-clear-message": "Bildirim öğesi silindi",
	"session-expiring": "Oturumun süresi doluyor",
	"session-expiring-description-inactive-hours": "{{hours}} saat {{minutes}} dakikadır etkin değilsiniz.",
	"session-expiring-description-inactive": "{{minutes}} dakikadır etkin değilsiniz.",
	"session-expiring-description-logged-out": "{{n}} saniye içinde oturumunuz kapatılacak.",
	"extend-session": "Oturumun süresini uzat",
	"dropdown-position": "{{index}}/{{total}}",
	unlicensed: unlicensed$2,
	"copy-clipboard": "Panoya Kopyala",
	"people-picker-search-entries": "\"{{query}}\" ile eşleşen {{count}} arama sonucu bulundu",
	"app-bar-aria-label": "Uygulama çubuğu",
	"nav-aria-label": "Sol gezinme",
	"chat-no-messages": "Sohbeti başlatmak için aşağıya bir mesaj yazın",
	"chat-type-a-message": "Mesaj yaz",
	"filter-service": "Hizmet:",
	"filter-severity": "Önem Derecesi:",
	"priority-low": "Düşük",
	"priority-medium": "Orta",
	"priority-high": "Yüksek",
	"priority-critical": "Kritik",
	"filter-option-all": "Tümü",
	"severity-info": "Bilgi",
	"severity-success": "Başarılı",
	"severity-warn": "Uyarı",
	"severity-error": "Hata",
	"severity-fatal": "Fatal",
	"breadcrumb-aria-label-default": "İçerik haritası",
	back: back$2,
	"switching-orgs": "Organizasyon Değiştirme",
	"switching-orgs-description": "{{ oldOrg }} organizasyonunu {{ newOrg }} olarak değiştirmeye çalışıyorsunuz. Devam etmek için lütfen önce oturumu kapatın.",
	"business-email-required": "Pro deneme sürümüne yükseltmek için iş e-postası gereklidir",
	"check-inbox-for-invite-link": "Davet bağlantısı için gelen kutunuzu kontrol edin ve yükseltmeyi tamamlamak için kabul edin",
	"invite-business-email-help": "Bu e-posta adresini kullanan organizasyonun zaten bir üyesiyseniz devam etmek için hesabınızda oturum açmanız yeterlidir.",
	"check-email-for-invite": "Davet için e-postanızı kontrol edin",
	"check-email-for-invite-description": "Daveti bulamıyorsanız spam klasörünüzü kontrol edin. Daveti kabul ettikten sonra Pro deneme sürümüne yükseltebilirsiniz.",
	"no-minimum-purchase": "Minimum satın alma yok.",
	"view-details-trial-plan": "Pro planının 60 günlük deneme sürümüne dahil edilen her şeyin ayrıntılarını görüntüleyin",
	"get-more-cloud": "UiPath Automation Cloud'dan daha fazla yararlanın",
	"start-free-trial": "Deneme sürümünü başlat",
	trademark: trademark$2,
	"send-invite": "Davet Gönder",
	"support-id": "Destek Kimliği",
	basic_auth_user: basic_auth_user$2,
	local_group: local_group$2,
	robot: robot$2,
	directory_group: directory_group$2,
	directory_user: directory_user$2,
	directory_app: directory_app$2,
	"unified-admin-button-label": "Erişimi yönet",
	"unified-search-placeholder": "UiPath Marketplace'te ve Belgelerde Ara",
	"unified-search-placeholder-v2": "Bileşenleri, sayfaları ve daha fazlasını arayın",
	"unified-search-recent-searches": "Son aramalar",
	"unified-search-recent-pages-visited": "Ziyaret edilen sayfalar",
	"unified-search-recent-resources-visited": "Ziyaret edilen kaynaklar",
	"unified-search-no-recent-searches": "Yakın zamanda yapılmış arama yok, sonuçları getirmek için 3 veya daha fazla karakter yazın",
	"unified-search-no-recent-searches-logographic-locales": "Yakın zamanda yapılmış arama yok, sonuçları getirmek için 1 veya daha fazla karakter yazın",
	"unified-search-marketplace": "UiPath Pazarı",
	"unified-search-documentation": "Belgeler",
	"unified-search-open-product": "{product} içinde açar",
	"unified-search-change-search-terms": "Arama terimini değiştirmeyi deneyin",
	"unified-search-no-results-found": "\"{term}\" ile eşleşen sonuç bulunamadı",
	"unified-search-footer": "Bunlar beklediğiniz sonuçlar değil mi? {feedbackLink} veya {learnMoreLink}",
	"unified-search-footer-no-feedback": "Bunlar beklediğiniz sonuçlar değil mi? {learnMoreLink}",
	"unified-search-footer-give-feedback": "Bunlar beklediğiniz sonuçlar değil mi? {feedbackLink}",
	"unified-search-documentation-link": "\"{query}\" öğesini Belgelerde ara",
	"unified-search-downloads": "{count} İndirilenler",
	"unified-search-runs": "{count} çalıştırma",
	"unified-search-all": "Tümü",
	"unified-search-see-all": "Tümünü gör",
	"unified-search-clear-button": "Temizle",
	"unified-search-filter": "Filtrele",
	"unified-search-all-count": "Tümü ({count})",
	"unified-search-components-count": "Bileşenler ({count})",
	"unified-search-pages-count": "Sayfalar ({count})",
	"unified-search-tags": "Etiketler: {tagList}",
	"learn-more": "Daha fazla bilgi edinin",
	"my-workspace": "Çalışma Alanım",
	"give-feedback": "Geri bildirimde bulun",
	"ap-autocomplete-input-no-results": "\"{query}\" ile eşleşen sonuç yok",
	"ap-dropdown-placeholder": "Seç...",
	"ap-date-picker-placeholder": "Tarih seç",
	"ap-time-picker-placeholder": "Zaman Seç",
	"ap-date-picker-selected-day-label": "{day} seçildi",
	"ap-breadcrumb-overflow-label": "İçerik haritası gizli bağlantıları",
	"unified-search-Studio": "Studio",
	"unified-search-AiCenter": "AI Center",
	"unified-search-Assistant": "UiPath Assistant",
	"unified-search-ProcessMining": "Process Mining",
	"unified-search-BusinessSolutions": "İş Ortağı Çözümleri",
	"unified-search-UiPathApps": "Uygulamalar",
	"unified-search-IntegrationServices": "Integration Service",
	"unified-search-StudioX": "StudioX",
	"unified-search-ProfessionalServices": "Profesyonel Hizmetler",
	"unified-search-Accelerator": "Hızlandırıcılar",
	"unified-search-StudioWeb": "Studio Web",
	"unified-search-AutomationOps": "Otomasyon İşlemleri",
	"unified-search-DocumentUnderstanding": "Document Understanding",
	"unified-search-Insights": "Insights",
	"unified-search-Other": "Diğer",
	"unified-search-Activity": "Etkinlikler",
	"unified-search-CustomActivity": "Etkinlikler",
	"unified-search-Snippet": "Parçacıklar",
	"unified-search-WorkflowTemplate": "Şablonlar",
	"unified-search-Connector": "Bağlayıcılar",
	"unified-search-Tool": "Araçlar",
	"unified-search-MLModel": "ML Modelleri",
	"unified-search-Solution": "Çözümler",
	"unified-search-Process": "Kullanıma Hazır Otomasyonlar",
	"unified-search-Widget": "Pencere Öğesi",
	"unified-search-BusinessSolution": "İş Ortağı Çözümleri",
	"unified-search-App": "Uygulamalar",
	"unified-search-UiPathAppSolution": "Uygulama Çözümleri",
	"unified-search-UiPathAppTemplate": "Uygulama Şablonları",
	"unified-search-IntegrationServiceConnector": "Integration Service Bağlayıcısı",
	"unified-search-StudioXWorkflowTemplate": "Şablonlar",
	"unified-search-ProfessionalService": "Profesyonel Hizmet",
	"unified-search-StudioWebTemplate": "Studio Web Şablonu",
	"unified-search-AutomationOpsPipeline": "İşlem Hatları",
	"unified-search-AutomationOpsPipelineTemplate": "İşlem Hattı Şablonları",
	"unified-search-ExtractionModel": "Ayıklama modelleri",
	"unified-search-marketplace-studio-activity": "Studio etkinliği",
	"unified-search-marketplace-studio-snippet": "Studio snippet'i",
	"unified-search-marketplace-studio-workflowtemplate": "Studio şablonu",
	"unified-search-marketplace-studio-connector": "Bağlayıcılar (Eski)",
	"unified-search-marketplace-studio-tool": "Studio aracı",
	"unified-search-marketplace-studio-solution": "Studio çözümü",
	"unified-search-marketplace-studioweb-studiowebtemplate": "Studio Web Şablonu",
	"unified-search-marketplace-studiox-studioxworkflowtemplate": "Studio X şablonu",
	"unified-search-marketplace-assistant-process": "Kullanıma Hazır Otomasyon",
	"unified-search-marketplace-aicenter-mlmodel": "ML Modeli",
	"unified-search-marketplace-processmining-app": "Process Mining Uygulama Şablonu",
	"unified-search-marketplace-uipathapps-uipathappsolution": "Uygulama Çözümü",
	"unified-search-marketplace-uipathapps-uipathapptemplate": "Uygulama Şablonu",
	"unified-search-marketplace-integrationservices-integrationserviceconnector": "Bağlayıcılar",
	"unified-search-marketplace-accelerator-accelerator": "Hızlandırıcı",
	"unified-search-marketplace-businesssolutions-businesssolution": "İş Ortağı Çözümü",
	"unified-search-marketplace-professionalservices-professionalservice": "Profesyonel Hizmetler",
	"unified-search-orchestrator-asset": "Varlık",
	"unified-search-orchestrator-process": "İşlem",
	"unified-search-orchestrator-trigger": "Tetikleyici",
	"unified-search-orchestrator-queue": "Sıra",
	"unified-search-orchestrator-bucket": "Kutu",
	"unified-search-orchestrator-actioncatalog": "Eylem kataloğu",
	"unified-search-orchestrator-machine": "Makine",
	"unified-search-orchestrator-webhook": "Webhook",
	"unified-search-integrationservice-connection": "Bağlantı",
	"unified-search-integrationservice-trigger": "Tetikleyici",
	"unified-search-dataservice-entity": "Varlık",
	"unified-search-dataservice-choiceset": "Seçim Kümesi",
	"unified-search-apps-app": "Uygulamalar",
	"unified-search-loading-search-results": "Arama sonuçları yükleniyor",
	"rich-text-editor-format-bold": "Kalın Biçimlendir",
	"rich-text-editor-bold": "Kalın",
	"rich-text-editor-format-italic": "İtalik biçimlendir",
	"rich-text-editor-italic": "İtalik",
	"rich-text-editor-format-underline": "Altı çizili biçimlendir",
	"rich-text-editor-underline": "Alt Çizgi",
	"rich-text-editor-format-strikethrough": "Biçim Üstü Çizili",
	"rich-text-editor-strikethrough": "Üstü Çizili",
	"rich-text-editor-format-ordered-list": "Sıralanmış listeyi biçimlendir",
	"rich-text-editor-ordered-list": "Sıralı liste",
	"rich-text-editor-format-unordered-list": "Sıralanmamış listeyi biçimlendir",
	"rich-text-editor-unordered-list": "Sıralanmamış liste",
	"rich-text-editor-insert-link": "Bağlantı Ekle",
	"rich-text-editor-link": "Bağlantı",
	"rich-text-editor-format-code": "Kodu biçimlendir",
	"rich-text-editor-code": "Kod",
	"ap-text-field-placeholder": "Bir değer gir",
	"notification-message-template": "{{ tenantName }} içinde {{ topic }}",
	build: build$2,
	discover: discover$2,
	operate: operate$2,
	feedback: feedback$2,
	"give-us-feedback": "Geri bildirimde bulunun",
	cancel: cancel$2,
	confirm: confirm$2,
	favorites: favorites$2,
	"favorites-limit-reached": "Sınıra ulaşıldı: En fazla 3 öğe ekleyebilirsiniz.",
	"favorites-description": "Favori ürünleriniz burada gösterilir. En fazla 3 öğe ekleyebilirsiniz.",
	"default-toggle": "Değiştirme düğmesi",
	"default-progress-spinner": "İçerik yükleniyor",
	"default-icon-button": "Simge düğmesi",
	"default-radio-group": "Radyo Grubu",
	"default-checkbox": "Onay Kutusu",
	"default-stepper-clickable": "tıklanabilir adımlarla",
	"default-stepper-disabled": "devre dışı bırakılmış adımlarla",
	"new-navigation": "Yeni gezinme",
	"product-launcher-tooltip": "Ürün başlatıcısı",
	"autopilot-tooltip": "Autopilot",
	"notifications-tooltip": "Bildirimler",
	"search-tooltip": "Ara",
	"help-tooltip": "Yardım",
	"profile-tooltip": "Profil",
	apply: apply$2,
	date: date$2,
	time: time$2,
	"date-range": "Tarih Aralığı:",
	"date-range-label": "Tarih aralığı",
	"date-time-label": "TarihSaat",
	"date-time-picker-label": "Tarih saat seçici",
	"date-range-start": "Başlat",
	"date-range-end": "Bitir",
	"date-range-presets": "Hazır Ayarlar",
	"date-range-picker-last-hour": "Son saat",
	"date-range-picker-today": "Bugün",
	"date-range-picker-last-seven-days": "Son 7 gün",
	"date-range-picker-last-two-weeks": "Geçen 2 Hafta",
	"date-range-picker-last-month": "Geçen ay",
	"date-range-picker-last-six-months": "Son 6 ay",
	"date-range-picker-custom": "Özel",
	"date-range-picker-start-tooltip": "Başlangıç tarihi bitiş tarihinden sonra olamaz",
	"date-range-picker-label": "Tarih aralığı seçici",
	"time-selector": "Saat seçici",
	"date-range-picker-options": "Tarih aralığı seçenekleri",
	"no-options": "Seçenek Yok",
	"type-to-search": "Aramak için yazın...",
	"autopilot-chat-header": "Autopilot",
	"autopilot-chat-input-placeholder": "Ne yapmak istiyorsunuz?",
	"autopilot-chat-footer": "Autopilot hata yapabilir. Lütfen yanıtları tekrar kontrol edin.",
	"autopilot-chat-new-chat": "Yeni Sohbet",
	"autopilot-chat-close": "Kapat",
	"autopilot-chat-attach-file": "Dosya ekle",
	"autopilot-chat-send": "Gönder",
	"autopilot-chat-stop": "Durdur",
	"autopilot-chat-remove-file": "Kaldır",
	"autopilot-chat-prompt-library": "İstem kitaplığı",
	"autopilot-chat-dropzone-overlay-title": "Dosyalarınızı isteminize eklemek için buraya bırakın",
	"autopilot-chat-dropzone-overlay-description": "Desteklenen dosya türleri: {{ fileTypes }}",
	"autopilot-chat-dropzone-overlay-error": "Desteklenmeyen dosya türü: {{ fileTypes }}",
	"autopilot-chat-code-block-language": "Metin",
	"autopilot-chat-code-block-copy": "Kopyala",
	"autopilot-chat-expand": "Genişlet",
	"autopilot-chat-collapse": "Daralt",
	"autopilot-chat-remove-file-name": "Kaldır: {{ name }}",
	"autopilot-chat-selected-files": "Seçili Dosyalar ({{ count }})",
	"autopilot-chat-files-preview": "{{ files }} ve {{ count }} tane daha",
	"autopilot-chat-thinking": "Düşünme",
	"autopilot-chat-analyzing": "Talebiniz analiz ediliyor",
	"autopilot-chat-thinking-more": "Biraz daha düşünüyorum",
	"autopilot-chat-suggestions": "Öneriler"
};

const home$1 = "主页";
const help$1 = "帮助";
const languages$1 = "语言";
const language$1 = "语言";
const edit$1 = "编辑";
const enter$1 = "Enter";
const theme$1 = "主题";
const logout$1 = "注销";
const tenants$1 = "租户";
const more$1 = "更多";
const admin$1 = "管理员";
const autoTheme$1 = "自动选择主题";
const dark$1 = "深色主题";
const light$1 = "浅色主题";
const dismiss$1 = "消除";
const warning$1 = "警告";
const info$1 = "信息";
const success$1 = "成功";
const error$1 = "错误";
const more_items$1 = "更多项目";
const notifications$1 = "通知";
const preview$1 = "预览";
const more_products$1 = "更多选项";
const current_plan_upgrade$1 = "您目前在使用 {{ license }} 计划";
const free_license$1 = "免费版";
const community_license$1 = "社区版";
const pro_trial_license$1 = "Pro 版试用";
const unlicensed$1 = "未许可";
const back$1 = "返回";
const trademark$1 = "TM";
const basic_auth_user$1 = "本地用户";
const local_group$1 = "本地组";
const robot$1 = "机器人";
const directory_group$1 = "目录组";
const directory_user$1 = "目录用户";
const directory_app$1 = "目录应用程序";
const build$1 = "构建";
const discover$1 = "发现";
const operate$1 = "运行";
const feedback$1 = "反馈";
const cancel$1 = "取消";
const confirm$1 = "确认";
const favorites$1 = "收藏夹";
const apply$1 = "应用";
const date$1 = "日期";
const time$1 = "时间";
const zhCN = {
	home: home$1,
	help: help$1,
	languages: languages$1,
	language: language$1,
	edit: edit$1,
	"edit-subject": "编辑 {{ subject }}",
	enter: enter$1,
	theme: theme$1,
	logout: logout$1,
	tenants: tenants$1,
	more: more$1,
	admin: admin$1,
	autoTheme: autoTheme$1,
	dark: dark$1,
	light: light$1,
	"light-hc": "高对比度浅色主题",
	"dark-hc": "高对比度深色主题",
	"close-button": "关闭按钮",
	"client-days": "还剩 {{ differenceInDays }} 天",
	"client-hours": "还剩 {{ differenceInHours }} 小时",
	"dropdown-placeholder": "请选择任意一个选项",
	"empty-tenant-list-placeholder": "无有效租户",
	"tenant-picker-label": "租户:",
	"tenant-picker-list": "租户",
	"error-page-401-header": "未经授权",
	"error-page-403-header": "糟糕! 您不在列表中",
	"error-page-403-description": "您无权查看“{{ pageTitle }}”。请联系管理员以获取必要权限。",
	"error-page-404-header": "抱歉，找不到网页",
	"error-page-404-description": "您正在查找的页面可能已被删除、名称已更改或暂时不可用。",
	"error-page-503-header": "请稍等",
	"error-page-503-description": "系统正在维护。请留意此处以获取更新信息。",
	"error-page-browser-header": "不支持此浏览器",
	"error-page-endie-header": "逐步淘汰 Internet Explorer",
	"error-page-endie-description": "自 2021 年 5 月 31 日起不再支持 Internet Explorer。要使用 UiPath，我们建议使用最新版本的 Chrome、Firefox、Safari 或 Edge。",
	"error-page-ip-restricted-header": "访问受限",
	"error-page-ip-restricted-description": "由于组织策略，您无法从此网络位置访问{{ pageTitle }}。请联系您的管理员。",
	"error-page-learn-more": "了解详情",
	"error-page-learn-why": "了解原因",
	"error-page-loader-header": "正在设置，请稍候",
	"error-page-loader-description": "这可能需要几分钟时间。当平台准备就绪时，页面将刷新。",
	"error-page-goto-home": "前往主页",
	"error-page-goto-uipath-website": "转到 UiPath 网站",
	"error-page-check-service": "检查服务状态",
	"error-page-know-why": "了解原因",
	"aria-label-logo": "UiPath 官方徽标。单击此处可转到 {{ serviceName }} 主页",
	"aria-label-logo-v2": "UiPath Automation Cloud 徽标，单击此处可转到 {serviceName} 主页",
	"language-na": "此服务不支持的语言。",
	dismiss: dismiss$1,
	warning: warning$1,
	info: info$1,
	success: success$1,
	error: error$1,
	"client-days-per-service": "您的试用期还剩 {{ differenceInDays }} 天",
	"client-days-per-service-with-name": "您{{ serviceName }}服务的免费试用期还剩 {{ differenceInDays }} 天",
	"client-hours-per-service": "您的试用期还剩 {{ differenceInHours }} 小时",
	"client-hours-per-service-with-name": "您{{ serviceName }}服务的免费试用期还剩 {{ differenceInHours }} 小时",
	"waffle-label": "应用程序启动器",
	"generic-error-message": "发生意外错误。请稍后重试",
	"help-menu-documentation": "文档",
	"help-menu-product-documentation": "{{ product }} 文档",
	"help-menu-downloads": "下载",
	"help-menu-forum": "社区论坛",
	"help-menu-training-tutorials": "培训和教程",
	"help-menu-uipath-academy": "UiPath Academy",
	"help-menu-youtube-tutorials": "YouTube 教程",
	"help-menu-release-notes": "发行说明",
	"help-menu-resources": "资源",
	"help-menu-support": "支持",
	more_items: more_items$1,
	notifications: notifications$1,
	"notifications-empty": "找不到任何通知",
	"notifications-all-read": "全部标记为“已读”",
	"notifications-unread": "标记为“未读”",
	"notifications-read": "标记为“已读”",
	"notifications-delete": "删除",
	"notifications-mute": "取消订阅 {{ topicOrTenant }}",
	"notifications-muted": "成功: 您已取消订阅 {{ topicOrTenant }} 通知。",
	"notifications-unread-only": "仅未读",
	"notifications-settings": "通知设置",
	"notifications-page": "通知页面",
	"notifications-clear-all": "全部清除",
	"notifications-end-list": "列表末尾",
	"notifications-expandCollapse": "展开/收起",
	"notifications-fetch-failure": "获取通知失败。请稍后重试",
	preview: preview$1,
	"unread-notifications-count": "{{ count }} 个未读通知",
	"people-picker-default-placeholder": "按名称或电子邮件搜索",
	"people-picker-groups-placeholder": "按组名搜索",
	"people-picker-single-mode-placeholder": "按名称或电子邮件搜索",
	"people-picker-single-mode-ad-helper-text": "按名称、邮箱或域\\SAM 帐户名称搜索",
	"people-picker-single-mode-aad-helper-text": "按名称、邮箱、组名称或应用程序名称搜索",
	"people-picker-default-helper-text": "按名字搜索，或输入电子邮件地址并用逗号或分号隔开。您可以使用 \"\\\" 对特殊字符进行转义。",
	"people-picker-aad-helper-text": "按名字搜索，或输入电子邮件地址并用逗号或分号隔开。您可以使用 \"\\\" 对特殊字符进行转义。",
	"people-picker-ad-ldap-helper-text": "按名字搜索，或输入电子邮件地址\\域\\SAM 帐户名称并用逗号或分号隔开。您可以使用 \"\\\" 对特殊字符进行转义。",
	"people-picker-invalid-error-helper": "使用有效的邮箱",
	"people-picker-resolve-error-helper": "有些条目无法解析。请删除这些条目或稍后重试",
	"people-picker-resolve-error-tooltip": "无法解析此条目。请删除此条目或稍后重试",
	"people-picker-domain-picker-helper": "选择域",
	"people-picker-too-many-entities": "您一次只能添加 {{ maxValue }} 个实体",
	"people-picker-more-info": "更多信息",
	"autocomplete-no-results": "未找与“{{ query }}”相符的结果",
	"autocomplete-limit-exceeded": "超过了 {limit} 的限制",
	"autocomplete-search-text": "输入搜索内容…",
	"autocomplete-no-results-people-picker": "未找与“{ query }”相符的结果",
	"autocomplete-loading": "正在加载…",
	"people-picker-add-users": "名称",
	"people-picker-add-groups": "组",
	"people-picker-add-apps": "应用程序",
	"people-picker-add-names": "名称",
	"tenant-picker-aria-label": "选择租户。当前: ",
	"people-picker-duplicate-chip": "有一些重复条目。请删除其中一个重复项，然后重试。",
	"profile-navigation": "首选项",
	"remove-chip": "删除“{{ value }}”",
	"default-cobranding-logo-alt-text": "联合品牌徽标",
	"canary-tenant": "测试",
	more_products: more_products$1,
	current_plan_upgrade: current_plan_upgrade$1,
	free_license: free_license$1,
	community_license: community_license$1,
	pro_trial_license: pro_trial_license$1,
	"notification-action-menu-text": "对通知执行的操作",
	"notification-allaction-menu-text": "对所有通知执行的更多操作",
	"buy-now": "立即购买",
	"contact-sales": "联系销售",
	"skip-content": "跳到主要内容",
	"object-picker-add-entry": "添加“{{ entry }}”",
	"start-free-trial-header": "开启 ",
	"sixty-days-trial": "UiPath Automation Cloud ",
	"with-uipath-cloud": "的 60 天试用",
	"take-advantage-capabilities": "充分利用我们成熟的 Automation Cloud 功能。",
	"upgrade-to-enterprise": "需要通过企业级监管、安全性等扩展您的自动化程序吗?",
	"trial-benefit-one": "用于实现远程按需执行的机器人",
	"trial-benefit-two": "UiPath 全天候支持",
	"trial-benefit-three": "运行时间保证",
	"trial-benefit-four": "多个租户，每个都托管在我们的任意区域",
	"view-pricing": "查看定价",
	"upgrade-trial-role": "职位名称",
	"upgrade-trial-company-name": "企业/组织名称",
	"upgrade-trial-business-email": "工作电子邮件地址",
	"notifications-clear-message": "通知项目已删除",
	"session-expiring": "会话过期",
	"session-expiring-description-inactive-hours": "您已不活动 {{hours}} 小时 {{minutes}} 分钟。",
	"session-expiring-description-inactive": "您已不活动 {{minutes}} 分钟。",
	"session-expiring-description-logged-out": "系统将在 {{n}} 秒后注销。",
	"extend-session": "扩展会话",
	"dropdown-position": "{{index}}/{{total}}",
	unlicensed: unlicensed$1,
	"copy-clipboard": "复制到剪贴板",
	"people-picker-search-entries": "找到 {{count}} 个与“{{query}}”匹配的搜索结果",
	"app-bar-aria-label": "应用程序栏",
	"nav-aria-label": "左侧导航",
	"chat-no-messages": "在下方输入消息即可开始聊天",
	"chat-type-a-message": "输入消息",
	"filter-service": "服务:",
	"filter-severity": "严重性:",
	"priority-low": "低",
	"priority-medium": "中",
	"priority-high": "高",
	"priority-critical": "关键",
	"filter-option-all": "全部",
	"severity-info": "信息",
	"severity-success": "Success",
	"severity-warn": "警告",
	"severity-error": "错误",
	"severity-fatal": "严重",
	"breadcrumb-aria-label-default": "痕迹",
	back: back$1,
	"switching-orgs": "切换组织",
	"switching-orgs-description": "您正尝试将组织从 {{ oldOrg }} 切换到 {{ newOrg }}。要继续操作，请先注销帐户。",
	"business-email-required": "必须使用企业邮箱才能升级到 Pro Trial",
	"check-inbox-for-invite-link": "检查您收件箱中的邀请链接，然后接受邀请以完成升级",
	"invite-business-email-help": "如果您已是使用该电子邮件地址的组织的成员，只需登录到您的帐户即可继续。",
	"check-email-for-invite": "检查您的邀请电子邮件",
	"check-email-for-invite-description": "如果找不到邀请，请检查垃圾邮件文件夹。接受邀请后，您可以升级到 Pro Trial。",
	"no-minimum-purchase": "无最低购买要求。",
	"view-details-trial-plan": "查看 Pro 计划 60 天试用版中包含的所有内容的详细信息",
	"get-more-cloud": "从 UiPath Automation Cloud 获取更多内容",
	"start-free-trial": "开始免费试用",
	trademark: trademark$1,
	"send-invite": "发送邀请",
	"support-id": "支持 ID",
	basic_auth_user: basic_auth_user$1,
	local_group: local_group$1,
	robot: robot$1,
	directory_group: directory_group$1,
	directory_user: directory_user$1,
	directory_app: directory_app$1,
	"unified-admin-button-label": "管理访问权限",
	"unified-search-placeholder": "搜索 Marketplace 和文档",
	"unified-search-placeholder-v2": "搜索组件、页面等",
	"unified-search-recent-searches": "最近的搜索",
	"unified-search-recent-pages-visited": "访问的页面",
	"unified-search-recent-resources-visited": "访问的资源",
	"unified-search-no-recent-searches": "最近没有搜索，请输入 3 个或更多个字符来获取结果",
	"unified-search-no-recent-searches-logographic-locales": "最近没有搜索，请输入 1 个或以上字符来获取结果",
	"unified-search-marketplace": "Uipath 市场",
	"unified-search-documentation": "文档",
	"unified-search-open-product": "在 {product} 中打开",
	"unified-search-change-search-terms": "尝试更改搜索词。",
	"unified-search-no-results-found": "未找到与“{term}”相符的结果",
	"unified-search-footer": "不是您期望的结果？{feedbackLink} 或 {learnMoreLink}",
	"unified-search-footer-no-feedback": "不是您期望的结果？{learnMoreLink}",
	"unified-search-footer-give-feedback": "不是您期望的结果？{feedbackLink}",
	"unified-search-documentation-link": "在文档中搜索“{query}”",
	"unified-search-downloads": "{count} 次下载",
	"unified-search-runs": "{count} 次运行",
	"unified-search-all": "全部",
	"unified-search-see-all": "查看全部",
	"unified-search-clear-button": "清除",
	"unified-search-filter": "筛选",
	"unified-search-all-count": "全部 ({count})",
	"unified-search-components-count": "组件 ({count})",
	"unified-search-pages-count": "页面 ({count})",
	"unified-search-tags": "标签：{tagList}",
	"learn-more": "了解详情",
	"my-workspace": "我的工作区",
	"give-feedback": "提供反馈",
	"ap-autocomplete-input-no-results": "未找与“{query}”相符的结果",
	"ap-dropdown-placeholder": "选择...",
	"ap-date-picker-placeholder": "选择日期",
	"ap-time-picker-placeholder": "选择时间",
	"ap-date-picker-selected-day-label": "已选定 {day} 行",
	"ap-breadcrumb-overflow-label": "面包屑导航隐藏的链接",
	"unified-search-Studio": "Studio",
	"unified-search-AiCenter": "AI Center",
	"unified-search-Assistant": "助理",
	"unified-search-ProcessMining": "Process Mining",
	"unified-search-BusinessSolutions": "合作伙伴解决方案",
	"unified-search-UiPathApps": "应用程序",
	"unified-search-IntegrationServices": "Integration Service",
	"unified-search-StudioX": "StudioX",
	"unified-search-ProfessionalServices": "专业服务",
	"unified-search-Accelerator": "加速器",
	"unified-search-StudioWeb": "Studio Web",
	"unified-search-AutomationOps": "自动化操作",
	"unified-search-DocumentUnderstanding": "Document Understanding",
	"unified-search-Insights": "Insights",
	"unified-search-Other": "其他",
	"unified-search-Activity": "活动",
	"unified-search-CustomActivity": "活动",
	"unified-search-Snippet": "代码片段",
	"unified-search-WorkflowTemplate": "模板",
	"unified-search-Connector": "连接器",
	"unified-search-Tool": "工具",
	"unified-search-MLModel": "ML 模型",
	"unified-search-Solution": "解决方案",
	"unified-search-Process": "即用型自动化",
	"unified-search-Widget": "微件",
	"unified-search-BusinessSolution": "合作伙伴解决方案",
	"unified-search-App": "应用程序",
	"unified-search-UiPathAppSolution": "应用程序解决方案",
	"unified-search-UiPathAppTemplate": "应用程序模板",
	"unified-search-IntegrationServiceConnector": "Integration Service 连接器",
	"unified-search-StudioXWorkflowTemplate": "模板",
	"unified-search-ProfessionalService": "专业服务",
	"unified-search-StudioWebTemplate": "Studio Web 模板",
	"unified-search-AutomationOpsPipeline": "管道",
	"unified-search-AutomationOpsPipelineTemplate": "管道模板",
	"unified-search-ExtractionModel": "提取模型",
	"unified-search-marketplace-studio-activity": "Studio 活动",
	"unified-search-marketplace-studio-snippet": "Studio 代码片段",
	"unified-search-marketplace-studio-workflowtemplate": "Studio 模板",
	"unified-search-marketplace-studio-connector": "连接器（旧版）",
	"unified-search-marketplace-studio-tool": "Studio 工具",
	"unified-search-marketplace-studio-solution": "Studio 解决方案",
	"unified-search-marketplace-studioweb-studiowebtemplate": "Studio Web 模板",
	"unified-search-marketplace-studiox-studioxworkflowtemplate": "Studio X 模板",
	"unified-search-marketplace-assistant-process": "即用型自动化",
	"unified-search-marketplace-aicenter-mlmodel": "ML 模型",
	"unified-search-marketplace-processmining-app": "Process Mining 应用程序模板",
	"unified-search-marketplace-uipathapps-uipathappsolution": "应用程序解决方案",
	"unified-search-marketplace-uipathapps-uipathapptemplate": "应用程序模板",
	"unified-search-marketplace-integrationservices-integrationserviceconnector": "连接器",
	"unified-search-marketplace-accelerator-accelerator": "加速器",
	"unified-search-marketplace-businesssolutions-businesssolution": "合作伙伴解决方案",
	"unified-search-marketplace-professionalservices-professionalservice": "专业服务",
	"unified-search-orchestrator-asset": "资产",
	"unified-search-orchestrator-process": "流程",
	"unified-search-orchestrator-trigger": "触发器",
	"unified-search-orchestrator-queue": "队列",
	"unified-search-orchestrator-bucket": "存储桶",
	"unified-search-orchestrator-actioncatalog": "操作目录",
	"unified-search-orchestrator-machine": "计算机",
	"unified-search-orchestrator-webhook": "Webhook",
	"unified-search-integrationservice-connection": "连接",
	"unified-search-integrationservice-trigger": "触发器",
	"unified-search-dataservice-entity": "实体",
	"unified-search-dataservice-choiceset": "选项集",
	"unified-search-apps-app": "应用程序",
	"unified-search-loading-search-results": "正在加载搜索结果",
	"rich-text-editor-format-bold": "粗体格式",
	"rich-text-editor-bold": "加粗",
	"rich-text-editor-format-italic": "斜体格式",
	"rich-text-editor-italic": "斜体",
	"rich-text-editor-format-underline": "下划线格式",
	"rich-text-editor-underline": "下划线",
	"rich-text-editor-format-strikethrough": "删除线格式",
	"rich-text-editor-strikethrough": "删除线",
	"rich-text-editor-format-ordered-list": "有序列表格式",
	"rich-text-editor-ordered-list": "有序列表",
	"rich-text-editor-format-unordered-list": "设置未排序列表格式",
	"rich-text-editor-unordered-list": "未排序列表",
	"rich-text-editor-insert-link": "插入链接",
	"rich-text-editor-link": "链接",
	"rich-text-editor-format-code": "格式代码",
	"rich-text-editor-code": "代码",
	"ap-text-field-placeholder": "输入一个值",
	"notification-message-template": "{{ tenantName }} 中的{{ topic }}",
	build: build$1,
	discover: discover$1,
	operate: operate$1,
	feedback: feedback$1,
	"give-us-feedback": "向我们提供反馈",
	cancel: cancel$1,
	confirm: confirm$1,
	favorites: favorites$1,
	"favorites-limit-reached": "达到上限：您最多只能添加 3 个项目。",
	"favorites-description": "您收藏的产品将显示在此处。您最多可以添加 3 个项目。",
	"default-toggle": "切换开关",
	"default-progress-spinner": "正在加载内容",
	"default-icon-button": "图标按钮",
	"default-radio-group": "广播组",
	"default-checkbox": "复选框",
	"default-stepper-clickable": "附有可单击的步骤",
	"default-stepper-disabled": "附有已禁用的步骤",
	"new-navigation": "新导航",
	"product-launcher-tooltip": "产品启动器",
	"autopilot-tooltip": "Autopilot",
	"notifications-tooltip": "通知",
	"search-tooltip": "搜索",
	"help-tooltip": "帮助",
	"profile-tooltip": "配置文件",
	apply: apply$1,
	date: date$1,
	time: time$1,
	"date-range": "日期范围：",
	"date-range-label": "数据范围",
	"date-time-label": "日期时间",
	"date-time-picker-label": "日期时间选取器",
	"date-range-start": "启动",
	"date-range-end": "结束",
	"date-range-presets": "预设",
	"date-range-picker-last-hour": "过去一小时",
	"date-range-picker-today": "今天",
	"date-range-picker-last-seven-days": "过去 7 天",
	"date-range-picker-last-two-weeks": "过去 2 周",
	"date-range-picker-last-month": "过去一个月",
	"date-range-picker-last-six-months": "过去 6 个月",
	"date-range-picker-custom": "自定义",
	"date-range-picker-start-tooltip": "开始日期不得晚于结束日期",
	"date-range-picker-label": "日期范围选取器",
	"time-selector": "时间选取器",
	"date-range-picker-options": "日期范围选项",
	"no-options": "无选项",
	"type-to-search": "输入搜索内容…",
	"autopilot-chat-header": "Autopilot",
	"autopilot-chat-input-placeholder": "要执行什么操作?",
	"autopilot-chat-footer": "Autopilot 可能会犯错。请仔细检查回答。",
	"autopilot-chat-new-chat": "新建聊天",
	"autopilot-chat-close": "关闭",
	"autopilot-chat-attach-file": "添加附件",
	"autopilot-chat-send": "发送",
	"autopilot-chat-stop": "停止",
	"autopilot-chat-remove-file": "删除",
	"autopilot-chat-prompt-library": "提示库",
	"autopilot-chat-dropzone-overlay-title": "将文件拖放到此处，以将其添加到提示中",
	"autopilot-chat-dropzone-overlay-description": "支持的文件类型：{{ fileTypes }}",
	"autopilot-chat-dropzone-overlay-error": "不支持的文件：{{ fileTypes }}。",
	"autopilot-chat-code-block-language": "文本",
	"autopilot-chat-code-block-copy": "复制",
	"autopilot-chat-expand": "展开",
	"autopilot-chat-collapse": "折叠",
	"autopilot-chat-remove-file-name": "删除 {{ name }}",
	"autopilot-chat-selected-files": "已选定文件 ({{ count }})",
	"autopilot-chat-files-preview": "{{ files }} 以及另外 {{ count }} 个",
	"autopilot-chat-thinking": "想法",
	"autopilot-chat-analyzing": "分析您的请求",
	"autopilot-chat-thinking-more": "进一步分析中",
	"autopilot-chat-suggestions": "建议"
};

const home = "首頁";
const help = "幫助";
const languages = "語言";
const language = "語言";
const edit = "編輯";
const enter = "輸入";
const theme = "主題";
const logout = "登出";
const tenants = "租用戶";
const more = "更多";
const admin = "管理員";
const autoTheme = "自動選取主題";
const dark = "深色主題";
const light = "淺色主題";
const dismiss = "解除";
const warning = "警告";
const info = "Info";
const success = "成功";
const error = "錯誤";
const more_items = "更多項目";
const notifications = "通知";
const preview = "預覽";
const more_products = "更多選項";
const current_plan_upgrade = "您正在制訂 {{ license }} 方案";
const free_license = "閒置";
const community_license = "社群";
const pro_trial_license = "Pro 試用版";
const unlicensed = "未許可";
const back = "返回";
const trademark = "TM";
const basic_auth_user = "本地用戶";
const local_group = "本機群組";
const robot = "機器人";
const directory_group = "目錄組";
const directory_user = "目錄使用者";
const directory_app = "目錄應用程式";
const build = "構建";
const discover = "發現";
const operate = "操作";
const feedback = "回饋";
const cancel = "取消";
const confirm = "確認";
const favorites = "我的最愛";
const apply = "應用";
const date = "日期";
const time = "時間";
const zhTW = {
	home: home,
	help: help,
	languages: languages,
	language: language,
	edit: edit,
	"edit-subject": "編輯 {{ subject }}",
	enter: enter,
	theme: theme,
	logout: logout,
	tenants: tenants,
	more: more,
	admin: admin,
	autoTheme: autoTheme,
	dark: dark,
	light: light,
	"light-hc": "高對比淺色主題",
	"dark-hc": "高對比深色主題",
	"close-button": "「關閉」按鈕",
	"client-days": "還剩 {{ differenceInDays }} 天",
	"client-hours": "還剩 {{ differenceInHours }} 小時",
	"dropdown-placeholder": "請選取任意一個選項",
	"empty-tenant-list-placeholder": "沒有有效的租用戶",
	"tenant-picker-label": "租戶:",
	"tenant-picker-list": "租戶",
	"error-page-401-header": "未經授權",
	"error-page-403-header": "糟糕! 您不在清單中",
	"error-page-403-description": "您沒有權限，無法檢視 {{ pageTitle }}。請聯繫管理員以取得所需的權限。",
	"error-page-404-header": "抱歉! 找不到網頁",
	"error-page-404-description": "您正在尋找的頁面可能已遭到移除、名稱已變更或暫時無法使用。",
	"error-page-503-header": "請稍等",
	"error-page-503-description": "系統正在維護。請留意此處以取得更新資訊。",
	"error-page-browser-header": "不支援此瀏覽器",
	"error-page-endie-header": "逐步淘汰 Internet Explorer",
	"error-page-endie-description": "自 2021 年 5 月 31 日起不再支援 Internet Explorer。若要使用 UiPath，我們建議使用最新版本的 Chrome、Firefox、Safari 或 Edge。",
	"error-page-ip-restricted-header": "存取受限",
	"error-page-ip-restricted-description": "由於組織原則的緣故，您無法從此網路位置存取 {{ pageTitle }}。請聯繫您的管理員。",
	"error-page-learn-more": "瞭解詳細資訊",
	"error-page-learn-why": "瞭解原因",
	"error-page-loader-header": "正在設定，請稍候",
	"error-page-loader-description": "這可能需要幾分鐘的時間。當平台準備就緒時，頁面將重新整理。",
	"error-page-goto-home": "移至首頁",
	"error-page-goto-uipath-website": "移至 UiPath 網站",
	"error-page-check-service": "檢查服務狀態",
	"error-page-know-why": "瞭解原因",
	"aria-label-logo": "UiPath 官方標誌。按一下此處可移至 {{ serviceName }} 首頁",
	"aria-label-logo-v2": "UiPath Automation Cloud 標誌，按一下此處可移至 {serviceName} 首頁",
	"language-na": "此服務不支援的語言。",
	dismiss: dismiss,
	warning: warning,
	info: info,
	success: success,
	error: error,
	"client-days-per-service": "您的試用期還剩 {{ differenceInDays }} 天",
	"client-days-per-service-with-name": "您的 {{ serviceName }} 免費試用期還剩 {{ differenceInDays }} 天",
	"client-hours-per-service": "您的試用期還剩 {{ differenceInHours }} 小時",
	"client-hours-per-service-with-name": "您的 {{ serviceName }} 免費試用期還剩 {{ differenceInHours }} 小時",
	"waffle-label": "應用程式啟動器",
	"generic-error-message": "發生非預期的錯誤。請稍後重試",
	"help-menu-documentation": "文件",
	"help-menu-product-documentation": "{{ product }} 文件",
	"help-menu-downloads": "下載內容",
	"help-menu-forum": "Community 論壇",
	"help-menu-training-tutorials": "訓練和教學課程",
	"help-menu-uipath-academy": "UiPath Academy",
	"help-menu-youtube-tutorials": "YouTube 教學課程",
	"help-menu-release-notes": "版本資訊",
	"help-menu-resources": "資源",
	"help-menu-support": "支援",
	more_items: more_items,
	notifications: notifications,
	"notifications-empty": "找不到任何通知",
	"notifications-all-read": "全部標記為「已讀」",
	"notifications-unread": "標示為「未讀」",
	"notifications-read": "標示為已讀",
	"notifications-delete": "刪除",
	"notifications-mute": "取消訂閱 {{ topicOrTenant }}",
	"notifications-muted": "成功: 您已取消訂閱 {{ topicOrTenant }} 通知。",
	"notifications-unread-only": "僅未讀",
	"notifications-settings": "通知設定",
	"notifications-page": "通知頁面",
	"notifications-clear-all": "全部清除",
	"notifications-end-list": "清單結尾",
	"notifications-expandCollapse": "展開/摺疊",
	"notifications-fetch-failure": "無法擷取通知。請稍後重試",
	preview: preview,
	"unread-notifications-count": "{{ count }} 個未讀通知",
	"people-picker-default-placeholder": "按名稱或電子郵件搜索",
	"people-picker-groups-placeholder": "按群組名稱搜尋",
	"people-picker-single-mode-placeholder": "按名稱或電子郵件搜尋",
	"people-picker-single-mode-ad-helper-text": "依名稱、電子郵件或網域\\samAccountName 搜尋",
	"people-picker-single-mode-aad-helper-text": "依名稱、電子郵件、群組名稱或應用程式名稱搜尋",
	"people-picker-default-helper-text": "依名稱搜尋，或輸入電子郵件地址 (以逗號或分號分隔)。您可以使用 \\ 逸出特殊字元。",
	"people-picker-aad-helper-text": "依名稱搜尋，或輸入電子郵件地址 (以逗號或分號分隔)。您可以使用 \\ 逸出特殊字元。",
	"people-picker-ad-ldap-helper-text": "依名稱搜尋，或輸入電子郵件地址或 domain\\samAccountNames (以逗號或分號分隔)。您可以使用 \\ 逸出特殊字元。",
	"people-picker-invalid-error-helper": "使用有效的電子郵件",
	"people-picker-resolve-error-helper": "有些項目無法解析。請移除這些項目或稍後重試",
	"people-picker-resolve-error-tooltip": "無法解析項目。請移除此項目或稍後重試",
	"people-picker-domain-picker-helper": "選取網域",
	"people-picker-too-many-entities": "您一次只能新增 {{ maxValue }} 個實體",
	"people-picker-more-info": "更多資訊",
	"autocomplete-no-results": "沒有與 “{{ query }}” 相符的結果",
	"autocomplete-limit-exceeded": "已超出 {limit} 的限制",
	"autocomplete-search-text": "輸入搜索內容…",
	"autocomplete-no-results-people-picker": "沒有與 “{ query }” 相符的結果",
	"autocomplete-loading": "正在載入…",
	"people-picker-add-users": "名稱",
	"people-picker-add-groups": "組",
	"people-picker-add-apps": "應用程式",
	"people-picker-add-names": "名稱",
	"tenant-picker-aria-label": "選取租用戶。目前: ",
	"people-picker-duplicate-chip": "有一些重複項目。請移除其中一個重複項目，然後重試。",
	"profile-navigation": "喜好設定",
	"remove-chip": "移除 \"{{ value }}\"",
	"default-cobranding-logo-alt-text": "聯合品牌標誌",
	"canary-tenant": "Canary",
	more_products: more_products,
	current_plan_upgrade: current_plan_upgrade,
	free_license: free_license,
	community_license: community_license,
	pro_trial_license: pro_trial_license,
	"notification-action-menu-text": "通知動作",
	"notification-allaction-menu-text": "對所有通知執行更多動作",
	"buy-now": "立即購買",
	"contact-sales": "連絡銷售",
	"skip-content": "跳到主要內容",
	"object-picker-add-entry": "新增「{{ entry }}」",
	"start-free-trial-header": "開始您的",
	"sixty-days-trial": "60 天",
	"with-uipath-cloud": "UiPath Automation Cloud 試用期",
	"take-advantage-capabilities": "充分利用我們成熟的 Automation Cloud 功能。",
	"upgrade-to-enterprise": "需要使用企業級監管、安全性等來擴展自動化程式?",
	"trial-benefit-one": "機器人可實現遠端、隨需執行",
	"trial-benefit-two": "UiPath 全天候支持",
	"trial-benefit-three": "正常執行時間保證",
	"trial-benefit-four": "多個租戶，每個都託管在我們的任意區域",
	"view-pricing": "查看定價",
	"upgrade-trial-role": "職位名稱",
	"upgrade-trial-company-name": "企業/組織名稱",
	"upgrade-trial-business-email": "工作電子郵寄地址",
	"notifications-clear-message": "已刪除通知項目",
	"session-expiring": "工作階段過期",
	"session-expiring-description-inactive-hours": "您已閒置 {{hours}} 小時 {{minutes}} 分鐘。",
	"session-expiring-description-inactive": "您處於閒置狀態的時間已達 {{minutes}} 分鐘。",
	"session-expiring-description-logged-out": "您將在 {{n}} 秒後登出。",
	"extend-session": "延長工作階段",
	"dropdown-position": "{{total}} 的 {{index}}",
	unlicensed: unlicensed,
	"copy-clipboard": "複製到剪貼板",
	"people-picker-search-entries": "找到 {{count}} 個搜尋結果與 “{{query}}” 相符",
	"app-bar-aria-label": "應用程式列",
	"nav-aria-label": "退出導覽",
	"chat-no-messages": "在下方輸入訊息以開始聊天",
	"chat-type-a-message": "輸入訊息",
	"filter-service": "服務:",
	"filter-severity": "嚴重性:",
	"priority-low": "低",
	"priority-medium": "中",
	"priority-high": "高",
	"priority-critical": "嚴重",
	"filter-option-all": "全部",
	"severity-info": "信息",
	"severity-success": "成功",
	"severity-warn": "警告",
	"severity-error": "錯誤",
	"severity-fatal": "嚴重",
	"breadcrumb-aria-label-default": "痕跡",
	back: back,
	"switching-orgs": "切換組織",
	"switching-orgs-description": "您正嘗試將組織從 {{ oldOrg }} 切換到 {{ newOrg }}。若要繼續，請先登出。",
	"business-email-required": "升級到 Pro Trial 需要企業電子郵件地址",
	"check-inbox-for-invite-link": "查看收件匣中收到的邀請連結，並接受邀請以完成升級程序",
	"invite-business-email-help": "如果您隸屬於已使用該電子郵件地址的組織，只需登入您的帳戶並繼續操作。",
	"check-email-for-invite": "查看電子郵件信箱中是否有邀請",
	"check-email-for-invite-description": "如果找不到邀請，請查看您的垃圾郵件資料夾。接受邀請後，就可以升級為 Pro Trial。",
	"no-minimum-purchase": "無最低購買要求。",
	"view-details-trial-plan": "查看相關資訊，瞭解 Pro 方案 60 天試用期包含的所有內容",
	"get-more-cloud": "更多 UiPath Automation Cloud 相關資訊",
	"start-free-trial": "開始免費試用期",
	trademark: trademark,
	"send-invite": "發送邀請",
	"support-id": "支持 ID",
	basic_auth_user: basic_auth_user,
	local_group: local_group,
	robot: robot,
	directory_group: directory_group,
	directory_user: directory_user,
	directory_app: directory_app,
	"unified-admin-button-label": "管理存取權限",
	"unified-search-placeholder": "搜尋 Marketplace 和文件",
	"unified-search-placeholder-v2": "搜尋元件、頁面等",
	"unified-search-recent-searches": "最近的搜尋",
	"unified-search-recent-pages-visited": "造訪過的頁面",
	"unified-search-recent-resources-visited": "造訪過的資源",
	"unified-search-no-recent-searches": "沒有最近的搜尋，請輸入 3 個或更多字元以擷取結果",
	"unified-search-no-recent-searches-logographic-locales": "沒有最近的搜尋，請輸入 1 個或更多字元以擷取結果",
	"unified-search-marketplace": "市場",
	"unified-search-documentation": "文檔",
	"unified-search-open-product": "在 {product} 中開啟",
	"unified-search-change-search-terms": "請嘗試變更您的搜尋字詞",
	"unified-search-no-results-found": "找不到與 \"{term}\" 相符的結果",
	"unified-search-footer": "不是您預期的結果?{feedbackLink} 或 {learnMoreLink}",
	"unified-search-footer-no-feedback": "不是您預期的結果?{learnMoreLink}",
	"unified-search-footer-give-feedback": "不是您預期的結果?{feedbackLink}",
	"unified-search-documentation-link": "在文件中搜尋 \"{query}\"",
	"unified-search-downloads": "{count} 個下載",
	"unified-search-runs": "{count} 次執行",
	"unified-search-all": "全部",
	"unified-search-see-all": "查看全部",
	"unified-search-clear-button": "清除",
	"unified-search-filter": "篩選",
	"unified-search-all-count": "全部 ({count})",
	"unified-search-components-count": "元件 ({count})",
	"unified-search-pages-count": "頁數 ({count})",
	"unified-search-tags": "標記: {tagList}",
	"learn-more": "瞭解詳情",
	"my-workspace": "我的工作區",
	"give-feedback": "提供意見反應",
	"ap-autocomplete-input-no-results": "沒有與 “{query}” 相符的結果",
	"ap-dropdown-placeholder": "選擇...",
	"ap-date-picker-placeholder": "選擇日期",
	"ap-time-picker-placeholder": "選擇時間",
	"ap-date-picker-selected-day-label": "{day} 已選取",
	"ap-breadcrumb-overflow-label": "痕跡隱藏連結",
	"unified-search-Studio": "Studio",
	"unified-search-AiCenter": "AI Center",
	"unified-search-Assistant": "助理",
	"unified-search-ProcessMining": "Process Mining",
	"unified-search-BusinessSolutions": "合作夥伴解決方案",
	"unified-search-UiPathApps": "應用程式",
	"unified-search-IntegrationServices": "Integration Service",
	"unified-search-StudioX": "StudioX",
	"unified-search-ProfessionalServices": "專業服務",
	"unified-search-Accelerator": "加速器",
	"unified-search-StudioWeb": "Studio Web",
	"unified-search-AutomationOps": "自動化治理",
	"unified-search-DocumentUnderstanding": "Document Understanding",
	"unified-search-Insights": "Insights",
	"unified-search-Other": "其他",
	"unified-search-Activity": "活動",
	"unified-search-CustomActivity": "活動",
	"unified-search-Snippet": "代碼片段",
	"unified-search-WorkflowTemplate": "範本",
	"unified-search-Connector": "連接器",
	"unified-search-Tool": "工具",
	"unified-search-MLModel": "ML 模型",
	"unified-search-Solution": "解決方案",
	"unified-search-Process": "現成的自動化",
	"unified-search-Widget": "微件",
	"unified-search-BusinessSolution": "合作夥伴解決方案",
	"unified-search-App": "應用程式",
	"unified-search-UiPathAppSolution": "應用程式解決方案",
	"unified-search-UiPathAppTemplate": "應用程式範本",
	"unified-search-IntegrationServiceConnector": "Integration Service 連接器",
	"unified-search-StudioXWorkflowTemplate": "範本",
	"unified-search-ProfessionalService": "專業服務",
	"unified-search-StudioWebTemplate": "Studio Web 範本",
	"unified-search-AutomationOpsPipeline": "管道",
	"unified-search-AutomationOpsPipelineTemplate": "管道範本",
	"unified-search-ExtractionModel": "擷取模型",
	"unified-search-marketplace-studio-activity": "Studio 活動",
	"unified-search-marketplace-studio-snippet": "Studio 程式碼片段",
	"unified-search-marketplace-studio-workflowtemplate": "Studio 範本",
	"unified-search-marketplace-studio-connector": "連接器 (舊版)",
	"unified-search-marketplace-studio-tool": "Studio 工具",
	"unified-search-marketplace-studio-solution": "Studio 解決方案",
	"unified-search-marketplace-studioweb-studiowebtemplate": "Studio Web 範本",
	"unified-search-marketplace-studiox-studioxworkflowtemplate": "Studio X 範本",
	"unified-search-marketplace-assistant-process": "準備就緒的自動化",
	"unified-search-marketplace-aicenter-mlmodel": "ML 模型",
	"unified-search-marketplace-processmining-app": "Process Mining 應用程式範本",
	"unified-search-marketplace-uipathapps-uipathappsolution": "應用程式解決方案",
	"unified-search-marketplace-uipathapps-uipathapptemplate": "應用程式範本",
	"unified-search-marketplace-integrationservices-integrationserviceconnector": "連接器",
	"unified-search-marketplace-accelerator-accelerator": "加速器",
	"unified-search-marketplace-businesssolutions-businesssolution": "合作夥伴解決方案",
	"unified-search-marketplace-professionalservices-professionalservice": "專業服務",
	"unified-search-orchestrator-asset": "資產",
	"unified-search-orchestrator-process": "流程",
	"unified-search-orchestrator-trigger": "觸發器",
	"unified-search-orchestrator-queue": "佇列",
	"unified-search-orchestrator-bucket": "存儲桶",
	"unified-search-orchestrator-actioncatalog": "動作目錄",
	"unified-search-orchestrator-machine": "電腦",
	"unified-search-orchestrator-webhook": "Webhook",
	"unified-search-integrationservice-connection": "連接",
	"unified-search-integrationservice-trigger": "觸發器",
	"unified-search-dataservice-entity": "實體",
	"unified-search-dataservice-choiceset": "選項集",
	"unified-search-apps-app": "應用程式",
	"unified-search-loading-search-results": "正在載入搜尋結果",
	"rich-text-editor-format-bold": "粗體格式",
	"rich-text-editor-bold": "加粗",
	"rich-text-editor-format-italic": "斜體格式",
	"rich-text-editor-italic": "斜體",
	"rich-text-editor-format-underline": "底線格式",
	"rich-text-editor-underline": "底線",
	"rich-text-editor-format-strikethrough": "刪除線格式",
	"rich-text-editor-strikethrough": "刪除線",
	"rich-text-editor-format-ordered-list": "排序清單格式",
	"rich-text-editor-ordered-list": "有序列表",
	"rich-text-editor-format-unordered-list": "未排序的清單格式",
	"rich-text-editor-unordered-list": "未排序的清單",
	"rich-text-editor-insert-link": "插入連結",
	"rich-text-editor-link": "連結",
	"rich-text-editor-format-code": "程式碼格式",
	"rich-text-editor-code": "代碼",
	"ap-text-field-placeholder": "輸入一個值",
	"notification-message-template": "{{ tenantName }} 中的 {{ topic }}",
	build: build,
	discover: discover,
	operate: operate,
	feedback: feedback,
	"give-us-feedback": "提供回饋",
	cancel: cancel,
	confirm: confirm,
	favorites: favorites,
	"favorites-limit-reached": "已達到限制: 您最多只能新增 3 個項目。",
	"favorites-description": "您常用的產品將顯示在此處。您最多可以新增 3 個項目。",
	"default-toggle": "切換開關",
	"default-progress-spinner": "正在載入內容",
	"default-icon-button": "圖示按鈕",
	"default-radio-group": "廣播組",
	"default-checkbox": "核取方塊",
	"default-stepper-clickable": "包含可點按的步驟",
	"default-stepper-disabled": "包含停用的步驟",
	"new-navigation": "新導覽",
	"product-launcher-tooltip": "產品啟動器",
	"autopilot-tooltip": "Autopilot",
	"notifications-tooltip": "通知",
	"search-tooltip": "搜索",
	"help-tooltip": "幫助",
	"profile-tooltip": "設定檔",
	apply: apply,
	date: date,
	time: time,
	"date-range": "日期範圍:",
	"date-range-label": "資料範圍",
	"date-time-label": "日期時間",
	"date-time-picker-label": "日期時間選擇器",
	"date-range-start": "開始",
	"date-range-end": "結束",
	"date-range-presets": "預設",
	"date-range-picker-last-hour": "過去一小時",
	"date-range-picker-today": "今天",
	"date-range-picker-last-seven-days": "過去 7 天",
	"date-range-picker-last-two-weeks": "過去 2 週",
	"date-range-picker-last-month": "過去一個月",
	"date-range-picker-last-six-months": "過去 6 個月",
	"date-range-picker-custom": "自訂",
	"date-range-picker-start-tooltip": "開始日期不得晚於結束日期",
	"date-range-picker-label": "日期範圍選取工具",
	"time-selector": "時間選取工具",
	"date-range-picker-options": "日期範圍選項",
	"no-options": "無選項",
	"type-to-search": "輸入搜索內容…",
	"autopilot-chat-header": "Autopilot",
	"autopilot-chat-input-placeholder": "我要怎麼做?",
	"autopilot-chat-footer": "Autopilot 可能會犯錯。請仔細檢查回應。",
	"autopilot-chat-new-chat": "新聊天",
	"autopilot-chat-close": "關閉",
	"autopilot-chat-attach-file": "附加檔案",
	"autopilot-chat-send": "發送",
	"autopilot-chat-stop": "停止",
	"autopilot-chat-remove-file": "刪除",
	"autopilot-chat-prompt-library": "提示元件庫",
	"autopilot-chat-dropzone-overlay-title": "將您的檔案拖放至此處，以將其新增至提示中",
	"autopilot-chat-dropzone-overlay-description": "支援的檔案類型: {{ fileTypes }}",
	"autopilot-chat-dropzone-overlay-error": "不支援的檔案: {{ fileTypes }}。",
	"autopilot-chat-code-block-language": "文本",
	"autopilot-chat-code-block-copy": "複製",
	"autopilot-chat-expand": "展開",
	"autopilot-chat-collapse": "折疊",
	"autopilot-chat-remove-file-name": "移除 {{ name }}",
	"autopilot-chat-selected-files": "選取的檔案 ({{ count }})",
	"autopilot-chat-files-preview": "{{ files }} 以及其他 {{ count }} 個",
	"autopilot-chat-thinking": "正在思考",
	"autopilot-chat-analyzing": "正在分析您的請求",
	"autopilot-chat-thinking-more": "再想一想",
	"autopilot-chat-suggestions": "建議"
};

const templateMatcher = /{{\s?([^{}\s]*)\s?}}/g;
const localeMap = {
    en,
    ja,
    de,
    fr,
    es,
    'es-mx': esMX,
    pt,
    'pt-br': ptBR,
    ko,
    ru,
    tr,
    'zh-cn': zhCN,
    'zh-tw': zhTW,
    keys: Object.keys(en).reduce((accum, current) => (Object.assign(Object.assign({}, accum), { [current]: current })), {}),
};

var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
function getLanguageText(languageCode) {
    return Languages[languageCode.toLowerCase()] || languageCode;
}
function t(key, params) {
    var _a, _b;
    const _c = params || {}, { locale } = _c, args = __rest(_c, ["locale"]);
    const correctLocale = (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) || ((_a = LocaleInstanceResolver === null || LocaleInstanceResolver === void 0 ? void 0 : LocaleInstanceResolver.Instance) === null || _a === void 0 ? void 0 : _a.locale) || getCachedLanguage() || defaultLanguage;
    const value = ((_b = localeMap[correctLocale]) === null || _b === void 0 ? void 0 : _b[key]) || en[key] || key;
    return interpolateString(value, args);
}
/**
 * Interpolates a string to replace parameters
 * "This is a {{ key }}" ==> "This is a value", with params = { key: "value" }
 * @param expr
 * @param params
*/
function interpolateString(expr, params) {
    if (!params) {
        return expr;
    }
    return expr.replace(templateMatcher, (substring, key) => {
        const r = params[key];
        return isDefined(r) ? r : substring;
    });
}

export { FeatureFlags as $, ApolloSettingKey as A, BuiltInGroups as B, global$1 as C, DeploymentType as D, getCircularReplacer as E, Features as F, GlobalEventEmitter as G, store$1 as H, handleThemeChange as I, getAutoThemeValue as J, validateThemeCode as K, Logger as L, getCachedTheme as M, defaultTheme as N, setTheme as O, PendoApiKey as P, MediaQueryListener as Q, darkMediaQuery as R, STORAGE_KEYS as S, Tracker as T, highContrastMediaQueries as U, AccountAndTenantsInstanceResolver as V, WellKnownApplication as W, Entitlement as X, isStandalone as Y, setUserTheme as Z, AppInsightsInstanceResolver as _, accessibilityChannelName as a, capitalizeFirstLetter as a$, getFeatureFlagsStore as a0, ChatInstanceResolver as a1, chatStore as a2, ThemeInstanceResolver as a3, AutopilotChatMode as a4, GlobalPropsInstanceResolver as a5, debounce_1 as a6, commonjsGlobal as a7, AutopilotChatInternalEvent as a8, AutopilotChatEvent as a9, isNonCloud as aA, defaultActiveItems as aB, AutopilotChatFileType as aC, AutopilotChatAccordionPosition as aD, MessageSource as aE, Scope as aF, ServiceType as aG, getMoreTileProps as aH, themeStorageKey as aI, parseArrayProps as aJ, SERVICE_IDS as aK, getFeatureFlags as aL, defaultMenuItems as aM, isString as aN, SeverityLevel$1 as aO, getScopedUrl as aP, patch as aQ, Languages as aR, DialogEventNames as aS, localeMap as aT, en as aU, templateMatcher as aV, isDefined as aW, translatedContactSalesUrl as aX, isNonEmptyString as aY, getScopedUrlFromDevProps as aZ, parseOrReturn as a_, getDefaultExportFromCjs as aa, t as ab, AutopilotChatRole as ac, AutopilotChatInterceptableEvent as ad, post as ae, LocalizationHeaderName as af, TenantHeaderKey as ag, get as ah, handleLanguageChange as ai, defaultLanguage as aj, getCachedLanguage as ak, validateLanguageCode as al, setLanguage as am, getCachedLanguageWithDate as an, setUserLanguage as ao, getAugmentedNamespace as ap, jwtDecode_esm as aq, sanitizeToken as ar, isLocal$1 as as, AuthSettings as at, caseInsensitiveCompare as au, isLocal as av, getMenuConfig as aw, defaultServiceOrder as ax, AccountType as ay, isFalsyOrWhitespace as az, alertDurationChannelName as b, NotificationSeverity as b0, getLanguageText as b1, themeList as b2, LanguageCodes as b3, getRelativeServicePath as b4, o as b5, createStore as c, getAccessToken as d, shouldRefetch as e, getAccountName as f, getOrganizationStandardUrl as g, AlertInstanceResolver as h, index_es5 as i, getFeatureFlag as j, AccessibilityInstanceResolver as k, AlertDurationDefault as l, AlertDurationEnum as m, SeverityLevel as n, getTenantName as o, put as p, AppInsightDriverBuilder as q, sanitizeUrl as r, sessionStore as s, getSpaceName as t, getEnvironment as u, getEnvConfigField as v, LocaleInstanceResolver as w, SHARED_PENDO_API_KEY as x, removeObjectUndefinedProperties as y, process$1 as z };

//# sourceMappingURL=loc-8e400c4a.js.map